import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  LocalDateTime: any;
  UUID: any;
  JSONObject: any;
  JSON: any;
  DateTime: any;
  Date: any;
  LocalDate: any;
  LocalTime: any;
  BigInt: any;
  jsonb: any;
  smallint: any;
  timestamptz: any;
  uuid: any;
  bit: any;
  json: any;
  bigint: any;
  _int4: any;
  _text: any;
  name: any;
  numeric: any;
  date: any;
  _timestamp: any;
  _uuid: any;
  bpchar: any;
  time: any;
  transitdoc_type: any;
  tenant_type: any;
  tsvector: any;
  bc_name: any;
  _declaration_tasks_data: any;
  document_scalar: any;
  _jsonb: any;
  timestamp: any;
  _varchar: any;
  _txtcode: any;
  query_int: any;
  _int2: any;
  _int8: any;
  ltree: any;
  lquery: any;
  ltxtquery: any;
  PASSWORD_REGEX: any;
};

export type Query_Root = {
  acs_goods_items_for_drs: Maybe<Array<Maybe<DeclarationGoodsItems>>>;
  acs_goods_items_for_drs_count: Maybe<Count>;
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk: Maybe<Address>;
  /** fetch data from the table: "address_group" */
  address_group: Array<Address_Group>;
  /** fetch data from the table: "address_group" using primary key columns */
  address_group_by_pk: Maybe<Address_Group>;
  /** fetch data from the table: "address_groups" */
  address_groups: Array<Address_Groups>;
  /** fetch data from the table: "address_mapping" */
  address_mapping: Array<Address_Mapping>;
  /** fetch data from the table: "address_mapping" using primary key columns */
  address_mapping_by_pk: Maybe<Address_Mapping>;
  /** fetch data from the table: "address_override" */
  address_override: Array<Address_Override>;
  /** fetch data from the table: "address_override" using primary key columns */
  address_override_by_pk: Maybe<Address_Override>;
  /** fetch data from the table: "address_type" */
  address_type: Array<Address_Type>;
  /** fetch data from the table: "address_type" using primary key columns */
  address_type_by_pk: Maybe<Address_Type>;
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch data from the table: "ai_stats_dt_type" */
  ai_stats_dt_type: Array<Ai_Stats_Dt_Type>;
  /** fetch data from the table: "ai_stats_type" */
  ai_stats_type: Array<Ai_Stats_Type>;
  /** fetch data from the table: "annotation_provider" */
  annotation_provider: Array<Annotation_Provider>;
  /** fetch data from the table: "annotation_provider" using primary key columns */
  annotation_provider_by_pk: Maybe<Annotation_Provider>;
  /** fetch data from the table: "annotation_type" */
  annotation_type: Array<Annotation_Type>;
  /** fetch data from the table: "annotation_type" using primary key columns */
  annotation_type_by_pk: Maybe<Annotation_Type>;
  /** fetch data from the table: "api_key" */
  api_key: Array<Api_Key>;
  /** fetch data from the table: "api_key" using primary key columns */
  api_key_by_pk: Maybe<Api_Key>;
  /** fetch data from the table: "arrival_type" */
  arrival_type: Array<Arrival_Type>;
  /** fetch data from the table: "arrival_type" using primary key columns */
  arrival_type_by_pk: Maybe<Arrival_Type>;
  /** fetch data from the table: "article" */
  article: Array<Article>;
  /** fetch data from the table: "article" using primary key columns */
  article_by_pk: Maybe<Article>;
  /** fetch data from the table: "bill" */
  bill: Array<Bill>;
  /** fetch aggregated fields from the table: "bill" */
  bill_aggregate: Bill_Aggregate;
  /** fetch data from the table: "bill" using primary key columns */
  bill_by_pk: Maybe<Bill>;
  /** fetch data from the table: "bill_detail" */
  bill_detail: Array<Bill_Detail>;
  /** fetch data from the table: "bill_detail" using primary key columns */
  bill_detail_by_pk: Maybe<Bill_Detail>;
  /** fetch data from the table: "clearance_type" */
  clearance_type: Array<Clearance_Type>;
  /** fetch data from the table: "clearance_type" using primary key columns */
  clearance_type_by_pk: Maybe<Clearance_Type>;
  /** An array relationship */
  containers: Array<Containers>;
  /** fetch data from the table: "containers" using primary key columns */
  containers_by_pk: Maybe<Containers>;
  /** fetch data from the table: "count_type" */
  count_type: Array<Count_Type>;
  /** fetch data from the table: "customs_office" */
  customs_office: Array<Customs_Office>;
  /** fetch data from the table: "customs_office" using primary key columns */
  customs_office_by_pk: Maybe<Customs_Office>;
  /** fetch data from the table: "customs_offices" */
  customs_offices: Array<Customs_Offices>;
  /** fetch data from the table: "customs_offices" using primary key columns */
  customs_offices_by_pk: Maybe<Customs_Offices>;
  /** fetch data from the table: "customs_response_data" */
  customs_response_data: Array<Customs_Response_Data>;
  /** fetch data from the table: "customs_response_data" using primary key columns */
  customs_response_data_by_pk: Maybe<Customs_Response_Data>;
  /** fetch data from the table: "customs_response_decoded" */
  customs_response_decoded: Array<Customs_Response_Decoded>;
  /** An array relationship */
  customs_response_goods_items: Array<Customs_Response_Goods_Items>;
  /** An aggregate relationship */
  customs_response_goods_items_aggregate: Customs_Response_Goods_Items_Aggregate;
  /** fetch data from the table: "customs_response_summary" */
  customs_response_summary: Array<Customs_Response_Summary>;
  /** fetch data from the table: "declaration" */
  declaration: Array<Declaration>;
  /** fetch data from the table: "declaration" using primary key columns */
  declaration_by_pk: Maybe<Declaration>;
  /** fetch data from the table: "declaration_discussion" */
  declaration_discussion: Array<Declaration_Discussion>;
  /** fetch aggregated fields from the table: "declaration_discussion" */
  declaration_discussion_aggregate: Declaration_Discussion_Aggregate;
  /** fetch data from the table: "declaration_discussion" using primary key columns */
  declaration_discussion_by_pk: Maybe<Declaration_Discussion>;
  /** fetch data from the table: "declaration_discussions" */
  declaration_discussions: Array<Declaration_Discussions>;
  /** fetch data from the table: "declaration_document" */
  declaration_document: Array<Declaration_Document>;
  /** fetch data from the table: "declaration_document" using primary key columns */
  declaration_document_by_pk: Maybe<Declaration_Document>;
  /** An array relationship */
  declaration_labels: Array<Declaration_Labels>;
  /** fetch data from the table: "declaration_labels" using primary key columns */
  declaration_labels_by_pk: Maybe<Declaration_Labels>;
  /** fetch data from the table: "declaration_message" */
  declaration_message: Array<Declaration_Message>;
  /** fetch aggregated fields from the table: "declaration_message" */
  declaration_message_aggregate: Declaration_Message_Aggregate;
  /** fetch data from the table: "declaration_message" using primary key columns */
  declaration_message_by_pk: Maybe<Declaration_Message>;
  /** fetch data from the table: "declaration_request" */
  declaration_request: Array<Declaration_Request>;
  /** fetch data from the table: "declaration_request_address" */
  declaration_request_address: Array<Declaration_Request_Address>;
  /** fetch data from the table: "declaration_request_address_ai" */
  declaration_request_address_ai: Array<Declaration_Request_Address_Ai>;
  /** fetch data from the table: "declaration_request_address_ai" using primary key columns */
  declaration_request_address_ai_by_pk: Maybe<Declaration_Request_Address_Ai>;
  /** fetch data from the table: "declaration_request_address" using primary key columns */
  declaration_request_address_by_pk: Maybe<Declaration_Request_Address>;
  /** fetch data from the table: "declaration_request" using primary key columns */
  declaration_request_by_pk: Maybe<Declaration_Request>;
  /** An array relationship */
  declaration_request_labels: Array<Declaration_Request_Labels>;
  /** fetch data from the table: "declaration_request_labels" using primary key columns */
  declaration_request_labels_by_pk: Maybe<Declaration_Request_Labels>;
  /** fetch data from the table: "declaration_requests" */
  declaration_requests: Array<Declaration_Requests>;
  /** fetch data from the table: "declaration_search" */
  declaration_search: Array<Declaration_Search>;
  /** An array relationship */
  declaration_special_mentions: Array<Declaration_Special_Mentions>;
  /** fetch data from the table: "declaration_special_mentions" using primary key columns */
  declaration_special_mentions_by_pk: Maybe<Declaration_Special_Mentions>;
  /** fetch data from the table: "declaration_status" */
  declaration_status: Array<Declaration_Status>;
  /** fetch data from the table: "declaration_status" using primary key columns */
  declaration_status_by_pk: Maybe<Declaration_Status>;
  /** fetch data from the table: "declaration_task" */
  declaration_task: Array<Declaration_Task>;
  /** fetch aggregated fields from the table: "declaration_task" */
  declaration_task_aggregate: Declaration_Task_Aggregate;
  /** fetch data from the table: "declaration_task" using primary key columns */
  declaration_task_by_pk: Maybe<Declaration_Task>;
  /** fetch data from the table: "declaration_tasks" */
  declaration_tasks: Array<Declaration_Tasks>;
  /** fetch data from the table: "declaration_tasks_obj" */
  declaration_tasks_obj: Array<Declaration_Tasks_Obj>;
  /** fetch data from the table: "declaration_type" */
  declaration_type: Array<Declaration_Type>;
  /** fetch data from the table: "declaration_type" using primary key columns */
  declaration_type_by_pk: Maybe<Declaration_Type>;
  /** fetch data from the table: "discussion_changes" */
  discussion_changes: Array<Discussion_Changes>;
  /** fetch data from the table: "doc_annotation" */
  doc_annotation: Array<Doc_Annotation>;
  /** fetch data from the table: "doc_annotation" using primary key columns */
  doc_annotation_by_pk: Maybe<Doc_Annotation>;
  /** fetch data from the table: "doc_search_type" */
  doc_search_type: Array<Doc_Search_Type>;
  /** fetch data from the table: "doc_stats_type" */
  doc_stats_type: Array<Doc_Stats_Type>;
  /** fetch data from the table: "docs_for_validation" */
  docs_for_validation: Array<Docs_For_Validation>;
  /** fetch data from the table: "document" */
  document: Array<Document>;
  /** fetch aggregated fields from the table: "document" */
  document_aggregate: Document_Aggregate;
  /** fetch data from the table: "document" using primary key columns */
  document_by_pk: Maybe<Document>;
  /** fetch data from the table: "document_extension" */
  document_extension: Array<Document_Extension>;
  /** fetch data from the table: "document_extension" using primary key columns */
  document_extension_by_pk: Maybe<Document_Extension>;
  /** fetch data from the table: "document_flag" */
  document_flag: Array<Document_Flag>;
  /** fetch data from the table: "document_flag" using primary key columns */
  document_flag_by_pk: Maybe<Document_Flag>;
  /** execute function "document_is_allowed" which returns "document" */
  document_is_allowed: Array<Document>;
  /** execute function "document_is_allowed" and query aggregates on result of table type "document" */
  document_is_allowed_aggregate: Document_Aggregate;
  /** fetch data from the table: "document_label_org_id" */
  document_label_org_id: Array<Document_Label_Org_Id>;
  /** fetch data from the table: "document_label_org_id" using primary key columns */
  document_label_org_id_by_pk: Maybe<Document_Label_Org_Id>;
  /** An array relationship */
  document_labels: Array<Document_Labels>;
  /** fetch data from the table: "document_labels" using primary key columns */
  document_labels_by_pk: Maybe<Document_Labels>;
  /** fetch data from the table: "document_page" */
  document_page: Array<Document_Page>;
  /** fetch aggregated fields from the table: "document_page" */
  document_page_aggregate: Document_Page_Aggregate;
  /** fetch data from the table: "document_page" using primary key columns */
  document_page_by_pk: Maybe<Document_Page>;
  /** fetch data from the table: "document_status" */
  document_status: Array<Document_Status>;
  /** fetch data from the table: "document_status" using primary key columns */
  document_status_by_pk: Maybe<Document_Status>;
  /** fetch data from the table: "document_type" */
  document_type: Array<Document_Type>;
  /** fetch aggregated fields from the table: "document_type" */
  document_type_aggregate: Document_Type_Aggregate;
  /** An array relationship */
  document_type_all_tenant_settings: Array<Document_Type_All_Tenant_Settings>;
  /** fetch data from the table: "document_type" using primary key columns */
  document_type_by_pk: Maybe<Document_Type>;
  /** An array relationship */
  document_type_tenant_settings: Array<Document_Type_Tenant_Settings>;
  /** fetch data from the table: "document_type_tenant_settings" using primary key columns */
  document_type_tenant_settings_by_pk: Maybe<Document_Type_Tenant_Settings>;
  documents: Maybe<Array<Documents>>;
  /** fetch data from the table: "dr_goods_item" */
  dr_goods_item: Array<Dr_Goods_Item>;
  /** fetch aggregated fields from the table: "dr_goods_item" */
  dr_goods_item_aggregate: Dr_Goods_Item_Aggregate;
  /** fetch data from the table: "dr_goods_item" using primary key columns */
  dr_goods_item_by_pk: Maybe<Dr_Goods_Item>;
  /** fetch data from the table: "dr_goods_items" */
  dr_goods_items: Array<Dr_Goods_Items>;
  /** fetch data from the table: "dr_stats" */
  dr_stats: Array<Dr_Stats>;
  /** fetch data from the table: "edec_countries" */
  edec_countries: Array<Edec_Countries>;
  /** fetch data from the table: "edec_countries" using primary key columns */
  edec_countries_by_pk: Maybe<Edec_Countries>;
  /** fetch data from the table: "edec_customs_offices" */
  edec_customs_offices: Array<Edec_Customs_Offices>;
  /** fetch data from the table: "edec_customs_offices" using primary key columns */
  edec_customs_offices_by_pk: Maybe<Edec_Customs_Offices>;
  /** fetch data from the table: "edec_domains" */
  edec_domains: Array<Edec_Domains>;
  /** fetch data from the table: "edec_domains" using primary key columns */
  edec_domains_by_pk: Maybe<Edec_Domains>;
  /** fetch data from the table: "edec_tariff_commodity_code" */
  edec_tariff_commodity_code: Array<Edec_Tariff_Commodity_Code>;
  /** fetch data from the table: "edec_tariff_commodity_code" using primary key columns */
  edec_tariff_commodity_code_by_pk: Maybe<Edec_Tariff_Commodity_Code>;
  /** fetch data from the table: "edec_tariff_statistical_code" */
  edec_tariff_statistical_code: Array<Edec_Tariff_Statistical_Code>;
  /** fetch data from the table: "edec_tariff_statistical_code" using primary key columns */
  edec_tariff_statistical_code_by_pk: Maybe<Edec_Tariff_Statistical_Code>;
  /** fetch data from the table: "email_search_type" */
  email_search_type: Array<Email_Search_Type>;
  /** fetch aggregated fields from the table: "email_search_type" */
  email_search_type_aggregate: Email_Search_Type_Aggregate;
  /** fetch data from the table: "extract_type" */
  extract_type: Array<Extract_Type>;
  /** fetch data from the table: "extract_type" using primary key columns */
  extract_type_by_pk: Maybe<Extract_Type>;
  /** fetch data from the table: "extraction_config" */
  extraction_config: Array<Extraction_Config>;
  /** fetch data from the table: "extraction_config" using primary key columns */
  extraction_config_by_pk: Maybe<Extraction_Config>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "file" */
  file_aggregate: File_Aggregate;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk: Maybe<File>;
  /** fetch data from the table: "file_stats_type" */
  file_stats_type: Array<File_Stats_Type>;
  /** fetch data from the table: "file_type" */
  file_type: Array<File_Type>;
  /** fetch data from the table: "file_type" using primary key columns */
  file_type_by_pk: Maybe<File_Type>;
  getAddressesByFrequency: Array<AddressAcs>;
  getAddressesOrOverrideACS: Array<AddressOrOverrideResult>;
  getAddressOverrides: Array<GetAddressOverridesResponse>;
  getAditRoles: Array<Role>;
  getAppModules: Array<ModuleEntity>;
  getBordereaus: Maybe<GetBordereaus>;
  getCommodityCodes: Array<CommodityCodeDescription>;
  getCurrentUser: UserPp;
  getDeclaraionLabels: Maybe<Array<DeclarationLabelQueryOutput>>;
  getDeclarationGoodItemsStatistics: Maybe<Scalars['JSON']>;
  getDeclarationRequestsAdit: Array<DeclarationFlat>;
  getDeclarationRequestStatistics: Maybe<Scalars['JSON']>;
  getFileDocuments: Array<GetFileDocumentsQuery>;
  getFiles: Maybe<Array<Maybe<GetFiles>>>;
  getGoodItemsStatistics: Maybe<Scalars['JSON']>;
  getOrgIds: Array<OrgIdEntity>;
  getPageFragmentText: Maybe<Scalars['JSON']>;
  getSASToken: Maybe<SasTokenResponse>;
  getTenantConfig: Maybe<Scalars['JSON']>;
  getTenants: Array<TenantEntity>;
  getUserConfig: Maybe<Scalars['JSON']>;
  getUserOrgIds: Array<OrgIdEntity>;
  getUserPermissions: Array<CaslRule>;
  getUsers: Array<UserPp>;
  getWDRoles: Array<Role>;
  getWDUsers: Array<UserPp>;
  /** fetch data from the table: "goods_item" */
  goods_item: Array<Goods_Item>;
  /** fetch aggregated fields from the table: "goods_item" */
  goods_item_aggregate: Goods_Item_Aggregate;
  /** fetch data from the table: "goods_item" using primary key columns */
  goods_item_by_pk: Maybe<Goods_Item>;
  /** An array relationship */
  goods_item_special_mentions: Array<Goods_Item_Special_Mentions>;
  /** An aggregate relationship */
  goods_item_special_mentions_aggregate: Goods_Item_Special_Mentions_Aggregate;
  /** fetch data from the table: "goods_item_special_mentions" using primary key columns */
  goods_item_special_mentions_by_pk: Maybe<Goods_Item_Special_Mentions>;
  /** fetch data from the table: "goods_items_for_drs" */
  goods_items_for_drs: Array<Goods_Items_For_Drs>;
  /** fetch data from the table: "group_member" */
  group_member: Array<Group_Member>;
  /** fetch data from the table: "group_member" using primary key columns */
  group_member_by_pk: Maybe<Group_Member>;
  /** fetch data from the table: "group_members" */
  group_members: Array<Group_Members>;
  /** fetch data from the table: "import_list_trigger" */
  import_list_trigger: Array<Import_List_Trigger>;
  /** fetch aggregated fields from the table: "import_list_trigger" */
  import_list_trigger_aggregate: Import_List_Trigger_Aggregate;
  /** fetch data from the table: "import_list_trigger" using primary key columns */
  import_list_trigger_by_pk: Maybe<Import_List_Trigger>;
  /** fetch data from the table: "intf.dr_payment_info" */
  intf_dr_payment_info: Array<Intf_Dr_Payment_Info>;
  /** fetch data from the table: "json_type" */
  json_type: Array<Json_Type>;
  /** fetch data from the table: "kc_users" */
  kc_users: Array<Kc_Users>;
  /** fetch data from the table: "max_date_type" */
  max_date_type: Array<Max_Date_Type>;
  /** fetch data from the table: "model_retrain" */
  model_retrain: Array<Model_Retrain>;
  /** fetch data from the table: "model_retrain" using primary key columns */
  model_retrain_by_pk: Maybe<Model_Retrain>;
  notifications: Maybe<Scalars['JSON']>;
  /** fetch data from the table: "org_id" */
  org_id: Array<Org_Id>;
  /** fetch data from the table: "org_id" using primary key columns */
  org_id_by_pk: Maybe<Org_Id>;
  /** fetch data from the table: "org_ids" */
  org_ids: Array<Org_Ids>;
  /** fetch data from the table: "org_params" */
  org_params: Array<Org_Params>;
  /** fetch data from the table: "org_params" using primary key columns */
  org_params_by_pk: Maybe<Org_Params>;
  /** fetch data from the table: "org_params_org_id" */
  org_params_org_id: Array<Org_Params_Org_Id>;
  /** An array relationship */
  packagings: Array<Packagings>;
  /** An aggregate relationship */
  packagings_aggregate: Packagings_Aggregate;
  /** fetch data from the table: "packagings" using primary key columns */
  packagings_by_pk: Maybe<Packagings>;
  /** fetch data from the table: "page" */
  page: Array<Page>;
  /** fetch data from the table: "page" using primary key columns */
  page_by_pk: Maybe<Page>;
  /** fetch data from the table: "page_extract" */
  page_extract: Array<Page_Extract>;
  /** fetch data from the table: "page_extract" using primary key columns */
  page_extract_by_pk: Maybe<Page_Extract>;
  /** fetch data from the table: "page_status" */
  page_status: Array<Page_Status>;
  /** fetch data from the table: "page_status" using primary key columns */
  page_status_by_pk: Maybe<Page_Status>;
  /** fetch data from the table: "pages_m2m_cache" */
  pages_m2m_cache: Array<Pages_M2m_Cache>;
  /** fetch aggregated fields from the table: "pages_m2m_cache" */
  pages_m2m_cache_aggregate: Pages_M2m_Cache_Aggregate;
  /** An array relationship */
  permits: Array<Permits>;
  /** An aggregate relationship */
  permits_aggregate: Permits_Aggregate;
  /** fetch data from the table: "permits" using primary key columns */
  permits_by_pk: Maybe<Permits>;
  /** execute function "pp_address_groups" which returns "address_groups" */
  pp_address_groups: Array<Address_Groups>;
  /** execute function "pp_addresses" which returns "addresses" */
  pp_addresses: Array<Addresses>;
  /** execute function "pp_addresses_by_payer_address" which returns "addresses" */
  pp_addresses_by_payer_address: Array<Addresses>;
  /** execute function "pp_addresses_by_payer_id" which returns "addresses" */
  pp_addresses_by_payer_id: Array<Addresses>;
  /** execute function "pp_ai_stats" which returns "ai_stats_type" */
  pp_ai_stats: Array<Ai_Stats_Type>;
  /** execute function "pp_ai_stats_dt" which returns "ai_stats_dt_type" */
  pp_ai_stats_dt: Array<Ai_Stats_Dt_Type>;
  /** execute function "pp_check_json_param" which returns "json_type" */
  pp_check_json_param: Array<Json_Type>;
  /** execute function "pp_customs_response_summary" which returns "customs_response_summary" */
  pp_customs_response_summary: Array<Customs_Response_Summary>;
  /** execute function "pp_declaration_request" which returns "declaration_request" */
  pp_declaration_request: Array<Declaration_Request>;
  pp_declaration_requests: Maybe<Array<DeclarationAcs>>;
  pp_declaration_requests_count: Maybe<Count>;
  pp_declaration_requests_report: Maybe<Scalars['JSON']>;
  /** execute function "pp_declaration_tasks" which returns "declaration_tasks" */
  pp_declaration_tasks: Array<Declaration_Tasks>;
  /** execute function "pp_declaration_tasks_agg" which returns "json_type" */
  pp_declaration_tasks_agg: Maybe<Json_Type>;
  /** execute function "pp_declaration_tasks_obj" which returns "declaration_tasks_obj" */
  pp_declaration_tasks_obj: Maybe<Declaration_Tasks_Obj>;
  /** execute function "pp_declarations" which returns "declaration_search" */
  pp_declarations: Array<Declaration_Search>;
  /** execute function "pp_delete_declaration_requests" which returns "json_type" */
  pp_delete_declaration_requests: Array<Json_Type>;
  /** execute function "pp_doc_max_date_hs" which returns "max_date_type" */
  pp_doc_max_date_hs: Array<Max_Date_Type>;
  /** execute function "pp_doc_max_date_v2" which returns "max_date_type" */
  pp_doc_max_date_v2: Array<Max_Date_Type>;
  /** execute function "pp_doc_search" which returns "doc_search_type" */
  pp_doc_search: Array<Doc_Search_Type>;
  /** execute function "pp_doc_search_hs" which returns "doc_search_type" */
  pp_doc_search_hs: Array<Doc_Search_Type>;
  /** execute function "pp_doc_stats" which returns "doc_stats_type" */
  pp_doc_stats: Array<Doc_Stats_Type>;
  /** execute function "pp_docs_for_validation" which returns "docs_for_validation" */
  pp_docs_for_validation: Array<Docs_For_Validation>;
  /** execute function "pp_document" which returns "document" */
  pp_document: Array<Document>;
  /** execute function "pp_document" and query aggregates on result of table type "document" */
  pp_document_aggregate: Document_Aggregate;
  /** execute function "pp_document_flag" which returns "document_flag" */
  pp_document_flag: Array<Document_Flag>;
  /** execute function "pp_document_labels" which returns "document_labels" */
  pp_document_labels: Array<Document_Labels>;
  /** execute function "pp_dr_goods_items" which returns "dr_goods_items" */
  pp_dr_goods_items: Array<Dr_Goods_Items>;
  /** execute function "pp_dr_max_date" which returns "max_date_type" */
  pp_dr_max_date: Array<Max_Date_Type>;
  /** execute function "pp_dr_stats" which returns "dr_stats" */
  pp_dr_stats: Array<Dr_Stats>;
  /** execute function "pp_email_search" which returns "email_search_type" */
  pp_email_search: Array<Email_Search_Type>;
  /** execute function "pp_email_search" and query aggregates on result of table type "email_search_type" */
  pp_email_search_aggregate: Email_Search_Type_Aggregate;
  /** execute function "pp_email_search_hs" which returns "email_search_type" */
  pp_email_search_hs: Array<Email_Search_Type>;
  /** execute function "pp_email_search_hs" and query aggregates on result of table type "email_search_type" */
  pp_email_search_hs_aggregate: Email_Search_Type_Aggregate;
  /** execute function "pp_file_max_date_hs" which returns "max_date_type" */
  pp_file_max_date_hs: Array<Max_Date_Type>;
  /** execute function "pp_file_max_date_v2" which returns "max_date_type" */
  pp_file_max_date_v2: Array<Max_Date_Type>;
  /** execute function "pp_file_search" which returns "pp_types.file_search" */
  pp_file_search: Array<Pp_Types_File_Search>;
  /** execute function "pp_file_search_hs" which returns "pp_types.file_search" */
  pp_file_search_hs: Array<Pp_Types_File_Search>;
  /** execute function "pp_file_stats" which returns "file_stats_type" */
  pp_file_stats: Array<File_Stats_Type>;
  pp_get_kpi_commodity_code: Maybe<CommodityCodeStatistics>;
  pp_get_kpis: Maybe<StatisticsDto>;
  /** execute function "pp_get_wd_perms_for_dr" which returns "json_type" */
  pp_get_wd_perms_for_dr: Array<Json_Type>;
  /** execute function "pp_group_members" which returns "group_members" */
  pp_group_members: Array<Group_Members>;
  /** execute function "pp_hasura_session" which returns "json_type" */
  pp_hasura_session: Array<Json_Type>;
  /** execute function "pp_kc_users" which returns "kc_users" */
  pp_kc_users: Array<Kc_Users>;
  /** execute function "pp_last_doc_in_dr" which returns "document" */
  pp_last_doc_in_dr: Array<Document>;
  /** execute function "pp_last_doc_in_dr" and query aggregates on result of table type "document" */
  pp_last_doc_in_dr_aggregate: Document_Aggregate;
  /** execute function "pp_menu_indicators" which returns "json_type" */
  pp_menu_indicators: Array<Json_Type>;
  /** execute function "pp_org_id_delete" which returns "json_type" */
  pp_org_id_delete: Array<Json_Type>;
  /** execute function "pp_org_id_insert" which returns "json_type" */
  pp_org_id_insert: Array<Json_Type>;
  /** execute function "pp_org_id_update" which returns "json_type" */
  pp_org_id_update: Array<Json_Type>;
  /** execute function "pp_org_ids" which returns "org_ids" */
  pp_org_ids: Array<Org_Ids>;
  /** execute function "pp_page_extract_grids_text" which returns "json_type" */
  pp_page_extract_grids_text: Array<Json_Type>;
  /** execute function "pp_page_extract_text_fragment" which returns "json_type" */
  pp_page_extract_text_fragment: Array<Json_Type>;
  /** execute function "pp_page_extract_text_fragment_v2" which returns "json_type" */
  pp_page_extract_text_fragment_v2: Array<Json_Type>;
  /** execute function "pp_tenants" which returns "tenants" */
  pp_tenants: Array<Tenants>;
  /** fetch data from the table: "pp_types.file_search" */
  pp_types_file_search: Array<Pp_Types_File_Search>;
  /** execute function "pp_user_org_id" which returns "user_org_id" */
  pp_user_org_id: Array<User_Org_Id>;
  /** execute function "pp_user_search" which returns "user_search_type" */
  pp_user_search: Array<User_Search_Type>;
  /** execute function "pp_users" which returns "users" */
  pp_users: Array<Users>;
  /** execute function "pp_view_document_history" which returns "view_document_history" */
  pp_view_document_history: Array<View_Document_History>;
  /** execute function "pp_view_file_history" which returns "view_file_history" */
  pp_view_file_history: Array<View_File_History>;
  /** An array relationship */
  previous_documents: Array<Previous_Documents>;
  /** fetch data from the table: "previous_documents" using primary key columns */
  previous_documents_by_pk: Maybe<Previous_Documents>;
  /** An array relationship */
  produced_documents: Array<Produced_Documents>;
  /** An aggregate relationship */
  produced_documents_aggregate: Produced_Documents_Aggregate;
  /** fetch data from the table: "produced_documents" using primary key columns */
  produced_documents_by_pk: Maybe<Produced_Documents>;
  /** fetch data from the table: "report" */
  report: Array<Report>;
  /** fetch aggregated fields from the table: "report" */
  report_aggregate: Report_Aggregate;
  /** fetch data from the table: "report" using primary key columns */
  report_by_pk: Maybe<Report>;
  /** fetch data from the table: "service" */
  service: Array<Service>;
  /** fetch data from the table: "service" using primary key columns */
  service_by_pk: Maybe<Service>;
  /** fetch data from the table: "service_rate" */
  service_rate: Array<Service_Rate>;
  /** fetch data from the table: "service_tariff" */
  service_tariff: Array<Service_Tariff>;
  /** fetch aggregated fields from the table: "service_tariff" */
  service_tariff_aggregate: Service_Tariff_Aggregate;
  /** fetch data from the table: "setting" */
  setting: Array<Setting>;
  /** fetch data from the table: "setting" using primary key columns */
  setting_by_pk: Maybe<Setting>;
  /** fetch data from the table: "setting_group" */
  setting_group: Array<Setting_Group>;
  /** fetch data from the table: "setting_group" using primary key columns */
  setting_group_by_pk: Maybe<Setting_Group>;
  /** fetch data from the table: "setting_value" */
  setting_value: Array<Setting_Value>;
  /** fetch data from the table: "setting_value" using primary key columns */
  setting_value_by_pk: Maybe<Setting_Value>;
  /** fetch data from the table: "tariff_number_description" */
  tariff_number_description: Array<Tariff_Number_Description>;
  /** fetch data from the table: "tariff_number_description" using primary key columns */
  tariff_number_description_by_pk: Maybe<Tariff_Number_Description>;
  /** fetch data from the table: "task_type" */
  task_type: Array<Task_Type>;
  /** fetch data from the table: "task_type" using primary key columns */
  task_type_by_pk: Maybe<Task_Type>;
  /** fetch data from the table: "tenant" */
  tenant: Array<Tenant>;
  /** fetch data from the table: "tenant" using primary key columns */
  tenant_by_pk: Maybe<Tenant>;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch data from the table: "transitdoc_type_descr" */
  transitdoc_type_descr: Array<Transitdoc_Type_Descr>;
  /** fetch data from the table: "user_org_id" */
  user_org_id: Array<User_Org_Id>;
  /** fetch data from the table: "user_org_id" using primary key columns */
  user_org_id_by_pk: Maybe<User_Org_Id>;
  /** fetch data from the table: "user_pp" */
  user_pp: Array<User_Pp>;
  /** fetch data from the table: "user_pp" using primary key columns */
  user_pp_by_pk: Maybe<User_Pp>;
  /** fetch data from the table: "user_search_type" */
  user_search_type: Array<User_Search_Type>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch data from the table: "view_document_history" */
  view_document_history: Array<View_Document_History>;
  /** fetch data from the table: "view_file_history" */
  view_file_history: Array<View_File_History>;
  /** fetch data from the table: "view_history" */
  view_history: Array<View_History>;
  /** fetch data from the table: "vw_documents" */
  vw_documents: Array<Vw_Documents>;
  /** fetch data from the table: "vw_finished_files" */
  vw_finished_files: Array<Vw_Finished_Files>;
};


export type Query_RootAcs_Goods_Items_For_DrsArgs = {
  _curr_userid?: InputMaybe<Scalars['String']>;
  args: AcsDeclarationGoodsItemsArgs;
};


export type Query_RootAcs_Goods_Items_For_Drs_CountArgs = {
  args: AcsDeclarationGoodsItemsArgs;
};


export type Query_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAddress_GroupArgs = {
  distinct_on?: InputMaybe<Array<Address_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Group_Order_By>>;
  where?: InputMaybe<Address_Group_Bool_Exp>;
};


export type Query_RootAddress_Group_By_PkArgs = {
  group_id: Scalars['smallint'];
  payer_address?: InputMaybe<Scalars['Int']>;
};


export type Query_RootAddress_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Address_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Groups_Order_By>>;
  where?: InputMaybe<Address_Groups_Bool_Exp>;
};


export type Query_RootAddress_MappingArgs = {
  distinct_on?: InputMaybe<Array<Address_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Mapping_Order_By>>;
  where?: InputMaybe<Address_Mapping_Bool_Exp>;
};


export type Query_RootAddress_Mapping_By_PkArgs = {
  address_id: Scalars['Int'];
  tenant_id: Scalars['uuid'];
};


export type Query_RootAddress_OverrideArgs = {
  distinct_on?: InputMaybe<Array<Address_Override_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Override_Order_By>>;
  where?: InputMaybe<Address_Override_Bool_Exp>;
};


export type Query_RootAddress_Override_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAddress_TypeArgs = {
  distinct_on?: InputMaybe<Array<Address_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Type_Order_By>>;
  where?: InputMaybe<Address_Type_Bool_Exp>;
};


export type Query_RootAddress_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Query_RootAi_Stats_Dt_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ai_Stats_Dt_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Dt_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Dt_Type_Bool_Exp>;
};


export type Query_RootAi_Stats_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ai_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Type_Bool_Exp>;
};


export type Query_RootAnnotation_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Annotation_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Annotation_Provider_Order_By>>;
  where?: InputMaybe<Annotation_Provider_Bool_Exp>;
};


export type Query_RootAnnotation_Provider_By_PkArgs = {
  annotation_provider_id: Scalars['smallint'];
};


export type Query_RootAnnotation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Annotation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Annotation_Type_Order_By>>;
  where?: InputMaybe<Annotation_Type_Bool_Exp>;
};


export type Query_RootAnnotation_Type_By_PkArgs = {
  anno_type_id: Scalars['smallint'];
  annotation_provider_id: Scalars['smallint'];
  document_type: Scalars['String'];
};


export type Query_RootApi_KeyArgs = {
  distinct_on?: InputMaybe<Array<Api_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Key_Order_By>>;
  where?: InputMaybe<Api_Key_Bool_Exp>;
};


export type Query_RootApi_Key_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootArrival_TypeArgs = {
  distinct_on?: InputMaybe<Array<Arrival_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Arrival_Type_Order_By>>;
  where?: InputMaybe<Arrival_Type_Bool_Exp>;
};


export type Query_RootArrival_Type_By_PkArgs = {
  arrival_type: Scalars['String'];
};


export type Query_RootArticleArgs = {
  distinct_on?: InputMaybe<Array<Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Order_By>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


export type Query_RootArticle_By_PkArgs = {
  article_id: Scalars['smallint'];
  doc_id: Scalars['uuid'];
};


export type Query_RootBillArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Order_By>>;
  where?: InputMaybe<Bill_Bool_Exp>;
};


export type Query_RootBill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Order_By>>;
  where?: InputMaybe<Bill_Bool_Exp>;
};


export type Query_RootBill_By_PkArgs = {
  bill_id: Scalars['bigint'];
};


export type Query_RootBill_DetailArgs = {
  distinct_on?: InputMaybe<Array<Bill_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Detail_Order_By>>;
  where?: InputMaybe<Bill_Detail_Bool_Exp>;
};


export type Query_RootBill_Detail_By_PkArgs = {
  detail_id: Scalars['bigint'];
};


export type Query_RootClearance_TypeArgs = {
  distinct_on?: InputMaybe<Array<Clearance_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clearance_Type_Order_By>>;
  where?: InputMaybe<Clearance_Type_Bool_Exp>;
};


export type Query_RootClearance_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootContainersArgs = {
  distinct_on?: InputMaybe<Array<Containers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Containers_Order_By>>;
  where?: InputMaybe<Containers_Bool_Exp>;
};


export type Query_RootContainers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCount_TypeArgs = {
  distinct_on?: InputMaybe<Array<Count_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Count_Type_Order_By>>;
  where?: InputMaybe<Count_Type_Bool_Exp>;
};


export type Query_RootCustoms_OfficeArgs = {
  distinct_on?: InputMaybe<Array<Customs_Office_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Office_Order_By>>;
  where?: InputMaybe<Customs_Office_Bool_Exp>;
};


export type Query_RootCustoms_Office_By_PkArgs = {
  office_number: Scalars['String'];
  valid_from: Scalars['timestamptz'];
};


export type Query_RootCustoms_OfficesArgs = {
  distinct_on?: InputMaybe<Array<Customs_Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Offices_Order_By>>;
  where?: InputMaybe<Customs_Offices_Bool_Exp>;
};


export type Query_RootCustoms_Offices_By_PkArgs = {
  office_number: Scalars['String'];
};


export type Query_RootCustoms_Response_DataArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Data_Order_By>>;
  where?: InputMaybe<Customs_Response_Data_Bool_Exp>;
};


export type Query_RootCustoms_Response_Data_By_PkArgs = {
  doc_id: Scalars['uuid'];
  document_version: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Query_RootCustoms_Response_DecodedArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Decoded_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Decoded_Order_By>>;
  where?: InputMaybe<Customs_Response_Decoded_Bool_Exp>;
};


export type Query_RootCustoms_Response_Goods_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Goods_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Goods_Items_Order_By>>;
  where?: InputMaybe<Customs_Response_Goods_Items_Bool_Exp>;
};


export type Query_RootCustoms_Response_Goods_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Goods_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Goods_Items_Order_By>>;
  where?: InputMaybe<Customs_Response_Goods_Items_Bool_Exp>;
};


export type Query_RootCustoms_Response_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Summary_Order_By>>;
  where?: InputMaybe<Customs_Response_Summary_Bool_Exp>;
};


export type Query_RootDeclarationArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Order_By>>;
  where?: InputMaybe<Declaration_Bool_Exp>;
};


export type Query_RootDeclaration_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Query_RootDeclaration_DiscussionArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


export type Query_RootDeclaration_Discussion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


export type Query_RootDeclaration_Discussion_By_PkArgs = {
  discussion_id: Scalars['bigint'];
};


export type Query_RootDeclaration_DiscussionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussions_Order_By>>;
  where?: InputMaybe<Declaration_Discussions_Bool_Exp>;
};


export type Query_RootDeclaration_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Document_Order_By>>;
  where?: InputMaybe<Declaration_Document_Bool_Exp>;
};


export type Query_RootDeclaration_Document_By_PkArgs = {
  doc_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Query_RootDeclaration_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Labels_Bool_Exp>;
};


export type Query_RootDeclaration_Labels_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDeclaration_MessageArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


export type Query_RootDeclaration_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


export type Query_RootDeclaration_Message_By_PkArgs = {
  creation_user: Scalars['uuid'];
  discussion_id: Scalars['bigint'];
  msg_date: Scalars['timestamptz'];
  read_date?: InputMaybe<Scalars['timestamptz']>;
};


export type Query_RootDeclaration_RequestArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


export type Query_RootDeclaration_Request_AddressArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


export type Query_RootDeclaration_Request_Address_AiArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Ai_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Ai_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Ai_Bool_Exp>;
};


export type Query_RootDeclaration_Request_Address_Ai_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDeclaration_Request_Address_By_PkArgs = {
  address_type: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Query_RootDeclaration_Request_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Query_RootDeclaration_Request_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
};


export type Query_RootDeclaration_Request_Labels_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  label_id: Scalars['Int'];
};


export type Query_RootDeclaration_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Requests_Order_By>>;
  where?: InputMaybe<Declaration_Requests_Bool_Exp>;
};


export type Query_RootDeclaration_SearchArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Search_Order_By>>;
  where?: InputMaybe<Declaration_Search_Bool_Exp>;
};


export type Query_RootDeclaration_Special_MentionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Special_Mentions_Order_By>>;
  where?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
};


export type Query_RootDeclaration_Special_Mentions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDeclaration_StatusArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Status_Order_By>>;
  where?: InputMaybe<Declaration_Status_Bool_Exp>;
};


export type Query_RootDeclaration_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootDeclaration_TaskArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


export type Query_RootDeclaration_Task_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


export type Query_RootDeclaration_Task_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDeclaration_TasksArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Bool_Exp>;
};


export type Query_RootDeclaration_Tasks_ObjArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Obj_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Obj_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Obj_Bool_Exp>;
};


export type Query_RootDeclaration_TypeArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Type_Order_By>>;
  where?: InputMaybe<Declaration_Type_Bool_Exp>;
};


export type Query_RootDeclaration_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootDiscussion_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Discussion_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discussion_Changes_Order_By>>;
  where?: InputMaybe<Discussion_Changes_Bool_Exp>;
};


export type Query_RootDoc_AnnotationArgs = {
  distinct_on?: InputMaybe<Array<Doc_Annotation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Annotation_Order_By>>;
  where?: InputMaybe<Doc_Annotation_Bool_Exp>;
};


export type Query_RootDoc_Annotation_By_PkArgs = {
  anno_type_id: Scalars['smallint'];
  doc_id: Scalars['uuid'];
};


export type Query_RootDoc_Search_TypeArgs = {
  distinct_on?: InputMaybe<Array<Doc_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Search_Type_Order_By>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Query_RootDoc_Stats_TypeArgs = {
  distinct_on?: InputMaybe<Array<Doc_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Stats_Type_Order_By>>;
  where?: InputMaybe<Doc_Stats_Type_Bool_Exp>;
};


export type Query_RootDocs_For_ValidationArgs = {
  distinct_on?: InputMaybe<Array<Docs_For_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Docs_For_Validation_Order_By>>;
  where?: InputMaybe<Docs_For_Validation_Bool_Exp>;
};


export type Query_RootDocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootDocument_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootDocument_By_PkArgs = {
  document_type: Scalars['String'];
  id: Scalars['uuid'];
};


export type Query_RootDocument_ExtensionArgs = {
  distinct_on?: InputMaybe<Array<Document_Extension_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Extension_Order_By>>;
  where?: InputMaybe<Document_Extension_Bool_Exp>;
};


export type Query_RootDocument_Extension_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootDocument_FlagArgs = {
  distinct_on?: InputMaybe<Array<Document_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Flag_Order_By>>;
  where?: InputMaybe<Document_Flag_Bool_Exp>;
};


export type Query_RootDocument_Flag_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDocument_Is_AllowedArgs = {
  args: Document_Is_Allowed_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootDocument_Is_Allowed_AggregateArgs = {
  args: Document_Is_Allowed_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootDocument_Label_Org_IdArgs = {
  distinct_on?: InputMaybe<Array<Document_Label_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Label_Org_Id_Order_By>>;
  where?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
};


export type Query_RootDocument_Label_Org_Id_By_PkArgs = {
  label_id: Scalars['Int'];
  org_id: Scalars['smallint'];
};


export type Query_RootDocument_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Document_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Labels_Order_By>>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};


export type Query_RootDocument_Labels_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDocument_PageArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


export type Query_RootDocument_Page_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


export type Query_RootDocument_Page_By_PkArgs = {
  document_id: Scalars['uuid'];
  page_id: Scalars['uuid'];
  page_number: Scalars['smallint'];
};


export type Query_RootDocument_StatusArgs = {
  distinct_on?: InputMaybe<Array<Document_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Status_Order_By>>;
  where?: InputMaybe<Document_Status_Bool_Exp>;
};


export type Query_RootDocument_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootDocument_TypeArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Query_RootDocument_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Query_RootDocument_Type_All_Tenant_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
};


export type Query_RootDocument_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootDocument_Type_Tenant_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
};


export type Query_RootDocument_Type_Tenant_Settings_By_PkArgs = {
  document_type: Scalars['String'];
  tenant: Scalars['uuid'];
};


export type Query_RootDocumentsArgs = {
  file: Scalars['UUID'];
  filters: FiltersExpressionAcsInput;
};


export type Query_RootDr_Goods_ItemArgs = {
  distinct_on?: InputMaybe<Array<Dr_Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Item_Order_By>>;
  where?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
};


export type Query_RootDr_Goods_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dr_Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Item_Order_By>>;
  where?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
};


export type Query_RootDr_Goods_Item_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  source: Scalars['smallint'];
  trader_item_id: Scalars['Int'];
};


export type Query_RootDr_Goods_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Dr_Goods_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Items_Order_By>>;
  where?: InputMaybe<Dr_Goods_Items_Bool_Exp>;
};


export type Query_RootDr_StatsArgs = {
  distinct_on?: InputMaybe<Array<Dr_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Stats_Order_By>>;
  where?: InputMaybe<Dr_Stats_Bool_Exp>;
};


export type Query_RootEdec_CountriesArgs = {
  distinct_on?: InputMaybe<Array<Edec_Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Countries_Order_By>>;
  where?: InputMaybe<Edec_Countries_Bool_Exp>;
};


export type Query_RootEdec_Countries_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEdec_Customs_OfficesArgs = {
  distinct_on?: InputMaybe<Array<Edec_Customs_Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Customs_Offices_Order_By>>;
  where?: InputMaybe<Edec_Customs_Offices_Bool_Exp>;
};


export type Query_RootEdec_Customs_Offices_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEdec_DomainsArgs = {
  distinct_on?: InputMaybe<Array<Edec_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Domains_Order_By>>;
  where?: InputMaybe<Edec_Domains_Bool_Exp>;
};


export type Query_RootEdec_Domains_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEdec_Tariff_Commodity_CodeArgs = {
  distinct_on?: InputMaybe<Array<Edec_Tariff_Commodity_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Tariff_Commodity_Code_Order_By>>;
  where?: InputMaybe<Edec_Tariff_Commodity_Code_Bool_Exp>;
};


export type Query_RootEdec_Tariff_Commodity_Code_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEdec_Tariff_Statistical_CodeArgs = {
  distinct_on?: InputMaybe<Array<Edec_Tariff_Statistical_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Tariff_Statistical_Code_Order_By>>;
  where?: InputMaybe<Edec_Tariff_Statistical_Code_Bool_Exp>;
};


export type Query_RootEdec_Tariff_Statistical_Code_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEmail_Search_TypeArgs = {
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Query_RootEmail_Search_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Query_RootExtract_TypeArgs = {
  distinct_on?: InputMaybe<Array<Extract_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Extract_Type_Order_By>>;
  where?: InputMaybe<Extract_Type_Bool_Exp>;
};


export type Query_RootExtract_Type_By_PkArgs = {
  extract_type_id: Scalars['smallint'];
};


export type Query_RootExtraction_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Extraction_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Extraction_Config_Order_By>>;
  where?: InputMaybe<Extraction_Config_Bool_Exp>;
};


export type Query_RootExtraction_Config_By_PkArgs = {
  address_id: Scalars['Int'];
};


export type Query_RootFileArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Query_RootFile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Query_RootFile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFile_Stats_TypeArgs = {
  distinct_on?: InputMaybe<Array<File_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Stats_Type_Order_By>>;
  where?: InputMaybe<File_Stats_Type_Bool_Exp>;
};


export type Query_RootFile_TypeArgs = {
  distinct_on?: InputMaybe<Array<File_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Type_Order_By>>;
  where?: InputMaybe<File_Type_Bool_Exp>;
};


export type Query_RootFile_Type_By_PkArgs = {
  doc_types?: InputMaybe<Scalars['_varchar']>;
  file_type: Scalars['String'];
};


export type Query_RootGetAddressesByFrequencyArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetAddressesOrOverrideAcsArgs = {
  ids: Array<Scalars['Float']>;
};


export type Query_RootGetAddressOverridesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetBordereausArgs = {
  args?: InputMaybe<BordereauArgs>;
};


export type Query_RootGetCommodityCodesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetDeclarationGoodItemsStatisticsArgs = {
  addresses?: InputMaybe<Scalars['String']>;
  addresses_qi?: InputMaybe<Scalars['String']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  declaration_labels?: InputMaybe<Scalars['String']>;
  declaration_statuses?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  evv_status?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  max_date?: InputMaybe<Scalars['timestamptz']>;
  min_date?: InputMaybe<Scalars['timestamptz']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderby?: InputMaybe<Scalars['String']>;
  payer?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  search_field?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  total_items?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetDeclarationRequestsAditArgs = {
  addresses?: InputMaybe<Array<AddressFilter>>;
  dateMax?: InputMaybe<Scalars['LocalDateTime']>;
  dateMin?: InputMaybe<Scalars['LocalDateTime']>;
  declarationStatus?: InputMaybe<Array<DeclarationStatus>>;
  limit?: InputMaybe<Scalars['Int']>;
  maxTotalColis?: InputMaybe<Scalars['Int']>;
  maxTotalGrossWeight?: InputMaybe<Scalars['Float']>;
  minTotalColis?: InputMaybe<Scalars['Int']>;
  minTotalGrossWeight?: InputMaybe<Scalars['Float']>;
  nonclassifiedDocsExists?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['JSONObject']>>;
  orgIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetDeclarationRequestStatisticsArgs = {
  addresses?: InputMaybe<Scalars['String']>;
  addresses_qi?: InputMaybe<Scalars['String']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  declaration_statuses?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  evv_status?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  max_date?: InputMaybe<Scalars['timestamptz']>;
  min_date?: InputMaybe<Scalars['timestamptz']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderby?: InputMaybe<Scalars['String']>;
  payer_id?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  search_field?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};


export type Query_RootGetFileDocumentsArgs = {
  documentStatus?: InputMaybe<Array<DocumentStatus>>;
  fileId?: InputMaybe<Scalars['UUID']>;
};


export type Query_RootGetFilesArgs = {
  fileNumber: Scalars['String'];
};


export type Query_RootGetGoodItemsStatisticsArgs = {
  commodityCodes?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderby?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetOrgIdsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type Query_RootGetPageFragmentTextArgs = {
  height?: InputMaybe<Scalars['Int']>;
  pageUrl?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
  x?: InputMaybe<Scalars['Int']>;
  y?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetSasTokenArgs = {
  container: Scalars['String'];
  contentDisposition?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetTenantConfigArgs = {
  tenantId?: InputMaybe<Scalars['ID']>;
};


export type Query_RootGetTenantsArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetUsersArgs = {
  args?: InputMaybe<GetUsersArgs>;
};


export type Query_RootGetWdUsersArgs = {
  args?: InputMaybe<GetUsersArgs>;
};


export type Query_RootGoods_ItemArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Order_By>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


export type Query_RootGoods_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Order_By>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


export type Query_RootGoods_Item_By_PkArgs = {
  customs_item_number: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Query_RootGoods_Item_Special_MentionsArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Special_Mentions_Order_By>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


export type Query_RootGoods_Item_Special_Mentions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Special_Mentions_Order_By>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


export type Query_RootGoods_Item_Special_Mentions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGoods_Items_For_DrsArgs = {
  distinct_on?: InputMaybe<Array<Goods_Items_For_Drs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Items_For_Drs_Order_By>>;
  where?: InputMaybe<Goods_Items_For_Drs_Bool_Exp>;
};


export type Query_RootGroup_MemberArgs = {
  distinct_on?: InputMaybe<Array<Group_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Member_Order_By>>;
  where?: InputMaybe<Group_Member_Bool_Exp>;
};


export type Query_RootGroup_Member_By_PkArgs = {
  address_id: Scalars['Int'];
  clearance_types: Scalars['_text'];
  declaration_types: Scalars['_text'];
  group_id: Scalars['smallint'];
};


export type Query_RootGroup_MembersArgs = {
  distinct_on?: InputMaybe<Array<Group_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Members_Order_By>>;
  where?: InputMaybe<Group_Members_Bool_Exp>;
};


export type Query_RootImport_List_TriggerArgs = {
  distinct_on?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_List_Trigger_Order_By>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


export type Query_RootImport_List_Trigger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_List_Trigger_Order_By>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


export type Query_RootImport_List_Trigger_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootIntf_Dr_Payment_InfoArgs = {
  distinct_on?: InputMaybe<Array<Intf_Dr_Payment_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Intf_Dr_Payment_Info_Order_By>>;
  where?: InputMaybe<Intf_Dr_Payment_Info_Bool_Exp>;
};


export type Query_RootJson_TypeArgs = {
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootKc_UsersArgs = {
  distinct_on?: InputMaybe<Array<Kc_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kc_Users_Order_By>>;
  where?: InputMaybe<Kc_Users_Bool_Exp>;
};


export type Query_RootMax_Date_TypeArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Query_RootModel_RetrainArgs = {
  distinct_on?: InputMaybe<Array<Model_Retrain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Retrain_Order_By>>;
  where?: InputMaybe<Model_Retrain_Bool_Exp>;
};


export type Query_RootModel_Retrain_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootNotificationsArgs = {
  count: Scalars['Int'];
};


export type Query_RootOrg_IdArgs = {
  distinct_on?: InputMaybe<Array<Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Id_Order_By>>;
  where?: InputMaybe<Org_Id_Bool_Exp>;
};


export type Query_RootOrg_Id_By_PkArgs = {
  org_id: Scalars['smallint'];
};


export type Query_RootOrg_IdsArgs = {
  distinct_on?: InputMaybe<Array<Org_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Ids_Order_By>>;
  where?: InputMaybe<Org_Ids_Bool_Exp>;
};


export type Query_RootOrg_ParamsArgs = {
  distinct_on?: InputMaybe<Array<Org_Params_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Params_Order_By>>;
  where?: InputMaybe<Org_Params_Bool_Exp>;
};


export type Query_RootOrg_Params_By_PkArgs = {
  org_id: Scalars['Int'];
};


export type Query_RootOrg_Params_Org_IdArgs = {
  distinct_on?: InputMaybe<Array<Org_Params_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Params_Org_Id_Order_By>>;
  where?: InputMaybe<Org_Params_Org_Id_Bool_Exp>;
};


export type Query_RootPackagingsArgs = {
  distinct_on?: InputMaybe<Array<Packagings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packagings_Order_By>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


export type Query_RootPackagings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packagings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packagings_Order_By>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


export type Query_RootPackagings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPageArgs = {
  distinct_on?: InputMaybe<Array<Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Order_By>>;
  where?: InputMaybe<Page_Bool_Exp>;
};


export type Query_RootPage_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPage_ExtractArgs = {
  distinct_on?: InputMaybe<Array<Page_Extract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Extract_Order_By>>;
  where?: InputMaybe<Page_Extract_Bool_Exp>;
};


export type Query_RootPage_Extract_By_PkArgs = {
  extract_type_id: Scalars['smallint'];
  page_id: Scalars['uuid'];
};


export type Query_RootPage_StatusArgs = {
  distinct_on?: InputMaybe<Array<Page_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Status_Order_By>>;
  where?: InputMaybe<Page_Status_Bool_Exp>;
};


export type Query_RootPage_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootPages_M2m_CacheArgs = {
  distinct_on?: InputMaybe<Array<Pages_M2m_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_M2m_Cache_Order_By>>;
  where?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
};


export type Query_RootPages_M2m_Cache_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pages_M2m_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_M2m_Cache_Order_By>>;
  where?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
};


export type Query_RootPermitsArgs = {
  distinct_on?: InputMaybe<Array<Permits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permits_Order_By>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


export type Query_RootPermits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permits_Order_By>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


export type Query_RootPermits_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPp_Address_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Address_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Groups_Order_By>>;
  where?: InputMaybe<Address_Groups_Bool_Exp>;
};


export type Query_RootPp_AddressesArgs = {
  args: Pp_Addresses_Args;
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Query_RootPp_Addresses_By_Payer_AddressArgs = {
  args: Pp_Addresses_By_Payer_Address_Args;
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Query_RootPp_Addresses_By_Payer_IdArgs = {
  args: Pp_Addresses_By_Payer_Id_Args;
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Query_RootPp_Ai_StatsArgs = {
  args: Pp_Ai_Stats_Args;
  distinct_on?: InputMaybe<Array<Ai_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Type_Bool_Exp>;
};


export type Query_RootPp_Ai_Stats_DtArgs = {
  args: Pp_Ai_Stats_Dt_Args;
  distinct_on?: InputMaybe<Array<Ai_Stats_Dt_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Dt_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Dt_Type_Bool_Exp>;
};


export type Query_RootPp_Check_Json_ParamArgs = {
  args: Pp_Check_Json_Param_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Customs_Response_SummaryArgs = {
  args: Pp_Customs_Response_Summary_Args;
  distinct_on?: InputMaybe<Array<Customs_Response_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Summary_Order_By>>;
  where?: InputMaybe<Customs_Response_Summary_Bool_Exp>;
};


export type Query_RootPp_Declaration_RequestArgs = {
  args: Pp_Declaration_Request_Args;
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


export type Query_RootPp_Declaration_RequestsArgs = {
  _curr_userid?: InputMaybe<Scalars['UUID']>;
  args: DeclarationRequestsArgs;
};


export type Query_RootPp_Declaration_Requests_CountArgs = {
  _curr_userid?: InputMaybe<Scalars['UUID']>;
  args: DeclarationRequestsArgs;
};


export type Query_RootPp_Declaration_Requests_ReportArgs = {
  args: DeclarationRequestsReportArgs;
};


export type Query_RootPp_Declaration_TasksArgs = {
  args: Pp_Declaration_Tasks_Args;
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Bool_Exp>;
};


export type Query_RootPp_Declaration_Tasks_AggArgs = {
  args: Pp_Declaration_Tasks_Agg_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Declaration_Tasks_ObjArgs = {
  args: Pp_Declaration_Tasks_Obj_Args;
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Obj_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Obj_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Obj_Bool_Exp>;
};


export type Query_RootPp_DeclarationsArgs = {
  args: Pp_Declarations_Args;
  distinct_on?: InputMaybe<Array<Declaration_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Search_Order_By>>;
  where?: InputMaybe<Declaration_Search_Bool_Exp>;
};


export type Query_RootPp_Delete_Declaration_RequestsArgs = {
  args: Pp_Delete_Declaration_Requests_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Doc_Max_Date_HsArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Query_RootPp_Doc_Max_Date_V2Args = {
  args: Pp_Doc_Max_Date_V2_Args;
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Query_RootPp_Doc_SearchArgs = {
  args: Pp_Doc_Search_Args;
  distinct_on?: InputMaybe<Array<Doc_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Search_Type_Order_By>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Query_RootPp_Doc_Search_HsArgs = {
  args: Pp_Doc_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Doc_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Search_Type_Order_By>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Query_RootPp_Doc_StatsArgs = {
  args: Pp_Doc_Stats_Args;
  distinct_on?: InputMaybe<Array<Doc_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Stats_Type_Order_By>>;
  where?: InputMaybe<Doc_Stats_Type_Bool_Exp>;
};


export type Query_RootPp_Docs_For_ValidationArgs = {
  args: Pp_Docs_For_Validation_Args;
  distinct_on?: InputMaybe<Array<Docs_For_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Docs_For_Validation_Order_By>>;
  where?: InputMaybe<Docs_For_Validation_Bool_Exp>;
};


export type Query_RootPp_DocumentArgs = {
  args: Pp_Document_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootPp_Document_AggregateArgs = {
  args: Pp_Document_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootPp_Document_FlagArgs = {
  args: Pp_Document_Flag_Args;
  distinct_on?: InputMaybe<Array<Document_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Flag_Order_By>>;
  where?: InputMaybe<Document_Flag_Bool_Exp>;
};


export type Query_RootPp_Document_LabelsArgs = {
  args: Pp_Document_Labels_Args;
  distinct_on?: InputMaybe<Array<Document_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Labels_Order_By>>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};


export type Query_RootPp_Dr_Goods_ItemsArgs = {
  args: Pp_Dr_Goods_Items_Args;
  distinct_on?: InputMaybe<Array<Dr_Goods_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Items_Order_By>>;
  where?: InputMaybe<Dr_Goods_Items_Bool_Exp>;
};


export type Query_RootPp_Dr_Max_DateArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Query_RootPp_Dr_StatsArgs = {
  args: Pp_Dr_Stats_Args;
  distinct_on?: InputMaybe<Array<Dr_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Stats_Order_By>>;
  where?: InputMaybe<Dr_Stats_Bool_Exp>;
};


export type Query_RootPp_Email_SearchArgs = {
  args: Pp_Email_Search_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Query_RootPp_Email_Search_AggregateArgs = {
  args: Pp_Email_Search_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Query_RootPp_Email_Search_HsArgs = {
  args: Pp_Email_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Query_RootPp_Email_Search_Hs_AggregateArgs = {
  args: Pp_Email_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Query_RootPp_File_Max_Date_HsArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Query_RootPp_File_Max_Date_V2Args = {
  args: Pp_File_Max_Date_V2_Args;
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Query_RootPp_File_SearchArgs = {
  args: Pp_File_Search_Args;
  distinct_on?: InputMaybe<Array<Pp_Types_File_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pp_Types_File_Search_Order_By>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Query_RootPp_File_Search_HsArgs = {
  args: Pp_File_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Pp_Types_File_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pp_Types_File_Search_Order_By>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Query_RootPp_File_StatsArgs = {
  args: Pp_File_Stats_Args;
  distinct_on?: InputMaybe<Array<File_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Stats_Type_Order_By>>;
  where?: InputMaybe<File_Stats_Type_Bool_Exp>;
};


export type Query_RootPp_Get_Kpi_Commodity_CodeArgs = {
  commodity_code?: InputMaybe<Scalars['String']>;
  date_from: Scalars['String'];
  date_to: Scalars['String'];
  tenant_id?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
};


export type Query_RootPp_Get_KpisArgs = {
  date_from: Scalars['String'];
  date_to: Scalars['String'];
  interval: Scalars['String'];
  lang?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
};


export type Query_RootPp_Get_Wd_Perms_For_DrArgs = {
  args: Pp_Get_Wd_Perms_For_Dr_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Group_MembersArgs = {
  distinct_on?: InputMaybe<Array<Group_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Members_Order_By>>;
  where?: InputMaybe<Group_Members_Bool_Exp>;
};


export type Query_RootPp_Hasura_SessionArgs = {
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Kc_UsersArgs = {
  args: Pp_Kc_Users_Args;
  distinct_on?: InputMaybe<Array<Kc_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kc_Users_Order_By>>;
  where?: InputMaybe<Kc_Users_Bool_Exp>;
};


export type Query_RootPp_Last_Doc_In_DrArgs = {
  args: Pp_Last_Doc_In_Dr_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootPp_Last_Doc_In_Dr_AggregateArgs = {
  args: Pp_Last_Doc_In_Dr_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootPp_Menu_IndicatorsArgs = {
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Org_Id_DeleteArgs = {
  args: Pp_Org_Id_Delete_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Org_Id_InsertArgs = {
  args: Pp_Org_Id_Insert_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Org_Id_UpdateArgs = {
  args: Pp_Org_Id_Update_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Org_IdsArgs = {
  args: Pp_Org_Ids_Args;
  distinct_on?: InputMaybe<Array<Org_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Ids_Order_By>>;
  where?: InputMaybe<Org_Ids_Bool_Exp>;
};


export type Query_RootPp_Page_Extract_Grids_TextArgs = {
  args: Pp_Page_Extract_Grids_Text_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Page_Extract_Text_FragmentArgs = {
  args: Pp_Page_Extract_Text_Fragment_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Page_Extract_Text_Fragment_V2Args = {
  args: Pp_Page_Extract_Text_Fragment_V2_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_TenantsArgs = {
  args: Pp_Tenants_Args;
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Query_RootPp_Types_File_SearchArgs = {
  distinct_on?: InputMaybe<Array<Pp_Types_File_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pp_Types_File_Search_Order_By>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Query_RootPp_User_Org_IdArgs = {
  args: Pp_User_Org_Id_Args;
  distinct_on?: InputMaybe<Array<User_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Org_Id_Order_By>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};


export type Query_RootPp_User_SearchArgs = {
  args: Pp_User_Search_Args;
  distinct_on?: InputMaybe<Array<User_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Search_Type_Order_By>>;
  where?: InputMaybe<User_Search_Type_Bool_Exp>;
};


export type Query_RootPp_UsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootPp_View_Document_HistoryArgs = {
  args: Pp_View_Document_History_Args;
  distinct_on?: InputMaybe<Array<View_Document_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_Document_History_Order_By>>;
  where?: InputMaybe<View_Document_History_Bool_Exp>;
};


export type Query_RootPp_View_File_HistoryArgs = {
  args: Pp_View_File_History_Args;
  distinct_on?: InputMaybe<Array<View_File_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_File_History_Order_By>>;
  where?: InputMaybe<View_File_History_Bool_Exp>;
};


export type Query_RootPrevious_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Previous_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Previous_Documents_Order_By>>;
  where?: InputMaybe<Previous_Documents_Bool_Exp>;
};


export type Query_RootPrevious_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProduced_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produced_Documents_Order_By>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};


export type Query_RootProduced_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produced_Documents_Order_By>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};


export type Query_RootProduced_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootReportArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Query_RootReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Query_RootReport_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootServiceArgs = {
  distinct_on?: InputMaybe<Array<Service_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Order_By>>;
  where?: InputMaybe<Service_Bool_Exp>;
};


export type Query_RootService_By_PkArgs = {
  srv_id: Scalars['Int'];
};


export type Query_RootService_RateArgs = {
  distinct_on?: InputMaybe<Array<Service_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Rate_Order_By>>;
  where?: InputMaybe<Service_Rate_Bool_Exp>;
};


export type Query_RootService_TariffArgs = {
  distinct_on?: InputMaybe<Array<Service_Tariff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Tariff_Order_By>>;
  where?: InputMaybe<Service_Tariff_Bool_Exp>;
};


export type Query_RootService_Tariff_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Tariff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Tariff_Order_By>>;
  where?: InputMaybe<Service_Tariff_Bool_Exp>;
};


export type Query_RootSettingArgs = {
  distinct_on?: InputMaybe<Array<Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Order_By>>;
  where?: InputMaybe<Setting_Bool_Exp>;
};


export type Query_RootSetting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSetting_GroupArgs = {
  distinct_on?: InputMaybe<Array<Setting_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Group_Order_By>>;
  where?: InputMaybe<Setting_Group_Bool_Exp>;
};


export type Query_RootSetting_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSetting_ValueArgs = {
  distinct_on?: InputMaybe<Array<Setting_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Value_Order_By>>;
  where?: InputMaybe<Setting_Value_Bool_Exp>;
};


export type Query_RootSetting_Value_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTariff_Number_DescriptionArgs = {
  distinct_on?: InputMaybe<Array<Tariff_Number_Description_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tariff_Number_Description_Order_By>>;
  where?: InputMaybe<Tariff_Number_Description_Bool_Exp>;
};


export type Query_RootTariff_Number_Description_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTask_TypeArgs = {
  distinct_on?: InputMaybe<Array<Task_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Task_Type_Order_By>>;
  where?: InputMaybe<Task_Type_Bool_Exp>;
};


export type Query_RootTask_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTenantArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenant_Order_By>>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};


export type Query_RootTenant_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTenantsArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Query_RootTransitdoc_Type_DescrArgs = {
  distinct_on?: InputMaybe<Array<Transitdoc_Type_Descr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transitdoc_Type_Descr_Order_By>>;
  where?: InputMaybe<Transitdoc_Type_Descr_Bool_Exp>;
};


export type Query_RootUser_Org_IdArgs = {
  distinct_on?: InputMaybe<Array<User_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Org_Id_Order_By>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};


export type Query_RootUser_Org_Id_By_PkArgs = {
  org_id: Scalars['smallint'];
  user_pp: Scalars['uuid'];
};


export type Query_RootUser_PpArgs = {
  distinct_on?: InputMaybe<Array<User_Pp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Pp_Order_By>>;
  where?: InputMaybe<User_Pp_Bool_Exp>;
};


export type Query_RootUser_Pp_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_Search_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Search_Type_Order_By>>;
  where?: InputMaybe<User_Search_Type_Bool_Exp>;
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootView_Document_HistoryArgs = {
  distinct_on?: InputMaybe<Array<View_Document_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_Document_History_Order_By>>;
  where?: InputMaybe<View_Document_History_Bool_Exp>;
};


export type Query_RootView_File_HistoryArgs = {
  distinct_on?: InputMaybe<Array<View_File_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_File_History_Order_By>>;
  where?: InputMaybe<View_File_History_Bool_Exp>;
};


export type Query_RootView_HistoryArgs = {
  distinct_on?: InputMaybe<Array<View_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_History_Order_By>>;
  where?: InputMaybe<View_History_Bool_Exp>;
};


export type Query_RootVw_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Vw_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vw_Documents_Order_By>>;
  where?: InputMaybe<Vw_Documents_Bool_Exp>;
};


export type Query_RootVw_Finished_FilesArgs = {
  distinct_on?: InputMaybe<Array<Vw_Finished_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vw_Finished_Files_Order_By>>;
  where?: InputMaybe<Vw_Finished_Files_Bool_Exp>;
};

export type AcsDeclarationGoodsItemsArgs = {
  _addresses?: InputMaybe<Array<AddressFilter>>;
  _addresses_qi?: InputMaybe<Scalars['String']>;
  _arrival_type?: InputMaybe<Scalars['String']>;
  _clr_type?: InputMaybe<Scalars['String']>;
  _date_max?: InputMaybe<Scalars['LocalDateTime']>;
  _date_min?: InputMaybe<Scalars['LocalDateTime']>;
  _decl_type?: InputMaybe<Scalars['String']>;
  _declaration_labels?: InputMaybe<Scalars['String']>;
  _declaration_statuses?: InputMaybe<Scalars['String']>;
  _evv_status?: InputMaybe<Scalars['String']>;
  _file_id?: InputMaybe<Scalars['UUID']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Array<Scalars['JSONObject']>>;
  _payer?: InputMaybe<Scalars['UUID']>;
  _search?: InputMaybe<Scalars['String']>;
  _search_field?: InputMaybe<Scalars['String']>;
};

export type AddressFilter = {
  addressIds: Array<Scalars['Int']>;
  addressType: Scalars['String'];
};

export type DeclarationGoodsItems = {
  addresses: Maybe<Array<AddressAcs>>;
  customsItemNumber: Scalars['Int'];
  customsOffice: Maybe<EdecCustomsOffices>;
  declaration: Maybe<DeclarationEntity>;
  declarationLabels: Maybe<Array<Maybe<DeclarationLabel>>>;
  declarationRequest: DeclarationRequestAcs;
  declarationSpecialMentions: Maybe<Array<DeclarationSpecialMentionEntity>>;
  declarationStatus: DeclarationStatus;
  documents: Maybe<Array<Documents>>;
  drNo: Scalars['Int'];
  fileId: Scalars['UUID'];
  goodsItems: Maybe<GoodsItemAcs>;
  goodsItemSpecialMentions: Maybe<Array<GoodsItemSpecialMentionEntity>>;
  identification: Maybe<Scalars['String']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  myDuties: Maybe<Scalars['Float']>;
  packagings: Maybe<Array<PackagingEntity>>;
  permits: Maybe<Array<PermitEntity>>;
  previousDocuments: Maybe<Array<PreviousDocumentEntity>>;
  producedDocuments: Maybe<Array<ProducedDocumentEntity>>;
  refs: Maybe<Scalars['String']>;
  userPp: Maybe<UserPp>;
};

export type AddressAcs = {
  additionalValues: Maybe<Scalars['JSONObject']>;
  addressType: Maybe<AddressTypeAcs>;
  addressTypeId: Maybe<Scalars['Int']>;
  aoId: Maybe<Scalars['Int']>;
  city: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyName2: Maybe<Scalars['String']>;
  contactEmail: Maybe<Scalars['String']>;
  contactPhone: Maybe<Scalars['String']>;
  contactWebsite: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  creationDate: Scalars['DateTime'];
  creationUser: Scalars['UUID'];
  customsAccountNumber: Maybe<Scalars['String']>;
  drReference: Maybe<Scalars['String']>;
  errorEmailAddress: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Maybe<Scalars['Boolean']>;
  isLocked: Scalars['Boolean'];
  isPlatformUser: Scalars['Boolean'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  meta: Maybe<Scalars['JSON']>;
  reference: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  streetNumber: Maybe<Scalars['String']>;
  traderIdentificationNumber: Maybe<Scalars['String']>;
  uidNumber: Maybe<Scalars['String']>;
  usageFrequency: Scalars['Int'];
  vatAccountNumber: Maybe<Scalars['String']>;
  vatNumber: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

export type AddressTypeAcs = {
  id: Scalars['Int'];
  meta: Maybe<Scalars['JSON']>;
  name: Maybe<Scalars['String']>;
  translation: Maybe<Scalars['JSON']>;
};

export type EdecCustomsOffices = {
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  created: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  number: Maybe<Scalars['String']>;
  prefix: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  validFrom: Maybe<Scalars['DateTime']>;
  validTo: Maybe<Scalars['DateTime']>;
  version: Maybe<Scalars['Int']>;
};

export type DeclarationEntity = {
  acceptanceDate: Maybe<Scalars['DateTime']>;
  accessCode: Maybe<Scalars['String']>;
  agreedLocationOfGoods: Maybe<Scalars['String']>;
  borderEauNumber: Maybe<Scalars['Int']>;
  bunchNumber: Maybe<Scalars['Int']>;
  changeInformation: Maybe<Scalars['String']>;
  clearanceLocation: Maybe<Scalars['Int']>;
  companyNumberTaxpayer: Maybe<Scalars['String']>;
  correctionCode: Maybe<Scalars['Int']>;
  correctionReason: Maybe<Scalars['String']>;
  customsAccountName: Maybe<Scalars['String']>;
  customsAccountNumber: Maybe<Scalars['Int']>;
  customsDeclarationNumber: Maybe<Scalars['String']>;
  customsDeclarationVersion: Maybe<Scalars['Int']>;
  customsOfficeNumber: Maybe<Scalars['String']>;
  declarantNumber: Maybe<Scalars['Int']>;
  declarationTime: Maybe<Scalars['Int']>;
  declarationType: Maybe<Scalars['String']>;
  deliveryDestination: Maybe<Scalars['String']>;
  dispatchCountry: Maybe<Scalars['String']>;
  dispatchCountryConfirmation: Maybe<Scalars['Boolean']>;
  drNo: Scalars['Int'];
  dutyAndOtherTaxesAmount: Maybe<Scalars['Float']>;
  dutyTotalAmount: Maybe<Scalars['Float']>;
  evvConfirmed: Scalars['Boolean'];
  evvReceived: Scalars['Boolean'];
  fileId: Scalars['String'];
  goodsItems: Maybe<Array<GoodsItemAcs>>;
  grossMass: Maybe<Scalars['Float']>;
  incoterms: Maybe<Scalars['String']>;
  initiator: Maybe<Scalars['Int']>;
  inspectionCode: Maybe<Scalars['Boolean']>;
  invoiceCurrencyType: Maybe<Scalars['String']>;
  lang: Maybe<Scalars['String']>;
  materialCheck: Maybe<Scalars['Boolean']>;
  packagingQuantity: Maybe<Scalars['Int']>;
  placeOfLoading: Maybe<Scalars['String']>;
  placeOfUnloading: Maybe<Scalars['String']>;
  postalShipmentType: Maybe<Scalars['String']>;
  previousDocument: Maybe<Array<PreviousDocumentEntity>>;
  procedureType: Maybe<Scalars['Int']>;
  provisionalDeclarationExpirationDate: Maybe<Scalars['String']>;
  reason: Maybe<Scalars['String']>;
  receiveStatus: Maybe<Scalars['Int']>;
  release: Maybe<Scalars['Boolean']>;
  requestorTraderIdentificationNumber: Maybe<Scalars['String']>;
  security: Maybe<Scalars['Boolean']>;
  selectionCorrelationId: Maybe<Scalars['String']>;
  sendStatus: Maybe<Scalars['Int']>;
  serviceType: Maybe<Scalars['String']>;
  showInWd: Maybe<Scalars['Boolean']>;
  specialMention: Maybe<Array<DeclarationSpecialMentionEntity>>;
  specificCircumstanceIndicator: Maybe<Scalars['String']>;
  status: Maybe<Scalars['Int']>;
  statusDate: Maybe<Scalars['Date']>;
  statusTime: Maybe<Scalars['String']>;
  totalColis: Maybe<Scalars['Int']>;
  totalGoodsItems: Maybe<Scalars['Int']>;
  totalGrossWeight: Maybe<Scalars['Float']>;
  totalVatValue: Maybe<Scalars['Float']>;
  traderDeclarationNumber: Maybe<Scalars['String']>;
  traderIdentificationNumber: Maybe<Scalars['String']>;
  traderReference: Maybe<Scalars['String']>;
  transferToTransitSystem: Maybe<Scalars['Boolean']>;
  transportCountry: Maybe<Scalars['String']>;
  transportInContainer: Maybe<Scalars['Boolean']>;
  transportMode: Maybe<Scalars['Int']>;
  transportNumber: Maybe<Scalars['String']>;
  transportType: Maybe<Scalars['String']>;
  uniqueConsignmentReferenceNumber: Maybe<Scalars['String']>;
  vatAccountName: Maybe<Scalars['String']>;
  vatAccountNumber: Maybe<Scalars['Int']>;
  vatNumber: Maybe<Scalars['String']>;
  vatSuffix: Maybe<Scalars['Boolean']>;
  vatTotalAmount: Maybe<Scalars['Float']>;
  warehouseCoded: Maybe<Scalars['Int']>;
};

export type GoodsItemAcs = {
  additionalUnit: Maybe<Scalars['String']>;
  additionalUnitConfirmation: Maybe<Scalars['Boolean']>;
  billingType: Maybe<Scalars['Int']>;
  clearanceType: Maybe<Scalars['Int']>;
  commercialGood: Maybe<Scalars['Boolean']>;
  commodityCode: Maybe<Scalars['String']>;
  commodityCodeConfirmation: Maybe<Scalars['Boolean']>;
  customsDeclarationVersion: Maybe<Scalars['Int']>;
  customsFavourCode: Maybe<Scalars['Int']>;
  customsItemNumber: Scalars['Int'];
  customsNetWeight: Maybe<Scalars['Float']>;
  description: Maybe<Scalars['String']>;
  direction: Maybe<Scalars['Int']>;
  drNo: Scalars['Int'];
  dutyAndOtherTaxesTotal: Maybe<Scalars['Float']>;
  dutyRate: Maybe<Scalars['Float']>;
  dutyTotal: Maybe<Scalars['Float']>;
  fileId: Scalars['JSON'];
  grossMass: Maybe<Scalars['Float']>;
  grossMassConfirmation: Maybe<Scalars['Boolean']>;
  netDuty: Maybe<Scalars['Boolean']>;
  netMass: Maybe<Scalars['Float']>;
  netMassConfirmation: Maybe<Scalars['Boolean']>;
  nonCustomsLawObligation: Maybe<Scalars['Int']>;
  originCountry: Maybe<Scalars['String']>;
  originPreference: Maybe<Scalars['Boolean']>;
  packaging: Maybe<Array<PackagingEntity>>;
  permitObligationCode: Maybe<Scalars['Int']>;
  preferenceConfirmation: Maybe<Scalars['Boolean']>;
  processType: Maybe<Scalars['Int']>;
  rateConfirmation: Maybe<Scalars['Boolean']>;
  refinementType: Maybe<Scalars['Int']>;
  refundType: Maybe<Scalars['Int']>;
  repair: Maybe<Scalars['Boolean']>;
  repairReason: Maybe<Scalars['String']>;
  selectionResult: Maybe<Scalars['Int']>;
  statisticalCode: Maybe<Scalars['Int']>;
  statisticalValue: Maybe<Scalars['Int']>;
  storageType: Maybe<Scalars['Int']>;
  tareSupplement: Maybe<Scalars['Float']>;
  tareSupplementConfirmation: Maybe<Scalars['Boolean']>;
  unDangerousGoodsCode: Maybe<Scalars['String']>;
  vatCode: Maybe<Scalars['Int']>;
  vatCodeConfirmation: Maybe<Scalars['Boolean']>;
  vatRate: Maybe<Scalars['Float']>;
  vatTotal: Maybe<Scalars['Float']>;
  vatValue: Maybe<Scalars['Float']>;
  vatValueConfirmation: Maybe<Scalars['Boolean']>;
  vocQuantity: Maybe<Scalars['Float']>;
};

export type PackagingEntity = {
  customsItemNumber: Maybe<Scalars['Int']>;
  drNo: Maybe<Scalars['Int']>;
  fileId: Maybe<Scalars['ID']>;
  id: Scalars['Int'];
  packagingQuantity: Maybe<Scalars['Float']>;
  packagingReferenceNumber: Maybe<Scalars['String']>;
  packagingType: Maybe<Scalars['String']>;
};

export type PreviousDocumentEntity = {
  additionalInformation: Maybe<Scalars['String']>;
  drNo: Scalars['ID'];
  fileId: Scalars['ID'];
  id: Scalars['ID'];
  previousDocumentReference: Maybe<Scalars['String']>;
  previousDocumentType: Maybe<Scalars['String']>;
};

export type DeclarationSpecialMentionEntity = {
  drNo: Scalars['Float'];
  fileId: Scalars['String'];
  id: Scalars['ID'];
  sequenceNumber: Scalars['Float'];
  text: Scalars['String'];
};

export type DeclarationLabel = {
  color: Scalars['String'];
  description: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Maybe<Scalars['Boolean']>;
  title: Maybe<Scalars['JSON']>;
};

export type DeclarationRequestAcs = {
  acceptanceDate: Maybe<Scalars['DateTime']>;
  accountNumber: Maybe<Scalars['String']>;
  aiAutodec: Maybe<Scalars['Boolean']>;
  aiDate: Maybe<Scalars['DateTime']>;
  arrivalTime: Maybe<Scalars['DateTime']>;
  arrivalType: Maybe<ArrivalType>;
  cevStatus: Maybe<Scalars['String']>;
  chExpDecl: Maybe<Scalars['Boolean']>;
  clearanceType: Scalars['String'];
  creationDate: Scalars['DateTime'];
  creationUser: Scalars['String'];
  customsDeclarationNumber: Maybe<Scalars['String']>;
  customsDeclarationVersion: Maybe<Scalars['Int']>;
  declarationType: Scalars['String'];
  destTolldeptCode: Maybe<Scalars['String']>;
  destTolldeptName: Maybe<Scalars['String']>;
  drNo: Scalars['Int'];
  edec: Maybe<Scalars['JSON']>;
  eta: Maybe<Scalars['DateTime']>;
  fileId: Scalars['String'];
  impCustClr: Maybe<Scalars['Boolean']>;
  isExpress: Scalars['Boolean'];
  meta: Scalars['JSON'];
  serviceType: Maybe<Scalars['String']>;
  tollDep: Maybe<Scalars['String']>;
  traderReference: Maybe<Scalars['String']>;
  transitdocType: Maybe<Scalars['String']>;
  trNo: Maybe<Scalars['String']>;
  userPp: Maybe<UserPp>;
  waNumber: Maybe<Scalars['String']>;
};

export enum ArrivalType {
  AllowedConsignee = 'allowed_consignee',
  Border = 'border',
  Unknown = 'unknown'
}

export type UserPp = {
  code: Maybe<Scalars['String']>;
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['String']>;
  defaultRoleId: Maybe<Scalars['Int']>;
  deleted: Maybe<Scalars['Boolean']>;
  deletedAt: Maybe<Scalars['DateTime']>;
  deletedByUser: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  email: Scalars['String'];
  externalAuthProvider: Scalars['Boolean'];
  firstName: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  ldapEntryDn: Maybe<Scalars['String']>;
  location: Maybe<Scalars['String']>;
  modules: Maybe<Array<ModuleEntity>>;
  oauthId: Maybe<Scalars['String']>;
  orgIdEntities: Array<OrgIdEntity>;
  permissions: Maybe<Scalars['String']>;
  permissionsDesk: Maybe<Array<Scalars['String']>>;
  phoneNumber: Maybe<Scalars['String']>;
  roles: Array<Role>;
  tenant: TenantEntity;
  tenantId: Scalars['UUID'];
  uiSettings: Scalars['JSON'];
  uiSettingsTemplates: Scalars['JSON'];
  userModules: Maybe<Array<UserModuleEntity>>;
  userType: Maybe<Scalars['String']>;
};

export type ModuleEntity = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type OrgIdEntity = {
  creationDate: Maybe<Scalars['DateTime']>;
  displayName: Scalars['String'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  orgId: Scalars['Float'];
  orgIdDescription: Scalars['String'];
};

export type Role = {
  description: Maybe<Scalars['String']>;
  grantedPermissions: Maybe<Array<GrantedPermission>>;
  id: Scalars['Int'];
  isWdRelevant: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  translations: Scalars['JSON'];
};

export type GrantedPermission = {
  permission: Maybe<PermissionEntity>;
  permissionId: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
};

export type PermissionEntity = {
  action: Maybe<Scalars['String']>;
  conditions: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  permissionId: Scalars['ID'];
  subject: Maybe<Scalars['String']>;
};

export type TenantEntity = {
  accountNumber: Maybe<Scalars['String']>;
  address: AddressAcs;
  addressId: Scalars['Int'];
  creationDate: Maybe<Scalars['DateTime']>;
  declarationLabels: Array<DeclarationLabel>;
  documentTypeTenantSettings: Array<DocumentTypeTenantSettingsAcs>;
  externalTenantId: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isWdCustomer: Scalars['Boolean'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  permissions: Maybe<Scalars['String']>;
  permissionsJs: Maybe<Scalars['JSON']>;
  roles: Maybe<Array<Role>>;
  tenantName: Scalars['String'];
  tenantType: TenantType;
  traderIdentificationNumber: Maybe<Scalars['String']>;
};

export type DocumentTypeTenantSettingsAcs = {
  code: Maybe<Scalars['String']>;
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  defaultFlags: Maybe<Scalars['Int']>;
  displayName: Maybe<Scalars['String']>;
  documentType: Scalars['String'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  meta: Maybe<Scalars['JSON']>;
};

export enum TenantType {
  Default = 'DEFAULT',
  Master = 'MASTER'
}

export type UserModuleEntity = {
  moduleId: Scalars['Int'];
  userId: Scalars['String'];
};

export enum DeclarationStatus {
  ArrivalConfirmed = 'arrival_confirmed',
  DeclarationCanceled = 'declaration_canceled',
  DeclarationExported = 'declaration_exported',
  DeclarationExportedReferenceMissing = 'declaration_exported_reference_missing',
  DeclarationPending = 'declaration_pending',
  DeclarationRevoked = 'declaration_revoked',
  DocumentsRecieved = 'documents_recieved',
  InProgress = 'in_progress',
  InformationMissing = 'information_missing'
}

export type Documents = {
  checksum: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['DateTime']>;
  creation_user: Scalars['UUID'];
  customs_response_data: Maybe<CustomsResponseData>;
  document_blobs: Maybe<Scalars['JSON']>;
  document_extension: Scalars['String'];
  document_flags: Scalars['BigInt'];
  document_name: Maybe<Scalars['String']>;
  document_status: Scalars['String'];
  document_type: Scalars['String'];
  document_version: Scalars['Int'];
  documentType: Maybe<DocumentType>;
  file: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  is_customs_relevant: Maybe<Scalars['Boolean']>;
  is_deleted: Scalars['Boolean'];
  is_generated: Scalars['Boolean'];
  is_template: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['DateTime']>;
  last_modified_user: Maybe<Scalars['UUID']>;
  meta: Scalars['JSON'];
  number_of_pages: Maybe<Scalars['Int']>;
  org_id: Maybe<Scalars['Int']>;
  pages_m2m: Maybe<Array<Maybe<DocumentPage>>>;
  sequence: Maybe<Scalars['Int']>;
};


export type DocumentsDocument_BlobsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type CustomsResponseData = {
  acceptance_date: Maybe<Scalars['LocalDate']>;
  acceptance_time: Maybe<Scalars['LocalTime']>;
  access_code: Maybe<Scalars['String']>;
  consignee: Maybe<Scalars['JSON']>;
  consignor: Maybe<EvvAddress>;
  correction_code: Scalars['Int'];
  creation_date: Maybe<Scalars['DateTime']>;
  customs_account: Maybe<Scalars['JSON']>;
  customs_clearance_type: Maybe<Scalars['Int']>;
  customs_office: Maybe<Scalars['JSON']>;
  declarant: Maybe<Scalars['JSON']>;
  declaration_type: Maybe<Scalars['String']>;
  dispatch_country: Maybe<Scalars['String']>;
  doc_id: Scalars['String'];
  doctype_detected: Maybe<Scalars['String']>;
  document_type: Maybe<Scalars['String']>;
  document_version: Scalars['Int'];
  dr_no: Scalars['Int'];
  duty_and_additional_taxes: Maybe<Scalars['JSON']>;
  file_id: Scalars['UUID'];
  ft_search: Maybe<Scalars['String']>;
  goods_item: Maybe<Scalars['JSON']>;
  goods_items_tbl: Maybe<Scalars['JSON']>;
  gross_mass: Maybe<Scalars['Float']>;
  importer: Maybe<Scalars['JSON']>;
  incoterms: Maybe<Scalars['String']>;
  invoice_currency_type: Maybe<Scalars['String']>;
  message: Scalars['Int'];
  meta: Maybe<Scalars['JSON']>;
  number_of_goods_items: Maybe<Scalars['Int']>;
  packaging_quantity: Maybe<Scalars['Int']>;
  previous_document: Maybe<Scalars['JSON']>;
  special_mention: Maybe<Scalars['JSON']>;
  trader_declaration_number: Maybe<Scalars['String']>;
  trader_identification_number: Maybe<Scalars['String']>;
  traderreference: Maybe<Scalars['String']>;
  transport_in_container: Maybe<Scalars['String']>;
  transport_means: Maybe<Scalars['JSON']>;
  valuation_summary: Maybe<Scalars['JSON']>;
  value: Scalars['JSON'];
  vat: Maybe<Scalars['JSON']>;
  vat_account: Maybe<Scalars['JSON']>;
  vatnumber: Maybe<Scalars['String']>;
  vatvalue: Maybe<Scalars['Float']>;
};

export type EvvAddress = {
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
};

export type DocumentType = {
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Scalars['UUID'];
  displayName: Maybe<Scalars['String']>;
  document_type_all_tenant_settings: Maybe<Array<DocumentTypeTenantSettings>>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  translations: Maybe<Scalars['JSON']>;
};


export type DocumentTypeDocument_Type_All_Tenant_SettingsArgs = {
  filters?: InputMaybe<FiltersExpressionAcsInput>;
};


export type DocumentTypeTranslationsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type FiltersExpressionAcsInput = {
  childExpressions?: InputMaybe<Array<FiltersExpressionAcsInput>>;
  filters?: InputMaybe<Array<FilterInput>>;
  operator: Scalars['String'];
};

export type FilterInput = {
  field: Scalars['String'];
  op: Scalars['String'];
  relationField?: InputMaybe<Scalars['String']>;
  values: Array<Scalars['String']>;
};

export type DocumentTypeTenantSettings = {
  code: Maybe<Scalars['String']>;
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  defaultFlags: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  documentSchema: Maybe<Scalars['JSON']>;
  documentType: Maybe<Scalars['String']>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  meta: Maybe<Scalars['JSON']>;
  tenant: Maybe<Scalars['UUID']>;
};

export type DocumentPage = {
  documentId: Scalars['UUID'];
  page: PageAcs;
  pageId: Scalars['UUID'];
  pageNumber: Scalars['Int'];
};

export type PageAcs = {
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Scalars['UUID'];
  id: Scalars['UUID'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  meta: Scalars['JSON'];
  ocrText: Maybe<Scalars['String']>;
  pageNumber: Maybe<Scalars['Int']>;
  pageStatus: Scalars['String'];
  rotate: Scalars['Int'];
  thumbnailBigUrl: Maybe<Scalars['String']>;
  thumbnailSmallUrl: Maybe<Scalars['String']>;
};

export type GoodsItemSpecialMentionEntity = {
  customsItemNumber: Maybe<Scalars['Int']>;
  drNo: Maybe<Scalars['Int']>;
  fileId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  sequenceNumber: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
};

export type PermitEntity = {
  additionalInformation: Maybe<Scalars['String']>;
  customsItemNumber: Maybe<Scalars['Int']>;
  drNo: Maybe<Scalars['Int']>;
  fileId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  issueDate: Maybe<Scalars['DateTime']>;
  permitAuthority: Maybe<Scalars['Int']>;
  permitItemDetails: Maybe<Scalars['JSON']>;
  permitNumber: Maybe<Scalars['String']>;
  permitType: Maybe<Scalars['Int']>;
};

export type ProducedDocumentEntity = {
  additionalInformation: Maybe<Scalars['String']>;
  customsItemNumber: Maybe<Scalars['Int']>;
  drNo: Maybe<Scalars['Int']>;
  fileId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  producedDocumentIssueDate: Maybe<Scalars['Date']>;
  producedDocumentReferenceNumber: Maybe<Scalars['String']>;
  producedDocumentType: Maybe<Scalars['String']>;
};

export type Count = {
  resultSetCount: Maybe<Scalars['Int']>;
};

/** select columns of table "address" */
export enum Address_Select_Column {
  /** column name */
  AdditionalValues = 'additional_values',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  AoId = 'ao_id',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CompanyName_2 = 'company_name_2',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContactWebsite = 'contact_website',
  /** column name */
  Country = 'country',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsAccountNumber = 'customs_account_number',
  /** column name */
  ErrorEmailAddress = 'error_email_address',
  /** column name */
  Id = 'id',
  /** column name */
  Imported = 'imported',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsLocked = 'is_locked',
  /** column name */
  IsPlatformUser = 'is_platform_user',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  Reference = 'reference',
  /** column name */
  SearchVector = 'search_vector',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number',
  /** column name */
  UidNumber = 'uid_number',
  /** column name */
  UsageFrequency = 'usage_frequency',
  /** column name */
  VatAccountNumber = 'vat_account_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  Zipcode = 'zipcode'
}

/** Ordering options when selecting data from "address". */
export type Address_Order_By = {
  additional_values?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  addressType?: InputMaybe<Address_Type_Order_By>;
  ao_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  company_name_2?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  contact_website?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  creationUser?: InputMaybe<User_Pp_Order_By>;
  customs_account_number?: InputMaybe<Order_By>;
  error_email_address?: InputMaybe<Order_By>;
  extraction_config?: InputMaybe<Extraction_Config_Order_By>;
  id?: InputMaybe<Order_By>;
  imported?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_locked?: InputMaybe<Order_By>;
  is_platform_user?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  search_vector?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenant_Order_By>;
  trader_identification_number?: InputMaybe<Order_By>;
  uid_number?: InputMaybe<Order_By>;
  usage_frequency?: InputMaybe<Order_By>;
  vat_account_number?: InputMaybe<Order_By>;
  vat_number?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** Ordering options when selecting data from "address_type". */
export type Address_Type_Order_By = {
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  translation?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_pp". */
export type User_Pp_Order_By = {
  code?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  ldap_entry_dn?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  oauth_id?: InputMaybe<Order_By>;
  permissions?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenant_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  ui_settings?: InputMaybe<Order_By>;
  ui_settings_templates?: InputMaybe<Order_By>;
  user_type?: InputMaybe<Order_By>;
  userOrgIds_aggregate?: InputMaybe<User_Org_Id_Aggregate_Order_By>;
};

/** Ordering options when selecting data from "tenant". */
export type Tenant_Order_By = {
  account_number?: InputMaybe<Order_By>;
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  api_keys_aggregate?: InputMaybe<Api_Key_Aggregate_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  declaration_labels_aggregate?: InputMaybe<Declaration_Labels_Aggregate_Order_By>;
  document_labels_aggregate?: InputMaybe<Document_Labels_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  import_list_triggers_aggregate?: InputMaybe<Import_List_Trigger_Aggregate_Order_By>;
  is_wd_customer?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  org_ids_aggregate?: InputMaybe<Org_Id_Aggregate_Order_By>;
  permissions?: InputMaybe<Order_By>;
  permissions_js?: InputMaybe<Order_By>;
  service_rates_aggregate?: InputMaybe<Service_Rate_Aggregate_Order_By>;
  tenant_name?: InputMaybe<Order_By>;
  tenant_type?: InputMaybe<Order_By>;
  tenantDocumentTypes_aggregate?: InputMaybe<Document_Type_All_Tenant_Settings_Aggregate_Order_By>;
  trader_identification_number?: InputMaybe<Order_By>;
  user_pps_aggregate?: InputMaybe<User_Pp_Aggregate_Order_By>;
};

/** order by aggregate values of table "api_key" */
export type Api_Key_Aggregate_Order_By = {
  avg?: InputMaybe<Api_Key_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Api_Key_Max_Order_By>;
  min?: InputMaybe<Api_Key_Min_Order_By>;
  stddev?: InputMaybe<Api_Key_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Api_Key_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Api_Key_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Api_Key_Sum_Order_By>;
  var_pop?: InputMaybe<Api_Key_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Api_Key_Var_Samp_Order_By>;
  variance?: InputMaybe<Api_Key_Variance_Order_By>;
};

/** order by avg() on columns of table "api_key" */
export type Api_Key_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "api_key" */
export type Api_Key_Max_Order_By = {
  api_key?: InputMaybe<Order_By>;
  dsplay_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "api_key" */
export type Api_Key_Min_Order_By = {
  api_key?: InputMaybe<Order_By>;
  dsplay_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "api_key" */
export type Api_Key_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "api_key" */
export type Api_Key_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "api_key" */
export type Api_Key_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "api_key" */
export type Api_Key_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "api_key" */
export type Api_Key_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "api_key" */
export type Api_Key_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "api_key" */
export type Api_Key_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_labels" */
export type Declaration_Labels_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Labels_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Labels_Max_Order_By>;
  min?: InputMaybe<Declaration_Labels_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Labels_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Labels_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Labels_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Labels_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Labels_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Labels_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Labels_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_labels" */
export type Declaration_Labels_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_labels" */
export type Declaration_Labels_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_labels" */
export type Declaration_Labels_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_labels" */
export type Declaration_Labels_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_labels" */
export type Declaration_Labels_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_labels" */
export type Declaration_Labels_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_labels" */
export type Declaration_Labels_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_labels" */
export type Declaration_Labels_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_labels" */
export type Declaration_Labels_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_labels" */
export type Declaration_Labels_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "document_labels" */
export type Document_Labels_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Labels_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Labels_Max_Order_By>;
  min?: InputMaybe<Document_Labels_Min_Order_By>;
  stddev?: InputMaybe<Document_Labels_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Labels_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Labels_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Labels_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Labels_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Labels_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Labels_Variance_Order_By>;
};

/** order by avg() on columns of table "document_labels" */
export type Document_Labels_Avg_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "document_labels" */
export type Document_Labels_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "document_labels" */
export type Document_Labels_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "document_labels" */
export type Document_Labels_Stddev_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "document_labels" */
export type Document_Labels_Stddev_Pop_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "document_labels" */
export type Document_Labels_Stddev_Samp_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "document_labels" */
export type Document_Labels_Sum_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "document_labels" */
export type Document_Labels_Var_Pop_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "document_labels" */
export type Document_Labels_Var_Samp_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "document_labels" */
export type Document_Labels_Variance_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "import_list_trigger" */
export type Import_List_Trigger_Aggregate_Order_By = {
  avg?: InputMaybe<Import_List_Trigger_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Import_List_Trigger_Max_Order_By>;
  min?: InputMaybe<Import_List_Trigger_Min_Order_By>;
  stddev?: InputMaybe<Import_List_Trigger_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Import_List_Trigger_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Import_List_Trigger_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Import_List_Trigger_Sum_Order_By>;
  var_pop?: InputMaybe<Import_List_Trigger_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Import_List_Trigger_Var_Samp_Order_By>;
  variance?: InputMaybe<Import_List_Trigger_Variance_Order_By>;
};

/** order by avg() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Max_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Min_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "org_id" */
export type Org_Id_Aggregate_Order_By = {
  avg?: InputMaybe<Org_Id_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Id_Max_Order_By>;
  min?: InputMaybe<Org_Id_Min_Order_By>;
  stddev?: InputMaybe<Org_Id_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_Id_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_Id_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_Id_Sum_Order_By>;
  var_pop?: InputMaybe<Org_Id_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_Id_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_Id_Variance_Order_By>;
};

/** order by avg() on columns of table "org_id" */
export type Org_Id_Avg_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "org_id" */
export type Org_Id_Max_Order_By = {
  /** org_id creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** org_id creation user. */
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  /** org_id last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified org_id. */
  last_modified_user?: InputMaybe<Order_By>;
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
  org_id_description?: InputMaybe<Order_By>;
  /** Tenant of org_id. */
  tenant_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "org_id" */
export type Org_Id_Min_Order_By = {
  /** org_id creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** org_id creation user. */
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  /** org_id last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified org_id. */
  last_modified_user?: InputMaybe<Order_By>;
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
  org_id_description?: InputMaybe<Order_By>;
  /** Tenant of org_id. */
  tenant_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "org_id" */
export type Org_Id_Stddev_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "org_id" */
export type Org_Id_Stddev_Pop_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "org_id" */
export type Org_Id_Stddev_Samp_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "org_id" */
export type Org_Id_Sum_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "org_id" */
export type Org_Id_Var_Pop_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "org_id" */
export type Org_Id_Var_Samp_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "org_id" */
export type Org_Id_Variance_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "service_rate" */
export type Service_Rate_Aggregate_Order_By = {
  avg?: InputMaybe<Service_Rate_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Service_Rate_Max_Order_By>;
  min?: InputMaybe<Service_Rate_Min_Order_By>;
  stddev?: InputMaybe<Service_Rate_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Service_Rate_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Service_Rate_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Service_Rate_Sum_Order_By>;
  var_pop?: InputMaybe<Service_Rate_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Service_Rate_Var_Samp_Order_By>;
  variance?: InputMaybe<Service_Rate_Variance_Order_By>;
};

/** order by avg() on columns of table "service_rate" */
export type Service_Rate_Avg_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "service_rate" */
export type Service_Rate_Max_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "service_rate" */
export type Service_Rate_Min_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "service_rate" */
export type Service_Rate_Stddev_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "service_rate" */
export type Service_Rate_Stddev_Pop_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "service_rate" */
export type Service_Rate_Stddev_Samp_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "service_rate" */
export type Service_Rate_Sum_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "service_rate" */
export type Service_Rate_Var_Pop_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "service_rate" */
export type Service_Rate_Var_Samp_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "service_rate" */
export type Service_Rate_Variance_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Type_All_Tenant_Settings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Type_All_Tenant_Settings_Max_Order_By>;
  min?: InputMaybe<Document_Type_All_Tenant_Settings_Min_Order_By>;
  stddev?: InputMaybe<Document_Type_All_Tenant_Settings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Type_All_Tenant_Settings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Type_All_Tenant_Settings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Type_All_Tenant_Settings_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Type_All_Tenant_Settings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Type_All_Tenant_Settings_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Type_All_Tenant_Settings_Variance_Order_By>;
};

/** order by avg() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Avg_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  default_flags?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  default_flags?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Stddev_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Stddev_Pop_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Stddev_Samp_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Sum_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Var_Pop_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Var_Samp_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Variance_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "user_pp" */
export type User_Pp_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Pp_Max_Order_By>;
  min?: InputMaybe<User_Pp_Min_Order_By>;
};

/** order by max() on columns of table "user_pp" */
export type User_Pp_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  /** User creation date */
  creation_date?: InputMaybe<Order_By>;
  /** user_pp creation user. */
  creation_user?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  /** id of user_pp. */
  id?: InputMaybe<Order_By>;
  /** user_pp last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified user_pp. */
  last_modified_user?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  ldap_entry_dn?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  oauth_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  /** Tenant of user_pp. */
  tenant_id?: InputMaybe<Order_By>;
  user_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_pp" */
export type User_Pp_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  /** User creation date */
  creation_date?: InputMaybe<Order_By>;
  /** user_pp creation user. */
  creation_user?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  /** id of user_pp. */
  id?: InputMaybe<Order_By>;
  /** user_pp last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified user_pp. */
  last_modified_user?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  ldap_entry_dn?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  oauth_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  /** Tenant of user_pp. */
  tenant_id?: InputMaybe<Order_By>;
  user_type?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "user_org_id" */
export type User_Org_Id_Aggregate_Order_By = {
  avg?: InputMaybe<User_Org_Id_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Org_Id_Max_Order_By>;
  min?: InputMaybe<User_Org_Id_Min_Order_By>;
  stddev?: InputMaybe<User_Org_Id_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Org_Id_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Org_Id_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Org_Id_Sum_Order_By>;
  var_pop?: InputMaybe<User_Org_Id_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Org_Id_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Org_Id_Variance_Order_By>;
};

/** order by avg() on columns of table "user_org_id" */
export type User_Org_Id_Avg_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "user_org_id" */
export type User_Org_Id_Max_Order_By = {
  /** user_org_id creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** user_org_id creation user. */
  creation_user?: InputMaybe<Order_By>;
  /** user_org_id last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified user_org_id. */
  last_modified_user?: InputMaybe<Order_By>;
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
  user_pp?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_org_id" */
export type User_Org_Id_Min_Order_By = {
  /** user_org_id creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** user_org_id creation user. */
  creation_user?: InputMaybe<Order_By>;
  /** user_org_id last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified user_org_id. */
  last_modified_user?: InputMaybe<Order_By>;
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
  user_pp?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "user_org_id" */
export type User_Org_Id_Stddev_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "user_org_id" */
export type User_Org_Id_Stddev_Pop_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "user_org_id" */
export type User_Org_Id_Stddev_Samp_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "user_org_id" */
export type User_Org_Id_Sum_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "user_org_id" */
export type User_Org_Id_Var_Pop_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "user_org_id" */
export type User_Org_Id_Var_Samp_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "user_org_id" */
export type User_Org_Id_Variance_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "extraction_config". */
export type Extraction_Config_Order_By = {
  address_id?: InputMaybe<Order_By>;
  aliases?: InputMaybe<Order_By>;
  document_templates?: InputMaybe<Order_By>;
  foun_config?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Bool_Exp>>;
  _not?: InputMaybe<Address_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Bool_Exp>>;
  additional_values?: InputMaybe<Jsonb_Comparison_Exp>;
  address_type?: InputMaybe<Int_Comparison_Exp>;
  addressType?: InputMaybe<Address_Type_Bool_Exp>;
  ao_id?: InputMaybe<Smallint_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  company_name_2?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  contact_website?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  creationUser?: InputMaybe<User_Pp_Bool_Exp>;
  customs_account_number?: InputMaybe<String_Comparison_Exp>;
  error_email_address?: InputMaybe<String_Comparison_Exp>;
  extraction_config?: InputMaybe<Extraction_Config_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  imported?: InputMaybe<Boolean_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_locked?: InputMaybe<Boolean_Comparison_Exp>;
  is_platform_user?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  search_vector?: InputMaybe<Tsvector_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Tenant_Bool_Exp>;
  trader_identification_number?: InputMaybe<String_Comparison_Exp>;
  uid_number?: InputMaybe<String_Comparison_Exp>;
  usage_frequency?: InputMaybe<Int_Comparison_Exp>;
  vat_account_number?: InputMaybe<String_Comparison_Exp>;
  vat_number?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to filter rows from the table "address_type". All fields are combined with a logical 'AND'. */
export type Address_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Type_Bool_Exp>>;
  _not?: InputMaybe<Address_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Type_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  translation?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** Boolean expression to filter rows from the table "user_pp". All fields are combined with a logical 'AND'. */
export type User_Pp_Bool_Exp = {
  _and?: InputMaybe<Array<User_Pp_Bool_Exp>>;
  _not?: InputMaybe<User_Pp_Bool_Exp>;
  _or?: InputMaybe<Array<User_Pp_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  ldap_entry_dn?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  oauth_id?: InputMaybe<String_Comparison_Exp>;
  permissions?: InputMaybe<Bit_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Tenant_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  ui_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  ui_settings_templates?: InputMaybe<Jsonb_Comparison_Exp>;
  user_type?: InputMaybe<String_Comparison_Exp>;
  userOrgIds?: InputMaybe<User_Org_Id_Bool_Exp>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "bit". All fields are combined with logical 'AND'. */
export type Bit_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bit']>;
  _gt?: InputMaybe<Scalars['bit']>;
  _gte?: InputMaybe<Scalars['bit']>;
  _in?: InputMaybe<Array<Scalars['bit']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bit']>;
  _lte?: InputMaybe<Scalars['bit']>;
  _neq?: InputMaybe<Scalars['bit']>;
  _nin?: InputMaybe<Array<Scalars['bit']>>;
};

/** Boolean expression to filter rows from the table "tenant". All fields are combined with a logical 'AND'. */
export type Tenant_Bool_Exp = {
  _and?: InputMaybe<Array<Tenant_Bool_Exp>>;
  _not?: InputMaybe<Tenant_Bool_Exp>;
  _or?: InputMaybe<Array<Tenant_Bool_Exp>>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  api_keys?: InputMaybe<Api_Key_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declaration_labels?: InputMaybe<Declaration_Labels_Bool_Exp>;
  document_labels?: InputMaybe<Document_Labels_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  import_list_triggers?: InputMaybe<Import_List_Trigger_Bool_Exp>;
  import_list_triggers_aggregate?: InputMaybe<Import_List_Trigger_Aggregate_Bool_Exp>;
  is_wd_customer?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  org_ids?: InputMaybe<Org_Id_Bool_Exp>;
  permissions?: InputMaybe<Bit_Comparison_Exp>;
  permissions_js?: InputMaybe<Jsonb_Comparison_Exp>;
  service_rates?: InputMaybe<Service_Rate_Bool_Exp>;
  tenant_name?: InputMaybe<String_Comparison_Exp>;
  tenant_type?: InputMaybe<Tenant_Type_Comparison_Exp>;
  tenantDocumentTypes?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
  trader_identification_number?: InputMaybe<String_Comparison_Exp>;
  user_pps?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "api_key". All fields are combined with a logical 'AND'. */
export type Api_Key_Bool_Exp = {
  _and?: InputMaybe<Array<Api_Key_Bool_Exp>>;
  _not?: InputMaybe<Api_Key_Bool_Exp>;
  _or?: InputMaybe<Array<Api_Key_Bool_Exp>>;
  api_key?: InputMaybe<String_Comparison_Exp>;
  dsplay_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_labels". All fields are combined with a logical 'AND'. */
export type Declaration_Labels_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Labels_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Labels_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Labels_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  tenant?: InputMaybe<Tenant_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "document_labels". All fields are combined with a logical 'AND'. */
export type Document_Labels_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Labels_Bool_Exp>>;
  _not?: InputMaybe<Document_Labels_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Labels_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<Jsonb_Comparison_Exp>;
  document_label_org_ids?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  tenant?: InputMaybe<Tenant_Bool_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "document_label_org_id". All fields are combined with a logical 'AND'. */
export type Document_Label_Org_Id_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Label_Org_Id_Bool_Exp>>;
  _not?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Label_Org_Id_Bool_Exp>>;
  label_id?: InputMaybe<Int_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  orgId?: InputMaybe<Org_Id_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "org_id". All fields are combined with a logical 'AND'. */
export type Org_Id_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Id_Bool_Exp>>;
  _not?: InputMaybe<Org_Id_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Id_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  org_id_description?: InputMaybe<String_Comparison_Exp>;
  orgIdUsers?: InputMaybe<User_Org_Id_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  userOrgId?: InputMaybe<User_Org_Id_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "document". All fields are combined with a logical 'AND'. */
export type Document_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Bool_Exp>>;
  _not?: InputMaybe<Document_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Bool_Exp>>;
  annotationType?: InputMaybe<Annotation_Type_Bool_Exp>;
  articles?: InputMaybe<Article_Bool_Exp>;
  checksum?: InputMaybe<String_Comparison_Exp>;
  computedPagesM2M?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
  created_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_response_data?: InputMaybe<Customs_Response_Data_Bool_Exp>;
  doc_tasks?: InputMaybe<Declaration_Task_Bool_Exp>;
  doc_tasks_aggregate?: InputMaybe<Declaration_Task_Aggregate_Bool_Exp>;
  docAnnotations?: InputMaybe<Doc_Annotation_Bool_Exp>;
  document_blobs?: InputMaybe<Jsonb_Comparison_Exp>;
  document_extension?: InputMaybe<String_Comparison_Exp>;
  document_flags?: InputMaybe<Bigint_Comparison_Exp>;
  document_is_allowed?: InputMaybe<Document_Bool_Exp>;
  document_name?: InputMaybe<String_Comparison_Exp>;
  document_status?: InputMaybe<String_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  document_version?: InputMaybe<Int_Comparison_Exp>;
  documentExtensionByDocumentExtension?: InputMaybe<Document_Extension_Bool_Exp>;
  documentFile?: InputMaybe<File_Bool_Exp>;
  documentType?: InputMaybe<Document_Type_Bool_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file?: InputMaybe<Uuid_Comparison_Exp>;
  file_object?: InputMaybe<File_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_customs_relevant?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_generated?: InputMaybe<Boolean_Comparison_Exp>;
  is_template?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  number_of_pages?: InputMaybe<Smallint_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  organization?: InputMaybe<Org_Id_Bool_Exp>;
  orgId?: InputMaybe<Org_Id_Bool_Exp>;
  pages_m2m?: InputMaybe<Document_Page_Bool_Exp>;
  pages_m2m_aggregate?: InputMaybe<Document_Page_Aggregate_Bool_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Document_Status_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "annotation_type". All fields are combined with a logical 'AND'. */
export type Annotation_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Annotation_Type_Bool_Exp>>;
  _not?: InputMaybe<Annotation_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Annotation_Type_Bool_Exp>>;
  anno_schema?: InputMaybe<Json_Comparison_Exp>;
  anno_type_id?: InputMaybe<Smallint_Comparison_Exp>;
  annotation_provider?: InputMaybe<Annotation_Provider_Bool_Exp>;
  annotation_provider_id?: InputMaybe<Smallint_Comparison_Exp>;
  annotation_schema?: InputMaybe<Jsonb_Comparison_Exp>;
  annotation_type?: InputMaybe<String_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  documentType?: InputMaybe<Document_Type_Bool_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  ui_schema?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

/** Boolean expression to filter rows from the table "annotation_provider". All fields are combined with a logical 'AND'. */
export type Annotation_Provider_Bool_Exp = {
  _and?: InputMaybe<Array<Annotation_Provider_Bool_Exp>>;
  _not?: InputMaybe<Annotation_Provider_Bool_Exp>;
  _or?: InputMaybe<Array<Annotation_Provider_Bool_Exp>>;
  annotation_provider?: InputMaybe<String_Comparison_Exp>;
  annotation_provider_id?: InputMaybe<Smallint_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "document_type". All fields are combined with a logical 'AND'. */
export type Document_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Type_Bool_Exp>>;
  _not?: InputMaybe<Document_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Type_Bool_Exp>>;
  annotation_types?: InputMaybe<Annotation_Type_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  document_type_all_tenant_settings?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
  document_type_tenant_settings?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  translations?: InputMaybe<Jsonb_Comparison_Exp>;
  user_pp?: InputMaybe<User_Pp_Bool_Exp>;
  userPpByCreationUser?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "document_type_all_tenant_settings". All fields are combined with a logical 'AND'. */
export type Document_Type_All_Tenant_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Bool_Exp>>;
  _not?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  default_flags?: InputMaybe<Bigint_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  document_schema?: InputMaybe<Jsonb_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  tenant?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** Boolean expression to filter rows from the table "document_type_tenant_settings". All fields are combined with a logical 'AND'. */
export type Document_Type_Tenant_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Type_Tenant_Settings_Bool_Exp>>;
  _not?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Type_Tenant_Settings_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  default_flags?: InputMaybe<Bigint_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  document_schema?: InputMaybe<Jsonb_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  documentType?: InputMaybe<Document_Type_Bool_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  tenant?: InputMaybe<Uuid_Comparison_Exp>;
  Tenant?: InputMaybe<Tenant_Bool_Exp>;
};

export type Document_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Document_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Document_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Document_Aggregate_Bool_Exp_Count>;
};

export type Document_Aggregate_Bool_Exp_Bool_And = {
  arguments: Document_Select_Column_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "document_aggregate_bool_exp_bool_and_arguments_columns" columns of table "document" */
export enum Document_Select_Column_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCustomsRelevant = 'is_customs_relevant',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  IsTemplate = 'is_template'
}

export type Document_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Document_Select_Column_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "document_aggregate_bool_exp_bool_or_arguments_columns" columns of table "document" */
export enum Document_Select_Column_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCustomsRelevant = 'is_customs_relevant',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  IsTemplate = 'is_template'
}

export type Document_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "document" */
export enum Document_Select_Column {
  /** column name */
  Checksum = 'checksum',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DocumentBlobs = 'document_blobs',
  /** column name */
  DocumentExtension = 'document_extension',
  /** column name */
  DocumentFlags = 'document_flags',
  /** column name */
  DocumentName = 'document_name',
  /** column name */
  DocumentStatus = 'document_status',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DocumentVersion = 'document_version',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  IsCustomsRelevant = 'is_customs_relevant',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  IsTemplate = 'is_template',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumberOfPages = 'number_of_pages',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Sequence = 'sequence'
}

/** Boolean expression to filter rows from the table "article". All fields are combined with a logical 'AND'. */
export type Article_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Bool_Exp>>;
  _not?: InputMaybe<Article_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Bool_Exp>>;
  article_id?: InputMaybe<Smallint_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  coords?: InputMaybe<_Int4_Comparison_Exp>;
  country_of_origin?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  doc_id?: InputMaybe<Uuid_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  gross_weight?: InputMaybe<String_Comparison_Exp>;
  height?: InputMaybe<String_Comparison_Exp>;
  hscode?: InputMaybe<String_Comparison_Exp>;
  length?: InputMaybe<String_Comparison_Exp>;
  marks?: InputMaybe<String_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  net_weight?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<String_Comparison_Exp>;
  purchase_order_number?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  total_price?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<String_Comparison_Exp>;
  width?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "_int4". All fields are combined with logical 'AND'. */
export type _Int4_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_int4']>;
  _gt?: InputMaybe<Scalars['_int4']>;
  _gte?: InputMaybe<Scalars['_int4']>;
  _in?: InputMaybe<Array<Scalars['_int4']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_int4']>;
  _lte?: InputMaybe<Scalars['_int4']>;
  _neq?: InputMaybe<Scalars['_int4']>;
  _nin?: InputMaybe<Array<Scalars['_int4']>>;
};

/** Boolean expression to filter rows from the table "pages_m2m_cache". All fields are combined with a logical 'AND'. */
export type Pages_M2m_Cache_Bool_Exp = {
  _and?: InputMaybe<Array<Pages_M2m_Cache_Bool_Exp>>;
  _not?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
  _or?: InputMaybe<Array<Pages_M2m_Cache_Bool_Exp>>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  page?: InputMaybe<Uuid_Comparison_Exp>;
  page_number?: InputMaybe<Bigint_Comparison_Exp>;
  page_status?: InputMaybe<String_Comparison_Exp>;
  rotate?: InputMaybe<Int_Comparison_Exp>;
  thumbnail_big_url?: InputMaybe<String_Comparison_Exp>;
  thumbnail_small_url?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "customs_response_data". All fields are combined with a logical 'AND'. */
export type Customs_Response_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Customs_Response_Data_Bool_Exp>>;
  _not?: InputMaybe<Customs_Response_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Customs_Response_Data_Bool_Exp>>;
  correction_code?: InputMaybe<Smallint_Comparison_Exp>;
  doc_id?: InputMaybe<Uuid_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_version?: InputMaybe<Int_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_task". All fields are combined with a logical 'AND'. */
export type Declaration_Task_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Task_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Task_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Task_Bool_Exp>>;
  assigned_to?: InputMaybe<Uuid_Comparison_Exp>;
  assigned_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  object_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_status_id?: InputMaybe<Int_Comparison_Exp>;
  task_type?: InputMaybe<Task_Type_Bool_Exp>;
  task_type_id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "file". All fields are combined with a logical 'AND'. */
export type File_Bool_Exp = {
  _and?: InputMaybe<Array<File_Bool_Exp>>;
  _not?: InputMaybe<File_Bool_Exp>;
  _or?: InputMaybe<Array<File_Bool_Exp>>;
  ai_doc_classification_confirmed?: InputMaybe<Boolean_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declaration?: InputMaybe<Declaration_Request_Bool_Exp>;
  declaration_requests?: InputMaybe<Declaration_Request_Bool_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  file_flags?: InputMaybe<Bigint_Comparison_Exp>;
  file_status?: InputMaybe<String_Comparison_Exp>;
  file_tasks?: InputMaybe<Declaration_Task_Bool_Exp>;
  file_tasks_aggregate?: InputMaybe<Declaration_Task_Aggregate_Bool_Exp>;
  file_type?: InputMaybe<String_Comparison_Exp>;
  file_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identification?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  orgId?: InputMaybe<Org_Id_Bool_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_request". All fields are combined with a logical 'AND'. */
export type Declaration_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Request_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Request_Bool_Exp>>;
  acceptance_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  addresses?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
  arrival_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  arrival_type?: InputMaybe<String_Comparison_Exp>;
  arrivalType?: InputMaybe<Arrival_Type_Bool_Exp>;
  bill_details?: InputMaybe<Bill_Detail_Bool_Exp>;
  cev_status?: InputMaybe<String_Comparison_Exp>;
  ch_exp_decl?: InputMaybe<Boolean_Comparison_Exp>;
  clearance_type?: InputMaybe<String_Comparison_Exp>;
  clearanceTypeByClearanceType?: InputMaybe<Clearance_Type_Bool_Exp>;
  clientCompany?: InputMaybe<Tenant_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_declaration_number?: InputMaybe<String_Comparison_Exp>;
  customs_declaration_version?: InputMaybe<Smallint_Comparison_Exp>;
  customs_response_goods_items?: InputMaybe<Customs_Response_Goods_Items_Bool_Exp>;
  customs_response_goods_items_aggregate?: InputMaybe<Customs_Response_Goods_Items_Aggregate_Bool_Exp>;
  customsOffices?: InputMaybe<Customs_Offices_Bool_Exp>;
  customsResponseSummary?: InputMaybe<Customs_Response_Summary_Bool_Exp>;
  declaration?: InputMaybe<Declaration_Bool_Exp>;
  declaration_discussions?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  declaration_discussions_aggregate?: InputMaybe<Declaration_Discussion_Aggregate_Bool_Exp>;
  declaration_documents?: InputMaybe<Declaration_Document_Bool_Exp>;
  declaration_request_addresses?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
  declaration_request_labels?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
  declaration_status?: InputMaybe<String_Comparison_Exp>;
  declaration_type?: InputMaybe<String_Comparison_Exp>;
  declarationStatusByDeclarationStatus?: InputMaybe<Declaration_Status_Bool_Exp>;
  declarationTypeByDeclarationType?: InputMaybe<Declaration_Type_Bool_Exp>;
  dest_tolldept_code?: InputMaybe<String_Comparison_Exp>;
  dest_tolldept_name?: InputMaybe<String_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  dr_goods_items?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
  dr_goods_items_aggregate?: InputMaybe<Dr_Goods_Item_Aggregate_Bool_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  edec?: InputMaybe<Jsonb_Comparison_Exp>;
  eta?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  imp_cust_clr?: InputMaybe<Boolean_Comparison_Exp>;
  is_express?: InputMaybe<Boolean_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  mrn_number?: InputMaybe<String_Comparison_Exp>;
  payer?: InputMaybe<Tenant_Bool_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  toll_dep?: InputMaybe<String_Comparison_Exp>;
  tr_no?: InputMaybe<String_Comparison_Exp>;
  trader_reference?: InputMaybe<String_Comparison_Exp>;
  transitdoc_type?: InputMaybe<Transitdoc_Type_Comparison_Exp>;
  user_pp?: InputMaybe<User_Pp_Bool_Exp>;
  wa_number?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_request_address". All fields are combined with a logical 'AND'. */
export type Declaration_Request_Address_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Request_Address_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Request_Address_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  address_type?: InputMaybe<Int_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declaration_request?: InputMaybe<Declaration_Request_Bool_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Json_Comparison_Exp>;
  refs?: InputMaybe<_Text_Comparison_Exp>;
  search_refs?: InputMaybe<_Text_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "_text". All fields are combined with logical 'AND'. */
export type _Text_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_text']>;
  _gt?: InputMaybe<Scalars['_text']>;
  _gte?: InputMaybe<Scalars['_text']>;
  _in?: InputMaybe<Array<Scalars['_text']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_text']>;
  _lte?: InputMaybe<Scalars['_text']>;
  _neq?: InputMaybe<Scalars['_text']>;
  _nin?: InputMaybe<Array<Scalars['_text']>>;
};

/** Boolean expression to filter rows from the table "arrival_type". All fields are combined with a logical 'AND'. */
export type Arrival_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Arrival_Type_Bool_Exp>>;
  _not?: InputMaybe<Arrival_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Arrival_Type_Bool_Exp>>;
  arrival_type?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "bill_detail". All fields are combined with a logical 'AND'. */
export type Bill_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Bill_Detail_Bool_Exp>>;
  _not?: InputMaybe<Bill_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Bill_Detail_Bool_Exp>>;
  bill?: InputMaybe<Bill_Bool_Exp>;
  bill_id?: InputMaybe<Bigint_Comparison_Exp>;
  charged_items?: InputMaybe<Bigint_Comparison_Exp>;
  const_charge?: InputMaybe<Numeric_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  declaration_request?: InputMaybe<Declaration_Request_Bool_Exp>;
  detail_id?: InputMaybe<Bigint_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  sequence?: InputMaybe<Smallint_Comparison_Exp>;
  service?: InputMaybe<Service_Bool_Exp>;
  srv_id?: InputMaybe<Int_Comparison_Exp>;
  var_charge?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "bill". All fields are combined with a logical 'AND'. */
export type Bill_Bool_Exp = {
  _and?: InputMaybe<Array<Bill_Bool_Exp>>;
  _not?: InputMaybe<Bill_Bool_Exp>;
  _or?: InputMaybe<Array<Bill_Bool_Exp>>;
  bill_details?: InputMaybe<Bill_Detail_Bool_Exp>;
  bill_id?: InputMaybe<Bigint_Comparison_Exp>;
  bill_type?: InputMaybe<Name_Comparison_Exp>;
  from_ts?: InputMaybe<Timestamptz_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  payment_terms?: InputMaybe<Smallint_Comparison_Exp>;
  tenant?: InputMaybe<Tenant_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  to_ts?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "name". All fields are combined with logical 'AND'. */
export type Name_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['name']>;
  _gt?: InputMaybe<Scalars['name']>;
  _gte?: InputMaybe<Scalars['name']>;
  _in?: InputMaybe<Array<Scalars['name']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['name']>;
  _lte?: InputMaybe<Scalars['name']>;
  _neq?: InputMaybe<Scalars['name']>;
  _nin?: InputMaybe<Array<Scalars['name']>>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** Boolean expression to filter rows from the table "service". All fields are combined with a logical 'AND'. */
export type Service_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Bool_Exp>>;
  _not?: InputMaybe<Service_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Bool_Exp>>;
  service_rates?: InputMaybe<Service_Rate_Bool_Exp>;
  srv_desk?: InputMaybe<String_Comparison_Exp>;
  srv_id?: InputMaybe<Int_Comparison_Exp>;
  srv_type?: InputMaybe<String_Comparison_Exp>;
  translation?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "service_rate". All fields are combined with a logical 'AND'. */
export type Service_Rate_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Rate_Bool_Exp>>;
  _not?: InputMaybe<Service_Rate_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Rate_Bool_Exp>>;
  const_included?: InputMaybe<Int_Comparison_Exp>;
  const_rate?: InputMaybe<Numeric_Comparison_Exp>;
  service?: InputMaybe<Service_Bool_Exp>;
  srv_id?: InputMaybe<Int_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  var_rate?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** Boolean expression to filter rows from the table "clearance_type". All fields are combined with a logical 'AND'. */
export type Clearance_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Clearance_Type_Bool_Exp>>;
  _not?: InputMaybe<Clearance_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Clearance_Type_Bool_Exp>>;
  declaration_requests?: InputMaybe<Declaration_Request_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "customs_response_goods_items". All fields are combined with a logical 'AND'. */
export type Customs_Response_Goods_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Customs_Response_Goods_Items_Bool_Exp>>;
  _not?: InputMaybe<Customs_Response_Goods_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Customs_Response_Goods_Items_Bool_Exp>>;
  additional_unit?: InputMaybe<Jsonb_Comparison_Exp>;
  commercial_good?: InputMaybe<String_Comparison_Exp>;
  commodity_code?: InputMaybe<Jsonb_Comparison_Exp>;
  customs_clearance_type?: InputMaybe<String_Comparison_Exp>;
  customs_itemnumber?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<Jsonb_Comparison_Exp>;
  doc_id?: InputMaybe<Uuid_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  duty_total?: InputMaybe<String_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  goods_item?: InputMaybe<Jsonb_Comparison_Exp>;
  grossmass?: InputMaybe<Jsonb_Comparison_Exp>;
  net_mass?: InputMaybe<Jsonb_Comparison_Exp>;
  non_customs_law_obligation?: InputMaybe<Jsonb_Comparison_Exp>;
  origin?: InputMaybe<Jsonb_Comparison_Exp>;
  origin_country?: InputMaybe<String_Comparison_Exp>;
  packaging?: InputMaybe<Jsonb_Comparison_Exp>;
  permit_obligation?: InputMaybe<Jsonb_Comparison_Exp>;
  preference?: InputMaybe<String_Comparison_Exp>;
  produced_document?: InputMaybe<Jsonb_Comparison_Exp>;
  statistic?: InputMaybe<Jsonb_Comparison_Exp>;
  statistical_code?: InputMaybe<Jsonb_Comparison_Exp>;
  statistical_value?: InputMaybe<String_Comparison_Exp>;
  valuation_details?: InputMaybe<Jsonb_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
  vat_total?: InputMaybe<String_Comparison_Exp>;
  vatvalue?: InputMaybe<String_Comparison_Exp>;
};

export type Customs_Response_Goods_Items_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customs_Response_Goods_Items_Aggregate_Bool_Exp_Count>;
};

export type Customs_Response_Goods_Items_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customs_Response_Goods_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Customs_Response_Goods_Items_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "customs_response_goods_items" */
export enum Customs_Response_Goods_Items_Select_Column {
  /** column name */
  AdditionalUnit = 'additional_unit',
  /** column name */
  CommercialGood = 'commercial_good',
  /** column name */
  CommodityCode = 'commodity_code',
  /** column name */
  CustomsClearanceType = 'customs_clearance_type',
  /** column name */
  CustomsItemnumber = 'customs_itemnumber',
  /** column name */
  Description = 'description',
  /** column name */
  DocId = 'doc_id',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  DutyTotal = 'duty_total',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GoodsItem = 'goods_item',
  /** column name */
  Grossmass = 'grossmass',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  NonCustomsLawObligation = 'non_customs_law_obligation',
  /** column name */
  Origin = 'origin',
  /** column name */
  OriginCountry = 'origin_country',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  PermitObligation = 'permit_obligation',
  /** column name */
  Preference = 'preference',
  /** column name */
  ProducedDocument = 'produced_document',
  /** column name */
  Statistic = 'statistic',
  /** column name */
  StatisticalCode = 'statistical_code',
  /** column name */
  StatisticalValue = 'statistical_value',
  /** column name */
  ValuationDetails = 'valuation_details',
  /** column name */
  Value = 'value',
  /** column name */
  VatTotal = 'vat_total',
  /** column name */
  Vatvalue = 'vatvalue'
}

/** Boolean expression to filter rows from the table "customs_offices". All fields are combined with a logical 'AND'. */
export type Customs_Offices_Bool_Exp = {
  _and?: InputMaybe<Array<Customs_Offices_Bool_Exp>>;
  _not?: InputMaybe<Customs_Offices_Bool_Exp>;
  _or?: InputMaybe<Array<Customs_Offices_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  office_number?: InputMaybe<String_Comparison_Exp>;
  prefix?: InputMaybe<String_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_to?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "customs_response_summary". All fields are combined with a logical 'AND'. */
export type Customs_Response_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<Customs_Response_Summary_Bool_Exp>>;
  _not?: InputMaybe<Customs_Response_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Customs_Response_Summary_Bool_Exp>>;
  acceptance_date?: InputMaybe<String_Comparison_Exp>;
  acceptance_dates?: InputMaybe<_Timestamp_Comparison_Exp>;
  acceptance_time?: InputMaybe<String_Comparison_Exp>;
  consignee?: InputMaybe<Jsonb_Comparison_Exp>;
  consignor?: InputMaybe<String_Comparison_Exp>;
  customs_account?: InputMaybe<Jsonb_Comparison_Exp>;
  customs_clearance_type?: InputMaybe<Numeric_Comparison_Exp>;
  customs_clearance_type_de?: InputMaybe<String_Comparison_Exp>;
  customs_clearance_type_en?: InputMaybe<String_Comparison_Exp>;
  customs_office?: InputMaybe<Jsonb_Comparison_Exp>;
  declarant?: InputMaybe<Jsonb_Comparison_Exp>;
  declaration_type?: InputMaybe<String_Comparison_Exp>;
  declaration_type_de?: InputMaybe<String_Comparison_Exp>;
  declaration_type_en?: InputMaybe<String_Comparison_Exp>;
  dispatch_country?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  duty_and_additional_taxes?: InputMaybe<Jsonb_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  gross_mass?: InputMaybe<Numeric_Comparison_Exp>;
  importer?: InputMaybe<Jsonb_Comparison_Exp>;
  incoterms?: InputMaybe<String_Comparison_Exp>;
  invoice_currency_type?: InputMaybe<String_Comparison_Exp>;
  number_of_goods_items?: InputMaybe<Bigint_Comparison_Exp>;
  packaging_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  previous_document?: InputMaybe<Jsonb_Comparison_Exp>;
  special_mention?: InputMaybe<Jsonb_Comparison_Exp>;
  src_docs?: InputMaybe<_Uuid_Comparison_Exp>;
  src_doctypes?: InputMaybe<_Text_Comparison_Exp>;
  trader_declaration_number?: InputMaybe<String_Comparison_Exp>;
  trader_identification_number?: InputMaybe<String_Comparison_Exp>;
  traderreference?: InputMaybe<String_Comparison_Exp>;
  transport_means?: InputMaybe<Jsonb_Comparison_Exp>;
  valuation_summary?: InputMaybe<Jsonb_Comparison_Exp>;
  vat?: InputMaybe<Jsonb_Comparison_Exp>;
  vat_account?: InputMaybe<Jsonb_Comparison_Exp>;
  vatnumber?: InputMaybe<String_Comparison_Exp>;
  vatvalue?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "_timestamp". All fields are combined with logical 'AND'. */
export type _Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_timestamp']>;
  _gt?: InputMaybe<Scalars['_timestamp']>;
  _gte?: InputMaybe<Scalars['_timestamp']>;
  _in?: InputMaybe<Array<Scalars['_timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_timestamp']>;
  _lte?: InputMaybe<Scalars['_timestamp']>;
  _neq?: InputMaybe<Scalars['_timestamp']>;
  _nin?: InputMaybe<Array<Scalars['_timestamp']>>;
};

/** Boolean expression to compare columns of type "_uuid". All fields are combined with logical 'AND'. */
export type _Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_uuid']>;
  _gt?: InputMaybe<Scalars['_uuid']>;
  _gte?: InputMaybe<Scalars['_uuid']>;
  _in?: InputMaybe<Array<Scalars['_uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_uuid']>;
  _lte?: InputMaybe<Scalars['_uuid']>;
  _neq?: InputMaybe<Scalars['_uuid']>;
  _nin?: InputMaybe<Array<Scalars['_uuid']>>;
};

/** Boolean expression to filter rows from the table "declaration". All fields are combined with a logical 'AND'. */
export type Declaration_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Bool_Exp>>;
  acceptance_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  access_code?: InputMaybe<String_Comparison_Exp>;
  addresses?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
  agreed_location_of_goods?: InputMaybe<String_Comparison_Exp>;
  ai_confirmed?: InputMaybe<Boolean_Comparison_Exp>;
  ai_results?: InputMaybe<Jsonb_Comparison_Exp>;
  border_eau_number?: InputMaybe<Numeric_Comparison_Exp>;
  bunch_number?: InputMaybe<Int_Comparison_Exp>;
  change_information?: InputMaybe<Date_Comparison_Exp>;
  clearance_location?: InputMaybe<Smallint_Comparison_Exp>;
  company_number_taxpayer?: InputMaybe<String_Comparison_Exp>;
  containers?: InputMaybe<Containers_Bool_Exp>;
  correction_code?: InputMaybe<Int_Comparison_Exp>;
  correction_reason?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_account_address_type?: InputMaybe<Int_Comparison_Exp>;
  customs_account_name?: InputMaybe<String_Comparison_Exp>;
  customs_account_number?: InputMaybe<Bigint_Comparison_Exp>;
  customs_declaration_number?: InputMaybe<String_Comparison_Exp>;
  customs_declaration_version?: InputMaybe<Int_Comparison_Exp>;
  customs_office_number?: InputMaybe<String_Comparison_Exp>;
  declarant_company_name?: InputMaybe<String_Comparison_Exp>;
  declarant_number?: InputMaybe<Int_Comparison_Exp>;
  declaration_request?: InputMaybe<Declaration_Request_Bool_Exp>;
  declaration_special_mentions?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
  declaration_time?: InputMaybe<Smallint_Comparison_Exp>;
  declaration_type?: InputMaybe<String_Comparison_Exp>;
  delivery_destination?: InputMaybe<Bpchar_Comparison_Exp>;
  dispatch_country?: InputMaybe<String_Comparison_Exp>;
  dispatch_country_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  duty_and_other_taxes_amount?: InputMaybe<Numeric_Comparison_Exp>;
  duty_total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  evv_confirmed?: InputMaybe<Boolean_Comparison_Exp>;
  evv_received?: InputMaybe<Boolean_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  goods_items?: InputMaybe<Goods_Item_Bool_Exp>;
  goods_items_aggregate?: InputMaybe<Goods_Item_Aggregate_Bool_Exp>;
  gross_mass?: InputMaybe<Numeric_Comparison_Exp>;
  incoterms?: InputMaybe<String_Comparison_Exp>;
  initiator?: InputMaybe<Smallint_Comparison_Exp>;
  injunction_type?: InputMaybe<Smallint_Comparison_Exp>;
  inspection_code?: InputMaybe<Boolean_Comparison_Exp>;
  invoice_currency_type?: InputMaybe<String_Comparison_Exp>;
  lang?: InputMaybe<String_Comparison_Exp>;
  material_check?: InputMaybe<Boolean_Comparison_Exp>;
  net_mass?: InputMaybe<Numeric_Comparison_Exp>;
  packaging_quantity?: InputMaybe<Int_Comparison_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_of_loading?: InputMaybe<String_Comparison_Exp>;
  place_of_unloading?: InputMaybe<String_Comparison_Exp>;
  postal_shipment_type?: InputMaybe<String_Comparison_Exp>;
  previous_documents?: InputMaybe<Previous_Documents_Bool_Exp>;
  procedure_type?: InputMaybe<Smallint_Comparison_Exp>;
  provisional_declaration_expiration_date?: InputMaybe<Date_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  receive_status?: InputMaybe<Int_Comparison_Exp>;
  release?: InputMaybe<Boolean_Comparison_Exp>;
  requestor_trader_identification_number?: InputMaybe<String_Comparison_Exp>;
  security?: InputMaybe<Boolean_Comparison_Exp>;
  selection_correlation_id?: InputMaybe<String_Comparison_Exp>;
  send_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  send_status?: InputMaybe<Int_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  show_in_wd?: InputMaybe<Boolean_Comparison_Exp>;
  specific_circumstance_indicator?: InputMaybe<Bpchar_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  status_date?: InputMaybe<Date_Comparison_Exp>;
  status_time?: InputMaybe<Time_Comparison_Exp>;
  tara_factor?: InputMaybe<Numeric_Comparison_Exp>;
  total_colis?: InputMaybe<Int_Comparison_Exp>;
  total_goods_items?: InputMaybe<Int_Comparison_Exp>;
  total_gross_weight?: InputMaybe<Numeric_Comparison_Exp>;
  total_vat_value?: InputMaybe<Numeric_Comparison_Exp>;
  trader_declaration_number?: InputMaybe<String_Comparison_Exp>;
  trader_identification_number?: InputMaybe<String_Comparison_Exp>;
  trader_reference?: InputMaybe<String_Comparison_Exp>;
  transfer_to_transit_system?: InputMaybe<Boolean_Comparison_Exp>;
  transport_country?: InputMaybe<String_Comparison_Exp>;
  transport_in_container?: InputMaybe<Boolean_Comparison_Exp>;
  transport_mode?: InputMaybe<Int_Comparison_Exp>;
  transport_number?: InputMaybe<String_Comparison_Exp>;
  transport_type?: InputMaybe<String_Comparison_Exp>;
  unique_consignment_reference_number?: InputMaybe<String_Comparison_Exp>;
  vat_account_address_type?: InputMaybe<Int_Comparison_Exp>;
  vat_account_name?: InputMaybe<String_Comparison_Exp>;
  vat_account_number?: InputMaybe<Bigint_Comparison_Exp>;
  vat_number?: InputMaybe<String_Comparison_Exp>;
  vat_suffix?: InputMaybe<Boolean_Comparison_Exp>;
  vat_total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  warehouse_coded?: InputMaybe<Smallint_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "containers". All fields are combined with a logical 'AND'. */
export type Containers_Bool_Exp = {
  _and?: InputMaybe<Array<Containers_Bool_Exp>>;
  _not?: InputMaybe<Containers_Bool_Exp>;
  _or?: InputMaybe<Array<Containers_Bool_Exp>>;
  container_number?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_special_mentions". All fields are combined with a logical 'AND'. */
export type Declaration_Special_Mentions_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Special_Mentions_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Special_Mentions_Bool_Exp>>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  sequence_number?: InputMaybe<Int_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bpchar']>;
  _gt?: InputMaybe<Scalars['bpchar']>;
  _gte?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']>;
  _in?: InputMaybe<Array<Scalars['bpchar']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']>;
  _lt?: InputMaybe<Scalars['bpchar']>;
  _lte?: InputMaybe<Scalars['bpchar']>;
  _neq?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']>;
};

/** Boolean expression to filter rows from the table "goods_item". All fields are combined with a logical 'AND'. */
export type Goods_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Goods_Item_Bool_Exp>>;
  _not?: InputMaybe<Goods_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Goods_Item_Bool_Exp>>;
  additional_unit?: InputMaybe<String_Comparison_Exp>;
  additional_unit_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  billing_type?: InputMaybe<Smallint_Comparison_Exp>;
  clearance_type?: InputMaybe<Int_Comparison_Exp>;
  commercial_good?: InputMaybe<Boolean_Comparison_Exp>;
  commodity_code?: InputMaybe<String_Comparison_Exp>;
  commodity_code_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_declaration_version?: InputMaybe<Int_Comparison_Exp>;
  customs_favour_code?: InputMaybe<Int_Comparison_Exp>;
  customs_item_number?: InputMaybe<Int_Comparison_Exp>;
  customs_net_weight?: InputMaybe<Numeric_Comparison_Exp>;
  declaration_request?: InputMaybe<Declaration_Request_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  direction?: InputMaybe<Smallint_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  duty_and_other_taxes_total?: InputMaybe<Numeric_Comparison_Exp>;
  duty_rate?: InputMaybe<Numeric_Comparison_Exp>;
  duty_total?: InputMaybe<Numeric_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  goods_item_special_mentions?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
  goods_item_special_mentions_aggregate?: InputMaybe<Goods_Item_Special_Mentions_Aggregate_Bool_Exp>;
  gross_mass?: InputMaybe<Numeric_Comparison_Exp>;
  gross_mass_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  net_duty?: InputMaybe<Boolean_Comparison_Exp>;
  net_mass?: InputMaybe<Numeric_Comparison_Exp>;
  net_mass_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  non_customs_law_obligation?: InputMaybe<Smallint_Comparison_Exp>;
  origin_country?: InputMaybe<String_Comparison_Exp>;
  origin_preference?: InputMaybe<Boolean_Comparison_Exp>;
  packagings?: InputMaybe<Packagings_Bool_Exp>;
  packagings_aggregate?: InputMaybe<Packagings_Aggregate_Bool_Exp>;
  permit_obligation_code?: InputMaybe<Int_Comparison_Exp>;
  permits?: InputMaybe<Permits_Bool_Exp>;
  permits_aggregate?: InputMaybe<Permits_Aggregate_Bool_Exp>;
  preference_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  process_type?: InputMaybe<Smallint_Comparison_Exp>;
  produced_documents?: InputMaybe<Produced_Documents_Bool_Exp>;
  produced_documents_aggregate?: InputMaybe<Produced_Documents_Aggregate_Bool_Exp>;
  rate_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  refinement_type?: InputMaybe<Smallint_Comparison_Exp>;
  refund_type?: InputMaybe<Smallint_Comparison_Exp>;
  repair?: InputMaybe<Boolean_Comparison_Exp>;
  repair_reason?: InputMaybe<String_Comparison_Exp>;
  selection_result?: InputMaybe<Int_Comparison_Exp>;
  statistical_code?: InputMaybe<Int_Comparison_Exp>;
  statistical_value?: InputMaybe<Int_Comparison_Exp>;
  statistical_value_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  storage_type?: InputMaybe<Smallint_Comparison_Exp>;
  tare_supplement?: InputMaybe<Numeric_Comparison_Exp>;
  tare_supplement_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  un_dangerous_goods_code?: InputMaybe<String_Comparison_Exp>;
  vat_code?: InputMaybe<Smallint_Comparison_Exp>;
  vat_code_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  vat_rate?: InputMaybe<Numeric_Comparison_Exp>;
  vat_total?: InputMaybe<Numeric_Comparison_Exp>;
  vat_value?: InputMaybe<Numeric_Comparison_Exp>;
  vat_value_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  voc_quantity?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "goods_item_special_mentions". All fields are combined with a logical 'AND'. */
export type Goods_Item_Special_Mentions_Bool_Exp = {
  _and?: InputMaybe<Array<Goods_Item_Special_Mentions_Bool_Exp>>;
  _not?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
  _or?: InputMaybe<Array<Goods_Item_Special_Mentions_Bool_Exp>>;
  customs_item_number?: InputMaybe<Int_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  sequence_number?: InputMaybe<Int_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

export type Goods_Item_Special_Mentions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Goods_Item_Special_Mentions_Aggregate_Bool_Exp_Count>;
};

export type Goods_Item_Special_Mentions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "goods_item_special_mentions" */
export enum Goods_Item_Special_Mentions_Select_Column {
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  SequenceNumber = 'sequence_number',
  /** column name */
  Text = 'text'
}

/** Boolean expression to filter rows from the table "packagings". All fields are combined with a logical 'AND'. */
export type Packagings_Bool_Exp = {
  _and?: InputMaybe<Array<Packagings_Bool_Exp>>;
  _not?: InputMaybe<Packagings_Bool_Exp>;
  _or?: InputMaybe<Array<Packagings_Bool_Exp>>;
  customs_item_number?: InputMaybe<Int_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  packaging_quantity?: InputMaybe<Int_Comparison_Exp>;
  packaging_reference_number?: InputMaybe<String_Comparison_Exp>;
  packaging_type?: InputMaybe<String_Comparison_Exp>;
};

export type Packagings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Packagings_Aggregate_Bool_Exp_Count>;
};

export type Packagings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Packagings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Packagings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "packagings" */
export enum Packagings_Select_Column {
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  PackagingQuantity = 'packaging_quantity',
  /** column name */
  PackagingReferenceNumber = 'packaging_reference_number',
  /** column name */
  PackagingType = 'packaging_type'
}

/** Boolean expression to filter rows from the table "permits". All fields are combined with a logical 'AND'. */
export type Permits_Bool_Exp = {
  _and?: InputMaybe<Array<Permits_Bool_Exp>>;
  _not?: InputMaybe<Permits_Bool_Exp>;
  _or?: InputMaybe<Array<Permits_Bool_Exp>>;
  additional_information?: InputMaybe<String_Comparison_Exp>;
  customs_item_number?: InputMaybe<Int_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  issue_date?: InputMaybe<Date_Comparison_Exp>;
  permit_authority?: InputMaybe<Int_Comparison_Exp>;
  permit_item_details?: InputMaybe<Jsonb_Comparison_Exp>;
  permit_number?: InputMaybe<String_Comparison_Exp>;
  permit_type?: InputMaybe<Int_Comparison_Exp>;
};

export type Permits_Aggregate_Bool_Exp = {
  count?: InputMaybe<Permits_Aggregate_Bool_Exp_Count>;
};

export type Permits_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Permits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Permits_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "permits" */
export enum Permits_Select_Column {
  /** column name */
  AdditionalInformation = 'additional_information',
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  PermitAuthority = 'permit_authority',
  /** column name */
  PermitItemDetails = 'permit_item_details',
  /** column name */
  PermitNumber = 'permit_number',
  /** column name */
  PermitType = 'permit_type'
}

/** Boolean expression to filter rows from the table "produced_documents". All fields are combined with a logical 'AND'. */
export type Produced_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Produced_Documents_Bool_Exp>>;
  _not?: InputMaybe<Produced_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Produced_Documents_Bool_Exp>>;
  additional_information?: InputMaybe<String_Comparison_Exp>;
  customs_item_number?: InputMaybe<Int_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  produced_document_issue_date?: InputMaybe<Date_Comparison_Exp>;
  produced_document_reference_number?: InputMaybe<String_Comparison_Exp>;
  produced_document_type?: InputMaybe<String_Comparison_Exp>;
};

export type Produced_Documents_Aggregate_Bool_Exp = {
  count?: InputMaybe<Produced_Documents_Aggregate_Bool_Exp_Count>;
};

export type Produced_Documents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Produced_Documents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "produced_documents" */
export enum Produced_Documents_Select_Column {
  /** column name */
  AdditionalInformation = 'additional_information',
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProducedDocumentIssueDate = 'produced_document_issue_date',
  /** column name */
  ProducedDocumentReferenceNumber = 'produced_document_reference_number',
  /** column name */
  ProducedDocumentType = 'produced_document_type'
}

export type Goods_Item_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Goods_Item_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Goods_Item_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Goods_Item_Aggregate_Bool_Exp_Count>;
};

export type Goods_Item_Aggregate_Bool_Exp_Bool_And = {
  arguments: Goods_Item_Select_Column_Goods_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Goods_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "goods_item_aggregate_bool_exp_bool_and_arguments_columns" columns of table "goods_item" */
export enum Goods_Item_Select_Column_Goods_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AdditionalUnitConfirmation = 'additional_unit_confirmation',
  /** column name */
  CommercialGood = 'commercial_good',
  /** column name */
  CommodityCodeConfirmation = 'commodity_code_confirmation',
  /** column name */
  GrossMassConfirmation = 'gross_mass_confirmation',
  /** column name */
  NetDuty = 'net_duty',
  /** column name */
  NetMassConfirmation = 'net_mass_confirmation',
  /** column name */
  OriginPreference = 'origin_preference',
  /** column name */
  PreferenceConfirmation = 'preference_confirmation',
  /** column name */
  RateConfirmation = 'rate_confirmation',
  /** column name */
  Repair = 'repair',
  /** column name */
  StatisticalValueConfirmation = 'statistical_value_confirmation',
  /** column name */
  TareSupplementConfirmation = 'tare_supplement_confirmation',
  /** column name */
  VatCodeConfirmation = 'vat_code_confirmation',
  /** column name */
  VatValueConfirmation = 'vat_value_confirmation'
}

export type Goods_Item_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Goods_Item_Select_Column_Goods_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Goods_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "goods_item_aggregate_bool_exp_bool_or_arguments_columns" columns of table "goods_item" */
export enum Goods_Item_Select_Column_Goods_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AdditionalUnitConfirmation = 'additional_unit_confirmation',
  /** column name */
  CommercialGood = 'commercial_good',
  /** column name */
  CommodityCodeConfirmation = 'commodity_code_confirmation',
  /** column name */
  GrossMassConfirmation = 'gross_mass_confirmation',
  /** column name */
  NetDuty = 'net_duty',
  /** column name */
  NetMassConfirmation = 'net_mass_confirmation',
  /** column name */
  OriginPreference = 'origin_preference',
  /** column name */
  PreferenceConfirmation = 'preference_confirmation',
  /** column name */
  RateConfirmation = 'rate_confirmation',
  /** column name */
  Repair = 'repair',
  /** column name */
  StatisticalValueConfirmation = 'statistical_value_confirmation',
  /** column name */
  TareSupplementConfirmation = 'tare_supplement_confirmation',
  /** column name */
  VatCodeConfirmation = 'vat_code_confirmation',
  /** column name */
  VatValueConfirmation = 'vat_value_confirmation'
}

export type Goods_Item_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Goods_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Goods_Item_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "goods_item" */
export enum Goods_Item_Select_Column {
  /** column name */
  AdditionalUnit = 'additional_unit',
  /** column name */
  AdditionalUnitConfirmation = 'additional_unit_confirmation',
  /** column name */
  BillingType = 'billing_type',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CommercialGood = 'commercial_good',
  /** column name */
  CommodityCode = 'commodity_code',
  /** column name */
  CommodityCodeConfirmation = 'commodity_code_confirmation',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  CustomsFavourCode = 'customs_favour_code',
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  CustomsNetWeight = 'customs_net_weight',
  /** column name */
  Description = 'description',
  /** column name */
  Direction = 'direction',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  DutyAndOtherTaxesTotal = 'duty_and_other_taxes_total',
  /** column name */
  DutyRate = 'duty_rate',
  /** column name */
  DutyTotal = 'duty_total',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GrossMass = 'gross_mass',
  /** column name */
  GrossMassConfirmation = 'gross_mass_confirmation',
  /** column name */
  NetDuty = 'net_duty',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  NetMassConfirmation = 'net_mass_confirmation',
  /** column name */
  NonCustomsLawObligation = 'non_customs_law_obligation',
  /** column name */
  OriginCountry = 'origin_country',
  /** column name */
  OriginPreference = 'origin_preference',
  /** column name */
  PermitObligationCode = 'permit_obligation_code',
  /** column name */
  PreferenceConfirmation = 'preference_confirmation',
  /** column name */
  ProcessType = 'process_type',
  /** column name */
  RateConfirmation = 'rate_confirmation',
  /** column name */
  RefinementType = 'refinement_type',
  /** column name */
  RefundType = 'refund_type',
  /** column name */
  Repair = 'repair',
  /** column name */
  RepairReason = 'repair_reason',
  /** column name */
  SelectionResult = 'selection_result',
  /** column name */
  StatisticalCode = 'statistical_code',
  /** column name */
  StatisticalValue = 'statistical_value',
  /** column name */
  StatisticalValueConfirmation = 'statistical_value_confirmation',
  /** column name */
  StorageType = 'storage_type',
  /** column name */
  TareSupplement = 'tare_supplement',
  /** column name */
  TareSupplementConfirmation = 'tare_supplement_confirmation',
  /** column name */
  UnDangerousGoodsCode = 'un_dangerous_goods_code',
  /** column name */
  VatCode = 'vat_code',
  /** column name */
  VatCodeConfirmation = 'vat_code_confirmation',
  /** column name */
  VatRate = 'vat_rate',
  /** column name */
  VatTotal = 'vat_total',
  /** column name */
  VatValue = 'vat_value',
  /** column name */
  VatValueConfirmation = 'vat_value_confirmation',
  /** column name */
  VocQuantity = 'voc_quantity'
}

/** Boolean expression to filter rows from the table "previous_documents". All fields are combined with a logical 'AND'. */
export type Previous_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Previous_Documents_Bool_Exp>>;
  _not?: InputMaybe<Previous_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Previous_Documents_Bool_Exp>>;
  additional_information?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  previous_document_reference?: InputMaybe<String_Comparison_Exp>;
  previous_document_type?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']>;
  _gt?: InputMaybe<Scalars['time']>;
  _gte?: InputMaybe<Scalars['time']>;
  _in?: InputMaybe<Array<Scalars['time']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['time']>;
  _lte?: InputMaybe<Scalars['time']>;
  _neq?: InputMaybe<Scalars['time']>;
  _nin?: InputMaybe<Array<Scalars['time']>>;
};

/** Boolean expression to filter rows from the table "declaration_discussion". All fields are combined with a logical 'AND'. */
export type Declaration_Discussion_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Discussion_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Discussion_Bool_Exp>>;
  closed?: InputMaybe<Boolean_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declaration_messages?: InputMaybe<Declaration_Message_Bool_Exp>;
  declaration_messages_aggregate?: InputMaybe<Declaration_Message_Aggregate_Bool_Exp>;
  declaration_request?: InputMaybe<Declaration_Request_Bool_Exp>;
  discussion_id?: InputMaybe<Bigint_Comparison_Exp>;
  discussion_theme?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  user_pp?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_message". All fields are combined with a logical 'AND'. */
export type Declaration_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Message_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Message_Bool_Exp>>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declaration_discussion?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  discussion_id?: InputMaybe<Bigint_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  msg_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  read_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

export type Declaration_Message_Aggregate_Bool_Exp = {
  count?: InputMaybe<Declaration_Message_Aggregate_Bool_Exp_Count>;
};

export type Declaration_Message_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Declaration_Message_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "declaration_message" */
export enum Declaration_Message_Select_Column {
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DiscussionId = 'discussion_id',
  /** column name */
  Message = 'message',
  /** column name */
  Meta = 'meta',
  /** column name */
  MsgDate = 'msg_date',
  /** column name */
  ReadDate = 'read_date',
  /** column name */
  Type = 'type'
}

export type Declaration_Discussion_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Declaration_Discussion_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Declaration_Discussion_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Declaration_Discussion_Aggregate_Bool_Exp_Count>;
};

export type Declaration_Discussion_Aggregate_Bool_Exp_Bool_And = {
  arguments: Declaration_Discussion_Select_Column_Declaration_Discussion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "declaration_discussion_aggregate_bool_exp_bool_and_arguments_columns" columns of table "declaration_discussion" */
export enum Declaration_Discussion_Select_Column_Declaration_Discussion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Closed = 'closed'
}

export type Declaration_Discussion_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Declaration_Discussion_Select_Column_Declaration_Discussion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "declaration_discussion_aggregate_bool_exp_bool_or_arguments_columns" columns of table "declaration_discussion" */
export enum Declaration_Discussion_Select_Column_Declaration_Discussion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Closed = 'closed'
}

export type Declaration_Discussion_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "declaration_discussion" */
export enum Declaration_Discussion_Select_Column {
  /** column name */
  Closed = 'closed',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DiscussionId = 'discussion_id',
  /** column name */
  DiscussionTheme = 'discussion_theme',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Meta = 'meta'
}

/** Boolean expression to filter rows from the table "declaration_document". All fields are combined with a logical 'AND'. */
export type Declaration_Document_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Document_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Document_Bool_Exp>>;
  doc_id?: InputMaybe<Uuid_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_request_labels". All fields are combined with a logical 'AND'. */
export type Declaration_Request_Labels_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Request_Labels_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Request_Labels_Bool_Exp>>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  label_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_status". All fields are combined with a logical 'AND'. */
export type Declaration_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Status_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_type". All fields are combined with a logical 'AND'. */
export type Declaration_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Type_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Type_Bool_Exp>>;
  declaration_requests?: InputMaybe<Declaration_Request_Bool_Exp>;
  document_schema?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "dr_goods_item". All fields are combined with a logical 'AND'. */
export type Dr_Goods_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Dr_Goods_Item_Bool_Exp>>;
  _not?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Dr_Goods_Item_Bool_Exp>>;
  additional_pcs?: InputMaybe<Numeric_Comparison_Exp>;
  amount?: InputMaybe<Jsonb_Comparison_Exp>;
  certificates?: InputMaybe<Jsonb_Comparison_Exp>;
  commodity_code?: InputMaybe<String_Comparison_Exp>;
  customs_net_mass?: InputMaybe<Numeric_Comparison_Exp>;
  declaration_request?: InputMaybe<Declaration_Request_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  gross_mass?: InputMaybe<Numeric_Comparison_Exp>;
  key?: InputMaybe<Numeric_Comparison_Exp>;
  net_declaration?: InputMaybe<Boolean_Comparison_Exp>;
  net_mass?: InputMaybe<Numeric_Comparison_Exp>;
  non_customs_law_obligation?: InputMaybe<Int_Comparison_Exp>;
  origin?: InputMaybe<Jsonb_Comparison_Exp>;
  packaging?: InputMaybe<Jsonb_Comparison_Exp>;
  revision?: InputMaybe<Boolean_Comparison_Exp>;
  source?: InputMaybe<Smallint_Comparison_Exp>;
  statistic?: InputMaybe<Jsonb_Comparison_Exp>;
  statistical_code?: InputMaybe<String_Comparison_Exp>;
  traded_goods?: InputMaybe<Boolean_Comparison_Exp>;
  trader_item_id?: InputMaybe<Int_Comparison_Exp>;
  valuation?: InputMaybe<Jsonb_Comparison_Exp>;
};

export type Dr_Goods_Item_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Dr_Goods_Item_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Dr_Goods_Item_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Dr_Goods_Item_Aggregate_Bool_Exp_Count>;
};

export type Dr_Goods_Item_Aggregate_Bool_Exp_Bool_And = {
  arguments: Dr_Goods_Item_Select_Column_Dr_Goods_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "dr_goods_item_aggregate_bool_exp_bool_and_arguments_columns" columns of table "dr_goods_item" */
export enum Dr_Goods_Item_Select_Column_Dr_Goods_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  NetDeclaration = 'net_declaration',
  /** column name */
  Revision = 'revision',
  /** column name */
  TradedGoods = 'traded_goods'
}

export type Dr_Goods_Item_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Dr_Goods_Item_Select_Column_Dr_Goods_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "dr_goods_item_aggregate_bool_exp_bool_or_arguments_columns" columns of table "dr_goods_item" */
export enum Dr_Goods_Item_Select_Column_Dr_Goods_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  NetDeclaration = 'net_declaration',
  /** column name */
  Revision = 'revision',
  /** column name */
  TradedGoods = 'traded_goods'
}

export type Dr_Goods_Item_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Dr_Goods_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "dr_goods_item" */
export enum Dr_Goods_Item_Select_Column {
  /** column name */
  AdditionalPcs = 'additional_pcs',
  /** column name */
  Amount = 'amount',
  /** column name */
  Certificates = 'certificates',
  /** column name */
  CommodityCode = 'commodity_code',
  /** column name */
  CustomsNetMass = 'customs_net_mass',
  /** column name */
  Description = 'description',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GrossMass = 'gross_mass',
  /** column name */
  Key = 'key',
  /** column name */
  NetDeclaration = 'net_declaration',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  NonCustomsLawObligation = 'non_customs_law_obligation',
  /** column name */
  Origin = 'origin',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  Revision = 'revision',
  /** column name */
  Source = 'source',
  /** column name */
  Statistic = 'statistic',
  /** column name */
  StatisticalCode = 'statistical_code',
  /** column name */
  TradedGoods = 'traded_goods',
  /** column name */
  TraderItemId = 'trader_item_id',
  /** column name */
  Valuation = 'valuation'
}

/** Boolean expression to compare columns of type "transitdoc_type". All fields are combined with logical 'AND'. */
export type Transitdoc_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['transitdoc_type']>;
  _gt?: InputMaybe<Scalars['transitdoc_type']>;
  _gte?: InputMaybe<Scalars['transitdoc_type']>;
  _in?: InputMaybe<Array<Scalars['transitdoc_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['transitdoc_type']>;
  _lte?: InputMaybe<Scalars['transitdoc_type']>;
  _neq?: InputMaybe<Scalars['transitdoc_type']>;
  _nin?: InputMaybe<Array<Scalars['transitdoc_type']>>;
};

export type Declaration_Task_Aggregate_Bool_Exp = {
  count?: InputMaybe<Declaration_Task_Aggregate_Bool_Exp_Count>;
};

export type Declaration_Task_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Declaration_Task_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "declaration_task" */
export enum Declaration_Task_Select_Column {
  /** column name */
  AssignedTo = 'assigned_to',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  TaskStatusId = 'task_status_id',
  /** column name */
  TaskTypeId = 'task_type_id',
  /** column name */
  Title = 'title'
}

/** Boolean expression to filter rows from the table "task_type". All fields are combined with a logical 'AND'. */
export type Task_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Type_Bool_Exp>>;
  _not?: InputMaybe<Task_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Type_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "doc_annotation". All fields are combined with a logical 'AND'. */
export type Doc_Annotation_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Annotation_Bool_Exp>>;
  _not?: InputMaybe<Doc_Annotation_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Annotation_Bool_Exp>>;
  anno_type_id?: InputMaybe<Smallint_Comparison_Exp>;
  annotation_type?: InputMaybe<Annotation_Type_Bool_Exp>;
  doc_id?: InputMaybe<Uuid_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "document_extension". All fields are combined with a logical 'AND'. */
export type Document_Extension_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Extension_Bool_Exp>>;
  _not?: InputMaybe<Document_Extension_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Extension_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  thumbnails_supported?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "document_page". All fields are combined with a logical 'AND'. */
export type Document_Page_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Page_Bool_Exp>>;
  _not?: InputMaybe<Document_Page_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Page_Bool_Exp>>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  page?: InputMaybe<Page_Bool_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  page_number?: InputMaybe<Smallint_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "page". All fields are combined with a logical 'AND'. */
export type Page_Bool_Exp = {
  _and?: InputMaybe<Array<Page_Bool_Exp>>;
  _not?: InputMaybe<Page_Bool_Exp>;
  _or?: InputMaybe<Array<Page_Bool_Exp>>;
  ai_ignore_retraining?: InputMaybe<Boolean_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Page_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Page_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  ocr_text?: InputMaybe<String_Comparison_Exp>;
  page_extracts?: InputMaybe<Page_Extract_Bool_Exp>;
  page_status?: InputMaybe<String_Comparison_Exp>;
  rotate?: InputMaybe<Smallint_Comparison_Exp>;
  thumbnail_big_url?: InputMaybe<String_Comparison_Exp>;
  thumbnail_small_url?: InputMaybe<String_Comparison_Exp>;
};

export type Document_Page_Aggregate_Bool_Exp = {
  count?: InputMaybe<Document_Page_Aggregate_Bool_Exp_Count>;
};

export type Document_Page_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Document_Page_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Document_Page_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "document_page" */
export enum Document_Page_Select_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  PageNumber = 'page_number'
}

/** Boolean expression to filter rows from the table "page_extract". All fields are combined with a logical 'AND'. */
export type Page_Extract_Bool_Exp = {
  _and?: InputMaybe<Array<Page_Extract_Bool_Exp>>;
  _not?: InputMaybe<Page_Extract_Bool_Exp>;
  _or?: InputMaybe<Array<Page_Extract_Bool_Exp>>;
  extract_type?: InputMaybe<Extract_Type_Bool_Exp>;
  extract_type_id?: InputMaybe<Smallint_Comparison_Exp>;
  page?: InputMaybe<Page_Bool_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  tables?: InputMaybe<Jsonb_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "extract_type". All fields are combined with a logical 'AND'. */
export type Extract_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Extract_Type_Bool_Exp>>;
  _not?: InputMaybe<Extract_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Extract_Type_Bool_Exp>>;
  extract_type_id?: InputMaybe<Smallint_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  translations?: InputMaybe<Json_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "document_status". All fields are combined with a logical 'AND'. */
export type Document_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Status_Bool_Exp>>;
  _not?: InputMaybe<Document_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Status_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "user_org_id". All fields are combined with a logical 'AND'. */
export type User_Org_Id_Bool_Exp = {
  _and?: InputMaybe<Array<User_Org_Id_Bool_Exp>>;
  _not?: InputMaybe<User_Org_Id_Bool_Exp>;
  _or?: InputMaybe<Array<User_Org_Id_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  orgId?: InputMaybe<Org_Id_Bool_Exp>;
  user_pp?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "import_list_trigger". All fields are combined with a logical 'AND'. */
export type Import_List_Trigger_Bool_Exp = {
  _and?: InputMaybe<Array<Import_List_Trigger_Bool_Exp>>;
  _not?: InputMaybe<Import_List_Trigger_Bool_Exp>;
  _or?: InputMaybe<Array<Import_List_Trigger_Bool_Exp>>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  creationUser?: InputMaybe<User_Pp_Bool_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<Declaration_Labels_Bool_Exp>;
  label_id?: InputMaybe<Int_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  lastModifiedUser?: InputMaybe<User_Pp_Bool_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

export type Import_List_Trigger_Aggregate_Bool_Exp = {
  count?: InputMaybe<Import_List_Trigger_Aggregate_Bool_Exp_Count>;
};

export type Import_List_Trigger_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Import_List_Trigger_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "import_list_trigger" */
export enum Import_List_Trigger_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  LabelId = 'label_id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type'
}

/** Boolean expression to compare columns of type "tenant_type". All fields are combined with logical 'AND'. */
export type Tenant_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tenant_type']>;
  _gt?: InputMaybe<Scalars['tenant_type']>;
  _gte?: InputMaybe<Scalars['tenant_type']>;
  _in?: InputMaybe<Array<Scalars['tenant_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['tenant_type']>;
  _lte?: InputMaybe<Scalars['tenant_type']>;
  _neq?: InputMaybe<Scalars['tenant_type']>;
  _nin?: InputMaybe<Array<Scalars['tenant_type']>>;
};

/** Boolean expression to filter rows from the table "extraction_config". All fields are combined with a logical 'AND'. */
export type Extraction_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Extraction_Config_Bool_Exp>>;
  _not?: InputMaybe<Extraction_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Extraction_Config_Bool_Exp>>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  aliases?: InputMaybe<Jsonb_Comparison_Exp>;
  document_templates?: InputMaybe<Jsonb_Comparison_Exp>;
  foun_config?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "tsvector". All fields are combined with logical 'AND'. */
export type Tsvector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tsvector']>;
  _gt?: InputMaybe<Scalars['tsvector']>;
  _gte?: InputMaybe<Scalars['tsvector']>;
  _in?: InputMaybe<Array<Scalars['tsvector']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['tsvector']>;
  _lte?: InputMaybe<Scalars['tsvector']>;
  _neq?: InputMaybe<Scalars['tsvector']>;
  _nin?: InputMaybe<Array<Scalars['tsvector']>>;
};

/** Table containing addresses of consgnor/consgnee */
export type Address = {
  additional_values: Maybe<Scalars['jsonb']>;
  address_type: Maybe<Scalars['Int']>;
  /** An object relationship */
  addressType: Maybe<Address_Type>;
  ao_id: Maybe<Scalars['smallint']>;
  city: Maybe<Scalars['String']>;
  company_name: Scalars['String'];
  company_name_2: Maybe<Scalars['String']>;
  contact_email: Maybe<Scalars['String']>;
  contact_phone: Maybe<Scalars['String']>;
  contact_website: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Scalars['uuid'];
  /** An object relationship */
  creationUser: Maybe<User_Pp>;
  customs_account_number: Maybe<Scalars['String']>;
  error_email_address: Maybe<Scalars['String']>;
  /** An object relationship */
  extraction_config: Maybe<Extraction_Config>;
  id: Scalars['Int'];
  imported: Maybe<Scalars['Boolean']>;
  is_active: Maybe<Scalars['Boolean']>;
  is_deleted: Maybe<Scalars['Boolean']>;
  is_locked: Maybe<Scalars['Boolean']>;
  is_platform_user: Scalars['Boolean'];
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  payer_id: Maybe<Scalars['uuid']>;
  reference: Maybe<Scalars['String']>;
  search_vector: Maybe<Scalars['tsvector']>;
  street: Maybe<Scalars['String']>;
  street_number: Maybe<Scalars['String']>;
  /** An object relationship */
  tenant: Maybe<Tenant>;
  trader_identification_number: Maybe<Scalars['String']>;
  uid_number: Maybe<Scalars['String']>;
  usage_frequency: Maybe<Scalars['Int']>;
  vat_account_number: Maybe<Scalars['String']>;
  vat_number: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};


/** Table containing addresses of consgnor/consgnee */
export type AddressAdditional_ValuesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Table containing addresses of consgnor/consgnee */
export type AddressMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "address_type" */
export type Address_Type = {
  id: Scalars['Int'];
  meta: Scalars['jsonb'];
  name: Scalars['String'];
  translation: Scalars['jsonb'];
};


/** columns and relationships of "address_type" */
export type Address_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "address_type" */
export type Address_TypeTranslationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Users of system */
export type User_Pp = {
  code: Maybe<Scalars['String']>;
  /** An object relationship */
  created_by_user: Maybe<User_Pp>;
  /** User creation date */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** user_pp creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  deleted: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['timestamptz']>;
  deleted_by_user: Maybe<Scalars['uuid']>;
  display_name: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  first_name: Maybe<Scalars['String']>;
  /** id of user_pp. */
  id: Scalars['uuid'];
  /** user_pp last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified user_pp. */
  last_modified_user: Maybe<Scalars['uuid']>;
  last_name: Maybe<Scalars['String']>;
  ldap_entry_dn: Maybe<Scalars['String']>;
  location: Maybe<Scalars['String']>;
  oauth_id: Maybe<Scalars['String']>;
  permissions: Maybe<Scalars['bit']>;
  phone_number: Maybe<Scalars['String']>;
  /** An object relationship */
  tenant: Tenant;
  /** Tenant of user_pp. */
  tenant_id: Scalars['uuid'];
  ui_settings: Maybe<Scalars['jsonb']>;
  ui_settings_templates: Maybe<Scalars['jsonb']>;
  user_type: Scalars['String'];
  /** An array relationship */
  userOrgIds: Array<User_Org_Id>;
};


/** Users of system */
export type User_PpUi_SettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Users of system */
export type User_PpUi_Settings_TemplatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Users of system */
export type User_PpUserOrgIdsArgs = {
  distinct_on?: InputMaybe<Array<User_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Org_Id_Order_By>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};

/** Tenant groups users. */
export type Tenant = {
  /** Swiss Customs account number */
  account_number: Maybe<Scalars['String']>;
  /** An object relationship */
  address: Address;
  address_id: Scalars['Int'];
  /** An array relationship */
  api_keys: Array<Api_Key>;
  /** tenant creation date. */
  creation_date: Scalars['timestamptz'];
  /** tenant creation user. */
  creation_user: Scalars['uuid'];
  /** An array relationship */
  declaration_labels: Array<Declaration_Labels>;
  /** An array relationship */
  document_labels: Array<Document_Labels>;
  /** id of tenant. */
  id: Scalars['uuid'];
  /** An array relationship */
  import_list_triggers: Array<Import_List_Trigger>;
  /** An aggregate relationship */
  import_list_triggers_aggregate: Import_List_Trigger_Aggregate;
  is_wd_customer: Scalars['Boolean'];
  /** tenant last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified tenant. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** An array relationship */
  org_ids: Array<Org_Id>;
  permissions: Maybe<Scalars['bit']>;
  permissions_js: Scalars['jsonb'];
  /** An array relationship */
  service_rates: Array<Service_Rate>;
  tenant_name: Scalars['String'];
  tenant_type: Maybe<Scalars['tenant_type']>;
  /** An array relationship */
  tenantDocumentTypes: Array<Document_Type_All_Tenant_Settings>;
  trader_identification_number: Maybe<Scalars['String']>;
  /** An array relationship */
  user_pps: Array<User_Pp>;
};


/** Tenant groups users. */
export type TenantApi_KeysArgs = {
  distinct_on?: InputMaybe<Array<Api_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Key_Order_By>>;
  where?: InputMaybe<Api_Key_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantDeclaration_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Labels_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantDocument_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Document_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Labels_Order_By>>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantImport_List_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_List_Trigger_Order_By>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantImport_List_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_List_Trigger_Order_By>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantOrg_IdsArgs = {
  distinct_on?: InputMaybe<Array<Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Id_Order_By>>;
  where?: InputMaybe<Org_Id_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantPermissions_JsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Tenant groups users. */
export type TenantService_RatesArgs = {
  distinct_on?: InputMaybe<Array<Service_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Rate_Order_By>>;
  where?: InputMaybe<Service_Rate_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantTenantDocumentTypesArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantUser_PpsArgs = {
  distinct_on?: InputMaybe<Array<User_Pp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Pp_Order_By>>;
  where?: InputMaybe<User_Pp_Bool_Exp>;
};

/** select columns of table "api_key" */
export enum Api_Key_Select_Column {
  /** column name */
  ApiKey = 'api_key',
  /** column name */
  DsplayName = 'dsplay_name',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta'
}

/** Ordering options when selecting data from "api_key". */
export type Api_Key_Order_By = {
  api_key?: InputMaybe<Order_By>;
  dsplay_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
};

/** Api_keys to call external methods of adit-api (now CreateDocument) */
export type Api_Key = {
  api_key: Scalars['String'];
  dsplay_name: Scalars['String'];
  id: Scalars['Int'];
  meta: Scalars['jsonb'];
};


/** Api_keys to call external methods of adit-api (now CreateDocument) */
export type Api_KeyMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "declaration_labels" */
export enum Declaration_Labels_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title'
}

/** Ordering options when selecting data from "declaration_labels". */
export type Declaration_Labels_Order_By = {
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenant_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** columns and relationships of "declaration_labels" */
export type Declaration_Labels = {
  color: Scalars['String'];
  description: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_deleted: Scalars['Boolean'];
  /** An object relationship */
  tenant: Tenant;
  tenant_id: Scalars['uuid'];
  title: Scalars['jsonb'];
};


/** columns and relationships of "declaration_labels" */
export type Declaration_LabelsTitleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "document_labels" */
export enum Document_Labels_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  Title = 'title'
}

/** Ordering options when selecting data from "document_labels". */
export type Document_Labels_Order_By = {
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document_label_org_ids_aggregate?: InputMaybe<Document_Label_Org_Id_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenant_Order_By>;
  tenantId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "document_label_org_id" */
export type Document_Label_Org_Id_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Label_Org_Id_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Label_Org_Id_Max_Order_By>;
  min?: InputMaybe<Document_Label_Org_Id_Min_Order_By>;
  stddev?: InputMaybe<Document_Label_Org_Id_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Label_Org_Id_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Label_Org_Id_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Label_Org_Id_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Label_Org_Id_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Label_Org_Id_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Label_Org_Id_Variance_Order_By>;
};

/** order by avg() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Avg_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Max_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Min_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Stddev_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Stddev_Pop_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Stddev_Samp_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Sum_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Var_Pop_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Var_Samp_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Variance_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** Labels for document. Name for tables must be SIGNULAR. */
export type Document_Labels = {
  color: Scalars['String'];
  description: Scalars['jsonb'];
  /** An array relationship */
  document_label_org_ids: Array<Document_Label_Org_Id>;
  /** id of document_labels. */
  id: Scalars['Int'];
  /** Marks document_labels record as deleted. */
  is_deleted: Scalars['Boolean'];
  /** An object relationship */
  tenant: Maybe<Tenant>;
  tenantId: Maybe<Scalars['uuid']>;
  title: Scalars['jsonb'];
};


/** Labels for document. Name for tables must be SIGNULAR. */
export type Document_LabelsDescriptionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Labels for document. Name for tables must be SIGNULAR. */
export type Document_LabelsDocument_Label_Org_IdsArgs = {
  distinct_on?: InputMaybe<Array<Document_Label_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Label_Org_Id_Order_By>>;
  where?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
};


/** Labels for document. Name for tables must be SIGNULAR. */
export type Document_LabelsTitleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "document_label_org_id" */
export enum Document_Label_Org_Id_Select_Column {
  /** column name */
  LabelId = 'label_id',
  /** column name */
  OrgId = 'org_id'
}

/** Ordering options when selecting data from "document_label_org_id". */
export type Document_Label_Org_Id_Order_By = {
  label_id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Org_Id_Order_By>;
};

/** Ordering options when selecting data from "org_id". */
export type Org_Id_Order_By = {
  active?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_id_description?: InputMaybe<Order_By>;
  orgIdUsers_aggregate?: InputMaybe<User_Org_Id_Aggregate_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  userOrgId?: InputMaybe<User_Org_Id_Order_By>;
};

/** order by aggregate values of table "document" */
export type Document_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Max_Order_By>;
  min?: InputMaybe<Document_Min_Order_By>;
  stddev?: InputMaybe<Document_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Variance_Order_By>;
};

/** order by avg() on columns of table "document" */
export type Document_Avg_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "document" */
export type Document_Max_Order_By = {
  /** MD5-checksum of document. */
  checksum?: InputMaybe<Order_By>;
  /** document creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** document creation user. */
  creation_user?: InputMaybe<Order_By>;
  document_extension?: InputMaybe<Order_By>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_name?: InputMaybe<Order_By>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Document Id related to document. */
  file?: InputMaybe<Order_By>;
  /** id of document. */
  id?: InputMaybe<Order_By>;
  /** document last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified document. */
  last_modified_user?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "document" */
export type Document_Min_Order_By = {
  /** MD5-checksum of document. */
  checksum?: InputMaybe<Order_By>;
  /** document creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** document creation user. */
  creation_user?: InputMaybe<Order_By>;
  document_extension?: InputMaybe<Order_By>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_name?: InputMaybe<Order_By>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Document Id related to document. */
  file?: InputMaybe<Order_By>;
  /** id of document. */
  id?: InputMaybe<Order_By>;
  /** document last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified document. */
  last_modified_user?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "document" */
export type Document_Stddev_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "document" */
export type Document_Stddev_Pop_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "document" */
export type Document_Stddev_Samp_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "document" */
export type Document_Sum_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "document" */
export type Document_Var_Pop_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "document" */
export type Document_Var_Samp_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "document" */
export type Document_Variance_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_org_id". */
export type User_Org_Id_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Org_Id_Order_By>;
  user_pp?: InputMaybe<Order_By>;
};

/** TABLE Of unknown puprose. Deprecate? */
export type Document_Label_Org_Id = {
  label_id: Scalars['Int'];
  /** Org_id related to document_label_org_id. */
  org_id: Scalars['smallint'];
  /** An object relationship */
  orgId: Org_Id;
};

/** List of orgranizations/departments/Abteilungs in system */
export type Org_Id = {
  /** can org_id be used to create new files in adit. */
  active: Maybe<Scalars['Boolean']>;
  /** org_id creation date. */
  creation_date: Scalars['timestamptz'];
  /** org_id creation user. */
  creation_user: Scalars['uuid'];
  display_name: Maybe<Scalars['String']>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  /** org_id last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified org_id. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** Org_id related to org_id. */
  org_id: Scalars['smallint'];
  org_id_description: Scalars['String'];
  /** An array relationship */
  orgIdUsers: Array<User_Org_Id>;
  /** Tenant of org_id. */
  tenant_id: Scalars['uuid'];
  /** An object relationship */
  userOrgId: Maybe<User_Org_Id>;
};


/** List of orgranizations/departments/Abteilungs in system */
export type Org_IdDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** List of orgranizations/departments/Abteilungs in system */
export type Org_IdDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** List of orgranizations/departments/Abteilungs in system */
export type Org_IdOrgIdUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Org_Id_Order_By>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};

/** Ordering options when selecting data from "document". */
export type Document_Order_By = {
  annotationType_aggregate?: InputMaybe<Annotation_Type_Aggregate_Order_By>;
  articles_aggregate?: InputMaybe<Article_Aggregate_Order_By>;
  checksum?: InputMaybe<Order_By>;
  computedPagesM2M_aggregate?: InputMaybe<Pages_M2m_Cache_Aggregate_Order_By>;
  created_by_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_response_data?: InputMaybe<Customs_Response_Data_Order_By>;
  doc_tasks_aggregate?: InputMaybe<Declaration_Task_Aggregate_Order_By>;
  docAnnotations_aggregate?: InputMaybe<Doc_Annotation_Aggregate_Order_By>;
  document_blobs?: InputMaybe<Order_By>;
  document_extension?: InputMaybe<Order_By>;
  document_flags?: InputMaybe<Order_By>;
  document_is_allowed_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  document_name?: InputMaybe<Order_By>;
  document_status?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  documentExtensionByDocumentExtension?: InputMaybe<Document_Extension_Order_By>;
  documentFile?: InputMaybe<File_Order_By>;
  documentType?: InputMaybe<Document_Type_Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file?: InputMaybe<Order_By>;
  file_object?: InputMaybe<File_Order_By>;
  id?: InputMaybe<Order_By>;
  is_customs_relevant?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_generated?: InputMaybe<Order_By>;
  is_template?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  number_of_pages?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Org_Id_Order_By>;
  orgId?: InputMaybe<Org_Id_Order_By>;
  pages_m2m_aggregate?: InputMaybe<Document_Page_Aggregate_Order_By>;
  sequence?: InputMaybe<Order_By>;
  status?: InputMaybe<Document_Status_Order_By>;
};

/** order by aggregate values of table "annotation_type" */
export type Annotation_Type_Aggregate_Order_By = {
  avg?: InputMaybe<Annotation_Type_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Annotation_Type_Max_Order_By>;
  min?: InputMaybe<Annotation_Type_Min_Order_By>;
  stddev?: InputMaybe<Annotation_Type_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Annotation_Type_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Annotation_Type_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Annotation_Type_Sum_Order_By>;
  var_pop?: InputMaybe<Annotation_Type_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Annotation_Type_Var_Samp_Order_By>;
  variance?: InputMaybe<Annotation_Type_Variance_Order_By>;
};

/** order by avg() on columns of table "annotation_type" */
export type Annotation_Type_Avg_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "annotation_type" */
export type Annotation_Type_Max_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
  annotation_type?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "annotation_type" */
export type Annotation_Type_Min_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
  annotation_type?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "annotation_type" */
export type Annotation_Type_Stddev_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "annotation_type" */
export type Annotation_Type_Stddev_Pop_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "annotation_type" */
export type Annotation_Type_Stddev_Samp_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "annotation_type" */
export type Annotation_Type_Sum_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "annotation_type" */
export type Annotation_Type_Var_Pop_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "annotation_type" */
export type Annotation_Type_Var_Samp_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "annotation_type" */
export type Annotation_Type_Variance_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "article" */
export type Article_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Max_Order_By>;
  min?: InputMaybe<Article_Min_Order_By>;
  stddev?: InputMaybe<Article_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Variance_Order_By>;
};

/** order by avg() on columns of table "article" */
export type Article_Avg_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "article" */
export type Article_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  country_of_origin?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  gross_weight?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  hscode?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  purchase_order_number?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "article" */
export type Article_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  country_of_origin?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  gross_weight?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  hscode?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  purchase_order_number?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "article" */
export type Article_Stddev_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "article" */
export type Article_Stddev_Pop_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "article" */
export type Article_Stddev_Samp_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "article" */
export type Article_Sum_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "article" */
export type Article_Var_Pop_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "article" */
export type Article_Var_Samp_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "article" */
export type Article_Variance_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Aggregate_Order_By = {
  avg?: InputMaybe<Pages_M2m_Cache_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pages_M2m_Cache_Max_Order_By>;
  min?: InputMaybe<Pages_M2m_Cache_Min_Order_By>;
  stddev?: InputMaybe<Pages_M2m_Cache_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pages_M2m_Cache_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pages_M2m_Cache_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pages_M2m_Cache_Sum_Order_By>;
  var_pop?: InputMaybe<Pages_M2m_Cache_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pages_M2m_Cache_Var_Samp_Order_By>;
  variance?: InputMaybe<Pages_M2m_Cache_Variance_Order_By>;
};

/** order by avg() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Avg_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Max_Order_By = {
  document_id?: InputMaybe<Order_By>;
  page?: InputMaybe<Order_By>;
  page_number?: InputMaybe<Order_By>;
  page_status?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
  thumbnail_big_url?: InputMaybe<Order_By>;
  thumbnail_small_url?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Min_Order_By = {
  document_id?: InputMaybe<Order_By>;
  page?: InputMaybe<Order_By>;
  page_number?: InputMaybe<Order_By>;
  page_status?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
  thumbnail_big_url?: InputMaybe<Order_By>;
  thumbnail_small_url?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Stddev_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Stddev_Pop_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Stddev_Samp_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Sum_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Var_Pop_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Var_Samp_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Variance_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "customs_response_data". */
export type Customs_Response_Data_Order_By = {
  correction_code?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  document_version?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_task" */
export type Declaration_Task_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Task_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Task_Max_Order_By>;
  min?: InputMaybe<Declaration_Task_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Task_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Task_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Task_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Task_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Task_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Task_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Task_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_task" */
export type Declaration_Task_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_task" */
export type Declaration_Task_Max_Order_By = {
  assigned_to?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_task" */
export type Declaration_Task_Min_Order_By = {
  assigned_to?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_task" */
export type Declaration_Task_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_task" */
export type Declaration_Task_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_task" */
export type Declaration_Task_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_task" */
export type Declaration_Task_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_task" */
export type Declaration_Task_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_task" */
export type Declaration_Task_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_task" */
export type Declaration_Task_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "doc_annotation" */
export type Doc_Annotation_Aggregate_Order_By = {
  avg?: InputMaybe<Doc_Annotation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doc_Annotation_Max_Order_By>;
  min?: InputMaybe<Doc_Annotation_Min_Order_By>;
  stddev?: InputMaybe<Doc_Annotation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Doc_Annotation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Doc_Annotation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Doc_Annotation_Sum_Order_By>;
  var_pop?: InputMaybe<Doc_Annotation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Doc_Annotation_Var_Samp_Order_By>;
  variance?: InputMaybe<Doc_Annotation_Variance_Order_By>;
};

/** order by avg() on columns of table "doc_annotation" */
export type Doc_Annotation_Avg_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "doc_annotation" */
export type Doc_Annotation_Max_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  /** Document Id related to doc_annotation. */
  doc_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "doc_annotation" */
export type Doc_Annotation_Min_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  /** Document Id related to doc_annotation. */
  doc_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "doc_annotation" */
export type Doc_Annotation_Stddev_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "doc_annotation" */
export type Doc_Annotation_Stddev_Pop_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "doc_annotation" */
export type Doc_Annotation_Stddev_Samp_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "doc_annotation" */
export type Doc_Annotation_Sum_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "doc_annotation" */
export type Doc_Annotation_Var_Pop_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "doc_annotation" */
export type Doc_Annotation_Var_Samp_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "doc_annotation" */
export type Doc_Annotation_Variance_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "document_extension". */
export type Document_Extension_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  thumbnails_supported?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/** Ordering options when selecting data from "file". */
export type File_Order_By = {
  ai_doc_classification_confirmed?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  declaration?: InputMaybe<Declaration_Request_Order_By>;
  declaration_requests_aggregate?: InputMaybe<Declaration_Request_Aggregate_Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  file_flags?: InputMaybe<Order_By>;
  file_status?: InputMaybe<Order_By>;
  file_tasks_aggregate?: InputMaybe<Declaration_Task_Aggregate_Order_By>;
  file_type?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identification?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  last_modified_by_user?: InputMaybe<User_Pp_Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Org_Id_Order_By>;
  session_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "declaration_request". */
export type Declaration_Request_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  addresses_aggregate?: InputMaybe<Declaration_Request_Address_Aggregate_Order_By>;
  arrival_time?: InputMaybe<Order_By>;
  arrival_type?: InputMaybe<Order_By>;
  arrivalType?: InputMaybe<Arrival_Type_Order_By>;
  bill_details_aggregate?: InputMaybe<Bill_Detail_Aggregate_Order_By>;
  cev_status?: InputMaybe<Order_By>;
  ch_exp_decl?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  clearanceTypeByClearanceType?: InputMaybe<Clearance_Type_Order_By>;
  clientCompany?: InputMaybe<Tenant_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_number?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_response_goods_items_aggregate?: InputMaybe<Customs_Response_Goods_Items_Aggregate_Order_By>;
  customsOffices?: InputMaybe<Customs_Offices_Order_By>;
  customsResponseSummary?: InputMaybe<Customs_Response_Summary_Order_By>;
  declaration?: InputMaybe<Declaration_Order_By>;
  declaration_discussions_aggregate?: InputMaybe<Declaration_Discussion_Aggregate_Order_By>;
  declaration_documents_aggregate?: InputMaybe<Declaration_Document_Aggregate_Order_By>;
  declaration_request_addresses_aggregate?: InputMaybe<Declaration_Request_Address_Aggregate_Order_By>;
  declaration_request_labels_aggregate?: InputMaybe<Declaration_Request_Labels_Aggregate_Order_By>;
  declaration_status?: InputMaybe<Order_By>;
  declaration_type?: InputMaybe<Order_By>;
  declarationStatusByDeclarationStatus?: InputMaybe<Declaration_Status_Order_By>;
  declarationTypeByDeclarationType?: InputMaybe<Declaration_Type_Order_By>;
  dest_tolldept_code?: InputMaybe<Order_By>;
  dest_tolldept_name?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  dr_goods_items_aggregate?: InputMaybe<Dr_Goods_Item_Aggregate_Order_By>;
  dr_no?: InputMaybe<Order_By>;
  edec?: InputMaybe<Order_By>;
  eta?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  file_id?: InputMaybe<Order_By>;
  imp_cust_clr?: InputMaybe<Order_By>;
  is_express?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  mrn_number?: InputMaybe<Order_By>;
  payer?: InputMaybe<Tenant_Order_By>;
  payer_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  toll_dep?: InputMaybe<Order_By>;
  tr_no?: InputMaybe<Order_By>;
  trader_reference?: InputMaybe<Order_By>;
  transitdoc_type?: InputMaybe<Order_By>;
  user_pp?: InputMaybe<User_Pp_Order_By>;
  wa_number?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_request_address" */
export type Declaration_Request_Address_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Request_Address_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Request_Address_Max_Order_By>;
  min?: InputMaybe<Declaration_Request_Address_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Request_Address_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Request_Address_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Request_Address_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Request_Address_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Request_Address_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Request_Address_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Request_Address_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "arrival_type". */
export type Arrival_Type_Order_By = {
  arrival_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "bill_detail" */
export type Bill_Detail_Aggregate_Order_By = {
  avg?: InputMaybe<Bill_Detail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Bill_Detail_Max_Order_By>;
  min?: InputMaybe<Bill_Detail_Min_Order_By>;
  stddev?: InputMaybe<Bill_Detail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Bill_Detail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Bill_Detail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Bill_Detail_Sum_Order_By>;
  var_pop?: InputMaybe<Bill_Detail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Bill_Detail_Var_Samp_Order_By>;
  variance?: InputMaybe<Bill_Detail_Variance_Order_By>;
};

/** order by avg() on columns of table "bill_detail" */
export type Bill_Detail_Avg_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "bill_detail" */
export type Bill_Detail_Max_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "bill_detail" */
export type Bill_Detail_Min_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "bill_detail" */
export type Bill_Detail_Stddev_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "bill_detail" */
export type Bill_Detail_Stddev_Pop_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "bill_detail" */
export type Bill_Detail_Stddev_Samp_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "bill_detail" */
export type Bill_Detail_Sum_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "bill_detail" */
export type Bill_Detail_Var_Pop_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "bill_detail" */
export type Bill_Detail_Var_Samp_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "bill_detail" */
export type Bill_Detail_Variance_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "clearance_type". */
export type Clearance_Type_Order_By = {
  declaration_requests_aggregate?: InputMaybe<Declaration_Request_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_request" */
export type Declaration_Request_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Request_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Request_Max_Order_By>;
  min?: InputMaybe<Declaration_Request_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Request_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Request_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Request_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Request_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Request_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Request_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Request_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_request" */
export type Declaration_Request_Avg_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_request" */
export type Declaration_Request_Max_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  /** Account number in CH customs */
  account_number?: InputMaybe<Order_By>;
  arrival_time?: InputMaybe<Order_By>;
  arrival_type?: InputMaybe<Order_By>;
  cev_status?: InputMaybe<Order_By>;
  /** Refer to values in table clearance_type. */
  clearance_type?: InputMaybe<Order_By>;
  /** Date of creation of declaration request. */
  creation_date?: InputMaybe<Order_By>;
  /** User created declaration request. */
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_number?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Refer to values in table declaration_status. */
  declaration_status?: InputMaybe<Order_By>;
  /** Refer to values in table declaration_type. */
  declaration_type?: InputMaybe<Order_By>;
  /** Destination Tolldept Code */
  dest_tolldept_code?: InputMaybe<Order_By>;
  /** Destination Tolldept Name */
  dest_tolldept_name?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
  eta?: InputMaybe<Order_By>;
  /** File related to declaration request. Part of primary key */
  file_id?: InputMaybe<Order_By>;
  mrn_number?: InputMaybe<Order_By>;
  /** Who is paying for customs declaration (tenant) */
  payer_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  /** Customs office number. Refer to customs_office table.office_number. */
  toll_dep?: InputMaybe<Order_By>;
  /** Truck and Trailer Plate No. */
  tr_no?: InputMaybe<Order_By>;
  trader_reference?: InputMaybe<Order_By>;
  /** Type Transitdocument */
  transitdoc_type?: InputMaybe<Order_By>;
  wa_number?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_request" */
export type Declaration_Request_Min_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  /** Account number in CH customs */
  account_number?: InputMaybe<Order_By>;
  arrival_time?: InputMaybe<Order_By>;
  arrival_type?: InputMaybe<Order_By>;
  cev_status?: InputMaybe<Order_By>;
  /** Refer to values in table clearance_type. */
  clearance_type?: InputMaybe<Order_By>;
  /** Date of creation of declaration request. */
  creation_date?: InputMaybe<Order_By>;
  /** User created declaration request. */
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_number?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Refer to values in table declaration_status. */
  declaration_status?: InputMaybe<Order_By>;
  /** Refer to values in table declaration_type. */
  declaration_type?: InputMaybe<Order_By>;
  /** Destination Tolldept Code */
  dest_tolldept_code?: InputMaybe<Order_By>;
  /** Destination Tolldept Name */
  dest_tolldept_name?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
  eta?: InputMaybe<Order_By>;
  /** File related to declaration request. Part of primary key */
  file_id?: InputMaybe<Order_By>;
  mrn_number?: InputMaybe<Order_By>;
  /** Who is paying for customs declaration (tenant) */
  payer_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  /** Customs office number. Refer to customs_office table.office_number. */
  toll_dep?: InputMaybe<Order_By>;
  /** Truck and Trailer Plate No. */
  tr_no?: InputMaybe<Order_By>;
  trader_reference?: InputMaybe<Order_By>;
  /** Type Transitdocument */
  transitdoc_type?: InputMaybe<Order_By>;
  wa_number?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_request" */
export type Declaration_Request_Stddev_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_request" */
export type Declaration_Request_Stddev_Pop_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_request" */
export type Declaration_Request_Stddev_Samp_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_request" */
export type Declaration_Request_Sum_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_request" */
export type Declaration_Request_Var_Pop_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_request" */
export type Declaration_Request_Var_Samp_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_request" */
export type Declaration_Request_Variance_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Customs_Response_Goods_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customs_Response_Goods_Items_Max_Order_By>;
  min?: InputMaybe<Customs_Response_Goods_Items_Min_Order_By>;
  stddev?: InputMaybe<Customs_Response_Goods_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Customs_Response_Goods_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Customs_Response_Goods_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Customs_Response_Goods_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Customs_Response_Goods_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Customs_Response_Goods_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Customs_Response_Goods_Items_Variance_Order_By>;
};

/** order by avg() on columns of table "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Avg_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Max_Order_By = {
  commercial_good?: InputMaybe<Order_By>;
  customs_clearance_type?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  preference?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vatvalue?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Min_Order_By = {
  commercial_good?: InputMaybe<Order_By>;
  customs_clearance_type?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  preference?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vatvalue?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Stddev_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Stddev_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Stddev_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Sum_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Var_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Var_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Variance_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "customs_offices". */
export type Customs_Offices_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  office_number?: InputMaybe<Order_By>;
  prefix?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "customs_response_summary". */
export type Customs_Response_Summary_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  acceptance_dates?: InputMaybe<Order_By>;
  acceptance_time?: InputMaybe<Order_By>;
  consignee?: InputMaybe<Order_By>;
  consignor?: InputMaybe<Order_By>;
  customs_account?: InputMaybe<Order_By>;
  customs_clearance_type?: InputMaybe<Order_By>;
  customs_clearance_type_de?: InputMaybe<Order_By>;
  customs_clearance_type_en?: InputMaybe<Order_By>;
  customs_office?: InputMaybe<Order_By>;
  declarant?: InputMaybe<Order_By>;
  declaration_type?: InputMaybe<Order_By>;
  declaration_type_de?: InputMaybe<Order_By>;
  declaration_type_en?: InputMaybe<Order_By>;
  dispatch_country?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_additional_taxes?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  importer?: InputMaybe<Order_By>;
  incoterms?: InputMaybe<Order_By>;
  invoice_currency_type?: InputMaybe<Order_By>;
  number_of_goods_items?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
  previous_document?: InputMaybe<Order_By>;
  special_mention?: InputMaybe<Order_By>;
  src_docs?: InputMaybe<Order_By>;
  src_doctypes?: InputMaybe<Order_By>;
  trader_declaration_number?: InputMaybe<Order_By>;
  trader_identification_number?: InputMaybe<Order_By>;
  traderreference?: InputMaybe<Order_By>;
  transport_means?: InputMaybe<Order_By>;
  valuation_summary?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
  vat_account?: InputMaybe<Order_By>;
  vatnumber?: InputMaybe<Order_By>;
  vatvalue?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "declaration". */
export type Declaration_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  access_code?: InputMaybe<Order_By>;
  addresses_aggregate?: InputMaybe<Declaration_Request_Address_Aggregate_Order_By>;
  agreed_location_of_goods?: InputMaybe<Order_By>;
  ai_confirmed?: InputMaybe<Order_By>;
  ai_results?: InputMaybe<Order_By>;
  border_eau_number?: InputMaybe<Order_By>;
  bunch_number?: InputMaybe<Order_By>;
  change_information?: InputMaybe<Order_By>;
  clearance_location?: InputMaybe<Order_By>;
  company_number_taxpayer?: InputMaybe<Order_By>;
  containers_aggregate?: InputMaybe<Containers_Aggregate_Order_By>;
  correction_code?: InputMaybe<Order_By>;
  correction_reason?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_account_address_type?: InputMaybe<Order_By>;
  customs_account_name?: InputMaybe<Order_By>;
  customs_account_number?: InputMaybe<Order_By>;
  customs_declaration_number?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_office_number?: InputMaybe<Order_By>;
  declarant_company_name?: InputMaybe<Order_By>;
  declarant_number?: InputMaybe<Order_By>;
  declaration_request?: InputMaybe<Declaration_Request_Order_By>;
  declaration_special_mentions_aggregate?: InputMaybe<Declaration_Special_Mentions_Aggregate_Order_By>;
  declaration_time?: InputMaybe<Order_By>;
  declaration_type?: InputMaybe<Order_By>;
  delivery_destination?: InputMaybe<Order_By>;
  dispatch_country?: InputMaybe<Order_By>;
  dispatch_country_confirmation?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_amount?: InputMaybe<Order_By>;
  duty_total_amount?: InputMaybe<Order_By>;
  evv_confirmed?: InputMaybe<Order_By>;
  evv_received?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  file_id?: InputMaybe<Order_By>;
  goods_items_aggregate?: InputMaybe<Goods_Item_Aggregate_Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  incoterms?: InputMaybe<Order_By>;
  initiator?: InputMaybe<Order_By>;
  injunction_type?: InputMaybe<Order_By>;
  inspection_code?: InputMaybe<Order_By>;
  invoice_currency_type?: InputMaybe<Order_By>;
  lang?: InputMaybe<Order_By>;
  material_check?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  place_of_loading?: InputMaybe<Order_By>;
  place_of_unloading?: InputMaybe<Order_By>;
  postal_shipment_type?: InputMaybe<Order_By>;
  previous_documents_aggregate?: InputMaybe<Previous_Documents_Aggregate_Order_By>;
  procedure_type?: InputMaybe<Order_By>;
  provisional_declaration_expiration_date?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  receive_status?: InputMaybe<Order_By>;
  release?: InputMaybe<Order_By>;
  requestor_trader_identification_number?: InputMaybe<Order_By>;
  security?: InputMaybe<Order_By>;
  selection_correlation_id?: InputMaybe<Order_By>;
  send_date?: InputMaybe<Order_By>;
  send_status?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  show_in_wd?: InputMaybe<Order_By>;
  specific_circumstance_indicator?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_date?: InputMaybe<Order_By>;
  status_time?: InputMaybe<Order_By>;
  tara_factor?: InputMaybe<Order_By>;
  total_colis?: InputMaybe<Order_By>;
  total_goods_items?: InputMaybe<Order_By>;
  total_gross_weight?: InputMaybe<Order_By>;
  total_vat_value?: InputMaybe<Order_By>;
  trader_declaration_number?: InputMaybe<Order_By>;
  trader_identification_number?: InputMaybe<Order_By>;
  trader_reference?: InputMaybe<Order_By>;
  transfer_to_transit_system?: InputMaybe<Order_By>;
  transport_country?: InputMaybe<Order_By>;
  transport_in_container?: InputMaybe<Order_By>;
  transport_mode?: InputMaybe<Order_By>;
  transport_number?: InputMaybe<Order_By>;
  transport_type?: InputMaybe<Order_By>;
  unique_consignment_reference_number?: InputMaybe<Order_By>;
  vat_account_address_type?: InputMaybe<Order_By>;
  vat_account_name?: InputMaybe<Order_By>;
  vat_account_number?: InputMaybe<Order_By>;
  vat_number?: InputMaybe<Order_By>;
  vat_suffix?: InputMaybe<Order_By>;
  vat_total_amount?: InputMaybe<Order_By>;
  warehouse_coded?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "containers" */
export type Containers_Aggregate_Order_By = {
  avg?: InputMaybe<Containers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Containers_Max_Order_By>;
  min?: InputMaybe<Containers_Min_Order_By>;
  stddev?: InputMaybe<Containers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Containers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Containers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Containers_Sum_Order_By>;
  var_pop?: InputMaybe<Containers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Containers_Var_Samp_Order_By>;
  variance?: InputMaybe<Containers_Variance_Order_By>;
};

/** order by avg() on columns of table "containers" */
export type Containers_Avg_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "containers" */
export type Containers_Max_Order_By = {
  container_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "containers" */
export type Containers_Min_Order_By = {
  container_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "containers" */
export type Containers_Stddev_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "containers" */
export type Containers_Stddev_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "containers" */
export type Containers_Stddev_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "containers" */
export type Containers_Sum_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "containers" */
export type Containers_Var_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "containers" */
export type Containers_Var_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "containers" */
export type Containers_Variance_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Special_Mentions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Special_Mentions_Max_Order_By>;
  min?: InputMaybe<Declaration_Special_Mentions_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Special_Mentions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Special_Mentions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Special_Mentions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Special_Mentions_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Special_Mentions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Special_Mentions_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Special_Mentions_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Avg_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Max_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Min_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Stddev_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Stddev_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Stddev_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Sum_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Var_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Var_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Variance_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "goods_item" */
export type Goods_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Goods_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Goods_Item_Max_Order_By>;
  min?: InputMaybe<Goods_Item_Min_Order_By>;
  stddev?: InputMaybe<Goods_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Goods_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Goods_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Goods_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Goods_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Goods_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Goods_Item_Variance_Order_By>;
};

/** order by avg() on columns of table "goods_item" */
export type Goods_Item_Avg_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "goods_item" */
export type Goods_Item_Max_Order_By = {
  additional_unit?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  commodity_code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  repair_reason?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  un_dangerous_goods_code?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "goods_item" */
export type Goods_Item_Min_Order_By = {
  additional_unit?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  commodity_code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  repair_reason?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  un_dangerous_goods_code?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "goods_item" */
export type Goods_Item_Stddev_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "goods_item" */
export type Goods_Item_Stddev_Pop_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "goods_item" */
export type Goods_Item_Stddev_Samp_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "goods_item" */
export type Goods_Item_Sum_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "goods_item" */
export type Goods_Item_Var_Pop_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "goods_item" */
export type Goods_Item_Var_Samp_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "goods_item" */
export type Goods_Item_Variance_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "previous_documents" */
export type Previous_Documents_Aggregate_Order_By = {
  avg?: InputMaybe<Previous_Documents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Previous_Documents_Max_Order_By>;
  min?: InputMaybe<Previous_Documents_Min_Order_By>;
  stddev?: InputMaybe<Previous_Documents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Previous_Documents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Previous_Documents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Previous_Documents_Sum_Order_By>;
  var_pop?: InputMaybe<Previous_Documents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Previous_Documents_Var_Samp_Order_By>;
  variance?: InputMaybe<Previous_Documents_Variance_Order_By>;
};

/** order by avg() on columns of table "previous_documents" */
export type Previous_Documents_Avg_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "previous_documents" */
export type Previous_Documents_Max_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  previous_document_reference?: InputMaybe<Order_By>;
  previous_document_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "previous_documents" */
export type Previous_Documents_Min_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  previous_document_reference?: InputMaybe<Order_By>;
  previous_document_type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "previous_documents" */
export type Previous_Documents_Stddev_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "previous_documents" */
export type Previous_Documents_Stddev_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "previous_documents" */
export type Previous_Documents_Stddev_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "previous_documents" */
export type Previous_Documents_Sum_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "previous_documents" */
export type Previous_Documents_Var_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "previous_documents" */
export type Previous_Documents_Var_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "previous_documents" */
export type Previous_Documents_Variance_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_discussion" */
export type Declaration_Discussion_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Discussion_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Discussion_Max_Order_By>;
  min?: InputMaybe<Declaration_Discussion_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Discussion_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Discussion_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Discussion_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Discussion_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Discussion_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Discussion_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Discussion_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Avg_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Max_Order_By = {
  /** Creation date of discussion. */
  creation_date?: InputMaybe<Order_By>;
  /** User initiated discussion. */
  creation_user?: InputMaybe<Order_By>;
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  /** Theme of discussion. */
  discussion_theme?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** File/Declaration related to discussion. */
  file_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Min_Order_By = {
  /** Creation date of discussion. */
  creation_date?: InputMaybe<Order_By>;
  /** User initiated discussion. */
  creation_user?: InputMaybe<Order_By>;
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  /** Theme of discussion. */
  discussion_theme?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** File/Declaration related to discussion. */
  file_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Stddev_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Stddev_Pop_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Stddev_Samp_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Sum_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Var_Pop_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Var_Samp_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Variance_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_document" */
export type Declaration_Document_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Document_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Document_Max_Order_By>;
  min?: InputMaybe<Declaration_Document_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Document_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Document_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Document_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Document_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Document_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Document_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Document_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_document" */
export type Declaration_Document_Avg_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_document" */
export type Declaration_Document_Max_Order_By = {
  doc_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_document" */
export type Declaration_Document_Min_Order_By = {
  doc_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_document" */
export type Declaration_Document_Stddev_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_document" */
export type Declaration_Document_Stddev_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_document" */
export type Declaration_Document_Stddev_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_document" */
export type Declaration_Document_Sum_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_document" */
export type Declaration_Document_Var_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_document" */
export type Declaration_Document_Var_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_document" */
export type Declaration_Document_Variance_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_request_labels" */
export type Declaration_Request_Labels_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Request_Labels_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Request_Labels_Max_Order_By>;
  min?: InputMaybe<Declaration_Request_Labels_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Request_Labels_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Request_Labels_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Request_Labels_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Request_Labels_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Request_Labels_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Request_Labels_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Request_Labels_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Avg_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Max_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Min_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Stddev_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Stddev_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Stddev_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Sum_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Var_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Var_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Variance_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "declaration_status". */
export type Declaration_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "declaration_type". */
export type Declaration_Type_Order_By = {
  declaration_requests_aggregate?: InputMaybe<Declaration_Request_Aggregate_Order_By>;
  document_schema?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "dr_goods_item" */
export type Dr_Goods_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Dr_Goods_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Dr_Goods_Item_Max_Order_By>;
  min?: InputMaybe<Dr_Goods_Item_Min_Order_By>;
  stddev?: InputMaybe<Dr_Goods_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Dr_Goods_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Dr_Goods_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Dr_Goods_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Dr_Goods_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Dr_Goods_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Dr_Goods_Item_Variance_Order_By>;
};

/** order by avg() on columns of table "dr_goods_item" */
export type Dr_Goods_Item_Avg_Order_By = {
  additional_pcs?: InputMaybe<Order_By>;
  customs_net_mass?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Order_By>;
  trader_item_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "dr_goods_item" */
export type Dr_Goods_Item_Max_Order_By = {
  additional_pcs?: InputMaybe<Order_By>;
  commodity_code?: InputMaybe<Order_By>;
  customs_net_mass?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  trader_item_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "dr_goods_item" */
export type Dr_Goods_Item_Min_Order_By = {
  additional_pcs?: InputMaybe<Order_By>;
  commodity_code?: InputMaybe<Order_By>;
  customs_net_mass?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  trader_item_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "dr_goods_item" */
export type Dr_Goods_Item_Stddev_Order_By = {
  additional_pcs?: InputMaybe<Order_By>;
  customs_net_mass?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Order_By>;
  trader_item_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "dr_goods_item" */
export type Dr_Goods_Item_Stddev_Pop_Order_By = {
  additional_pcs?: InputMaybe<Order_By>;
  customs_net_mass?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Order_By>;
  trader_item_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "dr_goods_item" */
export type Dr_Goods_Item_Stddev_Samp_Order_By = {
  additional_pcs?: InputMaybe<Order_By>;
  customs_net_mass?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Order_By>;
  trader_item_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "dr_goods_item" */
export type Dr_Goods_Item_Sum_Order_By = {
  additional_pcs?: InputMaybe<Order_By>;
  customs_net_mass?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Order_By>;
  trader_item_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "dr_goods_item" */
export type Dr_Goods_Item_Var_Pop_Order_By = {
  additional_pcs?: InputMaybe<Order_By>;
  customs_net_mass?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Order_By>;
  trader_item_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "dr_goods_item" */
export type Dr_Goods_Item_Var_Samp_Order_By = {
  additional_pcs?: InputMaybe<Order_By>;
  customs_net_mass?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Order_By>;
  trader_item_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "dr_goods_item" */
export type Dr_Goods_Item_Variance_Order_By = {
  additional_pcs?: InputMaybe<Order_By>;
  customs_net_mass?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Order_By>;
  trader_item_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "document_type". */
export type Document_Type_Order_By = {
  annotation_types_aggregate?: InputMaybe<Annotation_Type_Aggregate_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_type_all_tenant_settings_aggregate?: InputMaybe<Document_Type_All_Tenant_Settings_Aggregate_Order_By>;
  document_type_tenant_settings_aggregate?: InputMaybe<Document_Type_Tenant_Settings_Aggregate_Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
  user_pp?: InputMaybe<User_Pp_Order_By>;
  userPpByCreationUser?: InputMaybe<User_Pp_Order_By>;
};

/** order by aggregate values of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Type_Tenant_Settings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Type_Tenant_Settings_Max_Order_By>;
  min?: InputMaybe<Document_Type_Tenant_Settings_Min_Order_By>;
  stddev?: InputMaybe<Document_Type_Tenant_Settings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Type_Tenant_Settings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Type_Tenant_Settings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Type_Tenant_Settings_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Type_Tenant_Settings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Type_Tenant_Settings_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Type_Tenant_Settings_Variance_Order_By>;
};

/** order by avg() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Avg_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  default_flags?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  default_flags?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Stddev_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Stddev_Pop_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Stddev_Samp_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Sum_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Var_Pop_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Var_Samp_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Variance_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "document_page" */
export type Document_Page_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Page_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Page_Max_Order_By>;
  min?: InputMaybe<Document_Page_Min_Order_By>;
  stddev?: InputMaybe<Document_Page_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Page_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Page_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Page_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Page_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Page_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Page_Variance_Order_By>;
};

/** order by avg() on columns of table "document_page" */
export type Document_Page_Avg_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "document_page" */
export type Document_Page_Max_Order_By = {
  /** Document Id related to document_page. */
  document_id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  page_number?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "document_page" */
export type Document_Page_Min_Order_By = {
  /** Document Id related to document_page. */
  document_id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  page_number?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "document_page" */
export type Document_Page_Stddev_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "document_page" */
export type Document_Page_Stddev_Pop_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "document_page" */
export type Document_Page_Stddev_Samp_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "document_page" */
export type Document_Page_Sum_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "document_page" */
export type Document_Page_Var_Pop_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "document_page" */
export type Document_Page_Var_Samp_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "document_page" */
export type Document_Page_Variance_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "document_status". */
export type Document_Status_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type Document = {
  /** An array relationship */
  annotationType: Array<Annotation_Type>;
  /** An array relationship */
  articles: Array<Article>;
  /** MD5-checksum of document. */
  checksum: Maybe<Scalars['String']>;
  /** Substitutes pages_m2m relationship */
  computedPagesM2M: Maybe<Array<Pages_M2m_Cache>>;
  /** An object relationship */
  created_by_user: User_Pp;
  /** document creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document creation user. */
  creation_user: Scalars['uuid'];
  /** An object relationship */
  customs_response_data: Maybe<Customs_Response_Data>;
  /** An array relationship */
  doc_tasks: Array<Declaration_Task>;
  /** An aggregate relationship */
  doc_tasks_aggregate: Declaration_Task_Aggregate;
  /** An array relationship */
  docAnnotations: Array<Doc_Annotation>;
  document_blobs: Scalars['jsonb'];
  document_extension: Scalars['String'];
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Scalars['bigint'];
  document_is_allowed: Maybe<Array<Document>>;
  document_name: Maybe<Scalars['String']>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status: Scalars['String'];
  document_type: Scalars['String'];
  document_version: Scalars['Int'];
  /** An object relationship */
  documentExtensionByDocumentExtension: Document_Extension;
  /** An object relationship */
  documentFile: Maybe<File>;
  /** An object relationship */
  documentType: Document_Type;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['smallint']>;
  /** Document Id related to document. */
  file: Maybe<Scalars['uuid']>;
  /** An object relationship */
  file_object: Maybe<File>;
  /** id of document. */
  id: Scalars['uuid'];
  is_customs_relevant: Maybe<Scalars['Boolean']>;
  /** Marks document record as deleted. */
  is_deleted: Scalars['Boolean'];
  is_generated: Scalars['Boolean'];
  is_template: Maybe<Scalars['Boolean']>;
  /** document last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** additional attributes */
  meta: Scalars['jsonb'];
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['smallint']>;
  /** An object relationship */
  organization: Maybe<Org_Id>;
  /** An object relationship */
  orgId: Maybe<Org_Id>;
  /** An array relationship */
  pages_m2m: Array<Document_Page>;
  /** An aggregate relationship */
  pages_m2m_aggregate: Document_Page_Aggregate;
  sequence: Maybe<Scalars['Int']>;
  /** An object relationship */
  status: Document_Status;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentAnnotationTypeArgs = {
  distinct_on?: InputMaybe<Array<Annotation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Annotation_Type_Order_By>>;
  where?: InputMaybe<Annotation_Type_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentArticlesArgs = {
  distinct_on?: InputMaybe<Array<Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Order_By>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentComputedPagesM2MArgs = {
  distinct_on?: InputMaybe<Array<Pages_M2m_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_M2m_Cache_Order_By>>;
  where?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentDoc_TasksArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentDoc_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentDocAnnotationsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Annotation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Annotation_Order_By>>;
  where?: InputMaybe<Doc_Annotation_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentDocument_BlobsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentDocument_Is_AllowedArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentPages_M2mArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentPages_M2m_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};

/** select columns of table "annotation_type" */
export enum Annotation_Type_Select_Column {
  /** column name */
  AnnoSchema = 'anno_schema',
  /** column name */
  AnnoTypeId = 'anno_type_id',
  /** column name */
  AnnotationProviderId = 'annotation_provider_id',
  /** column name */
  AnnotationSchema = 'annotation_schema',
  /** column name */
  AnnotationType = 'annotation_type',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  Meta = 'meta',
  /** column name */
  UiSchema = 'ui_schema'
}

/** Ordering options when selecting data from "annotation_type". */
export type Annotation_Type_Order_By = {
  anno_schema?: InputMaybe<Order_By>;
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider?: InputMaybe<Annotation_Provider_Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
  annotation_schema?: InputMaybe<Order_By>;
  annotation_type?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Document_Type_Order_By>;
  meta?: InputMaybe<Order_By>;
  ui_schema?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "annotation_provider". */
export type Annotation_Provider_Order_By = {
  annotation_provider?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** Annotation types for doc_annotation. */
export type Annotation_Type = {
  anno_schema: Maybe<Scalars['json']>;
  anno_type_id: Scalars['smallint'];
  /** An object relationship */
  annotation_provider: Annotation_Provider;
  annotation_provider_id: Scalars['smallint'];
  annotation_schema: Maybe<Scalars['jsonb']>;
  annotation_type: Maybe<Scalars['String']>;
  document_type: Scalars['String'];
  /** An object relationship */
  documentType: Document_Type;
  /** additional attributes */
  meta: Scalars['jsonb'];
  ui_schema: Maybe<Scalars['jsonb']>;
};


/** Annotation types for doc_annotation. */
export type Annotation_TypeAnno_SchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Annotation types for doc_annotation. */
export type Annotation_TypeAnnotation_SchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Annotation types for doc_annotation. */
export type Annotation_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Annotation types for doc_annotation. */
export type Annotation_TypeUi_SchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "annotation_provider" */
export type Annotation_Provider = {
  annotation_provider: Scalars['String'];
  annotation_provider_id: Scalars['smallint'];
};

/** Document types in system */
export type Document_Type = {
  /** An array relationship */
  annotation_types: Array<Annotation_Type>;
  /** document_type creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document_type creation user. */
  creation_user: Scalars['uuid'];
  display_name: Maybe<Scalars['String']>;
  /** An array relationship */
  document_type_all_tenant_settings: Array<Document_Type_All_Tenant_Settings>;
  /** An array relationship */
  document_type_tenant_settings: Array<Document_Type_Tenant_Settings>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  /** document_type last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document_type. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  translations: Scalars['jsonb'];
  /** An object relationship */
  user_pp: Maybe<User_Pp>;
  /** An object relationship */
  userPpByCreationUser: User_Pp;
};


/** Document types in system */
export type Document_TypeAnnotation_TypesArgs = {
  distinct_on?: InputMaybe<Array<Annotation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Annotation_Type_Order_By>>;
  where?: InputMaybe<Annotation_Type_Bool_Exp>;
};


/** Document types in system */
export type Document_TypeDocument_Type_All_Tenant_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
};


/** Document types in system */
export type Document_TypeDocument_Type_Tenant_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
};


/** Document types in system */
export type Document_TypeDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** Document types in system */
export type Document_TypeDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** Document types in system */
export type Document_TypeTranslationsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "document_type_all_tenant_settings" */
export enum Document_Type_All_Tenant_Settings_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DefaultFlags = 'default_flags',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DocumentSchema = 'document_schema',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Tenant = 'tenant'
}

/** Ordering options when selecting data from "document_type_all_tenant_settings". */
export type Document_Type_All_Tenant_Settings_Order_By = {
  code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  default_flags?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_schema?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** columns and relationships of "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings = {
  code: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  default_flags: Maybe<Scalars['bigint']>;
  display_name: Maybe<Scalars['String']>;
  document_schema: Maybe<Scalars['jsonb']>;
  document_type: Maybe<Scalars['String']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  tenant: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_SettingsDocument_SchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_SettingsMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "document_type_tenant_settings" */
export enum Document_Type_Tenant_Settings_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DefaultFlags = 'default_flags',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DocumentSchema = 'document_schema',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Tenant = 'tenant'
}

/** Ordering options when selecting data from "document_type_tenant_settings". */
export type Document_Type_Tenant_Settings_Order_By = {
  code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  default_flags?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_schema?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Document_Type_Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
  Tenant?: InputMaybe<Tenant_Order_By>;
};

/** columns and relationships of "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings = {
  code: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  default_flags: Maybe<Scalars['bigint']>;
  display_name: Maybe<Scalars['String']>;
  document_schema: Maybe<Scalars['jsonb']>;
  document_type: Scalars['String'];
  /** An object relationship */
  documentType: Document_Type;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  tenant: Scalars['uuid'];
  /** An object relationship */
  Tenant: Maybe<Tenant>;
};


/** columns and relationships of "document_type_tenant_settings" */
export type Document_Type_Tenant_SettingsDocument_SchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "document_type_tenant_settings" */
export type Document_Type_Tenant_SettingsMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "document" */
export type Document_Aggregate = {
  aggregate: Maybe<Document_Aggregate_Fields>;
  nodes: Array<Document>;
};

/** aggregate fields of "document" */
export type Document_Aggregate_Fields = {
  avg: Maybe<Document_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Document_Max_Fields>;
  min: Maybe<Document_Min_Fields>;
  stddev: Maybe<Document_Stddev_Fields>;
  stddev_pop: Maybe<Document_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Document_Stddev_Samp_Fields>;
  sum: Maybe<Document_Sum_Fields>;
  var_pop: Maybe<Document_Var_Pop_Fields>;
  var_samp: Maybe<Document_Var_Samp_Fields>;
  variance: Maybe<Document_Variance_Fields>;
};


/** aggregate fields of "document" */
export type Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Document_Avg_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Document_Max_Fields = {
  /** MD5-checksum of document. */
  checksum: Maybe<Scalars['String']>;
  /** document creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  document_extension: Maybe<Scalars['String']>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['bigint']>;
  document_name: Maybe<Scalars['String']>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status: Maybe<Scalars['String']>;
  document_type: Maybe<Scalars['String']>;
  document_version: Maybe<Scalars['Int']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['smallint']>;
  /** Document Id related to document. */
  file: Maybe<Scalars['uuid']>;
  /** id of document. */
  id: Maybe<Scalars['uuid']>;
  /** document last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['smallint']>;
  sequence: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Document_Min_Fields = {
  /** MD5-checksum of document. */
  checksum: Maybe<Scalars['String']>;
  /** document creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  document_extension: Maybe<Scalars['String']>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['bigint']>;
  document_name: Maybe<Scalars['String']>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status: Maybe<Scalars['String']>;
  document_type: Maybe<Scalars['String']>;
  document_version: Maybe<Scalars['Int']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['smallint']>;
  /** Document Id related to document. */
  file: Maybe<Scalars['uuid']>;
  /** id of document. */
  id: Maybe<Scalars['uuid']>;
  /** document last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['smallint']>;
  sequence: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Document_Stddev_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Document_Stddev_Pop_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Document_Stddev_Samp_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Document_Sum_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['bigint']>;
  document_version: Maybe<Scalars['Int']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['smallint']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['smallint']>;
  sequence: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Document_Var_Pop_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Document_Var_Samp_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Document_Variance_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** select columns of table "article" */
export enum Article_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Code = 'code',
  /** column name */
  Coords = 'coords',
  /** column name */
  CountryOfOrigin = 'country_of_origin',
  /** column name */
  Description = 'description',
  /** column name */
  DocId = 'doc_id',
  /** column name */
  GrossWeight = 'gross_weight',
  /** column name */
  Height = 'height',
  /** column name */
  Hscode = 'hscode',
  /** column name */
  Length = 'length',
  /** column name */
  Marks = 'marks',
  /** column name */
  Meta = 'meta',
  /** column name */
  NetWeight = 'net_weight',
  /** column name */
  Number = 'number',
  /** column name */
  PageId = 'page_id',
  /** column name */
  Price = 'price',
  /** column name */
  PurchaseOrderNumber = 'purchase_order_number',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Size = 'size',
  /** column name */
  TotalPrice = 'total_price',
  /** column name */
  Unit = 'unit',
  /** column name */
  Volume = 'volume',
  /** column name */
  Width = 'width'
}

/** Ordering options when selecting data from "article". */
export type Article_Order_By = {
  article_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  coords?: InputMaybe<Order_By>;
  country_of_origin?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  gross_weight?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  hscode?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  purchase_order_number?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** columns and relationships of "article" */
export type Article = {
  article_id: Scalars['smallint'];
  code: Maybe<Scalars['String']>;
  coords: Maybe<Scalars['_int4']>;
  country_of_origin: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  doc_id: Scalars['uuid'];
  /** An object relationship */
  document: Maybe<Document>;
  gross_weight: Maybe<Scalars['String']>;
  height: Maybe<Scalars['String']>;
  hscode: Maybe<Scalars['String']>;
  length: Maybe<Scalars['String']>;
  marks: Maybe<Scalars['String']>;
  meta: Maybe<Scalars['jsonb']>;
  net_weight: Maybe<Scalars['String']>;
  number: Maybe<Scalars['String']>;
  page_id: Maybe<Scalars['uuid']>;
  price: Maybe<Scalars['String']>;
  purchase_order_number: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['String']>;
  size: Maybe<Scalars['String']>;
  total_price: Maybe<Scalars['String']>;
  unit: Maybe<Scalars['String']>;
  volume: Maybe<Scalars['String']>;
  width: Maybe<Scalars['String']>;
};


/** columns and relationships of "article" */
export type ArticleMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "pages_m2m_cache" */
export enum Pages_M2m_Cache_Select_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Page = 'page',
  /** column name */
  PageNumber = 'page_number',
  /** column name */
  PageStatus = 'page_status',
  /** column name */
  Rotate = 'rotate',
  /** column name */
  ThumbnailBigUrl = 'thumbnail_big_url',
  /** column name */
  ThumbnailSmallUrl = 'thumbnail_small_url'
}

/** Ordering options when selecting data from "pages_m2m_cache". */
export type Pages_M2m_Cache_Order_By = {
  document_id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  page?: InputMaybe<Order_By>;
  page_number?: InputMaybe<Order_By>;
  page_status?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
  thumbnail_big_url?: InputMaybe<Order_By>;
  thumbnail_small_url?: InputMaybe<Order_By>;
};

/** columns and relationships of "pages_m2m_cache" */
export type Pages_M2m_Cache = {
  document_id: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  page: Maybe<Scalars['uuid']>;
  page_number: Maybe<Scalars['bigint']>;
  page_status: Maybe<Scalars['String']>;
  rotate: Maybe<Scalars['Int']>;
  thumbnail_big_url: Maybe<Scalars['String']>;
  thumbnail_small_url: Maybe<Scalars['String']>;
};


/** columns and relationships of "pages_m2m_cache" */
export type Pages_M2m_CacheMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Table used to store edec responses for customs declaration */
export type Customs_Response_Data = {
  correction_code: Scalars['smallint'];
  doc_id: Scalars['uuid'];
  /** An object relationship */
  document: Maybe<Document>;
  document_version: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  meta: Maybe<Scalars['jsonb']>;
  value: Scalars['jsonb'];
};


/** Table used to store edec responses for customs declaration */
export type Customs_Response_DataMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Table used to store edec responses for customs declaration */
export type Customs_Response_DataValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Ordering options when selecting data from "declaration_task". */
export type Declaration_Task_Order_By = {
  assigned_to?: InputMaybe<Order_By>;
  assigned_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  due_date?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  task_status_id?: InputMaybe<Order_By>;
  task_type?: InputMaybe<Task_Type_Order_By>;
  task_type_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "task_type". */
export type Task_Type_Order_By = {
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
};

/** columns and relationships of "declaration_task" */
export type Declaration_Task = {
  assigned_to: Maybe<Scalars['uuid']>;
  /** An object relationship */
  assigned_user: Maybe<User_Pp>;
  creation_date: Scalars['timestamptz'];
  /** An object relationship */
  document: Maybe<Document>;
  due_date: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  file: Maybe<File>;
  id: Scalars['Int'];
  meta: Scalars['jsonb'];
  object_id: Scalars['uuid'];
  /** 1 = finished, 0 = open */
  task_status_id: Scalars['Int'];
  /** An object relationship */
  task_type: Task_Type;
  task_type_id: Scalars['Int'];
  title: Scalars['String'];
};


/** columns and relationships of "declaration_task" */
export type Declaration_TaskMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** File as collection of documents */
export type File = {
  ai_doc_classification_confirmed: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  created_by_user: User_Pp;
  /** file creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** file creation user. */
  creation_user: Scalars['uuid'];
  /** An object relationship */
  declaration: Maybe<Declaration_Request>;
  /** An array relationship */
  declaration_requests: Array<Declaration_Request>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  file_flags: Scalars['bigint'];
  file_status: Scalars['String'];
  /** An array relationship */
  file_tasks: Array<Declaration_Task>;
  /** An aggregate relationship */
  file_tasks_aggregate: Declaration_Task_Aggregate;
  file_type: Scalars['String'];
  file_url: Maybe<Scalars['String']>;
  /** id of file. */
  id: Scalars['uuid'];
  /**
   * Is usually set automatically by AQW.IdentificationProvider.
   *
   * AQW.IdentificationProvider can be set in tenant settings either DefaultProvider (random uuid) or a company specific provider which calls an external API endpoint.
   *
   */
  identification: Maybe<Scalars['String']>;
  /** Marks file record as deleted. */
  is_deleted: Scalars['Boolean'];
  /** An object relationship */
  last_modified_by_user: Maybe<User_Pp>;
  /** file last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified file. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** additional attributes */
  meta: Scalars['jsonb'];
  name: Maybe<Scalars['String']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['smallint']>;
  /** An object relationship */
  orgId: Maybe<Org_Id>;
  session_id: Scalars['String'];
};


/** File as collection of documents */
export type FileDeclaration_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


/** File as collection of documents */
export type FileDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** File as collection of documents */
export type FileDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** File as collection of documents */
export type FileFile_TasksArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


/** File as collection of documents */
export type FileFile_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


/** File as collection of documents */
export type FileMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Declaration request from liber. */
export type Declaration_Request = {
  acceptance_date: Maybe<Scalars['timestamptz']>;
  /** Account number in CH customs */
  account_number: Maybe<Scalars['String']>;
  /** An array relationship */
  addresses: Array<Declaration_Request_Address>;
  arrival_time: Maybe<Scalars['timestamptz']>;
  arrival_type: Maybe<Scalars['String']>;
  /** An object relationship */
  arrivalType: Maybe<Arrival_Type>;
  /** An array relationship */
  bill_details: Array<Bill_Detail>;
  cev_status: Maybe<Scalars['String']>;
  /** WeDeclare must create CH-Exportdeclaration */
  ch_exp_decl: Maybe<Scalars['Boolean']>;
  /** Refer to values in table clearance_type. */
  clearance_type: Scalars['String'];
  /** An object relationship */
  clearanceTypeByClearanceType: Clearance_Type;
  /** An object relationship */
  clientCompany: Maybe<Tenant>;
  /** Date of creation of declaration request. */
  creation_date: Scalars['timestamptz'];
  /** User created declaration request. */
  creation_user: Scalars['uuid'];
  customs_declaration_number: Maybe<Scalars['String']>;
  customs_declaration_version: Maybe<Scalars['smallint']>;
  /** An array relationship */
  customs_response_goods_items: Array<Customs_Response_Goods_Items>;
  /** An aggregate relationship */
  customs_response_goods_items_aggregate: Customs_Response_Goods_Items_Aggregate;
  /** An object relationship */
  customsOffices: Maybe<Customs_Offices>;
  /** An object relationship */
  customsResponseSummary: Maybe<Customs_Response_Summary>;
  /** An object relationship */
  declaration: Maybe<Declaration>;
  /** An array relationship */
  declaration_discussions: Array<Declaration_Discussion>;
  /** An aggregate relationship */
  declaration_discussions_aggregate: Declaration_Discussion_Aggregate;
  /** An array relationship */
  declaration_documents: Array<Declaration_Document>;
  /** An array relationship */
  declaration_request_addresses: Array<Declaration_Request_Address>;
  /** An array relationship */
  declaration_request_labels: Array<Declaration_Request_Labels>;
  /** Refer to values in table declaration_status. */
  declaration_status: Scalars['String'];
  /** Refer to values in table declaration_type. */
  declaration_type: Scalars['String'];
  /** An object relationship */
  declarationStatusByDeclarationStatus: Declaration_Status;
  /** An object relationship */
  declarationTypeByDeclarationType: Declaration_Type;
  /** Destination Tolldept Code */
  dest_tolldept_code: Maybe<Scalars['String']>;
  /** Destination Tolldept Name */
  dest_tolldept_name: Maybe<Scalars['String']>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  /** An array relationship */
  dr_goods_items: Array<Dr_Goods_Item>;
  /** An aggregate relationship */
  dr_goods_items_aggregate: Dr_Goods_Item_Aggregate;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no: Scalars['smallint'];
  edec: Maybe<Scalars['jsonb']>;
  eta: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  file: File;
  /** File related to declaration request. Part of primary key */
  file_id: Scalars['uuid'];
  /** WeDeclare must create the Import customs clearance in the destination Country */
  imp_cust_clr: Maybe<Scalars['Boolean']>;
  /** Service:  Standard  oder Express */
  is_express: Scalars['Boolean'];
  /** additional attributes */
  meta: Scalars['jsonb'];
  mrn_number: Maybe<Scalars['String']>;
  /** An object relationship */
  payer: Tenant;
  /** Who is paying for customs declaration (tenant) */
  payer_id: Scalars['uuid'];
  service_type: Maybe<Scalars['String']>;
  /** Customs office number. Refer to customs_office table.office_number. */
  toll_dep: Maybe<Scalars['String']>;
  /** Truck and Trailer Plate No. */
  tr_no: Maybe<Scalars['String']>;
  trader_reference: Maybe<Scalars['String']>;
  /** Type Transitdocument */
  transitdoc_type: Maybe<Scalars['transitdoc_type']>;
  /** An object relationship */
  user_pp: User_Pp;
  wa_number: Maybe<Scalars['String']>;
};


/** Declaration request from liber. */
export type Declaration_RequestAddressesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestBill_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Bill_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Detail_Order_By>>;
  where?: InputMaybe<Bill_Detail_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestCustoms_Response_Goods_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Goods_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Goods_Items_Order_By>>;
  where?: InputMaybe<Customs_Response_Goods_Items_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestCustoms_Response_Goods_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Goods_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Goods_Items_Order_By>>;
  where?: InputMaybe<Customs_Response_Goods_Items_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDeclaration_DiscussionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDeclaration_Discussions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDeclaration_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Document_Order_By>>;
  where?: InputMaybe<Declaration_Document_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDeclaration_Request_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDeclaration_Request_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDr_Goods_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Dr_Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Item_Order_By>>;
  where?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDr_Goods_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dr_Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Item_Order_By>>;
  where?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestEdecArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Declaration request from liber. */
export type Declaration_RequestMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "declaration_request_address" */
export enum Declaration_Request_Address_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Refs = 'refs',
  /** column name */
  SearchRefs = 'search_refs'
}

/** Ordering options when selecting data from "declaration_request_address". */
export type Declaration_Request_Address_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  declaration_request?: InputMaybe<Declaration_Request_Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  refs?: InputMaybe<Order_By>;
  search_refs?: InputMaybe<Order_By>;
};

/** columns and relationships of "declaration_request_address" */
export type Declaration_Request_Address = {
  /** An object relationship */
  address: Maybe<Address>;
  address_id: Maybe<Scalars['Int']>;
  address_type: Scalars['Int'];
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  /** An object relationship */
  declaration_request: Maybe<Declaration_Request>;
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  meta: Scalars['json'];
  refs: Scalars['_text'];
  search_refs: Maybe<Scalars['_text']>;
};


/** columns and relationships of "declaration_request_address" */
export type Declaration_Request_AddressMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "arrival_type" */
export type Arrival_Type = {
  arrival_type: Scalars['String'];
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  description: Maybe<Scalars['String']>;
  meta: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "arrival_type" */
export type Arrival_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "bill_detail" */
export enum Bill_Detail_Select_Column {
  /** column name */
  BillId = 'bill_id',
  /** column name */
  ChargedItems = 'charged_items',
  /** column name */
  ConstCharge = 'const_charge',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  DetailId = 'detail_id',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  SrvId = 'srv_id',
  /** column name */
  VarCharge = 'var_charge'
}

/** Ordering options when selecting data from "bill_detail". */
export type Bill_Detail_Order_By = {
  bill?: InputMaybe<Bill_Order_By>;
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  declaration_request?: InputMaybe<Declaration_Request_Order_By>;
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  service?: InputMaybe<Service_Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "bill". */
export type Bill_Order_By = {
  bill_details_aggregate?: InputMaybe<Bill_Detail_Aggregate_Order_By>;
  bill_id?: InputMaybe<Order_By>;
  bill_type?: InputMaybe<Order_By>;
  from_ts?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenant_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  to_ts?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "service". */
export type Service_Order_By = {
  service_rates_aggregate?: InputMaybe<Service_Rate_Aggregate_Order_By>;
  srv_desk?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  srv_type?: InputMaybe<Order_By>;
  translation?: InputMaybe<Order_By>;
};

/** columns and relationships of "bill_detail" */
export type Bill_Detail = {
  /** An object relationship */
  bill: Maybe<Bill>;
  bill_id: Maybe<Scalars['bigint']>;
  charged_items: Scalars['bigint'];
  const_charge: Scalars['numeric'];
  creation_date: Scalars['timestamptz'];
  /** An object relationship */
  declaration_request: Maybe<Declaration_Request>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id: Scalars['bigint'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  remark: Maybe<Scalars['String']>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence: Scalars['smallint'];
  /** An object relationship */
  service: Service;
  srv_id: Scalars['Int'];
  var_charge: Scalars['numeric'];
};

/** columns and relationships of "bill" */
export type Bill = {
  /** An array relationship */
  bill_details: Array<Bill_Detail>;
  bill_id: Scalars['bigint'];
  /**
   * type of bill, e.g.
   *  - regular - ordianry bill.
   * also might be
   *  - correction
   *  - account_close
   *
   */
  bill_type: Maybe<Scalars['name']>;
  from_ts: Maybe<Scalars['timestamptz']>;
  meta: Scalars['jsonb'];
  payment_terms: Maybe<Scalars['smallint']>;
  /** An object relationship */
  tenant: Maybe<Tenant>;
  tenant_id: Maybe<Scalars['uuid']>;
  to_ts: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "bill" */
export type BillBill_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Bill_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Detail_Order_By>>;
  where?: InputMaybe<Bill_Detail_Bool_Exp>;
};


/** columns and relationships of "bill" */
export type BillMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "service" */
export type Service = {
  /** An array relationship */
  service_rates: Array<Service_Rate>;
  srv_desk: Maybe<Scalars['String']>;
  srv_id: Scalars['Int'];
  srv_type: Maybe<Scalars['String']>;
  translation: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "service" */
export type ServiceService_RatesArgs = {
  distinct_on?: InputMaybe<Array<Service_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Rate_Order_By>>;
  where?: InputMaybe<Service_Rate_Bool_Exp>;
};


/** columns and relationships of "service" */
export type ServiceTranslationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "service_rate" */
export enum Service_Rate_Select_Column {
  /** column name */
  ConstIncluded = 'const_included',
  /** column name */
  ConstRate = 'const_rate',
  /** column name */
  SrvId = 'srv_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  VarRate = 'var_rate'
}

/** Ordering options when selecting data from "service_rate". */
export type Service_Rate_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  service?: InputMaybe<Service_Order_By>;
  srv_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** columns and relationships of "service_rate" */
export type Service_Rate = {
  const_included: Maybe<Scalars['Int']>;
  const_rate: Maybe<Scalars['numeric']>;
  /** An object relationship */
  service: Service;
  srv_id: Scalars['Int'];
  start_date: Scalars['date'];
  tenant_id: Scalars['uuid'];
  var_rate: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "clearance_type" */
export type Clearance_Type = {
  /** An array relationship */
  declaration_requests: Array<Declaration_Request>;
  name: Scalars['String'];
};


/** columns and relationships of "clearance_type" */
export type Clearance_TypeDeclaration_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};

/** select columns of table "declaration_request" */
export enum Declaration_Request_Select_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  ArrivalTime = 'arrival_time',
  /** column name */
  ArrivalType = 'arrival_type',
  /** column name */
  CevStatus = 'cev_status',
  /** column name */
  ChExpDecl = 'ch_exp_decl',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsDeclarationNumber = 'customs_declaration_number',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  DeclarationStatus = 'declaration_status',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DestTolldeptCode = 'dest_tolldept_code',
  /** column name */
  DestTolldeptName = 'dest_tolldept_name',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  Edec = 'edec',
  /** column name */
  Eta = 'eta',
  /** column name */
  FileId = 'file_id',
  /** column name */
  ImpCustClr = 'imp_cust_clr',
  /** column name */
  IsExpress = 'is_express',
  /** column name */
  Meta = 'meta',
  /** column name */
  MrnNumber = 'mrn_number',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  TollDep = 'toll_dep',
  /** column name */
  TrNo = 'tr_no',
  /** column name */
  TraderReference = 'trader_reference',
  /** column name */
  TransitdocType = 'transitdoc_type',
  /** column name */
  WaNumber = 'wa_number'
}

/** Ordering options when selecting data from "customs_response_goods_items". */
export type Customs_Response_Goods_Items_Order_By = {
  additional_unit?: InputMaybe<Order_By>;
  commercial_good?: InputMaybe<Order_By>;
  commodity_code?: InputMaybe<Order_By>;
  customs_clearance_type?: InputMaybe<Order_By>;
  customs_itemnumber?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  goods_item?: InputMaybe<Order_By>;
  grossmass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  origin?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  permit_obligation?: InputMaybe<Order_By>;
  preference?: InputMaybe<Order_By>;
  produced_document?: InputMaybe<Order_By>;
  statistic?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  valuation_details?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vatvalue?: InputMaybe<Order_By>;
};

/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_Items = {
  additional_unit: Maybe<Scalars['jsonb']>;
  commercial_good: Maybe<Scalars['String']>;
  commodity_code: Maybe<Scalars['jsonb']>;
  customs_clearance_type: Maybe<Scalars['String']>;
  customs_itemnumber: Maybe<Scalars['jsonb']>;
  description: Maybe<Scalars['jsonb']>;
  doc_id: Maybe<Scalars['uuid']>;
  document_type: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  duty_total: Maybe<Scalars['String']>;
  file_id: Maybe<Scalars['uuid']>;
  goods_item: Maybe<Scalars['jsonb']>;
  grossmass: Maybe<Scalars['jsonb']>;
  net_mass: Maybe<Scalars['jsonb']>;
  non_customs_law_obligation: Maybe<Scalars['jsonb']>;
  origin: Maybe<Scalars['jsonb']>;
  origin_country: Maybe<Scalars['String']>;
  packaging: Maybe<Scalars['jsonb']>;
  permit_obligation: Maybe<Scalars['jsonb']>;
  preference: Maybe<Scalars['String']>;
  produced_document: Maybe<Scalars['jsonb']>;
  statistic: Maybe<Scalars['jsonb']>;
  statistical_code: Maybe<Scalars['jsonb']>;
  statistical_value: Maybe<Scalars['String']>;
  valuation_details: Maybe<Scalars['jsonb']>;
  value: Maybe<Scalars['jsonb']>;
  vat_total: Maybe<Scalars['String']>;
  vatvalue: Maybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsAdditional_UnitArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsCommodity_CodeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsCustoms_ItemnumberArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsDescriptionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsGoods_ItemArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsGrossmassArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsNet_MassArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsNon_Customs_Law_ObligationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsOriginArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsPackagingArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsPermit_ObligationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsProduced_DocumentArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsStatisticArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsStatistical_CodeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsValuation_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_goods_items" */
export type Customs_Response_Goods_ItemsValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Aggregate = {
  aggregate: Maybe<Customs_Response_Goods_Items_Aggregate_Fields>;
  nodes: Array<Customs_Response_Goods_Items>;
};

/** aggregate fields of "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Aggregate_Fields = {
  avg: Maybe<Customs_Response_Goods_Items_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Customs_Response_Goods_Items_Max_Fields>;
  min: Maybe<Customs_Response_Goods_Items_Min_Fields>;
  stddev: Maybe<Customs_Response_Goods_Items_Stddev_Fields>;
  stddev_pop: Maybe<Customs_Response_Goods_Items_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Customs_Response_Goods_Items_Stddev_Samp_Fields>;
  sum: Maybe<Customs_Response_Goods_Items_Sum_Fields>;
  var_pop: Maybe<Customs_Response_Goods_Items_Var_Pop_Fields>;
  var_samp: Maybe<Customs_Response_Goods_Items_Var_Samp_Fields>;
  variance: Maybe<Customs_Response_Goods_Items_Variance_Fields>;
};


/** aggregate fields of "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customs_Response_Goods_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Customs_Response_Goods_Items_Avg_Fields = {
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Customs_Response_Goods_Items_Max_Fields = {
  commercial_good: Maybe<Scalars['String']>;
  customs_clearance_type: Maybe<Scalars['String']>;
  doc_id: Maybe<Scalars['uuid']>;
  document_type: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  duty_total: Maybe<Scalars['String']>;
  file_id: Maybe<Scalars['uuid']>;
  origin_country: Maybe<Scalars['String']>;
  preference: Maybe<Scalars['String']>;
  statistical_value: Maybe<Scalars['String']>;
  vat_total: Maybe<Scalars['String']>;
  vatvalue: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Customs_Response_Goods_Items_Min_Fields = {
  commercial_good: Maybe<Scalars['String']>;
  customs_clearance_type: Maybe<Scalars['String']>;
  doc_id: Maybe<Scalars['uuid']>;
  document_type: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  duty_total: Maybe<Scalars['String']>;
  file_id: Maybe<Scalars['uuid']>;
  origin_country: Maybe<Scalars['String']>;
  preference: Maybe<Scalars['String']>;
  statistical_value: Maybe<Scalars['String']>;
  vat_total: Maybe<Scalars['String']>;
  vatvalue: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Customs_Response_Goods_Items_Stddev_Fields = {
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Customs_Response_Goods_Items_Stddev_Pop_Fields = {
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Customs_Response_Goods_Items_Stddev_Samp_Fields = {
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Customs_Response_Goods_Items_Sum_Fields = {
  dr_no: Maybe<Scalars['smallint']>;
};

/** aggregate var_pop on columns */
export type Customs_Response_Goods_Items_Var_Pop_Fields = {
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Customs_Response_Goods_Items_Var_Samp_Fields = {
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Customs_Response_Goods_Items_Variance_Fields = {
  dr_no: Maybe<Scalars['Float']>;
};

/** Customs offices actual for today */
export type Customs_Offices = {
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  office_number: Scalars['String'];
  prefix: Maybe<Scalars['String']>;
  valid_from: Scalars['timestamptz'];
  valid_to: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "customs_response_summary" */
export type Customs_Response_Summary = {
  acceptance_date: Maybe<Scalars['String']>;
  acceptance_dates: Maybe<Scalars['_timestamp']>;
  acceptance_time: Maybe<Scalars['String']>;
  consignee: Maybe<Scalars['jsonb']>;
  consignor: Maybe<Scalars['String']>;
  customs_account: Maybe<Scalars['jsonb']>;
  customs_clearance_type: Maybe<Scalars['numeric']>;
  customs_clearance_type_de: Maybe<Scalars['String']>;
  customs_clearance_type_en: Maybe<Scalars['String']>;
  customs_office: Maybe<Scalars['jsonb']>;
  declarant: Maybe<Scalars['jsonb']>;
  declaration_type: Maybe<Scalars['String']>;
  declaration_type_de: Maybe<Scalars['String']>;
  declaration_type_en: Maybe<Scalars['String']>;
  dispatch_country: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  duty_and_additional_taxes: Maybe<Scalars['jsonb']>;
  file_id: Maybe<Scalars['uuid']>;
  gross_mass: Maybe<Scalars['numeric']>;
  importer: Maybe<Scalars['jsonb']>;
  incoterms: Maybe<Scalars['String']>;
  invoice_currency_type: Maybe<Scalars['String']>;
  number_of_goods_items: Maybe<Scalars['bigint']>;
  packaging_quantity: Maybe<Scalars['numeric']>;
  previous_document: Maybe<Scalars['jsonb']>;
  special_mention: Maybe<Scalars['jsonb']>;
  src_docs: Maybe<Scalars['_uuid']>;
  src_doctypes: Maybe<Scalars['_text']>;
  trader_declaration_number: Maybe<Scalars['String']>;
  trader_identification_number: Maybe<Scalars['String']>;
  traderreference: Maybe<Scalars['String']>;
  transport_means: Maybe<Scalars['jsonb']>;
  valuation_summary: Maybe<Scalars['jsonb']>;
  vat: Maybe<Scalars['jsonb']>;
  vat_account: Maybe<Scalars['jsonb']>;
  vatnumber: Maybe<Scalars['String']>;
  vatvalue: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "customs_response_summary" */
export type Customs_Response_SummaryConsigneeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_summary" */
export type Customs_Response_SummaryCustoms_AccountArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_summary" */
export type Customs_Response_SummaryCustoms_OfficeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_summary" */
export type Customs_Response_SummaryDeclarantArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_summary" */
export type Customs_Response_SummaryDuty_And_Additional_TaxesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_summary" */
export type Customs_Response_SummaryImporterArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_summary" */
export type Customs_Response_SummaryPrevious_DocumentArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_summary" */
export type Customs_Response_SummarySpecial_MentionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_summary" */
export type Customs_Response_SummaryTransport_MeansArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_summary" */
export type Customs_Response_SummaryValuation_SummaryArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_summary" */
export type Customs_Response_SummaryVatArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_summary" */
export type Customs_Response_SummaryVat_AccountArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "declaration" */
export type Declaration = {
  acceptance_date: Maybe<Scalars['timestamptz']>;
  access_code: Maybe<Scalars['String']>;
  /** An array relationship */
  addresses: Array<Declaration_Request_Address>;
  agreed_location_of_goods: Maybe<Scalars['String']>;
  ai_confirmed: Maybe<Scalars['Boolean']>;
  ai_results: Scalars['jsonb'];
  border_eau_number: Maybe<Scalars['numeric']>;
  bunch_number: Maybe<Scalars['Int']>;
  change_information: Maybe<Scalars['date']>;
  clearance_location: Maybe<Scalars['smallint']>;
  company_number_taxpayer: Maybe<Scalars['String']>;
  /** An array relationship */
  containers: Array<Containers>;
  correction_code: Maybe<Scalars['Int']>;
  correction_reason: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  customs_account_address_type: Maybe<Scalars['Int']>;
  customs_account_name: Maybe<Scalars['String']>;
  customs_account_number: Maybe<Scalars['bigint']>;
  customs_declaration_number: Maybe<Scalars['String']>;
  customs_declaration_version: Maybe<Scalars['Int']>;
  customs_office_number: Maybe<Scalars['String']>;
  declarant_company_name: Maybe<Scalars['String']>;
  declarant_number: Maybe<Scalars['Int']>;
  /** An object relationship */
  declaration_request: Maybe<Declaration_Request>;
  /** An array relationship */
  declaration_special_mentions: Array<Declaration_Special_Mentions>;
  declaration_time: Maybe<Scalars['smallint']>;
  declaration_type: Maybe<Scalars['String']>;
  delivery_destination: Maybe<Scalars['bpchar']>;
  dispatch_country: Maybe<Scalars['String']>;
  dispatch_country_confirmation: Maybe<Scalars['Boolean']>;
  dr_no: Scalars['smallint'];
  duty_and_other_taxes_amount: Maybe<Scalars['numeric']>;
  duty_total_amount: Maybe<Scalars['numeric']>;
  evv_confirmed: Scalars['Boolean'];
  evv_received: Scalars['Boolean'];
  /** An object relationship */
  file: File;
  file_id: Scalars['uuid'];
  /** An array relationship */
  goods_items: Array<Goods_Item>;
  /** An aggregate relationship */
  goods_items_aggregate: Goods_Item_Aggregate;
  gross_mass: Maybe<Scalars['numeric']>;
  incoterms: Maybe<Scalars['String']>;
  initiator: Maybe<Scalars['smallint']>;
  injunction_type: Maybe<Scalars['smallint']>;
  inspection_code: Maybe<Scalars['Boolean']>;
  invoice_currency_type: Maybe<Scalars['String']>;
  lang: Maybe<Scalars['String']>;
  material_check: Maybe<Scalars['Boolean']>;
  net_mass: Maybe<Scalars['numeric']>;
  packaging_quantity: Maybe<Scalars['Int']>;
  payer_id: Maybe<Scalars['uuid']>;
  place_of_loading: Maybe<Scalars['String']>;
  place_of_unloading: Maybe<Scalars['String']>;
  postal_shipment_type: Maybe<Scalars['String']>;
  /** An array relationship */
  previous_documents: Array<Previous_Documents>;
  procedure_type: Maybe<Scalars['smallint']>;
  provisional_declaration_expiration_date: Maybe<Scalars['date']>;
  reason: Maybe<Scalars['String']>;
  receive_status: Maybe<Scalars['Int']>;
  release: Maybe<Scalars['Boolean']>;
  requestor_trader_identification_number: Maybe<Scalars['String']>;
  security: Maybe<Scalars['Boolean']>;
  selection_correlation_id: Maybe<Scalars['String']>;
  send_date: Maybe<Scalars['timestamptz']>;
  send_status: Maybe<Scalars['Int']>;
  service_type: Maybe<Scalars['String']>;
  show_in_wd: Maybe<Scalars['Boolean']>;
  specific_circumstance_indicator: Maybe<Scalars['bpchar']>;
  status: Maybe<Scalars['Int']>;
  status_date: Maybe<Scalars['date']>;
  status_time: Maybe<Scalars['time']>;
  tara_factor: Maybe<Scalars['numeric']>;
  total_colis: Maybe<Scalars['Int']>;
  total_goods_items: Maybe<Scalars['Int']>;
  total_gross_weight: Maybe<Scalars['numeric']>;
  total_vat_value: Maybe<Scalars['numeric']>;
  trader_declaration_number: Maybe<Scalars['String']>;
  trader_identification_number: Maybe<Scalars['String']>;
  trader_reference: Maybe<Scalars['String']>;
  transfer_to_transit_system: Maybe<Scalars['Boolean']>;
  transport_country: Maybe<Scalars['String']>;
  transport_in_container: Maybe<Scalars['Boolean']>;
  transport_mode: Maybe<Scalars['Int']>;
  transport_number: Maybe<Scalars['String']>;
  transport_type: Maybe<Scalars['String']>;
  unique_consignment_reference_number: Maybe<Scalars['String']>;
  vat_account_address_type: Maybe<Scalars['Int']>;
  vat_account_name: Maybe<Scalars['String']>;
  vat_account_number: Maybe<Scalars['bigint']>;
  vat_number: Maybe<Scalars['String']>;
  vat_suffix: Maybe<Scalars['Boolean']>;
  vat_total_amount: Maybe<Scalars['numeric']>;
  warehouse_coded: Maybe<Scalars['smallint']>;
};


/** columns and relationships of "declaration" */
export type DeclarationAddressesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


/** columns and relationships of "declaration" */
export type DeclarationAi_ResultsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "declaration" */
export type DeclarationContainersArgs = {
  distinct_on?: InputMaybe<Array<Containers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Containers_Order_By>>;
  where?: InputMaybe<Containers_Bool_Exp>;
};


/** columns and relationships of "declaration" */
export type DeclarationDeclaration_Special_MentionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Special_Mentions_Order_By>>;
  where?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
};


/** columns and relationships of "declaration" */
export type DeclarationGoods_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Order_By>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


/** columns and relationships of "declaration" */
export type DeclarationGoods_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Order_By>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


/** columns and relationships of "declaration" */
export type DeclarationPrevious_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Previous_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Previous_Documents_Order_By>>;
  where?: InputMaybe<Previous_Documents_Bool_Exp>;
};

/** select columns of table "containers" */
export enum Containers_Select_Column {
  /** column name */
  ContainerNumber = 'container_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id'
}

/** Ordering options when selecting data from "containers". */
export type Containers_Order_By = {
  container_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "containers" */
export type Containers = {
  container_number: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
};

/** select columns of table "declaration_special_mentions" */
export enum Declaration_Special_Mentions_Select_Column {
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  SequenceNumber = 'sequence_number',
  /** column name */
  Text = 'text'
}

/** Ordering options when selecting data from "declaration_special_mentions". */
export type Declaration_Special_Mentions_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** columns and relationships of "declaration_special_mentions" */
export type Declaration_Special_Mentions = {
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
  sequence_number: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "goods_item". */
export type Goods_Item_Order_By = {
  additional_unit?: InputMaybe<Order_By>;
  additional_unit_confirmation?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  commercial_good?: InputMaybe<Order_By>;
  commodity_code?: InputMaybe<Order_By>;
  commodity_code_confirmation?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  declaration_request?: InputMaybe<Declaration_Request_Order_By>;
  description?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  goods_item_special_mentions_aggregate?: InputMaybe<Goods_Item_Special_Mentions_Aggregate_Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  gross_mass_confirmation?: InputMaybe<Order_By>;
  net_duty?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  net_mass_confirmation?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  origin_preference?: InputMaybe<Order_By>;
  packagings_aggregate?: InputMaybe<Packagings_Aggregate_Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  permits_aggregate?: InputMaybe<Permits_Aggregate_Order_By>;
  preference_confirmation?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  produced_documents_aggregate?: InputMaybe<Produced_Documents_Aggregate_Order_By>;
  rate_confirmation?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  repair?: InputMaybe<Order_By>;
  repair_reason?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  statistical_value_confirmation?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  tare_supplement_confirmation?: InputMaybe<Order_By>;
  un_dangerous_goods_code?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_code_confirmation?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  vat_value_confirmation?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Aggregate_Order_By = {
  avg?: InputMaybe<Goods_Item_Special_Mentions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Goods_Item_Special_Mentions_Max_Order_By>;
  min?: InputMaybe<Goods_Item_Special_Mentions_Min_Order_By>;
  stddev?: InputMaybe<Goods_Item_Special_Mentions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Goods_Item_Special_Mentions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Goods_Item_Special_Mentions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Goods_Item_Special_Mentions_Sum_Order_By>;
  var_pop?: InputMaybe<Goods_Item_Special_Mentions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Goods_Item_Special_Mentions_Var_Samp_Order_By>;
  variance?: InputMaybe<Goods_Item_Special_Mentions_Variance_Order_By>;
};

/** order by avg() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Avg_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Max_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Min_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Stddev_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Stddev_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Stddev_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Sum_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Var_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Var_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Variance_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "packagings" */
export type Packagings_Aggregate_Order_By = {
  avg?: InputMaybe<Packagings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Packagings_Max_Order_By>;
  min?: InputMaybe<Packagings_Min_Order_By>;
  stddev?: InputMaybe<Packagings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Packagings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Packagings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Packagings_Sum_Order_By>;
  var_pop?: InputMaybe<Packagings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Packagings_Var_Samp_Order_By>;
  variance?: InputMaybe<Packagings_Variance_Order_By>;
};

/** order by avg() on columns of table "packagings" */
export type Packagings_Avg_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "packagings" */
export type Packagings_Max_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
  packaging_reference_number?: InputMaybe<Order_By>;
  packaging_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "packagings" */
export type Packagings_Min_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
  packaging_reference_number?: InputMaybe<Order_By>;
  packaging_type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "packagings" */
export type Packagings_Stddev_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "packagings" */
export type Packagings_Stddev_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "packagings" */
export type Packagings_Stddev_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "packagings" */
export type Packagings_Sum_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "packagings" */
export type Packagings_Var_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "packagings" */
export type Packagings_Var_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "packagings" */
export type Packagings_Variance_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "permits" */
export type Permits_Aggregate_Order_By = {
  avg?: InputMaybe<Permits_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Permits_Max_Order_By>;
  min?: InputMaybe<Permits_Min_Order_By>;
  stddev?: InputMaybe<Permits_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Permits_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Permits_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Permits_Sum_Order_By>;
  var_pop?: InputMaybe<Permits_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Permits_Var_Samp_Order_By>;
  variance?: InputMaybe<Permits_Variance_Order_By>;
};

/** order by avg() on columns of table "permits" */
export type Permits_Avg_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "permits" */
export type Permits_Max_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_number?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "permits" */
export type Permits_Min_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_number?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "permits" */
export type Permits_Stddev_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "permits" */
export type Permits_Stddev_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "permits" */
export type Permits_Stddev_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "permits" */
export type Permits_Sum_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "permits" */
export type Permits_Var_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "permits" */
export type Permits_Var_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "permits" */
export type Permits_Variance_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "produced_documents" */
export type Produced_Documents_Aggregate_Order_By = {
  avg?: InputMaybe<Produced_Documents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Produced_Documents_Max_Order_By>;
  min?: InputMaybe<Produced_Documents_Min_Order_By>;
  stddev?: InputMaybe<Produced_Documents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Produced_Documents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Produced_Documents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Produced_Documents_Sum_Order_By>;
  var_pop?: InputMaybe<Produced_Documents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Produced_Documents_Var_Samp_Order_By>;
  variance?: InputMaybe<Produced_Documents_Variance_Order_By>;
};

/** order by avg() on columns of table "produced_documents" */
export type Produced_Documents_Avg_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "produced_documents" */
export type Produced_Documents_Max_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  produced_document_issue_date?: InputMaybe<Order_By>;
  produced_document_reference_number?: InputMaybe<Order_By>;
  produced_document_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "produced_documents" */
export type Produced_Documents_Min_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  produced_document_issue_date?: InputMaybe<Order_By>;
  produced_document_reference_number?: InputMaybe<Order_By>;
  produced_document_type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "produced_documents" */
export type Produced_Documents_Stddev_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "produced_documents" */
export type Produced_Documents_Stddev_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "produced_documents" */
export type Produced_Documents_Stddev_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "produced_documents" */
export type Produced_Documents_Sum_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "produced_documents" */
export type Produced_Documents_Var_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "produced_documents" */
export type Produced_Documents_Var_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "produced_documents" */
export type Produced_Documents_Variance_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "goods_item" */
export type Goods_Item = {
  additional_unit: Maybe<Scalars['String']>;
  additional_unit_confirmation: Maybe<Scalars['Boolean']>;
  billing_type: Maybe<Scalars['smallint']>;
  clearance_type: Maybe<Scalars['Int']>;
  commercial_good: Maybe<Scalars['Boolean']>;
  commodity_code: Maybe<Scalars['String']>;
  commodity_code_confirmation: Maybe<Scalars['Boolean']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  customs_declaration_version: Maybe<Scalars['Int']>;
  customs_favour_code: Maybe<Scalars['Int']>;
  customs_item_number: Scalars['Int'];
  customs_net_weight: Maybe<Scalars['numeric']>;
  /** An object relationship */
  declaration_request: Maybe<Declaration_Request>;
  description: Maybe<Scalars['String']>;
  direction: Maybe<Scalars['smallint']>;
  dr_no: Scalars['smallint'];
  duty_and_other_taxes_total: Maybe<Scalars['numeric']>;
  duty_rate: Maybe<Scalars['numeric']>;
  duty_total: Maybe<Scalars['numeric']>;
  file_id: Scalars['uuid'];
  /** An array relationship */
  goods_item_special_mentions: Array<Goods_Item_Special_Mentions>;
  /** An aggregate relationship */
  goods_item_special_mentions_aggregate: Goods_Item_Special_Mentions_Aggregate;
  gross_mass: Maybe<Scalars['numeric']>;
  gross_mass_confirmation: Maybe<Scalars['Boolean']>;
  net_duty: Maybe<Scalars['Boolean']>;
  net_mass: Maybe<Scalars['numeric']>;
  net_mass_confirmation: Maybe<Scalars['Boolean']>;
  non_customs_law_obligation: Maybe<Scalars['smallint']>;
  origin_country: Maybe<Scalars['String']>;
  origin_preference: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  packagings: Array<Packagings>;
  /** An aggregate relationship */
  packagings_aggregate: Packagings_Aggregate;
  permit_obligation_code: Maybe<Scalars['Int']>;
  /** An array relationship */
  permits: Array<Permits>;
  /** An aggregate relationship */
  permits_aggregate: Permits_Aggregate;
  preference_confirmation: Maybe<Scalars['Boolean']>;
  process_type: Maybe<Scalars['smallint']>;
  /** An array relationship */
  produced_documents: Array<Produced_Documents>;
  /** An aggregate relationship */
  produced_documents_aggregate: Produced_Documents_Aggregate;
  rate_confirmation: Maybe<Scalars['Boolean']>;
  refinement_type: Maybe<Scalars['smallint']>;
  refund_type: Maybe<Scalars['smallint']>;
  repair: Maybe<Scalars['Boolean']>;
  repair_reason: Maybe<Scalars['String']>;
  selection_result: Maybe<Scalars['Int']>;
  statistical_code: Maybe<Scalars['Int']>;
  statistical_value: Maybe<Scalars['Int']>;
  statistical_value_confirmation: Maybe<Scalars['Boolean']>;
  storage_type: Maybe<Scalars['smallint']>;
  tare_supplement: Maybe<Scalars['numeric']>;
  tare_supplement_confirmation: Maybe<Scalars['Boolean']>;
  un_dangerous_goods_code: Maybe<Scalars['String']>;
  vat_code: Maybe<Scalars['smallint']>;
  vat_code_confirmation: Maybe<Scalars['Boolean']>;
  vat_rate: Maybe<Scalars['numeric']>;
  vat_total: Maybe<Scalars['numeric']>;
  vat_value: Maybe<Scalars['numeric']>;
  vat_value_confirmation: Maybe<Scalars['Boolean']>;
  voc_quantity: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemGoods_Item_Special_MentionsArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Special_Mentions_Order_By>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemGoods_Item_Special_Mentions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Special_Mentions_Order_By>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemPackagingsArgs = {
  distinct_on?: InputMaybe<Array<Packagings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packagings_Order_By>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemPackagings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packagings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packagings_Order_By>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemPermitsArgs = {
  distinct_on?: InputMaybe<Array<Permits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permits_Order_By>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemPermits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permits_Order_By>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemProduced_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produced_Documents_Order_By>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemProduced_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produced_Documents_Order_By>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "goods_item_special_mentions". */
export type Goods_Item_Special_Mentions_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** columns and relationships of "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
  sequence_number: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
};

/** aggregated selection of "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Aggregate = {
  aggregate: Maybe<Goods_Item_Special_Mentions_Aggregate_Fields>;
  nodes: Array<Goods_Item_Special_Mentions>;
};

/** aggregate fields of "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Aggregate_Fields = {
  avg: Maybe<Goods_Item_Special_Mentions_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Goods_Item_Special_Mentions_Max_Fields>;
  min: Maybe<Goods_Item_Special_Mentions_Min_Fields>;
  stddev: Maybe<Goods_Item_Special_Mentions_Stddev_Fields>;
  stddev_pop: Maybe<Goods_Item_Special_Mentions_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Goods_Item_Special_Mentions_Stddev_Samp_Fields>;
  sum: Maybe<Goods_Item_Special_Mentions_Sum_Fields>;
  var_pop: Maybe<Goods_Item_Special_Mentions_Var_Pop_Fields>;
  var_samp: Maybe<Goods_Item_Special_Mentions_Var_Samp_Fields>;
  variance: Maybe<Goods_Item_Special_Mentions_Variance_Fields>;
};


/** aggregate fields of "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Goods_Item_Special_Mentions_Avg_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Goods_Item_Special_Mentions_Max_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  sequence_number: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Goods_Item_Special_Mentions_Min_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  sequence_number: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Goods_Item_Special_Mentions_Stddev_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Goods_Item_Special_Mentions_Stddev_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Goods_Item_Special_Mentions_Stddev_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Goods_Item_Special_Mentions_Sum_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  id: Maybe<Scalars['Int']>;
  sequence_number: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Goods_Item_Special_Mentions_Var_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Goods_Item_Special_Mentions_Var_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Goods_Item_Special_Mentions_Variance_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** Ordering options when selecting data from "packagings". */
export type Packagings_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
  packaging_reference_number?: InputMaybe<Order_By>;
  packaging_type?: InputMaybe<Order_By>;
};

/** columns and relationships of "packagings" */
export type Packagings = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
  packaging_quantity: Maybe<Scalars['Int']>;
  packaging_reference_number: Maybe<Scalars['String']>;
  packaging_type: Maybe<Scalars['String']>;
};

/** aggregated selection of "packagings" */
export type Packagings_Aggregate = {
  aggregate: Maybe<Packagings_Aggregate_Fields>;
  nodes: Array<Packagings>;
};

/** aggregate fields of "packagings" */
export type Packagings_Aggregate_Fields = {
  avg: Maybe<Packagings_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Packagings_Max_Fields>;
  min: Maybe<Packagings_Min_Fields>;
  stddev: Maybe<Packagings_Stddev_Fields>;
  stddev_pop: Maybe<Packagings_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Packagings_Stddev_Samp_Fields>;
  sum: Maybe<Packagings_Sum_Fields>;
  var_pop: Maybe<Packagings_Var_Pop_Fields>;
  var_samp: Maybe<Packagings_Var_Samp_Fields>;
  variance: Maybe<Packagings_Variance_Fields>;
};


/** aggregate fields of "packagings" */
export type Packagings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Packagings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Packagings_Avg_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Packagings_Max_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  packaging_quantity: Maybe<Scalars['Int']>;
  packaging_reference_number: Maybe<Scalars['String']>;
  packaging_type: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Packagings_Min_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  packaging_quantity: Maybe<Scalars['Int']>;
  packaging_reference_number: Maybe<Scalars['String']>;
  packaging_type: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Packagings_Stddev_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Packagings_Stddev_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Packagings_Stddev_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Packagings_Sum_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  id: Maybe<Scalars['Int']>;
  packaging_quantity: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Packagings_Var_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Packagings_Var_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Packagings_Variance_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** Ordering options when selecting data from "permits". */
export type Permits_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_item_details?: InputMaybe<Order_By>;
  permit_number?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** columns and relationships of "permits" */
export type Permits = {
  additional_information: Maybe<Scalars['String']>;
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
  issue_date: Maybe<Scalars['date']>;
  permit_authority: Maybe<Scalars['Int']>;
  permit_item_details: Maybe<Scalars['jsonb']>;
  permit_number: Maybe<Scalars['String']>;
  permit_type: Maybe<Scalars['Int']>;
};


/** columns and relationships of "permits" */
export type PermitsPermit_Item_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "permits" */
export type Permits_Aggregate = {
  aggregate: Maybe<Permits_Aggregate_Fields>;
  nodes: Array<Permits>;
};

/** aggregate fields of "permits" */
export type Permits_Aggregate_Fields = {
  avg: Maybe<Permits_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Permits_Max_Fields>;
  min: Maybe<Permits_Min_Fields>;
  stddev: Maybe<Permits_Stddev_Fields>;
  stddev_pop: Maybe<Permits_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Permits_Stddev_Samp_Fields>;
  sum: Maybe<Permits_Sum_Fields>;
  var_pop: Maybe<Permits_Var_Pop_Fields>;
  var_samp: Maybe<Permits_Var_Samp_Fields>;
  variance: Maybe<Permits_Variance_Fields>;
};


/** aggregate fields of "permits" */
export type Permits_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Permits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Permits_Avg_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Permits_Max_Fields = {
  additional_information: Maybe<Scalars['String']>;
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  issue_date: Maybe<Scalars['date']>;
  permit_authority: Maybe<Scalars['Int']>;
  permit_number: Maybe<Scalars['String']>;
  permit_type: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Permits_Min_Fields = {
  additional_information: Maybe<Scalars['String']>;
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  issue_date: Maybe<Scalars['date']>;
  permit_authority: Maybe<Scalars['Int']>;
  permit_number: Maybe<Scalars['String']>;
  permit_type: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Permits_Stddev_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Permits_Stddev_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Permits_Stddev_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Permits_Sum_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  id: Maybe<Scalars['Int']>;
  permit_authority: Maybe<Scalars['Int']>;
  permit_type: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Permits_Var_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Permits_Var_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Permits_Variance_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** Ordering options when selecting data from "produced_documents". */
export type Produced_Documents_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  produced_document_issue_date?: InputMaybe<Order_By>;
  produced_document_reference_number?: InputMaybe<Order_By>;
  produced_document_type?: InputMaybe<Order_By>;
};

/** columns and relationships of "produced_documents" */
export type Produced_Documents = {
  additional_information: Maybe<Scalars['String']>;
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
  produced_document_issue_date: Maybe<Scalars['date']>;
  produced_document_reference_number: Maybe<Scalars['String']>;
  produced_document_type: Maybe<Scalars['String']>;
};

/** aggregated selection of "produced_documents" */
export type Produced_Documents_Aggregate = {
  aggregate: Maybe<Produced_Documents_Aggregate_Fields>;
  nodes: Array<Produced_Documents>;
};

/** aggregate fields of "produced_documents" */
export type Produced_Documents_Aggregate_Fields = {
  avg: Maybe<Produced_Documents_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Produced_Documents_Max_Fields>;
  min: Maybe<Produced_Documents_Min_Fields>;
  stddev: Maybe<Produced_Documents_Stddev_Fields>;
  stddev_pop: Maybe<Produced_Documents_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Produced_Documents_Stddev_Samp_Fields>;
  sum: Maybe<Produced_Documents_Sum_Fields>;
  var_pop: Maybe<Produced_Documents_Var_Pop_Fields>;
  var_samp: Maybe<Produced_Documents_Var_Samp_Fields>;
  variance: Maybe<Produced_Documents_Variance_Fields>;
};


/** aggregate fields of "produced_documents" */
export type Produced_Documents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Produced_Documents_Avg_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Produced_Documents_Max_Fields = {
  additional_information: Maybe<Scalars['String']>;
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  produced_document_issue_date: Maybe<Scalars['date']>;
  produced_document_reference_number: Maybe<Scalars['String']>;
  produced_document_type: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Produced_Documents_Min_Fields = {
  additional_information: Maybe<Scalars['String']>;
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  produced_document_issue_date: Maybe<Scalars['date']>;
  produced_document_reference_number: Maybe<Scalars['String']>;
  produced_document_type: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Produced_Documents_Stddev_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Produced_Documents_Stddev_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Produced_Documents_Stddev_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Produced_Documents_Sum_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  id: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Produced_Documents_Var_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Produced_Documents_Var_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Produced_Documents_Variance_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregated selection of "goods_item" */
export type Goods_Item_Aggregate = {
  aggregate: Maybe<Goods_Item_Aggregate_Fields>;
  nodes: Array<Goods_Item>;
};

/** aggregate fields of "goods_item" */
export type Goods_Item_Aggregate_Fields = {
  avg: Maybe<Goods_Item_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Goods_Item_Max_Fields>;
  min: Maybe<Goods_Item_Min_Fields>;
  stddev: Maybe<Goods_Item_Stddev_Fields>;
  stddev_pop: Maybe<Goods_Item_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Goods_Item_Stddev_Samp_Fields>;
  sum: Maybe<Goods_Item_Sum_Fields>;
  var_pop: Maybe<Goods_Item_Var_Pop_Fields>;
  var_samp: Maybe<Goods_Item_Var_Samp_Fields>;
  variance: Maybe<Goods_Item_Variance_Fields>;
};


/** aggregate fields of "goods_item" */
export type Goods_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Goods_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Goods_Item_Avg_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Goods_Item_Max_Fields = {
  additional_unit: Maybe<Scalars['String']>;
  billing_type: Maybe<Scalars['smallint']>;
  clearance_type: Maybe<Scalars['Int']>;
  commodity_code: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  customs_declaration_version: Maybe<Scalars['Int']>;
  customs_favour_code: Maybe<Scalars['Int']>;
  customs_item_number: Maybe<Scalars['Int']>;
  customs_net_weight: Maybe<Scalars['numeric']>;
  description: Maybe<Scalars['String']>;
  direction: Maybe<Scalars['smallint']>;
  dr_no: Maybe<Scalars['smallint']>;
  duty_and_other_taxes_total: Maybe<Scalars['numeric']>;
  duty_rate: Maybe<Scalars['numeric']>;
  duty_total: Maybe<Scalars['numeric']>;
  file_id: Maybe<Scalars['uuid']>;
  gross_mass: Maybe<Scalars['numeric']>;
  net_mass: Maybe<Scalars['numeric']>;
  non_customs_law_obligation: Maybe<Scalars['smallint']>;
  origin_country: Maybe<Scalars['String']>;
  permit_obligation_code: Maybe<Scalars['Int']>;
  process_type: Maybe<Scalars['smallint']>;
  refinement_type: Maybe<Scalars['smallint']>;
  refund_type: Maybe<Scalars['smallint']>;
  repair_reason: Maybe<Scalars['String']>;
  selection_result: Maybe<Scalars['Int']>;
  statistical_code: Maybe<Scalars['Int']>;
  statistical_value: Maybe<Scalars['Int']>;
  storage_type: Maybe<Scalars['smallint']>;
  tare_supplement: Maybe<Scalars['numeric']>;
  un_dangerous_goods_code: Maybe<Scalars['String']>;
  vat_code: Maybe<Scalars['smallint']>;
  vat_rate: Maybe<Scalars['numeric']>;
  vat_total: Maybe<Scalars['numeric']>;
  vat_value: Maybe<Scalars['numeric']>;
  voc_quantity: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Goods_Item_Min_Fields = {
  additional_unit: Maybe<Scalars['String']>;
  billing_type: Maybe<Scalars['smallint']>;
  clearance_type: Maybe<Scalars['Int']>;
  commodity_code: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  customs_declaration_version: Maybe<Scalars['Int']>;
  customs_favour_code: Maybe<Scalars['Int']>;
  customs_item_number: Maybe<Scalars['Int']>;
  customs_net_weight: Maybe<Scalars['numeric']>;
  description: Maybe<Scalars['String']>;
  direction: Maybe<Scalars['smallint']>;
  dr_no: Maybe<Scalars['smallint']>;
  duty_and_other_taxes_total: Maybe<Scalars['numeric']>;
  duty_rate: Maybe<Scalars['numeric']>;
  duty_total: Maybe<Scalars['numeric']>;
  file_id: Maybe<Scalars['uuid']>;
  gross_mass: Maybe<Scalars['numeric']>;
  net_mass: Maybe<Scalars['numeric']>;
  non_customs_law_obligation: Maybe<Scalars['smallint']>;
  origin_country: Maybe<Scalars['String']>;
  permit_obligation_code: Maybe<Scalars['Int']>;
  process_type: Maybe<Scalars['smallint']>;
  refinement_type: Maybe<Scalars['smallint']>;
  refund_type: Maybe<Scalars['smallint']>;
  repair_reason: Maybe<Scalars['String']>;
  selection_result: Maybe<Scalars['Int']>;
  statistical_code: Maybe<Scalars['Int']>;
  statistical_value: Maybe<Scalars['Int']>;
  storage_type: Maybe<Scalars['smallint']>;
  tare_supplement: Maybe<Scalars['numeric']>;
  un_dangerous_goods_code: Maybe<Scalars['String']>;
  vat_code: Maybe<Scalars['smallint']>;
  vat_rate: Maybe<Scalars['numeric']>;
  vat_total: Maybe<Scalars['numeric']>;
  vat_value: Maybe<Scalars['numeric']>;
  voc_quantity: Maybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Goods_Item_Stddev_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Goods_Item_Stddev_Pop_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Goods_Item_Stddev_Samp_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Goods_Item_Sum_Fields = {
  billing_type: Maybe<Scalars['smallint']>;
  clearance_type: Maybe<Scalars['Int']>;
  customs_declaration_version: Maybe<Scalars['Int']>;
  customs_favour_code: Maybe<Scalars['Int']>;
  customs_item_number: Maybe<Scalars['Int']>;
  customs_net_weight: Maybe<Scalars['numeric']>;
  direction: Maybe<Scalars['smallint']>;
  dr_no: Maybe<Scalars['smallint']>;
  duty_and_other_taxes_total: Maybe<Scalars['numeric']>;
  duty_rate: Maybe<Scalars['numeric']>;
  duty_total: Maybe<Scalars['numeric']>;
  gross_mass: Maybe<Scalars['numeric']>;
  net_mass: Maybe<Scalars['numeric']>;
  non_customs_law_obligation: Maybe<Scalars['smallint']>;
  permit_obligation_code: Maybe<Scalars['Int']>;
  process_type: Maybe<Scalars['smallint']>;
  refinement_type: Maybe<Scalars['smallint']>;
  refund_type: Maybe<Scalars['smallint']>;
  selection_result: Maybe<Scalars['Int']>;
  statistical_code: Maybe<Scalars['Int']>;
  statistical_value: Maybe<Scalars['Int']>;
  storage_type: Maybe<Scalars['smallint']>;
  tare_supplement: Maybe<Scalars['numeric']>;
  vat_code: Maybe<Scalars['smallint']>;
  vat_rate: Maybe<Scalars['numeric']>;
  vat_total: Maybe<Scalars['numeric']>;
  vat_value: Maybe<Scalars['numeric']>;
  voc_quantity: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Goods_Item_Var_Pop_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Goods_Item_Var_Samp_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Goods_Item_Variance_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** select columns of table "previous_documents" */
export enum Previous_Documents_Select_Column {
  /** column name */
  AdditionalInformation = 'additional_information',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  PreviousDocumentReference = 'previous_document_reference',
  /** column name */
  PreviousDocumentType = 'previous_document_type'
}

/** Ordering options when selecting data from "previous_documents". */
export type Previous_Documents_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  previous_document_reference?: InputMaybe<Order_By>;
  previous_document_type?: InputMaybe<Order_By>;
};

/** columns and relationships of "previous_documents" */
export type Previous_Documents = {
  additional_information: Maybe<Scalars['String']>;
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  id: Scalars['Int'];
  previous_document_reference: Maybe<Scalars['String']>;
  previous_document_type: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "declaration_discussion". */
export type Declaration_Discussion_Order_By = {
  closed?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  declaration_messages_aggregate?: InputMaybe<Declaration_Message_Aggregate_Order_By>;
  declaration_request?: InputMaybe<Declaration_Request_Order_By>;
  discussion_id?: InputMaybe<Order_By>;
  discussion_theme?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  user_pp?: InputMaybe<User_Pp_Order_By>;
};

/** order by aggregate values of table "declaration_message" */
export type Declaration_Message_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Message_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Message_Max_Order_By>;
  min?: InputMaybe<Declaration_Message_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Message_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Message_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Message_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Message_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Message_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Message_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Message_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_message" */
export type Declaration_Message_Avg_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_message" */
export type Declaration_Message_Max_Order_By = {
  /** declaration_message creation user. */
  creation_user?: InputMaybe<Order_By>;
  discussion_id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  msg_date?: InputMaybe<Order_By>;
  read_date?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_message" */
export type Declaration_Message_Min_Order_By = {
  /** declaration_message creation user. */
  creation_user?: InputMaybe<Order_By>;
  discussion_id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  msg_date?: InputMaybe<Order_By>;
  read_date?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_message" */
export type Declaration_Message_Stddev_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_message" */
export type Declaration_Message_Stddev_Pop_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_message" */
export type Declaration_Message_Stddev_Samp_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_message" */
export type Declaration_Message_Sum_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_message" */
export type Declaration_Message_Var_Pop_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_message" */
export type Declaration_Message_Var_Samp_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_message" */
export type Declaration_Message_Variance_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** Discussions related to files/declarations. */
export type Declaration_Discussion = {
  /** Discussion is closed */
  closed: Scalars['Boolean'];
  /** Creation date of discussion. */
  creation_date: Scalars['timestamptz'];
  /** User initiated discussion. */
  creation_user: Scalars['uuid'];
  /** An array relationship */
  declaration_messages: Array<Declaration_Message>;
  /** An aggregate relationship */
  declaration_messages_aggregate: Declaration_Message_Aggregate;
  /** An object relationship */
  declaration_request: Maybe<Declaration_Request>;
  /** Unique identificator of discussion. */
  discussion_id: Scalars['bigint'];
  /** Theme of discussion. */
  discussion_theme: Maybe<Scalars['String']>;
  dr_no: Scalars['smallint'];
  /** File/Declaration related to discussion. */
  file_id: Scalars['uuid'];
  /** additional attributes */
  meta: Scalars['jsonb'];
  /** An object relationship */
  user_pp: User_Pp;
};


/** Discussions related to files/declarations. */
export type Declaration_DiscussionDeclaration_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


/** Discussions related to files/declarations. */
export type Declaration_DiscussionDeclaration_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


/** Discussions related to files/declarations. */
export type Declaration_DiscussionMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Ordering options when selecting data from "declaration_message". */
export type Declaration_Message_Order_By = {
  creation_user?: InputMaybe<Order_By>;
  declaration_discussion?: InputMaybe<Declaration_Discussion_Order_By>;
  discussion_id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  msg_date?: InputMaybe<Order_By>;
  read_date?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/** Message in declaration discussion. */
export type Declaration_Message = {
  /** declaration_message creation user. */
  creation_user: Scalars['uuid'];
  /** An object relationship */
  declaration_discussion: Declaration_Discussion;
  discussion_id: Scalars['bigint'];
  message: Scalars['String'];
  meta: Scalars['jsonb'];
  msg_date: Scalars['timestamptz'];
  read_date: Maybe<Scalars['timestamptz']>;
  type: Maybe<Scalars['String']>;
  /** An object relationship */
  user: Maybe<User_Pp>;
};


/** Message in declaration discussion. */
export type Declaration_MessageMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "declaration_message" */
export type Declaration_Message_Aggregate = {
  aggregate: Maybe<Declaration_Message_Aggregate_Fields>;
  nodes: Array<Declaration_Message>;
};

/** aggregate fields of "declaration_message" */
export type Declaration_Message_Aggregate_Fields = {
  avg: Maybe<Declaration_Message_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Declaration_Message_Max_Fields>;
  min: Maybe<Declaration_Message_Min_Fields>;
  stddev: Maybe<Declaration_Message_Stddev_Fields>;
  stddev_pop: Maybe<Declaration_Message_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Declaration_Message_Stddev_Samp_Fields>;
  sum: Maybe<Declaration_Message_Sum_Fields>;
  var_pop: Maybe<Declaration_Message_Var_Pop_Fields>;
  var_samp: Maybe<Declaration_Message_Var_Samp_Fields>;
  variance: Maybe<Declaration_Message_Variance_Fields>;
};


/** aggregate fields of "declaration_message" */
export type Declaration_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Declaration_Message_Avg_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Declaration_Message_Max_Fields = {
  /** declaration_message creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  discussion_id: Maybe<Scalars['bigint']>;
  message: Maybe<Scalars['String']>;
  msg_date: Maybe<Scalars['timestamptz']>;
  read_date: Maybe<Scalars['timestamptz']>;
  type: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Declaration_Message_Min_Fields = {
  /** declaration_message creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  discussion_id: Maybe<Scalars['bigint']>;
  message: Maybe<Scalars['String']>;
  msg_date: Maybe<Scalars['timestamptz']>;
  read_date: Maybe<Scalars['timestamptz']>;
  type: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Declaration_Message_Stddev_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Declaration_Message_Stddev_Pop_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Declaration_Message_Stddev_Samp_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Declaration_Message_Sum_Fields = {
  discussion_id: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Declaration_Message_Var_Pop_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Declaration_Message_Var_Samp_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Declaration_Message_Variance_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregated selection of "declaration_discussion" */
export type Declaration_Discussion_Aggregate = {
  aggregate: Maybe<Declaration_Discussion_Aggregate_Fields>;
  nodes: Array<Declaration_Discussion>;
};

/** aggregate fields of "declaration_discussion" */
export type Declaration_Discussion_Aggregate_Fields = {
  avg: Maybe<Declaration_Discussion_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Declaration_Discussion_Max_Fields>;
  min: Maybe<Declaration_Discussion_Min_Fields>;
  stddev: Maybe<Declaration_Discussion_Stddev_Fields>;
  stddev_pop: Maybe<Declaration_Discussion_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Declaration_Discussion_Stddev_Samp_Fields>;
  sum: Maybe<Declaration_Discussion_Sum_Fields>;
  var_pop: Maybe<Declaration_Discussion_Var_Pop_Fields>;
  var_samp: Maybe<Declaration_Discussion_Var_Samp_Fields>;
  variance: Maybe<Declaration_Discussion_Variance_Fields>;
};


/** aggregate fields of "declaration_discussion" */
export type Declaration_Discussion_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Declaration_Discussion_Avg_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Declaration_Discussion_Max_Fields = {
  /** Creation date of discussion. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** User initiated discussion. */
  creation_user: Maybe<Scalars['uuid']>;
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['bigint']>;
  /** Theme of discussion. */
  discussion_theme: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  /** File/Declaration related to discussion. */
  file_id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Declaration_Discussion_Min_Fields = {
  /** Creation date of discussion. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** User initiated discussion. */
  creation_user: Maybe<Scalars['uuid']>;
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['bigint']>;
  /** Theme of discussion. */
  discussion_theme: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  /** File/Declaration related to discussion. */
  file_id: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Declaration_Discussion_Stddev_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Declaration_Discussion_Stddev_Pop_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Declaration_Discussion_Stddev_Samp_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Declaration_Discussion_Sum_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['bigint']>;
  dr_no: Maybe<Scalars['smallint']>;
};

/** aggregate var_pop on columns */
export type Declaration_Discussion_Var_Pop_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Declaration_Discussion_Var_Samp_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Declaration_Discussion_Variance_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** select columns of table "declaration_document" */
export enum Declaration_Document_Select_Column {
  /** column name */
  DocId = 'doc_id',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id'
}

/** Ordering options when selecting data from "declaration_document". */
export type Declaration_Document_Order_By = {
  doc_id?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "declaration_document" */
export type Declaration_Document = {
  doc_id: Scalars['uuid'];
  /** An object relationship */
  document: Maybe<Document>;
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};

/** select columns of table "declaration_request_labels" */
export enum Declaration_Request_Labels_Select_Column {
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  LabelId = 'label_id'
}

/** Ordering options when selecting data from "declaration_request_labels". */
export type Declaration_Request_Labels_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "declaration_request_labels" */
export type Declaration_Request_Labels = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  label_id: Scalars['Int'];
};

/** columns and relationships of "declaration_status" */
export type Declaration_Status = {
  name: Scalars['String'];
};

/** columns and relationships of "declaration_type" */
export type Declaration_Type = {
  /** An array relationship */
  declaration_requests: Array<Declaration_Request>;
  document_schema: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
};


/** columns and relationships of "declaration_type" */
export type Declaration_TypeDeclaration_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


/** columns and relationships of "declaration_type" */
export type Declaration_TypeDocument_SchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Ordering options when selecting data from "dr_goods_item". */
export type Dr_Goods_Item_Order_By = {
  additional_pcs?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  certificates?: InputMaybe<Order_By>;
  commodity_code?: InputMaybe<Order_By>;
  customs_net_mass?: InputMaybe<Order_By>;
  declaration_request?: InputMaybe<Declaration_Request_Order_By>;
  description?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  net_declaration?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  origin?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  statistic?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  traded_goods?: InputMaybe<Order_By>;
  trader_item_id?: InputMaybe<Order_By>;
  valuation?: InputMaybe<Order_By>;
};

/** columns and relationships of "dr_goods_item" */
export type Dr_Goods_Item = {
  additional_pcs: Maybe<Scalars['numeric']>;
  amount: Maybe<Scalars['jsonb']>;
  certificates: Maybe<Scalars['jsonb']>;
  commodity_code: Maybe<Scalars['String']>;
  customs_net_mass: Maybe<Scalars['numeric']>;
  /** An object relationship */
  declaration_request: Maybe<Declaration_Request>;
  description: Maybe<Scalars['String']>;
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  gross_mass: Maybe<Scalars['numeric']>;
  key: Maybe<Scalars['numeric']>;
  net_declaration: Maybe<Scalars['Boolean']>;
  net_mass: Maybe<Scalars['numeric']>;
  non_customs_law_obligation: Maybe<Scalars['Int']>;
  origin: Maybe<Scalars['jsonb']>;
  packaging: Maybe<Scalars['jsonb']>;
  revision: Maybe<Scalars['Boolean']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source: Scalars['smallint'];
  statistic: Maybe<Scalars['jsonb']>;
  statistical_code: Maybe<Scalars['String']>;
  traded_goods: Maybe<Scalars['Boolean']>;
  trader_item_id: Scalars['Int'];
  valuation: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "dr_goods_item" */
export type Dr_Goods_ItemAmountArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dr_goods_item" */
export type Dr_Goods_ItemCertificatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dr_goods_item" */
export type Dr_Goods_ItemOriginArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dr_goods_item" */
export type Dr_Goods_ItemPackagingArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dr_goods_item" */
export type Dr_Goods_ItemStatisticArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dr_goods_item" */
export type Dr_Goods_ItemValuationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "dr_goods_item" */
export type Dr_Goods_Item_Aggregate = {
  aggregate: Maybe<Dr_Goods_Item_Aggregate_Fields>;
  nodes: Array<Dr_Goods_Item>;
};

/** aggregate fields of "dr_goods_item" */
export type Dr_Goods_Item_Aggregate_Fields = {
  avg: Maybe<Dr_Goods_Item_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Dr_Goods_Item_Max_Fields>;
  min: Maybe<Dr_Goods_Item_Min_Fields>;
  stddev: Maybe<Dr_Goods_Item_Stddev_Fields>;
  stddev_pop: Maybe<Dr_Goods_Item_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Dr_Goods_Item_Stddev_Samp_Fields>;
  sum: Maybe<Dr_Goods_Item_Sum_Fields>;
  var_pop: Maybe<Dr_Goods_Item_Var_Pop_Fields>;
  var_samp: Maybe<Dr_Goods_Item_Var_Samp_Fields>;
  variance: Maybe<Dr_Goods_Item_Variance_Fields>;
};


/** aggregate fields of "dr_goods_item" */
export type Dr_Goods_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dr_Goods_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Dr_Goods_Item_Avg_Fields = {
  additional_pcs: Maybe<Scalars['Float']>;
  customs_net_mass: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  key: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source: Maybe<Scalars['Float']>;
  trader_item_id: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Dr_Goods_Item_Max_Fields = {
  additional_pcs: Maybe<Scalars['numeric']>;
  commodity_code: Maybe<Scalars['String']>;
  customs_net_mass: Maybe<Scalars['numeric']>;
  description: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  gross_mass: Maybe<Scalars['numeric']>;
  key: Maybe<Scalars['numeric']>;
  net_mass: Maybe<Scalars['numeric']>;
  non_customs_law_obligation: Maybe<Scalars['Int']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source: Maybe<Scalars['smallint']>;
  statistical_code: Maybe<Scalars['String']>;
  trader_item_id: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Dr_Goods_Item_Min_Fields = {
  additional_pcs: Maybe<Scalars['numeric']>;
  commodity_code: Maybe<Scalars['String']>;
  customs_net_mass: Maybe<Scalars['numeric']>;
  description: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  gross_mass: Maybe<Scalars['numeric']>;
  key: Maybe<Scalars['numeric']>;
  net_mass: Maybe<Scalars['numeric']>;
  non_customs_law_obligation: Maybe<Scalars['Int']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source: Maybe<Scalars['smallint']>;
  statistical_code: Maybe<Scalars['String']>;
  trader_item_id: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Dr_Goods_Item_Stddev_Fields = {
  additional_pcs: Maybe<Scalars['Float']>;
  customs_net_mass: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  key: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source: Maybe<Scalars['Float']>;
  trader_item_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Dr_Goods_Item_Stddev_Pop_Fields = {
  additional_pcs: Maybe<Scalars['Float']>;
  customs_net_mass: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  key: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source: Maybe<Scalars['Float']>;
  trader_item_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Dr_Goods_Item_Stddev_Samp_Fields = {
  additional_pcs: Maybe<Scalars['Float']>;
  customs_net_mass: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  key: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source: Maybe<Scalars['Float']>;
  trader_item_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Dr_Goods_Item_Sum_Fields = {
  additional_pcs: Maybe<Scalars['numeric']>;
  customs_net_mass: Maybe<Scalars['numeric']>;
  dr_no: Maybe<Scalars['smallint']>;
  gross_mass: Maybe<Scalars['numeric']>;
  key: Maybe<Scalars['numeric']>;
  net_mass: Maybe<Scalars['numeric']>;
  non_customs_law_obligation: Maybe<Scalars['Int']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source: Maybe<Scalars['smallint']>;
  trader_item_id: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Dr_Goods_Item_Var_Pop_Fields = {
  additional_pcs: Maybe<Scalars['Float']>;
  customs_net_mass: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  key: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source: Maybe<Scalars['Float']>;
  trader_item_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Dr_Goods_Item_Var_Samp_Fields = {
  additional_pcs: Maybe<Scalars['Float']>;
  customs_net_mass: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  key: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source: Maybe<Scalars['Float']>;
  trader_item_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Dr_Goods_Item_Variance_Fields = {
  additional_pcs: Maybe<Scalars['Float']>;
  customs_net_mass: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  key: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source: Maybe<Scalars['Float']>;
  trader_item_id: Maybe<Scalars['Float']>;
};

/** aggregated selection of "declaration_task" */
export type Declaration_Task_Aggregate = {
  aggregate: Maybe<Declaration_Task_Aggregate_Fields>;
  nodes: Array<Declaration_Task>;
};

/** aggregate fields of "declaration_task" */
export type Declaration_Task_Aggregate_Fields = {
  avg: Maybe<Declaration_Task_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Declaration_Task_Max_Fields>;
  min: Maybe<Declaration_Task_Min_Fields>;
  stddev: Maybe<Declaration_Task_Stddev_Fields>;
  stddev_pop: Maybe<Declaration_Task_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Declaration_Task_Stddev_Samp_Fields>;
  sum: Maybe<Declaration_Task_Sum_Fields>;
  var_pop: Maybe<Declaration_Task_Var_Pop_Fields>;
  var_samp: Maybe<Declaration_Task_Var_Samp_Fields>;
  variance: Maybe<Declaration_Task_Variance_Fields>;
};


/** aggregate fields of "declaration_task" */
export type Declaration_Task_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Declaration_Task_Avg_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Declaration_Task_Max_Fields = {
  assigned_to: Maybe<Scalars['uuid']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  due_date: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['Int']>;
  object_id: Maybe<Scalars['uuid']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Int']>;
  task_type_id: Maybe<Scalars['Int']>;
  title: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Declaration_Task_Min_Fields = {
  assigned_to: Maybe<Scalars['uuid']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  due_date: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['Int']>;
  object_id: Maybe<Scalars['uuid']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Int']>;
  task_type_id: Maybe<Scalars['Int']>;
  title: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Declaration_Task_Stddev_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Declaration_Task_Stddev_Pop_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Declaration_Task_Stddev_Samp_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Declaration_Task_Sum_Fields = {
  id: Maybe<Scalars['Int']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Int']>;
  task_type_id: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Declaration_Task_Var_Pop_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Declaration_Task_Var_Samp_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Declaration_Task_Variance_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "task_type" */
export type Task_Type = {
  display_name: Scalars['String'];
  id: Scalars['Int'];
  meta: Scalars['jsonb'];
};


/** columns and relationships of "task_type" */
export type Task_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "doc_annotation" */
export enum Doc_Annotation_Select_Column {
  /** column name */
  AnnoTypeId = 'anno_type_id',
  /** column name */
  DocId = 'doc_id',
  /** column name */
  Value = 'value'
}

/** Ordering options when selecting data from "doc_annotation". */
export type Doc_Annotation_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_type?: InputMaybe<Annotation_Type_Order_By>;
  doc_id?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Contains annotations for document. */
export type Doc_Annotation = {
  anno_type_id: Scalars['smallint'];
  /** An object relationship */
  annotation_type: Annotation_Type;
  /** Document Id related to doc_annotation. */
  doc_id: Scalars['uuid'];
  /** An object relationship */
  document: Maybe<Document>;
  value: Maybe<Scalars['jsonb']>;
};


/** Contains annotations for document. */
export type Doc_AnnotationValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Enum-like table from document.extension. Questionable utitily. */
export type Document_Extension = {
  /** document_extension creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document_extension creation user. */
  creation_user: Scalars['uuid'];
  display_name: Maybe<Scalars['String']>;
  /** document_extension last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document_extension. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  thumbnails_supported: Scalars['Boolean'];
  /** An object relationship */
  user: Maybe<User_Pp>;
};

/** Ordering options when selecting data from "document_page". */
export type Document_Page_Order_By = {
  document?: InputMaybe<Document_Order_By>;
  document_id?: InputMaybe<Order_By>;
  page?: InputMaybe<Page_Order_By>;
  page_id?: InputMaybe<Order_By>;
  page_number?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "page". */
export type Page_Order_By = {
  ai_ignore_retraining?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Page_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  ocr_text?: InputMaybe<Order_By>;
  page_extracts_aggregate?: InputMaybe<Page_Extract_Aggregate_Order_By>;
  page_status?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
  thumbnail_big_url?: InputMaybe<Order_By>;
  thumbnail_small_url?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "page_extract" */
export type Page_Extract_Aggregate_Order_By = {
  avg?: InputMaybe<Page_Extract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Page_Extract_Max_Order_By>;
  min?: InputMaybe<Page_Extract_Min_Order_By>;
  stddev?: InputMaybe<Page_Extract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Page_Extract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Page_Extract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Page_Extract_Sum_Order_By>;
  var_pop?: InputMaybe<Page_Extract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Page_Extract_Var_Samp_Order_By>;
  variance?: InputMaybe<Page_Extract_Variance_Order_By>;
};

/** order by avg() on columns of table "page_extract" */
export type Page_Extract_Avg_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "page_extract" */
export type Page_Extract_Max_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "page_extract" */
export type Page_Extract_Min_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "page_extract" */
export type Page_Extract_Stddev_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "page_extract" */
export type Page_Extract_Stddev_Pop_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "page_extract" */
export type Page_Extract_Stddev_Samp_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "page_extract" */
export type Page_Extract_Sum_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "page_extract" */
export type Page_Extract_Var_Pop_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "page_extract" */
export type Page_Extract_Var_Samp_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "page_extract" */
export type Page_Extract_Variance_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** Many-to-many relation between document and page */
export type Document_Page = {
  /** An object relationship */
  document: Maybe<Document>;
  /** Document Id related to document_page. */
  document_id: Scalars['uuid'];
  /** An object relationship */
  page: Maybe<Page>;
  page_id: Scalars['uuid'];
  page_number: Scalars['smallint'];
};

/** The biggest and possibly least useful table in DB. Beware relation pagesm2ms if graphq queries */
export type Page = {
  ai_ignore_retraining: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  created_by_user: Maybe<User_Pp>;
  /** page creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** page creation user. */
  creation_user: Scalars['uuid'];
  /** An array relationship */
  documents: Array<Document_Page>;
  /** An aggregate relationship */
  documents_aggregate: Document_Page_Aggregate;
  /** id of page. */
  id: Scalars['uuid'];
  /** page last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified page. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** additional attributes */
  meta: Scalars['jsonb'];
  ocr_text: Maybe<Scalars['String']>;
  /** An array relationship */
  page_extracts: Array<Page_Extract>;
  page_status: Scalars['String'];
  rotate: Scalars['smallint'];
  thumbnail_big_url: Maybe<Scalars['String']>;
  thumbnail_small_url: Maybe<Scalars['String']>;
};


/** The biggest and possibly least useful table in DB. Beware relation pagesm2ms if graphq queries */
export type PageDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


/** The biggest and possibly least useful table in DB. Beware relation pagesm2ms if graphq queries */
export type PageDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


/** The biggest and possibly least useful table in DB. Beware relation pagesm2ms if graphq queries */
export type PageMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** The biggest and possibly least useful table in DB. Beware relation pagesm2ms if graphq queries */
export type PagePage_ExtractsArgs = {
  distinct_on?: InputMaybe<Array<Page_Extract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Extract_Order_By>>;
  where?: InputMaybe<Page_Extract_Bool_Exp>;
};

/** aggregated selection of "document_page" */
export type Document_Page_Aggregate = {
  aggregate: Maybe<Document_Page_Aggregate_Fields>;
  nodes: Array<Document_Page>;
};

/** aggregate fields of "document_page" */
export type Document_Page_Aggregate_Fields = {
  avg: Maybe<Document_Page_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Document_Page_Max_Fields>;
  min: Maybe<Document_Page_Min_Fields>;
  stddev: Maybe<Document_Page_Stddev_Fields>;
  stddev_pop: Maybe<Document_Page_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Document_Page_Stddev_Samp_Fields>;
  sum: Maybe<Document_Page_Sum_Fields>;
  var_pop: Maybe<Document_Page_Var_Pop_Fields>;
  var_samp: Maybe<Document_Page_Var_Samp_Fields>;
  variance: Maybe<Document_Page_Variance_Fields>;
};


/** aggregate fields of "document_page" */
export type Document_Page_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Page_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Document_Page_Avg_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Document_Page_Max_Fields = {
  /** Document Id related to document_page. */
  document_id: Maybe<Scalars['uuid']>;
  page_id: Maybe<Scalars['uuid']>;
  page_number: Maybe<Scalars['smallint']>;
};

/** aggregate min on columns */
export type Document_Page_Min_Fields = {
  /** Document Id related to document_page. */
  document_id: Maybe<Scalars['uuid']>;
  page_id: Maybe<Scalars['uuid']>;
  page_number: Maybe<Scalars['smallint']>;
};

/** aggregate stddev on columns */
export type Document_Page_Stddev_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Document_Page_Stddev_Pop_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Document_Page_Stddev_Samp_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Document_Page_Sum_Fields = {
  page_number: Maybe<Scalars['smallint']>;
};

/** aggregate var_pop on columns */
export type Document_Page_Var_Pop_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Document_Page_Var_Samp_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Document_Page_Variance_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** select columns of table "page_extract" */
export enum Page_Extract_Select_Column {
  /** column name */
  ExtractTypeId = 'extract_type_id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  Tables = 'tables',
  /** column name */
  Value = 'value'
}

/** Ordering options when selecting data from "page_extract". */
export type Page_Extract_Order_By = {
  extract_type?: InputMaybe<Extract_Type_Order_By>;
  extract_type_id?: InputMaybe<Order_By>;
  page?: InputMaybe<Page_Order_By>;
  page_id?: InputMaybe<Order_By>;
  tables?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "extract_type". */
export type Extract_Type_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
};

/** columns and relationships of "page_extract" */
export type Page_Extract = {
  /** An object relationship */
  extract_type: Extract_Type;
  extract_type_id: Scalars['smallint'];
  /** An object relationship */
  page: Page;
  page_id: Scalars['uuid'];
  tables: Maybe<Scalars['jsonb']>;
  value: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "page_extract" */
export type Page_ExtractTablesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "page_extract" */
export type Page_ExtractValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Enum-like table. Used as value in page_extract. */
export type Extract_Type = {
  extract_type_id: Scalars['smallint'];
  /** additional attributes */
  meta: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  translations: Maybe<Scalars['json']>;
};


/** Enum-like table. Used as value in page_extract. */
export type Extract_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Enum-like table. Used as value in page_extract. */
export type Extract_TypeTranslationsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Enum-like table that holds values for document.document_status */
export type Document_Status = {
  /** document_status creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document_status creation user. */
  creation_user: Scalars['uuid'];
  display_name: Maybe<Scalars['String']>;
  /** document_status last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document_status. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  /** An object relationship */
  user: Maybe<User_Pp>;
};

/** select columns of table "user_org_id" */
export enum User_Org_Id_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  UserPp = 'user_pp'
}

/** Many-to-many relations beteewn users and organizations/Abtreilungs. */
export type User_Org_Id = {
  /** user_org_id creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** user_org_id creation user. */
  creation_user: Scalars['uuid'];
  /** user_org_id last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified user_org_id. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** Org_id related to user_org_id. */
  org_id: Scalars['smallint'];
  /** An object relationship */
  orgId: Maybe<Org_Id>;
  user_pp: Scalars['uuid'];
};

/** Ordering options when selecting data from "import_list_trigger". */
export type Import_List_Trigger_Order_By = {
  config?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  creationUser?: InputMaybe<User_Pp_Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Declaration_Labels_Order_By>;
  label_id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  lastModifiedUser?: InputMaybe<User_Pp_Order_By>;
  meta?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Table for storing import-list-alert-trigger configurations */
export type Import_List_Trigger = {
  config: Scalars['jsonb'];
  creation_date: Scalars['timestamptz'];
  creation_user: Maybe<Scalars['uuid']>;
  /** An object relationship */
  creationUser: Maybe<User_Pp>;
  display_name: Scalars['String'];
  id: Scalars['Int'];
  /** An object relationship */
  label: Maybe<Declaration_Labels>;
  label_id: Maybe<Scalars['Int']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  /** An object relationship */
  lastModifiedUser: Maybe<User_Pp>;
  meta: Scalars['jsonb'];
  tenant_id: Scalars['uuid'];
  type: Scalars['String'];
};


/** Table for storing import-list-alert-trigger configurations */
export type Import_List_TriggerConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Table for storing import-list-alert-trigger configurations */
export type Import_List_TriggerMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "import_list_trigger" */
export type Import_List_Trigger_Aggregate = {
  aggregate: Maybe<Import_List_Trigger_Aggregate_Fields>;
  nodes: Array<Import_List_Trigger>;
};

/** aggregate fields of "import_list_trigger" */
export type Import_List_Trigger_Aggregate_Fields = {
  avg: Maybe<Import_List_Trigger_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Import_List_Trigger_Max_Fields>;
  min: Maybe<Import_List_Trigger_Min_Fields>;
  stddev: Maybe<Import_List_Trigger_Stddev_Fields>;
  stddev_pop: Maybe<Import_List_Trigger_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Import_List_Trigger_Stddev_Samp_Fields>;
  sum: Maybe<Import_List_Trigger_Sum_Fields>;
  var_pop: Maybe<Import_List_Trigger_Var_Pop_Fields>;
  var_samp: Maybe<Import_List_Trigger_Var_Samp_Fields>;
  variance: Maybe<Import_List_Trigger_Variance_Fields>;
};


/** aggregate fields of "import_list_trigger" */
export type Import_List_Trigger_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Import_List_Trigger_Avg_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Import_List_Trigger_Max_Fields = {
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  display_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  label_id: Maybe<Scalars['Int']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  tenant_id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Import_List_Trigger_Min_Fields = {
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  display_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  label_id: Maybe<Scalars['Int']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  tenant_id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Import_List_Trigger_Stddev_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Import_List_Trigger_Stddev_Pop_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Import_List_Trigger_Stddev_Samp_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Import_List_Trigger_Sum_Fields = {
  id: Maybe<Scalars['Int']>;
  label_id: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Import_List_Trigger_Var_Pop_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Import_List_Trigger_Var_Samp_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Import_List_Trigger_Variance_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** select columns of table "org_id" */
export enum Org_Id_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgIdDescription = 'org_id_description',
  /** column name */
  TenantId = 'tenant_id'
}

/** select columns of table "user_pp" */
export enum User_Pp_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedByUser = 'deleted_by_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LdapEntryDn = 'ldap_entry_dn',
  /** column name */
  Location = 'location',
  /** column name */
  OauthId = 'oauth_id',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UiSettings = 'ui_settings',
  /** column name */
  UiSettingsTemplates = 'ui_settings_templates',
  /** column name */
  UserType = 'user_type'
}

/** columns and relationships of "extraction_config" */
export type Extraction_Config = {
  address_id: Scalars['Int'];
  aliases: Maybe<Scalars['jsonb']>;
  document_templates: Maybe<Scalars['jsonb']>;
  foun_config: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "extraction_config" */
export type Extraction_ConfigAliasesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "extraction_config" */
export type Extraction_ConfigDocument_TemplatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "extraction_config" */
export type Extraction_ConfigFoun_ConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "address_group" */
export enum Address_Group_Select_Column {
  /** column name */
  BusinessCase = 'business_case',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  PayerAddress = 'payer_address'
}

/** Ordering options when selecting data from "address_group". */
export type Address_Group_Order_By = {
  business_case?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  groupMembers_aggregate?: InputMaybe<Group_Member_Aggregate_Order_By>;
  payer_address?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "group_member" */
export type Group_Member_Aggregate_Order_By = {
  avg?: InputMaybe<Group_Member_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Group_Member_Max_Order_By>;
  min?: InputMaybe<Group_Member_Min_Order_By>;
  stddev?: InputMaybe<Group_Member_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Group_Member_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Group_Member_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Group_Member_Sum_Order_By>;
  var_pop?: InputMaybe<Group_Member_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Group_Member_Var_Samp_Order_By>;
  variance?: InputMaybe<Group_Member_Variance_Order_By>;
};

/** order by avg() on columns of table "group_member" */
export type Group_Member_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "group_member" */
export type Group_Member_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "group_member" */
export type Group_Member_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "group_member" */
export type Group_Member_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "group_member" */
export type Group_Member_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "group_member" */
export type Group_Member_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "group_member" */
export type Group_Member_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "group_member" */
export type Group_Member_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "group_member" */
export type Group_Member_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "group_member" */
export type Group_Member_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "address_group". All fields are combined with a logical 'AND'. */
export type Address_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Group_Bool_Exp>>;
  _not?: InputMaybe<Address_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Group_Bool_Exp>>;
  business_case?: InputMaybe<Bc_Name_Comparison_Exp>;
  group_id?: InputMaybe<Smallint_Comparison_Exp>;
  group_name?: InputMaybe<String_Comparison_Exp>;
  groupMembers?: InputMaybe<Group_Member_Bool_Exp>;
  payer_address?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "bc_name". All fields are combined with logical 'AND'. */
export type Bc_Name_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bc_name']>;
  _gt?: InputMaybe<Scalars['bc_name']>;
  _gte?: InputMaybe<Scalars['bc_name']>;
  _in?: InputMaybe<Array<Scalars['bc_name']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bc_name']>;
  _lte?: InputMaybe<Scalars['bc_name']>;
  _neq?: InputMaybe<Scalars['bc_name']>;
  _nin?: InputMaybe<Array<Scalars['bc_name']>>;
};

/** Boolean expression to filter rows from the table "group_member". All fields are combined with a logical 'AND'. */
export type Group_Member_Bool_Exp = {
  _and?: InputMaybe<Array<Group_Member_Bool_Exp>>;
  _not?: InputMaybe<Group_Member_Bool_Exp>;
  _or?: InputMaybe<Array<Group_Member_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  address_type?: InputMaybe<Smallint_Comparison_Exp>;
  clearance_types?: InputMaybe<_Text_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declaration_types?: InputMaybe<_Text_Comparison_Exp>;
  group_id?: InputMaybe<Smallint_Comparison_Exp>;
  permissions_js?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** columns and relationships of "address_group" */
export type Address_Group = {
  business_case: Maybe<Scalars['bc_name']>;
  group_id: Scalars['smallint'];
  group_name: Maybe<Scalars['String']>;
  /** An array relationship */
  groupMembers: Array<Group_Member>;
  payer_address: Maybe<Scalars['Int']>;
};


/** columns and relationships of "address_group" */
export type Address_GroupGroupMembersArgs = {
  distinct_on?: InputMaybe<Array<Group_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Member_Order_By>>;
  where?: InputMaybe<Group_Member_Bool_Exp>;
};

/** select columns of table "group_member" */
export enum Group_Member_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  ClearanceTypes = 'clearance_types',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DeclarationTypes = 'declaration_types',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  PermissionsJs = 'permissions_js'
}

/** Ordering options when selecting data from "group_member". */
export type Group_Member_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  clearance_types?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  declaration_types?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  permissions_js?: InputMaybe<Order_By>;
};

/** columns and relationships of "group_member" */
export type Group_Member = {
  /** An object relationship */
  address: Maybe<Address>;
  address_id: Scalars['Int'];
  address_type: Maybe<Scalars['smallint']>;
  clearance_types: Scalars['_text'];
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  declaration_types: Scalars['_text'];
  group_id: Scalars['smallint'];
  permissions_js: Scalars['jsonb'];
};


/** columns and relationships of "group_member" */
export type Group_MemberPermissions_JsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "address_groups" */
export enum Address_Groups_Select_Column {
  /** column name */
  BusinessCase = 'business_case',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  PayerAddress = 'payer_address',
  /** column name */
  PayerName = 'payer_name'
}

/** Ordering options when selecting data from "address_groups". */
export type Address_Groups_Order_By = {
  business_case?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  groupMembers_aggregate?: InputMaybe<Group_Member_Aggregate_Order_By>;
  groupMembersDesc_aggregate?: InputMaybe<Group_Members_Aggregate_Order_By>;
  payer_address?: InputMaybe<Order_By>;
  payer_name?: InputMaybe<Order_By>;
  payerAddress?: InputMaybe<Address_Order_By>;
};

/** order by aggregate values of table "group_members" */
export type Group_Members_Aggregate_Order_By = {
  avg?: InputMaybe<Group_Members_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Group_Members_Max_Order_By>;
  min?: InputMaybe<Group_Members_Min_Order_By>;
  stddev?: InputMaybe<Group_Members_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Group_Members_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Group_Members_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Group_Members_Sum_Order_By>;
  var_pop?: InputMaybe<Group_Members_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Group_Members_Var_Samp_Order_By>;
  variance?: InputMaybe<Group_Members_Variance_Order_By>;
};

/** order by avg() on columns of table "group_members" */
export type Group_Members_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  payer_address?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "group_members" */
export type Group_Members_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  business_case?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  payer_address?: InputMaybe<Order_By>;
  payer_company?: InputMaybe<Order_By>;
  payer_tenant?: InputMaybe<Order_By>;
  payer_type?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "group_members" */
export type Group_Members_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  business_case?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  payer_address?: InputMaybe<Order_By>;
  payer_company?: InputMaybe<Order_By>;
  payer_tenant?: InputMaybe<Order_By>;
  payer_type?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "group_members" */
export type Group_Members_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  payer_address?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "group_members" */
export type Group_Members_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  payer_address?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "group_members" */
export type Group_Members_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  payer_address?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "group_members" */
export type Group_Members_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  payer_address?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "group_members" */
export type Group_Members_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  payer_address?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "group_members" */
export type Group_Members_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  payer_address?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "group_members" */
export type Group_Members_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  payer_address?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "address_groups". All fields are combined with a logical 'AND'. */
export type Address_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Groups_Bool_Exp>>;
  _not?: InputMaybe<Address_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Groups_Bool_Exp>>;
  business_case?: InputMaybe<Bc_Name_Comparison_Exp>;
  group_id?: InputMaybe<Smallint_Comparison_Exp>;
  group_name?: InputMaybe<String_Comparison_Exp>;
  groupMembers?: InputMaybe<Group_Member_Bool_Exp>;
  groupMembersDesc?: InputMaybe<Group_Members_Bool_Exp>;
  payer_address?: InputMaybe<Int_Comparison_Exp>;
  payer_name?: InputMaybe<String_Comparison_Exp>;
  payerAddress?: InputMaybe<Address_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "group_members". All fields are combined with a logical 'AND'. */
export type Group_Members_Bool_Exp = {
  _and?: InputMaybe<Array<Group_Members_Bool_Exp>>;
  _not?: InputMaybe<Group_Members_Bool_Exp>;
  _or?: InputMaybe<Array<Group_Members_Bool_Exp>>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  address_type?: InputMaybe<String_Comparison_Exp>;
  business_case?: InputMaybe<Bc_Name_Comparison_Exp>;
  clearance_types?: InputMaybe<_Text_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  declaration_types?: InputMaybe<_Text_Comparison_Exp>;
  group_id?: InputMaybe<Smallint_Comparison_Exp>;
  group_name?: InputMaybe<String_Comparison_Exp>;
  payer?: InputMaybe<Address_Bool_Exp>;
  payer_address?: InputMaybe<Int_Comparison_Exp>;
  payer_company?: InputMaybe<String_Comparison_Exp>;
  payer_tenant?: InputMaybe<Uuid_Comparison_Exp>;
  payer_type?: InputMaybe<String_Comparison_Exp>;
  permissions_js?: InputMaybe<Jsonb_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "address_groups" */
export type Address_Groups = {
  business_case: Maybe<Scalars['bc_name']>;
  group_id: Scalars['smallint'];
  group_name: Maybe<Scalars['String']>;
  /** An array relationship */
  groupMembers: Array<Group_Member>;
  /** An array relationship */
  groupMembersDesc: Array<Group_Members>;
  payer_address: Maybe<Scalars['Int']>;
  payer_name: Maybe<Scalars['String']>;
  /** An object relationship */
  payerAddress: Maybe<Address>;
};


/** columns and relationships of "address_groups" */
export type Address_GroupsGroupMembersArgs = {
  distinct_on?: InputMaybe<Array<Group_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Member_Order_By>>;
  where?: InputMaybe<Group_Member_Bool_Exp>;
};


/** columns and relationships of "address_groups" */
export type Address_GroupsGroupMembersDescArgs = {
  distinct_on?: InputMaybe<Array<Group_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Members_Order_By>>;
  where?: InputMaybe<Group_Members_Bool_Exp>;
};

/** select columns of table "group_members" */
export enum Group_Members_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  BusinessCase = 'business_case',
  /** column name */
  ClearanceTypes = 'clearance_types',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  DeclarationTypes = 'declaration_types',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  PayerAddress = 'payer_address',
  /** column name */
  PayerCompany = 'payer_company',
  /** column name */
  PayerTenant = 'payer_tenant',
  /** column name */
  PayerType = 'payer_type',
  /** column name */
  PermissionsJs = 'permissions_js',
  /** column name */
  TenantId = 'tenant_id'
}

/** Ordering options when selecting data from "group_members". */
export type Group_Members_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  business_case?: InputMaybe<Order_By>;
  clearance_types?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  declaration_types?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  payer?: InputMaybe<Address_Order_By>;
  payer_address?: InputMaybe<Order_By>;
  payer_company?: InputMaybe<Order_By>;
  payer_tenant?: InputMaybe<Order_By>;
  payer_type?: InputMaybe<Order_By>;
  permissions_js?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "group_members" */
export type Group_Members = {
  address_id: Maybe<Scalars['Int']>;
  address_type: Maybe<Scalars['String']>;
  business_case: Maybe<Scalars['bc_name']>;
  clearance_types: Maybe<Scalars['_text']>;
  company_name: Maybe<Scalars['String']>;
  declaration_types: Maybe<Scalars['_text']>;
  group_id: Maybe<Scalars['smallint']>;
  group_name: Maybe<Scalars['String']>;
  /** An object relationship */
  payer: Maybe<Address>;
  payer_address: Maybe<Scalars['Int']>;
  payer_company: Maybe<Scalars['String']>;
  payer_tenant: Maybe<Scalars['uuid']>;
  payer_type: Maybe<Scalars['String']>;
  permissions_js: Maybe<Scalars['jsonb']>;
  tenant_id: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "group_members" */
export type Group_MembersPermissions_JsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "address_mapping" */
export enum Address_Mapping_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AddressOverrideId = 'address_override_id',
  /** column name */
  IsCrossAddress = 'is_cross_address',
  /** column name */
  TenantId = 'tenant_id'
}

/** Ordering options when selecting data from "address_mapping". */
export type Address_Mapping_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_override_id?: InputMaybe<Order_By>;
  is_cross_address?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "address_mapping". All fields are combined with a logical 'AND'. */
export type Address_Mapping_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Mapping_Bool_Exp>>;
  _not?: InputMaybe<Address_Mapping_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Mapping_Bool_Exp>>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  address_override_id?: InputMaybe<Int_Comparison_Exp>;
  is_cross_address?: InputMaybe<Boolean_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "address_mapping" */
export type Address_Mapping = {
  address_id: Scalars['Int'];
  address_override_id: Scalars['Int'];
  is_cross_address: Scalars['Boolean'];
  tenant_id: Scalars['uuid'];
};

/** select columns of table "address_override" */
export enum Address_Override_Select_Column {
  /** column name */
  AddressType = 'address_type',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContactWebsite = 'contact_website',
  /** column name */
  Country = 'country',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  Reference = 'reference',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  Zipcode = 'zipcode'
}

/** Ordering options when selecting data from "address_override". */
export type Address_Override_Order_By = {
  address_type?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  contact_website?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  vat_number?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "address_override". All fields are combined with a logical 'AND'. */
export type Address_Override_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Override_Bool_Exp>>;
  _not?: InputMaybe<Address_Override_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Override_Bool_Exp>>;
  address_type?: InputMaybe<Int_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  contact_website?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  vat_number?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "address_override" */
export type Address_Override = {
  address_type: Maybe<Scalars['Int']>;
  city: Maybe<Scalars['String']>;
  company_name: Scalars['String'];
  contact_email: Maybe<Scalars['String']>;
  contact_phone: Maybe<Scalars['String']>;
  contact_website: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Scalars['uuid'];
  id: Scalars['Int'];
  is_deleted: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  payer_id: Maybe<Scalars['uuid']>;
  reference: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  street_number: Maybe<Scalars['String']>;
  vat_number: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};


/** columns and relationships of "address_override" */
export type Address_OverrideMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "address_type" */
export enum Address_Type_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Translation = 'translation'
}

/** select columns of table "addresses" */
export enum Addresses_Select_Column {
  /** column name */
  AddressType = 'address_type',
  /** column name */
  AddressTypes = 'address_types',
  /** column name */
  AoId = 'ao_id',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContactWebsite = 'contact_website',
  /** column name */
  Country = 'country',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsAccountNumber = 'customs_account_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Qty = 'qty',
  /** column name */
  Reference = 'reference',
  /** column name */
  Source = 'source',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  VatAccountNumber = 'vat_account_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  Zipcode = 'zipcode'
}

/** Ordering options when selecting data from "addresses". */
export type Addresses_Order_By = {
  address_type?: InputMaybe<Order_By>;
  address_types?: InputMaybe<Order_By>;
  addressType?: InputMaybe<Address_Type_Order_By>;
  ao_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  contact_website?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_account_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenant_Order_By>;
  vat_account_number?: InputMaybe<Order_By>;
  vat_number?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "addresses". All fields are combined with a logical 'AND'. */
export type Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Addresses_Bool_Exp>>;
  _not?: InputMaybe<Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Addresses_Bool_Exp>>;
  address_type?: InputMaybe<Int_Comparison_Exp>;
  address_types?: InputMaybe<_Int4_Comparison_Exp>;
  addressType?: InputMaybe<Address_Type_Bool_Exp>;
  ao_id?: InputMaybe<Int_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  contact_website?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_account_number?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Tenant_Bool_Exp>;
  vat_account_number?: InputMaybe<String_Comparison_Exp>;
  vat_number?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** View that used as SETOF type for pp_addresses() */
export type Addresses = {
  address_type: Maybe<Scalars['Int']>;
  address_types: Maybe<Scalars['_int4']>;
  /** An object relationship */
  addressType: Maybe<Address_Type>;
  ao_id: Maybe<Scalars['Int']>;
  city: Maybe<Scalars['String']>;
  company_name: Scalars['String'];
  contact_email: Maybe<Scalars['String']>;
  contact_phone: Maybe<Scalars['String']>;
  contact_website: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Scalars['uuid'];
  customs_account_number: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_deleted: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  qty: Maybe<Scalars['bigint']>;
  reference: Maybe<Scalars['String']>;
  source: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  street_number: Maybe<Scalars['String']>;
  /** An object relationship */
  tenant: Maybe<Tenant>;
  vat_account_number: Maybe<Scalars['String']>;
  vat_number: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};


/** View that used as SETOF type for pp_addresses() */
export type AddressesMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "ai_stats_dt_type" */
export enum Ai_Stats_Dt_Type_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  DocsQty = 'docs_qty',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  PagesQty = 'pages_qty',
  /** column name */
  SuccessRatio = 'success_ratio',
  /** column name */
  TypesMatch = 'types_match',
  /** column name */
  Unknowns = 'unknowns',
  /** column name */
  UnknownsPct = 'unknowns_pct'
}

/** Ordering options when selecting data from "ai_stats_dt_type". */
export type Ai_Stats_Dt_Type_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  docs_qty?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Document_Type_Order_By>;
  pages_qty?: InputMaybe<Order_By>;
  success_ratio?: InputMaybe<Order_By>;
  types_match?: InputMaybe<Order_By>;
  unknowns?: InputMaybe<Order_By>;
  unknowns_pct?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ai_stats_dt_type". All fields are combined with a logical 'AND'. */
export type Ai_Stats_Dt_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Stats_Dt_Type_Bool_Exp>>;
  _not?: InputMaybe<Ai_Stats_Dt_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Stats_Dt_Type_Bool_Exp>>;
  creation_date?: InputMaybe<Date_Comparison_Exp>;
  docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  documentType?: InputMaybe<Document_Type_Bool_Exp>;
  pages_qty?: InputMaybe<Bigint_Comparison_Exp>;
  success_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  types_match?: InputMaybe<Numeric_Comparison_Exp>;
  unknowns?: InputMaybe<Numeric_Comparison_Exp>;
  unknowns_pct?: InputMaybe<Numeric_Comparison_Exp>;
};

/** SETOF-type for pp_ai_stats_dt. */
export type Ai_Stats_Dt_Type = {
  creation_date: Maybe<Scalars['date']>;
  docs_qty: Maybe<Scalars['bigint']>;
  document_type: Maybe<Scalars['String']>;
  /** An object relationship */
  documentType: Maybe<Document_Type>;
  pages_qty: Maybe<Scalars['bigint']>;
  success_ratio: Maybe<Scalars['numeric']>;
  types_match: Maybe<Scalars['numeric']>;
  unknowns: Maybe<Scalars['numeric']>;
  unknowns_pct: Maybe<Scalars['numeric']>;
};

/** select columns of table "ai_stats_type" */
export enum Ai_Stats_Type_Select_Column {
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  SuccessRatio = 'success_ratio',
  /** column name */
  Total = 'total',
  /** column name */
  TypesMatch = 'types_match',
  /** column name */
  Unknowns = 'unknowns',
  /** column name */
  UnknownsPct = 'unknowns_pct'
}

/** Ordering options when selecting data from "ai_stats_type". */
export type Ai_Stats_Type_Order_By = {
  document_type?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Document_Type_Order_By>;
  success_ratio?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  types_match?: InputMaybe<Order_By>;
  unknowns?: InputMaybe<Order_By>;
  unknowns_pct?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ai_stats_type". All fields are combined with a logical 'AND'. */
export type Ai_Stats_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Stats_Type_Bool_Exp>>;
  _not?: InputMaybe<Ai_Stats_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Stats_Type_Bool_Exp>>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  documentType?: InputMaybe<Document_Type_Bool_Exp>;
  success_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  total?: InputMaybe<Bigint_Comparison_Exp>;
  types_match?: InputMaybe<Numeric_Comparison_Exp>;
  unknowns?: InputMaybe<Numeric_Comparison_Exp>;
  unknowns_pct?: InputMaybe<Numeric_Comparison_Exp>;
};

/** SETOF-type used in pp_ai_stats. */
export type Ai_Stats_Type = {
  document_type: Maybe<Scalars['String']>;
  /** An object relationship */
  documentType: Maybe<Document_Type>;
  success_ratio: Maybe<Scalars['numeric']>;
  total: Maybe<Scalars['bigint']>;
  types_match: Maybe<Scalars['numeric']>;
  unknowns: Maybe<Scalars['numeric']>;
  unknowns_pct: Maybe<Scalars['numeric']>;
};

/** select columns of table "annotation_provider" */
export enum Annotation_Provider_Select_Column {
  /** column name */
  AnnotationProvider = 'annotation_provider',
  /** column name */
  AnnotationProviderId = 'annotation_provider_id'
}

/** select columns of table "arrival_type" */
export enum Arrival_Type_Select_Column {
  /** column name */
  ArrivalType = 'arrival_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Description = 'description',
  /** column name */
  Meta = 'meta'
}

/** select columns of table "bill" */
export enum Bill_Select_Column {
  /** column name */
  BillId = 'bill_id',
  /** column name */
  BillType = 'bill_type',
  /** column name */
  FromTs = 'from_ts',
  /** column name */
  Meta = 'meta',
  /** column name */
  PaymentTerms = 'payment_terms',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ToTs = 'to_ts'
}

/** aggregated selection of "bill" */
export type Bill_Aggregate = {
  aggregate: Maybe<Bill_Aggregate_Fields>;
  nodes: Array<Bill>;
};

/** aggregate fields of "bill" */
export type Bill_Aggregate_Fields = {
  avg: Maybe<Bill_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Bill_Max_Fields>;
  min: Maybe<Bill_Min_Fields>;
  stddev: Maybe<Bill_Stddev_Fields>;
  stddev_pop: Maybe<Bill_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Bill_Stddev_Samp_Fields>;
  sum: Maybe<Bill_Sum_Fields>;
  var_pop: Maybe<Bill_Var_Pop_Fields>;
  var_samp: Maybe<Bill_Var_Samp_Fields>;
  variance: Maybe<Bill_Variance_Fields>;
};


/** aggregate fields of "bill" */
export type Bill_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bill_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Bill_Avg_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Bill_Max_Fields = {
  bill_id: Maybe<Scalars['bigint']>;
  from_ts: Maybe<Scalars['timestamptz']>;
  payment_terms: Maybe<Scalars['smallint']>;
  tenant_id: Maybe<Scalars['uuid']>;
  to_ts: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Bill_Min_Fields = {
  bill_id: Maybe<Scalars['bigint']>;
  from_ts: Maybe<Scalars['timestamptz']>;
  payment_terms: Maybe<Scalars['smallint']>;
  tenant_id: Maybe<Scalars['uuid']>;
  to_ts: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Bill_Stddev_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Bill_Stddev_Pop_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Bill_Stddev_Samp_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Bill_Sum_Fields = {
  bill_id: Maybe<Scalars['bigint']>;
  payment_terms: Maybe<Scalars['smallint']>;
};

/** aggregate var_pop on columns */
export type Bill_Var_Pop_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Bill_Var_Samp_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Bill_Variance_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** select columns of table "clearance_type" */
export enum Clearance_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** select columns of table "count_type" */
export enum Count_Type_Select_Column {
  /** column name */
  Count = 'count'
}

/** Ordering options when selecting data from "count_type". */
export type Count_Type_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "count_type". All fields are combined with a logical 'AND'. */
export type Count_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Count_Type_Bool_Exp>>;
  _not?: InputMaybe<Count_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Count_Type_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** This view created for using functions as  'RETURNS  SETOF count_type'   */
export type Count_Type = {
  count: Maybe<Scalars['bigint']>;
};

/** select columns of table "customs_office" */
export enum Customs_Office_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Name = 'name',
  /** column name */
  OfficeNumber = 'office_number',
  /** column name */
  Prefix = 'prefix',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

/** Ordering options when selecting data from "customs_office". */
export type Customs_Office_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  office_number?: InputMaybe<Order_By>;
  prefix?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "customs_office". All fields are combined with a logical 'AND'. */
export type Customs_Office_Bool_Exp = {
  _and?: InputMaybe<Array<Customs_Office_Bool_Exp>>;
  _not?: InputMaybe<Customs_Office_Bool_Exp>;
  _or?: InputMaybe<Array<Customs_Office_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  office_number?: InputMaybe<String_Comparison_Exp>;
  prefix?: InputMaybe<String_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_to?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "customs_office" */
export type Customs_Office = {
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  office_number: Scalars['String'];
  prefix: Maybe<Scalars['String']>;
  valid_from: Scalars['timestamptz'];
  valid_to: Maybe<Scalars['timestamptz']>;
};

/** select columns of table "customs_offices" */
export enum Customs_Offices_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Name = 'name',
  /** column name */
  OfficeNumber = 'office_number',
  /** column name */
  Prefix = 'prefix',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

/** select columns of table "customs_response_data" */
export enum Customs_Response_Data_Select_Column {
  /** column name */
  CorrectionCode = 'correction_code',
  /** column name */
  DocId = 'doc_id',
  /** column name */
  DocumentVersion = 'document_version',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Value = 'value'
}

/** select columns of table "customs_response_decoded" */
export enum Customs_Response_Decoded_Select_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AcceptanceTime = 'acceptance_time',
  /** column name */
  AccessCode = 'access_code',
  /** column name */
  Consignee = 'consignee',
  /** column name */
  Consignor = 'consignor',
  /** column name */
  CustomsAccount = 'customs_account',
  /** column name */
  CustomsClearanceType = 'customs_clearance_type',
  /** column name */
  CustomsOffice = 'customs_office',
  /** column name */
  Declarant = 'declarant',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DispatchCountry = 'dispatch_country',
  /** column name */
  DocId = 'doc_id',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  DutyAndAdditionalTaxes = 'duty_and_additional_taxes',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GrossMass = 'gross_mass',
  /** column name */
  Importer = 'importer',
  /** column name */
  Incoterms = 'incoterms',
  /** column name */
  InvoiceCurrencyType = 'invoice_currency_type',
  /** column name */
  NumberOfGoodsItems = 'number_of_goods_items',
  /** column name */
  PackagingQuantity = 'packaging_quantity',
  /** column name */
  PreviousDocument = 'previous_document',
  /** column name */
  SpecialMention = 'special_mention',
  /** column name */
  TraderDeclarationNumber = 'trader_declaration_number',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number',
  /** column name */
  Traderreference = 'traderreference',
  /** column name */
  TransportInContainer = 'transport_in_container',
  /** column name */
  TransportMeans = 'transport_means',
  /** column name */
  ValuationSummary = 'valuation_summary',
  /** column name */
  Value = 'value',
  /** column name */
  Vat = 'vat',
  /** column name */
  VatAccount = 'vat_account',
  /** column name */
  Vatnumber = 'vatnumber',
  /** column name */
  Vatvalue = 'vatvalue'
}

/** Ordering options when selecting data from "customs_response_decoded". */
export type Customs_Response_Decoded_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  acceptance_time?: InputMaybe<Order_By>;
  access_code?: InputMaybe<Order_By>;
  consignee?: InputMaybe<Order_By>;
  consignor?: InputMaybe<Order_By>;
  customs_account?: InputMaybe<Order_By>;
  customs_clearance_type?: InputMaybe<Order_By>;
  customs_office?: InputMaybe<Order_By>;
  declarant?: InputMaybe<Order_By>;
  declaration_type?: InputMaybe<Order_By>;
  dispatch_country?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_additional_taxes?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  importer?: InputMaybe<Order_By>;
  incoterms?: InputMaybe<Order_By>;
  invoice_currency_type?: InputMaybe<Order_By>;
  number_of_goods_items?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
  previous_document?: InputMaybe<Order_By>;
  special_mention?: InputMaybe<Order_By>;
  trader_declaration_number?: InputMaybe<Order_By>;
  trader_identification_number?: InputMaybe<Order_By>;
  traderreference?: InputMaybe<Order_By>;
  transport_in_container?: InputMaybe<Order_By>;
  transport_means?: InputMaybe<Order_By>;
  valuation_summary?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
  vat_account?: InputMaybe<Order_By>;
  vatnumber?: InputMaybe<Order_By>;
  vatvalue?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "customs_response_decoded". All fields are combined with a logical 'AND'. */
export type Customs_Response_Decoded_Bool_Exp = {
  _and?: InputMaybe<Array<Customs_Response_Decoded_Bool_Exp>>;
  _not?: InputMaybe<Customs_Response_Decoded_Bool_Exp>;
  _or?: InputMaybe<Array<Customs_Response_Decoded_Bool_Exp>>;
  acceptance_date?: InputMaybe<String_Comparison_Exp>;
  acceptance_time?: InputMaybe<String_Comparison_Exp>;
  access_code?: InputMaybe<String_Comparison_Exp>;
  consignee?: InputMaybe<Jsonb_Comparison_Exp>;
  consignor?: InputMaybe<Jsonb_Comparison_Exp>;
  customs_account?: InputMaybe<Jsonb_Comparison_Exp>;
  customs_clearance_type?: InputMaybe<Numeric_Comparison_Exp>;
  customs_office?: InputMaybe<Jsonb_Comparison_Exp>;
  declarant?: InputMaybe<Jsonb_Comparison_Exp>;
  declaration_type?: InputMaybe<String_Comparison_Exp>;
  dispatch_country?: InputMaybe<String_Comparison_Exp>;
  doc_id?: InputMaybe<Uuid_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  duty_and_additional_taxes?: InputMaybe<Jsonb_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  gross_mass?: InputMaybe<Numeric_Comparison_Exp>;
  importer?: InputMaybe<Jsonb_Comparison_Exp>;
  incoterms?: InputMaybe<String_Comparison_Exp>;
  invoice_currency_type?: InputMaybe<String_Comparison_Exp>;
  number_of_goods_items?: InputMaybe<Bigint_Comparison_Exp>;
  packaging_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  previous_document?: InputMaybe<Jsonb_Comparison_Exp>;
  special_mention?: InputMaybe<Jsonb_Comparison_Exp>;
  trader_declaration_number?: InputMaybe<String_Comparison_Exp>;
  trader_identification_number?: InputMaybe<String_Comparison_Exp>;
  traderreference?: InputMaybe<String_Comparison_Exp>;
  transport_in_container?: InputMaybe<String_Comparison_Exp>;
  transport_means?: InputMaybe<Jsonb_Comparison_Exp>;
  valuation_summary?: InputMaybe<Jsonb_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
  vat?: InputMaybe<Jsonb_Comparison_Exp>;
  vat_account?: InputMaybe<Jsonb_Comparison_Exp>;
  vatnumber?: InputMaybe<String_Comparison_Exp>;
  vatvalue?: InputMaybe<Numeric_Comparison_Exp>;
};

/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_Decoded = {
  acceptance_date: Maybe<Scalars['String']>;
  acceptance_time: Maybe<Scalars['String']>;
  access_code: Maybe<Scalars['String']>;
  consignee: Maybe<Scalars['jsonb']>;
  consignor: Maybe<Scalars['jsonb']>;
  customs_account: Maybe<Scalars['jsonb']>;
  customs_clearance_type: Maybe<Scalars['numeric']>;
  customs_office: Maybe<Scalars['jsonb']>;
  declarant: Maybe<Scalars['jsonb']>;
  declaration_type: Maybe<Scalars['String']>;
  dispatch_country: Maybe<Scalars['String']>;
  doc_id: Maybe<Scalars['uuid']>;
  document_type: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  duty_and_additional_taxes: Maybe<Scalars['jsonb']>;
  file_id: Maybe<Scalars['uuid']>;
  gross_mass: Maybe<Scalars['numeric']>;
  importer: Maybe<Scalars['jsonb']>;
  incoterms: Maybe<Scalars['String']>;
  invoice_currency_type: Maybe<Scalars['String']>;
  number_of_goods_items: Maybe<Scalars['bigint']>;
  packaging_quantity: Maybe<Scalars['numeric']>;
  previous_document: Maybe<Scalars['jsonb']>;
  special_mention: Maybe<Scalars['jsonb']>;
  trader_declaration_number: Maybe<Scalars['String']>;
  trader_identification_number: Maybe<Scalars['String']>;
  traderreference: Maybe<Scalars['String']>;
  transport_in_container: Maybe<Scalars['String']>;
  transport_means: Maybe<Scalars['jsonb']>;
  valuation_summary: Maybe<Scalars['jsonb']>;
  value: Maybe<Scalars['jsonb']>;
  vat: Maybe<Scalars['jsonb']>;
  vat_account: Maybe<Scalars['jsonb']>;
  vatnumber: Maybe<Scalars['String']>;
  vatvalue: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedConsigneeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedConsignorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedCustoms_AccountArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedCustoms_OfficeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedDeclarantArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedDuty_And_Additional_TaxesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedImporterArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedPrevious_DocumentArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedSpecial_MentionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedTransport_MeansArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedValuation_SummaryArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedVatArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customs_response_decoded" */
export type Customs_Response_DecodedVat_AccountArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "customs_response_summary" */
export enum Customs_Response_Summary_Select_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AcceptanceDates = 'acceptance_dates',
  /** column name */
  AcceptanceTime = 'acceptance_time',
  /** column name */
  Consignee = 'consignee',
  /** column name */
  Consignor = 'consignor',
  /** column name */
  CustomsAccount = 'customs_account',
  /** column name */
  CustomsClearanceType = 'customs_clearance_type',
  /** column name */
  CustomsClearanceTypeDe = 'customs_clearance_type_de',
  /** column name */
  CustomsClearanceTypeEn = 'customs_clearance_type_en',
  /** column name */
  CustomsOffice = 'customs_office',
  /** column name */
  Declarant = 'declarant',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DeclarationTypeDe = 'declaration_type_de',
  /** column name */
  DeclarationTypeEn = 'declaration_type_en',
  /** column name */
  DispatchCountry = 'dispatch_country',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  DutyAndAdditionalTaxes = 'duty_and_additional_taxes',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GrossMass = 'gross_mass',
  /** column name */
  Importer = 'importer',
  /** column name */
  Incoterms = 'incoterms',
  /** column name */
  InvoiceCurrencyType = 'invoice_currency_type',
  /** column name */
  NumberOfGoodsItems = 'number_of_goods_items',
  /** column name */
  PackagingQuantity = 'packaging_quantity',
  /** column name */
  PreviousDocument = 'previous_document',
  /** column name */
  SpecialMention = 'special_mention',
  /** column name */
  SrcDocs = 'src_docs',
  /** column name */
  SrcDoctypes = 'src_doctypes',
  /** column name */
  TraderDeclarationNumber = 'trader_declaration_number',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number',
  /** column name */
  Traderreference = 'traderreference',
  /** column name */
  TransportMeans = 'transport_means',
  /** column name */
  ValuationSummary = 'valuation_summary',
  /** column name */
  Vat = 'vat',
  /** column name */
  VatAccount = 'vat_account',
  /** column name */
  Vatnumber = 'vatnumber',
  /** column name */
  Vatvalue = 'vatvalue'
}

/** select columns of table "declaration" */
export enum Declaration_Select_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AccessCode = 'access_code',
  /** column name */
  AgreedLocationOfGoods = 'agreed_location_of_goods',
  /** column name */
  AiConfirmed = 'ai_confirmed',
  /** column name */
  AiResults = 'ai_results',
  /** column name */
  BorderEauNumber = 'border_eau_number',
  /** column name */
  BunchNumber = 'bunch_number',
  /** column name */
  ChangeInformation = 'change_information',
  /** column name */
  ClearanceLocation = 'clearance_location',
  /** column name */
  CompanyNumberTaxpayer = 'company_number_taxpayer',
  /** column name */
  CorrectionCode = 'correction_code',
  /** column name */
  CorrectionReason = 'correction_reason',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsAccountAddressType = 'customs_account_address_type',
  /** column name */
  CustomsAccountName = 'customs_account_name',
  /** column name */
  CustomsAccountNumber = 'customs_account_number',
  /** column name */
  CustomsDeclarationNumber = 'customs_declaration_number',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  CustomsOfficeNumber = 'customs_office_number',
  /** column name */
  DeclarantCompanyName = 'declarant_company_name',
  /** column name */
  DeclarantNumber = 'declarant_number',
  /** column name */
  DeclarationTime = 'declaration_time',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DeliveryDestination = 'delivery_destination',
  /** column name */
  DispatchCountry = 'dispatch_country',
  /** column name */
  DispatchCountryConfirmation = 'dispatch_country_confirmation',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  DutyAndOtherTaxesAmount = 'duty_and_other_taxes_amount',
  /** column name */
  DutyTotalAmount = 'duty_total_amount',
  /** column name */
  EvvConfirmed = 'evv_confirmed',
  /** column name */
  EvvReceived = 'evv_received',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GrossMass = 'gross_mass',
  /** column name */
  Incoterms = 'incoterms',
  /** column name */
  Initiator = 'initiator',
  /** column name */
  InjunctionType = 'injunction_type',
  /** column name */
  InspectionCode = 'inspection_code',
  /** column name */
  InvoiceCurrencyType = 'invoice_currency_type',
  /** column name */
  Lang = 'lang',
  /** column name */
  MaterialCheck = 'material_check',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  PackagingQuantity = 'packaging_quantity',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  PlaceOfLoading = 'place_of_loading',
  /** column name */
  PlaceOfUnloading = 'place_of_unloading',
  /** column name */
  PostalShipmentType = 'postal_shipment_type',
  /** column name */
  ProcedureType = 'procedure_type',
  /** column name */
  ProvisionalDeclarationExpirationDate = 'provisional_declaration_expiration_date',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReceiveStatus = 'receive_status',
  /** column name */
  Release = 'release',
  /** column name */
  RequestorTraderIdentificationNumber = 'requestor_trader_identification_number',
  /** column name */
  Security = 'security',
  /** column name */
  SelectionCorrelationId = 'selection_correlation_id',
  /** column name */
  SendDate = 'send_date',
  /** column name */
  SendStatus = 'send_status',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  ShowInWd = 'show_in_wd',
  /** column name */
  SpecificCircumstanceIndicator = 'specific_circumstance_indicator',
  /** column name */
  Status = 'status',
  /** column name */
  StatusDate = 'status_date',
  /** column name */
  StatusTime = 'status_time',
  /** column name */
  TaraFactor = 'tara_factor',
  /** column name */
  TotalColis = 'total_colis',
  /** column name */
  TotalGoodsItems = 'total_goods_items',
  /** column name */
  TotalGrossWeight = 'total_gross_weight',
  /** column name */
  TotalVatValue = 'total_vat_value',
  /** column name */
  TraderDeclarationNumber = 'trader_declaration_number',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number',
  /** column name */
  TraderReference = 'trader_reference',
  /** column name */
  TransferToTransitSystem = 'transfer_to_transit_system',
  /** column name */
  TransportCountry = 'transport_country',
  /** column name */
  TransportInContainer = 'transport_in_container',
  /** column name */
  TransportMode = 'transport_mode',
  /** column name */
  TransportNumber = 'transport_number',
  /** column name */
  TransportType = 'transport_type',
  /** column name */
  UniqueConsignmentReferenceNumber = 'unique_consignment_reference_number',
  /** column name */
  VatAccountAddressType = 'vat_account_address_type',
  /** column name */
  VatAccountName = 'vat_account_name',
  /** column name */
  VatAccountNumber = 'vat_account_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  VatSuffix = 'vat_suffix',
  /** column name */
  VatTotalAmount = 'vat_total_amount',
  /** column name */
  WarehouseCoded = 'warehouse_coded'
}

/** select columns of table "declaration_discussions" */
export enum Declaration_Discussions_Select_Column {
  /** column name */
  Closed = 'closed',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DiscussionId = 'discussion_id',
  /** column name */
  DiscussionTheme = 'discussion_theme',
  /** column name */
  FileId = 'file_id',
  /** column name */
  LastReadDate = 'last_read_date',
  /** column name */
  LiberUser = 'liber_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Reference = 'reference'
}

/** Ordering options when selecting data from "declaration_discussions". */
export type Declaration_Discussions_Order_By = {
  closed?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  discussion_id?: InputMaybe<Order_By>;
  discussion_theme?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  last_read_date?: InputMaybe<Order_By>;
  liber_user?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Declaration_Message_Aggregate_Order_By>;
  meta?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "declaration_discussions". All fields are combined with a logical 'AND'. */
export type Declaration_Discussions_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Discussions_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Discussions_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Discussions_Bool_Exp>>;
  closed?: InputMaybe<Boolean_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  discussion_id?: InputMaybe<Bigint_Comparison_Exp>;
  discussion_theme?: InputMaybe<String_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  last_read_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  liber_user?: InputMaybe<String_Comparison_Exp>;
  messages?: InputMaybe<Declaration_Message_Bool_Exp>;
  messages_aggregate?: InputMaybe<Declaration_Message_Aggregate_Bool_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
};

/** Discussions related to files/declarations. Prefer use this view instead of this table. */
export type Declaration_Discussions = {
  closed: Maybe<Scalars['Boolean']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  discussion_id: Maybe<Scalars['bigint']>;
  discussion_theme: Maybe<Scalars['String']>;
  file_id: Maybe<Scalars['uuid']>;
  last_read_date: Maybe<Scalars['timestamptz']>;
  liber_user: Maybe<Scalars['String']>;
  /** An array relationship */
  messages: Array<Declaration_Message>;
  /** An aggregate relationship */
  messages_aggregate: Declaration_Message_Aggregate;
  meta: Maybe<Scalars['jsonb']>;
  reference: Maybe<Scalars['String']>;
};


/** Discussions related to files/declarations. Prefer use this view instead of this table. */
export type Declaration_DiscussionsMessagesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


/** Discussions related to files/declarations. Prefer use this view instead of this table. */
export type Declaration_DiscussionsMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


/** Discussions related to files/declarations. Prefer use this view instead of this table. */
export type Declaration_DiscussionsMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "declaration_request_address_ai" */
export enum Declaration_Request_Address_Ai_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id'
}

/** Ordering options when selecting data from "declaration_request_address_ai". */
export type Declaration_Request_Address_Ai_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "declaration_request_address_ai". All fields are combined with a logical 'AND'. */
export type Declaration_Request_Address_Ai_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Request_Address_Ai_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Request_Address_Ai_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Request_Address_Ai_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  address_type?: InputMaybe<Int_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "declaration_request_address_ai" */
export type Declaration_Request_Address_Ai = {
  /** An object relationship */
  address: Maybe<Address>;
  address_id: Scalars['Int'];
  address_type: Scalars['Int'];
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  id: Scalars['Int'];
};

/** select columns of table "declaration_requests" */
export enum Declaration_Requests_Select_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  ArrivalTime = 'arrival_time',
  /** column name */
  ArrivalType = 'arrival_type',
  /** column name */
  AutoclassifiedDocsQty = 'autoclassified_docs_qty',
  /** column name */
  ChExpDecl = 'ch_exp_decl',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsDeclarationNumber = 'customs_declaration_number',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  DeclarationStatus = 'declaration_status',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DestTolldeptCode = 'dest_tolldept_code',
  /** column name */
  DestTolldeptName = 'dest_tolldept_name',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  Eta = 'eta',
  /** column name */
  FileId = 'file_id',
  /** column name */
  ImpCustClr = 'imp_cust_clr',
  /** column name */
  IsExpress = 'is_express',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  Meta = 'meta',
  /** column name */
  NonclassifiedDocsExists = 'nonclassified_docs_exists',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  PermissionsJs = 'permissions_js',
  /** column name */
  Qty = 'qty',
  /** column name */
  Reference = 'reference',
  /** column name */
  RowNumber = 'row_number',
  /** column name */
  TollDep = 'toll_dep',
  /** column name */
  TrNo = 'tr_no',
  /** column name */
  TraderReference = 'trader_reference',
  /** column name */
  TransitdocType = 'transitdoc_type',
  /** column name */
  WaNumber = 'wa_number'
}

/** Ordering options when selecting data from "declaration_requests". */
export type Declaration_Requests_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  addresses_aggregate?: InputMaybe<Declaration_Request_Address_Aggregate_Order_By>;
  arrival_time?: InputMaybe<Order_By>;
  arrival_type?: InputMaybe<Order_By>;
  autoclassified_docs_qty?: InputMaybe<Order_By>;
  ch_exp_decl?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_number?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_response_data_aggregate?: InputMaybe<Customs_Response_Data_Aggregate_Order_By>;
  customsOffice?: InputMaybe<Customs_Offices_Order_By>;
  customsResponseGoodsItems_aggregate?: InputMaybe<Customs_Response_Goods_Items_Aggregate_Order_By>;
  customsResponseSummary?: InputMaybe<Customs_Response_Summary_Order_By>;
  declaration_discussions_aggregate?: InputMaybe<Declaration_Discussion_Aggregate_Order_By>;
  declaration_labels_aggregate?: InputMaybe<Declaration_Request_Labels_Aggregate_Order_By>;
  declaration_status?: InputMaybe<Order_By>;
  declaration_type?: InputMaybe<Order_By>;
  dest_tolldept_code?: InputMaybe<Order_By>;
  dest_tolldept_name?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  eta?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  file_id?: InputMaybe<Order_By>;
  goodsItems_aggregate?: InputMaybe<Dr_Goods_Item_Aggregate_Order_By>;
  imp_cust_clr?: InputMaybe<Order_By>;
  is_express?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  nonclassified_docs_exists?: InputMaybe<Order_By>;
  payer?: InputMaybe<Tenant_Order_By>;
  payer_id?: InputMaybe<Order_By>;
  permissions_js?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  row_number?: InputMaybe<Order_By>;
  toll_dep?: InputMaybe<Order_By>;
  tr_no?: InputMaybe<Order_By>;
  trader_reference?: InputMaybe<Order_By>;
  transitdoc_type?: InputMaybe<Order_By>;
  user_pp?: InputMaybe<User_Pp_Order_By>;
  wa_number?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "customs_response_data" */
export type Customs_Response_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Customs_Response_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customs_Response_Data_Max_Order_By>;
  min?: InputMaybe<Customs_Response_Data_Min_Order_By>;
  stddev?: InputMaybe<Customs_Response_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Customs_Response_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Customs_Response_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Customs_Response_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Customs_Response_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Customs_Response_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Customs_Response_Data_Variance_Order_By>;
};

/** order by avg() on columns of table "customs_response_data" */
export type Customs_Response_Data_Avg_Order_By = {
  correction_code?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "customs_response_data" */
export type Customs_Response_Data_Max_Order_By = {
  correction_code?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "customs_response_data" */
export type Customs_Response_Data_Min_Order_By = {
  correction_code?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "customs_response_data" */
export type Customs_Response_Data_Stddev_Order_By = {
  correction_code?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "customs_response_data" */
export type Customs_Response_Data_Stddev_Pop_Order_By = {
  correction_code?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "customs_response_data" */
export type Customs_Response_Data_Stddev_Samp_Order_By = {
  correction_code?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "customs_response_data" */
export type Customs_Response_Data_Sum_Order_By = {
  correction_code?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "customs_response_data" */
export type Customs_Response_Data_Var_Pop_Order_By = {
  correction_code?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "customs_response_data" */
export type Customs_Response_Data_Var_Samp_Order_By = {
  correction_code?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "customs_response_data" */
export type Customs_Response_Data_Variance_Order_By = {
  correction_code?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "declaration_requests". All fields are combined with a logical 'AND'. */
export type Declaration_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Requests_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Requests_Bool_Exp>>;
  acceptance_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  addresses?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
  arrival_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  arrival_type?: InputMaybe<String_Comparison_Exp>;
  autoclassified_docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  ch_exp_decl?: InputMaybe<Boolean_Comparison_Exp>;
  clearance_type?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_declaration_number?: InputMaybe<String_Comparison_Exp>;
  customs_declaration_version?: InputMaybe<Smallint_Comparison_Exp>;
  customs_response_data?: InputMaybe<Customs_Response_Data_Bool_Exp>;
  customsOffice?: InputMaybe<Customs_Offices_Bool_Exp>;
  customsResponseGoodsItems?: InputMaybe<Customs_Response_Goods_Items_Bool_Exp>;
  customsResponseGoodsItems_aggregate?: InputMaybe<Customs_Response_Goods_Items_Aggregate_Bool_Exp>;
  customsResponseSummary?: InputMaybe<Customs_Response_Summary_Bool_Exp>;
  declaration_discussions?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  declaration_discussions_aggregate?: InputMaybe<Declaration_Discussion_Aggregate_Bool_Exp>;
  declaration_labels?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
  declaration_status?: InputMaybe<String_Comparison_Exp>;
  declaration_type?: InputMaybe<String_Comparison_Exp>;
  dest_tolldept_code?: InputMaybe<String_Comparison_Exp>;
  dest_tolldept_name?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  eta?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  goodsItems?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
  goodsItems_aggregate?: InputMaybe<Dr_Goods_Item_Aggregate_Bool_Exp>;
  imp_cust_clr?: InputMaybe<Boolean_Comparison_Exp>;
  is_express?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  nonclassified_docs_exists?: InputMaybe<Boolean_Comparison_Exp>;
  payer?: InputMaybe<Tenant_Bool_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  permissions_js?: InputMaybe<Json_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  row_number?: InputMaybe<Bigint_Comparison_Exp>;
  toll_dep?: InputMaybe<String_Comparison_Exp>;
  tr_no?: InputMaybe<String_Comparison_Exp>;
  trader_reference?: InputMaybe<String_Comparison_Exp>;
  transitdoc_type?: InputMaybe<Transitdoc_Type_Comparison_Exp>;
  user_pp?: InputMaybe<User_Pp_Bool_Exp>;
  wa_number?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "declaration_requests" */
export type Declaration_Requests = {
  acceptance_date: Maybe<Scalars['timestamptz']>;
  account_number: Maybe<Scalars['String']>;
  /** An array relationship */
  addresses: Array<Declaration_Request_Address>;
  arrival_time: Maybe<Scalars['timestamptz']>;
  arrival_type: Maybe<Scalars['String']>;
  autoclassified_docs_qty: Maybe<Scalars['bigint']>;
  ch_exp_decl: Maybe<Scalars['Boolean']>;
  clearance_type: Scalars['String'];
  creation_date: Scalars['timestamptz'];
  creation_user: Scalars['uuid'];
  customs_declaration_number: Maybe<Scalars['String']>;
  customs_declaration_version: Maybe<Scalars['smallint']>;
  /** fetch data from the table: "customs_response_data" */
  customs_response_data: Array<Customs_Response_Data>;
  /** An object relationship */
  customsOffice: Maybe<Customs_Offices>;
  /** An array relationship */
  customsResponseGoodsItems: Array<Customs_Response_Goods_Items>;
  /** An aggregate relationship */
  customsResponseGoodsItems_aggregate: Customs_Response_Goods_Items_Aggregate;
  /** An object relationship */
  customsResponseSummary: Maybe<Customs_Response_Summary>;
  /** An array relationship */
  declaration_discussions: Array<Declaration_Discussion>;
  /** An aggregate relationship */
  declaration_discussions_aggregate: Declaration_Discussion_Aggregate;
  /** An array relationship */
  declaration_labels: Array<Declaration_Request_Labels>;
  declaration_status: Scalars['String'];
  declaration_type: Scalars['String'];
  dest_tolldept_code: Maybe<Scalars['String']>;
  dest_tolldept_name: Maybe<Scalars['String']>;
  dr_no: Scalars['smallint'];
  eta: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  file: Maybe<File>;
  file_id: Scalars['uuid'];
  /** An array relationship */
  goodsItems: Array<Dr_Goods_Item>;
  /** An aggregate relationship */
  goodsItems_aggregate: Dr_Goods_Item_Aggregate;
  imp_cust_clr: Maybe<Scalars['Boolean']>;
  is_express: Scalars['Boolean'];
  last_modified_date: Maybe<Scalars['timestamptz']>;
  meta: Scalars['jsonb'];
  nonclassified_docs_exists: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  payer: Maybe<Tenant>;
  payer_id: Scalars['uuid'];
  permissions_js: Maybe<Scalars['json']>;
  qty: Maybe<Scalars['bigint']>;
  reference: Maybe<Scalars['String']>;
  row_number: Maybe<Scalars['bigint']>;
  toll_dep: Maybe<Scalars['String']>;
  tr_no: Maybe<Scalars['String']>;
  trader_reference: Maybe<Scalars['String']>;
  transitdoc_type: Maybe<Scalars['transitdoc_type']>;
  /** An object relationship */
  user_pp: Maybe<User_Pp>;
  wa_number: Maybe<Scalars['String']>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsAddressesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsCustoms_Response_DataArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Data_Order_By>>;
  where?: InputMaybe<Customs_Response_Data_Bool_Exp>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsCustomsResponseGoodsItemsArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Goods_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Goods_Items_Order_By>>;
  where?: InputMaybe<Customs_Response_Goods_Items_Bool_Exp>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsCustomsResponseGoodsItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Goods_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Goods_Items_Order_By>>;
  where?: InputMaybe<Customs_Response_Goods_Items_Bool_Exp>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsDeclaration_DiscussionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsDeclaration_Discussions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsDeclaration_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsGoodsItemsArgs = {
  distinct_on?: InputMaybe<Array<Dr_Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Item_Order_By>>;
  where?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsGoodsItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dr_Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Item_Order_By>>;
  where?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsPermissions_JsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "declaration_search" */
export enum Declaration_Search_Select_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  ArrivalTime = 'arrival_time',
  /** column name */
  ArrivalType = 'arrival_type',
  /** column name */
  AutoclassifiedDocsQty = 'autoclassified_docs_qty',
  /** column name */
  ClassifiedDocsQty = 'classified_docs_qty',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DeclarationStatus = 'declaration_status',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DocsQty = 'docs_qty',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  Eta = 'eta',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Identification = 'identification',
  /** column name */
  IsExpress = 'is_express',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  NonclassifiedDocsExists = 'nonclassified_docs_exists',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  Reference = 'reference',
  /** column name */
  UserDisplayName = 'user_display_name',
  /** column name */
  WaNumber = 'wa_number'
}

/** Ordering options when selecting data from "declaration_search". */
export type Declaration_Search_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  addresses_aggregate?: InputMaybe<Declaration_Request_Address_Aggregate_Order_By>;
  arrival_time?: InputMaybe<Order_By>;
  arrival_type?: InputMaybe<Order_By>;
  arrivalType?: InputMaybe<Arrival_Type_Order_By>;
  autoclassified_docs_qty?: InputMaybe<Order_By>;
  classified_docs_qty?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  declaration_status?: InputMaybe<Order_By>;
  declaration_type?: InputMaybe<Order_By>;
  declarationDiscussions_aggregate?: InputMaybe<Declaration_Discussion_Aggregate_Order_By>;
  docs_qty?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  eta?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  file_id?: InputMaybe<Order_By>;
  goodsItems_aggregate?: InputMaybe<Dr_Goods_Item_Aggregate_Order_By>;
  identification?: InputMaybe<Order_By>;
  is_express?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  nonclassified_docs_exists?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
  user_display_name?: InputMaybe<Order_By>;
  wa_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "declaration_search". All fields are combined with a logical 'AND'. */
export type Declaration_Search_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Search_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Search_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Search_Bool_Exp>>;
  acceptance_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  addresses?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
  arrival_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  arrival_type?: InputMaybe<String_Comparison_Exp>;
  arrivalType?: InputMaybe<Arrival_Type_Bool_Exp>;
  autoclassified_docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  classified_docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  clearance_type?: InputMaybe<String_Comparison_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declaration_status?: InputMaybe<String_Comparison_Exp>;
  declaration_type?: InputMaybe<String_Comparison_Exp>;
  declarationDiscussions?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  declarationDiscussions_aggregate?: InputMaybe<Declaration_Discussion_Aggregate_Bool_Exp>;
  docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  eta?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  goodsItems?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
  goodsItems_aggregate?: InputMaybe<Dr_Goods_Item_Aggregate_Bool_Exp>;
  identification?: InputMaybe<String_Comparison_Exp>;
  is_express?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  nonclassified_docs_exists?: InputMaybe<Boolean_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
  user_display_name?: InputMaybe<String_Comparison_Exp>;
  wa_number?: InputMaybe<String_Comparison_Exp>;
};

/** View that used as return type `SETOF` for [pp_declarations](DB/functions/pp_declarations). By itself - not very useful */
export type Declaration_Search = {
  acceptance_date: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  addresses: Array<Declaration_Request_Address>;
  arrival_time: Maybe<Scalars['timestamptz']>;
  arrival_type: Maybe<Scalars['String']>;
  /** An object relationship */
  arrivalType: Maybe<Arrival_Type>;
  autoclassified_docs_qty: Maybe<Scalars['bigint']>;
  classified_docs_qty: Maybe<Scalars['bigint']>;
  clearance_type: Scalars['String'];
  company_id: Maybe<Scalars['Int']>;
  company_name: Maybe<Scalars['String']>;
  creation_date: Scalars['timestamptz'];
  creation_user: Scalars['uuid'];
  declaration_status: Scalars['String'];
  declaration_type: Scalars['String'];
  /** An array relationship */
  declarationDiscussions: Array<Declaration_Discussion>;
  /** An aggregate relationship */
  declarationDiscussions_aggregate: Declaration_Discussion_Aggregate;
  docs_qty: Maybe<Scalars['bigint']>;
  dr_no: Scalars['smallint'];
  eta: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  file: Maybe<File>;
  file_id: Scalars['uuid'];
  /** An array relationship */
  goodsItems: Array<Dr_Goods_Item>;
  /** An aggregate relationship */
  goodsItems_aggregate: Dr_Goods_Item_Aggregate;
  identification: Maybe<Scalars['String']>;
  is_express: Scalars['Boolean'];
  last_modified_date: Maybe<Scalars['timestamptz']>;
  nonclassified_docs_exists: Maybe<Scalars['Boolean']>;
  org_id: Maybe<Scalars['smallint']>;
  qty: Maybe<Scalars['bigint']>;
  reference: Maybe<Scalars['String']>;
  /** An object relationship */
  user: Maybe<User_Pp>;
  user_display_name: Maybe<Scalars['String']>;
  wa_number: Maybe<Scalars['String']>;
};


/** View that used as return type `SETOF` for [pp_declarations](DB/functions/pp_declarations). By itself - not very useful */
export type Declaration_SearchAddressesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


/** View that used as return type `SETOF` for [pp_declarations](DB/functions/pp_declarations). By itself - not very useful */
export type Declaration_SearchDeclarationDiscussionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


/** View that used as return type `SETOF` for [pp_declarations](DB/functions/pp_declarations). By itself - not very useful */
export type Declaration_SearchDeclarationDiscussions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


/** View that used as return type `SETOF` for [pp_declarations](DB/functions/pp_declarations). By itself - not very useful */
export type Declaration_SearchGoodsItemsArgs = {
  distinct_on?: InputMaybe<Array<Dr_Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Item_Order_By>>;
  where?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
};


/** View that used as return type `SETOF` for [pp_declarations](DB/functions/pp_declarations). By itself - not very useful */
export type Declaration_SearchGoodsItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dr_Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Item_Order_By>>;
  where?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
};

/** select columns of table "declaration_status" */
export enum Declaration_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** select columns of table "declaration_tasks" */
export enum Declaration_Tasks_Select_Column {
  /** column name */
  AssignedTo = 'assigned_to',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  Rn = 'rn',
  /** column name */
  TaskStatusId = 'task_status_id',
  /** column name */
  TaskTypeId = 'task_type_id',
  /** column name */
  Title = 'title'
}

/** Ordering options when selecting data from "declaration_tasks". */
export type Declaration_Tasks_Order_By = {
  assigned_to?: InputMaybe<Order_By>;
  assigned_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  due_date?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  rn?: InputMaybe<Order_By>;
  task_status_id?: InputMaybe<Order_By>;
  task_type?: InputMaybe<Task_Type_Order_By>;
  task_type_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "declaration_tasks". All fields are combined with a logical 'AND'. */
export type Declaration_Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Tasks_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Tasks_Bool_Exp>>;
  assigned_to?: InputMaybe<Uuid_Comparison_Exp>;
  assigned_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  object_id?: InputMaybe<Uuid_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  rn?: InputMaybe<Bigint_Comparison_Exp>;
  task_status_id?: InputMaybe<Int_Comparison_Exp>;
  task_type?: InputMaybe<Task_Type_Bool_Exp>;
  task_type_id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "declaration_tasks" */
export type Declaration_Tasks = {
  assigned_to: Maybe<Scalars['uuid']>;
  /** An object relationship */
  assigned_user: Maybe<User_Pp>;
  creation_date: Scalars['timestamptz'];
  /** An object relationship */
  document: Maybe<Document>;
  due_date: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  file: Maybe<File>;
  id: Scalars['Int'];
  meta: Scalars['jsonb'];
  object_id: Scalars['uuid'];
  qty: Maybe<Scalars['bigint']>;
  rn: Maybe<Scalars['bigint']>;
  task_status_id: Scalars['Int'];
  /** An object relationship */
  task_type: Maybe<Task_Type>;
  task_type_id: Scalars['Int'];
  title: Scalars['String'];
};


/** columns and relationships of "declaration_tasks" */
export type Declaration_TasksMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "declaration_tasks_obj" */
export enum Declaration_Tasks_Obj_Select_Column {
  /** column name */
  Tasks = 'tasks',
  /** column name */
  TotalFinished = 'total_finished',
  /** column name */
  TotalOpened = 'total_opened'
}

/** Ordering options when selecting data from "declaration_tasks_obj". */
export type Declaration_Tasks_Obj_Order_By = {
  tasks?: InputMaybe<Order_By>;
  total_finished?: InputMaybe<Order_By>;
  total_opened?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "declaration_tasks_obj". All fields are combined with a logical 'AND'. */
export type Declaration_Tasks_Obj_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Tasks_Obj_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Tasks_Obj_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Tasks_Obj_Bool_Exp>>;
  tasks?: InputMaybe<_Declaration_Tasks_Data_Comparison_Exp>;
  total_finished?: InputMaybe<Bigint_Comparison_Exp>;
  total_opened?: InputMaybe<Bigint_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "_declaration_tasks_data". All fields are combined with logical 'AND'. */
export type _Declaration_Tasks_Data_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_declaration_tasks_data']>;
  _gt?: InputMaybe<Scalars['_declaration_tasks_data']>;
  _gte?: InputMaybe<Scalars['_declaration_tasks_data']>;
  _in?: InputMaybe<Array<Scalars['_declaration_tasks_data']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_declaration_tasks_data']>;
  _lte?: InputMaybe<Scalars['_declaration_tasks_data']>;
  _neq?: InputMaybe<Scalars['_declaration_tasks_data']>;
  _nin?: InputMaybe<Array<Scalars['_declaration_tasks_data']>>;
};

/** columns and relationships of "declaration_tasks_obj" */
export type Declaration_Tasks_Obj = {
  tasks: Maybe<Scalars['_declaration_tasks_data']>;
  total_finished: Maybe<Scalars['bigint']>;
  total_opened: Maybe<Scalars['bigint']>;
};

/** select columns of table "declaration_type" */
export enum Declaration_Type_Select_Column {
  /** column name */
  DocumentSchema = 'document_schema',
  /** column name */
  Name = 'name'
}

/** select columns of table "discussion_changes" */
export enum Discussion_Changes_Select_Column {
  /** column name */
  AditUser = 'adit_user',
  /** column name */
  DeclarationStatus = 'declaration_status',
  /** column name */
  DiscussionClosed = 'discussion_closed',
  /** column name */
  DiscussionId = 'discussion_id',
  /** column name */
  DiscussionTheme = 'discussion_theme',
  /** column name */
  FileId = 'file_id',
  /** column name */
  FileName = 'file_name',
  /** column name */
  LastMsgDate = 'last_msg_date',
  /** column name */
  LastUser = 'last_user',
  /** column name */
  LiberUser = 'liber_user',
  /** column name */
  Reference = 'reference'
}

/** Ordering options when selecting data from "discussion_changes". */
export type Discussion_Changes_Order_By = {
  adit_user?: InputMaybe<Order_By>;
  aditUser?: InputMaybe<User_Pp_Order_By>;
  declaration_status?: InputMaybe<Order_By>;
  discussion_closed?: InputMaybe<Order_By>;
  discussion_id?: InputMaybe<Order_By>;
  discussion_theme?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  last_msg_date?: InputMaybe<Order_By>;
  last_user?: InputMaybe<Order_By>;
  liber_user?: InputMaybe<Order_By>;
  liberUser?: InputMaybe<User_Pp_Order_By>;
  messages_aggregate?: InputMaybe<Declaration_Message_Aggregate_Order_By>;
  reference?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "discussion_changes". All fields are combined with a logical 'AND'. */
export type Discussion_Changes_Bool_Exp = {
  _and?: InputMaybe<Array<Discussion_Changes_Bool_Exp>>;
  _not?: InputMaybe<Discussion_Changes_Bool_Exp>;
  _or?: InputMaybe<Array<Discussion_Changes_Bool_Exp>>;
  adit_user?: InputMaybe<Uuid_Comparison_Exp>;
  aditUser?: InputMaybe<User_Pp_Bool_Exp>;
  declaration_status?: InputMaybe<String_Comparison_Exp>;
  discussion_closed?: InputMaybe<Boolean_Comparison_Exp>;
  discussion_id?: InputMaybe<Bigint_Comparison_Exp>;
  discussion_theme?: InputMaybe<String_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  last_msg_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_user?: InputMaybe<Uuid_Comparison_Exp>;
  liber_user?: InputMaybe<Uuid_Comparison_Exp>;
  liberUser?: InputMaybe<User_Pp_Bool_Exp>;
  messages?: InputMaybe<Declaration_Message_Bool_Exp>;
  messages_aggregate?: InputMaybe<Declaration_Message_Aggregate_Bool_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
};

/** View that detects changes in declaration discussions. */
export type Discussion_Changes = {
  adit_user: Maybe<Scalars['uuid']>;
  /** An object relationship */
  aditUser: Maybe<User_Pp>;
  declaration_status: Maybe<Scalars['String']>;
  discussion_closed: Maybe<Scalars['Boolean']>;
  discussion_id: Maybe<Scalars['bigint']>;
  discussion_theme: Maybe<Scalars['String']>;
  file_id: Maybe<Scalars['uuid']>;
  file_name: Maybe<Scalars['String']>;
  last_msg_date: Maybe<Scalars['timestamptz']>;
  last_user: Maybe<Scalars['uuid']>;
  liber_user: Maybe<Scalars['uuid']>;
  /** An object relationship */
  liberUser: Maybe<User_Pp>;
  /** An array relationship */
  messages: Array<Declaration_Message>;
  /** An aggregate relationship */
  messages_aggregate: Declaration_Message_Aggregate;
  reference: Maybe<Scalars['String']>;
};


/** View that detects changes in declaration discussions. */
export type Discussion_ChangesMessagesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


/** View that detects changes in declaration discussions. */
export type Discussion_ChangesMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};

/** select columns of table "doc_search_type" */
export enum Doc_Search_Type_Select_Column {
  /** column name */
  Checksum = 'checksum',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DocumentBlobs = 'document_blobs',
  /** column name */
  DocumentExtension = 'document_extension',
  /** column name */
  DocumentFlags = 'document_flags',
  /** column name */
  DocumentName = 'document_name',
  /** column name */
  DocumentStatus = 'document_status',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumberOfPages = 'number_of_pages',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgIdDescription = 'org_id_description',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  TotalRows = 'total_rows',
  /** column name */
  UserCode = 'user_code',
  /** column name */
  UserDisplayName = 'user_display_name'
}

/** Ordering options when selecting data from "doc_search_type". */
export type Doc_Search_Type_Order_By = {
  checksum?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  document_blobs?: InputMaybe<Order_By>;
  document_extension?: InputMaybe<Order_By>;
  document_flags?: InputMaybe<Order_By>;
  document_name?: InputMaybe<Order_By>;
  document_status?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  file?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_generated?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  number_of_pages?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_id_description?: InputMaybe<Order_By>;
  pages_m2m_aggregate?: InputMaybe<Document_Page_Aggregate_Order_By>;
  sequence?: InputMaybe<Order_By>;
  total_rows?: InputMaybe<Order_By>;
  user_code?: InputMaybe<Order_By>;
  user_display_name?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "doc_search_type". All fields are combined with a logical 'AND'. */
export type Doc_Search_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Search_Type_Bool_Exp>>;
  _not?: InputMaybe<Doc_Search_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Search_Type_Bool_Exp>>;
  checksum?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  document_blobs?: InputMaybe<Jsonb_Comparison_Exp>;
  document_extension?: InputMaybe<String_Comparison_Exp>;
  document_flags?: InputMaybe<Bigint_Comparison_Exp>;
  document_name?: InputMaybe<String_Comparison_Exp>;
  document_status?: InputMaybe<String_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_generated?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  number_of_pages?: InputMaybe<Smallint_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  org_id_description?: InputMaybe<String_Comparison_Exp>;
  pages_m2m?: InputMaybe<Document_Page_Bool_Exp>;
  pages_m2m_aggregate?: InputMaybe<Document_Page_Aggregate_Bool_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
  total_rows?: InputMaybe<Bigint_Comparison_Exp>;
  user_code?: InputMaybe<String_Comparison_Exp>;
  user_display_name?: InputMaybe<String_Comparison_Exp>;
};

/** SETOF-type from pp_doc_search% functions. */
export type Doc_Search_Type = {
  checksum: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  document_blobs: Maybe<Scalars['jsonb']>;
  document_extension: Maybe<Scalars['String']>;
  document_flags: Maybe<Scalars['bigint']>;
  document_name: Maybe<Scalars['String']>;
  document_status: Maybe<Scalars['String']>;
  document_type: Maybe<Scalars['String']>;
  file: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  is_deleted: Maybe<Scalars['Boolean']>;
  is_generated: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  number_of_pages: Maybe<Scalars['smallint']>;
  org_id: Maybe<Scalars['smallint']>;
  org_id_description: Maybe<Scalars['String']>;
  /** An array relationship */
  pages_m2m: Array<Document_Page>;
  /** An aggregate relationship */
  pages_m2m_aggregate: Document_Page_Aggregate;
  sequence: Maybe<Scalars['Int']>;
  total_rows: Maybe<Scalars['bigint']>;
  user_code: Maybe<Scalars['String']>;
  user_display_name: Maybe<Scalars['String']>;
};


/** SETOF-type from pp_doc_search% functions. */
export type Doc_Search_TypeDocument_BlobsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** SETOF-type from pp_doc_search% functions. */
export type Doc_Search_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** SETOF-type from pp_doc_search% functions. */
export type Doc_Search_TypePages_M2mArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


/** SETOF-type from pp_doc_search% functions. */
export type Doc_Search_TypePages_M2m_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};

/** select columns of table "doc_stats_type" */
export enum Doc_Stats_Type_Select_Column {
  /** column name */
  DocsQty = 'docs_qty',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  TotalPages = 'total_pages',
  /** column name */
  UsersQty = 'users_qty'
}

/** Ordering options when selecting data from "doc_stats_type". */
export type Doc_Stats_Type_Order_By = {
  docs_qty?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  total_pages?: InputMaybe<Order_By>;
  users_qty?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "doc_stats_type". All fields are combined with a logical 'AND'. */
export type Doc_Stats_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Stats_Type_Bool_Exp>>;
  _not?: InputMaybe<Doc_Stats_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Stats_Type_Bool_Exp>>;
  docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  total_pages?: InputMaybe<Bigint_Comparison_Exp>;
  users_qty?: InputMaybe<Bigint_Comparison_Exp>;
};

/** SETOF-type used used in pp_doc_stats. */
export type Doc_Stats_Type = {
  docs_qty: Maybe<Scalars['bigint']>;
  document_type: Maybe<Scalars['String']>;
  total_pages: Maybe<Scalars['bigint']>;
  users_qty: Maybe<Scalars['bigint']>;
};

/** select columns of table "docs_for_validation" */
export enum Docs_For_Validation_Select_Column {
  /** column name */
  Checksum = 'checksum',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DocOrder = 'doc_order',
  /** column name */
  DocumentBlobs = 'document_blobs',
  /** column name */
  DocumentExtension = 'document_extension',
  /** column name */
  DocumentFlags = 'document_flags',
  /** column name */
  DocumentName = 'document_name',
  /** column name */
  DocumentStatus = 'document_status',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  IsCustomsRelevant = 'is_customs_relevant',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumberOfPages = 'number_of_pages',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Sequence = 'sequence'
}

/** Ordering options when selecting data from "docs_for_validation". */
export type Docs_For_Validation_Order_By = {
  checksum?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  doc_order?: InputMaybe<Order_By>;
  document_blobs?: InputMaybe<Order_By>;
  document_extension?: InputMaybe<Order_By>;
  document_flags?: InputMaybe<Order_By>;
  document_name?: InputMaybe<Order_By>;
  document_status?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  file?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_customs_relevant?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_generated?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  number_of_pages?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/** Boolean expression to filter rows from the table "docs_for_validation". All fields are combined with a logical 'AND'. */
export type Docs_For_Validation_Bool_Exp = {
  _and?: InputMaybe<Array<Docs_For_Validation_Bool_Exp>>;
  _not?: InputMaybe<Docs_For_Validation_Bool_Exp>;
  _or?: InputMaybe<Array<Docs_For_Validation_Bool_Exp>>;
  checksum?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  doc_order?: InputMaybe<Bigint_Comparison_Exp>;
  document_blobs?: InputMaybe<Jsonb_Comparison_Exp>;
  document_extension?: InputMaybe<String_Comparison_Exp>;
  document_flags?: InputMaybe<Bigint_Comparison_Exp>;
  document_name?: InputMaybe<String_Comparison_Exp>;
  document_status?: InputMaybe<String_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_customs_relevant?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_generated?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  number_of_pages?: InputMaybe<Smallint_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

/**
 * Documents for validation.
 *
 * Returned in order:
 * - `file`
 * - `document_type`
 * - `sequence`
 *
 *
 */
export type Docs_For_Validation = {
  checksum: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  doc_order: Maybe<Scalars['bigint']>;
  document_blobs: Maybe<Scalars['jsonb']>;
  document_extension: Maybe<Scalars['String']>;
  document_flags: Maybe<Scalars['bigint']>;
  document_name: Maybe<Scalars['String']>;
  document_status: Maybe<Scalars['String']>;
  document_type: Maybe<Scalars['String']>;
  file: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  is_customs_relevant: Maybe<Scalars['Boolean']>;
  is_deleted: Maybe<Scalars['Boolean']>;
  is_generated: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  number_of_pages: Maybe<Scalars['smallint']>;
  org_id: Maybe<Scalars['smallint']>;
  sequence: Maybe<Scalars['Int']>;
  /** An object relationship */
  user: Maybe<User_Pp>;
};


/**
 * Documents for validation.
 *
 * Returned in order:
 * - `file`
 * - `document_type`
 * - `sequence`
 *
 *
 */
export type Docs_For_ValidationDocument_BlobsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/**
 * Documents for validation.
 *
 * Returned in order:
 * - `file`
 * - `document_type`
 * - `sequence`
 *
 *
 */
export type Docs_For_ValidationMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "document_extension" */
export enum Document_Extension_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Name = 'name',
  /** column name */
  ThumbnailsSupported = 'thumbnails_supported'
}

/** select columns of table "document_flag" */
export enum Document_Flag_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Translation = 'translation'
}

/** Ordering options when selecting data from "document_flag". */
export type Document_Flag_Order_By = {
  color?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  translation?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "document_flag". All fields are combined with a logical 'AND'. */
export type Document_Flag_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Flag_Bool_Exp>>;
  _not?: InputMaybe<Document_Flag_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Flag_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  display?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  translation?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Bitmask flag for documents. Use pp_enc_df/pp_dec_df to decode document.document_flags value. */
export type Document_Flag = {
  color: Maybe<Scalars['String']>;
  display: Scalars['Int'];
  /** id of document_flag. */
  id: Scalars['bigint'];
  name: Scalars['String'];
  translation: Scalars['jsonb'];
};


/** Bitmask flag for documents. Use pp_enc_df/pp_dec_df to decode document.document_flags value. */
export type Document_FlagTranslationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type Document_Is_Allowed_Args = {
  document_row?: InputMaybe<Scalars['document_scalar']>;
  hasura_session?: InputMaybe<Scalars['json']>;
};

/** select columns of table "document_status" */
export enum Document_Status_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Name = 'name'
}

/** select columns of table "document_type" */
export enum Document_Type_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Name = 'name',
  /** column name */
  Translations = 'translations'
}

/** aggregated selection of "document_type" */
export type Document_Type_Aggregate = {
  aggregate: Maybe<Document_Type_Aggregate_Fields>;
  nodes: Array<Document_Type>;
};

/** aggregate fields of "document_type" */
export type Document_Type_Aggregate_Fields = {
  count: Scalars['Int'];
  max: Maybe<Document_Type_Max_Fields>;
  min: Maybe<Document_Type_Min_Fields>;
};


/** aggregate fields of "document_type" */
export type Document_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Document_Type_Max_Fields = {
  /** document_type creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document_type creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  display_name: Maybe<Scalars['String']>;
  /** document_type last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document_type. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Document_Type_Min_Fields = {
  /** document_type creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document_type creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  display_name: Maybe<Scalars['String']>;
  /** document_type last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document_type. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** select columns of table "dr_goods_items" */
export enum Dr_Goods_Items_Select_Column {
  /** column name */
  Certificates = 'certificates',
  /** column name */
  CommodityCode = 'commodity_code',
  /** column name */
  Description = 'description',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GrossMass = 'gross_mass',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  NonCustomsLawObligation = 'non_customs_law_obligation',
  /** column name */
  Origin = 'origin',
  /** column name */
  OriginCountry = 'origin_country',
  /** column name */
  OriginPreference = 'origin_preference',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  Qty = 'qty',
  /** column name */
  Rn = 'rn',
  /** column name */
  Statistic = 'statistic',
  /** column name */
  StatisticCommercialGood = 'statistic_commercial_good',
  /** column name */
  StatisticCustomsClearanceType = 'statistic_customs_clearance_type',
  /** column name */
  StatisticRepair = 'statistic_repair',
  /** column name */
  StatisticStatisticalValue = 'statistic_statistical_value',
  /** column name */
  TraderItemId = 'trader_item_id',
  /** column name */
  Valuation = 'valuation',
  /** column name */
  ValuationVatCode = 'valuation_vat_code',
  /** column name */
  ValuationVatValue = 'valuation_vat_value'
}

/** Ordering options when selecting data from "dr_goods_items". */
export type Dr_Goods_Items_Order_By = {
  certificates?: InputMaybe<Order_By>;
  commodity_code?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  origin?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  origin_preference?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  rn?: InputMaybe<Order_By>;
  statistic?: InputMaybe<Order_By>;
  statistic_commercial_good?: InputMaybe<Order_By>;
  statistic_customs_clearance_type?: InputMaybe<Order_By>;
  statistic_repair?: InputMaybe<Order_By>;
  statistic_statistical_value?: InputMaybe<Order_By>;
  trader_item_id?: InputMaybe<Order_By>;
  valuation?: InputMaybe<Order_By>;
  valuation_vat_code?: InputMaybe<Order_By>;
  valuation_vat_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "dr_goods_items". All fields are combined with a logical 'AND'. */
export type Dr_Goods_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Dr_Goods_Items_Bool_Exp>>;
  _not?: InputMaybe<Dr_Goods_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Dr_Goods_Items_Bool_Exp>>;
  certificates?: InputMaybe<Jsonb_Comparison_Exp>;
  commodity_code?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  gross_mass?: InputMaybe<Numeric_Comparison_Exp>;
  net_mass?: InputMaybe<Numeric_Comparison_Exp>;
  non_customs_law_obligation?: InputMaybe<Int_Comparison_Exp>;
  origin?: InputMaybe<Jsonb_Comparison_Exp>;
  origin_country?: InputMaybe<String_Comparison_Exp>;
  origin_preference?: InputMaybe<Int_Comparison_Exp>;
  packaging?: InputMaybe<_Jsonb_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  rn?: InputMaybe<Bigint_Comparison_Exp>;
  statistic?: InputMaybe<Jsonb_Comparison_Exp>;
  statistic_commercial_good?: InputMaybe<Int_Comparison_Exp>;
  statistic_customs_clearance_type?: InputMaybe<Int_Comparison_Exp>;
  statistic_repair?: InputMaybe<Int_Comparison_Exp>;
  statistic_statistical_value?: InputMaybe<Int_Comparison_Exp>;
  trader_item_id?: InputMaybe<Int_Comparison_Exp>;
  valuation?: InputMaybe<Jsonb_Comparison_Exp>;
  valuation_vat_code?: InputMaybe<Int_Comparison_Exp>;
  valuation_vat_value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "_jsonb". All fields are combined with logical 'AND'. */
export type _Jsonb_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_jsonb']>;
  _gt?: InputMaybe<Scalars['_jsonb']>;
  _gte?: InputMaybe<Scalars['_jsonb']>;
  _in?: InputMaybe<Array<Scalars['_jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_jsonb']>;
  _lte?: InputMaybe<Scalars['_jsonb']>;
  _neq?: InputMaybe<Scalars['_jsonb']>;
  _nin?: InputMaybe<Array<Scalars['_jsonb']>>;
};

/** columns and relationships of "dr_goods_items" */
export type Dr_Goods_Items = {
  certificates: Maybe<Scalars['jsonb']>;
  commodity_code: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  gross_mass: Maybe<Scalars['numeric']>;
  net_mass: Maybe<Scalars['numeric']>;
  non_customs_law_obligation: Maybe<Scalars['Int']>;
  origin: Maybe<Scalars['jsonb']>;
  origin_country: Maybe<Scalars['String']>;
  origin_preference: Maybe<Scalars['Int']>;
  packaging: Maybe<Scalars['_jsonb']>;
  qty: Maybe<Scalars['bigint']>;
  rn: Maybe<Scalars['bigint']>;
  statistic: Maybe<Scalars['jsonb']>;
  statistic_commercial_good: Maybe<Scalars['Int']>;
  statistic_customs_clearance_type: Maybe<Scalars['Int']>;
  statistic_repair: Maybe<Scalars['Int']>;
  statistic_statistical_value: Maybe<Scalars['Int']>;
  trader_item_id: Maybe<Scalars['Int']>;
  valuation: Maybe<Scalars['jsonb']>;
  valuation_vat_code: Maybe<Scalars['Int']>;
  valuation_vat_value: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "dr_goods_items" */
export type Dr_Goods_ItemsCertificatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dr_goods_items" */
export type Dr_Goods_ItemsOriginArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dr_goods_items" */
export type Dr_Goods_ItemsStatisticArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "dr_goods_items" */
export type Dr_Goods_ItemsValuationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "dr_stats" */
export enum Dr_Stats_Select_Column {
  /** column name */
  MetricId = 'metric_id',
  /** column name */
  MetricLabel = 'metric_label',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TenantName = 'tenant_name',
  /** column name */
  Value = 'value'
}

/** Ordering options when selecting data from "dr_stats". */
export type Dr_Stats_Order_By = {
  metric_id?: InputMaybe<Order_By>;
  metric_label?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tenant_name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "dr_stats". All fields are combined with a logical 'AND'. */
export type Dr_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Dr_Stats_Bool_Exp>>;
  _not?: InputMaybe<Dr_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Dr_Stats_Bool_Exp>>;
  metric_id?: InputMaybe<String_Comparison_Exp>;
  metric_label?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_name?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** columns and relationships of "dr_stats" */
export type Dr_Stats = {
  metric_id: Maybe<Scalars['String']>;
  metric_label: Maybe<Scalars['String']>;
  tenant_id: Maybe<Scalars['uuid']>;
  tenant_name: Maybe<Scalars['String']>;
  value: Maybe<Scalars['numeric']>;
};

/** select columns of table "edec_countries" */
export enum Edec_Countries_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsoCode = 'iso_code',
  /** column name */
  NameDe = 'name_de',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameIt = 'name_it',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  Version = 'version'
}

/** Ordering options when selecting data from "edec_countries". */
export type Edec_Countries_Order_By = {
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  iso_code?: InputMaybe<Order_By>;
  name_de?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_it?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "edec_countries". All fields are combined with a logical 'AND'. */
export type Edec_Countries_Bool_Exp = {
  _and?: InputMaybe<Array<Edec_Countries_Bool_Exp>>;
  _not?: InputMaybe<Edec_Countries_Bool_Exp>;
  _or?: InputMaybe<Array<Edec_Countries_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  iso_code?: InputMaybe<Bpchar_Comparison_Exp>;
  name_de?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_it?: InputMaybe<String_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_to?: InputMaybe<Date_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "edec_countries" */
export type Edec_Countries = {
  created: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  iso_code: Scalars['bpchar'];
  name_de: Maybe<Scalars['String']>;
  name_en: Maybe<Scalars['String']>;
  name_fr: Maybe<Scalars['String']>;
  name_it: Maybe<Scalars['String']>;
  valid_from: Maybe<Scalars['date']>;
  valid_to: Maybe<Scalars['date']>;
  version: Maybe<Scalars['Int']>;
};

/** select columns of table "edec_customs_offices" */
export enum Edec_Customs_Offices_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  Prefix = 'prefix',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  Version = 'version'
}

/** Ordering options when selecting data from "edec_customs_offices". */
export type Edec_Customs_Offices_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  prefix?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "edec_customs_offices". All fields are combined with a logical 'AND'. */
export type Edec_Customs_Offices_Bool_Exp = {
  _and?: InputMaybe<Array<Edec_Customs_Offices_Bool_Exp>>;
  _not?: InputMaybe<Edec_Customs_Offices_Bool_Exp>;
  _or?: InputMaybe<Array<Edec_Customs_Offices_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  prefix?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_to?: InputMaybe<Date_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "edec_customs_offices" */
export type Edec_Customs_Offices = {
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  created: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  number: Maybe<Scalars['String']>;
  prefix: Maybe<Scalars['String']>;
  updated_at: Maybe<Scalars['timestamptz']>;
  valid_from: Maybe<Scalars['date']>;
  valid_to: Maybe<Scalars['date']>;
  version: Maybe<Scalars['Int']>;
};

/** select columns of table "edec_domains" */
export enum Edec_Domains_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DomainName = 'domain_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MeaningDe = 'meaning_de',
  /** column name */
  MeaningEn = 'meaning_en',
  /** column name */
  MeaningFr = 'meaning_fr',
  /** column name */
  MeaningIt = 'meaning_it',
  /** column name */
  ValidForExport = 'valid_for_export',
  /** column name */
  ValidForImport = 'valid_for_import',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  Value = 'value',
  /** column name */
  Version = 'version'
}

/** Ordering options when selecting data from "edec_domains". */
export type Edec_Domains_Order_By = {
  created_at?: InputMaybe<Order_By>;
  domain_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  meaning_de?: InputMaybe<Order_By>;
  meaning_en?: InputMaybe<Order_By>;
  meaning_fr?: InputMaybe<Order_By>;
  meaning_it?: InputMaybe<Order_By>;
  valid_for_export?: InputMaybe<Order_By>;
  valid_for_import?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "edec_domains". All fields are combined with a logical 'AND'. */
export type Edec_Domains_Bool_Exp = {
  _and?: InputMaybe<Array<Edec_Domains_Bool_Exp>>;
  _not?: InputMaybe<Edec_Domains_Bool_Exp>;
  _or?: InputMaybe<Array<Edec_Domains_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  domain_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  meaning_de?: InputMaybe<String_Comparison_Exp>;
  meaning_en?: InputMaybe<String_Comparison_Exp>;
  meaning_fr?: InputMaybe<String_Comparison_Exp>;
  meaning_it?: InputMaybe<String_Comparison_Exp>;
  valid_for_export?: InputMaybe<Boolean_Comparison_Exp>;
  valid_for_import?: InputMaybe<Boolean_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_to?: InputMaybe<Date_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "edec_domains" */
export type Edec_Domains = {
  created_at: Maybe<Scalars['timestamptz']>;
  domain_name: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  meaning_de: Maybe<Scalars['String']>;
  meaning_en: Maybe<Scalars['String']>;
  meaning_fr: Maybe<Scalars['String']>;
  meaning_it: Maybe<Scalars['String']>;
  valid_for_export: Maybe<Scalars['Boolean']>;
  valid_for_import: Maybe<Scalars['Boolean']>;
  valid_from: Maybe<Scalars['date']>;
  valid_to: Maybe<Scalars['date']>;
  value: Maybe<Scalars['String']>;
  version: Maybe<Scalars['Int']>;
};

/** select columns of table "edec_tariff_commodity_code" */
export enum Edec_Tariff_Commodity_Code_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ValidForExport = 'valid_for_export',
  /** column name */
  ValidForImport = 'valid_for_import',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  Value = 'value',
  /** column name */
  Version = 'version'
}

/** Ordering options when selecting data from "edec_tariff_commodity_code". */
export type Edec_Tariff_Commodity_Code_Order_By = {
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  valid_for_export?: InputMaybe<Order_By>;
  valid_for_import?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "edec_tariff_commodity_code". All fields are combined with a logical 'AND'. */
export type Edec_Tariff_Commodity_Code_Bool_Exp = {
  _and?: InputMaybe<Array<Edec_Tariff_Commodity_Code_Bool_Exp>>;
  _not?: InputMaybe<Edec_Tariff_Commodity_Code_Bool_Exp>;
  _or?: InputMaybe<Array<Edec_Tariff_Commodity_Code_Bool_Exp>>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  valid_for_export?: InputMaybe<Boolean_Comparison_Exp>;
  valid_for_import?: InputMaybe<Boolean_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_to?: InputMaybe<Date_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** columns and relationships of "edec_tariff_commodity_code" */
export type Edec_Tariff_Commodity_Code = {
  created: Scalars['timestamp'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  valid_for_export: Scalars['Boolean'];
  valid_for_import: Scalars['Boolean'];
  valid_from: Scalars['date'];
  valid_to: Scalars['date'];
  value: Scalars['String'];
  version: Scalars['Int'];
};

/** select columns of table "edec_tariff_statistical_code" */
export enum Edec_Tariff_Statistical_Code_Select_Column {
  /** column name */
  CommodityCodeId = 'commodity_code_id',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LowerScaleWeight = 'lower_scale_weight',
  /** column name */
  ScaleWeightCode = 'scale_weight_code',
  /** column name */
  StorageType = 'storage_type',
  /** column name */
  UpperScaleWeight = 'upper_scale_weight',
  /** column name */
  ValidForExport = 'valid_for_export',
  /** column name */
  ValidForImport = 'valid_for_import',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  Value = 'value',
  /** column name */
  Version = 'version'
}

/** Ordering options when selecting data from "edec_tariff_statistical_code". */
export type Edec_Tariff_Statistical_Code_Order_By = {
  commodity_code_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  lower_scale_weight?: InputMaybe<Order_By>;
  scale_weight_code?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  upper_scale_weight?: InputMaybe<Order_By>;
  valid_for_export?: InputMaybe<Order_By>;
  valid_for_import?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "edec_tariff_statistical_code". All fields are combined with a logical 'AND'. */
export type Edec_Tariff_Statistical_Code_Bool_Exp = {
  _and?: InputMaybe<Array<Edec_Tariff_Statistical_Code_Bool_Exp>>;
  _not?: InputMaybe<Edec_Tariff_Statistical_Code_Bool_Exp>;
  _or?: InputMaybe<Array<Edec_Tariff_Statistical_Code_Bool_Exp>>;
  commodity_code_id?: InputMaybe<Int_Comparison_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  lower_scale_weight?: InputMaybe<Numeric_Comparison_Exp>;
  scale_weight_code?: InputMaybe<Int_Comparison_Exp>;
  storage_type?: InputMaybe<String_Comparison_Exp>;
  upper_scale_weight?: InputMaybe<Numeric_Comparison_Exp>;
  valid_for_export?: InputMaybe<Boolean_Comparison_Exp>;
  valid_for_import?: InputMaybe<Boolean_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_to?: InputMaybe<Date_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "edec_tariff_statistical_code" */
export type Edec_Tariff_Statistical_Code = {
  commodity_code_id: Scalars['Int'];
  created: Scalars['timestamp'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  lower_scale_weight: Maybe<Scalars['numeric']>;
  scale_weight_code: Scalars['Int'];
  storage_type: Scalars['String'];
  upper_scale_weight: Maybe<Scalars['numeric']>;
  valid_for_export: Scalars['Boolean'];
  valid_for_import: Scalars['Boolean'];
  valid_from: Scalars['date'];
  valid_to: Scalars['date'];
  value: Scalars['Int'];
  version: Scalars['Int'];
};

/** select columns of table "email_search_type" */
export enum Email_Search_Type_Select_Column {
  /** column name */
  Attachments = 'attachments',
  /** column name */
  Company = 'company',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  FileStatus = 'file_status',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Sender = 'sender',
  /** column name */
  TotalRows = 'total_rows'
}

/** Ordering options when selecting data from "email_search_type". */
export type Email_Search_Type_Order_By = {
  attachments?: InputMaybe<Order_By>;
  company?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  file_status?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sender?: InputMaybe<Order_By>;
  total_rows?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "email_search_type". All fields are combined with a logical 'AND'. */
export type Email_Search_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Search_Type_Bool_Exp>>;
  _not?: InputMaybe<Email_Search_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Search_Type_Bool_Exp>>;
  attachments?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  file_status?: InputMaybe<String_Comparison_Exp>;
  file_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sender?: InputMaybe<String_Comparison_Exp>;
  total_rows?: InputMaybe<Bigint_Comparison_Exp>;
};

/** SETOF-type for pp_email_search% functions. */
export type Email_Search_Type = {
  attachments: Maybe<Scalars['String']>;
  company: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  file_status: Maybe<Scalars['String']>;
  file_url: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  name: Maybe<Scalars['String']>;
  sender: Maybe<Scalars['String']>;
  total_rows: Maybe<Scalars['bigint']>;
};


/** SETOF-type for pp_email_search% functions. */
export type Email_Search_TypeDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** SETOF-type for pp_email_search% functions. */
export type Email_Search_TypeDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** SETOF-type for pp_email_search% functions. */
export type Email_Search_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "email_search_type" */
export type Email_Search_Type_Aggregate = {
  aggregate: Maybe<Email_Search_Type_Aggregate_Fields>;
  nodes: Array<Email_Search_Type>;
};

/** aggregate fields of "email_search_type" */
export type Email_Search_Type_Aggregate_Fields = {
  avg: Maybe<Email_Search_Type_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Email_Search_Type_Max_Fields>;
  min: Maybe<Email_Search_Type_Min_Fields>;
  stddev: Maybe<Email_Search_Type_Stddev_Fields>;
  stddev_pop: Maybe<Email_Search_Type_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Email_Search_Type_Stddev_Samp_Fields>;
  sum: Maybe<Email_Search_Type_Sum_Fields>;
  var_pop: Maybe<Email_Search_Type_Var_Pop_Fields>;
  var_samp: Maybe<Email_Search_Type_Var_Samp_Fields>;
  variance: Maybe<Email_Search_Type_Variance_Fields>;
};


/** aggregate fields of "email_search_type" */
export type Email_Search_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Email_Search_Type_Avg_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Email_Search_Type_Max_Fields = {
  attachments: Maybe<Scalars['String']>;
  company: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  file_status: Maybe<Scalars['String']>;
  file_url: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  sender: Maybe<Scalars['String']>;
  total_rows: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Email_Search_Type_Min_Fields = {
  attachments: Maybe<Scalars['String']>;
  company: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  file_status: Maybe<Scalars['String']>;
  file_url: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  sender: Maybe<Scalars['String']>;
  total_rows: Maybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Email_Search_Type_Stddev_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Email_Search_Type_Stddev_Pop_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Email_Search_Type_Stddev_Samp_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Email_Search_Type_Sum_Fields = {
  total_rows: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Email_Search_Type_Var_Pop_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Email_Search_Type_Var_Samp_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Email_Search_Type_Variance_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** select columns of table "extract_type" */
export enum Extract_Type_Select_Column {
  /** column name */
  ExtractTypeId = 'extract_type_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Translations = 'translations'
}

/** select columns of table "extraction_config" */
export enum Extraction_Config_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Aliases = 'aliases',
  /** column name */
  DocumentTemplates = 'document_templates',
  /** column name */
  FounConfig = 'foun_config'
}

/** select columns of table "file" */
export enum File_Select_Column {
  /** column name */
  AiDocClassificationConfirmed = 'ai_doc_classification_confirmed',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  FileFlags = 'file_flags',
  /** column name */
  FileStatus = 'file_status',
  /** column name */
  FileType = 'file_type',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Identification = 'identification',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SessionId = 'session_id'
}

/** aggregated selection of "file" */
export type File_Aggregate = {
  aggregate: Maybe<File_Aggregate_Fields>;
  nodes: Array<File>;
};

/** aggregate fields of "file" */
export type File_Aggregate_Fields = {
  avg: Maybe<File_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<File_Max_Fields>;
  min: Maybe<File_Min_Fields>;
  stddev: Maybe<File_Stddev_Fields>;
  stddev_pop: Maybe<File_Stddev_Pop_Fields>;
  stddev_samp: Maybe<File_Stddev_Samp_Fields>;
  sum: Maybe<File_Sum_Fields>;
  var_pop: Maybe<File_Var_Pop_Fields>;
  var_samp: Maybe<File_Var_Samp_Fields>;
  variance: Maybe<File_Variance_Fields>;
};


/** aggregate fields of "file" */
export type File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type File_Avg_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type File_Max_Fields = {
  /** file creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** file creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  file_flags: Maybe<Scalars['bigint']>;
  file_status: Maybe<Scalars['String']>;
  file_type: Maybe<Scalars['String']>;
  file_url: Maybe<Scalars['String']>;
  /** id of file. */
  id: Maybe<Scalars['uuid']>;
  /**
   * Is usually set automatically by AQW.IdentificationProvider.
   *
   * AQW.IdentificationProvider can be set in tenant settings either DefaultProvider (random uuid) or a company specific provider which calls an external API endpoint.
   *
   */
  identification: Maybe<Scalars['String']>;
  /** file last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified file. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['smallint']>;
  session_id: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type File_Min_Fields = {
  /** file creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** file creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  file_flags: Maybe<Scalars['bigint']>;
  file_status: Maybe<Scalars['String']>;
  file_type: Maybe<Scalars['String']>;
  file_url: Maybe<Scalars['String']>;
  /** id of file. */
  id: Maybe<Scalars['uuid']>;
  /**
   * Is usually set automatically by AQW.IdentificationProvider.
   *
   * AQW.IdentificationProvider can be set in tenant settings either DefaultProvider (random uuid) or a company specific provider which calls an external API endpoint.
   *
   */
  identification: Maybe<Scalars['String']>;
  /** file last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified file. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['smallint']>;
  session_id: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type File_Stddev_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type File_Stddev_Pop_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type File_Stddev_Samp_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type File_Sum_Fields = {
  file_flags: Maybe<Scalars['bigint']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['smallint']>;
};

/** aggregate var_pop on columns */
export type File_Var_Pop_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type File_Var_Samp_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type File_Variance_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** select columns of table "file_stats_type" */
export enum File_Stats_Type_Select_Column {
  /** column name */
  FileFlags = 'file_flags',
  /** column name */
  FileFlagsId = 'file_flags_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  UsersQty = 'users_qty'
}

/** Ordering options when selecting data from "file_stats_type". */
export type File_Stats_Type_Order_By = {
  file_flags?: InputMaybe<Order_By>;
  file_flags_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  users_qty?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "file_stats_type". All fields are combined with a logical 'AND'. */
export type File_Stats_Type_Bool_Exp = {
  _and?: InputMaybe<Array<File_Stats_Type_Bool_Exp>>;
  _not?: InputMaybe<File_Stats_Type_Bool_Exp>;
  _or?: InputMaybe<Array<File_Stats_Type_Bool_Exp>>;
  file_flags?: InputMaybe<String_Comparison_Exp>;
  file_flags_id?: InputMaybe<Bigint_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  users_qty?: InputMaybe<Bigint_Comparison_Exp>;
};

/** SETOF-type used in pp_file_stats. */
export type File_Stats_Type = {
  file_flags: Maybe<Scalars['String']>;
  file_flags_id: Maybe<Scalars['bigint']>;
  qty: Maybe<Scalars['bigint']>;
  users_qty: Maybe<Scalars['bigint']>;
};

/** select columns of table "file_type" */
export enum File_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  DocTypes = 'doc_types',
  /** column name */
  FileType = 'file_type'
}

/** Ordering options when selecting data from "file_type". */
export type File_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  doc_types?: InputMaybe<Order_By>;
  file_type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "file_type". All fields are combined with a logical 'AND'. */
export type File_Type_Bool_Exp = {
  _and?: InputMaybe<Array<File_Type_Bool_Exp>>;
  _not?: InputMaybe<File_Type_Bool_Exp>;
  _or?: InputMaybe<Array<File_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  doc_types?: InputMaybe<_Varchar_Comparison_Exp>;
  file_type?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "_varchar". All fields are combined with logical 'AND'. */
export type _Varchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_varchar']>;
  _gt?: InputMaybe<Scalars['_varchar']>;
  _gte?: InputMaybe<Scalars['_varchar']>;
  _in?: InputMaybe<Array<Scalars['_varchar']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_varchar']>;
  _lte?: InputMaybe<Scalars['_varchar']>;
  _neq?: InputMaybe<Scalars['_varchar']>;
  _nin?: InputMaybe<Array<Scalars['_varchar']>>;
};

/** File types in system. Restrict document types inside files of specific file_type. */
export type File_Type = {
  description: Scalars['String'];
  doc_types: Maybe<Scalars['_varchar']>;
  file_type: Scalars['String'];
};

export type AddressOrOverrideResult = {
  address: AddressAcs;
  original_id: Maybe<Scalars['Int']>;
};

export type GetAddressOverridesResponse = {
  qty: Scalars['Float'];
  sourceAddress: AddressAcs;
  targetAddress: AddressAcs;
};

export type BordereauArgs = {
  dutiesFrom?: InputMaybe<Scalars['Float']>;
  dutiesTo?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxDate?: InputMaybe<Scalars['LocalDateTime']>;
  minDate?: InputMaybe<Scalars['LocalDateTime']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderby?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BordereauStatus>;
  vatFrom?: InputMaybe<Scalars['Float']>;
  vatTo?: InputMaybe<Scalars['Float']>;
};

export enum BordereauStatus {
  All = 'All',
  Completed = 'Completed',
  NotCompleted = 'NotCompleted'
}

export type GetBordereaus = {
  count: Maybe<Scalars['Int']>;
  data: Maybe<Array<Maybe<Bordereau>>>;
};

export type Bordereau = {
  accountNumber: Maybe<Scalars['String']>;
  amount: Maybe<Scalars['Float']>;
  bordereauItems: Maybe<Array<Maybe<BordereauItem>>>;
  bordereauPdfDoc: Maybe<Documents>;
  bordereauXmlDoc: Maybe<Documents>;
  consignee: Maybe<Scalars['String']>;
  documentDate: Maybe<Scalars['Date']>;
  documentNumber: Scalars['String'];
  documentTime: Maybe<Scalars['LocalTime']>;
  documentTitle: Maybe<Scalars['String']>;
  duties: Maybe<Scalars['Float']>;
  numberOfDocuments: Maybe<Scalars['Int']>;
  status: Maybe<Scalars['Boolean']>;
  vat: Maybe<Scalars['Float']>;
};

export type BordereauItem = {
  amount: Maybe<Scalars['Float']>;
  customOffice: Maybe<CustomsOfficeAcs>;
  customsDeclarationVersion: Maybe<Scalars['Int']>;
  customsReference: Scalars['String'];
  documentTypeAbbreviation: Maybe<Scalars['String']>;
  documentTypeName: Scalars['String'];
  documentTypeNameTranslations: Maybe<TranslationsAcs>;
  drNo: Maybe<Scalars['Int']>;
  file: Maybe<FileAcs>;
  id: Scalars['Int'];
  status: Maybe<Scalars['Boolean']>;
  traderReference: Maybe<Scalars['String']>;
};

export type CustomsOfficeAcs = {
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  officeNumber: Scalars['String'];
  prefix: Maybe<Scalars['String']>;
  validFrom: Maybe<Scalars['DateTime']>;
  validTo: Maybe<Scalars['DateTime']>;
};

export type TranslationsAcs = {
  de: Maybe<Scalars['String']>;
  en: Maybe<Scalars['String']>;
};

export type FileAcs = {
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['String']>;
  declarations: Maybe<Array<Maybe<DeclarationAcs>>>;
  documents: Array<Documents>;
  fileFlags: Maybe<Scalars['String']>;
  fileStatus: Maybe<Scalars['String']>;
  fileType: Maybe<Scalars['String']>;
  fileUrl: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  identification: Maybe<Scalars['String']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['String']>;
  meta: Maybe<Scalars['JSON']>;
  name: Maybe<Scalars['String']>;
  orgId: Maybe<Scalars['Int']>;
  sessionId: Scalars['String'];
};


export type FileAcsDocumentsArgs = {
  filters?: InputMaybe<FiltersExpressionAcsInput>;
};

export type DeclarationAcs = {
  addresses: Maybe<Array<DeclarationAddressAcs>>;
  addresses_deprecated: Maybe<Array<Maybe<DeclarationAddress>>>;
  addressReferences: Maybe<Scalars['String']>;
  autoclassifiedDocsQty: Maybe<Scalars['String']>;
  customs_offices_deprecated: Maybe<CustomsOffice>;
  customsOffice: Maybe<EdecCustomsOffices>;
  declaration: DeclarationEntity;
  declarationDiscussion: Maybe<DeclarationDiscussionEntity>;
  declarationLabels: Array<DeclarationLabel>;
  declarationRequest: DeclarationRequestAcs;
  declarationStatus: DeclarationStatus;
  drNo: Scalars['Int'];
  file: FileAcs;
  fileId: Scalars['String'];
  myDuties: Maybe<Scalars['JSON']>;
  nonclassifiedDocsExists: Maybe<Scalars['Boolean']>;
  payer: TenantEntity;
  payerAddress: AddressAcs;
  searchReferences: Maybe<Scalars['String']>;
  userPp: Maybe<UserPp>;
};

export type DeclarationAddressAcs = {
  addressType: Maybe<AddressTypeAcs>;
  addressTypeId: Maybe<Scalars['Int']>;
  aoId: Maybe<Scalars['Int']>;
  city: Maybe<Scalars['String']>;
  companyName: Maybe<Scalars['String']>;
  contactEmail: Maybe<Scalars['String']>;
  contactPhone: Maybe<Scalars['String']>;
  contactWebsite: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  customsAccountNumber: Maybe<Scalars['String']>;
  drReference: Maybe<Scalars['String']>;
  errorEmailAddress: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  isLocked: Maybe<Scalars['Boolean']>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  meta: Maybe<Scalars['JSON']>;
  reference: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  streetNumber: Maybe<Scalars['String']>;
  traderIdentificationNumber: Maybe<Scalars['String']>;
  vatAccountNumber: Maybe<Scalars['String']>;
  vatNumber: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

export type DeclarationAddress = {
  address: Maybe<AddressAcs>;
  addressId: Maybe<Scalars['Int']>;
  addressType: Scalars['Int'];
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  drNo: Scalars['Int'];
  fileId: Scalars['UUID'];
  meta: Maybe<Scalars['JSON']>;
  refs: Maybe<Array<Scalars['String']>>;
};

export type CustomsOffice = {
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  officeNumber: Scalars['String'];
  prefix: Maybe<Scalars['String']>;
  validFrom: Maybe<Scalars['DateTime']>;
  validRange: Maybe<Scalars['String']>;
  validTo: Maybe<Scalars['DateTime']>;
};

export type DeclarationDiscussionEntity = {
  closed: Scalars['Boolean'];
  creationDate: Scalars['DateTime'];
  discussionId: Scalars['Int'];
  discussionTheme: Maybe<Scalars['String']>;
  meta: Scalars['JSON'];
  unreadMessagesCount: Scalars['Int'];
};

export type CommodityCodeDescription = {
  commodityCode: Maybe<Scalars['String']>;
  descriptionDe: Scalars['String'];
  hierarchyVisual: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeclarationLabelQueryOutput = {
  color: Scalars['String'];
  description: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_deleted: Scalars['Boolean'];
  tenant_id: Scalars['UUID'];
  title: Scalars['JSON'];
};

export type DeclarationFlat = {
  addressReferences: Maybe<Scalars['String']>;
  autoclassifiedDocsQty: Scalars['Int'];
  consigneeName: Maybe<Scalars['String']>;
  consigneeRef: Maybe<Scalars['String']>;
  consignorName: Maybe<Scalars['String']>;
  consignorRef: Maybe<Scalars['String']>;
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['String']>;
  customsOfficeNumber: Maybe<Scalars['String']>;
  declarationStatus: DeclarationStatus;
  discussionId: Maybe<Scalars['Int']>;
  drNo: Scalars['Int'];
  evvReceived: Maybe<Scalars['Boolean']>;
  fileId: Scalars['String'];
  identification: Maybe<Scalars['String']>;
  importerRef: Maybe<Scalars['String']>;
  messageCount: Scalars['Int'];
  nonclassifiedDocsExists: Scalars['Int'];
  orgId: Maybe<Scalars['Int']>;
  payerName: Maybe<Scalars['String']>;
  payerRef: Maybe<Scalars['String']>;
  totalColis: Maybe<Scalars['Float']>;
  totalGrossWeight: Maybe<Scalars['Float']>;
};

export enum DocumentStatus {
  Archived = 'Archived',
  ArchivedFailed = 'ArchivedFailed',
  ArchivedPending = 'ArchivedPending',
  Classified = 'Classified',
  ClassifiedFailed = 'ClassifiedFailed',
  ClassifiedPending = 'ClassifiedPending',
  Finished = 'Finished',
  Initial = 'Initial',
  Pending = 'Pending',
  Proceeded = 'Proceeded',
  Raw = 'Raw',
  ThumbnailsFailed = 'ThumbnailsFailed',
  ThumbnailsGenerated = 'ThumbnailsGenerated',
  ThumbnailsPending = 'ThumbnailsPending',
  ThumbnailsProcessingFailed = 'ThumbnailsProcessingFailed',
  Uploaded = 'Uploaded'
}

export type GetFileDocumentsQuery = {
  blobs: Maybe<Array<DocumentBlob>>;
  creationUser: Maybe<Scalars['String']>;
  documentExtension: Scalars['String'];
  documentFlags: Scalars['Int'];
  documentName: Scalars['String'];
  documentStatus: Scalars['String'];
  documentType: Scalars['String'];
  documentTypeTranslations: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSON']>;
  pages: Array<PageAcs>;
  sequence: Maybe<Scalars['Int']>;
};

export type DocumentBlob = {
  extension: Scalars['String'];
  initial: Scalars['Boolean'];
  url: Scalars['String'];
};

export type GetFiles = {
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  declarations: Maybe<Array<Maybe<DeclarationAcs>>>;
  documents: Maybe<Array<Maybe<GetFilesDocumentAcs>>>;
  fileFlags: Maybe<Scalars['Int']>;
  fileUrl: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  identification: Maybe<Scalars['String']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSON']>;
  name: Maybe<Scalars['String']>;
  orgId: Maybe<Scalars['Int']>;
};

export type GetFilesDocumentAcs = {
  checksum: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['DateTime']>;
  creation_user: Maybe<Scalars['UUID']>;
  document_blobs: Maybe<Scalars['JSON']>;
  document_extension: Maybe<Scalars['String']>;
  document_flags: Maybe<Scalars['Int']>;
  document_name: Maybe<Scalars['String']>;
  document_status: Maybe<Scalars['String']>;
  document_type: Maybe<GetFilesDocumentTypeAcs>;
  document_version: Maybe<Scalars['Int']>;
  documentPages: Maybe<Array<GetFilesDocumentPage>>;
  file: Scalars['UUID'];
  id: Scalars['UUID'];
  is_customs_relevant: Maybe<Scalars['Boolean']>;
  is_deleted: Maybe<Scalars['Boolean']>;
  is_generated: Maybe<Scalars['Boolean']>;
  is_template: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['DateTime']>;
  last_modified_user: Maybe<Scalars['UUID']>;
  meta: Maybe<Scalars['JSON']>;
  number_of_pages: Maybe<Scalars['Int']>;
  org_id: Maybe<Scalars['Int']>;
  sequence: Maybe<Scalars['Int']>;
};

export type GetFilesDocumentTypeAcs = {
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  displayName: Maybe<Scalars['String']>;
  documentTypeTenantSettings: Maybe<Array<GetFilesDocumentTypeTenantSettings>>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  name: Maybe<Scalars['String']>;
  translations: Maybe<Scalars['JSON']>;
};

export type GetFilesDocumentTypeTenantSettings = {
  code: Maybe<Scalars['String']>;
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  defaultFlags: Maybe<Scalars['Int']>;
  displayName: Maybe<Scalars['String']>;
  documentSchema: Maybe<Scalars['JSON']>;
  documentType: Maybe<Scalars['String']>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  meta: Maybe<Scalars['JSON']>;
  tenant: Scalars['UUID'];
};

export type GetFilesDocumentPage = {
  documentId: Scalars['UUID'];
  page: Maybe<GetFilesPageAcs>;
  pageId: Scalars['UUID'];
  pageNumber: Maybe<Scalars['Int']>;
};

export type GetFilesPageAcs = {
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  meta: Maybe<Scalars['JSON']>;
  ocrText: Maybe<Scalars['String']>;
  pageStatus: Maybe<Scalars['String']>;
  rotate: Maybe<Scalars['Int']>;
  thumbnailBigUrl: Maybe<Scalars['String']>;
  thumbnailSmallUrl: Maybe<Scalars['String']>;
};

export type SasTokenResponse = {
  container: Maybe<Scalars['String']>;
  expiryDate: Maybe<Scalars['String']>;
  sasToken: Maybe<Scalars['String']>;
};

export type CaslRule = {
  action: Actions;
  subject: Subjects;
};

export enum Actions {
  Archive = 'Archive',
  Create = 'Create',
  Delete = 'Delete',
  Download = 'Download',
  HideColumns = 'HideColumns',
  Preview = 'Preview',
  Print = 'Print',
  Read = 'Read',
  Share = 'Share',
  Subscribe = 'Subscribe',
  Update = 'Update',
  Upload = 'Upload'
}

export enum Subjects {
  CustomerDocument = 'CustomerDocument',
  CustomsDocument = 'CustomsDocument',
  DashboardTable = 'DashboardTable',
  DashboardTile = 'DashboardTile',
  Declaration = 'Declaration',
  DeclarationGoodItemReport = 'DeclarationGoodItemReport',
  DeclarationReport = 'DeclarationReport',
  Document = 'Document',
  FreeTextFieldReference = 'FreeTextFieldReference',
  Kpi = 'KPI',
  NotificationsImport = 'NotificationsImport',
  NotificationsStatus = 'NotificationsStatus'
}

export type GetUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Scalars['UUID']>;
};

/** select columns of table "goods_items_for_drs" */
export enum Goods_Items_For_Drs_Select_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AdditionalUnit = 'additional_unit',
  /** column name */
  ArrivalTime = 'arrival_time',
  /** column name */
  ArrivalType = 'arrival_type',
  /** column name */
  AutoclassifiedDocsQty = 'autoclassified_docs_qty',
  /** column name */
  ChExpDecl = 'ch_exp_decl',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CommercialGood = 'commercial_good',
  /** column name */
  CommodityCode = 'commodity_code',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsClearanceType = 'customs_clearance_type',
  /** column name */
  CustomsDeclarationNumber = 'customs_declaration_number',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  CustomsItemnumber = 'customs_itemnumber',
  /** column name */
  DeclarationStatus = 'declaration_status',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  Description = 'description',
  /** column name */
  DestTolldeptCode = 'dest_tolldept_code',
  /** column name */
  DestTolldeptName = 'dest_tolldept_name',
  /** column name */
  DocId = 'doc_id',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  DutyTotal = 'duty_total',
  /** column name */
  Eta = 'eta',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GoodsItem = 'goods_item',
  /** column name */
  Grossmass = 'grossmass',
  /** column name */
  HsCode = 'hs_code',
  /** column name */
  ImpCustClr = 'imp_cust_clr',
  /** column name */
  IsExpress = 'is_express',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  Meta = 'meta',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  NonCustomsLawObligation = 'non_customs_law_obligation',
  /** column name */
  NonclassifiedDocsExists = 'nonclassified_docs_exists',
  /** column name */
  Origin = 'origin',
  /** column name */
  OriginCountry = 'origin_country',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  PermissionsJs = 'permissions_js',
  /** column name */
  PermitObligation = 'permit_obligation',
  /** column name */
  Preference = 'preference',
  /** column name */
  ProducedDocument = 'produced_document',
  /** column name */
  Qty = 'qty',
  /** column name */
  Reference = 'reference',
  /** column name */
  RowNumber = 'row_number',
  /** column name */
  Statistic = 'statistic',
  /** column name */
  StatisticalCode = 'statistical_code',
  /** column name */
  StatisticalValue = 'statistical_value',
  /** column name */
  TollDep = 'toll_dep',
  /** column name */
  TrNo = 'tr_no',
  /** column name */
  TraderReference = 'trader_reference',
  /** column name */
  TransitdocType = 'transitdoc_type',
  /** column name */
  ValuationDetails = 'valuation_details',
  /** column name */
  Value = 'value',
  /** column name */
  VatTotal = 'vat_total',
  /** column name */
  Vatvalue = 'vatvalue',
  /** column name */
  WaNumber = 'wa_number'
}

/** Ordering options when selecting data from "goods_items_for_drs". */
export type Goods_Items_For_Drs_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  additional_unit?: InputMaybe<Order_By>;
  arrival_time?: InputMaybe<Order_By>;
  arrival_type?: InputMaybe<Order_By>;
  autoclassified_docs_qty?: InputMaybe<Order_By>;
  ch_exp_decl?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  commercial_good?: InputMaybe<Order_By>;
  commodity_code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_clearance_type?: InputMaybe<Order_By>;
  customs_declaration_number?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_itemnumber?: InputMaybe<Order_By>;
  declaration_request?: InputMaybe<Declaration_Request_Order_By>;
  declaration_status?: InputMaybe<Order_By>;
  declaration_type?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dest_tolldept_code?: InputMaybe<Order_By>;
  dest_tolldept_name?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  eta?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  goods_item?: InputMaybe<Order_By>;
  grossmass?: InputMaybe<Order_By>;
  hs_code?: InputMaybe<Order_By>;
  imp_cust_clr?: InputMaybe<Order_By>;
  is_express?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  nonclassified_docs_exists?: InputMaybe<Order_By>;
  origin?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  permissions_js?: InputMaybe<Order_By>;
  permit_obligation?: InputMaybe<Order_By>;
  preference?: InputMaybe<Order_By>;
  produced_document?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  row_number?: InputMaybe<Order_By>;
  statistic?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  toll_dep?: InputMaybe<Order_By>;
  tr_no?: InputMaybe<Order_By>;
  trader_reference?: InputMaybe<Order_By>;
  transitdoc_type?: InputMaybe<Order_By>;
  valuation_details?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vatvalue?: InputMaybe<Order_By>;
  wa_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "goods_items_for_drs". All fields are combined with a logical 'AND'. */
export type Goods_Items_For_Drs_Bool_Exp = {
  _and?: InputMaybe<Array<Goods_Items_For_Drs_Bool_Exp>>;
  _not?: InputMaybe<Goods_Items_For_Drs_Bool_Exp>;
  _or?: InputMaybe<Array<Goods_Items_For_Drs_Bool_Exp>>;
  acceptance_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  additional_unit?: InputMaybe<Jsonb_Comparison_Exp>;
  arrival_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  arrival_type?: InputMaybe<String_Comparison_Exp>;
  autoclassified_docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  ch_exp_decl?: InputMaybe<Boolean_Comparison_Exp>;
  clearance_type?: InputMaybe<String_Comparison_Exp>;
  commercial_good?: InputMaybe<String_Comparison_Exp>;
  commodity_code?: InputMaybe<Jsonb_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_clearance_type?: InputMaybe<String_Comparison_Exp>;
  customs_declaration_number?: InputMaybe<String_Comparison_Exp>;
  customs_declaration_version?: InputMaybe<Smallint_Comparison_Exp>;
  customs_itemnumber?: InputMaybe<Jsonb_Comparison_Exp>;
  declaration_request?: InputMaybe<Declaration_Request_Bool_Exp>;
  declaration_status?: InputMaybe<String_Comparison_Exp>;
  declaration_type?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<Jsonb_Comparison_Exp>;
  dest_tolldept_code?: InputMaybe<String_Comparison_Exp>;
  dest_tolldept_name?: InputMaybe<String_Comparison_Exp>;
  doc_id?: InputMaybe<Uuid_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  duty_total?: InputMaybe<String_Comparison_Exp>;
  eta?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  goods_item?: InputMaybe<Jsonb_Comparison_Exp>;
  grossmass?: InputMaybe<Jsonb_Comparison_Exp>;
  hs_code?: InputMaybe<String_Comparison_Exp>;
  imp_cust_clr?: InputMaybe<Boolean_Comparison_Exp>;
  is_express?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  net_mass?: InputMaybe<Jsonb_Comparison_Exp>;
  non_customs_law_obligation?: InputMaybe<Jsonb_Comparison_Exp>;
  nonclassified_docs_exists?: InputMaybe<Boolean_Comparison_Exp>;
  origin?: InputMaybe<Jsonb_Comparison_Exp>;
  origin_country?: InputMaybe<String_Comparison_Exp>;
  packaging?: InputMaybe<Jsonb_Comparison_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  permissions_js?: InputMaybe<Json_Comparison_Exp>;
  permit_obligation?: InputMaybe<Jsonb_Comparison_Exp>;
  preference?: InputMaybe<String_Comparison_Exp>;
  produced_document?: InputMaybe<Jsonb_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  row_number?: InputMaybe<Bigint_Comparison_Exp>;
  statistic?: InputMaybe<Jsonb_Comparison_Exp>;
  statistical_code?: InputMaybe<Jsonb_Comparison_Exp>;
  statistical_value?: InputMaybe<String_Comparison_Exp>;
  toll_dep?: InputMaybe<String_Comparison_Exp>;
  tr_no?: InputMaybe<String_Comparison_Exp>;
  trader_reference?: InputMaybe<String_Comparison_Exp>;
  transitdoc_type?: InputMaybe<Transitdoc_Type_Comparison_Exp>;
  valuation_details?: InputMaybe<Jsonb_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
  vat_total?: InputMaybe<String_Comparison_Exp>;
  vatvalue?: InputMaybe<String_Comparison_Exp>;
  wa_number?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_Drs = {
  acceptance_date: Maybe<Scalars['timestamptz']>;
  account_number: Maybe<Scalars['String']>;
  additional_unit: Maybe<Scalars['jsonb']>;
  arrival_time: Maybe<Scalars['timestamptz']>;
  arrival_type: Maybe<Scalars['String']>;
  autoclassified_docs_qty: Maybe<Scalars['bigint']>;
  ch_exp_decl: Maybe<Scalars['Boolean']>;
  clearance_type: Maybe<Scalars['String']>;
  commercial_good: Maybe<Scalars['String']>;
  commodity_code: Maybe<Scalars['jsonb']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  customs_clearance_type: Maybe<Scalars['String']>;
  customs_declaration_number: Maybe<Scalars['String']>;
  customs_declaration_version: Maybe<Scalars['smallint']>;
  customs_itemnumber: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  declaration_request: Maybe<Declaration_Request>;
  declaration_status: Maybe<Scalars['String']>;
  declaration_type: Maybe<Scalars['String']>;
  description: Maybe<Scalars['jsonb']>;
  dest_tolldept_code: Maybe<Scalars['String']>;
  dest_tolldept_name: Maybe<Scalars['String']>;
  doc_id: Maybe<Scalars['uuid']>;
  document_type: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  duty_total: Maybe<Scalars['String']>;
  eta: Maybe<Scalars['timestamptz']>;
  file_id: Maybe<Scalars['uuid']>;
  goods_item: Maybe<Scalars['jsonb']>;
  grossmass: Maybe<Scalars['jsonb']>;
  hs_code: Maybe<Scalars['String']>;
  imp_cust_clr: Maybe<Scalars['Boolean']>;
  is_express: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  meta: Maybe<Scalars['jsonb']>;
  net_mass: Maybe<Scalars['jsonb']>;
  non_customs_law_obligation: Maybe<Scalars['jsonb']>;
  nonclassified_docs_exists: Maybe<Scalars['Boolean']>;
  origin: Maybe<Scalars['jsonb']>;
  origin_country: Maybe<Scalars['String']>;
  packaging: Maybe<Scalars['jsonb']>;
  payer_id: Maybe<Scalars['uuid']>;
  permissions_js: Maybe<Scalars['json']>;
  permit_obligation: Maybe<Scalars['jsonb']>;
  preference: Maybe<Scalars['String']>;
  produced_document: Maybe<Scalars['jsonb']>;
  qty: Maybe<Scalars['bigint']>;
  reference: Maybe<Scalars['String']>;
  row_number: Maybe<Scalars['bigint']>;
  statistic: Maybe<Scalars['jsonb']>;
  statistical_code: Maybe<Scalars['jsonb']>;
  statistical_value: Maybe<Scalars['String']>;
  toll_dep: Maybe<Scalars['String']>;
  tr_no: Maybe<Scalars['String']>;
  trader_reference: Maybe<Scalars['String']>;
  transitdoc_type: Maybe<Scalars['transitdoc_type']>;
  valuation_details: Maybe<Scalars['jsonb']>;
  value: Maybe<Scalars['jsonb']>;
  vat_total: Maybe<Scalars['String']>;
  vatvalue: Maybe<Scalars['String']>;
  wa_number: Maybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsAdditional_UnitArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsCommodity_CodeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsCustoms_ItemnumberArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsDescriptionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsGoods_ItemArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsGrossmassArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsNet_MassArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsNon_Customs_Law_ObligationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsOriginArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsPackagingArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsPermissions_JsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsPermit_ObligationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsProduced_DocumentArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsStatisticArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsStatistical_CodeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsValuation_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "intf.dr_payment_info" */
export enum Intf_Dr_Payment_Info_Select_Column {
  /** column name */
  Addresses = 'addresses',
  /** column name */
  AddressesQi = 'addresses_qi',
  /** column name */
  Payer = 'payer'
}

/** Ordering options when selecting data from "intf.dr_payment_info". */
export type Intf_Dr_Payment_Info_Order_By = {
  addresses?: InputMaybe<Order_By>;
  addresses_qi?: InputMaybe<Order_By>;
  payer?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "intf.dr_payment_info". All fields are combined with a logical 'AND'. */
export type Intf_Dr_Payment_Info_Bool_Exp = {
  _and?: InputMaybe<Array<Intf_Dr_Payment_Info_Bool_Exp>>;
  _not?: InputMaybe<Intf_Dr_Payment_Info_Bool_Exp>;
  _or?: InputMaybe<Array<Intf_Dr_Payment_Info_Bool_Exp>>;
  addresses?: InputMaybe<_Int4_Comparison_Exp>;
  addresses_qi?: InputMaybe<String_Comparison_Exp>;
  payer?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "intf.dr_payment_info" */
export type Intf_Dr_Payment_Info = {
  addresses: Maybe<Scalars['_int4']>;
  addresses_qi: Maybe<Scalars['String']>;
  payer: Maybe<Scalars['uuid']>;
};

/** select columns of table "json_type" */
export enum Json_Type_Select_Column {
  /** column name */
  JsonValue = 'json_value'
}

/** Ordering options when selecting data from "json_type". */
export type Json_Type_Order_By = {
  json_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "json_type". All fields are combined with a logical 'AND'. */
export type Json_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Json_Type_Bool_Exp>>;
  _not?: InputMaybe<Json_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Json_Type_Bool_Exp>>;
  json_value?: InputMaybe<Json_Comparison_Exp>;
};

/** SETOF-type used for json output. */
export type Json_Type = {
  json_value: Maybe<Scalars['json']>;
};


/** SETOF-type used for json output. */
export type Json_TypeJson_ValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "kc_users" */
export enum Kc_Users_Select_Column {
  /** column name */
  AditPermissions = 'adit_permissions',
  /** column name */
  AditPermissionsDesk = 'adit_permissions_desk',
  /** column name */
  AditPermissionsHex = 'adit_permissions_hex',
  /** column name */
  AditRoles = 'adit_roles',
  /** column name */
  Attrs = 'attrs',
  /** column name */
  Code = 'code',
  /** column name */
  Created = 'created',
  /** column name */
  DefaultRole = 'default_role',
  /** column name */
  Email = 'email',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FederationLink = 'federation_link',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LiberRoles = 'liber_roles',
  /** column name */
  Location = 'location',
  /** column name */
  NotBefore = 'not_before',
  /** column name */
  OrgIds = 'org_ids',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Qty = 'qty',
  /** column name */
  RealmId = 'realm_id',
  /** column name */
  RequiredActions = 'required_actions',
  /** column name */
  ServiceAccountClientLink = 'service_account_client_link',
  /** column name */
  Tenant = 'tenant',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserClientRoles = 'user_client_roles',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username'
}

/** Ordering options when selecting data from "kc_users". */
export type Kc_Users_Order_By = {
  adit_permissions?: InputMaybe<Order_By>;
  adit_permissions_desk?: InputMaybe<Order_By>;
  adit_permissions_hex?: InputMaybe<Order_By>;
  adit_roles?: InputMaybe<Order_By>;
  attrs?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  default_role?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  federation_link?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  liber_roles?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  not_before?: InputMaybe<Order_By>;
  org_ids?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  realm_id?: InputMaybe<Order_By>;
  required_actions?: InputMaybe<Order_By>;
  service_account_client_link?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_client_roles?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "kc_users". All fields are combined with a logical 'AND'. */
export type Kc_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Kc_Users_Bool_Exp>>;
  _not?: InputMaybe<Kc_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Kc_Users_Bool_Exp>>;
  adit_permissions?: InputMaybe<Bigint_Comparison_Exp>;
  adit_permissions_desk?: InputMaybe<_Txtcode_Comparison_Exp>;
  adit_permissions_hex?: InputMaybe<String_Comparison_Exp>;
  adit_roles?: InputMaybe<Jsonb_Comparison_Exp>;
  attrs?: InputMaybe<Jsonb_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  default_role?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  federation_link?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  liber_roles?: InputMaybe<Jsonb_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  not_before?: InputMaybe<Int_Comparison_Exp>;
  org_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  realm_id?: InputMaybe<String_Comparison_Exp>;
  required_actions?: InputMaybe<_Varchar_Comparison_Exp>;
  service_account_client_link?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  user_client_roles?: InputMaybe<Jsonb_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "_txtcode". All fields are combined with logical 'AND'. */
export type _Txtcode_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_txtcode']>;
  _gt?: InputMaybe<Scalars['_txtcode']>;
  _gte?: InputMaybe<Scalars['_txtcode']>;
  _in?: InputMaybe<Array<Scalars['_txtcode']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_txtcode']>;
  _lte?: InputMaybe<Scalars['_txtcode']>;
  _neq?: InputMaybe<Scalars['_txtcode']>;
  _nin?: InputMaybe<Array<Scalars['_txtcode']>>;
};

/** columns and relationships of "kc_users" */
export type Kc_Users = {
  adit_permissions: Maybe<Scalars['bigint']>;
  adit_permissions_desk: Maybe<Scalars['_txtcode']>;
  adit_permissions_hex: Maybe<Scalars['String']>;
  adit_roles: Maybe<Scalars['jsonb']>;
  attrs: Maybe<Scalars['jsonb']>;
  code: Maybe<Scalars['String']>;
  created: Maybe<Scalars['timestamptz']>;
  default_role: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  enabled: Maybe<Scalars['Boolean']>;
  federation_link: Maybe<Scalars['String']>;
  first_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  last_name: Maybe<Scalars['String']>;
  liber_roles: Maybe<Scalars['jsonb']>;
  location: Maybe<Scalars['String']>;
  not_before: Maybe<Scalars['Int']>;
  org_ids: Maybe<Scalars['jsonb']>;
  phone_number: Maybe<Scalars['String']>;
  qty: Maybe<Scalars['bigint']>;
  realm_id: Maybe<Scalars['String']>;
  required_actions: Maybe<Scalars['_varchar']>;
  service_account_client_link: Maybe<Scalars['String']>;
  tenant: Maybe<Scalars['String']>;
  tenant_id: Maybe<Scalars['String']>;
  user_client_roles: Maybe<Scalars['jsonb']>;
  user_id: Maybe<Scalars['uuid']>;
  username: Maybe<Scalars['String']>;
};


/** columns and relationships of "kc_users" */
export type Kc_UsersAdit_RolesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "kc_users" */
export type Kc_UsersAttrsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "kc_users" */
export type Kc_UsersLiber_RolesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "kc_users" */
export type Kc_UsersOrg_IdsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "kc_users" */
export type Kc_UsersUser_Client_RolesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "max_date_type" */
export enum Max_Date_Type_Select_Column {
  /** column name */
  MaxChangeDate = 'max_change_date'
}

/** Ordering options when selecting data from "max_date_type". */
export type Max_Date_Type_Order_By = {
  max_change_date?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "max_date_type". All fields are combined with a logical 'AND'. */
export type Max_Date_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Max_Date_Type_Bool_Exp>>;
  _not?: InputMaybe<Max_Date_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Max_Date_Type_Bool_Exp>>;
  max_change_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** SETOF-type for pp_file_max_date_hs and pp_doc_max_date_hs. */
export type Max_Date_Type = {
  max_change_date: Maybe<Scalars['timestamptz']>;
};

/** select columns of table "model_retrain" */
export enum Model_Retrain_Select_Column {
  /** column name */
  EndTime = 'end_time',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Id = 'id',
  /** column name */
  RequestTime = 'request_time',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status'
}

/** Ordering options when selecting data from "model_retrain". */
export type Model_Retrain_Order_By = {
  end_time?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_time?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "model_retrain". All fields are combined with a logical 'AND'. */
export type Model_Retrain_Bool_Exp = {
  _and?: InputMaybe<Array<Model_Retrain_Bool_Exp>>;
  _not?: InputMaybe<Model_Retrain_Bool_Exp>;
  _or?: InputMaybe<Array<Model_Retrain_Bool_Exp>>;
  end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  request_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "model_retrain" */
export type Model_Retrain = {
  end_time: Maybe<Scalars['timestamptz']>;
  error_message: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  request_time: Maybe<Scalars['timestamptz']>;
  start_time: Maybe<Scalars['timestamptz']>;
  status: Maybe<Scalars['String']>;
};

/** select columns of table "org_ids" */
export enum Org_Ids_Select_Column {
  /** column name */
  AddressesDesc = 'addresses_desc',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DocsAffected = 'docs_affected',
  /** column name */
  FilesAffected = 'files_affected',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgIdDescription = 'org_id_description',
  /** column name */
  OrgIdsDesc = 'org_ids_desc',
  /** column name */
  OrgParams = 'org_params',
  /** column name */
  Qty = 'qty',
  /** column name */
  UsersAffected = 'users_affected'
}

/** Ordering options when selecting data from "org_ids". */
export type Org_Ids_Order_By = {
  addresses_desc?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  docs_affected?: InputMaybe<Order_By>;
  files_affected?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_id_description?: InputMaybe<Order_By>;
  org_ids_desc?: InputMaybe<Order_By>;
  org_params?: InputMaybe<Order_By>;
  orgParams?: InputMaybe<Org_Params_Order_By>;
  qty?: InputMaybe<Order_By>;
  users_affected?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "org_params". */
export type Org_Params_Order_By = {
  addresses?: InputMaybe<Order_By>;
  file_ids?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_ids?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Org_Id_Order_By>;
  orgIds_aggregate?: InputMaybe<Org_Params_Org_Id_Aggregate_Order_By>;
  search?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "org_params_org_id" */
export type Org_Params_Org_Id_Aggregate_Order_By = {
  avg?: InputMaybe<Org_Params_Org_Id_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Params_Org_Id_Max_Order_By>;
  min?: InputMaybe<Org_Params_Org_Id_Min_Order_By>;
  stddev?: InputMaybe<Org_Params_Org_Id_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_Params_Org_Id_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_Params_Org_Id_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_Params_Org_Id_Sum_Order_By>;
  var_pop?: InputMaybe<Org_Params_Org_Id_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_Params_Org_Id_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_Params_Org_Id_Variance_Order_By>;
};

/** order by avg() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Avg_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Max_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Min_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Stddev_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Stddev_Pop_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Stddev_Samp_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Sum_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Var_Pop_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Var_Samp_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Variance_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_ids". All fields are combined with a logical 'AND'. */
export type Org_Ids_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Ids_Bool_Exp>>;
  _not?: InputMaybe<Org_Ids_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Ids_Bool_Exp>>;
  addresses_desc?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  docs_affected?: InputMaybe<_Uuid_Comparison_Exp>;
  files_affected?: InputMaybe<_Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  org_id_description?: InputMaybe<String_Comparison_Exp>;
  org_ids_desc?: InputMaybe<String_Comparison_Exp>;
  org_params?: InputMaybe<Json_Comparison_Exp>;
  orgParams?: InputMaybe<Org_Params_Bool_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  users_affected?: InputMaybe<_Uuid_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "org_params". All fields are combined with a logical 'AND'. */
export type Org_Params_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Params_Bool_Exp>>;
  _not?: InputMaybe<Org_Params_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Params_Bool_Exp>>;
  addresses?: InputMaybe<Query_Int_Comparison_Exp>;
  file_ids?: InputMaybe<_Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Int_Comparison_Exp>;
  org_ids?: InputMaybe<_Int2_Comparison_Exp>;
  orgId?: InputMaybe<Org_Id_Bool_Exp>;
  orgIds?: InputMaybe<Org_Params_Org_Id_Bool_Exp>;
  search?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "query_int". All fields are combined with logical 'AND'. */
export type Query_Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['query_int']>;
  _gt?: InputMaybe<Scalars['query_int']>;
  _gte?: InputMaybe<Scalars['query_int']>;
  _in?: InputMaybe<Array<Scalars['query_int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['query_int']>;
  _lte?: InputMaybe<Scalars['query_int']>;
  _neq?: InputMaybe<Scalars['query_int']>;
  _nin?: InputMaybe<Array<Scalars['query_int']>>;
};

/** Boolean expression to compare columns of type "_int2". All fields are combined with logical 'AND'. */
export type _Int2_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_int2']>;
  _gt?: InputMaybe<Scalars['_int2']>;
  _gte?: InputMaybe<Scalars['_int2']>;
  _in?: InputMaybe<Array<Scalars['_int2']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_int2']>;
  _lte?: InputMaybe<Scalars['_int2']>;
  _neq?: InputMaybe<Scalars['_int2']>;
  _nin?: InputMaybe<Array<Scalars['_int2']>>;
};

/** Boolean expression to filter rows from the table "org_params_org_id". All fields are combined with a logical 'AND'. */
export type Org_Params_Org_Id_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Params_Org_Id_Bool_Exp>>;
  _not?: InputMaybe<Org_Params_Org_Id_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Params_Org_Id_Bool_Exp>>;
  org_id?: InputMaybe<Int_Comparison_Exp>;
  param_org_id?: InputMaybe<Smallint_Comparison_Exp>;
  paramOrgId?: InputMaybe<Org_Id_Bool_Exp>;
};

/** columns and relationships of "org_ids" */
export type Org_Ids = {
  addresses_desc: Maybe<Scalars['String']>;
  display_name: Maybe<Scalars['String']>;
  docs_affected: Maybe<Scalars['_uuid']>;
  files_affected: Maybe<Scalars['_uuid']>;
  org_id: Maybe<Scalars['smallint']>;
  org_id_description: Maybe<Scalars['String']>;
  org_ids_desc: Maybe<Scalars['String']>;
  org_params: Maybe<Scalars['json']>;
  /** An object relationship */
  orgParams: Maybe<Org_Params>;
  qty: Maybe<Scalars['bigint']>;
  users_affected: Maybe<Scalars['_uuid']>;
};


/** columns and relationships of "org_ids" */
export type Org_IdsOrg_ParamsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "org_params" */
export type Org_Params = {
  addresses: Maybe<Scalars['query_int']>;
  file_ids: Maybe<Scalars['_uuid']>;
  org_id: Scalars['Int'];
  org_ids: Maybe<Scalars['_int2']>;
  /** An object relationship */
  orgId: Maybe<Org_Id>;
  /** An array relationship */
  orgIds: Array<Org_Params_Org_Id>;
  search: Maybe<Scalars['String']>;
};


/** columns and relationships of "org_params" */
export type Org_ParamsOrgIdsArgs = {
  distinct_on?: InputMaybe<Array<Org_Params_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Params_Org_Id_Order_By>>;
  where?: InputMaybe<Org_Params_Org_Id_Bool_Exp>;
};

/** select columns of table "org_params_org_id" */
export enum Org_Params_Org_Id_Select_Column {
  /** column name */
  OrgId = 'org_id',
  /** column name */
  ParamOrgId = 'param_org_id'
}

/** Ordering options when selecting data from "org_params_org_id". */
export type Org_Params_Org_Id_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
  paramOrgId?: InputMaybe<Org_Id_Order_By>;
};

/** columns and relationships of "org_params_org_id" */
export type Org_Params_Org_Id = {
  org_id: Maybe<Scalars['Int']>;
  param_org_id: Maybe<Scalars['smallint']>;
  /** An object relationship */
  paramOrgId: Maybe<Org_Id>;
};

/** select columns of table "org_params" */
export enum Org_Params_Select_Column {
  /** column name */
  Addresses = 'addresses',
  /** column name */
  FileIds = 'file_ids',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgIds = 'org_ids',
  /** column name */
  Search = 'search'
}

/** select columns of table "page" */
export enum Page_Select_Column {
  /** column name */
  AiIgnoreRetraining = 'ai_ignore_retraining',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  OcrText = 'ocr_text',
  /** column name */
  PageStatus = 'page_status',
  /** column name */
  Rotate = 'rotate',
  /** column name */
  ThumbnailBigUrl = 'thumbnail_big_url',
  /** column name */
  ThumbnailSmallUrl = 'thumbnail_small_url'
}

/** select columns of table "page_status" */
export enum Page_Status_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Name = 'name'
}

/** Ordering options when selecting data from "page_status". */
export type Page_Status_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/** Boolean expression to filter rows from the table "page_status". All fields are combined with a logical 'AND'. */
export type Page_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Page_Status_Bool_Exp>>;
  _not?: InputMaybe<Page_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Page_Status_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Enum-like table for page.status. Questionable utility. */
export type Page_Status = {
  /** page_status creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** page_status creation user. */
  creation_user: Scalars['uuid'];
  display_name: Maybe<Scalars['String']>;
  /** page_status last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified page_status. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  /** An object relationship */
  user: User_Pp;
};

/** aggregated selection of "pages_m2m_cache" */
export type Pages_M2m_Cache_Aggregate = {
  aggregate: Maybe<Pages_M2m_Cache_Aggregate_Fields>;
  nodes: Array<Pages_M2m_Cache>;
};

/** aggregate fields of "pages_m2m_cache" */
export type Pages_M2m_Cache_Aggregate_Fields = {
  avg: Maybe<Pages_M2m_Cache_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Pages_M2m_Cache_Max_Fields>;
  min: Maybe<Pages_M2m_Cache_Min_Fields>;
  stddev: Maybe<Pages_M2m_Cache_Stddev_Fields>;
  stddev_pop: Maybe<Pages_M2m_Cache_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Pages_M2m_Cache_Stddev_Samp_Fields>;
  sum: Maybe<Pages_M2m_Cache_Sum_Fields>;
  var_pop: Maybe<Pages_M2m_Cache_Var_Pop_Fields>;
  var_samp: Maybe<Pages_M2m_Cache_Var_Samp_Fields>;
  variance: Maybe<Pages_M2m_Cache_Variance_Fields>;
};


/** aggregate fields of "pages_m2m_cache" */
export type Pages_M2m_Cache_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pages_M2m_Cache_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pages_M2m_Cache_Avg_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Pages_M2m_Cache_Max_Fields = {
  document_id: Maybe<Scalars['uuid']>;
  page: Maybe<Scalars['uuid']>;
  page_number: Maybe<Scalars['bigint']>;
  page_status: Maybe<Scalars['String']>;
  rotate: Maybe<Scalars['Int']>;
  thumbnail_big_url: Maybe<Scalars['String']>;
  thumbnail_small_url: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Pages_M2m_Cache_Min_Fields = {
  document_id: Maybe<Scalars['uuid']>;
  page: Maybe<Scalars['uuid']>;
  page_number: Maybe<Scalars['bigint']>;
  page_status: Maybe<Scalars['String']>;
  rotate: Maybe<Scalars['Int']>;
  thumbnail_big_url: Maybe<Scalars['String']>;
  thumbnail_small_url: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Pages_M2m_Cache_Stddev_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pages_M2m_Cache_Stddev_Pop_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pages_M2m_Cache_Stddev_Samp_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Pages_M2m_Cache_Sum_Fields = {
  page_number: Maybe<Scalars['bigint']>;
  rotate: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Pages_M2m_Cache_Var_Pop_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pages_M2m_Cache_Var_Samp_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pages_M2m_Cache_Variance_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

export type Pp_Addresses_Args = {
  _address_ids?: InputMaybe<Scalars['_int4']>;
  _address_types?: InputMaybe<Scalars['_int4']>;
  _empty_address_type?: InputMaybe<Scalars['Boolean']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
  _show_deleted?: InputMaybe<Scalars['Boolean']>;
};

export type Pp_Addresses_By_Payer_Address_Args = {
  _payer_address?: InputMaybe<Scalars['Int']>;
};

export type Pp_Addresses_By_Payer_Id_Args = {
  _payer_id?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Ai_Stats_Args = {
  _crusers?: InputMaybe<Scalars['_uuid']>;
  _ended?: InputMaybe<Scalars['timestamptz']>;
  _only_ai_doctypes?: InputMaybe<Scalars['Boolean']>;
  _orgids?: InputMaybe<Scalars['_int2']>;
  _started?: InputMaybe<Scalars['timestamptz']>;
};

export type Pp_Ai_Stats_Dt_Args = {
  _crusers?: InputMaybe<Scalars['_uuid']>;
  _ended?: InputMaybe<Scalars['timestamptz']>;
  _only_ai_doctypes?: InputMaybe<Scalars['Boolean']>;
  _orgids?: InputMaybe<Scalars['_int2']>;
  _started?: InputMaybe<Scalars['timestamptz']>;
};

export type Pp_Check_Json_Param_Args = {
  _param?: InputMaybe<Scalars['json']>;
};

export type Pp_Customs_Response_Summary_Args = {
  _with_evv?: InputMaybe<Scalars['Boolean']>;
};

export type Pp_Declaration_Request_Args = {
  _file_ids?: InputMaybe<Scalars['_uuid']>;
};

export type DeclarationRequestsArgs = {
  _addresses?: InputMaybe<Array<AddressFilter>>;
  _addresses_qi?: InputMaybe<Scalars['String']>;
  _arrival_type?: InputMaybe<Scalars['String']>;
  _clr_type?: InputMaybe<Scalars['String']>;
  _date_max?: InputMaybe<Scalars['LocalDateTime']>;
  _date_min?: InputMaybe<Scalars['LocalDateTime']>;
  _decl_type?: InputMaybe<Scalars['String']>;
  _declaration_labels?: InputMaybe<Scalars['String']>;
  _declaration_statuses?: InputMaybe<Scalars['String']>;
  _evv_status?: InputMaybe<Scalars['String']>;
  _file_id?: InputMaybe<Scalars['UUID']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Array<Scalars['JSONObject']>>;
  _payer?: InputMaybe<Scalars['UUID']>;
  _search?: InputMaybe<Scalars['String']>;
  _search_field?: InputMaybe<Scalars['String']>;
};

export type DeclarationRequestsReportArgs = {
  _addresses?: InputMaybe<Array<AddressFilter>>;
  _addresses_qi?: InputMaybe<Scalars['String']>;
  _arrival_type?: InputMaybe<Scalars['String']>;
  _clr_type?: InputMaybe<Scalars['String']>;
  _columns: Array<Scalars['String']>;
  _date_max?: InputMaybe<Scalars['LocalDateTime']>;
  _date_min?: InputMaybe<Scalars['LocalDateTime']>;
  _decl_type?: InputMaybe<Scalars['String']>;
  _declaration_labels?: InputMaybe<Scalars['String']>;
  _declaration_statuses?: InputMaybe<Scalars['String']>;
  _evv_status?: InputMaybe<Scalars['String']>;
  _file_id?: InputMaybe<Scalars['UUID']>;
  _nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  _orderby?: InputMaybe<Array<Scalars['JSONObject']>>;
  _payer?: InputMaybe<Scalars['UUID']>;
  _search?: InputMaybe<Scalars['String']>;
  _search_field?: InputMaybe<Scalars['String']>;
  _total_items?: InputMaybe<Scalars['Int']>;
};

export type Pp_Declaration_Tasks_Args = {
  _assigned_to?: InputMaybe<Scalars['uuid']>;
  _creation_date?: InputMaybe<Scalars['timestamptz']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _max_due_date?: InputMaybe<Scalars['timestamptz']>;
  _min_due_date?: InputMaybe<Scalars['timestamptz']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
  _search_lang?: InputMaybe<Scalars['String']>;
  _task_status_id?: InputMaybe<Scalars['Int']>;
  _task_type_id?: InputMaybe<Scalars['Int']>;
};

export type Pp_Declaration_Tasks_Agg_Args = {
  _assigned_to?: InputMaybe<Scalars['uuid']>;
  _creation_date?: InputMaybe<Scalars['timestamptz']>;
  _max_due_date?: InputMaybe<Scalars['timestamptz']>;
  _min_due_date?: InputMaybe<Scalars['timestamptz']>;
  _search?: InputMaybe<Scalars['String']>;
  _search_lang?: InputMaybe<Scalars['String']>;
  _task_type_id?: InputMaybe<Scalars['Int']>;
};

export type Pp_Declaration_Tasks_Obj_Args = {
  _assigned_to?: InputMaybe<Scalars['uuid']>;
  _creation_date?: InputMaybe<Scalars['timestamptz']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _max_due_date?: InputMaybe<Scalars['timestamptz']>;
  _min_due_date?: InputMaybe<Scalars['timestamptz']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
  _search_lang?: InputMaybe<Scalars['String']>;
  _task_status_id?: InputMaybe<Scalars['Int']>;
  _task_type_id?: InputMaybe<Scalars['Int']>;
};

export type Pp_Declarations_Args = {
  _addresses?: InputMaybe<Scalars['_int4']>;
  _enddate?: InputMaybe<Scalars['timestamptz']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _orgids?: InputMaybe<Scalars['_int4']>;
  _search?: InputMaybe<Scalars['String']>;
  _startdate?: InputMaybe<Scalars['timestamptz']>;
};

export type Pp_Delete_Declaration_Requests_Args = {
  _file_ids?: InputMaybe<Scalars['_uuid']>;
};

export type Pp_Doc_Max_Date_V2_Args = {
  _my?: InputMaybe<Scalars['Boolean']>;
};

export type Pp_Doc_Search_Args = {
  _creationuser?: InputMaybe<Scalars['uuid']>;
  _curr_userid?: InputMaybe<Scalars['uuid']>;
  _docflags?: InputMaybe<Scalars['bigint']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _searchval?: InputMaybe<Scalars['String']>;
};

export type Pp_Doc_Search_Hs_Args = {
  _creationuser?: InputMaybe<Scalars['uuid']>;
  _docflags?: InputMaybe<Scalars['bigint']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _searchval?: InputMaybe<Scalars['String']>;
};

export type Pp_Doc_Stats_Args = {
  _crusers?: InputMaybe<Scalars['_uuid']>;
  _ended?: InputMaybe<Scalars['timestamptz']>;
  _orgids?: InputMaybe<Scalars['_int2']>;
  _started?: InputMaybe<Scalars['timestamptz']>;
  _tenant?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Docs_For_Validation_Args = {
  _doc_id?: InputMaybe<Scalars['uuid']>;
  _org_ids?: InputMaybe<Scalars['_int2']>;
};

export type Pp_Document_Args = {
  _ids?: InputMaybe<Scalars['_uuid']>;
};

export type Pp_Document_Flag_Args = {
  _ids?: InputMaybe<Scalars['_int8']>;
};

export type Pp_Document_Labels_Args = {
  _ids?: InputMaybe<Scalars['_int4']>;
};

export type Pp_Dr_Goods_Items_Args = {
  _addresses?: InputMaybe<Scalars['_int4']>;
  _addresses_qi?: InputMaybe<Scalars['String']>;
  _arrival_type?: InputMaybe<Scalars['String']>;
  _clr_type?: InputMaybe<Scalars['String']>;
  _commodity_codes?: InputMaybe<Scalars['_text']>;
  _date_max?: InputMaybe<Scalars['timestamptz']>;
  _date_min?: InputMaybe<Scalars['timestamptz']>;
  _decl_type?: InputMaybe<Scalars['String']>;
  _declaration_statuses?: InputMaybe<Scalars['_varchar']>;
  _file_id?: InputMaybe<Scalars['uuid']>;
  _items_search?: InputMaybe<Scalars['String']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
};

export type Pp_Dr_Stats_Args = {
  _metric?: InputMaybe<Scalars['String']>;
  _tenant_id?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Email_Search_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
  _userid?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Email_Search_Hs_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
};

export type Pp_File_Max_Date_V2_Args = {
  _my?: InputMaybe<Scalars['Boolean']>;
};

export type Pp_File_Search_Args = {
  _addresses?: InputMaybe<Scalars['_int4']>;
  _curr_userid?: InputMaybe<Scalars['uuid']>;
  _file_flags?: InputMaybe<Scalars['_int8']>;
  _file_statuses?: InputMaybe<Scalars['_text']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _max_date?: InputMaybe<Scalars['timestamptz']>;
  _min_date?: InputMaybe<Scalars['timestamptz']>;
  _my_files_only?: InputMaybe<Scalars['Boolean']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _org_ids?: InputMaybe<Scalars['_int2']>;
  _searchval?: InputMaybe<Scalars['String']>;
};

/** select columns of table "pp_types.file_search" */
export enum Pp_Types_File_Search_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsRelevant = 'customs_relevant',
  /** column name */
  CustomsRelevantQty = 'customs_relevant_qty',
  /** column name */
  ExtractionCompletedQty = 'extraction_completed_qty',
  /** column name */
  ExtractionRequired = 'extraction_required',
  /** column name */
  ExtractionRequiredQty = 'extraction_required_qty',
  /** column name */
  FileFlags = 'file_flags',
  /** column name */
  FileStatus = 'file_status',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Identification = 'identification',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgIdDescription = 'org_id_description',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TotalRows = 'total_rows'
}

/** Ordering options when selecting data from "pp_types.file_search". */
export type Pp_Types_File_Search_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_relevant?: InputMaybe<Order_By>;
  customs_relevant_qty?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  extraction_completed_qty?: InputMaybe<Order_By>;
  extraction_required?: InputMaybe<Order_By>;
  extraction_required_qty?: InputMaybe<Order_By>;
  file_flags?: InputMaybe<Order_By>;
  file_status?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identification?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org?: InputMaybe<Org_Id_Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_id_description?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  total_rows?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pp_types.file_search". All fields are combined with a logical 'AND'. */
export type Pp_Types_File_Search_Bool_Exp = {
  _and?: InputMaybe<Array<Pp_Types_File_Search_Bool_Exp>>;
  _not?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
  _or?: InputMaybe<Array<Pp_Types_File_Search_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_relevant?: InputMaybe<Boolean_Comparison_Exp>;
  customs_relevant_qty?: InputMaybe<Bigint_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  extraction_completed_qty?: InputMaybe<Bigint_Comparison_Exp>;
  extraction_required?: InputMaybe<Boolean_Comparison_Exp>;
  extraction_required_qty?: InputMaybe<Bigint_Comparison_Exp>;
  file_flags?: InputMaybe<Bigint_Comparison_Exp>;
  file_status?: InputMaybe<String_Comparison_Exp>;
  file_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identification?: InputMaybe<String_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org?: InputMaybe<Org_Id_Bool_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  org_id_description?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  total_rows?: InputMaybe<Bigint_Comparison_Exp>;
};

/** types.file_search used as SETOF type for pp_file_search% functions. By itself is not very useful */
export type Pp_Types_File_Search = {
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Scalars['uuid'];
  customs_relevant: Maybe<Scalars['Boolean']>;
  customs_relevant_qty: Maybe<Scalars['bigint']>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  extraction_completed_qty: Maybe<Scalars['bigint']>;
  extraction_required: Maybe<Scalars['Boolean']>;
  extraction_required_qty: Maybe<Scalars['bigint']>;
  file_flags: Scalars['bigint'];
  file_status: Scalars['String'];
  file_url: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  identification: Maybe<Scalars['String']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Scalars['jsonb'];
  name: Maybe<Scalars['String']>;
  /** An object relationship */
  org: Maybe<Org_Id>;
  org_id: Scalars['smallint'];
  org_id_description: Scalars['String'];
  session_id: Scalars['String'];
  total_rows: Maybe<Scalars['bigint']>;
};


/** types.file_search used as SETOF type for pp_file_search% functions. By itself is not very useful */
export type Pp_Types_File_SearchDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** types.file_search used as SETOF type for pp_file_search% functions. By itself is not very useful */
export type Pp_Types_File_SearchDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** types.file_search used as SETOF type for pp_file_search% functions. By itself is not very useful */
export type Pp_Types_File_SearchMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type Pp_File_Search_Hs_Args = {
  _addresses?: InputMaybe<Scalars['_int4']>;
  _file_flags?: InputMaybe<Scalars['_int8']>;
  _file_statuses?: InputMaybe<Scalars['_text']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _max_date?: InputMaybe<Scalars['timestamptz']>;
  _min_date?: InputMaybe<Scalars['timestamptz']>;
  _my_files_only?: InputMaybe<Scalars['Boolean']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _org_ids?: InputMaybe<Scalars['_int2']>;
  _searchval?: InputMaybe<Scalars['String']>;
};

export type Pp_File_Stats_Args = {
  _crusers?: InputMaybe<Scalars['_uuid']>;
  _ended?: InputMaybe<Scalars['timestamptz']>;
  _orgids?: InputMaybe<Scalars['_int2']>;
  _started?: InputMaybe<Scalars['timestamptz']>;
};

export type CommodityCodeStatistics = {
  declarationCount: Scalars['Float'];
  goodsItemCount: Scalars['Float'];
  totalGrossMass: Scalars['Float'];
  totalNetMass: Scalars['Float'];
};

export type StatisticsDto = {
  avgCommodityCodesPerDeclaration: Scalars['Float'];
  commodityCodesChapters: Array<StatisticTariffNumberItem>;
  customsAgencies: Array<StatisticItem>;
  customsDeclarations: DateInterval;
};

export type StatisticTariffNumberItem = {
  chapter: Scalars['String'];
  declarationCount: Scalars['Float'];
  goodsItemCount: Scalars['Float'];
  heading: Scalars['String'];
  subheading: Scalars['String'];
  tariffNumber: Scalars['String'];
  totalGrossMass: Scalars['Float'];
  totalNetMass: Scalars['Float'];
};

export type StatisticItem = {
  count: Scalars['Float'];
  label: Scalars['String'];
  percentage: Scalars['Float'];
  traderIdentificationNumber: Scalars['String'];
};

export type DateInterval = {
  dateInterval: Array<DateIntervalItem>;
  tickInterval: Scalars['String'];
};

export type DateIntervalItem = {
  count: Scalars['Float'];
  date: Scalars['String'];
  lastYearCount: Scalars['Float'];
};

export type Pp_Get_Wd_Perms_For_Dr_Args = {
  _dr_no?: InputMaybe<Scalars['smallint']>;
  _file_id?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Kc_Users_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
  _tenants?: InputMaybe<Scalars['_uuid']>;
  _uid?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Last_Doc_In_Dr_Args = {
  _dr_no?: InputMaybe<Scalars['smallint']>;
  _file_id?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Org_Id_Delete_Args = {
  _force?: InputMaybe<Scalars['Boolean']>;
  _org_id?: InputMaybe<Scalars['smallint']>;
};

export type Pp_Org_Id_Insert_Args = {
  _desk?: InputMaybe<Scalars['String']>;
  _display_name?: InputMaybe<Scalars['String']>;
  _org_id?: InputMaybe<Scalars['smallint']>;
  _org_params?: InputMaybe<Scalars['json']>;
  _tenant?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Org_Id_Update_Args = {
  _desk?: InputMaybe<Scalars['String']>;
  _display_name?: InputMaybe<Scalars['String']>;
  _org_id?: InputMaybe<Scalars['smallint']>;
  _org_params?: InputMaybe<Scalars['json']>;
  _tenant?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Org_Ids_Args = {
  _id?: InputMaybe<Scalars['smallint']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
};

export type Pp_Page_Extract_Grids_Text_Args = {
  _coordinates?: InputMaybe<Scalars['jsonb']>;
  _extract_type_id?: InputMaybe<Scalars['smallint']>;
  _page_id?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Page_Extract_Text_Fragment_Args = {
  _extract_type_id?: InputMaybe<Scalars['smallint']>;
  _height?: InputMaybe<Scalars['numeric']>;
  _pageid?: InputMaybe<Scalars['uuid']>;
  _width?: InputMaybe<Scalars['numeric']>;
  _x?: InputMaybe<Scalars['numeric']>;
  _y?: InputMaybe<Scalars['numeric']>;
};

export type Pp_Page_Extract_Text_Fragment_V2_Args = {
  _extract_type_id?: InputMaybe<Scalars['smallint']>;
  _height?: InputMaybe<Scalars['numeric']>;
  _pageid?: InputMaybe<Scalars['uuid']>;
  _width?: InputMaybe<Scalars['numeric']>;
  _x?: InputMaybe<Scalars['numeric']>;
  _y?: InputMaybe<Scalars['numeric']>;
};

export type Pp_Tenants_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
  _tenant_id?: InputMaybe<Scalars['uuid']>;
};

/** select columns of table "tenants" */
export enum Tenants_Select_Column {
  /** column name */
  AddressGroups = 'address_groups',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  PermissionsDesk = 'permissions_desk',
  /** column name */
  Qty = 'qty',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TenantName = 'tenant_name',
  /** column name */
  TenantType = 'tenant_type',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number'
}

/** Ordering options when selecting data from "tenants". */
export type Tenants_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_groups?: InputMaybe<Order_By>;
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  creationUser?: InputMaybe<User_Pp_Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  lastModifiedUser?: InputMaybe<User_Pp_Order_By>;
  permissions?: InputMaybe<Order_By>;
  permissions_desk?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tenant_name?: InputMaybe<Order_By>;
  tenant_type?: InputMaybe<Order_By>;
  trader_identification_number?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<User_Pp_Aggregate_Order_By>;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type Tenants_Bool_Exp = {
  _and?: InputMaybe<Array<Tenants_Bool_Exp>>;
  _not?: InputMaybe<Tenants_Bool_Exp>;
  _or?: InputMaybe<Array<Tenants_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_groups?: InputMaybe<_Int2_Comparison_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  address_type?: InputMaybe<String_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  creationUser?: InputMaybe<User_Pp_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  lastModifiedUser?: InputMaybe<User_Pp_Bool_Exp>;
  permissions?: InputMaybe<String_Comparison_Exp>;
  permissions_desk?: InputMaybe<_Txtcode_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_name?: InputMaybe<String_Comparison_Exp>;
  tenant_type?: InputMaybe<Tenant_Type_Comparison_Exp>;
  trader_identification_number?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<User_Pp_Bool_Exp>;
};

/** SETOF type for pp_tenants() */
export type Tenants = {
  /** An object relationship */
  address: Maybe<Address>;
  address_groups: Maybe<Scalars['_int2']>;
  address_id: Scalars['Int'];
  address_type: Scalars['String'];
  company_name: Scalars['String'];
  creation_date: Scalars['timestamptz'];
  creation_user: Scalars['uuid'];
  /** An object relationship */
  creationUser: Maybe<User_Pp>;
  id: Scalars['uuid'];
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  /** An object relationship */
  lastModifiedUser: Maybe<User_Pp>;
  permissions: Maybe<Scalars['String']>;
  permissions_desk: Maybe<Scalars['_txtcode']>;
  qty: Maybe<Scalars['bigint']>;
  tenant_id: Maybe<Scalars['uuid']>;
  tenant_name: Scalars['String'];
  tenant_type: Maybe<Scalars['tenant_type']>;
  trader_identification_number: Maybe<Scalars['String']>;
  /** An array relationship */
  users: Array<User_Pp>;
};


/** SETOF type for pp_tenants() */
export type TenantsUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Pp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Pp_Order_By>>;
  where?: InputMaybe<User_Pp_Bool_Exp>;
};

export type Pp_User_Org_Id_Args = {
  _uids?: InputMaybe<Scalars['_uuid']>;
};

export type Pp_User_Search_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
};

/** select columns of table "user_search_type" */
export enum User_Search_Type_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Role = 'role',
  /** column name */
  TotalRows = 'total_rows'
}

/** Ordering options when selecting data from "user_search_type". */
export type User_Search_Type_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  total_rows?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_search_type". All fields are combined with a logical 'AND'. */
export type User_Search_Type_Bool_Exp = {
  _and?: InputMaybe<Array<User_Search_Type_Bool_Exp>>;
  _not?: InputMaybe<User_Search_Type_Bool_Exp>;
  _or?: InputMaybe<Array<User_Search_Type_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<Json_Comparison_Exp>;
  total_rows?: InputMaybe<Bigint_Comparison_Exp>;
};

/** SETOF-type used in pp_user_search and pp_user_search_hs */
export type User_Search_Type = {
  creation_date: Maybe<Scalars['timestamptz']>;
  display_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  location: Maybe<Scalars['String']>;
  role: Maybe<Scalars['json']>;
  total_rows: Maybe<Scalars['bigint']>;
};


/** SETOF-type used in pp_user_search and pp_user_search_hs */
export type User_Search_TypeRoleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  Orgs = 'orgs',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  PermissionsDesk = 'permissions_desk',
  /** column name */
  Tenant = 'tenant',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  code?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  orgs?: InputMaybe<Order_By>;
  permissions?: InputMaybe<Order_By>;
  permissions_desk?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  orgs?: InputMaybe<_Int2_Comparison_Exp>;
  permissions?: InputMaybe<String_Comparison_Exp>;
  permissions_desk?: InputMaybe<_Txtcode_Comparison_Exp>;
  tenant?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** View of users in system. Prefer use this view insead of table user_pp. */
export type Users = {
  code: Maybe<Scalars['String']>;
  display_name: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  orgs: Maybe<Scalars['_int2']>;
  permissions: Maybe<Scalars['String']>;
  permissions_desk: Maybe<Scalars['_txtcode']>;
  tenant: Maybe<Scalars['String']>;
  tenant_id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user: Maybe<User_Pp>;
  user_id: Maybe<Scalars['uuid']>;
};

export type Pp_View_Document_History_Args = {
  _ids?: InputMaybe<Scalars['_uuid']>;
};

/** select columns of table "view_document_history" */
export enum View_Document_History_Select_Column {
  /** column name */
  ActionTitle = 'action_title',
  /** column name */
  ActionUser = 'action_user',
  /** column name */
  ActionValue = 'action_value',
  /** column name */
  Id = 'id',
  /** column name */
  OpDate = 'op_date'
}

/** Ordering options when selecting data from "view_document_history". */
export type View_Document_History_Order_By = {
  action_title?: InputMaybe<Order_By>;
  action_user?: InputMaybe<Order_By>;
  action_value?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  id?: InputMaybe<Order_By>;
  op_date?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "view_document_history". All fields are combined with a logical 'AND'. */
export type View_Document_History_Bool_Exp = {
  _and?: InputMaybe<Array<View_Document_History_Bool_Exp>>;
  _not?: InputMaybe<View_Document_History_Bool_Exp>;
  _or?: InputMaybe<Array<View_Document_History_Bool_Exp>>;
  action_title?: InputMaybe<String_Comparison_Exp>;
  action_user?: InputMaybe<Uuid_Comparison_Exp>;
  action_value?: InputMaybe<String_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  op_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** History of changes in document. */
export type View_Document_History = {
  action_title: Maybe<Scalars['String']>;
  action_user: Maybe<Scalars['uuid']>;
  action_value: Maybe<Scalars['String']>;
  /** An object relationship */
  document: Maybe<Document>;
  id: Scalars['uuid'];
  op_date: Scalars['timestamptz'];
};

export type Pp_View_File_History_Args = {
  _file_id?: InputMaybe<Scalars['uuid']>;
};

/** select columns of table "view_file_history" */
export enum View_File_History_Select_Column {
  /** column name */
  ActionTitle = 'action_title',
  /** column name */
  ActionUser = 'action_user',
  /** column name */
  ActionValue = 'action_value',
  /** column name */
  Id = 'id',
  /** column name */
  OpDate = 'op_date'
}

/** Ordering options when selecting data from "view_file_history". */
export type View_File_History_Order_By = {
  action_title?: InputMaybe<Order_By>;
  action_user?: InputMaybe<Order_By>;
  action_value?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  id?: InputMaybe<Order_By>;
  op_date?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "view_file_history". All fields are combined with a logical 'AND'. */
export type View_File_History_Bool_Exp = {
  _and?: InputMaybe<Array<View_File_History_Bool_Exp>>;
  _not?: InputMaybe<View_File_History_Bool_Exp>;
  _or?: InputMaybe<Array<View_File_History_Bool_Exp>>;
  action_title?: InputMaybe<String_Comparison_Exp>;
  action_user?: InputMaybe<Uuid_Comparison_Exp>;
  action_value?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  op_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** History of changes in table file. */
export type View_File_History = {
  action_title: Maybe<Scalars['String']>;
  action_user: Maybe<Scalars['uuid']>;
  action_value: Maybe<Scalars['String']>;
  /** An object relationship */
  file: Maybe<File>;
  id: Scalars['uuid'];
  op_date: Scalars['timestamptz'];
};

/** select columns of table "report" */
export enum Report_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  Md5 = 'md5',
  /** column name */
  Status = 'status',
  /** column name */
  Url = 'url'
}

/** Ordering options when selecting data from "report". */
export type Report_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  md5?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "report". All fields are combined with a logical 'AND'. */
export type Report_Bool_Exp = {
  _and?: InputMaybe<Array<Report_Bool_Exp>>;
  _not?: InputMaybe<Report_Bool_Exp>;
  _or?: InputMaybe<Array<Report_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  md5?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "report" */
export type Report = {
  creation_date: Scalars['timestamptz'];
  creation_user: Scalars['uuid'];
  id: Scalars['uuid'];
  last_modified_date: Maybe<Scalars['timestamptz']>;
  md5: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

/** aggregated selection of "report" */
export type Report_Aggregate = {
  aggregate: Maybe<Report_Aggregate_Fields>;
  nodes: Array<Report>;
};

/** aggregate fields of "report" */
export type Report_Aggregate_Fields = {
  count: Scalars['Int'];
  max: Maybe<Report_Max_Fields>;
  min: Maybe<Report_Min_Fields>;
};


/** aggregate fields of "report" */
export type Report_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Report_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Report_Max_Fields = {
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  md5: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Report_Min_Fields = {
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  md5: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

/** select columns of table "service" */
export enum Service_Select_Column {
  /** column name */
  SrvDesk = 'srv_desk',
  /** column name */
  SrvId = 'srv_id',
  /** column name */
  SrvType = 'srv_type',
  /** column name */
  Translation = 'translation'
}

/** select columns of table "service_tariff" */
export enum Service_Tariff_Select_Column {
  /** column name */
  DirectUploadCost = 'direct_upload_cost',
  /** column name */
  EmailUploadCost = 'email_upload_cost',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  PositionCost = 'position_cost',
  /** column name */
  PositionsIncluded = 'positions_included',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TenantId = 'tenant_id'
}

/** Ordering options when selecting data from "service_tariff". */
export type Service_Tariff_Order_By = {
  direct_upload_cost?: InputMaybe<Order_By>;
  email_upload_cost?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  position_cost?: InputMaybe<Order_By>;
  positions_included?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "service_tariff". All fields are combined with a logical 'AND'. */
export type Service_Tariff_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Tariff_Bool_Exp>>;
  _not?: InputMaybe<Service_Tariff_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Tariff_Bool_Exp>>;
  direct_upload_cost?: InputMaybe<Numeric_Comparison_Exp>;
  email_upload_cost?: InputMaybe<Numeric_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  position_cost?: InputMaybe<Numeric_Comparison_Exp>;
  positions_included?: InputMaybe<Int_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "service_tariff" */
export type Service_Tariff = {
  direct_upload_cost: Maybe<Scalars['numeric']>;
  email_upload_cost: Maybe<Scalars['numeric']>;
  end_date: Maybe<Scalars['date']>;
  id: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  position_cost: Maybe<Scalars['numeric']>;
  positions_included: Maybe<Scalars['Int']>;
  start_date: Maybe<Scalars['date']>;
  tenant_id: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "service_tariff" */
export type Service_TariffMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "service_tariff" */
export type Service_Tariff_Aggregate = {
  aggregate: Maybe<Service_Tariff_Aggregate_Fields>;
  nodes: Array<Service_Tariff>;
};

/** aggregate fields of "service_tariff" */
export type Service_Tariff_Aggregate_Fields = {
  avg: Maybe<Service_Tariff_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Service_Tariff_Max_Fields>;
  min: Maybe<Service_Tariff_Min_Fields>;
  stddev: Maybe<Service_Tariff_Stddev_Fields>;
  stddev_pop: Maybe<Service_Tariff_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Service_Tariff_Stddev_Samp_Fields>;
  sum: Maybe<Service_Tariff_Sum_Fields>;
  var_pop: Maybe<Service_Tariff_Var_Pop_Fields>;
  var_samp: Maybe<Service_Tariff_Var_Samp_Fields>;
  variance: Maybe<Service_Tariff_Variance_Fields>;
};


/** aggregate fields of "service_tariff" */
export type Service_Tariff_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Service_Tariff_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Service_Tariff_Avg_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Service_Tariff_Max_Fields = {
  direct_upload_cost: Maybe<Scalars['numeric']>;
  email_upload_cost: Maybe<Scalars['numeric']>;
  end_date: Maybe<Scalars['date']>;
  id: Maybe<Scalars['uuid']>;
  position_cost: Maybe<Scalars['numeric']>;
  positions_included: Maybe<Scalars['Int']>;
  start_date: Maybe<Scalars['date']>;
  tenant_id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Service_Tariff_Min_Fields = {
  direct_upload_cost: Maybe<Scalars['numeric']>;
  email_upload_cost: Maybe<Scalars['numeric']>;
  end_date: Maybe<Scalars['date']>;
  id: Maybe<Scalars['uuid']>;
  position_cost: Maybe<Scalars['numeric']>;
  positions_included: Maybe<Scalars['Int']>;
  start_date: Maybe<Scalars['date']>;
  tenant_id: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Service_Tariff_Stddev_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Service_Tariff_Stddev_Pop_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Service_Tariff_Stddev_Samp_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Service_Tariff_Sum_Fields = {
  direct_upload_cost: Maybe<Scalars['numeric']>;
  email_upload_cost: Maybe<Scalars['numeric']>;
  position_cost: Maybe<Scalars['numeric']>;
  positions_included: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Service_Tariff_Var_Pop_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Service_Tariff_Var_Samp_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Service_Tariff_Variance_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** select columns of table "setting" */
export enum Setting_Select_Column {
  /** column name */
  Constrained = 'constrained',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DataType = 'data_type',
  /** column name */
  DefaultValue = 'default_value',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  MaxValue = 'max_value',
  /** column name */
  MinValue = 'min_value',
  /** column name */
  SettingGroupId = 'setting_group_id'
}

/** Ordering options when selecting data from "setting". */
export type Setting_Order_By = {
  constrained?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  data_type?: InputMaybe<Order_By>;
  default_value?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
  setting_group?: InputMaybe<Setting_Group_Order_By>;
  setting_group_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/** Ordering options when selecting data from "setting_group". */
export type Setting_Group_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  settings_aggregate?: InputMaybe<Setting_Aggregate_Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/** order by aggregate values of table "setting" */
export type Setting_Aggregate_Order_By = {
  avg?: InputMaybe<Setting_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Setting_Max_Order_By>;
  min?: InputMaybe<Setting_Min_Order_By>;
  stddev?: InputMaybe<Setting_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Setting_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Setting_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Setting_Sum_Order_By>;
  var_pop?: InputMaybe<Setting_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Setting_Var_Samp_Order_By>;
  variance?: InputMaybe<Setting_Variance_Order_By>;
};

/** order by avg() on columns of table "setting" */
export type Setting_Avg_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "setting" */
export type Setting_Max_Order_By = {
  /** setting creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** setting creation user. */
  creation_user?: InputMaybe<Order_By>;
  data_type?: InputMaybe<Order_By>;
  default_value?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** id of setting. */
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  /** setting last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified setting. */
  last_modified_user?: InputMaybe<Order_By>;
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
  setting_group_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "setting" */
export type Setting_Min_Order_By = {
  /** setting creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** setting creation user. */
  creation_user?: InputMaybe<Order_By>;
  data_type?: InputMaybe<Order_By>;
  default_value?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** id of setting. */
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  /** setting last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified setting. */
  last_modified_user?: InputMaybe<Order_By>;
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
  setting_group_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "setting" */
export type Setting_Stddev_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "setting" */
export type Setting_Stddev_Pop_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "setting" */
export type Setting_Stddev_Samp_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "setting" */
export type Setting_Sum_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "setting" */
export type Setting_Var_Pop_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "setting" */
export type Setting_Var_Samp_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "setting" */
export type Setting_Variance_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "setting". All fields are combined with a logical 'AND'. */
export type Setting_Bool_Exp = {
  _and?: InputMaybe<Array<Setting_Bool_Exp>>;
  _not?: InputMaybe<Setting_Bool_Exp>;
  _or?: InputMaybe<Array<Setting_Bool_Exp>>;
  constrained?: InputMaybe<Boolean_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  data_type?: InputMaybe<String_Comparison_Exp>;
  default_value?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identifier?: InputMaybe<String_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  max_value?: InputMaybe<Numeric_Comparison_Exp>;
  min_value?: InputMaybe<Numeric_Comparison_Exp>;
  setting_group?: InputMaybe<Setting_Group_Bool_Exp>;
  setting_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "setting_group". All fields are combined with a logical 'AND'. */
export type Setting_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Setting_Group_Bool_Exp>>;
  _not?: InputMaybe<Setting_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Setting_Group_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  settings?: InputMaybe<Setting_Bool_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Settings. This thing is itself db-in-db. Never saw in usage. */
export type Setting = {
  constrained: Maybe<Scalars['Boolean']>;
  /** setting creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** setting creation user. */
  creation_user: Scalars['uuid'];
  data_type: Maybe<Scalars['String']>;
  default_value: Maybe<Scalars['String']>;
  description: Scalars['String'];
  /** id of setting. */
  id: Scalars['uuid'];
  identifier: Scalars['String'];
  /** setting last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified setting. */
  last_modified_user: Maybe<Scalars['uuid']>;
  max_value: Maybe<Scalars['numeric']>;
  min_value: Maybe<Scalars['numeric']>;
  /** An object relationship */
  setting_group: Maybe<Setting_Group>;
  setting_group_id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user: User_Pp;
};

/** Settings has groupes. Nothing more could be said about them. */
export type Setting_Group = {
  /** setting_group creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** setting_group creation user. */
  creation_user: Scalars['uuid'];
  description: Scalars['String'];
  /** id of setting_group. */
  id: Scalars['uuid'];
  /** setting_group last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified setting_group. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** An array relationship */
  settings: Array<Setting>;
  /** An object relationship */
  user: User_Pp;
};


/** Settings has groupes. Nothing more could be said about them. */
export type Setting_GroupSettingsArgs = {
  distinct_on?: InputMaybe<Array<Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Order_By>>;
  where?: InputMaybe<Setting_Bool_Exp>;
};

/** select columns of table "setting_group" */
export enum Setting_Group_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user'
}

/** select columns of table "setting_value" */
export enum Setting_Value_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsTemplate = 'is_template',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  ReferenceTypeId = 'reference_type_id',
  /** column name */
  SettingId = 'setting_id',
  /** column name */
  Value = 'value'
}

/** Ordering options when selecting data from "setting_value". */
export type Setting_Value_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_template?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  reference_type_id?: InputMaybe<Order_By>;
  setting_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "setting_value". All fields are combined with a logical 'AND'. */
export type Setting_Value_Bool_Exp = {
  _and?: InputMaybe<Array<Setting_Value_Bool_Exp>>;
  _not?: InputMaybe<Setting_Value_Bool_Exp>;
  _or?: InputMaybe<Array<Setting_Value_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_template?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  reference_type_id?: InputMaybe<String_Comparison_Exp>;
  setting_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** DB in DB. Reason to think about deprecation. */
export type Setting_Value = {
  /** setting_value creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** setting_value creation user. */
  creation_user: Scalars['uuid'];
  display_name: Scalars['String'];
  /** id of setting_value. */
  id: Scalars['uuid'];
  is_template: Scalars['Boolean'];
  /** setting_value last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified setting_value. */
  last_modified_user: Maybe<Scalars['uuid']>;
  reference_id: Scalars['String'];
  reference_type_id: Scalars['String'];
  setting_id: Scalars['uuid'];
  /** An object relationship */
  user: User_Pp;
  value: Maybe<Scalars['jsonb']>;
};


/** DB in DB. Reason to think about deprecation. */
export type Setting_ValueValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "tariff_number_description" */
export enum Tariff_Number_Description_Select_Column {
  /** column name */
  DescriptionDe = 'description_de',
  /** column name */
  HierarchyPath = 'hierarchy_path',
  /** column name */
  HierarchyVisual = 'hierarchy_visual',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  TariffNumber = 'tariff_number',
  /** column name */
  Tsv = 'tsv'
}

/** Ordering options when selecting data from "tariff_number_description". */
export type Tariff_Number_Description_Order_By = {
  description_de?: InputMaybe<Order_By>;
  hierarchy_path?: InputMaybe<Order_By>;
  hierarchy_visual?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  tariff_number?: InputMaybe<Order_By>;
  tsv?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tariff_number_description". All fields are combined with a logical 'AND'. */
export type Tariff_Number_Description_Bool_Exp = {
  _and?: InputMaybe<Array<Tariff_Number_Description_Bool_Exp>>;
  _not?: InputMaybe<Tariff_Number_Description_Bool_Exp>;
  _or?: InputMaybe<Array<Tariff_Number_Description_Bool_Exp>>;
  description_de?: InputMaybe<String_Comparison_Exp>;
  hierarchy_path?: InputMaybe<Ltree_Comparison_Exp>;
  hierarchy_visual?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  parent_id?: InputMaybe<Int_Comparison_Exp>;
  tariff_number?: InputMaybe<String_Comparison_Exp>;
  tsv?: InputMaybe<Tsvector_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "ltree". All fields are combined with logical 'AND'. */
export type Ltree_Comparison_Exp = {
  /** is the left argument an ancestor of right (or equal)? */
  _ancestor?: InputMaybe<Scalars['ltree']>;
  /** does array contain an ancestor of `ltree`? */
  _ancestor_any?: InputMaybe<Array<Scalars['ltree']>>;
  /** is the left argument a descendant of right (or equal)? */
  _descendant?: InputMaybe<Scalars['ltree']>;
  /** does array contain a descendant of `ltree`? */
  _descendant_any?: InputMaybe<Array<Scalars['ltree']>>;
  _eq?: InputMaybe<Scalars['ltree']>;
  _gt?: InputMaybe<Scalars['ltree']>;
  _gte?: InputMaybe<Scalars['ltree']>;
  _in?: InputMaybe<Array<Scalars['ltree']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['ltree']>;
  _lte?: InputMaybe<Scalars['ltree']>;
  /** does `ltree` match `lquery`? */
  _matches?: InputMaybe<Scalars['lquery']>;
  /** does `ltree` match any `lquery` in array? */
  _matches_any?: InputMaybe<Array<Scalars['String']>>;
  /** does `ltree` match `ltxtquery`? */
  _matches_fulltext?: InputMaybe<Scalars['ltxtquery']>;
  _neq?: InputMaybe<Scalars['ltree']>;
  _nin?: InputMaybe<Array<Scalars['ltree']>>;
};

/** columns and relationships of "tariff_number_description" */
export type Tariff_Number_Description = {
  description_de: Maybe<Scalars['String']>;
  hierarchy_path: Maybe<Scalars['ltree']>;
  hierarchy_visual: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  parent_id: Maybe<Scalars['Int']>;
  tariff_number: Maybe<Scalars['String']>;
  tsv: Maybe<Scalars['tsvector']>;
};

/** select columns of table "task_type" */
export enum Task_Type_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta'
}

/** select columns of table "tenant" */
export enum Tenant_Select_Column {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  IsWdCustomer = 'is_wd_customer',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  PermissionsJs = 'permissions_js',
  /** column name */
  TenantName = 'tenant_name',
  /** column name */
  TenantType = 'tenant_type',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number'
}

/** select columns of table "transitdoc_type_descr" */
export enum Transitdoc_Type_Descr_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  TransitdocType = 'transitdoc_type'
}

/** Ordering options when selecting data from "transitdoc_type_descr". */
export type Transitdoc_Type_Descr_Order_By = {
  description?: InputMaybe<Order_By>;
  transitdoc_type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transitdoc_type_descr". All fields are combined with a logical 'AND'. */
export type Transitdoc_Type_Descr_Bool_Exp = {
  _and?: InputMaybe<Array<Transitdoc_Type_Descr_Bool_Exp>>;
  _not?: InputMaybe<Transitdoc_Type_Descr_Bool_Exp>;
  _or?: InputMaybe<Array<Transitdoc_Type_Descr_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  transitdoc_type?: InputMaybe<Transitdoc_Type_Comparison_Exp>;
};

/** columns and relationships of "transitdoc_type_descr" */
export type Transitdoc_Type_Descr = {
  description: Maybe<Scalars['String']>;
  transitdoc_type: Maybe<Scalars['transitdoc_type']>;
};

/** select columns of table "view_history" */
export enum View_History_Select_Column {
  /** column name */
  ActionTitle = 'action_title',
  /** column name */
  ActionUser = 'action_user',
  /** column name */
  ActionValue = 'action_value',
  /** column name */
  Entity = 'entity',
  /** column name */
  Id = 'id',
  /** column name */
  OpDate = 'op_date'
}

/** Ordering options when selecting data from "view_history". */
export type View_History_Order_By = {
  action_title?: InputMaybe<Order_By>;
  action_user?: InputMaybe<Order_By>;
  action_value?: InputMaybe<Order_By>;
  entity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  op_date?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "view_history". All fields are combined with a logical 'AND'. */
export type View_History_Bool_Exp = {
  _and?: InputMaybe<Array<View_History_Bool_Exp>>;
  _not?: InputMaybe<View_History_Bool_Exp>;
  _or?: InputMaybe<Array<View_History_Bool_Exp>>;
  action_title?: InputMaybe<String_Comparison_Exp>;
  action_user?: InputMaybe<Uuid_Comparison_Exp>;
  action_value?: InputMaybe<String_Comparison_Exp>;
  entity?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  op_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** History of changes in documents and files. */
export type View_History = {
  action_title: Maybe<Scalars['String']>;
  action_user: Maybe<Scalars['uuid']>;
  action_value: Maybe<Scalars['String']>;
  entity: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  op_date: Scalars['timestamptz'];
};

/** select columns of table "vw_documents" */
export enum Vw_Documents_Select_Column {
  /** column name */
  Checksum = 'checksum',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DocumentBlobs = 'document_blobs',
  /** column name */
  DocumentExtension = 'document_extension',
  /** column name */
  DocumentFlags = 'document_flags',
  /** column name */
  DocumentName = 'document_name',
  /** column name */
  DocumentStatus = 'document_status',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  IsCustomsRelevant = 'is_customs_relevant',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumberOfPages = 'number_of_pages',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Sequence = 'sequence'
}

/** Ordering options when selecting data from "vw_documents". */
export type Vw_Documents_Order_By = {
  checksum?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  document_blobs?: InputMaybe<Order_By>;
  document_extension?: InputMaybe<Order_By>;
  document_flags?: InputMaybe<Order_By>;
  document_name?: InputMaybe<Order_By>;
  document_status?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Document_Type_Order_By>;
  file?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_customs_relevant?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_generated?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  number_of_pages?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  pages_m2m_aggregate?: InputMaybe<Document_Page_Aggregate_Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vw_documents". All fields are combined with a logical 'AND'. */
export type Vw_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Documents_Bool_Exp>>;
  _not?: InputMaybe<Vw_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Documents_Bool_Exp>>;
  checksum?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  document_blobs?: InputMaybe<Jsonb_Comparison_Exp>;
  document_extension?: InputMaybe<String_Comparison_Exp>;
  document_flags?: InputMaybe<Bigint_Comparison_Exp>;
  document_name?: InputMaybe<String_Comparison_Exp>;
  document_status?: InputMaybe<String_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  documentType?: InputMaybe<Document_Type_Bool_Exp>;
  file?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_customs_relevant?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_generated?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  number_of_pages?: InputMaybe<Smallint_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  pages_m2m?: InputMaybe<Document_Page_Bool_Exp>;
  pages_m2m_aggregate?: InputMaybe<Document_Page_Aggregate_Bool_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "vw_documents" */
export type Vw_Documents = {
  checksum: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  document_blobs: Maybe<Scalars['jsonb']>;
  document_extension: Maybe<Scalars['String']>;
  document_flags: Maybe<Scalars['bigint']>;
  document_name: Maybe<Scalars['String']>;
  document_status: Maybe<Scalars['String']>;
  document_type: Maybe<Scalars['String']>;
  /** An object relationship */
  documentType: Maybe<Document_Type>;
  file: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  is_customs_relevant: Maybe<Scalars['Boolean']>;
  is_deleted: Maybe<Scalars['Boolean']>;
  is_generated: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  number_of_pages: Maybe<Scalars['smallint']>;
  org_id: Maybe<Scalars['smallint']>;
  /** An array relationship */
  pages_m2m: Array<Document_Page>;
  /** An aggregate relationship */
  pages_m2m_aggregate: Document_Page_Aggregate;
  sequence: Maybe<Scalars['Int']>;
};


/** columns and relationships of "vw_documents" */
export type Vw_DocumentsDocument_BlobsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "vw_documents" */
export type Vw_DocumentsMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "vw_documents" */
export type Vw_DocumentsPages_M2mArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


/** columns and relationships of "vw_documents" */
export type Vw_DocumentsPages_M2m_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};

/** select columns of table "vw_finished_files" */
export enum Vw_Finished_Files_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  FileFlags = 'file_flags',
  /** column name */
  FileStatus = 'file_status',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Identification = 'identification',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SessionId = 'session_id'
}

/** Ordering options when selecting data from "vw_finished_files". */
export type Vw_Finished_Files_Order_By = {
  created_by_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  declarations_aggregate?: InputMaybe<Declaration_Request_Aggregate_Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  file_flags?: InputMaybe<Order_By>;
  file_status?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identification?: InputMaybe<Order_By>;
  last_modified_by_user?: InputMaybe<User_Pp_Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Org_Id_Order_By>;
  session_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vw_finished_files". All fields are combined with a logical 'AND'. */
export type Vw_Finished_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Finished_Files_Bool_Exp>>;
  _not?: InputMaybe<Vw_Finished_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Finished_Files_Bool_Exp>>;
  created_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declarations?: InputMaybe<Declaration_Request_Bool_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  file_flags?: InputMaybe<Bigint_Comparison_Exp>;
  file_status?: InputMaybe<String_Comparison_Exp>;
  file_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identification?: InputMaybe<String_Comparison_Exp>;
  last_modified_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  orgId?: InputMaybe<Org_Id_Bool_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
};

/** This view has no raison d'etre. It musr be deprecated. */
export type Vw_Finished_Files = {
  /** An object relationship */
  created_by_user: Maybe<User_Pp>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  /** An array relationship */
  declarations: Array<Declaration_Request>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  file_flags: Maybe<Scalars['bigint']>;
  file_status: Maybe<Scalars['String']>;
  file_url: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  identification: Maybe<Scalars['String']>;
  /** An object relationship */
  last_modified_by_user: Maybe<User_Pp>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  name: Maybe<Scalars['String']>;
  org_id: Maybe<Scalars['smallint']>;
  /** An object relationship */
  orgId: Maybe<Org_Id>;
  session_id: Maybe<Scalars['String']>;
};


/** This view has no raison d'etre. It musr be deprecated. */
export type Vw_Finished_FilesDeclarationsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


/** This view has no raison d'etre. It musr be deprecated. */
export type Vw_Finished_FilesDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** This view has no raison d'etre. It musr be deprecated. */
export type Vw_Finished_FilesDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** This view has no raison d'etre. It musr be deprecated. */
export type Vw_Finished_FilesMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** mutation root */
export type Mutation_Root = {
  acs_insert_address_one: Maybe<AddressAcs>;
  acs_update_address_visibility: Maybe<Array<Maybe<AddressVisibility>>>;
  activate2FA: UserResponse;
  addNotificationTrigger: Maybe<NotificationTrigger>;
  assignDeclarationLabels: Maybe<Array<Maybe<DeclarationLabelMutationOutput>>>;
  assignNotificationLabels: Maybe<Array<Maybe<NotificationLabelMutationOutput>>>;
  classifyWeDeclareDocument: Maybe<Scalars['JSON']>;
  copyDeclarationAndGoodsItems: Scalars['Boolean'];
  createAditUser: Scalars['Boolean'];
  createDeclarationMessage: Maybe<CreateDeclarationMessageResponse>;
  createDeclarationReq: Maybe<CreateDeclarationReqResponse>;
  createDeclarationRequest: CreateDeclarationRequestResponse;
  createDocument: Maybe<CreateDocumentResponse>;
  createEmptyDocument: Maybe<CreateEmptyDocumentResponse>;
  createTenantACS: Scalars['Boolean'];
  createWDUser: Scalars['Boolean'];
  /** delete data from the table: "address" */
  delete_address: Maybe<Address_Mutation_Response>;
  /** delete single row from the table: "address" */
  delete_address_by_pk: Maybe<Address>;
  /** delete data from the table: "containers" */
  delete_containers: Maybe<Containers_Mutation_Response>;
  /** delete single row from the table: "containers" */
  delete_containers_by_pk: Maybe<Containers>;
  /** delete data from the table: "declaration" */
  delete_declaration: Maybe<Declaration_Mutation_Response>;
  /** delete single row from the table: "declaration" */
  delete_declaration_by_pk: Maybe<Declaration>;
  /** delete data from the table: "declaration_discussion" */
  delete_declaration_discussion: Maybe<Declaration_Discussion_Mutation_Response>;
  /** delete single row from the table: "declaration_discussion" */
  delete_declaration_discussion_by_pk: Maybe<Declaration_Discussion>;
  /** delete data from the table: "declaration_message" */
  delete_declaration_message: Maybe<Declaration_Message_Mutation_Response>;
  /** delete single row from the table: "declaration_message" */
  delete_declaration_message_by_pk: Maybe<Declaration_Message>;
  /** delete data from the table: "declaration_request" */
  delete_declaration_request: Maybe<Declaration_Request_Mutation_Response>;
  /** delete data from the table: "declaration_request_address" */
  delete_declaration_request_address: Maybe<Declaration_Request_Address_Mutation_Response>;
  /** delete single row from the table: "declaration_request_address" */
  delete_declaration_request_address_by_pk: Maybe<Declaration_Request_Address>;
  /** delete single row from the table: "declaration_request" */
  delete_declaration_request_by_pk: Maybe<Declaration_Request>;
  /** delete data from the table: "declaration_special_mentions" */
  delete_declaration_special_mentions: Maybe<Declaration_Special_Mentions_Mutation_Response>;
  /** delete single row from the table: "declaration_special_mentions" */
  delete_declaration_special_mentions_by_pk: Maybe<Declaration_Special_Mentions>;
  /** delete data from the table: "doc_annotation" */
  delete_doc_annotation: Maybe<Doc_Annotation_Mutation_Response>;
  /** delete single row from the table: "doc_annotation" */
  delete_doc_annotation_by_pk: Maybe<Doc_Annotation>;
  /** delete data from the table: "document" */
  delete_document: Maybe<Document_Mutation_Response>;
  /** delete single row from the table: "document" */
  delete_document_by_pk: Maybe<Document>;
  /** delete data from the table: "document_labels" */
  delete_document_labels: Maybe<Document_Labels_Mutation_Response>;
  /** delete single row from the table: "document_labels" */
  delete_document_labels_by_pk: Maybe<Document_Labels>;
  /** delete data from the table: "document_type" */
  delete_document_type: Maybe<Document_Type_Mutation_Response>;
  /** delete single row from the table: "document_type" */
  delete_document_type_by_pk: Maybe<Document_Type>;
  /** delete data from the table: "document_type_tenant_settings" */
  delete_document_type_tenant_settings: Maybe<Document_Type_Tenant_Settings_Mutation_Response>;
  /** delete single row from the table: "document_type_tenant_settings" */
  delete_document_type_tenant_settings_by_pk: Maybe<Document_Type_Tenant_Settings>;
  /** delete data from the table: "dr_goods_item" */
  delete_dr_goods_item: Maybe<Dr_Goods_Item_Mutation_Response>;
  /** delete single row from the table: "dr_goods_item" */
  delete_dr_goods_item_by_pk: Maybe<Dr_Goods_Item>;
  /** delete data from the table: "file" */
  delete_file: Maybe<File_Mutation_Response>;
  /** delete single row from the table: "file" */
  delete_file_by_pk: Maybe<File>;
  /** delete data from the table: "goods_item" */
  delete_goods_item: Maybe<Goods_Item_Mutation_Response>;
  /** delete single row from the table: "goods_item" */
  delete_goods_item_by_pk: Maybe<Goods_Item>;
  /** delete data from the table: "import_list_trigger" */
  delete_import_list_trigger: Maybe<Import_List_Trigger_Mutation_Response>;
  /** delete single row from the table: "import_list_trigger" */
  delete_import_list_trigger_by_pk: Maybe<Import_List_Trigger>;
  /** delete data from the table: "packagings" */
  delete_packagings: Maybe<Packagings_Mutation_Response>;
  /** delete single row from the table: "packagings" */
  delete_packagings_by_pk: Maybe<Packagings>;
  /** delete data from the table: "page" */
  delete_page: Maybe<Page_Mutation_Response>;
  /** delete single row from the table: "page" */
  delete_page_by_pk: Maybe<Page>;
  /** delete data from the table: "page_extract" */
  delete_page_extract: Maybe<Page_Extract_Mutation_Response>;
  /** delete single row from the table: "page_extract" */
  delete_page_extract_by_pk: Maybe<Page_Extract>;
  /** delete data from the table: "previous_documents" */
  delete_previous_documents: Maybe<Previous_Documents_Mutation_Response>;
  /** delete single row from the table: "previous_documents" */
  delete_previous_documents_by_pk: Maybe<Previous_Documents>;
  /** delete data from the table: "produced_documents" */
  delete_produced_documents: Maybe<Produced_Documents_Mutation_Response>;
  /** delete single row from the table: "produced_documents" */
  delete_produced_documents_by_pk: Maybe<Produced_Documents>;
  /** delete data from the table: "service_tariff" */
  delete_service_tariff: Maybe<Service_Tariff_Mutation_Response>;
  /** delete data from the table: "setting_value" */
  delete_setting_value: Maybe<Setting_Value_Mutation_Response>;
  /** delete single row from the table: "setting_value" */
  delete_setting_value_by_pk: Maybe<Setting_Value>;
  /** delete data from the table: "user_pp" */
  delete_user_pp: Maybe<User_Pp_Mutation_Response>;
  /** delete single row from the table: "user_pp" */
  delete_user_pp_by_pk: Maybe<User_Pp>;
  deleteNotificationTrigger: Maybe<NotificationTrigger>;
  editAddressACS: AddressAcs;
  editTenantACS: Scalars['Boolean'];
  enqueueDocument: Maybe<CreateDocumentResponse>;
  exportDeclaration: Scalars['Boolean'];
  finishDocumentValidation: Maybe<Scalars['JSON']>;
  generate2FA: UserResponse;
  /** insert data into the table: "address" */
  insert_address: Maybe<Address_Mutation_Response>;
  /** insert a single row into the table: "address" */
  insert_address_one: Maybe<Address>;
  /** insert data into the table: "address_override" */
  insert_address_override: Maybe<Address_Override_Mutation_Response>;
  /** insert a single row into the table: "address_override" */
  insert_address_override_one: Maybe<Address_Override>;
  /** insert data into the table: "bill_detail" */
  insert_bill_detail: Maybe<Bill_Detail_Mutation_Response>;
  /** insert a single row into the table: "bill_detail" */
  insert_bill_detail_one: Maybe<Bill_Detail>;
  /** insert data into the table: "containers" */
  insert_containers: Maybe<Containers_Mutation_Response>;
  /** insert a single row into the table: "containers" */
  insert_containers_one: Maybe<Containers>;
  /** insert data into the table: "declaration" */
  insert_declaration: Maybe<Declaration_Mutation_Response>;
  /** insert data into the table: "declaration_discussion" */
  insert_declaration_discussion: Maybe<Declaration_Discussion_Mutation_Response>;
  /** insert a single row into the table: "declaration_discussion" */
  insert_declaration_discussion_one: Maybe<Declaration_Discussion>;
  /** insert data into the table: "declaration_message" */
  insert_declaration_message: Maybe<Declaration_Message_Mutation_Response>;
  /** insert a single row into the table: "declaration_message" */
  insert_declaration_message_one: Maybe<Declaration_Message>;
  /** insert a single row into the table: "declaration" */
  insert_declaration_one: Maybe<Declaration>;
  /** insert data into the table: "declaration_request" */
  insert_declaration_request: Maybe<Declaration_Request_Mutation_Response>;
  /** insert data into the table: "declaration_request_address" */
  insert_declaration_request_address: Maybe<Declaration_Request_Address_Mutation_Response>;
  /** insert a single row into the table: "declaration_request_address" */
  insert_declaration_request_address_one: Maybe<Declaration_Request_Address>;
  /** insert a single row into the table: "declaration_request" */
  insert_declaration_request_one: Maybe<Declaration_Request>;
  /** insert data into the table: "declaration_special_mentions" */
  insert_declaration_special_mentions: Maybe<Declaration_Special_Mentions_Mutation_Response>;
  /** insert a single row into the table: "declaration_special_mentions" */
  insert_declaration_special_mentions_one: Maybe<Declaration_Special_Mentions>;
  /** insert data into the table: "doc_annotation" */
  insert_doc_annotation: Maybe<Doc_Annotation_Mutation_Response>;
  /** insert a single row into the table: "doc_annotation" */
  insert_doc_annotation_one: Maybe<Doc_Annotation>;
  /** insert data into the table: "document" */
  insert_document: Maybe<Document_Mutation_Response>;
  /** insert data into the table: "document_label_org_id" */
  insert_document_label_org_id: Maybe<Document_Label_Org_Id_Mutation_Response>;
  /** insert a single row into the table: "document_label_org_id" */
  insert_document_label_org_id_one: Maybe<Document_Label_Org_Id>;
  /** insert data into the table: "document_labels" */
  insert_document_labels: Maybe<Document_Labels_Mutation_Response>;
  /** insert a single row into the table: "document_labels" */
  insert_document_labels_one: Maybe<Document_Labels>;
  /** insert a single row into the table: "document" */
  insert_document_one: Maybe<Document>;
  /** insert data into the table: "document_type" */
  insert_document_type: Maybe<Document_Type_Mutation_Response>;
  /** insert a single row into the table: "document_type" */
  insert_document_type_one: Maybe<Document_Type>;
  /** insert data into the table: "document_type_tenant_settings" */
  insert_document_type_tenant_settings: Maybe<Document_Type_Tenant_Settings_Mutation_Response>;
  /** insert a single row into the table: "document_type_tenant_settings" */
  insert_document_type_tenant_settings_one: Maybe<Document_Type_Tenant_Settings>;
  /** insert data into the table: "dr_goods_item" */
  insert_dr_goods_item: Maybe<Dr_Goods_Item_Mutation_Response>;
  /** insert a single row into the table: "dr_goods_item" */
  insert_dr_goods_item_one: Maybe<Dr_Goods_Item>;
  /** insert data into the table: "file" */
  insert_file: Maybe<File_Mutation_Response>;
  /** insert a single row into the table: "file" */
  insert_file_one: Maybe<File>;
  /** insert data into the table: "goods_item" */
  insert_goods_item: Maybe<Goods_Item_Mutation_Response>;
  /** insert a single row into the table: "goods_item" */
  insert_goods_item_one: Maybe<Goods_Item>;
  /** insert data into the table: "import_list_trigger" */
  insert_import_list_trigger: Maybe<Import_List_Trigger_Mutation_Response>;
  /** insert a single row into the table: "import_list_trigger" */
  insert_import_list_trigger_one: Maybe<Import_List_Trigger>;
  /** insert data into the table: "model_retrain" */
  insert_model_retrain: Maybe<Model_Retrain_Mutation_Response>;
  /** insert a single row into the table: "model_retrain" */
  insert_model_retrain_one: Maybe<Model_Retrain>;
  /** insert data into the table: "packagings" */
  insert_packagings: Maybe<Packagings_Mutation_Response>;
  /** insert a single row into the table: "packagings" */
  insert_packagings_one: Maybe<Packagings>;
  /** insert data into the table: "page" */
  insert_page: Maybe<Page_Mutation_Response>;
  /** insert data into the table: "page_extract" */
  insert_page_extract: Maybe<Page_Extract_Mutation_Response>;
  /** insert a single row into the table: "page_extract" */
  insert_page_extract_one: Maybe<Page_Extract>;
  /** insert a single row into the table: "page" */
  insert_page_one: Maybe<Page>;
  /** insert data into the table: "previous_documents" */
  insert_previous_documents: Maybe<Previous_Documents_Mutation_Response>;
  /** insert a single row into the table: "previous_documents" */
  insert_previous_documents_one: Maybe<Previous_Documents>;
  /** insert data into the table: "produced_documents" */
  insert_produced_documents: Maybe<Produced_Documents_Mutation_Response>;
  /** insert a single row into the table: "produced_documents" */
  insert_produced_documents_one: Maybe<Produced_Documents>;
  /** insert data into the table: "service_tariff" */
  insert_service_tariff: Maybe<Service_Tariff_Mutation_Response>;
  /** insert a single row into the table: "service_tariff" */
  insert_service_tariff_one: Maybe<Service_Tariff>;
  /** insert data into the table: "setting_value" */
  insert_setting_value: Maybe<Setting_Value_Mutation_Response>;
  /** insert a single row into the table: "setting_value" */
  insert_setting_value_one: Maybe<Setting_Value>;
  /** insert data into the table: "tenant" */
  insert_tenant: Maybe<Tenant_Mutation_Response>;
  /** insert a single row into the table: "tenant" */
  insert_tenant_one: Maybe<Tenant>;
  /** insert data into the table: "user_org_id" */
  insert_user_org_id: Maybe<User_Org_Id_Mutation_Response>;
  /** insert a single row into the table: "user_org_id" */
  insert_user_org_id_one: Maybe<User_Org_Id>;
  /** insert data into the table: "user_pp" */
  insert_user_pp: Maybe<User_Pp_Mutation_Response>;
  /** insert a single row into the table: "user_pp" */
  insert_user_pp_one: Maybe<User_Pp>;
  linkAddressesACS: Array<AddressMappingEntity>;
  markDocumentAsTemplate: Maybe<Scalars['JSON']>;
  patchTenantConfig: Maybe<Scalars['JSON']>;
  patchUserConfig: Maybe<Scalars['JSON']>;
  refreshOrgIds: Scalars['Boolean'];
  refreshOrgIdsV2: Scalars['Boolean'];
  removeUser: Scalars['Boolean'];
  scheduleAldiSrvProcessing: Maybe<Scalars['JSON']>;
  scheduleDeclarationExport: Maybe<Scalars['JSON']>;
  scheduleDocAnnotationExport: Maybe<Scalars['JSON']>;
  scheduleDocuments: Maybe<Scalars['JSON']>;
  scheduleFileExport: Maybe<Scalars['JSON']>;
  scheduleFiles: Maybe<Scalars['JSON']>;
  scheduleTableCalculation: Maybe<Scalars['JSON']>;
  sendAditResetPasswordLink: Scalars['Boolean'];
  sendDeclarationArrivalNotification: Maybe<Scalars['JSON']>;
  sendWDResetPasswordLink: Scalars['Boolean'];
  transmitFile: Maybe<TransmitFileResponse>;
  triggerArticlesExtraction: Maybe<Scalars['JSON']>;
  unlinkAddressACS: Scalars['Boolean'];
  /** update data of the table: "address" */
  update_address: Maybe<Address_Mutation_Response>;
  /** update single row of the table: "address" */
  update_address_by_pk: Maybe<Address>;
  /** update multiples rows of table: "address" */
  update_address_many: Maybe<Array<Maybe<Address_Mutation_Response>>>;
  /** update data of the table: "address_override" */
  update_address_override: Maybe<Address_Override_Mutation_Response>;
  /** update single row of the table: "address_override" */
  update_address_override_by_pk: Maybe<Address_Override>;
  /** update multiples rows of table: "address_override" */
  update_address_override_many: Maybe<Array<Maybe<Address_Override_Mutation_Response>>>;
  /** update data of the table: "bill_detail" */
  update_bill_detail: Maybe<Bill_Detail_Mutation_Response>;
  /** update single row of the table: "bill_detail" */
  update_bill_detail_by_pk: Maybe<Bill_Detail>;
  /** update multiples rows of table: "bill_detail" */
  update_bill_detail_many: Maybe<Array<Maybe<Bill_Detail_Mutation_Response>>>;
  /** update data of the table: "containers" */
  update_containers: Maybe<Containers_Mutation_Response>;
  /** update single row of the table: "containers" */
  update_containers_by_pk: Maybe<Containers>;
  /** update multiples rows of table: "containers" */
  update_containers_many: Maybe<Array<Maybe<Containers_Mutation_Response>>>;
  /** update data of the table: "declaration" */
  update_declaration: Maybe<Declaration_Mutation_Response>;
  /** update single row of the table: "declaration" */
  update_declaration_by_pk: Maybe<Declaration>;
  /** update data of the table: "declaration_discussions" */
  update_declaration_discussions: Maybe<Declaration_Discussions_Mutation_Response>;
  /** update multiples rows of table: "declaration_discussions" */
  update_declaration_discussions_many: Maybe<Array<Maybe<Declaration_Discussions_Mutation_Response>>>;
  /** update multiples rows of table: "declaration" */
  update_declaration_many: Maybe<Array<Maybe<Declaration_Mutation_Response>>>;
  /** update data of the table: "declaration_message" */
  update_declaration_message: Maybe<Declaration_Message_Mutation_Response>;
  /** update single row of the table: "declaration_message" */
  update_declaration_message_by_pk: Maybe<Declaration_Message>;
  /** update multiples rows of table: "declaration_message" */
  update_declaration_message_many: Maybe<Array<Maybe<Declaration_Message_Mutation_Response>>>;
  /** update data of the table: "declaration_request" */
  update_declaration_request: Maybe<Declaration_Request_Mutation_Response>;
  /** update data of the table: "declaration_request_address" */
  update_declaration_request_address: Maybe<Declaration_Request_Address_Mutation_Response>;
  /** update single row of the table: "declaration_request_address" */
  update_declaration_request_address_by_pk: Maybe<Declaration_Request_Address>;
  /** update multiples rows of table: "declaration_request_address" */
  update_declaration_request_address_many: Maybe<Array<Maybe<Declaration_Request_Address_Mutation_Response>>>;
  /** update single row of the table: "declaration_request" */
  update_declaration_request_by_pk: Maybe<Declaration_Request>;
  /** update multiples rows of table: "declaration_request" */
  update_declaration_request_many: Maybe<Array<Maybe<Declaration_Request_Mutation_Response>>>;
  /** update data of the table: "declaration_special_mentions" */
  update_declaration_special_mentions: Maybe<Declaration_Special_Mentions_Mutation_Response>;
  /** update single row of the table: "declaration_special_mentions" */
  update_declaration_special_mentions_by_pk: Maybe<Declaration_Special_Mentions>;
  /** update multiples rows of table: "declaration_special_mentions" */
  update_declaration_special_mentions_many: Maybe<Array<Maybe<Declaration_Special_Mentions_Mutation_Response>>>;
  /** update data of the table: "declaration_task" */
  update_declaration_task: Maybe<Declaration_Task_Mutation_Response>;
  /** update single row of the table: "declaration_task" */
  update_declaration_task_by_pk: Maybe<Declaration_Task>;
  /** update multiples rows of table: "declaration_task" */
  update_declaration_task_many: Maybe<Array<Maybe<Declaration_Task_Mutation_Response>>>;
  /** update data of the table: "doc_annotation" */
  update_doc_annotation: Maybe<Doc_Annotation_Mutation_Response>;
  /** update single row of the table: "doc_annotation" */
  update_doc_annotation_by_pk: Maybe<Doc_Annotation>;
  /** update multiples rows of table: "doc_annotation" */
  update_doc_annotation_many: Maybe<Array<Maybe<Doc_Annotation_Mutation_Response>>>;
  /** update data of the table: "document" */
  update_document: Maybe<Document_Mutation_Response>;
  /** update single row of the table: "document" */
  update_document_by_pk: Maybe<Document>;
  /** update data of the table: "document_labels" */
  update_document_labels: Maybe<Document_Labels_Mutation_Response>;
  /** update single row of the table: "document_labels" */
  update_document_labels_by_pk: Maybe<Document_Labels>;
  /** update multiples rows of table: "document_labels" */
  update_document_labels_many: Maybe<Array<Maybe<Document_Labels_Mutation_Response>>>;
  /** update multiples rows of table: "document" */
  update_document_many: Maybe<Array<Maybe<Document_Mutation_Response>>>;
  /** update data of the table: "document_type" */
  update_document_type: Maybe<Document_Type_Mutation_Response>;
  /** update single row of the table: "document_type" */
  update_document_type_by_pk: Maybe<Document_Type>;
  /** update multiples rows of table: "document_type" */
  update_document_type_many: Maybe<Array<Maybe<Document_Type_Mutation_Response>>>;
  /** update data of the table: "document_type_tenant_settings" */
  update_document_type_tenant_settings: Maybe<Document_Type_Tenant_Settings_Mutation_Response>;
  /** update single row of the table: "document_type_tenant_settings" */
  update_document_type_tenant_settings_by_pk: Maybe<Document_Type_Tenant_Settings>;
  /** update multiples rows of table: "document_type_tenant_settings" */
  update_document_type_tenant_settings_many: Maybe<Array<Maybe<Document_Type_Tenant_Settings_Mutation_Response>>>;
  /** update data of the table: "dr_goods_item" */
  update_dr_goods_item: Maybe<Dr_Goods_Item_Mutation_Response>;
  /** update single row of the table: "dr_goods_item" */
  update_dr_goods_item_by_pk: Maybe<Dr_Goods_Item>;
  /** update multiples rows of table: "dr_goods_item" */
  update_dr_goods_item_many: Maybe<Array<Maybe<Dr_Goods_Item_Mutation_Response>>>;
  /** update data of the table: "extraction_config" */
  update_extraction_config: Maybe<Extraction_Config_Mutation_Response>;
  /** update single row of the table: "extraction_config" */
  update_extraction_config_by_pk: Maybe<Extraction_Config>;
  /** update multiples rows of table: "extraction_config" */
  update_extraction_config_many: Maybe<Array<Maybe<Extraction_Config_Mutation_Response>>>;
  /** update data of the table: "file" */
  update_file: Maybe<File_Mutation_Response>;
  /** update single row of the table: "file" */
  update_file_by_pk: Maybe<File>;
  /** update multiples rows of table: "file" */
  update_file_many: Maybe<Array<Maybe<File_Mutation_Response>>>;
  /** update data of the table: "goods_item" */
  update_goods_item: Maybe<Goods_Item_Mutation_Response>;
  /** update single row of the table: "goods_item" */
  update_goods_item_by_pk: Maybe<Goods_Item>;
  /** update multiples rows of table: "goods_item" */
  update_goods_item_many: Maybe<Array<Maybe<Goods_Item_Mutation_Response>>>;
  /** update data of the table: "import_list_trigger" */
  update_import_list_trigger: Maybe<Import_List_Trigger_Mutation_Response>;
  /** update single row of the table: "import_list_trigger" */
  update_import_list_trigger_by_pk: Maybe<Import_List_Trigger>;
  /** update multiples rows of table: "import_list_trigger" */
  update_import_list_trigger_many: Maybe<Array<Maybe<Import_List_Trigger_Mutation_Response>>>;
  /** update data of the table: "model_retrain" */
  update_model_retrain: Maybe<Model_Retrain_Mutation_Response>;
  /** update single row of the table: "model_retrain" */
  update_model_retrain_by_pk: Maybe<Model_Retrain>;
  /** update multiples rows of table: "model_retrain" */
  update_model_retrain_many: Maybe<Array<Maybe<Model_Retrain_Mutation_Response>>>;
  /** update data of the table: "packagings" */
  update_packagings: Maybe<Packagings_Mutation_Response>;
  /** update single row of the table: "packagings" */
  update_packagings_by_pk: Maybe<Packagings>;
  /** update multiples rows of table: "packagings" */
  update_packagings_many: Maybe<Array<Maybe<Packagings_Mutation_Response>>>;
  /** update data of the table: "page" */
  update_page: Maybe<Page_Mutation_Response>;
  /** update single row of the table: "page" */
  update_page_by_pk: Maybe<Page>;
  /** update data of the table: "page_extract" */
  update_page_extract: Maybe<Page_Extract_Mutation_Response>;
  /** update single row of the table: "page_extract" */
  update_page_extract_by_pk: Maybe<Page_Extract>;
  /** update multiples rows of table: "page_extract" */
  update_page_extract_many: Maybe<Array<Maybe<Page_Extract_Mutation_Response>>>;
  /** update multiples rows of table: "page" */
  update_page_many: Maybe<Array<Maybe<Page_Mutation_Response>>>;
  /** update data of the table: "previous_documents" */
  update_previous_documents: Maybe<Previous_Documents_Mutation_Response>;
  /** update single row of the table: "previous_documents" */
  update_previous_documents_by_pk: Maybe<Previous_Documents>;
  /** update multiples rows of table: "previous_documents" */
  update_previous_documents_many: Maybe<Array<Maybe<Previous_Documents_Mutation_Response>>>;
  /** update data of the table: "produced_documents" */
  update_produced_documents: Maybe<Produced_Documents_Mutation_Response>;
  /** update single row of the table: "produced_documents" */
  update_produced_documents_by_pk: Maybe<Produced_Documents>;
  /** update multiples rows of table: "produced_documents" */
  update_produced_documents_many: Maybe<Array<Maybe<Produced_Documents_Mutation_Response>>>;
  /** update data of the table: "service_tariff" */
  update_service_tariff: Maybe<Service_Tariff_Mutation_Response>;
  /** update multiples rows of table: "service_tariff" */
  update_service_tariff_many: Maybe<Array<Maybe<Service_Tariff_Mutation_Response>>>;
  /** update data of the table: "setting_value" */
  update_setting_value: Maybe<Setting_Value_Mutation_Response>;
  /** update single row of the table: "setting_value" */
  update_setting_value_by_pk: Maybe<Setting_Value>;
  /** update multiples rows of table: "setting_value" */
  update_setting_value_many: Maybe<Array<Maybe<Setting_Value_Mutation_Response>>>;
  /** update data of the table: "tenant" */
  update_tenant: Maybe<Tenant_Mutation_Response>;
  /** update single row of the table: "tenant" */
  update_tenant_by_pk: Maybe<Tenant>;
  /** update multiples rows of table: "tenant" */
  update_tenant_many: Maybe<Array<Maybe<Tenant_Mutation_Response>>>;
  /** update data of the table: "user_pp" */
  update_user_pp: Maybe<User_Pp_Mutation_Response>;
  /** update single row of the table: "user_pp" */
  update_user_pp_by_pk: Maybe<User_Pp>;
  /** update multiples rows of table: "user_pp" */
  update_user_pp_many: Maybe<Array<Maybe<User_Pp_Mutation_Response>>>;
  updateAditUser: Scalars['Boolean'];
  updateFileNumber: Maybe<ReassignFileNumberResponse>;
  updateNotificationTrigger: Maybe<NotificationTrigger>;
  updatePassword: Scalars['Boolean'];
  updateWDUser: Scalars['Boolean'];
  upsertAddressByReference: AddressAcs;
  validateFileNumber: Maybe<ValidateFileNumberResponse>;
  validateJourneyNumber: Maybe<ValidateJourneyNumberResponse>;
};


/** mutation root */
export type Mutation_RootAcs_Insert_Address_OneArgs = {
  object: AddressInsertArgs;
  onConflict: Conflict;
};


/** mutation root */
export type Mutation_RootAcs_Update_Address_VisibilityArgs = {
  fileId: Scalars['UUID'];
};


/** mutation root */
export type Mutation_RootActivate2FaArgs = {
  activate2FAInput: Activate2FaDto;
};


/** mutation root */
export type Mutation_RootAddNotificationTriggerArgs = {
  data: NotificationTriggerInput;
};


/** mutation root */
export type Mutation_RootAssignDeclarationLabelsArgs = {
  labels: Array<DeclarationLabelInput>;
};


/** mutation root */
export type Mutation_RootAssignNotificationLabelsArgs = {
  labels: Array<NotificationLabelInput>;
};


/** mutation root */
export type Mutation_RootClassifyWeDeclareDocumentArgs = {
  doc_id: Scalars['ID'];
  document_type: Scalars['String'];
  is_customs_relevant?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type Mutation_RootCopyDeclarationAndGoodsItemsArgs = {
  copyDeclarationInput: CopyDeclarationInputDto;
};


/** mutation root */
export type Mutation_RootCreateAditUserArgs = {
  createUserInput: AditUserDto;
};


/** mutation root */
export type Mutation_RootCreateDeclarationMessageArgs = {
  discussionId: Scalars['Int'];
  message: Scalars['String'];
  messageType: Scalars['String'];
  source: Scalars['String'];
  user: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootCreateDeclarationReqArgs = {
  data: CreateDeclarationReqInput;
};


/** mutation root */
export type Mutation_RootCreateDeclarationRequestArgs = {
  createDeclarationRequestV2Input: CreateDeclarationRequestDto;
};


/** mutation root */
export type Mutation_RootCreateDocumentArgs = {
  document: CreateDocumentInput;
};


/** mutation root */
export type Mutation_RootCreateEmptyDocumentArgs = {
  document: CreateEmptyDocumentInput;
  fileId?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootCreateTenantAcsArgs = {
  addressId: Scalars['Int'];
  externalTenantId?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  tenantName: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreateWdUserArgs = {
  createUserInput: WdCreateUserDto;
};


/** mutation root */
export type Mutation_RootDelete_AddressArgs = {
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ContainersArgs = {
  where: Containers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Containers_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DeclarationArgs = {
  where: Declaration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Declaration_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Declaration_DiscussionArgs = {
  where: Declaration_Discussion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Discussion_By_PkArgs = {
  discussion_id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Declaration_MessageArgs = {
  where: Declaration_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Message_By_PkArgs = {
  creation_user: Scalars['uuid'];
  discussion_id: Scalars['bigint'];
  msg_date: Scalars['timestamptz'];
  read_date: Scalars['timestamptz'];
};


/** mutation root */
export type Mutation_RootDelete_Declaration_RequestArgs = {
  where: Declaration_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Request_AddressArgs = {
  where: Declaration_Request_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Request_Address_By_PkArgs = {
  address_type: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Request_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Special_MentionsArgs = {
  where: Declaration_Special_Mentions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Special_Mentions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Doc_AnnotationArgs = {
  where: Doc_Annotation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Doc_Annotation_By_PkArgs = {
  anno_type_id: Scalars['smallint'];
  doc_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_DocumentArgs = {
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_By_PkArgs = {
  document_type: Scalars['String'];
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Document_LabelsArgs = {
  where: Document_Labels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Labels_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Document_TypeArgs = {
  where: Document_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Document_Type_Tenant_SettingsArgs = {
  where: Document_Type_Tenant_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Type_Tenant_Settings_By_PkArgs = {
  document_type: Scalars['String'];
  tenant: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Dr_Goods_ItemArgs = {
  where: Dr_Goods_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dr_Goods_Item_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  source: Scalars['smallint'];
  trader_item_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_FileArgs = {
  where: File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Goods_ItemArgs = {
  where: Goods_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Goods_Item_By_PkArgs = {
  customs_item_number: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Import_List_TriggerArgs = {
  where: Import_List_Trigger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Import_List_Trigger_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PackagingsArgs = {
  where: Packagings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Packagings_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PageArgs = {
  where: Page_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Page_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Page_ExtractArgs = {
  where: Page_Extract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Page_Extract_By_PkArgs = {
  extract_type_id: Scalars['smallint'];
  page_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Previous_DocumentsArgs = {
  where: Previous_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Previous_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Produced_DocumentsArgs = {
  where: Produced_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Produced_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Service_TariffArgs = {
  where: Service_Tariff_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Setting_ValueArgs = {
  where: Setting_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Setting_Value_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_PpArgs = {
  where: User_Pp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Pp_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteNotificationTriggerArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootEditAddressAcsArgs = {
  additionalParams: EditAddressInputAcs;
  aoId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  newData: AddressInputRs;
};


/** mutation root */
export type Mutation_RootEditTenantAcsArgs = {
  addressId: Scalars['Int'];
  externalTenantId?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  tenantId: Scalars['String'];
  tenantName: Scalars['String'];
};


/** mutation root */
export type Mutation_RootEnqueueDocumentArgs = {
  document: EnqueueDocumentInput;
};


/** mutation root */
export type Mutation_RootExportDeclarationArgs = {
  exportDeclarationInput: ExportDeclarationDto;
};


/** mutation root */
export type Mutation_RootFinishDocumentValidationArgs = {
  docId: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootInsert_AddressArgs = {
  objects: Array<Address_Insert_Input>;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OneArgs = {
  object: Address_Insert_Input;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OverrideArgs = {
  objects: Array<Address_Override_Insert_Input>;
  on_conflict?: InputMaybe<Address_Override_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_Override_OneArgs = {
  object: Address_Override_Insert_Input;
  on_conflict?: InputMaybe<Address_Override_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bill_DetailArgs = {
  objects: Array<Bill_Detail_Insert_Input>;
  on_conflict?: InputMaybe<Bill_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bill_Detail_OneArgs = {
  object: Bill_Detail_Insert_Input;
  on_conflict?: InputMaybe<Bill_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ContainersArgs = {
  objects: Array<Containers_Insert_Input>;
  on_conflict?: InputMaybe<Containers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Containers_OneArgs = {
  object: Containers_Insert_Input;
  on_conflict?: InputMaybe<Containers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DeclarationArgs = {
  objects: Array<Declaration_Insert_Input>;
  on_conflict?: InputMaybe<Declaration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_DiscussionArgs = {
  objects: Array<Declaration_Discussion_Insert_Input>;
  on_conflict?: InputMaybe<Declaration_Discussion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Discussion_OneArgs = {
  object: Declaration_Discussion_Insert_Input;
  on_conflict?: InputMaybe<Declaration_Discussion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_MessageArgs = {
  objects: Array<Declaration_Message_Insert_Input>;
  on_conflict?: InputMaybe<Declaration_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Message_OneArgs = {
  object: Declaration_Message_Insert_Input;
  on_conflict?: InputMaybe<Declaration_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_OneArgs = {
  object: Declaration_Insert_Input;
  on_conflict?: InputMaybe<Declaration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_RequestArgs = {
  objects: Array<Declaration_Request_Insert_Input>;
  on_conflict?: InputMaybe<Declaration_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Request_AddressArgs = {
  objects: Array<Declaration_Request_Address_Insert_Input>;
  on_conflict?: InputMaybe<Declaration_Request_Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Request_Address_OneArgs = {
  object: Declaration_Request_Address_Insert_Input;
  on_conflict?: InputMaybe<Declaration_Request_Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Request_OneArgs = {
  object: Declaration_Request_Insert_Input;
  on_conflict?: InputMaybe<Declaration_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Special_MentionsArgs = {
  objects: Array<Declaration_Special_Mentions_Insert_Input>;
  on_conflict?: InputMaybe<Declaration_Special_Mentions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Special_Mentions_OneArgs = {
  object: Declaration_Special_Mentions_Insert_Input;
  on_conflict?: InputMaybe<Declaration_Special_Mentions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_AnnotationArgs = {
  objects: Array<Doc_Annotation_Insert_Input>;
  on_conflict?: InputMaybe<Doc_Annotation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Annotation_OneArgs = {
  object: Doc_Annotation_Insert_Input;
  on_conflict?: InputMaybe<Doc_Annotation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentArgs = {
  objects: Array<Document_Insert_Input>;
  on_conflict?: InputMaybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Label_Org_IdArgs = {
  objects: Array<Document_Label_Org_Id_Insert_Input>;
  on_conflict?: InputMaybe<Document_Label_Org_Id_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Label_Org_Id_OneArgs = {
  object: Document_Label_Org_Id_Insert_Input;
  on_conflict?: InputMaybe<Document_Label_Org_Id_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_LabelsArgs = {
  objects: Array<Document_Labels_Insert_Input>;
  on_conflict?: InputMaybe<Document_Labels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Labels_OneArgs = {
  object: Document_Labels_Insert_Input;
  on_conflict?: InputMaybe<Document_Labels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_OneArgs = {
  object: Document_Insert_Input;
  on_conflict?: InputMaybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_TypeArgs = {
  objects: Array<Document_Type_Insert_Input>;
  on_conflict?: InputMaybe<Document_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Type_OneArgs = {
  object: Document_Type_Insert_Input;
  on_conflict?: InputMaybe<Document_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Type_Tenant_SettingsArgs = {
  objects: Array<Document_Type_Tenant_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Document_Type_Tenant_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Type_Tenant_Settings_OneArgs = {
  object: Document_Type_Tenant_Settings_Insert_Input;
  on_conflict?: InputMaybe<Document_Type_Tenant_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dr_Goods_ItemArgs = {
  objects: Array<Dr_Goods_Item_Insert_Input>;
  on_conflict?: InputMaybe<Dr_Goods_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dr_Goods_Item_OneArgs = {
  object: Dr_Goods_Item_Insert_Input;
  on_conflict?: InputMaybe<Dr_Goods_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileArgs = {
  objects: Array<File_Insert_Input>;
  on_conflict?: InputMaybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_OneArgs = {
  object: File_Insert_Input;
  on_conflict?: InputMaybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Goods_ItemArgs = {
  objects: Array<Goods_Item_Insert_Input>;
  on_conflict?: InputMaybe<Goods_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Goods_Item_OneArgs = {
  object: Goods_Item_Insert_Input;
  on_conflict?: InputMaybe<Goods_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Import_List_TriggerArgs = {
  objects: Array<Import_List_Trigger_Insert_Input>;
  on_conflict?: InputMaybe<Import_List_Trigger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Import_List_Trigger_OneArgs = {
  object: Import_List_Trigger_Insert_Input;
  on_conflict?: InputMaybe<Import_List_Trigger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_RetrainArgs = {
  objects: Array<Model_Retrain_Insert_Input>;
  on_conflict?: InputMaybe<Model_Retrain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Retrain_OneArgs = {
  object: Model_Retrain_Insert_Input;
  on_conflict?: InputMaybe<Model_Retrain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PackagingsArgs = {
  objects: Array<Packagings_Insert_Input>;
  on_conflict?: InputMaybe<Packagings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Packagings_OneArgs = {
  object: Packagings_Insert_Input;
  on_conflict?: InputMaybe<Packagings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PageArgs = {
  objects: Array<Page_Insert_Input>;
  on_conflict?: InputMaybe<Page_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Page_ExtractArgs = {
  objects: Array<Page_Extract_Insert_Input>;
  on_conflict?: InputMaybe<Page_Extract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Page_Extract_OneArgs = {
  object: Page_Extract_Insert_Input;
  on_conflict?: InputMaybe<Page_Extract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Page_OneArgs = {
  object: Page_Insert_Input;
  on_conflict?: InputMaybe<Page_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Previous_DocumentsArgs = {
  objects: Array<Previous_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Previous_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Previous_Documents_OneArgs = {
  object: Previous_Documents_Insert_Input;
  on_conflict?: InputMaybe<Previous_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Produced_DocumentsArgs = {
  objects: Array<Produced_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Produced_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Produced_Documents_OneArgs = {
  object: Produced_Documents_Insert_Input;
  on_conflict?: InputMaybe<Produced_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_TariffArgs = {
  objects: Array<Service_Tariff_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Tariff_OneArgs = {
  object: Service_Tariff_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Setting_ValueArgs = {
  objects: Array<Setting_Value_Insert_Input>;
  on_conflict?: InputMaybe<Setting_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Setting_Value_OneArgs = {
  object: Setting_Value_Insert_Input;
  on_conflict?: InputMaybe<Setting_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantArgs = {
  objects: Array<Tenant_Insert_Input>;
  on_conflict?: InputMaybe<Tenant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenant_OneArgs = {
  object: Tenant_Insert_Input;
  on_conflict?: InputMaybe<Tenant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Org_IdArgs = {
  objects: Array<User_Org_Id_Insert_Input>;
  on_conflict?: InputMaybe<User_Org_Id_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Org_Id_OneArgs = {
  object: User_Org_Id_Insert_Input;
  on_conflict?: InputMaybe<User_Org_Id_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_PpArgs = {
  objects: Array<User_Pp_Insert_Input>;
  on_conflict?: InputMaybe<User_Pp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Pp_OneArgs = {
  object: User_Pp_Insert_Input;
  on_conflict?: InputMaybe<User_Pp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLinkAddressesAcsArgs = {
  input: LinkAddressesInputAcs;
};


/** mutation root */
export type Mutation_RootMarkDocumentAsTemplateArgs = {
  docId: Scalars['ID'];
  isTemplate?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type Mutation_RootPatchTenantConfigArgs = {
  tenantId?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['JSON']>;
};


/** mutation root */
export type Mutation_RootPatchUserConfigArgs = {
  value?: InputMaybe<Scalars['JSON']>;
};


/** mutation root */
export type Mutation_RootRefreshOrgIdsArgs = {
  ids: Array<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootRefreshOrgIdsV2Args = {
  ids: Array<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootRemoveUserArgs = {
  id: Scalars['UUID'];
};


/** mutation root */
export type Mutation_RootScheduleAldiSrvProcessingArgs = {
  drNo: Scalars['Int'];
  fileId: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootScheduleDeclarationExportArgs = {
  drNo: Scalars['Int'];
  fileId: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootScheduleDocAnnotationExportArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootScheduleDocumentsArgs = {
  documentIds: Array<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootScheduleFileExportArgs = {
  fileId: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootScheduleFilesArgs = {
  fileIds: Array<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootScheduleTableCalculationArgs = {
  docId: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootSendAditResetPasswordLinkArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSendDeclarationArrivalNotificationArgs = {
  data: SendDeclarationArrivalNotificationInput;
};


/** mutation root */
export type Mutation_RootSendWdResetPasswordLinkArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type Mutation_RootTransmitFileArgs = {
  data: TransmitFileInput;
};


/** mutation root */
export type Mutation_RootTriggerArticlesExtractionArgs = {
  document_type: Scalars['String'];
  fileId?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootUnlinkAddressAcsArgs = {
  sourceAddressId?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type Mutation_RootUpdate_AddressArgs = {
  _append?: InputMaybe<Address_Append_Input>;
  _delete_at_path?: InputMaybe<Address_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Address_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Address_Delete_Key_Input>;
  _inc?: InputMaybe<Address_Inc_Input>;
  _prepend?: InputMaybe<Address_Prepend_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_By_PkArgs = {
  _append?: InputMaybe<Address_Append_Input>;
  _delete_at_path?: InputMaybe<Address_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Address_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Address_Delete_Key_Input>;
  _inc?: InputMaybe<Address_Inc_Input>;
  _prepend?: InputMaybe<Address_Prepend_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  pk_columns: Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_ManyArgs = {
  updates: Array<Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Address_OverrideArgs = {
  _append?: InputMaybe<Address_Override_Append_Input>;
  _delete_at_path?: InputMaybe<Address_Override_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Address_Override_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Address_Override_Delete_Key_Input>;
  _inc?: InputMaybe<Address_Override_Inc_Input>;
  _prepend?: InputMaybe<Address_Override_Prepend_Input>;
  _set?: InputMaybe<Address_Override_Set_Input>;
  where: Address_Override_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Override_By_PkArgs = {
  _append?: InputMaybe<Address_Override_Append_Input>;
  _delete_at_path?: InputMaybe<Address_Override_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Address_Override_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Address_Override_Delete_Key_Input>;
  _inc?: InputMaybe<Address_Override_Inc_Input>;
  _prepend?: InputMaybe<Address_Override_Prepend_Input>;
  _set?: InputMaybe<Address_Override_Set_Input>;
  pk_columns: Address_Override_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Override_ManyArgs = {
  updates: Array<Address_Override_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bill_DetailArgs = {
  _inc?: InputMaybe<Bill_Detail_Inc_Input>;
  _set?: InputMaybe<Bill_Detail_Set_Input>;
  where: Bill_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bill_Detail_By_PkArgs = {
  _inc?: InputMaybe<Bill_Detail_Inc_Input>;
  _set?: InputMaybe<Bill_Detail_Set_Input>;
  pk_columns: Bill_Detail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bill_Detail_ManyArgs = {
  updates: Array<Bill_Detail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ContainersArgs = {
  _inc?: InputMaybe<Containers_Inc_Input>;
  _set?: InputMaybe<Containers_Set_Input>;
  where: Containers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Containers_By_PkArgs = {
  _inc?: InputMaybe<Containers_Inc_Input>;
  _set?: InputMaybe<Containers_Set_Input>;
  pk_columns: Containers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Containers_ManyArgs = {
  updates: Array<Containers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DeclarationArgs = {
  _append?: InputMaybe<Declaration_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Prepend_Input>;
  _set?: InputMaybe<Declaration_Set_Input>;
  where: Declaration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_By_PkArgs = {
  _append?: InputMaybe<Declaration_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Prepend_Input>;
  _set?: InputMaybe<Declaration_Set_Input>;
  pk_columns: Declaration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_DiscussionsArgs = {
  _set?: InputMaybe<Declaration_Discussions_Set_Input>;
  where: Declaration_Discussions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Discussions_ManyArgs = {
  updates: Array<Declaration_Discussions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_ManyArgs = {
  updates: Array<Declaration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_MessageArgs = {
  _append?: InputMaybe<Declaration_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Message_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Message_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Message_Prepend_Input>;
  _set?: InputMaybe<Declaration_Message_Set_Input>;
  where: Declaration_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Message_By_PkArgs = {
  _append?: InputMaybe<Declaration_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Message_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Message_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Message_Prepend_Input>;
  _set?: InputMaybe<Declaration_Message_Set_Input>;
  pk_columns: Declaration_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Message_ManyArgs = {
  updates: Array<Declaration_Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_RequestArgs = {
  _append?: InputMaybe<Declaration_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Request_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Request_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Request_Prepend_Input>;
  _set?: InputMaybe<Declaration_Request_Set_Input>;
  where: Declaration_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Request_AddressArgs = {
  _inc?: InputMaybe<Declaration_Request_Address_Inc_Input>;
  _set?: InputMaybe<Declaration_Request_Address_Set_Input>;
  where: Declaration_Request_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Request_Address_By_PkArgs = {
  _inc?: InputMaybe<Declaration_Request_Address_Inc_Input>;
  _set?: InputMaybe<Declaration_Request_Address_Set_Input>;
  pk_columns: Declaration_Request_Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Request_Address_ManyArgs = {
  updates: Array<Declaration_Request_Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Request_By_PkArgs = {
  _append?: InputMaybe<Declaration_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Request_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Request_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Request_Prepend_Input>;
  _set?: InputMaybe<Declaration_Request_Set_Input>;
  pk_columns: Declaration_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Request_ManyArgs = {
  updates: Array<Declaration_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Special_MentionsArgs = {
  _inc?: InputMaybe<Declaration_Special_Mentions_Inc_Input>;
  _set?: InputMaybe<Declaration_Special_Mentions_Set_Input>;
  where: Declaration_Special_Mentions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Special_Mentions_By_PkArgs = {
  _inc?: InputMaybe<Declaration_Special_Mentions_Inc_Input>;
  _set?: InputMaybe<Declaration_Special_Mentions_Set_Input>;
  pk_columns: Declaration_Special_Mentions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Special_Mentions_ManyArgs = {
  updates: Array<Declaration_Special_Mentions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_TaskArgs = {
  _append?: InputMaybe<Declaration_Task_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Task_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Task_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Task_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Task_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Task_Prepend_Input>;
  _set?: InputMaybe<Declaration_Task_Set_Input>;
  where: Declaration_Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Task_By_PkArgs = {
  _append?: InputMaybe<Declaration_Task_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Task_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Task_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Task_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Task_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Task_Prepend_Input>;
  _set?: InputMaybe<Declaration_Task_Set_Input>;
  pk_columns: Declaration_Task_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Task_ManyArgs = {
  updates: Array<Declaration_Task_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_AnnotationArgs = {
  _append?: InputMaybe<Doc_Annotation_Append_Input>;
  _delete_at_path?: InputMaybe<Doc_Annotation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Doc_Annotation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Doc_Annotation_Delete_Key_Input>;
  _prepend?: InputMaybe<Doc_Annotation_Prepend_Input>;
  _set?: InputMaybe<Doc_Annotation_Set_Input>;
  where: Doc_Annotation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Annotation_By_PkArgs = {
  _append?: InputMaybe<Doc_Annotation_Append_Input>;
  _delete_at_path?: InputMaybe<Doc_Annotation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Doc_Annotation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Doc_Annotation_Delete_Key_Input>;
  _prepend?: InputMaybe<Doc_Annotation_Prepend_Input>;
  _set?: InputMaybe<Doc_Annotation_Set_Input>;
  pk_columns: Doc_Annotation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Annotation_ManyArgs = {
  updates: Array<Doc_Annotation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentArgs = {
  _append?: InputMaybe<Document_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Inc_Input>;
  _prepend?: InputMaybe<Document_Prepend_Input>;
  _set?: InputMaybe<Document_Set_Input>;
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_By_PkArgs = {
  _append?: InputMaybe<Document_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Inc_Input>;
  _prepend?: InputMaybe<Document_Prepend_Input>;
  _set?: InputMaybe<Document_Set_Input>;
  pk_columns: Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_LabelsArgs = {
  _append?: InputMaybe<Document_Labels_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Labels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Labels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Labels_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Labels_Inc_Input>;
  _prepend?: InputMaybe<Document_Labels_Prepend_Input>;
  _set?: InputMaybe<Document_Labels_Set_Input>;
  where: Document_Labels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Labels_By_PkArgs = {
  _append?: InputMaybe<Document_Labels_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Labels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Labels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Labels_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Labels_Inc_Input>;
  _prepend?: InputMaybe<Document_Labels_Prepend_Input>;
  _set?: InputMaybe<Document_Labels_Set_Input>;
  pk_columns: Document_Labels_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Labels_ManyArgs = {
  updates: Array<Document_Labels_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_ManyArgs = {
  updates: Array<Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_TypeArgs = {
  _append?: InputMaybe<Document_Type_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Type_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Type_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Type_Delete_Key_Input>;
  _prepend?: InputMaybe<Document_Type_Prepend_Input>;
  _set?: InputMaybe<Document_Type_Set_Input>;
  where: Document_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_By_PkArgs = {
  _append?: InputMaybe<Document_Type_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Type_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Type_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Type_Delete_Key_Input>;
  _prepend?: InputMaybe<Document_Type_Prepend_Input>;
  _set?: InputMaybe<Document_Type_Set_Input>;
  pk_columns: Document_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_ManyArgs = {
  updates: Array<Document_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_Tenant_SettingsArgs = {
  _append?: InputMaybe<Document_Type_Tenant_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Type_Tenant_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Type_Tenant_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Type_Tenant_Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Type_Tenant_Settings_Inc_Input>;
  _prepend?: InputMaybe<Document_Type_Tenant_Settings_Prepend_Input>;
  _set?: InputMaybe<Document_Type_Tenant_Settings_Set_Input>;
  where: Document_Type_Tenant_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_Tenant_Settings_By_PkArgs = {
  _append?: InputMaybe<Document_Type_Tenant_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Type_Tenant_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Type_Tenant_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Type_Tenant_Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Type_Tenant_Settings_Inc_Input>;
  _prepend?: InputMaybe<Document_Type_Tenant_Settings_Prepend_Input>;
  _set?: InputMaybe<Document_Type_Tenant_Settings_Set_Input>;
  pk_columns: Document_Type_Tenant_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_Tenant_Settings_ManyArgs = {
  updates: Array<Document_Type_Tenant_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dr_Goods_ItemArgs = {
  _append?: InputMaybe<Dr_Goods_Item_Append_Input>;
  _delete_at_path?: InputMaybe<Dr_Goods_Item_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Dr_Goods_Item_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Dr_Goods_Item_Delete_Key_Input>;
  _inc?: InputMaybe<Dr_Goods_Item_Inc_Input>;
  _prepend?: InputMaybe<Dr_Goods_Item_Prepend_Input>;
  _set?: InputMaybe<Dr_Goods_Item_Set_Input>;
  where: Dr_Goods_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dr_Goods_Item_By_PkArgs = {
  _append?: InputMaybe<Dr_Goods_Item_Append_Input>;
  _delete_at_path?: InputMaybe<Dr_Goods_Item_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Dr_Goods_Item_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Dr_Goods_Item_Delete_Key_Input>;
  _inc?: InputMaybe<Dr_Goods_Item_Inc_Input>;
  _prepend?: InputMaybe<Dr_Goods_Item_Prepend_Input>;
  _set?: InputMaybe<Dr_Goods_Item_Set_Input>;
  pk_columns: Dr_Goods_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dr_Goods_Item_ManyArgs = {
  updates: Array<Dr_Goods_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Extraction_ConfigArgs = {
  _append?: InputMaybe<Extraction_Config_Append_Input>;
  _delete_at_path?: InputMaybe<Extraction_Config_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Extraction_Config_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Extraction_Config_Delete_Key_Input>;
  _inc?: InputMaybe<Extraction_Config_Inc_Input>;
  _prepend?: InputMaybe<Extraction_Config_Prepend_Input>;
  _set?: InputMaybe<Extraction_Config_Set_Input>;
  where: Extraction_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Extraction_Config_By_PkArgs = {
  _append?: InputMaybe<Extraction_Config_Append_Input>;
  _delete_at_path?: InputMaybe<Extraction_Config_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Extraction_Config_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Extraction_Config_Delete_Key_Input>;
  _inc?: InputMaybe<Extraction_Config_Inc_Input>;
  _prepend?: InputMaybe<Extraction_Config_Prepend_Input>;
  _set?: InputMaybe<Extraction_Config_Set_Input>;
  pk_columns: Extraction_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Extraction_Config_ManyArgs = {
  updates: Array<Extraction_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FileArgs = {
  _append?: InputMaybe<File_Append_Input>;
  _delete_at_path?: InputMaybe<File_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<File_Delete_Elem_Input>;
  _delete_key?: InputMaybe<File_Delete_Key_Input>;
  _inc?: InputMaybe<File_Inc_Input>;
  _prepend?: InputMaybe<File_Prepend_Input>;
  _set?: InputMaybe<File_Set_Input>;
  where: File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_By_PkArgs = {
  _append?: InputMaybe<File_Append_Input>;
  _delete_at_path?: InputMaybe<File_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<File_Delete_Elem_Input>;
  _delete_key?: InputMaybe<File_Delete_Key_Input>;
  _inc?: InputMaybe<File_Inc_Input>;
  _prepend?: InputMaybe<File_Prepend_Input>;
  _set?: InputMaybe<File_Set_Input>;
  pk_columns: File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_File_ManyArgs = {
  updates: Array<File_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Goods_ItemArgs = {
  _inc?: InputMaybe<Goods_Item_Inc_Input>;
  _set?: InputMaybe<Goods_Item_Set_Input>;
  where: Goods_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Goods_Item_By_PkArgs = {
  _inc?: InputMaybe<Goods_Item_Inc_Input>;
  _set?: InputMaybe<Goods_Item_Set_Input>;
  pk_columns: Goods_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Goods_Item_ManyArgs = {
  updates: Array<Goods_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Import_List_TriggerArgs = {
  _append?: InputMaybe<Import_List_Trigger_Append_Input>;
  _delete_at_path?: InputMaybe<Import_List_Trigger_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Import_List_Trigger_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Import_List_Trigger_Delete_Key_Input>;
  _inc?: InputMaybe<Import_List_Trigger_Inc_Input>;
  _prepend?: InputMaybe<Import_List_Trigger_Prepend_Input>;
  _set?: InputMaybe<Import_List_Trigger_Set_Input>;
  where: Import_List_Trigger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Import_List_Trigger_By_PkArgs = {
  _append?: InputMaybe<Import_List_Trigger_Append_Input>;
  _delete_at_path?: InputMaybe<Import_List_Trigger_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Import_List_Trigger_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Import_List_Trigger_Delete_Key_Input>;
  _inc?: InputMaybe<Import_List_Trigger_Inc_Input>;
  _prepend?: InputMaybe<Import_List_Trigger_Prepend_Input>;
  _set?: InputMaybe<Import_List_Trigger_Set_Input>;
  pk_columns: Import_List_Trigger_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Import_List_Trigger_ManyArgs = {
  updates: Array<Import_List_Trigger_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Model_RetrainArgs = {
  _inc?: InputMaybe<Model_Retrain_Inc_Input>;
  _set?: InputMaybe<Model_Retrain_Set_Input>;
  where: Model_Retrain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Retrain_By_PkArgs = {
  _inc?: InputMaybe<Model_Retrain_Inc_Input>;
  _set?: InputMaybe<Model_Retrain_Set_Input>;
  pk_columns: Model_Retrain_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Retrain_ManyArgs = {
  updates: Array<Model_Retrain_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PackagingsArgs = {
  _inc?: InputMaybe<Packagings_Inc_Input>;
  _set?: InputMaybe<Packagings_Set_Input>;
  where: Packagings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Packagings_By_PkArgs = {
  _inc?: InputMaybe<Packagings_Inc_Input>;
  _set?: InputMaybe<Packagings_Set_Input>;
  pk_columns: Packagings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Packagings_ManyArgs = {
  updates: Array<Packagings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PageArgs = {
  _append?: InputMaybe<Page_Append_Input>;
  _delete_at_path?: InputMaybe<Page_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Page_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Page_Delete_Key_Input>;
  _inc?: InputMaybe<Page_Inc_Input>;
  _prepend?: InputMaybe<Page_Prepend_Input>;
  _set?: InputMaybe<Page_Set_Input>;
  where: Page_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Page_By_PkArgs = {
  _append?: InputMaybe<Page_Append_Input>;
  _delete_at_path?: InputMaybe<Page_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Page_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Page_Delete_Key_Input>;
  _inc?: InputMaybe<Page_Inc_Input>;
  _prepend?: InputMaybe<Page_Prepend_Input>;
  _set?: InputMaybe<Page_Set_Input>;
  pk_columns: Page_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Page_ExtractArgs = {
  _append?: InputMaybe<Page_Extract_Append_Input>;
  _delete_at_path?: InputMaybe<Page_Extract_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Page_Extract_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Page_Extract_Delete_Key_Input>;
  _inc?: InputMaybe<Page_Extract_Inc_Input>;
  _prepend?: InputMaybe<Page_Extract_Prepend_Input>;
  _set?: InputMaybe<Page_Extract_Set_Input>;
  where: Page_Extract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Page_Extract_By_PkArgs = {
  _append?: InputMaybe<Page_Extract_Append_Input>;
  _delete_at_path?: InputMaybe<Page_Extract_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Page_Extract_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Page_Extract_Delete_Key_Input>;
  _inc?: InputMaybe<Page_Extract_Inc_Input>;
  _prepend?: InputMaybe<Page_Extract_Prepend_Input>;
  _set?: InputMaybe<Page_Extract_Set_Input>;
  pk_columns: Page_Extract_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Page_Extract_ManyArgs = {
  updates: Array<Page_Extract_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Page_ManyArgs = {
  updates: Array<Page_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Previous_DocumentsArgs = {
  _inc?: InputMaybe<Previous_Documents_Inc_Input>;
  _set?: InputMaybe<Previous_Documents_Set_Input>;
  where: Previous_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Previous_Documents_By_PkArgs = {
  _inc?: InputMaybe<Previous_Documents_Inc_Input>;
  _set?: InputMaybe<Previous_Documents_Set_Input>;
  pk_columns: Previous_Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Previous_Documents_ManyArgs = {
  updates: Array<Previous_Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Produced_DocumentsArgs = {
  _inc?: InputMaybe<Produced_Documents_Inc_Input>;
  _set?: InputMaybe<Produced_Documents_Set_Input>;
  where: Produced_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Produced_Documents_By_PkArgs = {
  _inc?: InputMaybe<Produced_Documents_Inc_Input>;
  _set?: InputMaybe<Produced_Documents_Set_Input>;
  pk_columns: Produced_Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Produced_Documents_ManyArgs = {
  updates: Array<Produced_Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Service_TariffArgs = {
  _append?: InputMaybe<Service_Tariff_Append_Input>;
  _delete_at_path?: InputMaybe<Service_Tariff_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Service_Tariff_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Service_Tariff_Delete_Key_Input>;
  _inc?: InputMaybe<Service_Tariff_Inc_Input>;
  _prepend?: InputMaybe<Service_Tariff_Prepend_Input>;
  _set?: InputMaybe<Service_Tariff_Set_Input>;
  where: Service_Tariff_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Tariff_ManyArgs = {
  updates: Array<Service_Tariff_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Setting_ValueArgs = {
  _append?: InputMaybe<Setting_Value_Append_Input>;
  _delete_at_path?: InputMaybe<Setting_Value_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Setting_Value_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Setting_Value_Delete_Key_Input>;
  _prepend?: InputMaybe<Setting_Value_Prepend_Input>;
  _set?: InputMaybe<Setting_Value_Set_Input>;
  where: Setting_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Setting_Value_By_PkArgs = {
  _append?: InputMaybe<Setting_Value_Append_Input>;
  _delete_at_path?: InputMaybe<Setting_Value_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Setting_Value_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Setting_Value_Delete_Key_Input>;
  _prepend?: InputMaybe<Setting_Value_Prepend_Input>;
  _set?: InputMaybe<Setting_Value_Set_Input>;
  pk_columns: Setting_Value_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Setting_Value_ManyArgs = {
  updates: Array<Setting_Value_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantArgs = {
  _inc?: InputMaybe<Tenant_Inc_Input>;
  _set?: InputMaybe<Tenant_Set_Input>;
  where: Tenant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenant_By_PkArgs = {
  _inc?: InputMaybe<Tenant_Inc_Input>;
  _set?: InputMaybe<Tenant_Set_Input>;
  pk_columns: Tenant_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenant_ManyArgs = {
  updates: Array<Tenant_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_PpArgs = {
  _append?: InputMaybe<User_Pp_Append_Input>;
  _delete_at_path?: InputMaybe<User_Pp_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Pp_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Pp_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Pp_Prepend_Input>;
  _set?: InputMaybe<User_Pp_Set_Input>;
  where: User_Pp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Pp_By_PkArgs = {
  _append?: InputMaybe<User_Pp_Append_Input>;
  _delete_at_path?: InputMaybe<User_Pp_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Pp_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Pp_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Pp_Prepend_Input>;
  _set?: InputMaybe<User_Pp_Set_Input>;
  pk_columns: User_Pp_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Pp_ManyArgs = {
  updates: Array<User_Pp_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateAditUserArgs = {
  updateUserInput: AditUserDto;
};


/** mutation root */
export type Mutation_RootUpdateFileNumberArgs = {
  file_id?: InputMaybe<Scalars['ID']>;
  file_number?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootUpdateNotificationTriggerArgs = {
  data: NotificationTriggerInput;
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootUpdatePasswordArgs = {
  updatePasswordInput: UpdatePasswordDto;
};


/** mutation root */
export type Mutation_RootUpdateWdUserArgs = {
  updateUserInput: WdUpdateUserDto;
};


/** mutation root */
export type Mutation_RootUpsertAddressByReferenceArgs = {
  object: AddressUpsertArgs;
};


/** mutation root */
export type Mutation_RootValidateFileNumberArgs = {
  number: Scalars['String'];
};


/** mutation root */
export type Mutation_RootValidateJourneyNumberArgs = {
  number: Scalars['String'];
};

export type AddressInsertArgs = {
  evvAddress: InsertAddressInputAcs;
  lbaseReference: Scalars['String'];
};

export type InsertAddressInputAcs = {
  addressId?: InputMaybe<Scalars['Int']>;
  addressType: Scalars['Int'];
  city: Scalars['String'];
  companyEmail?: InputMaybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyPhone?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  street: Scalars['String'];
  zipcode: Scalars['String'];
};

export type Conflict = {
  updateColumns: Array<Scalars['String']>;
};

export type AddressVisibility = {
  addressId: Scalars['Int'];
  visibleAddress: Scalars['Int'];
};

export type Activate2FaDto = {
  authCode: Scalars['String'];
};

export type UserResponse = {
  data: Maybe<Scalars['JSON']>;
  error: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type NotificationTriggerInput = {
  config: Config;
  displayName: Scalars['String'];
  labelId?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['JSON']>;
  notificationType: Scalars['String'];
};

export type Config = {
  checkPreference?: InputMaybe<Scalars['Boolean']>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryOfOrigin?: InputMaybe<Scalars['String']>;
  feeAmount?: InputMaybe<Scalars['Float']>;
  hsCode?: InputMaybe<Scalars['String']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  specificHsCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NotificationTrigger = {
  config: Maybe<Scalars['JSON']>;
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: UserPp;
  displayName: Scalars['String'];
  id: Scalars['Int'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<UserPp>;
  meta: Maybe<Scalars['JSON']>;
  type: Scalars['String'];
};

export type DeclarationLabelInput = {
  drNo: Scalars['Int'];
  fileId: Scalars['UUID'];
  labelIds: Array<Scalars['Int']>;
};

export type DeclarationLabelMutationOutput = {
  drNo: Scalars['Int'];
  fileId: Scalars['UUID'];
  labelId: Scalars['Int'];
};

export type NotificationLabelInput = {
  drNo: Scalars['Int'];
  fileId: Scalars['UUID'];
  labelIds: Array<Scalars['Int']>;
};

export type NotificationLabelMutationOutput = {
  drNo: Scalars['Int'];
  fileId: Scalars['UUID'];
  labelId: Scalars['Int'];
};

export type CopyDeclarationInputDto = {
  sourceDrNo: Scalars['Int'];
  sourceFileId: Scalars['String'];
  targetDrNo: Scalars['Int'];
  targetFileId: Scalars['String'];
};

export type AditUserDto = {
  code?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  externalAuthProviderId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  modules?: InputMaybe<Array<Scalars['Float']>>;
  orgIds?: InputMaybe<Array<Scalars['Int']>>;
  permissions?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateDeclarationMessageResponse = {
  affected_rows: Maybe<Scalars['Int']>;
};

export type CreateDeclarationReqInput = {
  declaration?: InputMaybe<DeclarationInput>;
  documents: Array<CreateDeclarationDocumentInput>;
  fileId?: InputMaybe<Scalars['ID']>;
  flags: Scalars['Int'];
  ignoreChecksum: Scalars['Boolean'];
  orgId: Scalars['Int'];
};

export type DeclarationInput = {
  addresses?: InputMaybe<Array<InputMaybe<DeclarationAddressInput>>>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  declaration_status?: InputMaybe<Scalars['String']>;
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['Int']>;
  eta?: InputMaybe<Scalars['String']>;
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  is_express?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<Scalars['JSON']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  payer_name?: InputMaybe<Scalars['String']>;
  toll_dep?: InputMaybe<Scalars['String']>;
  tr_no?: InputMaybe<Scalars['String']>;
  transitdoc_type?: InputMaybe<Scalars['String']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

export type DeclarationAddressInput = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['JSON']>;
  reference?: InputMaybe<Scalars['String']>;
  refs?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type CreateDeclarationDocumentInput = {
  companyId?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  documentVersion?: InputMaybe<Scalars['Int']>;
  erpSystemId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  flags?: InputMaybe<Scalars['Int']>;
  orgId?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type CreateDeclarationReqResponse = {
  documentIds: Maybe<Array<Maybe<Scalars['ID']>>>;
  error: Maybe<Scalars['String']>;
  fileId: Maybe<Scalars['ID']>;
  success: Maybe<Scalars['Boolean']>;
};

export type CreateDeclarationRequestDto = {
  declaration?: InputMaybe<DeclarationInputV2>;
  documents: Array<CreateDeclarationDocumentInputV2>;
  fileId?: InputMaybe<Scalars['ID']>;
  flags?: InputMaybe<Scalars['Int']>;
  ignoreChecksum: Scalars['Boolean'];
  orgId: Scalars['Int'];
};

export type DeclarationInputV2 = {
  addresses?: InputMaybe<Array<InputMaybe<DeclarationAddressInput>>>;
  arrival_time?: InputMaybe<Scalars['DateTime']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  declaration_status?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['Int']>;
  eta?: InputMaybe<Scalars['String']>;
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  is_express?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<Scalars['JSON']>;
  payer_id?: InputMaybe<Scalars['String']>;
  payer_name?: InputMaybe<Scalars['String']>;
  service_type?: InputMaybe<Scalars['String']>;
  toll_dep?: InputMaybe<Scalars['String']>;
  total_colis?: InputMaybe<Scalars['Int']>;
  total_gross_weight?: InputMaybe<Scalars['Float']>;
  tr_no?: InputMaybe<Scalars['String']>;
  transitdoc_type?: InputMaybe<Scalars['String']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

export type CreateDeclarationDocumentInputV2 = {
  companyId?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  documentVersion?: InputMaybe<Scalars['Int']>;
  erpSystemId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  flags?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type CreateDeclarationRequestResponse = {
  documentIds: Maybe<Array<Maybe<Scalars['ID']>>>;
  error: Maybe<Scalars['String']>;
  fileId: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type CreateDocumentInput = {
  checksum?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  documentStatus?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  erpSystemId?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  flags?: InputMaybe<Scalars['Int']>;
  orgId?: InputMaybe<Scalars['Int']>;
  sequence?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type CreateDocumentResponse = {
  documentId: Maybe<Scalars['String']>;
  error: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type CreateEmptyDocumentInput = {
  checksum?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  erpSystemId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  flags?: InputMaybe<Scalars['Int']>;
  numberOfPages: Scalars['Int'];
  orgId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type CreateEmptyDocumentResponse = {
  documentId: Maybe<Scalars['String']>;
  error: Maybe<Scalars['String']>;
  pageIds: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type WdCreateUserDto = {
  email?: InputMaybe<Scalars['String']>;
  externalAuthProvider?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  userId?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "address" */
export type Address_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address>;
};

/** response of any mutation on the table "containers" */
export type Containers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Containers>;
};

/** response of any mutation on the table "declaration" */
export type Declaration_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration>;
};

/** response of any mutation on the table "declaration_discussion" */
export type Declaration_Discussion_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Discussion>;
};

/** response of any mutation on the table "declaration_message" */
export type Declaration_Message_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Message>;
};

/** response of any mutation on the table "declaration_request" */
export type Declaration_Request_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Request>;
};

/** response of any mutation on the table "declaration_request_address" */
export type Declaration_Request_Address_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Request_Address>;
};

/** response of any mutation on the table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Special_Mentions>;
};

/** response of any mutation on the table "doc_annotation" */
export type Doc_Annotation_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Doc_Annotation>;
};

/** response of any mutation on the table "document" */
export type Document_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document>;
};

/** response of any mutation on the table "document_labels" */
export type Document_Labels_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Labels>;
};

/** response of any mutation on the table "document_type" */
export type Document_Type_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Type>;
};

/** response of any mutation on the table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Type_Tenant_Settings>;
};

/** response of any mutation on the table "dr_goods_item" */
export type Dr_Goods_Item_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Dr_Goods_Item>;
};

/** response of any mutation on the table "file" */
export type File_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<File>;
};

/** response of any mutation on the table "goods_item" */
export type Goods_Item_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Goods_Item>;
};

/** response of any mutation on the table "import_list_trigger" */
export type Import_List_Trigger_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Import_List_Trigger>;
};

/** response of any mutation on the table "packagings" */
export type Packagings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Packagings>;
};

/** response of any mutation on the table "page" */
export type Page_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Page>;
};

/** response of any mutation on the table "page_extract" */
export type Page_Extract_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Page_Extract>;
};

/** response of any mutation on the table "previous_documents" */
export type Previous_Documents_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Previous_Documents>;
};

/** response of any mutation on the table "produced_documents" */
export type Produced_Documents_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Produced_Documents>;
};

/** response of any mutation on the table "service_tariff" */
export type Service_Tariff_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Service_Tariff>;
};

/** response of any mutation on the table "setting_value" */
export type Setting_Value_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Setting_Value>;
};

/** response of any mutation on the table "user_pp" */
export type User_Pp_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Pp>;
};

export type EditAddressInputAcs = {
  source: Scalars['String'];
  tenantId: Scalars['String'];
};

export type AddressInputRs = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['JSON']>;
  reference?: InputMaybe<Scalars['String']>;
  refs?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type EnqueueDocumentInput = {
  documentId: Scalars['ID'];
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
};

export type ExportDeclarationDto = {
  drNo: Scalars['Float'];
  fileId: Scalars['String'];
};

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creationUser?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  reference?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Tenant_Obj_Rel_Insert_Input>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "user_pp" */
export type User_Pp_Obj_Rel_Insert_Input = {
  data: User_Pp_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Pp_On_Conflict>;
};

/** input type for inserting data into table "user_pp" */
export type User_Pp_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_by_user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  /** User creation date */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** user_pp creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_by_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  /** id of user_pp. */
  id?: InputMaybe<Scalars['uuid']>;
  /** user_pp last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified user_pp. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  ldap_entry_dn?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  oauth_id?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Tenant_Obj_Rel_Insert_Input>;
  /** Tenant of user_pp. */
  tenant_id?: InputMaybe<Scalars['uuid']>;
  user_type?: InputMaybe<Scalars['String']>;
  userOrgIds?: InputMaybe<User_Org_Id_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "tenant" */
export type Tenant_Obj_Rel_Insert_Input = {
  data: Tenant_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenant_On_Conflict>;
};

/** input type for inserting data into table "tenant" */
export type Tenant_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  /** tenant creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** tenant creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  document_labels?: InputMaybe<Document_Labels_Arr_Rel_Insert_Input>;
  /** id of tenant. */
  id?: InputMaybe<Scalars['uuid']>;
  import_list_triggers?: InputMaybe<Import_List_Trigger_Arr_Rel_Insert_Input>;
  /** tenant last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified tenant. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  tenant_name?: InputMaybe<Scalars['String']>;
  tenant_type?: InputMaybe<Scalars['tenant_type']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
  user_pps?: InputMaybe<User_Pp_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "address" */
export type Address_Obj_Rel_Insert_Input = {
  data: Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_On_Conflict>;
};

/** on_conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: InputMaybe<Address_Bool_Exp>;
};

/** unique or primary key constraints on table "address" */
export enum Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressPkey = 'address_pkey'
}

/** update columns of table "address" */
export enum Address_Update_Column {
  /** column name */
  AddressType = 'address_type',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContactWebsite = 'contact_website',
  /** column name */
  Country = 'country',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  Meta = 'meta',
  /** column name */
  Reference = 'reference',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  Zipcode = 'zipcode'
}

/** input type for inserting array relation for remote table "document_labels" */
export type Document_Labels_Arr_Rel_Insert_Input = {
  data: Array<Document_Labels_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Labels_On_Conflict>;
};

/** input type for inserting data into table "document_labels" */
export type Document_Labels_Insert_Input = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  document_label_org_ids?: InputMaybe<Document_Label_Org_Id_Arr_Rel_Insert_Input>;
  /** id of document_labels. */
  id?: InputMaybe<Scalars['Int']>;
  /** Marks document_labels record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  tenant?: InputMaybe<Tenant_Obj_Rel_Insert_Input>;
  tenantId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "document_label_org_id" */
export type Document_Label_Org_Id_Arr_Rel_Insert_Input = {
  data: Array<Document_Label_Org_Id_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Label_Org_Id_On_Conflict>;
};

/** input type for inserting data into table "document_label_org_id" */
export type Document_Label_Org_Id_Insert_Input = {
  label_id?: InputMaybe<Scalars['Int']>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Scalars['smallint']>;
};

/** on_conflict condition type for table "document_label_org_id" */
export type Document_Label_Org_Id_On_Conflict = {
  constraint: Document_Label_Org_Id_Constraint;
  update_columns?: Array<Document_Label_Org_Id_Update_Column>;
  where?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
};

/** unique or primary key constraints on table "document_label_org_id" */
export enum Document_Label_Org_Id_Constraint {
  /** unique or primary key constraint on columns "label_id", "org_id" */
  DocumentLabelOrgIdPkey = 'document_label_org_id_pkey'
}

/** placeholder for update columns of table "document_label_org_id" (current role has no relevant permissions) */
export enum Document_Label_Org_Id_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** on_conflict condition type for table "document_labels" */
export type Document_Labels_On_Conflict = {
  constraint: Document_Labels_Constraint;
  update_columns?: Array<Document_Labels_Update_Column>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};

/** unique or primary key constraints on table "document_labels" */
export enum Document_Labels_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentLabelsIdKey = 'document_labels_id_key',
  /** unique or primary key constraint on columns "id" */
  DocumentLabelsPkey = 'document_labels_pkey'
}

/** update columns of table "document_labels" */
export enum Document_Labels_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Title = 'title'
}

/** input type for inserting array relation for remote table "import_list_trigger" */
export type Import_List_Trigger_Arr_Rel_Insert_Input = {
  data: Array<Import_List_Trigger_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Import_List_Trigger_On_Conflict>;
};

/** input type for inserting data into table "import_list_trigger" */
export type Import_List_Trigger_Insert_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creationUser?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  lastModifiedUser?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  meta?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "import_list_trigger" */
export type Import_List_Trigger_On_Conflict = {
  constraint: Import_List_Trigger_Constraint;
  update_columns?: Array<Import_List_Trigger_Update_Column>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};

/** unique or primary key constraints on table "import_list_trigger" */
export enum Import_List_Trigger_Constraint {
  /** unique or primary key constraint on columns "id" */
  ImportListTriggerPkey = 'import_list_trigger_pkey'
}

/** update columns of table "import_list_trigger" */
export enum Import_List_Trigger_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Type = 'type'
}

/** input type for inserting array relation for remote table "user_pp" */
export type User_Pp_Arr_Rel_Insert_Input = {
  data: Array<User_Pp_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Pp_On_Conflict>;
};

/** on_conflict condition type for table "user_pp" */
export type User_Pp_On_Conflict = {
  constraint: User_Pp_Constraint;
  update_columns?: Array<User_Pp_Update_Column>;
  where?: InputMaybe<User_Pp_Bool_Exp>;
};

/** unique or primary key constraints on table "user_pp" */
export enum User_Pp_Constraint {
  /** unique or primary key constraint on columns "code" */
  UiUserPpCode = 'ui_user_pp_code',
  /** unique or primary key constraint on columns "tenant_id", "id" */
  UiUserPpId = 'ui_user_pp_id',
  /** unique or primary key constraint on columns "oauth_id" */
  UserIntOauthIdKey = 'user_int_oauth_id_key',
  /** unique or primary key constraint on columns "id" */
  UserIntPkey = 'user_int_pkey'
}

/** update columns of table "user_pp" */
export enum User_Pp_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedByUser = 'deleted_by_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LdapEntryDn = 'ldap_entry_dn',
  /** column name */
  Location = 'location',
  /** column name */
  OauthId = 'oauth_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UiSettings = 'ui_settings',
  /** column name */
  UiSettingsTemplates = 'ui_settings_templates',
  /** column name */
  UserType = 'user_type'
}

/** on_conflict condition type for table "tenant" */
export type Tenant_On_Conflict = {
  constraint: Tenant_Constraint;
  update_columns?: Array<Tenant_Update_Column>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};

/** unique or primary key constraints on table "tenant" */
export enum Tenant_Constraint {
  /** unique or primary key constraint on columns "id" */
  TenantPkey = 'tenant_pkey',
  /** unique or primary key constraint on columns "address_id" */
  UiTenantAddressId = 'ui_tenant_address_id'
}

/** update columns of table "tenant" */
export enum Tenant_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  TenantName = 'tenant_name',
  /** column name */
  TenantType = 'tenant_type',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number'
}

/** input type for inserting array relation for remote table "user_org_id" */
export type User_Org_Id_Arr_Rel_Insert_Input = {
  data: Array<User_Org_Id_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Org_Id_On_Conflict>;
};

/** input type for inserting data into table "user_org_id" */
export type User_Org_Id_Insert_Input = {
  /** user_org_id creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** user_org_id creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** user_org_id last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified user_org_id. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Scalars['smallint']>;
  user_pp?: InputMaybe<Scalars['uuid']>;
};

/** on_conflict condition type for table "user_org_id" */
export type User_Org_Id_On_Conflict = {
  constraint: User_Org_Id_Constraint;
  update_columns?: Array<User_Org_Id_Update_Column>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};

/** unique or primary key constraints on table "user_org_id" */
export enum User_Org_Id_Constraint {
  /** unique or primary key constraint on columns "org_id", "user_pp" */
  UserOrgIdPkey = 'user_org_id_pkey'
}

/** placeholder for update columns of table "user_org_id" (current role has no relevant permissions) */
export enum User_Org_Id_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** input type for inserting data into table "address_override" */
export type Address_Override_Insert_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  reference?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "address_override" */
export type Address_Override_On_Conflict = {
  constraint: Address_Override_Constraint;
  update_columns?: Array<Address_Override_Update_Column>;
  where?: InputMaybe<Address_Override_Bool_Exp>;
};

/** unique or primary key constraints on table "address_override" */
export enum Address_Override_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressOverridePkey = 'address_override_pkey'
}

/** update columns of table "address_override" */
export enum Address_Override_Update_Column {
  /** column name */
  AddressType = 'address_type',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContactWebsite = 'contact_website',
  /** column name */
  Country = 'country',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  Reference = 'reference',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  Zipcode = 'zipcode'
}

/** response of any mutation on the table "address_override" */
export type Address_Override_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address_Override>;
};

/** input type for inserting data into table "bill_detail" */
export type Bill_Detail_Insert_Input = {
  bill_id?: InputMaybe<Scalars['bigint']>;
  charged_items?: InputMaybe<Scalars['bigint']>;
  const_charge?: InputMaybe<Scalars['numeric']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  declaration_request?: InputMaybe<Declaration_Request_Obj_Rel_Insert_Input>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Scalars['bigint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  remark?: InputMaybe<Scalars['String']>;
  srv_id?: InputMaybe<Scalars['Int']>;
  var_charge?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting object relation for remote table "declaration_request" */
export type Declaration_Request_Obj_Rel_Insert_Input = {
  data: Declaration_Request_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Request_On_Conflict>;
};

/** input type for inserting data into table "declaration_request" */
export type Declaration_Request_Insert_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  /** Account number in CH customs */
  account_number?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Declaration_Request_Address_Arr_Rel_Insert_Input>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  bill_details?: InputMaybe<Bill_Detail_Arr_Rel_Insert_Input>;
  /** WeDeclare must create CH-Exportdeclaration */
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  /** Refer to values in table clearance_type. */
  clearance_type?: InputMaybe<Scalars['String']>;
  clientCompany?: InputMaybe<Tenant_Obj_Rel_Insert_Input>;
  /** Date of creation of declaration request. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** User created declaration request. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['smallint']>;
  declaration?: InputMaybe<Declaration_Obj_Rel_Insert_Input>;
  declaration_discussions?: InputMaybe<Declaration_Discussion_Arr_Rel_Insert_Input>;
  declaration_request_addresses?: InputMaybe<Declaration_Request_Address_Arr_Rel_Insert_Input>;
  /** Refer to values in table declaration_status. */
  declaration_status?: InputMaybe<Scalars['String']>;
  /** Refer to values in table declaration_type. */
  declaration_type?: InputMaybe<Scalars['String']>;
  /** Destination Tolldept Code */
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  /** Destination Tolldept Name */
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  dr_goods_items?: InputMaybe<Dr_Goods_Item_Arr_Rel_Insert_Input>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Scalars['smallint']>;
  edec?: InputMaybe<Scalars['jsonb']>;
  eta?: InputMaybe<Scalars['timestamptz']>;
  file?: InputMaybe<File_Obj_Rel_Insert_Input>;
  /** File related to declaration request. Part of primary key */
  file_id?: InputMaybe<Scalars['uuid']>;
  /** WeDeclare must create the Import customs clearance in the destination Country */
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  /** Service:  Standard  oder Express */
  is_express?: InputMaybe<Scalars['Boolean']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  payer?: InputMaybe<Tenant_Obj_Rel_Insert_Input>;
  /** Who is paying for customs declaration (tenant) */
  payer_id?: InputMaybe<Scalars['uuid']>;
  /** Customs office number. Refer to customs_office table.office_number. */
  toll_dep?: InputMaybe<Scalars['String']>;
  /** Truck and Trailer Plate No. */
  tr_no?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  /** Type Transitdocument */
  transitdoc_type?: InputMaybe<Scalars['transitdoc_type']>;
  user_pp?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  wa_number?: InputMaybe<Scalars['String']>;
};

/** input type for inserting array relation for remote table "declaration_request_address" */
export type Declaration_Request_Address_Arr_Rel_Insert_Input = {
  data: Array<Declaration_Request_Address_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Request_Address_On_Conflict>;
};

/** input type for inserting data into table "declaration_request_address" */
export type Declaration_Request_Address_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['Int']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  declaration_request?: InputMaybe<Declaration_Request_Obj_Rel_Insert_Input>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['json']>;
  refs?: InputMaybe<Scalars['_text']>;
  search_refs?: InputMaybe<Scalars['_text']>;
};

/** on_conflict condition type for table "declaration_request_address" */
export type Declaration_Request_Address_On_Conflict = {
  constraint: Declaration_Request_Address_Constraint;
  update_columns?: Array<Declaration_Request_Address_Update_Column>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};

/** unique or primary key constraints on table "declaration_request_address" */
export enum Declaration_Request_Address_Constraint {
  /** unique or primary key constraint on columns "dr_no", "address_type", "file_id" */
  DeclarationRequestAddressPkey = 'declaration_request_address_pkey'
}

/** update columns of table "declaration_request_address" */
export enum Declaration_Request_Address_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Refs = 'refs',
  /** column name */
  SearchRefs = 'search_refs'
}

/** input type for inserting array relation for remote table "bill_detail" */
export type Bill_Detail_Arr_Rel_Insert_Input = {
  data: Array<Bill_Detail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Bill_Detail_On_Conflict>;
};

/** on_conflict condition type for table "bill_detail" */
export type Bill_Detail_On_Conflict = {
  constraint: Bill_Detail_Constraint;
  update_columns?: Array<Bill_Detail_Update_Column>;
  where?: InputMaybe<Bill_Detail_Bool_Exp>;
};

/** unique or primary key constraints on table "bill_detail" */
export enum Bill_Detail_Constraint {
  /** unique or primary key constraint on columns "srv_id", "dr_no", "file_id" */
  BillDetailFileIdDrNoSrvIdUindex = 'bill_detail_file_id_dr_no_srv_id_uindex',
  /** unique or primary key constraint on columns "detail_id" */
  BillDetailPk = 'bill_detail_pk',
  /** unique or primary key constraint on columns "srv_id", "dr_no", "file_id" */
  BillDetailUq = 'bill_detail_uq'
}

/** update columns of table "bill_detail" */
export enum Bill_Detail_Update_Column {
  /** column name */
  BillId = 'bill_id',
  /** column name */
  ChargedItems = 'charged_items',
  /** column name */
  ConstCharge = 'const_charge',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  DetailId = 'detail_id',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  SrvId = 'srv_id',
  /** column name */
  VarCharge = 'var_charge'
}

/** input type for inserting object relation for remote table "declaration" */
export type Declaration_Obj_Rel_Insert_Input = {
  data: Declaration_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_On_Conflict>;
};

/** input type for inserting data into table "declaration" */
export type Declaration_Insert_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  access_code?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Declaration_Request_Address_Arr_Rel_Insert_Input>;
  agreed_location_of_goods?: InputMaybe<Scalars['String']>;
  ai_confirmed?: InputMaybe<Scalars['Boolean']>;
  ai_results?: InputMaybe<Scalars['jsonb']>;
  border_eau_number?: InputMaybe<Scalars['numeric']>;
  bunch_number?: InputMaybe<Scalars['Int']>;
  change_information?: InputMaybe<Scalars['date']>;
  clearance_location?: InputMaybe<Scalars['smallint']>;
  company_number_taxpayer?: InputMaybe<Scalars['String']>;
  containers?: InputMaybe<Containers_Arr_Rel_Insert_Input>;
  correction_code?: InputMaybe<Scalars['Int']>;
  correction_reason?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_account_address_type?: InputMaybe<Scalars['Int']>;
  customs_account_name?: InputMaybe<Scalars['String']>;
  customs_account_number?: InputMaybe<Scalars['bigint']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_office_number?: InputMaybe<Scalars['String']>;
  declarant_company_name?: InputMaybe<Scalars['String']>;
  declarant_number?: InputMaybe<Scalars['Int']>;
  declaration_request?: InputMaybe<Declaration_Request_Obj_Rel_Insert_Input>;
  declaration_special_mentions?: InputMaybe<Declaration_Special_Mentions_Arr_Rel_Insert_Input>;
  declaration_time?: InputMaybe<Scalars['smallint']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  delivery_destination?: InputMaybe<Scalars['bpchar']>;
  dispatch_country?: InputMaybe<Scalars['String']>;
  dispatch_country_confirmation?: InputMaybe<Scalars['Boolean']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_amount?: InputMaybe<Scalars['numeric']>;
  duty_total_amount?: InputMaybe<Scalars['numeric']>;
  evv_confirmed?: InputMaybe<Scalars['Boolean']>;
  evv_received?: InputMaybe<Scalars['Boolean']>;
  file?: InputMaybe<File_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']>;
  goods_items?: InputMaybe<Goods_Item_Arr_Rel_Insert_Input>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  incoterms?: InputMaybe<Scalars['String']>;
  initiator?: InputMaybe<Scalars['smallint']>;
  injunction_type?: InputMaybe<Scalars['smallint']>;
  inspection_code?: InputMaybe<Scalars['Boolean']>;
  invoice_currency_type?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
  material_check?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  place_of_loading?: InputMaybe<Scalars['String']>;
  place_of_unloading?: InputMaybe<Scalars['String']>;
  postal_shipment_type?: InputMaybe<Scalars['String']>;
  previous_documents?: InputMaybe<Previous_Documents_Arr_Rel_Insert_Input>;
  procedure_type?: InputMaybe<Scalars['smallint']>;
  provisional_declaration_expiration_date?: InputMaybe<Scalars['date']>;
  reason?: InputMaybe<Scalars['String']>;
  receive_status?: InputMaybe<Scalars['Int']>;
  release?: InputMaybe<Scalars['Boolean']>;
  requestor_trader_identification_number?: InputMaybe<Scalars['String']>;
  security?: InputMaybe<Scalars['Boolean']>;
  selection_correlation_id?: InputMaybe<Scalars['String']>;
  send_date?: InputMaybe<Scalars['timestamptz']>;
  send_status?: InputMaybe<Scalars['Int']>;
  service_type?: InputMaybe<Scalars['String']>;
  show_in_wd?: InputMaybe<Scalars['Boolean']>;
  specific_circumstance_indicator?: InputMaybe<Scalars['bpchar']>;
  status?: InputMaybe<Scalars['Int']>;
  status_date?: InputMaybe<Scalars['date']>;
  status_time?: InputMaybe<Scalars['time']>;
  tara_factor?: InputMaybe<Scalars['numeric']>;
  total_goods_items?: InputMaybe<Scalars['Int']>;
  total_vat_value?: InputMaybe<Scalars['numeric']>;
  trader_declaration_number?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  transfer_to_transit_system?: InputMaybe<Scalars['Boolean']>;
  transport_country?: InputMaybe<Scalars['String']>;
  transport_in_container?: InputMaybe<Scalars['Boolean']>;
  transport_mode?: InputMaybe<Scalars['Int']>;
  transport_number?: InputMaybe<Scalars['String']>;
  transport_type?: InputMaybe<Scalars['String']>;
  unique_consignment_reference_number?: InputMaybe<Scalars['String']>;
  vat_account_address_type?: InputMaybe<Scalars['Int']>;
  vat_account_name?: InputMaybe<Scalars['String']>;
  vat_account_number?: InputMaybe<Scalars['bigint']>;
  vat_number?: InputMaybe<Scalars['String']>;
  vat_suffix?: InputMaybe<Scalars['Boolean']>;
  vat_total_amount?: InputMaybe<Scalars['numeric']>;
  warehouse_coded?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting array relation for remote table "containers" */
export type Containers_Arr_Rel_Insert_Input = {
  data: Array<Containers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Containers_On_Conflict>;
};

/** input type for inserting data into table "containers" */
export type Containers_Insert_Input = {
  container_number?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** on_conflict condition type for table "containers" */
export type Containers_On_Conflict = {
  constraint: Containers_Constraint;
  update_columns?: Array<Containers_Update_Column>;
  where?: InputMaybe<Containers_Bool_Exp>;
};

/** unique or primary key constraints on table "containers" */
export enum Containers_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContainersPkey = 'containers_pkey',
  /** unique or primary key constraint on columns "dr_no", "container_number", "file_id" */
  ContainersUn = 'containers_un'
}

/** update columns of table "containers" */
export enum Containers_Update_Column {
  /** column name */
  ContainerNumber = 'container_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id'
}

/** input type for inserting array relation for remote table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Arr_Rel_Insert_Input = {
  data: Array<Declaration_Special_Mentions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Special_Mentions_On_Conflict>;
};

/** input type for inserting data into table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Insert_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  sequence_number?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "declaration_special_mentions" */
export type Declaration_Special_Mentions_On_Conflict = {
  constraint: Declaration_Special_Mentions_Constraint;
  update_columns?: Array<Declaration_Special_Mentions_Update_Column>;
  where?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
};

/** unique or primary key constraints on table "declaration_special_mentions" */
export enum Declaration_Special_Mentions_Constraint {
  /** unique or primary key constraint on columns "id" */
  DeclarationSpecialMentionsPkey = 'declaration_special_mentions_pkey',
  /** unique or primary key constraint on columns "dr_no", "file_id", "text" */
  DeclarationSpecialMentionsUn = 'declaration_special_mentions_un'
}

/** update columns of table "declaration_special_mentions" */
export enum Declaration_Special_Mentions_Update_Column {
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  SequenceNumber = 'sequence_number',
  /** column name */
  Text = 'text'
}

/** input type for inserting object relation for remote table "file" */
export type File_Obj_Rel_Insert_Input = {
  data: File_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<File_On_Conflict>;
};

/** input type for inserting data into table "file" */
export type File_Insert_Input = {
  created_by_user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  /** file creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  declaration?: InputMaybe<Declaration_Request_Obj_Rel_Insert_Input>;
  declaration_requests?: InputMaybe<Declaration_Request_Arr_Rel_Insert_Input>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  file_flags?: InputMaybe<Scalars['bigint']>;
  file_status?: InputMaybe<Scalars['String']>;
  file_type?: InputMaybe<Scalars['String']>;
  file_url?: InputMaybe<Scalars['String']>;
  /** id of file. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Is usually set automatically by AQW.IdentificationProvider.
   *
   * AQW.IdentificationProvider can be set in tenant settings either DefaultProvider (random uuid) or a company specific provider which calls an external API endpoint.
   *
   */
  identification?: InputMaybe<Scalars['String']>;
  /** Marks file record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_by_user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  /** file last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified file. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  /** Org_id related to file. */
  org_id?: InputMaybe<Scalars['smallint']>;
  session_id?: InputMaybe<Scalars['String']>;
};

/** input type for inserting array relation for remote table "declaration_request" */
export type Declaration_Request_Arr_Rel_Insert_Input = {
  data: Array<Declaration_Request_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Request_On_Conflict>;
};

/** on_conflict condition type for table "declaration_request" */
export type Declaration_Request_On_Conflict = {
  constraint: Declaration_Request_Constraint;
  update_columns?: Array<Declaration_Request_Update_Column>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};

/** unique or primary key constraints on table "declaration_request" */
export enum Declaration_Request_Constraint {
  /** unique or primary key constraint on columns "dr_no", "file_id" */
  PkDeclarationRequestFileIdDrNo = 'pk_declaration_request_file_id_dr_no',
  /** unique or primary key constraint on columns "creation_date", "dr_no", "file_id" */
  UiDrFileIdCreationDate = 'ui_dr_file_id_creation_date'
}

/** update columns of table "declaration_request" */
export enum Declaration_Request_Update_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  ArrivalTime = 'arrival_time',
  /** column name */
  ArrivalType = 'arrival_type',
  /** column name */
  ChExpDecl = 'ch_exp_decl',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsDeclarationNumber = 'customs_declaration_number',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  DeclarationStatus = 'declaration_status',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DestTolldeptCode = 'dest_tolldept_code',
  /** column name */
  DestTolldeptName = 'dest_tolldept_name',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  Edec = 'edec',
  /** column name */
  Eta = 'eta',
  /** column name */
  FileId = 'file_id',
  /** column name */
  ImpCustClr = 'imp_cust_clr',
  /** column name */
  IsExpress = 'is_express',
  /** column name */
  Meta = 'meta',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  TollDep = 'toll_dep',
  /** column name */
  TrNo = 'tr_no',
  /** column name */
  TraderReference = 'trader_reference',
  /** column name */
  TransitdocType = 'transitdoc_type',
  /** column name */
  WaNumber = 'wa_number'
}

/** input type for inserting array relation for remote table "document" */
export type Document_Arr_Rel_Insert_Input = {
  data: Array<Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_On_Conflict>;
};

/** input type for inserting data into table "document" */
export type Document_Insert_Input = {
  /** MD5-checksum of document. */
  checksum?: InputMaybe<Scalars['String']>;
  created_by_user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  /** document creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** document creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  docAnnotations?: InputMaybe<Doc_Annotation_Arr_Rel_Insert_Input>;
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  document_extension?: InputMaybe<Scalars['String']>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Scalars['bigint']>;
  document_name?: InputMaybe<Scalars['String']>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  documentFile?: InputMaybe<File_Obj_Rel_Insert_Input>;
  documentType?: InputMaybe<Document_Type_Obj_Rel_Insert_Input>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Scalars['smallint']>;
  /** Document Id related to document. */
  file?: InputMaybe<Scalars['uuid']>;
  file_object?: InputMaybe<File_Obj_Rel_Insert_Input>;
  /** id of document. */
  id?: InputMaybe<Scalars['uuid']>;
  is_customs_relevant?: InputMaybe<Scalars['Boolean']>;
  /** Marks document record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_generated?: InputMaybe<Scalars['Boolean']>;
  /** document last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified document. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Scalars['smallint']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting array relation for remote table "doc_annotation" */
export type Doc_Annotation_Arr_Rel_Insert_Input = {
  data: Array<Doc_Annotation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Doc_Annotation_On_Conflict>;
};

/** input type for inserting data into table "doc_annotation" */
export type Doc_Annotation_Insert_Input = {
  anno_type_id?: InputMaybe<Scalars['smallint']>;
  /** Document Id related to doc_annotation. */
  doc_id?: InputMaybe<Scalars['uuid']>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting object relation for remote table "document" */
export type Document_Obj_Rel_Insert_Input = {
  data: Document_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_On_Conflict>;
};

/** on_conflict condition type for table "document" */
export type Document_On_Conflict = {
  constraint: Document_Constraint;
  update_columns?: Array<Document_Update_Column>;
  where?: InputMaybe<Document_Bool_Exp>;
};

/** unique or primary key constraints on table "document" */
export enum Document_Constraint {
  /** unique or primary key constraint on columns "document_type", "id" */
  DocumentPkey = 'document_pkey'
}

/** update columns of table "document" */
export enum Document_Update_Column {
  /** column name */
  Checksum = 'checksum',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DocumentBlobs = 'document_blobs',
  /** column name */
  DocumentExtension = 'document_extension',
  /** column name */
  DocumentFlags = 'document_flags',
  /** column name */
  DocumentName = 'document_name',
  /** column name */
  DocumentStatus = 'document_status',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  IsCustomsRelevant = 'is_customs_relevant',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumberOfPages = 'number_of_pages',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Sequence = 'sequence'
}

/** on_conflict condition type for table "doc_annotation" */
export type Doc_Annotation_On_Conflict = {
  constraint: Doc_Annotation_Constraint;
  update_columns?: Array<Doc_Annotation_Update_Column>;
  where?: InputMaybe<Doc_Annotation_Bool_Exp>;
};

/** unique or primary key constraints on table "doc_annotation" */
export enum Doc_Annotation_Constraint {
  /** unique or primary key constraint on columns "anno_type_id", "doc_id" */
  PkDocAnnotationDocIdAnnoTypeId = 'pk_doc_annotation_doc_id_anno_type_id'
}

/** update columns of table "doc_annotation" */
export enum Doc_Annotation_Update_Column {
  /** column name */
  Value = 'value'
}

/** input type for inserting object relation for remote table "document_type" */
export type Document_Type_Obj_Rel_Insert_Input = {
  data: Document_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Type_On_Conflict>;
};

/** input type for inserting data into table "document_type" */
export type Document_Type_Insert_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  document_type_tenant_settings?: InputMaybe<Document_Type_Tenant_Settings_Arr_Rel_Insert_Input>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Scalars['jsonb']>;
  user_pp?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  userPpByCreationUser?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
};

/** input type for inserting array relation for remote table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Arr_Rel_Insert_Input = {
  data: Array<Document_Type_Tenant_Settings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Type_Tenant_Settings_On_Conflict>;
};

/** input type for inserting data into table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  default_flags?: InputMaybe<Scalars['bigint']>;
  display_name?: InputMaybe<Scalars['String']>;
  document_schema?: InputMaybe<Scalars['jsonb']>;
  document_type?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Document_Type_Obj_Rel_Insert_Input>;
  meta?: InputMaybe<Scalars['jsonb']>;
  tenant?: InputMaybe<Scalars['uuid']>;
  Tenant?: InputMaybe<Tenant_Obj_Rel_Insert_Input>;
};

/** on_conflict condition type for table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_On_Conflict = {
  constraint: Document_Type_Tenant_Settings_Constraint;
  update_columns?: Array<Document_Type_Tenant_Settings_Update_Column>;
  where?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
};

/** unique or primary key constraints on table "document_type_tenant_settings" */
export enum Document_Type_Tenant_Settings_Constraint {
  /** unique or primary key constraint on columns "document_type", "tenant" */
  DocumentTypeTenantSettingsPkey = 'document_type_tenant_settings_pkey'
}

/** update columns of table "document_type_tenant_settings" */
export enum Document_Type_Tenant_Settings_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DefaultFlags = 'default_flags',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DocumentSchema = 'document_schema',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta'
}

/** on_conflict condition type for table "document_type" */
export type Document_Type_On_Conflict = {
  constraint: Document_Type_Constraint;
  update_columns?: Array<Document_Type_Update_Column>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};

/** unique or primary key constraints on table "document_type" */
export enum Document_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  DocumentTypePkey = 'document_type_pkey'
}

/** update columns of table "document_type" */
export enum Document_Type_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name',
  /** column name */
  Translations = 'translations'
}

/** on_conflict condition type for table "file" */
export type File_On_Conflict = {
  constraint: File_Constraint;
  update_columns?: Array<File_Update_Column>;
  where?: InputMaybe<File_Bool_Exp>;
};

/** unique or primary key constraints on table "file" */
export enum File_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilePkey = 'file_pkey',
  /** unique or primary key constraint on columns "session_id" */
  FileSessionIdKey = 'file_session_id_key',
  /** unique or primary key constraint on columns "identification" */
  FileUqIdentification = 'file_uq_identification',
  /** unique or primary key constraint on columns "org_id", "id" */
  UiFileIdOrgId = 'ui_file_id_org_id'
}

/** update columns of table "file" */
export enum File_Update_Column {
  /** column name */
  AiDocClassificationConfirmed = 'ai_doc_classification_confirmed',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  FileFlags = 'file_flags',
  /** column name */
  FileStatus = 'file_status',
  /** column name */
  FileType = 'file_type',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Identification = 'identification',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SessionId = 'session_id'
}

/** input type for inserting array relation for remote table "goods_item" */
export type Goods_Item_Arr_Rel_Insert_Input = {
  data: Array<Goods_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Goods_Item_On_Conflict>;
};

/** input type for inserting data into table "goods_item" */
export type Goods_Item_Insert_Input = {
  additional_unit?: InputMaybe<Scalars['String']>;
  additional_unit_confirmation?: InputMaybe<Scalars['Boolean']>;
  billing_type?: InputMaybe<Scalars['smallint']>;
  clearance_type?: InputMaybe<Scalars['Int']>;
  commercial_good?: InputMaybe<Scalars['Boolean']>;
  commodity_code?: InputMaybe<Scalars['String']>;
  commodity_code_confirmation?: InputMaybe<Scalars['Boolean']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_favour_code?: InputMaybe<Scalars['Int']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  customs_net_weight?: InputMaybe<Scalars['numeric']>;
  declaration_request?: InputMaybe<Declaration_Request_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['smallint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_total?: InputMaybe<Scalars['numeric']>;
  duty_rate?: InputMaybe<Scalars['numeric']>;
  duty_total?: InputMaybe<Scalars['numeric']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  gross_mass_confirmation?: InputMaybe<Scalars['Boolean']>;
  net_duty?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  net_mass_confirmation?: InputMaybe<Scalars['Boolean']>;
  non_customs_law_obligation?: InputMaybe<Scalars['smallint']>;
  origin_country?: InputMaybe<Scalars['String']>;
  origin_preference?: InputMaybe<Scalars['Boolean']>;
  packagings?: InputMaybe<Packagings_Arr_Rel_Insert_Input>;
  permit_obligation_code?: InputMaybe<Scalars['Int']>;
  preference_confirmation?: InputMaybe<Scalars['Boolean']>;
  process_type?: InputMaybe<Scalars['smallint']>;
  produced_documents?: InputMaybe<Produced_Documents_Arr_Rel_Insert_Input>;
  rate_confirmation?: InputMaybe<Scalars['Boolean']>;
  refinement_type?: InputMaybe<Scalars['smallint']>;
  refund_type?: InputMaybe<Scalars['smallint']>;
  repair?: InputMaybe<Scalars['Boolean']>;
  repair_reason?: InputMaybe<Scalars['String']>;
  selection_result?: InputMaybe<Scalars['Int']>;
  statistical_code?: InputMaybe<Scalars['Int']>;
  statistical_value?: InputMaybe<Scalars['Int']>;
  statistical_value_confirmation?: InputMaybe<Scalars['Boolean']>;
  storage_type?: InputMaybe<Scalars['smallint']>;
  tare_supplement?: InputMaybe<Scalars['numeric']>;
  tare_supplement_confirmation?: InputMaybe<Scalars['Boolean']>;
  un_dangerous_goods_code?: InputMaybe<Scalars['String']>;
  vat_code?: InputMaybe<Scalars['smallint']>;
  vat_code_confirmation?: InputMaybe<Scalars['Boolean']>;
  vat_rate?: InputMaybe<Scalars['numeric']>;
  vat_total?: InputMaybe<Scalars['numeric']>;
  vat_value?: InputMaybe<Scalars['numeric']>;
  vat_value_confirmation?: InputMaybe<Scalars['Boolean']>;
  voc_quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting array relation for remote table "packagings" */
export type Packagings_Arr_Rel_Insert_Input = {
  data: Array<Packagings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Packagings_On_Conflict>;
};

/** input type for inserting data into table "packagings" */
export type Packagings_Insert_Input = {
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  packaging_reference_number?: InputMaybe<Scalars['String']>;
  packaging_type?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "packagings" */
export type Packagings_On_Conflict = {
  constraint: Packagings_Constraint;
  update_columns?: Array<Packagings_Update_Column>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};

/** unique or primary key constraints on table "packagings" */
export enum Packagings_Constraint {
  /** unique or primary key constraint on columns "id" */
  PackagingsPkey = 'packagings_pkey'
}

/** update columns of table "packagings" */
export enum Packagings_Update_Column {
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  PackagingQuantity = 'packaging_quantity',
  /** column name */
  PackagingReferenceNumber = 'packaging_reference_number',
  /** column name */
  PackagingType = 'packaging_type'
}

/** input type for inserting array relation for remote table "produced_documents" */
export type Produced_Documents_Arr_Rel_Insert_Input = {
  data: Array<Produced_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Produced_Documents_On_Conflict>;
};

/** input type for inserting data into table "produced_documents" */
export type Produced_Documents_Insert_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  produced_document_issue_date?: InputMaybe<Scalars['date']>;
  produced_document_reference_number?: InputMaybe<Scalars['String']>;
  produced_document_type?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "produced_documents" */
export type Produced_Documents_On_Conflict = {
  constraint: Produced_Documents_Constraint;
  update_columns?: Array<Produced_Documents_Update_Column>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};

/** unique or primary key constraints on table "produced_documents" */
export enum Produced_Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProducedDocumentsPkey = 'produced_documents_pkey',
  /** unique or primary key constraint on columns "customs_item_number", "dr_no", "produced_document_type", "produced_document_reference_number", "file_id" */
  ProducedDocumentsUn = 'produced_documents_un'
}

/** update columns of table "produced_documents" */
export enum Produced_Documents_Update_Column {
  /** column name */
  AdditionalInformation = 'additional_information',
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProducedDocumentIssueDate = 'produced_document_issue_date',
  /** column name */
  ProducedDocumentReferenceNumber = 'produced_document_reference_number',
  /** column name */
  ProducedDocumentType = 'produced_document_type'
}

/** on_conflict condition type for table "goods_item" */
export type Goods_Item_On_Conflict = {
  constraint: Goods_Item_Constraint;
  update_columns?: Array<Goods_Item_Update_Column>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};

/** unique or primary key constraints on table "goods_item" */
export enum Goods_Item_Constraint {
  /** unique or primary key constraint on columns "customs_item_number", "dr_no", "file_id" */
  GoodsItemResponsePkey = 'goods_item_response_pkey'
}

/** update columns of table "goods_item" */
export enum Goods_Item_Update_Column {
  /** column name */
  AdditionalUnit = 'additional_unit',
  /** column name */
  AdditionalUnitConfirmation = 'additional_unit_confirmation',
  /** column name */
  BillingType = 'billing_type',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CommercialGood = 'commercial_good',
  /** column name */
  CommodityCode = 'commodity_code',
  /** column name */
  CommodityCodeConfirmation = 'commodity_code_confirmation',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  CustomsFavourCode = 'customs_favour_code',
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  CustomsNetWeight = 'customs_net_weight',
  /** column name */
  Description = 'description',
  /** column name */
  Direction = 'direction',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  DutyAndOtherTaxesTotal = 'duty_and_other_taxes_total',
  /** column name */
  DutyRate = 'duty_rate',
  /** column name */
  DutyTotal = 'duty_total',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GrossMass = 'gross_mass',
  /** column name */
  GrossMassConfirmation = 'gross_mass_confirmation',
  /** column name */
  NetDuty = 'net_duty',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  NetMassConfirmation = 'net_mass_confirmation',
  /** column name */
  NonCustomsLawObligation = 'non_customs_law_obligation',
  /** column name */
  OriginCountry = 'origin_country',
  /** column name */
  OriginPreference = 'origin_preference',
  /** column name */
  PermitObligationCode = 'permit_obligation_code',
  /** column name */
  PreferenceConfirmation = 'preference_confirmation',
  /** column name */
  ProcessType = 'process_type',
  /** column name */
  RateConfirmation = 'rate_confirmation',
  /** column name */
  RefinementType = 'refinement_type',
  /** column name */
  RefundType = 'refund_type',
  /** column name */
  Repair = 'repair',
  /** column name */
  RepairReason = 'repair_reason',
  /** column name */
  SelectionResult = 'selection_result',
  /** column name */
  StatisticalCode = 'statistical_code',
  /** column name */
  StatisticalValue = 'statistical_value',
  /** column name */
  StatisticalValueConfirmation = 'statistical_value_confirmation',
  /** column name */
  StorageType = 'storage_type',
  /** column name */
  TareSupplement = 'tare_supplement',
  /** column name */
  TareSupplementConfirmation = 'tare_supplement_confirmation',
  /** column name */
  UnDangerousGoodsCode = 'un_dangerous_goods_code',
  /** column name */
  VatCode = 'vat_code',
  /** column name */
  VatCodeConfirmation = 'vat_code_confirmation',
  /** column name */
  VatRate = 'vat_rate',
  /** column name */
  VatTotal = 'vat_total',
  /** column name */
  VatValue = 'vat_value',
  /** column name */
  VatValueConfirmation = 'vat_value_confirmation',
  /** column name */
  VocQuantity = 'voc_quantity'
}

/** input type for inserting array relation for remote table "previous_documents" */
export type Previous_Documents_Arr_Rel_Insert_Input = {
  data: Array<Previous_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Previous_Documents_On_Conflict>;
};

/** input type for inserting data into table "previous_documents" */
export type Previous_Documents_Insert_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  previous_document_reference?: InputMaybe<Scalars['String']>;
  previous_document_type?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "previous_documents" */
export type Previous_Documents_On_Conflict = {
  constraint: Previous_Documents_Constraint;
  update_columns?: Array<Previous_Documents_Update_Column>;
  where?: InputMaybe<Previous_Documents_Bool_Exp>;
};

/** unique or primary key constraints on table "previous_documents" */
export enum Previous_Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  PreviousDocumentsPk = 'previous_documents_pk',
  /** unique or primary key constraint on columns "dr_no", "previous_document_reference", "previous_document_type", "file_id" */
  PreviousDocumentsUn = 'previous_documents_un'
}

/** update columns of table "previous_documents" */
export enum Previous_Documents_Update_Column {
  /** column name */
  AdditionalInformation = 'additional_information',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  PreviousDocumentReference = 'previous_document_reference',
  /** column name */
  PreviousDocumentType = 'previous_document_type'
}

/** on_conflict condition type for table "declaration" */
export type Declaration_On_Conflict = {
  constraint: Declaration_Constraint;
  update_columns?: Array<Declaration_Update_Column>;
  where?: InputMaybe<Declaration_Bool_Exp>;
};

/** unique or primary key constraints on table "declaration" */
export enum Declaration_Constraint {
  /** unique or primary key constraint on columns "dr_no", "file_id" */
  CustomsResponsePkey = 'customs_response_pkey'
}

/** update columns of table "declaration" */
export enum Declaration_Update_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AccessCode = 'access_code',
  /** column name */
  AgreedLocationOfGoods = 'agreed_location_of_goods',
  /** column name */
  AiConfirmed = 'ai_confirmed',
  /** column name */
  AiResults = 'ai_results',
  /** column name */
  BorderEauNumber = 'border_eau_number',
  /** column name */
  BunchNumber = 'bunch_number',
  /** column name */
  ChangeInformation = 'change_information',
  /** column name */
  ClearanceLocation = 'clearance_location',
  /** column name */
  CompanyNumberTaxpayer = 'company_number_taxpayer',
  /** column name */
  CorrectionCode = 'correction_code',
  /** column name */
  CorrectionReason = 'correction_reason',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsAccountAddressType = 'customs_account_address_type',
  /** column name */
  CustomsAccountName = 'customs_account_name',
  /** column name */
  CustomsAccountNumber = 'customs_account_number',
  /** column name */
  CustomsDeclarationNumber = 'customs_declaration_number',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  CustomsOfficeNumber = 'customs_office_number',
  /** column name */
  DeclarantCompanyName = 'declarant_company_name',
  /** column name */
  DeclarantNumber = 'declarant_number',
  /** column name */
  DeclarationTime = 'declaration_time',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DeliveryDestination = 'delivery_destination',
  /** column name */
  DispatchCountry = 'dispatch_country',
  /** column name */
  DispatchCountryConfirmation = 'dispatch_country_confirmation',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  DutyAndOtherTaxesAmount = 'duty_and_other_taxes_amount',
  /** column name */
  DutyTotalAmount = 'duty_total_amount',
  /** column name */
  EvvConfirmed = 'evv_confirmed',
  /** column name */
  EvvReceived = 'evv_received',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GrossMass = 'gross_mass',
  /** column name */
  Incoterms = 'incoterms',
  /** column name */
  Initiator = 'initiator',
  /** column name */
  InjunctionType = 'injunction_type',
  /** column name */
  InspectionCode = 'inspection_code',
  /** column name */
  InvoiceCurrencyType = 'invoice_currency_type',
  /** column name */
  Lang = 'lang',
  /** column name */
  MaterialCheck = 'material_check',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  PackagingQuantity = 'packaging_quantity',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  PlaceOfLoading = 'place_of_loading',
  /** column name */
  PlaceOfUnloading = 'place_of_unloading',
  /** column name */
  PostalShipmentType = 'postal_shipment_type',
  /** column name */
  ProcedureType = 'procedure_type',
  /** column name */
  ProvisionalDeclarationExpirationDate = 'provisional_declaration_expiration_date',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReceiveStatus = 'receive_status',
  /** column name */
  Release = 'release',
  /** column name */
  RequestorTraderIdentificationNumber = 'requestor_trader_identification_number',
  /** column name */
  Security = 'security',
  /** column name */
  SelectionCorrelationId = 'selection_correlation_id',
  /** column name */
  SendDate = 'send_date',
  /** column name */
  SendStatus = 'send_status',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  ShowInWd = 'show_in_wd',
  /** column name */
  SpecificCircumstanceIndicator = 'specific_circumstance_indicator',
  /** column name */
  Status = 'status',
  /** column name */
  StatusDate = 'status_date',
  /** column name */
  StatusTime = 'status_time',
  /** column name */
  TaraFactor = 'tara_factor',
  /** column name */
  TotalGoodsItems = 'total_goods_items',
  /** column name */
  TotalVatValue = 'total_vat_value',
  /** column name */
  TraderDeclarationNumber = 'trader_declaration_number',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number',
  /** column name */
  TraderReference = 'trader_reference',
  /** column name */
  TransferToTransitSystem = 'transfer_to_transit_system',
  /** column name */
  TransportCountry = 'transport_country',
  /** column name */
  TransportInContainer = 'transport_in_container',
  /** column name */
  TransportMode = 'transport_mode',
  /** column name */
  TransportNumber = 'transport_number',
  /** column name */
  TransportType = 'transport_type',
  /** column name */
  UniqueConsignmentReferenceNumber = 'unique_consignment_reference_number',
  /** column name */
  VatAccountAddressType = 'vat_account_address_type',
  /** column name */
  VatAccountName = 'vat_account_name',
  /** column name */
  VatAccountNumber = 'vat_account_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  VatSuffix = 'vat_suffix',
  /** column name */
  VatTotalAmount = 'vat_total_amount',
  /** column name */
  WarehouseCoded = 'warehouse_coded'
}

/** input type for inserting array relation for remote table "declaration_discussion" */
export type Declaration_Discussion_Arr_Rel_Insert_Input = {
  data: Array<Declaration_Discussion_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Discussion_On_Conflict>;
};

/** input type for inserting data into table "declaration_discussion" */
export type Declaration_Discussion_Insert_Input = {
  /** Discussion is closed */
  closed?: InputMaybe<Scalars['Boolean']>;
  /** Creation date of discussion. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** User initiated discussion. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  declaration_messages?: InputMaybe<Declaration_Message_Arr_Rel_Insert_Input>;
  declaration_request?: InputMaybe<Declaration_Request_Obj_Rel_Insert_Input>;
  /** Theme of discussion. */
  discussion_theme?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  /** File/Declaration related to discussion. */
  file_id?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  user_pp?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
};

/** input type for inserting array relation for remote table "declaration_message" */
export type Declaration_Message_Arr_Rel_Insert_Input = {
  data: Array<Declaration_Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Message_On_Conflict>;
};

/** input type for inserting data into table "declaration_message" */
export type Declaration_Message_Insert_Input = {
  /** declaration_message creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  declaration_discussion?: InputMaybe<Declaration_Discussion_Obj_Rel_Insert_Input>;
  discussion_id?: InputMaybe<Scalars['bigint']>;
  message?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  msg_date?: InputMaybe<Scalars['timestamptz']>;
  read_date?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "declaration_discussion" */
export type Declaration_Discussion_Obj_Rel_Insert_Input = {
  data: Declaration_Discussion_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Discussion_On_Conflict>;
};

/** on_conflict condition type for table "declaration_discussion" */
export type Declaration_Discussion_On_Conflict = {
  constraint: Declaration_Discussion_Constraint;
  update_columns?: Array<Declaration_Discussion_Update_Column>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};

/** unique or primary key constraints on table "declaration_discussion" */
export enum Declaration_Discussion_Constraint {
  /** unique or primary key constraint on columns "discussion_id" */
  PkDeclarationDiscussionDiscussionId = 'pk_declaration_discussion_discussion_id'
}

/** placeholder for update columns of table "declaration_discussion" (current role has no relevant permissions) */
export enum Declaration_Discussion_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** on_conflict condition type for table "declaration_message" */
export type Declaration_Message_On_Conflict = {
  constraint: Declaration_Message_Constraint;
  update_columns?: Array<Declaration_Message_Update_Column>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};

/** unique or primary key constraints on table "declaration_message" */
export enum Declaration_Message_Constraint {
  /** unique or primary key constraint on columns "msg_date", "creation_user", "discussion_id", "read_date" */
  PkDeclarationMessageDiscussionIdMsgDateCreationUser = 'pk_declaration_message_discussion_id_msg_date_creation_user'
}

/** update columns of table "declaration_message" */
export enum Declaration_Message_Update_Column {
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DiscussionId = 'discussion_id',
  /** column name */
  Message = 'message',
  /** column name */
  Meta = 'meta',
  /** column name */
  MsgDate = 'msg_date',
  /** column name */
  ReadDate = 'read_date',
  /** column name */
  Type = 'type'
}

/** input type for inserting array relation for remote table "dr_goods_item" */
export type Dr_Goods_Item_Arr_Rel_Insert_Input = {
  data: Array<Dr_Goods_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Dr_Goods_Item_On_Conflict>;
};

/** input type for inserting data into table "dr_goods_item" */
export type Dr_Goods_Item_Insert_Input = {
  additional_pcs?: InputMaybe<Scalars['numeric']>;
  amount?: InputMaybe<Scalars['jsonb']>;
  certificates?: InputMaybe<Scalars['jsonb']>;
  commodity_code?: InputMaybe<Scalars['String']>;
  customs_net_mass?: InputMaybe<Scalars['numeric']>;
  declaration_request?: InputMaybe<Declaration_Request_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  key?: InputMaybe<Scalars['numeric']>;
  net_declaration?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  non_customs_law_obligation?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<Scalars['jsonb']>;
  packaging?: InputMaybe<Scalars['jsonb']>;
  revision?: InputMaybe<Scalars['Boolean']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Scalars['smallint']>;
  statistic?: InputMaybe<Scalars['jsonb']>;
  statistical_code?: InputMaybe<Scalars['String']>;
  traded_goods?: InputMaybe<Scalars['Boolean']>;
  trader_item_id?: InputMaybe<Scalars['Int']>;
  valuation?: InputMaybe<Scalars['jsonb']>;
};

/** on_conflict condition type for table "dr_goods_item" */
export type Dr_Goods_Item_On_Conflict = {
  constraint: Dr_Goods_Item_Constraint;
  update_columns?: Array<Dr_Goods_Item_Update_Column>;
  where?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
};

/** unique or primary key constraints on table "dr_goods_item" */
export enum Dr_Goods_Item_Constraint {
  /** unique or primary key constraint on columns "dr_no", "source", "file_id", "trader_item_id" */
  PkDrGoodItemFileIdDrNoTraderItemId = 'pk_dr_good_item_file_id_dr_no_trader_item_id'
}

/** update columns of table "dr_goods_item" */
export enum Dr_Goods_Item_Update_Column {
  /** column name */
  AdditionalPcs = 'additional_pcs',
  /** column name */
  Amount = 'amount',
  /** column name */
  Certificates = 'certificates',
  /** column name */
  CommodityCode = 'commodity_code',
  /** column name */
  CustomsNetMass = 'customs_net_mass',
  /** column name */
  Description = 'description',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GrossMass = 'gross_mass',
  /** column name */
  Key = 'key',
  /** column name */
  NetDeclaration = 'net_declaration',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  NonCustomsLawObligation = 'non_customs_law_obligation',
  /** column name */
  Origin = 'origin',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  Revision = 'revision',
  /** column name */
  Source = 'source',
  /** column name */
  Statistic = 'statistic',
  /** column name */
  StatisticalCode = 'statistical_code',
  /** column name */
  TradedGoods = 'traded_goods',
  /** column name */
  TraderItemId = 'trader_item_id',
  /** column name */
  Valuation = 'valuation'
}

/** response of any mutation on the table "bill_detail" */
export type Bill_Detail_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Bill_Detail>;
};

/** response of any mutation on the table "document_label_org_id" */
export type Document_Label_Org_Id_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Label_Org_Id>;
};

/** input type for inserting data into table "model_retrain" */
export type Model_Retrain_Insert_Input = {
  end_time?: InputMaybe<Scalars['timestamptz']>;
  error_message?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  request_time?: InputMaybe<Scalars['timestamptz']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "model_retrain" */
export type Model_Retrain_On_Conflict = {
  constraint: Model_Retrain_Constraint;
  update_columns?: Array<Model_Retrain_Update_Column>;
  where?: InputMaybe<Model_Retrain_Bool_Exp>;
};

/** unique or primary key constraints on table "model_retrain" */
export enum Model_Retrain_Constraint {
  /** unique or primary key constraint on columns "id" */
  ModelRetrainPkey = 'model_retrain_pkey'
}

/** update columns of table "model_retrain" */
export enum Model_Retrain_Update_Column {
  /** column name */
  EndTime = 'end_time',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Id = 'id',
  /** column name */
  RequestTime = 'request_time',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status'
}

/** response of any mutation on the table "model_retrain" */
export type Model_Retrain_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Model_Retrain>;
};

/** input type for inserting data into table "page" */
export type Page_Insert_Input = {
  created_by_user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  /** page creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** page creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** id of page. */
  id?: InputMaybe<Scalars['uuid']>;
  /** page last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified page. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  ocr_text?: InputMaybe<Scalars['String']>;
  page_extracts?: InputMaybe<Page_Extract_Arr_Rel_Insert_Input>;
  page_status?: InputMaybe<Scalars['String']>;
  rotate?: InputMaybe<Scalars['smallint']>;
  thumbnail_big_url?: InputMaybe<Scalars['String']>;
  thumbnail_small_url?: InputMaybe<Scalars['String']>;
};

/** input type for inserting array relation for remote table "page_extract" */
export type Page_Extract_Arr_Rel_Insert_Input = {
  data: Array<Page_Extract_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Page_Extract_On_Conflict>;
};

/** input type for inserting data into table "page_extract" */
export type Page_Extract_Insert_Input = {
  extract_type_id?: InputMaybe<Scalars['smallint']>;
  page?: InputMaybe<Page_Obj_Rel_Insert_Input>;
  page_id?: InputMaybe<Scalars['uuid']>;
  tables?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting object relation for remote table "page" */
export type Page_Obj_Rel_Insert_Input = {
  data: Page_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Page_On_Conflict>;
};

/** on_conflict condition type for table "page" */
export type Page_On_Conflict = {
  constraint: Page_Constraint;
  update_columns?: Array<Page_Update_Column>;
  where?: InputMaybe<Page_Bool_Exp>;
};

/** unique or primary key constraints on table "page" */
export enum Page_Constraint {
  /** unique or primary key constraint on columns "id" */
  PagePkey = 'page_pkey',
  /** unique or primary key constraint on columns "id", "page_status" */
  UiPageId = 'ui_page_id'
}

/** update columns of table "page" */
export enum Page_Update_Column {
  /** column name */
  AiIgnoreRetraining = 'ai_ignore_retraining',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  OcrText = 'ocr_text',
  /** column name */
  PageStatus = 'page_status',
  /** column name */
  Rotate = 'rotate',
  /** column name */
  ThumbnailBigUrl = 'thumbnail_big_url',
  /** column name */
  ThumbnailSmallUrl = 'thumbnail_small_url'
}

/** on_conflict condition type for table "page_extract" */
export type Page_Extract_On_Conflict = {
  constraint: Page_Extract_Constraint;
  update_columns?: Array<Page_Extract_Update_Column>;
  where?: InputMaybe<Page_Extract_Bool_Exp>;
};

/** unique or primary key constraints on table "page_extract" */
export enum Page_Extract_Constraint {
  /** unique or primary key constraint on columns "extract_type_id", "page_id" */
  PageExtractPk = 'page_extract_pk'
}

/** update columns of table "page_extract" */
export enum Page_Extract_Update_Column {
  /** column name */
  ExtractTypeId = 'extract_type_id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  Tables = 'tables',
  /** column name */
  Value = 'value'
}

/** input type for inserting data into table "service_tariff" */
export type Service_Tariff_Insert_Input = {
  direct_upload_cost?: InputMaybe<Scalars['numeric']>;
  email_upload_cost?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  position_cost?: InputMaybe<Scalars['numeric']>;
  positions_included?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
};

/** input type for inserting data into table "setting_value" */
export type Setting_Value_Insert_Input = {
  /** setting_value creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** setting_value creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** id of setting_value. */
  id?: InputMaybe<Scalars['uuid']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
  /** setting_value last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified setting_value. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  reference_id?: InputMaybe<Scalars['String']>;
  reference_type_id?: InputMaybe<Scalars['String']>;
  setting_id?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** on_conflict condition type for table "setting_value" */
export type Setting_Value_On_Conflict = {
  constraint: Setting_Value_Constraint;
  update_columns?: Array<Setting_Value_Update_Column>;
  where?: InputMaybe<Setting_Value_Bool_Exp>;
};

/** unique or primary key constraints on table "setting_value" */
export enum Setting_Value_Constraint {
  /** unique or primary key constraint on columns "id" */
  SettingTemplatePkey = 'setting_template_pkey'
}

/** update columns of table "setting_value" */
export enum Setting_Value_Update_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsTemplate = 'is_template',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  ReferenceTypeId = 'reference_type_id',
  /** column name */
  SettingId = 'setting_id',
  /** column name */
  Value = 'value'
}

/** response of any mutation on the table "tenant" */
export type Tenant_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenant>;
};

/** response of any mutation on the table "user_org_id" */
export type User_Org_Id_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Org_Id>;
};

export type LinkAddressesInputAcs = {
  linkAddressId: Scalars['Int'];
  linkAoId?: InputMaybe<Scalars['Int']>;
  linkedToAddressId: Scalars['Int'];
  linkedToAoId?: InputMaybe<Scalars['Int']>;
  sourceLink: Scalars['String'];
  sourceLinkedTo: Scalars['String'];
  tenantId: Scalars['String'];
};

export type AddressMappingEntity = {
  address_id: Scalars['Int'];
  address_override_id: Scalars['Int'];
  is_cross_address: Maybe<Scalars['Boolean']>;
  tenant_id: Scalars['String'];
};

export type SendDeclarationArrivalNotificationInput = {
  arrival_time: Scalars['timestamptz'];
  dr_no: Scalars['Int'];
  file_id: Scalars['uuid'];
};

export type TransmitFileInput = {
  files: Array<TransmitFileEntry>;
  keepDocuments: Array<InputMaybe<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type TransmitFileEntry = {
  declaration_creation_assigned_to?: InputMaybe<Scalars['ID']>;
  declarationData?: InputMaybe<DeclarationData>;
  documents: Array<InputMaybe<TransmitFileDocument>>;
  documentsToDelete?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  existingDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  fileId?: InputMaybe<Scalars['String']>;
  fileNumber?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  flags: Scalars['Int'];
  notify_after_extraction?: InputMaybe<Array<Scalars['ID']>>;
  orgId: Scalars['Int'];
  reviewedAndVerified?: InputMaybe<Scalars['Boolean']>;
  scheduleFileExport?: InputMaybe<Scalars['Boolean']>;
};

export type DeclarationData = {
  consigneeAddressId?: InputMaybe<Scalars['Int']>;
  consignorAddressId?: InputMaybe<Scalars['Int']>;
  customsOfficeNumber?: InputMaybe<Scalars['String']>;
  etaDate?: InputMaybe<Scalars['timestamptz']>;
  importerAddressId?: InputMaybe<Scalars['Int']>;
  payerAddressId?: InputMaybe<Scalars['Int']>;
  payerName?: InputMaybe<Scalars['String']>;
  payerReference?: InputMaybe<Scalars['String']>;
  totalColis?: InputMaybe<Scalars['Int']>;
  totalGrossWeight?: InputMaybe<Scalars['Float']>;
};

export type TransmitFileDocument = {
  documentType?: InputMaybe<Scalars['String']>;
  flags?: InputMaybe<Scalars['Int']>;
  manual_annotation_due_date?: InputMaybe<Scalars['timestamptz']>;
  meta?: InputMaybe<Scalars['JSON']>;
  selectedPages: Array<Scalars['ID']>;
};

export type TransmitFileResponse = {
  error: Maybe<Scalars['String']>;
  fileIds: Maybe<Array<Maybe<Scalars['ID']>>>;
  success: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Address_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Address_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Address_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Address_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "address" */
export type Address_Inc_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Address_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "address" */
export type Address_Set_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  reference?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: address */
export type Address_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Address_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Address_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Address_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Address_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Address_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Address_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Address_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Address_Override_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Address_Override_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Address_Override_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Address_Override_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "address_override" */
export type Address_Override_Inc_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Address_Override_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "address_override" */
export type Address_Override_Set_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  reference?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: address_override */
export type Address_Override_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Address_Override_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Address_Override_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Address_Override_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Address_Override_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Address_Override_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Address_Override_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Address_Override_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Override_Set_Input>;
  where: Address_Override_Bool_Exp;
};

/** input type for incrementing numeric columns in table "bill_detail" */
export type Bill_Detail_Inc_Input = {
  bill_id?: InputMaybe<Scalars['bigint']>;
  charged_items?: InputMaybe<Scalars['bigint']>;
  const_charge?: InputMaybe<Scalars['numeric']>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Scalars['bigint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  srv_id?: InputMaybe<Scalars['Int']>;
  var_charge?: InputMaybe<Scalars['numeric']>;
};

/** input type for updating data in table "bill_detail" */
export type Bill_Detail_Set_Input = {
  bill_id?: InputMaybe<Scalars['bigint']>;
  charged_items?: InputMaybe<Scalars['bigint']>;
  const_charge?: InputMaybe<Scalars['numeric']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Scalars['bigint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  remark?: InputMaybe<Scalars['String']>;
  srv_id?: InputMaybe<Scalars['Int']>;
  var_charge?: InputMaybe<Scalars['numeric']>;
};

/** primary key columns input for table: bill_detail */
export type Bill_Detail_Pk_Columns_Input = {
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id: Scalars['bigint'];
};

export type Bill_Detail_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bill_Detail_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bill_Detail_Set_Input>;
  where: Bill_Detail_Bool_Exp;
};

/** input type for incrementing numeric columns in table "containers" */
export type Containers_Inc_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "containers" */
export type Containers_Set_Input = {
  container_number?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** primary key columns input for table: containers */
export type Containers_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Containers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Containers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Containers_Set_Input>;
  where: Containers_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Append_Input = {
  ai_results?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Declaration_Delete_At_Path_Input = {
  ai_results?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Declaration_Delete_Elem_Input = {
  ai_results?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Declaration_Delete_Key_Input = {
  ai_results?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "declaration" */
export type Declaration_Inc_Input = {
  border_eau_number?: InputMaybe<Scalars['numeric']>;
  bunch_number?: InputMaybe<Scalars['Int']>;
  clearance_location?: InputMaybe<Scalars['smallint']>;
  correction_code?: InputMaybe<Scalars['Int']>;
  customs_account_address_type?: InputMaybe<Scalars['Int']>;
  customs_account_number?: InputMaybe<Scalars['bigint']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  declarant_number?: InputMaybe<Scalars['Int']>;
  declaration_time?: InputMaybe<Scalars['smallint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_amount?: InputMaybe<Scalars['numeric']>;
  duty_total_amount?: InputMaybe<Scalars['numeric']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  initiator?: InputMaybe<Scalars['smallint']>;
  injunction_type?: InputMaybe<Scalars['smallint']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  procedure_type?: InputMaybe<Scalars['smallint']>;
  receive_status?: InputMaybe<Scalars['Int']>;
  send_status?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['Int']>;
  tara_factor?: InputMaybe<Scalars['numeric']>;
  total_goods_items?: InputMaybe<Scalars['Int']>;
  total_vat_value?: InputMaybe<Scalars['numeric']>;
  transport_mode?: InputMaybe<Scalars['Int']>;
  vat_account_address_type?: InputMaybe<Scalars['Int']>;
  vat_account_number?: InputMaybe<Scalars['bigint']>;
  vat_total_amount?: InputMaybe<Scalars['numeric']>;
  warehouse_coded?: InputMaybe<Scalars['smallint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Prepend_Input = {
  ai_results?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "declaration" */
export type Declaration_Set_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  access_code?: InputMaybe<Scalars['String']>;
  agreed_location_of_goods?: InputMaybe<Scalars['String']>;
  ai_confirmed?: InputMaybe<Scalars['Boolean']>;
  ai_results?: InputMaybe<Scalars['jsonb']>;
  border_eau_number?: InputMaybe<Scalars['numeric']>;
  bunch_number?: InputMaybe<Scalars['Int']>;
  change_information?: InputMaybe<Scalars['date']>;
  clearance_location?: InputMaybe<Scalars['smallint']>;
  company_number_taxpayer?: InputMaybe<Scalars['String']>;
  correction_code?: InputMaybe<Scalars['Int']>;
  correction_reason?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_account_address_type?: InputMaybe<Scalars['Int']>;
  customs_account_name?: InputMaybe<Scalars['String']>;
  customs_account_number?: InputMaybe<Scalars['bigint']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_office_number?: InputMaybe<Scalars['String']>;
  declarant_company_name?: InputMaybe<Scalars['String']>;
  declarant_number?: InputMaybe<Scalars['Int']>;
  declaration_time?: InputMaybe<Scalars['smallint']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  delivery_destination?: InputMaybe<Scalars['bpchar']>;
  dispatch_country?: InputMaybe<Scalars['String']>;
  dispatch_country_confirmation?: InputMaybe<Scalars['Boolean']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_amount?: InputMaybe<Scalars['numeric']>;
  duty_total_amount?: InputMaybe<Scalars['numeric']>;
  evv_confirmed?: InputMaybe<Scalars['Boolean']>;
  evv_received?: InputMaybe<Scalars['Boolean']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  incoterms?: InputMaybe<Scalars['String']>;
  initiator?: InputMaybe<Scalars['smallint']>;
  injunction_type?: InputMaybe<Scalars['smallint']>;
  inspection_code?: InputMaybe<Scalars['Boolean']>;
  invoice_currency_type?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
  material_check?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  place_of_loading?: InputMaybe<Scalars['String']>;
  place_of_unloading?: InputMaybe<Scalars['String']>;
  postal_shipment_type?: InputMaybe<Scalars['String']>;
  procedure_type?: InputMaybe<Scalars['smallint']>;
  provisional_declaration_expiration_date?: InputMaybe<Scalars['date']>;
  reason?: InputMaybe<Scalars['String']>;
  receive_status?: InputMaybe<Scalars['Int']>;
  release?: InputMaybe<Scalars['Boolean']>;
  requestor_trader_identification_number?: InputMaybe<Scalars['String']>;
  security?: InputMaybe<Scalars['Boolean']>;
  selection_correlation_id?: InputMaybe<Scalars['String']>;
  send_date?: InputMaybe<Scalars['timestamptz']>;
  send_status?: InputMaybe<Scalars['Int']>;
  service_type?: InputMaybe<Scalars['String']>;
  show_in_wd?: InputMaybe<Scalars['Boolean']>;
  specific_circumstance_indicator?: InputMaybe<Scalars['bpchar']>;
  status?: InputMaybe<Scalars['Int']>;
  status_date?: InputMaybe<Scalars['date']>;
  status_time?: InputMaybe<Scalars['time']>;
  tara_factor?: InputMaybe<Scalars['numeric']>;
  total_goods_items?: InputMaybe<Scalars['Int']>;
  total_vat_value?: InputMaybe<Scalars['numeric']>;
  trader_declaration_number?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  transfer_to_transit_system?: InputMaybe<Scalars['Boolean']>;
  transport_country?: InputMaybe<Scalars['String']>;
  transport_in_container?: InputMaybe<Scalars['Boolean']>;
  transport_mode?: InputMaybe<Scalars['Int']>;
  transport_number?: InputMaybe<Scalars['String']>;
  transport_type?: InputMaybe<Scalars['String']>;
  unique_consignment_reference_number?: InputMaybe<Scalars['String']>;
  vat_account_address_type?: InputMaybe<Scalars['Int']>;
  vat_account_name?: InputMaybe<Scalars['String']>;
  vat_account_number?: InputMaybe<Scalars['bigint']>;
  vat_number?: InputMaybe<Scalars['String']>;
  vat_suffix?: InputMaybe<Scalars['Boolean']>;
  vat_total_amount?: InputMaybe<Scalars['numeric']>;
  warehouse_coded?: InputMaybe<Scalars['smallint']>;
};

/** primary key columns input for table: declaration */
export type Declaration_Pk_Columns_Input = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};

/** input type for updating data in table "declaration_discussions" */
export type Declaration_Discussions_Set_Input = {
  last_read_date?: InputMaybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "declaration_discussions" */
export type Declaration_Discussions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Discussions>;
};

export type Declaration_Discussions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Discussions_Set_Input>;
  where: Declaration_Discussions_Bool_Exp;
};

export type Declaration_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Declaration_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Declaration_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Declaration_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Declaration_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Declaration_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Declaration_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Set_Input>;
  where: Declaration_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Message_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Declaration_Message_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Declaration_Message_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Declaration_Message_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "declaration_message" */
export type Declaration_Message_Inc_Input = {
  discussion_id?: InputMaybe<Scalars['bigint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Message_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "declaration_message" */
export type Declaration_Message_Set_Input = {
  /** declaration_message creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  discussion_id?: InputMaybe<Scalars['bigint']>;
  message?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  msg_date?: InputMaybe<Scalars['timestamptz']>;
  read_date?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: declaration_message */
export type Declaration_Message_Pk_Columns_Input = {
  /** declaration_message creation user. */
  creation_user: Scalars['uuid'];
  discussion_id: Scalars['bigint'];
  msg_date: Scalars['timestamptz'];
  read_date: Scalars['timestamptz'];
};

export type Declaration_Message_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Declaration_Message_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Declaration_Message_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Declaration_Message_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Declaration_Message_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Declaration_Message_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Declaration_Message_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Message_Set_Input>;
  where: Declaration_Message_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Request_Append_Input = {
  edec?: InputMaybe<Scalars['jsonb']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Declaration_Request_Delete_At_Path_Input = {
  edec?: InputMaybe<Array<Scalars['String']>>;
  /** additional attributes */
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Declaration_Request_Delete_Elem_Input = {
  edec?: InputMaybe<Scalars['Int']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Declaration_Request_Delete_Key_Input = {
  edec?: InputMaybe<Scalars['String']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "declaration_request" */
export type Declaration_Request_Inc_Input = {
  customs_declaration_version?: InputMaybe<Scalars['smallint']>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Scalars['smallint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Request_Prepend_Input = {
  edec?: InputMaybe<Scalars['jsonb']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "declaration_request" */
export type Declaration_Request_Set_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  /** Account number in CH customs */
  account_number?: InputMaybe<Scalars['String']>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  /** WeDeclare must create CH-Exportdeclaration */
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  /** Refer to values in table clearance_type. */
  clearance_type?: InputMaybe<Scalars['String']>;
  /** Date of creation of declaration request. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** User created declaration request. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['smallint']>;
  /** Refer to values in table declaration_status. */
  declaration_status?: InputMaybe<Scalars['String']>;
  /** Refer to values in table declaration_type. */
  declaration_type?: InputMaybe<Scalars['String']>;
  /** Destination Tolldept Code */
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  /** Destination Tolldept Name */
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Scalars['smallint']>;
  edec?: InputMaybe<Scalars['jsonb']>;
  eta?: InputMaybe<Scalars['timestamptz']>;
  /** File related to declaration request. Part of primary key */
  file_id?: InputMaybe<Scalars['uuid']>;
  /** WeDeclare must create the Import customs clearance in the destination Country */
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  /** Service:  Standard  oder Express */
  is_express?: InputMaybe<Scalars['Boolean']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  /** Who is paying for customs declaration (tenant) */
  payer_id?: InputMaybe<Scalars['uuid']>;
  /** Customs office number. Refer to customs_office table.office_number. */
  toll_dep?: InputMaybe<Scalars['String']>;
  /** Truck and Trailer Plate No. */
  tr_no?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  /** Type Transitdocument */
  transitdoc_type?: InputMaybe<Scalars['transitdoc_type']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "declaration_request_address" */
export type Declaration_Request_Address_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
};

/** input type for updating data in table "declaration_request_address" */
export type Declaration_Request_Address_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['Int']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['json']>;
  refs?: InputMaybe<Scalars['_text']>;
  search_refs?: InputMaybe<Scalars['_text']>;
};

/** primary key columns input for table: declaration_request_address */
export type Declaration_Request_Address_Pk_Columns_Input = {
  address_type: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};

export type Declaration_Request_Address_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Declaration_Request_Address_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Request_Address_Set_Input>;
  where: Declaration_Request_Address_Bool_Exp;
};

/** primary key columns input for table: declaration_request */
export type Declaration_Request_Pk_Columns_Input = {
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no: Scalars['smallint'];
  /** File related to declaration request. Part of primary key */
  file_id: Scalars['uuid'];
};

export type Declaration_Request_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Declaration_Request_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Declaration_Request_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Declaration_Request_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Declaration_Request_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Declaration_Request_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Declaration_Request_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Request_Set_Input>;
  where: Declaration_Request_Bool_Exp;
};

/** input type for incrementing numeric columns in table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Inc_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
  sequence_number?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Set_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  sequence_number?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: declaration_special_mentions */
export type Declaration_Special_Mentions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Declaration_Special_Mentions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Declaration_Special_Mentions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Special_Mentions_Set_Input>;
  where: Declaration_Special_Mentions_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Task_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Declaration_Task_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Declaration_Task_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Declaration_Task_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "declaration_task" */
export type Declaration_Task_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Scalars['Int']>;
  task_type_id?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Task_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "declaration_task" */
export type Declaration_Task_Set_Input = {
  assigned_to?: InputMaybe<Scalars['uuid']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  due_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  object_id?: InputMaybe<Scalars['uuid']>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Scalars['Int']>;
  task_type_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "declaration_task" */
export type Declaration_Task_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Task>;
};

/** primary key columns input for table: declaration_task */
export type Declaration_Task_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Declaration_Task_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Declaration_Task_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Declaration_Task_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Declaration_Task_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Declaration_Task_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Declaration_Task_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Declaration_Task_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Task_Set_Input>;
  where: Declaration_Task_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Doc_Annotation_Append_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Doc_Annotation_Delete_At_Path_Input = {
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Doc_Annotation_Delete_Elem_Input = {
  value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Doc_Annotation_Delete_Key_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Doc_Annotation_Prepend_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "doc_annotation" */
export type Doc_Annotation_Set_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** primary key columns input for table: doc_annotation */
export type Doc_Annotation_Pk_Columns_Input = {
  anno_type_id: Scalars['smallint'];
  /** Document Id related to doc_annotation. */
  doc_id: Scalars['uuid'];
};

export type Doc_Annotation_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Doc_Annotation_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Doc_Annotation_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Doc_Annotation_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Doc_Annotation_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Doc_Annotation_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Doc_Annotation_Set_Input>;
  where: Doc_Annotation_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Document_Append_Input = {
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Document_Delete_At_Path_Input = {
  document_blobs?: InputMaybe<Array<Scalars['String']>>;
  /** additional attributes */
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Document_Delete_Elem_Input = {
  document_blobs?: InputMaybe<Scalars['Int']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Document_Delete_Key_Input = {
  document_blobs?: InputMaybe<Scalars['String']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "document" */
export type Document_Inc_Input = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Scalars['bigint']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Scalars['smallint']>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Scalars['smallint']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Document_Prepend_Input = {
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "document" */
export type Document_Set_Input = {
  /** MD5-checksum of document. */
  checksum?: InputMaybe<Scalars['String']>;
  /** document creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** document creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  document_extension?: InputMaybe<Scalars['String']>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Scalars['bigint']>;
  document_name?: InputMaybe<Scalars['String']>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Scalars['smallint']>;
  /** Document Id related to document. */
  file?: InputMaybe<Scalars['uuid']>;
  /** id of document. */
  id?: InputMaybe<Scalars['uuid']>;
  is_customs_relevant?: InputMaybe<Scalars['Boolean']>;
  /** Marks document record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_generated?: InputMaybe<Scalars['Boolean']>;
  /** document last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified document. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Scalars['smallint']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** primary key columns input for table: document */
export type Document_Pk_Columns_Input = {
  document_type: Scalars['String'];
  /** id of document. */
  id: Scalars['uuid'];
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Document_Labels_Append_Input = {
  description?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Document_Labels_Delete_At_Path_Input = {
  description?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Document_Labels_Delete_Elem_Input = {
  description?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Document_Labels_Delete_Key_Input = {
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "document_labels" */
export type Document_Labels_Inc_Input = {
  /** id of document_labels. */
  id?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Document_Labels_Prepend_Input = {
  description?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "document_labels" */
export type Document_Labels_Set_Input = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  /** id of document_labels. */
  id?: InputMaybe<Scalars['Int']>;
  /** Marks document_labels record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['jsonb']>;
};

/** primary key columns input for table: document_labels */
export type Document_Labels_Pk_Columns_Input = {
  /** id of document_labels. */
  id: Scalars['Int'];
};

export type Document_Labels_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Document_Labels_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Document_Labels_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Document_Labels_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Document_Labels_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Labels_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Document_Labels_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Labels_Set_Input>;
  where: Document_Labels_Bool_Exp;
};

export type Document_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Document_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Document_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Document_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Document_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Document_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Set_Input>;
  where: Document_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Document_Type_Append_Input = {
  translations?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Document_Type_Delete_At_Path_Input = {
  translations?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Document_Type_Delete_Elem_Input = {
  translations?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Document_Type_Delete_Key_Input = {
  translations?: InputMaybe<Scalars['String']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Document_Type_Prepend_Input = {
  translations?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "document_type" */
export type Document_Type_Set_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Scalars['jsonb']>;
};

/** primary key columns input for table: document_type */
export type Document_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

export type Document_Type_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Document_Type_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Document_Type_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Document_Type_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Document_Type_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Document_Type_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Type_Set_Input>;
  where: Document_Type_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Document_Type_Tenant_Settings_Append_Input = {
  document_schema?: InputMaybe<Scalars['jsonb']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Document_Type_Tenant_Settings_Delete_At_Path_Input = {
  document_schema?: InputMaybe<Array<Scalars['String']>>;
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Document_Type_Tenant_Settings_Delete_Elem_Input = {
  document_schema?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Document_Type_Tenant_Settings_Delete_Key_Input = {
  document_schema?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Inc_Input = {
  default_flags?: InputMaybe<Scalars['bigint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Document_Type_Tenant_Settings_Prepend_Input = {
  document_schema?: InputMaybe<Scalars['jsonb']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  default_flags?: InputMaybe<Scalars['bigint']>;
  display_name?: InputMaybe<Scalars['String']>;
  document_schema?: InputMaybe<Scalars['jsonb']>;
  document_type?: InputMaybe<Scalars['String']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** primary key columns input for table: document_type_tenant_settings */
export type Document_Type_Tenant_Settings_Pk_Columns_Input = {
  document_type: Scalars['String'];
  tenant: Scalars['uuid'];
};

export type Document_Type_Tenant_Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Document_Type_Tenant_Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Document_Type_Tenant_Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Document_Type_Tenant_Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Document_Type_Tenant_Settings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Type_Tenant_Settings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Document_Type_Tenant_Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Type_Tenant_Settings_Set_Input>;
  where: Document_Type_Tenant_Settings_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Dr_Goods_Item_Append_Input = {
  amount?: InputMaybe<Scalars['jsonb']>;
  certificates?: InputMaybe<Scalars['jsonb']>;
  origin?: InputMaybe<Scalars['jsonb']>;
  packaging?: InputMaybe<Scalars['jsonb']>;
  statistic?: InputMaybe<Scalars['jsonb']>;
  valuation?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Dr_Goods_Item_Delete_At_Path_Input = {
  amount?: InputMaybe<Array<Scalars['String']>>;
  certificates?: InputMaybe<Array<Scalars['String']>>;
  origin?: InputMaybe<Array<Scalars['String']>>;
  packaging?: InputMaybe<Array<Scalars['String']>>;
  statistic?: InputMaybe<Array<Scalars['String']>>;
  valuation?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Dr_Goods_Item_Delete_Elem_Input = {
  amount?: InputMaybe<Scalars['Int']>;
  certificates?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<Scalars['Int']>;
  packaging?: InputMaybe<Scalars['Int']>;
  statistic?: InputMaybe<Scalars['Int']>;
  valuation?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Dr_Goods_Item_Delete_Key_Input = {
  amount?: InputMaybe<Scalars['String']>;
  certificates?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['String']>;
  statistic?: InputMaybe<Scalars['String']>;
  valuation?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "dr_goods_item" */
export type Dr_Goods_Item_Inc_Input = {
  additional_pcs?: InputMaybe<Scalars['numeric']>;
  customs_net_mass?: InputMaybe<Scalars['numeric']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  key?: InputMaybe<Scalars['numeric']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  non_customs_law_obligation?: InputMaybe<Scalars['Int']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Scalars['smallint']>;
  trader_item_id?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Dr_Goods_Item_Prepend_Input = {
  amount?: InputMaybe<Scalars['jsonb']>;
  certificates?: InputMaybe<Scalars['jsonb']>;
  origin?: InputMaybe<Scalars['jsonb']>;
  packaging?: InputMaybe<Scalars['jsonb']>;
  statistic?: InputMaybe<Scalars['jsonb']>;
  valuation?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "dr_goods_item" */
export type Dr_Goods_Item_Set_Input = {
  additional_pcs?: InputMaybe<Scalars['numeric']>;
  amount?: InputMaybe<Scalars['jsonb']>;
  certificates?: InputMaybe<Scalars['jsonb']>;
  commodity_code?: InputMaybe<Scalars['String']>;
  customs_net_mass?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  key?: InputMaybe<Scalars['numeric']>;
  net_declaration?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  non_customs_law_obligation?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<Scalars['jsonb']>;
  packaging?: InputMaybe<Scalars['jsonb']>;
  revision?: InputMaybe<Scalars['Boolean']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Scalars['smallint']>;
  statistic?: InputMaybe<Scalars['jsonb']>;
  statistical_code?: InputMaybe<Scalars['String']>;
  traded_goods?: InputMaybe<Scalars['Boolean']>;
  trader_item_id?: InputMaybe<Scalars['Int']>;
  valuation?: InputMaybe<Scalars['jsonb']>;
};

/** primary key columns input for table: dr_goods_item */
export type Dr_Goods_Item_Pk_Columns_Input = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source: Scalars['smallint'];
  trader_item_id: Scalars['Int'];
};

export type Dr_Goods_Item_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Dr_Goods_Item_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Dr_Goods_Item_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Dr_Goods_Item_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Dr_Goods_Item_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Dr_Goods_Item_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Dr_Goods_Item_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dr_Goods_Item_Set_Input>;
  where: Dr_Goods_Item_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Extraction_Config_Append_Input = {
  aliases?: InputMaybe<Scalars['jsonb']>;
  document_templates?: InputMaybe<Scalars['jsonb']>;
  foun_config?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Extraction_Config_Delete_At_Path_Input = {
  aliases?: InputMaybe<Array<Scalars['String']>>;
  document_templates?: InputMaybe<Array<Scalars['String']>>;
  foun_config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Extraction_Config_Delete_Elem_Input = {
  aliases?: InputMaybe<Scalars['Int']>;
  document_templates?: InputMaybe<Scalars['Int']>;
  foun_config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Extraction_Config_Delete_Key_Input = {
  aliases?: InputMaybe<Scalars['String']>;
  document_templates?: InputMaybe<Scalars['String']>;
  foun_config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "extraction_config" */
export type Extraction_Config_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Extraction_Config_Prepend_Input = {
  aliases?: InputMaybe<Scalars['jsonb']>;
  document_templates?: InputMaybe<Scalars['jsonb']>;
  foun_config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "extraction_config" */
export type Extraction_Config_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  aliases?: InputMaybe<Scalars['jsonb']>;
  document_templates?: InputMaybe<Scalars['jsonb']>;
  foun_config?: InputMaybe<Scalars['jsonb']>;
};

/** response of any mutation on the table "extraction_config" */
export type Extraction_Config_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Extraction_Config>;
};

/** primary key columns input for table: extraction_config */
export type Extraction_Config_Pk_Columns_Input = {
  address_id: Scalars['Int'];
};

export type Extraction_Config_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Extraction_Config_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Extraction_Config_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Extraction_Config_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Extraction_Config_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Extraction_Config_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Extraction_Config_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Extraction_Config_Set_Input>;
  where: Extraction_Config_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type File_Append_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type File_Delete_At_Path_Input = {
  /** additional attributes */
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type File_Delete_Elem_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type File_Delete_Key_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "file" */
export type File_Inc_Input = {
  file_flags?: InputMaybe<Scalars['bigint']>;
  /** Org_id related to file. */
  org_id?: InputMaybe<Scalars['smallint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type File_Prepend_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "file" */
export type File_Set_Input = {
  ai_doc_classification_confirmed?: InputMaybe<Scalars['Boolean']>;
  /** file creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** file creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  file_flags?: InputMaybe<Scalars['bigint']>;
  file_status?: InputMaybe<Scalars['String']>;
  file_type?: InputMaybe<Scalars['String']>;
  file_url?: InputMaybe<Scalars['String']>;
  /** id of file. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Is usually set automatically by AQW.IdentificationProvider.
   *
   * AQW.IdentificationProvider can be set in tenant settings either DefaultProvider (random uuid) or a company specific provider which calls an external API endpoint.
   *
   */
  identification?: InputMaybe<Scalars['String']>;
  /** Marks file record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  /** file last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  /** Org_id related to file. */
  org_id?: InputMaybe<Scalars['smallint']>;
  session_id?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: file */
export type File_Pk_Columns_Input = {
  /** id of file. */
  id: Scalars['uuid'];
};

export type File_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<File_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<File_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<File_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<File_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<File_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<File_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<File_Set_Input>;
  where: File_Bool_Exp;
};

/** input type for incrementing numeric columns in table "goods_item" */
export type Goods_Item_Inc_Input = {
  billing_type?: InputMaybe<Scalars['smallint']>;
  clearance_type?: InputMaybe<Scalars['Int']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_favour_code?: InputMaybe<Scalars['Int']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  customs_net_weight?: InputMaybe<Scalars['numeric']>;
  direction?: InputMaybe<Scalars['smallint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_total?: InputMaybe<Scalars['numeric']>;
  duty_rate?: InputMaybe<Scalars['numeric']>;
  duty_total?: InputMaybe<Scalars['numeric']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  non_customs_law_obligation?: InputMaybe<Scalars['smallint']>;
  permit_obligation_code?: InputMaybe<Scalars['Int']>;
  process_type?: InputMaybe<Scalars['smallint']>;
  refinement_type?: InputMaybe<Scalars['smallint']>;
  refund_type?: InputMaybe<Scalars['smallint']>;
  selection_result?: InputMaybe<Scalars['Int']>;
  statistical_code?: InputMaybe<Scalars['Int']>;
  statistical_value?: InputMaybe<Scalars['Int']>;
  storage_type?: InputMaybe<Scalars['smallint']>;
  tare_supplement?: InputMaybe<Scalars['numeric']>;
  vat_code?: InputMaybe<Scalars['smallint']>;
  vat_rate?: InputMaybe<Scalars['numeric']>;
  vat_total?: InputMaybe<Scalars['numeric']>;
  vat_value?: InputMaybe<Scalars['numeric']>;
  voc_quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for updating data in table "goods_item" */
export type Goods_Item_Set_Input = {
  additional_unit?: InputMaybe<Scalars['String']>;
  additional_unit_confirmation?: InputMaybe<Scalars['Boolean']>;
  billing_type?: InputMaybe<Scalars['smallint']>;
  clearance_type?: InputMaybe<Scalars['Int']>;
  commercial_good?: InputMaybe<Scalars['Boolean']>;
  commodity_code?: InputMaybe<Scalars['String']>;
  commodity_code_confirmation?: InputMaybe<Scalars['Boolean']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_favour_code?: InputMaybe<Scalars['Int']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  customs_net_weight?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['smallint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_total?: InputMaybe<Scalars['numeric']>;
  duty_rate?: InputMaybe<Scalars['numeric']>;
  duty_total?: InputMaybe<Scalars['numeric']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  gross_mass_confirmation?: InputMaybe<Scalars['Boolean']>;
  net_duty?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  net_mass_confirmation?: InputMaybe<Scalars['Boolean']>;
  non_customs_law_obligation?: InputMaybe<Scalars['smallint']>;
  origin_country?: InputMaybe<Scalars['String']>;
  origin_preference?: InputMaybe<Scalars['Boolean']>;
  permit_obligation_code?: InputMaybe<Scalars['Int']>;
  preference_confirmation?: InputMaybe<Scalars['Boolean']>;
  process_type?: InputMaybe<Scalars['smallint']>;
  rate_confirmation?: InputMaybe<Scalars['Boolean']>;
  refinement_type?: InputMaybe<Scalars['smallint']>;
  refund_type?: InputMaybe<Scalars['smallint']>;
  repair?: InputMaybe<Scalars['Boolean']>;
  repair_reason?: InputMaybe<Scalars['String']>;
  selection_result?: InputMaybe<Scalars['Int']>;
  statistical_code?: InputMaybe<Scalars['Int']>;
  statistical_value?: InputMaybe<Scalars['Int']>;
  statistical_value_confirmation?: InputMaybe<Scalars['Boolean']>;
  storage_type?: InputMaybe<Scalars['smallint']>;
  tare_supplement?: InputMaybe<Scalars['numeric']>;
  tare_supplement_confirmation?: InputMaybe<Scalars['Boolean']>;
  un_dangerous_goods_code?: InputMaybe<Scalars['String']>;
  vat_code?: InputMaybe<Scalars['smallint']>;
  vat_code_confirmation?: InputMaybe<Scalars['Boolean']>;
  vat_rate?: InputMaybe<Scalars['numeric']>;
  vat_total?: InputMaybe<Scalars['numeric']>;
  vat_value?: InputMaybe<Scalars['numeric']>;
  vat_value_confirmation?: InputMaybe<Scalars['Boolean']>;
  voc_quantity?: InputMaybe<Scalars['numeric']>;
};

/** primary key columns input for table: goods_item */
export type Goods_Item_Pk_Columns_Input = {
  customs_item_number: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};

export type Goods_Item_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Goods_Item_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Goods_Item_Set_Input>;
  where: Goods_Item_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Import_List_Trigger_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Import_List_Trigger_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']>>;
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Import_List_Trigger_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Import_List_Trigger_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "import_list_trigger" */
export type Import_List_Trigger_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Import_List_Trigger_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "import_list_trigger" */
export type Import_List_Trigger_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: import_list_trigger */
export type Import_List_Trigger_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Import_List_Trigger_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Import_List_Trigger_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Import_List_Trigger_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Import_List_Trigger_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Import_List_Trigger_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Import_List_Trigger_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Import_List_Trigger_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Import_List_Trigger_Set_Input>;
  where: Import_List_Trigger_Bool_Exp;
};

/** input type for incrementing numeric columns in table "model_retrain" */
export type Model_Retrain_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "model_retrain" */
export type Model_Retrain_Set_Input = {
  end_time?: InputMaybe<Scalars['timestamptz']>;
  error_message?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  request_time?: InputMaybe<Scalars['timestamptz']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: model_retrain */
export type Model_Retrain_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Model_Retrain_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Model_Retrain_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Retrain_Set_Input>;
  where: Model_Retrain_Bool_Exp;
};

/** input type for incrementing numeric columns in table "packagings" */
export type Packagings_Inc_Input = {
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "packagings" */
export type Packagings_Set_Input = {
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  packaging_reference_number?: InputMaybe<Scalars['String']>;
  packaging_type?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: packagings */
export type Packagings_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Packagings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Packagings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Packagings_Set_Input>;
  where: Packagings_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Page_Append_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Page_Delete_At_Path_Input = {
  /** additional attributes */
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Page_Delete_Elem_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Page_Delete_Key_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "page" */
export type Page_Inc_Input = {
  rotate?: InputMaybe<Scalars['smallint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Page_Prepend_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "page" */
export type Page_Set_Input = {
  ai_ignore_retraining?: InputMaybe<Scalars['Boolean']>;
  /** page creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** page creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** id of page. */
  id?: InputMaybe<Scalars['uuid']>;
  /** page last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified page. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  ocr_text?: InputMaybe<Scalars['String']>;
  page_status?: InputMaybe<Scalars['String']>;
  rotate?: InputMaybe<Scalars['smallint']>;
  thumbnail_big_url?: InputMaybe<Scalars['String']>;
  thumbnail_small_url?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: page */
export type Page_Pk_Columns_Input = {
  /** id of page. */
  id: Scalars['uuid'];
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Page_Extract_Append_Input = {
  tables?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Page_Extract_Delete_At_Path_Input = {
  tables?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Page_Extract_Delete_Elem_Input = {
  tables?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Page_Extract_Delete_Key_Input = {
  tables?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "page_extract" */
export type Page_Extract_Inc_Input = {
  extract_type_id?: InputMaybe<Scalars['smallint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Page_Extract_Prepend_Input = {
  tables?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "page_extract" */
export type Page_Extract_Set_Input = {
  extract_type_id?: InputMaybe<Scalars['smallint']>;
  page_id?: InputMaybe<Scalars['uuid']>;
  tables?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** primary key columns input for table: page_extract */
export type Page_Extract_Pk_Columns_Input = {
  extract_type_id: Scalars['smallint'];
  page_id: Scalars['uuid'];
};

export type Page_Extract_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Page_Extract_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Page_Extract_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Page_Extract_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Page_Extract_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Page_Extract_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Page_Extract_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Page_Extract_Set_Input>;
  where: Page_Extract_Bool_Exp;
};

export type Page_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Page_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Page_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Page_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Page_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Page_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Page_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Page_Set_Input>;
  where: Page_Bool_Exp;
};

/** input type for incrementing numeric columns in table "previous_documents" */
export type Previous_Documents_Inc_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "previous_documents" */
export type Previous_Documents_Set_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  previous_document_reference?: InputMaybe<Scalars['String']>;
  previous_document_type?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: previous_documents */
export type Previous_Documents_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Previous_Documents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Previous_Documents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Previous_Documents_Set_Input>;
  where: Previous_Documents_Bool_Exp;
};

/** input type for incrementing numeric columns in table "produced_documents" */
export type Produced_Documents_Inc_Input = {
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "produced_documents" */
export type Produced_Documents_Set_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  produced_document_issue_date?: InputMaybe<Scalars['date']>;
  produced_document_reference_number?: InputMaybe<Scalars['String']>;
  produced_document_type?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: produced_documents */
export type Produced_Documents_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Produced_Documents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Produced_Documents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Produced_Documents_Set_Input>;
  where: Produced_Documents_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Service_Tariff_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Service_Tariff_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Service_Tariff_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Service_Tariff_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "service_tariff" */
export type Service_Tariff_Inc_Input = {
  direct_upload_cost?: InputMaybe<Scalars['numeric']>;
  email_upload_cost?: InputMaybe<Scalars['numeric']>;
  position_cost?: InputMaybe<Scalars['numeric']>;
  positions_included?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Service_Tariff_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "service_tariff" */
export type Service_Tariff_Set_Input = {
  direct_upload_cost?: InputMaybe<Scalars['numeric']>;
  email_upload_cost?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  position_cost?: InputMaybe<Scalars['numeric']>;
  positions_included?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
};

export type Service_Tariff_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Service_Tariff_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Service_Tariff_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Service_Tariff_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Service_Tariff_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Service_Tariff_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Service_Tariff_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Service_Tariff_Set_Input>;
  where: Service_Tariff_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Setting_Value_Append_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Setting_Value_Delete_At_Path_Input = {
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Setting_Value_Delete_Elem_Input = {
  value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Setting_Value_Delete_Key_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Setting_Value_Prepend_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "setting_value" */
export type Setting_Value_Set_Input = {
  /** setting_value creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** setting_value creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** id of setting_value. */
  id?: InputMaybe<Scalars['uuid']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
  /** setting_value last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified setting_value. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  reference_id?: InputMaybe<Scalars['String']>;
  reference_type_id?: InputMaybe<Scalars['String']>;
  setting_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** primary key columns input for table: setting_value */
export type Setting_Value_Pk_Columns_Input = {
  /** id of setting_value. */
  id: Scalars['uuid'];
};

export type Setting_Value_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Setting_Value_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Setting_Value_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Setting_Value_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Setting_Value_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Setting_Value_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Setting_Value_Set_Input>;
  where: Setting_Value_Bool_Exp;
};

/** input type for incrementing numeric columns in table "tenant" */
export type Tenant_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "tenant" */
export type Tenant_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  /** tenant creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** tenant creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** id of tenant. */
  id?: InputMaybe<Scalars['uuid']>;
  /** tenant last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified tenant. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  tenant_name?: InputMaybe<Scalars['String']>;
  tenant_type?: InputMaybe<Scalars['tenant_type']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: tenant */
export type Tenant_Pk_Columns_Input = {
  /** id of tenant. */
  id: Scalars['uuid'];
};

export type Tenant_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tenant_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenant_Set_Input>;
  where: Tenant_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Pp_Append_Input = {
  ui_settings?: InputMaybe<Scalars['jsonb']>;
  ui_settings_templates?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Pp_Delete_At_Path_Input = {
  ui_settings?: InputMaybe<Array<Scalars['String']>>;
  ui_settings_templates?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Pp_Delete_Elem_Input = {
  ui_settings?: InputMaybe<Scalars['Int']>;
  ui_settings_templates?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Pp_Delete_Key_Input = {
  ui_settings?: InputMaybe<Scalars['String']>;
  ui_settings_templates?: InputMaybe<Scalars['String']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Pp_Prepend_Input = {
  ui_settings?: InputMaybe<Scalars['jsonb']>;
  ui_settings_templates?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "user_pp" */
export type User_Pp_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  /** User creation date */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** user_pp creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_by_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  /** id of user_pp. */
  id?: InputMaybe<Scalars['uuid']>;
  /** user_pp last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified user_pp. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  ldap_entry_dn?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  oauth_id?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  /** Tenant of user_pp. */
  tenant_id?: InputMaybe<Scalars['uuid']>;
  ui_settings?: InputMaybe<Scalars['jsonb']>;
  ui_settings_templates?: InputMaybe<Scalars['jsonb']>;
  user_type?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: user_pp */
export type User_Pp_Pk_Columns_Input = {
  /** id of user_pp. */
  id: Scalars['uuid'];
};

export type User_Pp_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Pp_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Pp_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Pp_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Pp_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Pp_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Pp_Set_Input>;
  where: User_Pp_Bool_Exp;
};

export type ReassignFileNumberResponse = {
  file_id: Maybe<Scalars['ID']>;
  file_status: Maybe<Scalars['String']>;
  identification: Maybe<Scalars['String']>;
};

export type UpdatePasswordDto = {
  id: Scalars['String'];
  newPassword: Scalars['PASSWORD_REGEX'];
  oldPassword: Scalars['String'];
};

export type WdUpdateUserDto = {
  externalAuthProvider?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type AddressUpsertArgs = {
  evvAddress: UpsertAddressInputAcs;
  lbaseReference: Scalars['String'];
};

export type UpsertAddressInputAcs = {
  additionalValues?: InputMaybe<Scalars['JSON']>;
  city: Scalars['String'];
  companyEmail?: InputMaybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyName2: Scalars['String'];
  companyPhone?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  customsAccountNumber?: InputMaybe<Scalars['String']>;
  errorEmailAddress?: InputMaybe<Scalars['String']>;
  isLocked?: InputMaybe<Scalars['Boolean']>;
  status: Scalars['Int'];
  street: Scalars['String'];
  traderIdentificationNumber?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  vatAccountNumber?: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
};

export type ValidateFileNumberResponse = {
  data: Maybe<ShipmentData>;
  error_code: Maybe<Scalars['String']>;
  error_description: Maybe<Scalars['String']>;
};

export type ShipmentData = {
  consignee: Maybe<ShipmentInfoAddress>;
  consignor: Maybe<ShipmentInfoAddress>;
  importer: Maybe<ShipmentInfoAddress>;
  lines: Maybe<Array<Maybe<Line>>>;
  orderedBy: Maybe<ShipmentInfoAddress>;
  orgId: Maybe<Scalars['String']>;
  shipmentNumber: Maybe<Scalars['String']>;
  shipper: Maybe<ShipmentInfoAddress>;
  traffic: Maybe<Scalars['String']>;
};

export type ShipmentInfoAddress = {
  adrID: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  consigneeAdrID: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
};

export type Line = {
  grossWeight: Maybe<Scalars['String']>;
  packaging: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['String']>;
};

export type ValidateJourneyNumberResponse = {
  data: Maybe<Scalars['JSON']>;
  error_code: Maybe<Scalars['String']>;
  error_description: Maybe<Scalars['String']>;
};

export type Subscription_Root = {
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk: Maybe<Address>;
  /** fetch data from the table: "address_group" */
  address_group: Array<Address_Group>;
  /** fetch data from the table: "address_group" using primary key columns */
  address_group_by_pk: Maybe<Address_Group>;
  /** fetch data from the table in a streaming manner: "address_group" */
  address_group_stream: Array<Address_Group>;
  /** fetch data from the table: "address_groups" */
  address_groups: Array<Address_Groups>;
  /** fetch data from the table in a streaming manner: "address_groups" */
  address_groups_stream: Array<Address_Groups>;
  /** fetch data from the table: "address_mapping" */
  address_mapping: Array<Address_Mapping>;
  /** fetch data from the table: "address_mapping" using primary key columns */
  address_mapping_by_pk: Maybe<Address_Mapping>;
  /** fetch data from the table in a streaming manner: "address_mapping" */
  address_mapping_stream: Array<Address_Mapping>;
  /** fetch data from the table: "address_override" */
  address_override: Array<Address_Override>;
  /** fetch data from the table: "address_override" using primary key columns */
  address_override_by_pk: Maybe<Address_Override>;
  /** fetch data from the table in a streaming manner: "address_override" */
  address_override_stream: Array<Address_Override>;
  /** fetch data from the table in a streaming manner: "address" */
  address_stream: Array<Address>;
  /** fetch data from the table: "address_type" */
  address_type: Array<Address_Type>;
  /** fetch data from the table: "address_type" using primary key columns */
  address_type_by_pk: Maybe<Address_Type>;
  /** fetch data from the table in a streaming manner: "address_type" */
  address_type_stream: Array<Address_Type>;
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch data from the table in a streaming manner: "addresses" */
  addresses_stream: Array<Addresses>;
  /** fetch data from the table: "ai_stats_dt_type" */
  ai_stats_dt_type: Array<Ai_Stats_Dt_Type>;
  /** fetch data from the table in a streaming manner: "ai_stats_dt_type" */
  ai_stats_dt_type_stream: Array<Ai_Stats_Dt_Type>;
  /** fetch data from the table: "ai_stats_type" */
  ai_stats_type: Array<Ai_Stats_Type>;
  /** fetch data from the table in a streaming manner: "ai_stats_type" */
  ai_stats_type_stream: Array<Ai_Stats_Type>;
  /** fetch data from the table: "annotation_provider" */
  annotation_provider: Array<Annotation_Provider>;
  /** fetch data from the table: "annotation_provider" using primary key columns */
  annotation_provider_by_pk: Maybe<Annotation_Provider>;
  /** fetch data from the table in a streaming manner: "annotation_provider" */
  annotation_provider_stream: Array<Annotation_Provider>;
  /** fetch data from the table: "annotation_type" */
  annotation_type: Array<Annotation_Type>;
  /** fetch data from the table: "annotation_type" using primary key columns */
  annotation_type_by_pk: Maybe<Annotation_Type>;
  /** fetch data from the table in a streaming manner: "annotation_type" */
  annotation_type_stream: Array<Annotation_Type>;
  /** fetch data from the table: "api_key" */
  api_key: Array<Api_Key>;
  /** fetch data from the table: "api_key" using primary key columns */
  api_key_by_pk: Maybe<Api_Key>;
  /** fetch data from the table in a streaming manner: "api_key" */
  api_key_stream: Array<Api_Key>;
  /** fetch data from the table: "arrival_type" */
  arrival_type: Array<Arrival_Type>;
  /** fetch data from the table: "arrival_type" using primary key columns */
  arrival_type_by_pk: Maybe<Arrival_Type>;
  /** fetch data from the table in a streaming manner: "arrival_type" */
  arrival_type_stream: Array<Arrival_Type>;
  /** fetch data from the table: "article" */
  article: Array<Article>;
  /** fetch data from the table: "article" using primary key columns */
  article_by_pk: Maybe<Article>;
  /** fetch data from the table in a streaming manner: "article" */
  article_stream: Array<Article>;
  /** fetch data from the table: "bill" */
  bill: Array<Bill>;
  /** fetch aggregated fields from the table: "bill" */
  bill_aggregate: Bill_Aggregate;
  /** fetch data from the table: "bill" using primary key columns */
  bill_by_pk: Maybe<Bill>;
  /** fetch data from the table: "bill_detail" */
  bill_detail: Array<Bill_Detail>;
  /** fetch data from the table: "bill_detail" using primary key columns */
  bill_detail_by_pk: Maybe<Bill_Detail>;
  /** fetch data from the table in a streaming manner: "bill_detail" */
  bill_detail_stream: Array<Bill_Detail>;
  /** fetch data from the table in a streaming manner: "bill" */
  bill_stream: Array<Bill>;
  /** fetch data from the table: "clearance_type" */
  clearance_type: Array<Clearance_Type>;
  /** fetch data from the table: "clearance_type" using primary key columns */
  clearance_type_by_pk: Maybe<Clearance_Type>;
  /** fetch data from the table in a streaming manner: "clearance_type" */
  clearance_type_stream: Array<Clearance_Type>;
  /** An array relationship */
  containers: Array<Containers>;
  /** fetch data from the table: "containers" using primary key columns */
  containers_by_pk: Maybe<Containers>;
  /** fetch data from the table in a streaming manner: "containers" */
  containers_stream: Array<Containers>;
  /** fetch data from the table: "count_type" */
  count_type: Array<Count_Type>;
  /** fetch data from the table in a streaming manner: "count_type" */
  count_type_stream: Array<Count_Type>;
  /** fetch data from the table: "customs_office" */
  customs_office: Array<Customs_Office>;
  /** fetch data from the table: "customs_office" using primary key columns */
  customs_office_by_pk: Maybe<Customs_Office>;
  /** fetch data from the table in a streaming manner: "customs_office" */
  customs_office_stream: Array<Customs_Office>;
  /** fetch data from the table: "customs_offices" */
  customs_offices: Array<Customs_Offices>;
  /** fetch data from the table: "customs_offices" using primary key columns */
  customs_offices_by_pk: Maybe<Customs_Offices>;
  /** fetch data from the table in a streaming manner: "customs_offices" */
  customs_offices_stream: Array<Customs_Offices>;
  /** fetch data from the table: "customs_response_data" */
  customs_response_data: Array<Customs_Response_Data>;
  /** fetch data from the table: "customs_response_data" using primary key columns */
  customs_response_data_by_pk: Maybe<Customs_Response_Data>;
  /** fetch data from the table in a streaming manner: "customs_response_data" */
  customs_response_data_stream: Array<Customs_Response_Data>;
  /** fetch data from the table: "customs_response_decoded" */
  customs_response_decoded: Array<Customs_Response_Decoded>;
  /** fetch data from the table in a streaming manner: "customs_response_decoded" */
  customs_response_decoded_stream: Array<Customs_Response_Decoded>;
  /** An array relationship */
  customs_response_goods_items: Array<Customs_Response_Goods_Items>;
  /** An aggregate relationship */
  customs_response_goods_items_aggregate: Customs_Response_Goods_Items_Aggregate;
  /** fetch data from the table in a streaming manner: "customs_response_goods_items" */
  customs_response_goods_items_stream: Array<Customs_Response_Goods_Items>;
  /** fetch data from the table: "customs_response_summary" */
  customs_response_summary: Array<Customs_Response_Summary>;
  /** fetch data from the table in a streaming manner: "customs_response_summary" */
  customs_response_summary_stream: Array<Customs_Response_Summary>;
  /** fetch data from the table: "declaration" */
  declaration: Array<Declaration>;
  /** fetch data from the table: "declaration" using primary key columns */
  declaration_by_pk: Maybe<Declaration>;
  /** fetch data from the table: "declaration_discussion" */
  declaration_discussion: Array<Declaration_Discussion>;
  /** fetch aggregated fields from the table: "declaration_discussion" */
  declaration_discussion_aggregate: Declaration_Discussion_Aggregate;
  /** fetch data from the table: "declaration_discussion" using primary key columns */
  declaration_discussion_by_pk: Maybe<Declaration_Discussion>;
  /** fetch data from the table in a streaming manner: "declaration_discussion" */
  declaration_discussion_stream: Array<Declaration_Discussion>;
  /** fetch data from the table: "declaration_discussions" */
  declaration_discussions: Array<Declaration_Discussions>;
  /** fetch data from the table in a streaming manner: "declaration_discussions" */
  declaration_discussions_stream: Array<Declaration_Discussions>;
  /** fetch data from the table: "declaration_document" */
  declaration_document: Array<Declaration_Document>;
  /** fetch data from the table: "declaration_document" using primary key columns */
  declaration_document_by_pk: Maybe<Declaration_Document>;
  /** fetch data from the table in a streaming manner: "declaration_document" */
  declaration_document_stream: Array<Declaration_Document>;
  /** An array relationship */
  declaration_labels: Array<Declaration_Labels>;
  /** fetch data from the table: "declaration_labels" using primary key columns */
  declaration_labels_by_pk: Maybe<Declaration_Labels>;
  /** fetch data from the table in a streaming manner: "declaration_labels" */
  declaration_labels_stream: Array<Declaration_Labels>;
  /** fetch data from the table: "declaration_message" */
  declaration_message: Array<Declaration_Message>;
  /** fetch aggregated fields from the table: "declaration_message" */
  declaration_message_aggregate: Declaration_Message_Aggregate;
  /** fetch data from the table: "declaration_message" using primary key columns */
  declaration_message_by_pk: Maybe<Declaration_Message>;
  /** fetch data from the table in a streaming manner: "declaration_message" */
  declaration_message_stream: Array<Declaration_Message>;
  /** fetch data from the table: "declaration_request" */
  declaration_request: Array<Declaration_Request>;
  /** fetch data from the table: "declaration_request_address" */
  declaration_request_address: Array<Declaration_Request_Address>;
  /** fetch data from the table: "declaration_request_address_ai" */
  declaration_request_address_ai: Array<Declaration_Request_Address_Ai>;
  /** fetch data from the table: "declaration_request_address_ai" using primary key columns */
  declaration_request_address_ai_by_pk: Maybe<Declaration_Request_Address_Ai>;
  /** fetch data from the table in a streaming manner: "declaration_request_address_ai" */
  declaration_request_address_ai_stream: Array<Declaration_Request_Address_Ai>;
  /** fetch data from the table: "declaration_request_address" using primary key columns */
  declaration_request_address_by_pk: Maybe<Declaration_Request_Address>;
  /** fetch data from the table in a streaming manner: "declaration_request_address" */
  declaration_request_address_stream: Array<Declaration_Request_Address>;
  /** fetch data from the table: "declaration_request" using primary key columns */
  declaration_request_by_pk: Maybe<Declaration_Request>;
  /** An array relationship */
  declaration_request_labels: Array<Declaration_Request_Labels>;
  /** fetch data from the table: "declaration_request_labels" using primary key columns */
  declaration_request_labels_by_pk: Maybe<Declaration_Request_Labels>;
  /** fetch data from the table in a streaming manner: "declaration_request_labels" */
  declaration_request_labels_stream: Array<Declaration_Request_Labels>;
  /** fetch data from the table in a streaming manner: "declaration_request" */
  declaration_request_stream: Array<Declaration_Request>;
  /** fetch data from the table: "declaration_requests" */
  declaration_requests: Array<Declaration_Requests>;
  /** fetch data from the table in a streaming manner: "declaration_requests" */
  declaration_requests_stream: Array<Declaration_Requests>;
  /** fetch data from the table: "declaration_search" */
  declaration_search: Array<Declaration_Search>;
  /** fetch data from the table in a streaming manner: "declaration_search" */
  declaration_search_stream: Array<Declaration_Search>;
  /** An array relationship */
  declaration_special_mentions: Array<Declaration_Special_Mentions>;
  /** fetch data from the table: "declaration_special_mentions" using primary key columns */
  declaration_special_mentions_by_pk: Maybe<Declaration_Special_Mentions>;
  /** fetch data from the table in a streaming manner: "declaration_special_mentions" */
  declaration_special_mentions_stream: Array<Declaration_Special_Mentions>;
  /** fetch data from the table: "declaration_status" */
  declaration_status: Array<Declaration_Status>;
  /** fetch data from the table: "declaration_status" using primary key columns */
  declaration_status_by_pk: Maybe<Declaration_Status>;
  /** fetch data from the table in a streaming manner: "declaration_status" */
  declaration_status_stream: Array<Declaration_Status>;
  /** fetch data from the table in a streaming manner: "declaration" */
  declaration_stream: Array<Declaration>;
  /** fetch data from the table: "declaration_task" */
  declaration_task: Array<Declaration_Task>;
  /** fetch aggregated fields from the table: "declaration_task" */
  declaration_task_aggregate: Declaration_Task_Aggregate;
  /** fetch data from the table: "declaration_task" using primary key columns */
  declaration_task_by_pk: Maybe<Declaration_Task>;
  /** fetch data from the table in a streaming manner: "declaration_task" */
  declaration_task_stream: Array<Declaration_Task>;
  /** fetch data from the table: "declaration_tasks" */
  declaration_tasks: Array<Declaration_Tasks>;
  /** fetch data from the table: "declaration_tasks_obj" */
  declaration_tasks_obj: Array<Declaration_Tasks_Obj>;
  /** fetch data from the table in a streaming manner: "declaration_tasks_obj" */
  declaration_tasks_obj_stream: Array<Declaration_Tasks_Obj>;
  /** fetch data from the table in a streaming manner: "declaration_tasks" */
  declaration_tasks_stream: Array<Declaration_Tasks>;
  /** fetch data from the table: "declaration_type" */
  declaration_type: Array<Declaration_Type>;
  /** fetch data from the table: "declaration_type" using primary key columns */
  declaration_type_by_pk: Maybe<Declaration_Type>;
  /** fetch data from the table in a streaming manner: "declaration_type" */
  declaration_type_stream: Array<Declaration_Type>;
  /** fetch data from the table: "discussion_changes" */
  discussion_changes: Array<Discussion_Changes>;
  /** fetch data from the table in a streaming manner: "discussion_changes" */
  discussion_changes_stream: Array<Discussion_Changes>;
  /** fetch data from the table: "doc_annotation" */
  doc_annotation: Array<Doc_Annotation>;
  /** fetch data from the table: "doc_annotation" using primary key columns */
  doc_annotation_by_pk: Maybe<Doc_Annotation>;
  /** fetch data from the table in a streaming manner: "doc_annotation" */
  doc_annotation_stream: Array<Doc_Annotation>;
  /** fetch data from the table: "doc_search_type" */
  doc_search_type: Array<Doc_Search_Type>;
  /** fetch data from the table in a streaming manner: "doc_search_type" */
  doc_search_type_stream: Array<Doc_Search_Type>;
  /** fetch data from the table: "doc_stats_type" */
  doc_stats_type: Array<Doc_Stats_Type>;
  /** fetch data from the table in a streaming manner: "doc_stats_type" */
  doc_stats_type_stream: Array<Doc_Stats_Type>;
  /** fetch data from the table: "docs_for_validation" */
  docs_for_validation: Array<Docs_For_Validation>;
  /** fetch data from the table in a streaming manner: "docs_for_validation" */
  docs_for_validation_stream: Array<Docs_For_Validation>;
  /** fetch data from the table: "document" */
  document: Array<Document>;
  /** fetch aggregated fields from the table: "document" */
  document_aggregate: Document_Aggregate;
  /** fetch data from the table: "document" using primary key columns */
  document_by_pk: Maybe<Document>;
  /** fetch data from the table: "document_extension" */
  document_extension: Array<Document_Extension>;
  /** fetch data from the table: "document_extension" using primary key columns */
  document_extension_by_pk: Maybe<Document_Extension>;
  /** fetch data from the table in a streaming manner: "document_extension" */
  document_extension_stream: Array<Document_Extension>;
  /** fetch data from the table: "document_flag" */
  document_flag: Array<Document_Flag>;
  /** fetch data from the table: "document_flag" using primary key columns */
  document_flag_by_pk: Maybe<Document_Flag>;
  /** fetch data from the table in a streaming manner: "document_flag" */
  document_flag_stream: Array<Document_Flag>;
  /** execute function "document_is_allowed" which returns "document" */
  document_is_allowed: Array<Document>;
  /** execute function "document_is_allowed" and query aggregates on result of table type "document" */
  document_is_allowed_aggregate: Document_Aggregate;
  /** fetch data from the table: "document_label_org_id" */
  document_label_org_id: Array<Document_Label_Org_Id>;
  /** fetch data from the table: "document_label_org_id" using primary key columns */
  document_label_org_id_by_pk: Maybe<Document_Label_Org_Id>;
  /** fetch data from the table in a streaming manner: "document_label_org_id" */
  document_label_org_id_stream: Array<Document_Label_Org_Id>;
  /** An array relationship */
  document_labels: Array<Document_Labels>;
  /** fetch data from the table: "document_labels" using primary key columns */
  document_labels_by_pk: Maybe<Document_Labels>;
  /** fetch data from the table in a streaming manner: "document_labels" */
  document_labels_stream: Array<Document_Labels>;
  /** fetch data from the table: "document_page" */
  document_page: Array<Document_Page>;
  /** fetch aggregated fields from the table: "document_page" */
  document_page_aggregate: Document_Page_Aggregate;
  /** fetch data from the table: "document_page" using primary key columns */
  document_page_by_pk: Maybe<Document_Page>;
  /** fetch data from the table in a streaming manner: "document_page" */
  document_page_stream: Array<Document_Page>;
  /** fetch data from the table: "document_status" */
  document_status: Array<Document_Status>;
  /** fetch data from the table: "document_status" using primary key columns */
  document_status_by_pk: Maybe<Document_Status>;
  /** fetch data from the table in a streaming manner: "document_status" */
  document_status_stream: Array<Document_Status>;
  /** fetch data from the table in a streaming manner: "document" */
  document_stream: Array<Document>;
  /** fetch data from the table: "document_type" */
  document_type: Array<Document_Type>;
  /** fetch aggregated fields from the table: "document_type" */
  document_type_aggregate: Document_Type_Aggregate;
  /** An array relationship */
  document_type_all_tenant_settings: Array<Document_Type_All_Tenant_Settings>;
  /** fetch data from the table in a streaming manner: "document_type_all_tenant_settings" */
  document_type_all_tenant_settings_stream: Array<Document_Type_All_Tenant_Settings>;
  /** fetch data from the table: "document_type" using primary key columns */
  document_type_by_pk: Maybe<Document_Type>;
  /** fetch data from the table in a streaming manner: "document_type" */
  document_type_stream: Array<Document_Type>;
  /** An array relationship */
  document_type_tenant_settings: Array<Document_Type_Tenant_Settings>;
  /** fetch data from the table: "document_type_tenant_settings" using primary key columns */
  document_type_tenant_settings_by_pk: Maybe<Document_Type_Tenant_Settings>;
  /** fetch data from the table in a streaming manner: "document_type_tenant_settings" */
  document_type_tenant_settings_stream: Array<Document_Type_Tenant_Settings>;
  /** fetch data from the table: "dr_goods_item" */
  dr_goods_item: Array<Dr_Goods_Item>;
  /** fetch aggregated fields from the table: "dr_goods_item" */
  dr_goods_item_aggregate: Dr_Goods_Item_Aggregate;
  /** fetch data from the table: "dr_goods_item" using primary key columns */
  dr_goods_item_by_pk: Maybe<Dr_Goods_Item>;
  /** fetch data from the table in a streaming manner: "dr_goods_item" */
  dr_goods_item_stream: Array<Dr_Goods_Item>;
  /** fetch data from the table: "dr_goods_items" */
  dr_goods_items: Array<Dr_Goods_Items>;
  /** fetch data from the table in a streaming manner: "dr_goods_items" */
  dr_goods_items_stream: Array<Dr_Goods_Items>;
  /** fetch data from the table: "dr_stats" */
  dr_stats: Array<Dr_Stats>;
  /** fetch data from the table in a streaming manner: "dr_stats" */
  dr_stats_stream: Array<Dr_Stats>;
  /** fetch data from the table: "edec_countries" */
  edec_countries: Array<Edec_Countries>;
  /** fetch data from the table: "edec_countries" using primary key columns */
  edec_countries_by_pk: Maybe<Edec_Countries>;
  /** fetch data from the table in a streaming manner: "edec_countries" */
  edec_countries_stream: Array<Edec_Countries>;
  /** fetch data from the table: "edec_customs_offices" */
  edec_customs_offices: Array<Edec_Customs_Offices>;
  /** fetch data from the table: "edec_customs_offices" using primary key columns */
  edec_customs_offices_by_pk: Maybe<Edec_Customs_Offices>;
  /** fetch data from the table in a streaming manner: "edec_customs_offices" */
  edec_customs_offices_stream: Array<Edec_Customs_Offices>;
  /** fetch data from the table: "edec_domains" */
  edec_domains: Array<Edec_Domains>;
  /** fetch data from the table: "edec_domains" using primary key columns */
  edec_domains_by_pk: Maybe<Edec_Domains>;
  /** fetch data from the table in a streaming manner: "edec_domains" */
  edec_domains_stream: Array<Edec_Domains>;
  /** fetch data from the table: "edec_tariff_commodity_code" */
  edec_tariff_commodity_code: Array<Edec_Tariff_Commodity_Code>;
  /** fetch data from the table: "edec_tariff_commodity_code" using primary key columns */
  edec_tariff_commodity_code_by_pk: Maybe<Edec_Tariff_Commodity_Code>;
  /** fetch data from the table in a streaming manner: "edec_tariff_commodity_code" */
  edec_tariff_commodity_code_stream: Array<Edec_Tariff_Commodity_Code>;
  /** fetch data from the table: "edec_tariff_statistical_code" */
  edec_tariff_statistical_code: Array<Edec_Tariff_Statistical_Code>;
  /** fetch data from the table: "edec_tariff_statistical_code" using primary key columns */
  edec_tariff_statistical_code_by_pk: Maybe<Edec_Tariff_Statistical_Code>;
  /** fetch data from the table in a streaming manner: "edec_tariff_statistical_code" */
  edec_tariff_statistical_code_stream: Array<Edec_Tariff_Statistical_Code>;
  /** fetch data from the table: "email_search_type" */
  email_search_type: Array<Email_Search_Type>;
  /** fetch aggregated fields from the table: "email_search_type" */
  email_search_type_aggregate: Email_Search_Type_Aggregate;
  /** fetch data from the table in a streaming manner: "email_search_type" */
  email_search_type_stream: Array<Email_Search_Type>;
  /** fetch data from the table: "extract_type" */
  extract_type: Array<Extract_Type>;
  /** fetch data from the table: "extract_type" using primary key columns */
  extract_type_by_pk: Maybe<Extract_Type>;
  /** fetch data from the table in a streaming manner: "extract_type" */
  extract_type_stream: Array<Extract_Type>;
  /** fetch data from the table: "extraction_config" */
  extraction_config: Array<Extraction_Config>;
  /** fetch data from the table: "extraction_config" using primary key columns */
  extraction_config_by_pk: Maybe<Extraction_Config>;
  /** fetch data from the table in a streaming manner: "extraction_config" */
  extraction_config_stream: Array<Extraction_Config>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "file" */
  file_aggregate: File_Aggregate;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk: Maybe<File>;
  /** fetch data from the table: "file_stats_type" */
  file_stats_type: Array<File_Stats_Type>;
  /** fetch data from the table in a streaming manner: "file_stats_type" */
  file_stats_type_stream: Array<File_Stats_Type>;
  /** fetch data from the table in a streaming manner: "file" */
  file_stream: Array<File>;
  /** fetch data from the table: "file_type" */
  file_type: Array<File_Type>;
  /** fetch data from the table: "file_type" using primary key columns */
  file_type_by_pk: Maybe<File_Type>;
  /** fetch data from the table in a streaming manner: "file_type" */
  file_type_stream: Array<File_Type>;
  /** fetch data from the table: "goods_item" */
  goods_item: Array<Goods_Item>;
  /** fetch aggregated fields from the table: "goods_item" */
  goods_item_aggregate: Goods_Item_Aggregate;
  /** fetch data from the table: "goods_item" using primary key columns */
  goods_item_by_pk: Maybe<Goods_Item>;
  /** An array relationship */
  goods_item_special_mentions: Array<Goods_Item_Special_Mentions>;
  /** An aggregate relationship */
  goods_item_special_mentions_aggregate: Goods_Item_Special_Mentions_Aggregate;
  /** fetch data from the table: "goods_item_special_mentions" using primary key columns */
  goods_item_special_mentions_by_pk: Maybe<Goods_Item_Special_Mentions>;
  /** fetch data from the table in a streaming manner: "goods_item_special_mentions" */
  goods_item_special_mentions_stream: Array<Goods_Item_Special_Mentions>;
  /** fetch data from the table in a streaming manner: "goods_item" */
  goods_item_stream: Array<Goods_Item>;
  /** fetch data from the table: "goods_items_for_drs" */
  goods_items_for_drs: Array<Goods_Items_For_Drs>;
  /** fetch data from the table in a streaming manner: "goods_items_for_drs" */
  goods_items_for_drs_stream: Array<Goods_Items_For_Drs>;
  /** fetch data from the table: "group_member" */
  group_member: Array<Group_Member>;
  /** fetch data from the table: "group_member" using primary key columns */
  group_member_by_pk: Maybe<Group_Member>;
  /** fetch data from the table in a streaming manner: "group_member" */
  group_member_stream: Array<Group_Member>;
  /** fetch data from the table: "group_members" */
  group_members: Array<Group_Members>;
  /** fetch data from the table in a streaming manner: "group_members" */
  group_members_stream: Array<Group_Members>;
  /** fetch data from the table: "import_list_trigger" */
  import_list_trigger: Array<Import_List_Trigger>;
  /** fetch aggregated fields from the table: "import_list_trigger" */
  import_list_trigger_aggregate: Import_List_Trigger_Aggregate;
  /** fetch data from the table: "import_list_trigger" using primary key columns */
  import_list_trigger_by_pk: Maybe<Import_List_Trigger>;
  /** fetch data from the table in a streaming manner: "import_list_trigger" */
  import_list_trigger_stream: Array<Import_List_Trigger>;
  /** fetch data from the table: "intf.dr_payment_info" */
  intf_dr_payment_info: Array<Intf_Dr_Payment_Info>;
  /** fetch data from the table in a streaming manner: "intf.dr_payment_info" */
  intf_dr_payment_info_stream: Array<Intf_Dr_Payment_Info>;
  /** fetch data from the table: "json_type" */
  json_type: Array<Json_Type>;
  /** fetch data from the table in a streaming manner: "json_type" */
  json_type_stream: Array<Json_Type>;
  /** fetch data from the table: "kc_users" */
  kc_users: Array<Kc_Users>;
  /** fetch data from the table in a streaming manner: "kc_users" */
  kc_users_stream: Array<Kc_Users>;
  /** fetch data from the table: "max_date_type" */
  max_date_type: Array<Max_Date_Type>;
  /** fetch data from the table in a streaming manner: "max_date_type" */
  max_date_type_stream: Array<Max_Date_Type>;
  /** fetch data from the table: "model_retrain" */
  model_retrain: Array<Model_Retrain>;
  /** fetch data from the table: "model_retrain" using primary key columns */
  model_retrain_by_pk: Maybe<Model_Retrain>;
  /** fetch data from the table in a streaming manner: "model_retrain" */
  model_retrain_stream: Array<Model_Retrain>;
  /** fetch data from the table: "org_id" */
  org_id: Array<Org_Id>;
  /** fetch data from the table: "org_id" using primary key columns */
  org_id_by_pk: Maybe<Org_Id>;
  /** fetch data from the table in a streaming manner: "org_id" */
  org_id_stream: Array<Org_Id>;
  /** fetch data from the table: "org_ids" */
  org_ids: Array<Org_Ids>;
  /** fetch data from the table in a streaming manner: "org_ids" */
  org_ids_stream: Array<Org_Ids>;
  /** fetch data from the table: "org_params" */
  org_params: Array<Org_Params>;
  /** fetch data from the table: "org_params" using primary key columns */
  org_params_by_pk: Maybe<Org_Params>;
  /** fetch data from the table: "org_params_org_id" */
  org_params_org_id: Array<Org_Params_Org_Id>;
  /** fetch data from the table in a streaming manner: "org_params_org_id" */
  org_params_org_id_stream: Array<Org_Params_Org_Id>;
  /** fetch data from the table in a streaming manner: "org_params" */
  org_params_stream: Array<Org_Params>;
  /** An array relationship */
  packagings: Array<Packagings>;
  /** An aggregate relationship */
  packagings_aggregate: Packagings_Aggregate;
  /** fetch data from the table: "packagings" using primary key columns */
  packagings_by_pk: Maybe<Packagings>;
  /** fetch data from the table in a streaming manner: "packagings" */
  packagings_stream: Array<Packagings>;
  /** fetch data from the table: "page" */
  page: Array<Page>;
  /** fetch data from the table: "page" using primary key columns */
  page_by_pk: Maybe<Page>;
  /** fetch data from the table: "page_extract" */
  page_extract: Array<Page_Extract>;
  /** fetch data from the table: "page_extract" using primary key columns */
  page_extract_by_pk: Maybe<Page_Extract>;
  /** fetch data from the table in a streaming manner: "page_extract" */
  page_extract_stream: Array<Page_Extract>;
  /** fetch data from the table: "page_status" */
  page_status: Array<Page_Status>;
  /** fetch data from the table: "page_status" using primary key columns */
  page_status_by_pk: Maybe<Page_Status>;
  /** fetch data from the table in a streaming manner: "page_status" */
  page_status_stream: Array<Page_Status>;
  /** fetch data from the table in a streaming manner: "page" */
  page_stream: Array<Page>;
  /** fetch data from the table: "pages_m2m_cache" */
  pages_m2m_cache: Array<Pages_M2m_Cache>;
  /** fetch aggregated fields from the table: "pages_m2m_cache" */
  pages_m2m_cache_aggregate: Pages_M2m_Cache_Aggregate;
  /** fetch data from the table in a streaming manner: "pages_m2m_cache" */
  pages_m2m_cache_stream: Array<Pages_M2m_Cache>;
  /** An array relationship */
  permits: Array<Permits>;
  /** An aggregate relationship */
  permits_aggregate: Permits_Aggregate;
  /** fetch data from the table: "permits" using primary key columns */
  permits_by_pk: Maybe<Permits>;
  /** fetch data from the table in a streaming manner: "permits" */
  permits_stream: Array<Permits>;
  /** execute function "pp_address_groups" which returns "address_groups" */
  pp_address_groups: Array<Address_Groups>;
  /** execute function "pp_addresses" which returns "addresses" */
  pp_addresses: Array<Addresses>;
  /** execute function "pp_addresses_by_payer_address" which returns "addresses" */
  pp_addresses_by_payer_address: Array<Addresses>;
  /** execute function "pp_addresses_by_payer_id" which returns "addresses" */
  pp_addresses_by_payer_id: Array<Addresses>;
  /** execute function "pp_ai_stats" which returns "ai_stats_type" */
  pp_ai_stats: Array<Ai_Stats_Type>;
  /** execute function "pp_ai_stats_dt" which returns "ai_stats_dt_type" */
  pp_ai_stats_dt: Array<Ai_Stats_Dt_Type>;
  /** execute function "pp_check_json_param" which returns "json_type" */
  pp_check_json_param: Array<Json_Type>;
  /** execute function "pp_customs_response_summary" which returns "customs_response_summary" */
  pp_customs_response_summary: Array<Customs_Response_Summary>;
  /** execute function "pp_declaration_request" which returns "declaration_request" */
  pp_declaration_request: Array<Declaration_Request>;
  /** execute function "pp_declaration_tasks" which returns "declaration_tasks" */
  pp_declaration_tasks: Array<Declaration_Tasks>;
  /** execute function "pp_declaration_tasks_agg" which returns "json_type" */
  pp_declaration_tasks_agg: Maybe<Json_Type>;
  /** execute function "pp_declaration_tasks_obj" which returns "declaration_tasks_obj" */
  pp_declaration_tasks_obj: Maybe<Declaration_Tasks_Obj>;
  /** execute function "pp_declarations" which returns "declaration_search" */
  pp_declarations: Array<Declaration_Search>;
  /** execute function "pp_delete_declaration_requests" which returns "json_type" */
  pp_delete_declaration_requests: Array<Json_Type>;
  /** execute function "pp_doc_max_date_hs" which returns "max_date_type" */
  pp_doc_max_date_hs: Array<Max_Date_Type>;
  /** execute function "pp_doc_max_date_v2" which returns "max_date_type" */
  pp_doc_max_date_v2: Array<Max_Date_Type>;
  /** execute function "pp_doc_search" which returns "doc_search_type" */
  pp_doc_search: Array<Doc_Search_Type>;
  /** execute function "pp_doc_search_hs" which returns "doc_search_type" */
  pp_doc_search_hs: Array<Doc_Search_Type>;
  /** execute function "pp_doc_stats" which returns "doc_stats_type" */
  pp_doc_stats: Array<Doc_Stats_Type>;
  /** execute function "pp_docs_for_validation" which returns "docs_for_validation" */
  pp_docs_for_validation: Array<Docs_For_Validation>;
  /** execute function "pp_document" which returns "document" */
  pp_document: Array<Document>;
  /** execute function "pp_document" and query aggregates on result of table type "document" */
  pp_document_aggregate: Document_Aggregate;
  /** execute function "pp_document_flag" which returns "document_flag" */
  pp_document_flag: Array<Document_Flag>;
  /** execute function "pp_document_labels" which returns "document_labels" */
  pp_document_labels: Array<Document_Labels>;
  /** execute function "pp_dr_goods_items" which returns "dr_goods_items" */
  pp_dr_goods_items: Array<Dr_Goods_Items>;
  /** execute function "pp_dr_max_date" which returns "max_date_type" */
  pp_dr_max_date: Array<Max_Date_Type>;
  /** execute function "pp_dr_stats" which returns "dr_stats" */
  pp_dr_stats: Array<Dr_Stats>;
  /** execute function "pp_email_search" which returns "email_search_type" */
  pp_email_search: Array<Email_Search_Type>;
  /** execute function "pp_email_search" and query aggregates on result of table type "email_search_type" */
  pp_email_search_aggregate: Email_Search_Type_Aggregate;
  /** execute function "pp_email_search_hs" which returns "email_search_type" */
  pp_email_search_hs: Array<Email_Search_Type>;
  /** execute function "pp_email_search_hs" and query aggregates on result of table type "email_search_type" */
  pp_email_search_hs_aggregate: Email_Search_Type_Aggregate;
  /** execute function "pp_file_max_date_hs" which returns "max_date_type" */
  pp_file_max_date_hs: Array<Max_Date_Type>;
  /** execute function "pp_file_max_date_v2" which returns "max_date_type" */
  pp_file_max_date_v2: Array<Max_Date_Type>;
  /** execute function "pp_file_search" which returns "pp_types.file_search" */
  pp_file_search: Array<Pp_Types_File_Search>;
  /** execute function "pp_file_search_hs" which returns "pp_types.file_search" */
  pp_file_search_hs: Array<Pp_Types_File_Search>;
  /** execute function "pp_file_stats" which returns "file_stats_type" */
  pp_file_stats: Array<File_Stats_Type>;
  /** execute function "pp_get_wd_perms_for_dr" which returns "json_type" */
  pp_get_wd_perms_for_dr: Array<Json_Type>;
  /** execute function "pp_group_members" which returns "group_members" */
  pp_group_members: Array<Group_Members>;
  /** execute function "pp_hasura_session" which returns "json_type" */
  pp_hasura_session: Array<Json_Type>;
  /** execute function "pp_kc_users" which returns "kc_users" */
  pp_kc_users: Array<Kc_Users>;
  /** execute function "pp_last_doc_in_dr" which returns "document" */
  pp_last_doc_in_dr: Array<Document>;
  /** execute function "pp_last_doc_in_dr" and query aggregates on result of table type "document" */
  pp_last_doc_in_dr_aggregate: Document_Aggregate;
  /** execute function "pp_menu_indicators" which returns "json_type" */
  pp_menu_indicators: Array<Json_Type>;
  /** execute function "pp_org_id_delete" which returns "json_type" */
  pp_org_id_delete: Array<Json_Type>;
  /** execute function "pp_org_id_insert" which returns "json_type" */
  pp_org_id_insert: Array<Json_Type>;
  /** execute function "pp_org_id_update" which returns "json_type" */
  pp_org_id_update: Array<Json_Type>;
  /** execute function "pp_org_ids" which returns "org_ids" */
  pp_org_ids: Array<Org_Ids>;
  /** execute function "pp_page_extract_grids_text" which returns "json_type" */
  pp_page_extract_grids_text: Array<Json_Type>;
  /** execute function "pp_page_extract_text_fragment" which returns "json_type" */
  pp_page_extract_text_fragment: Array<Json_Type>;
  /** execute function "pp_page_extract_text_fragment_v2" which returns "json_type" */
  pp_page_extract_text_fragment_v2: Array<Json_Type>;
  /** execute function "pp_tenants" which returns "tenants" */
  pp_tenants: Array<Tenants>;
  /** fetch data from the table: "pp_types.file_search" */
  pp_types_file_search: Array<Pp_Types_File_Search>;
  /** fetch data from the table in a streaming manner: "pp_types.file_search" */
  pp_types_file_search_stream: Array<Pp_Types_File_Search>;
  /** execute function "pp_user_org_id" which returns "user_org_id" */
  pp_user_org_id: Array<User_Org_Id>;
  /** execute function "pp_user_search" which returns "user_search_type" */
  pp_user_search: Array<User_Search_Type>;
  /** execute function "pp_users" which returns "users" */
  pp_users: Array<Users>;
  /** execute function "pp_view_document_history" which returns "view_document_history" */
  pp_view_document_history: Array<View_Document_History>;
  /** execute function "pp_view_file_history" which returns "view_file_history" */
  pp_view_file_history: Array<View_File_History>;
  /** An array relationship */
  previous_documents: Array<Previous_Documents>;
  /** fetch data from the table: "previous_documents" using primary key columns */
  previous_documents_by_pk: Maybe<Previous_Documents>;
  /** fetch data from the table in a streaming manner: "previous_documents" */
  previous_documents_stream: Array<Previous_Documents>;
  /** An array relationship */
  produced_documents: Array<Produced_Documents>;
  /** An aggregate relationship */
  produced_documents_aggregate: Produced_Documents_Aggregate;
  /** fetch data from the table: "produced_documents" using primary key columns */
  produced_documents_by_pk: Maybe<Produced_Documents>;
  /** fetch data from the table in a streaming manner: "produced_documents" */
  produced_documents_stream: Array<Produced_Documents>;
  /** fetch data from the table: "report" */
  report: Array<Report>;
  /** fetch aggregated fields from the table: "report" */
  report_aggregate: Report_Aggregate;
  /** fetch data from the table: "report" using primary key columns */
  report_by_pk: Maybe<Report>;
  /** fetch data from the table in a streaming manner: "report" */
  report_stream: Array<Report>;
  /** fetch data from the table: "service" */
  service: Array<Service>;
  /** fetch data from the table: "service" using primary key columns */
  service_by_pk: Maybe<Service>;
  /** fetch data from the table: "service_rate" */
  service_rate: Array<Service_Rate>;
  /** fetch data from the table in a streaming manner: "service_rate" */
  service_rate_stream: Array<Service_Rate>;
  /** fetch data from the table in a streaming manner: "service" */
  service_stream: Array<Service>;
  /** fetch data from the table: "service_tariff" */
  service_tariff: Array<Service_Tariff>;
  /** fetch aggregated fields from the table: "service_tariff" */
  service_tariff_aggregate: Service_Tariff_Aggregate;
  /** fetch data from the table in a streaming manner: "service_tariff" */
  service_tariff_stream: Array<Service_Tariff>;
  /** fetch data from the table: "setting" */
  setting: Array<Setting>;
  /** fetch data from the table: "setting" using primary key columns */
  setting_by_pk: Maybe<Setting>;
  /** fetch data from the table: "setting_group" */
  setting_group: Array<Setting_Group>;
  /** fetch data from the table: "setting_group" using primary key columns */
  setting_group_by_pk: Maybe<Setting_Group>;
  /** fetch data from the table in a streaming manner: "setting_group" */
  setting_group_stream: Array<Setting_Group>;
  /** fetch data from the table in a streaming manner: "setting" */
  setting_stream: Array<Setting>;
  /** fetch data from the table: "setting_value" */
  setting_value: Array<Setting_Value>;
  /** fetch data from the table: "setting_value" using primary key columns */
  setting_value_by_pk: Maybe<Setting_Value>;
  /** fetch data from the table in a streaming manner: "setting_value" */
  setting_value_stream: Array<Setting_Value>;
  /** fetch data from the table: "tariff_number_description" */
  tariff_number_description: Array<Tariff_Number_Description>;
  /** fetch data from the table: "tariff_number_description" using primary key columns */
  tariff_number_description_by_pk: Maybe<Tariff_Number_Description>;
  /** fetch data from the table in a streaming manner: "tariff_number_description" */
  tariff_number_description_stream: Array<Tariff_Number_Description>;
  /** fetch data from the table: "task_type" */
  task_type: Array<Task_Type>;
  /** fetch data from the table: "task_type" using primary key columns */
  task_type_by_pk: Maybe<Task_Type>;
  /** fetch data from the table in a streaming manner: "task_type" */
  task_type_stream: Array<Task_Type>;
  /** fetch data from the table: "tenant" */
  tenant: Array<Tenant>;
  /** fetch data from the table: "tenant" using primary key columns */
  tenant_by_pk: Maybe<Tenant>;
  /** fetch data from the table in a streaming manner: "tenant" */
  tenant_stream: Array<Tenant>;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch data from the table in a streaming manner: "tenants" */
  tenants_stream: Array<Tenants>;
  /** fetch data from the table: "transitdoc_type_descr" */
  transitdoc_type_descr: Array<Transitdoc_Type_Descr>;
  /** fetch data from the table in a streaming manner: "transitdoc_type_descr" */
  transitdoc_type_descr_stream: Array<Transitdoc_Type_Descr>;
  /** fetch data from the table: "user_org_id" */
  user_org_id: Array<User_Org_Id>;
  /** fetch data from the table: "user_org_id" using primary key columns */
  user_org_id_by_pk: Maybe<User_Org_Id>;
  /** fetch data from the table in a streaming manner: "user_org_id" */
  user_org_id_stream: Array<User_Org_Id>;
  /** fetch data from the table: "user_pp" */
  user_pp: Array<User_Pp>;
  /** fetch data from the table: "user_pp" using primary key columns */
  user_pp_by_pk: Maybe<User_Pp>;
  /** fetch data from the table in a streaming manner: "user_pp" */
  user_pp_stream: Array<User_Pp>;
  /** fetch data from the table: "user_search_type" */
  user_search_type: Array<User_Search_Type>;
  /** fetch data from the table in a streaming manner: "user_search_type" */
  user_search_type_stream: Array<User_Search_Type>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "view_document_history" */
  view_document_history: Array<View_Document_History>;
  /** fetch data from the table in a streaming manner: "view_document_history" */
  view_document_history_stream: Array<View_Document_History>;
  /** fetch data from the table: "view_file_history" */
  view_file_history: Array<View_File_History>;
  /** fetch data from the table in a streaming manner: "view_file_history" */
  view_file_history_stream: Array<View_File_History>;
  /** fetch data from the table: "view_history" */
  view_history: Array<View_History>;
  /** fetch data from the table in a streaming manner: "view_history" */
  view_history_stream: Array<View_History>;
  /** fetch data from the table: "vw_documents" */
  vw_documents: Array<Vw_Documents>;
  /** fetch data from the table in a streaming manner: "vw_documents" */
  vw_documents_stream: Array<Vw_Documents>;
  /** fetch data from the table: "vw_finished_files" */
  vw_finished_files: Array<Vw_Finished_Files>;
  /** fetch data from the table in a streaming manner: "vw_finished_files" */
  vw_finished_files_stream: Array<Vw_Finished_Files>;
};


export type Subscription_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAddress_GroupArgs = {
  distinct_on?: InputMaybe<Array<Address_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Group_Order_By>>;
  where?: InputMaybe<Address_Group_Bool_Exp>;
};


export type Subscription_RootAddress_Group_By_PkArgs = {
  group_id: Scalars['smallint'];
  payer_address?: InputMaybe<Scalars['Int']>;
};


export type Subscription_RootAddress_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Group_Bool_Exp>;
};


export type Subscription_RootAddress_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Address_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Groups_Order_By>>;
  where?: InputMaybe<Address_Groups_Bool_Exp>;
};


export type Subscription_RootAddress_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Groups_Bool_Exp>;
};


export type Subscription_RootAddress_MappingArgs = {
  distinct_on?: InputMaybe<Array<Address_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Mapping_Order_By>>;
  where?: InputMaybe<Address_Mapping_Bool_Exp>;
};


export type Subscription_RootAddress_Mapping_By_PkArgs = {
  address_id: Scalars['Int'];
  tenant_id: Scalars['uuid'];
};


export type Subscription_RootAddress_Mapping_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Mapping_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Mapping_Bool_Exp>;
};


export type Subscription_RootAddress_OverrideArgs = {
  distinct_on?: InputMaybe<Array<Address_Override_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Override_Order_By>>;
  where?: InputMaybe<Address_Override_Bool_Exp>;
};


export type Subscription_RootAddress_Override_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAddress_Override_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Override_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Override_Bool_Exp>;
};


export type Subscription_RootAddress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_TypeArgs = {
  distinct_on?: InputMaybe<Array<Address_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Type_Order_By>>;
  where?: InputMaybe<Address_Type_Bool_Exp>;
};


export type Subscription_RootAddress_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAddress_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Type_Bool_Exp>;
};


export type Subscription_RootAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAddresses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Addresses_Stream_Cursor_Input>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAi_Stats_Dt_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ai_Stats_Dt_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Dt_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Dt_Type_Bool_Exp>;
};


export type Subscription_RootAi_Stats_Dt_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ai_Stats_Dt_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Ai_Stats_Dt_Type_Bool_Exp>;
};


export type Subscription_RootAi_Stats_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ai_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Type_Bool_Exp>;
};


export type Subscription_RootAi_Stats_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ai_Stats_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Ai_Stats_Type_Bool_Exp>;
};


export type Subscription_RootAnnotation_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Annotation_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Annotation_Provider_Order_By>>;
  where?: InputMaybe<Annotation_Provider_Bool_Exp>;
};


export type Subscription_RootAnnotation_Provider_By_PkArgs = {
  annotation_provider_id: Scalars['smallint'];
};


export type Subscription_RootAnnotation_Provider_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Annotation_Provider_Stream_Cursor_Input>>;
  where?: InputMaybe<Annotation_Provider_Bool_Exp>;
};


export type Subscription_RootAnnotation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Annotation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Annotation_Type_Order_By>>;
  where?: InputMaybe<Annotation_Type_Bool_Exp>;
};


export type Subscription_RootAnnotation_Type_By_PkArgs = {
  anno_type_id: Scalars['smallint'];
  annotation_provider_id: Scalars['smallint'];
  document_type: Scalars['String'];
};


export type Subscription_RootAnnotation_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Annotation_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Annotation_Type_Bool_Exp>;
};


export type Subscription_RootApi_KeyArgs = {
  distinct_on?: InputMaybe<Array<Api_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Key_Order_By>>;
  where?: InputMaybe<Api_Key_Bool_Exp>;
};


export type Subscription_RootApi_Key_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootApi_Key_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Api_Key_Stream_Cursor_Input>>;
  where?: InputMaybe<Api_Key_Bool_Exp>;
};


export type Subscription_RootArrival_TypeArgs = {
  distinct_on?: InputMaybe<Array<Arrival_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Arrival_Type_Order_By>>;
  where?: InputMaybe<Arrival_Type_Bool_Exp>;
};


export type Subscription_RootArrival_Type_By_PkArgs = {
  arrival_type: Scalars['String'];
};


export type Subscription_RootArrival_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Arrival_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Arrival_Type_Bool_Exp>;
};


export type Subscription_RootArticleArgs = {
  distinct_on?: InputMaybe<Array<Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Order_By>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


export type Subscription_RootArticle_By_PkArgs = {
  article_id: Scalars['smallint'];
  doc_id: Scalars['uuid'];
};


export type Subscription_RootArticle_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


export type Subscription_RootBillArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Order_By>>;
  where?: InputMaybe<Bill_Bool_Exp>;
};


export type Subscription_RootBill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Order_By>>;
  where?: InputMaybe<Bill_Bool_Exp>;
};


export type Subscription_RootBill_By_PkArgs = {
  bill_id: Scalars['bigint'];
};


export type Subscription_RootBill_DetailArgs = {
  distinct_on?: InputMaybe<Array<Bill_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Detail_Order_By>>;
  where?: InputMaybe<Bill_Detail_Bool_Exp>;
};


export type Subscription_RootBill_Detail_By_PkArgs = {
  detail_id: Scalars['bigint'];
};


export type Subscription_RootBill_Detail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Bill_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Bill_Detail_Bool_Exp>;
};


export type Subscription_RootBill_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Bill_Stream_Cursor_Input>>;
  where?: InputMaybe<Bill_Bool_Exp>;
};


export type Subscription_RootClearance_TypeArgs = {
  distinct_on?: InputMaybe<Array<Clearance_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clearance_Type_Order_By>>;
  where?: InputMaybe<Clearance_Type_Bool_Exp>;
};


export type Subscription_RootClearance_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootClearance_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Clearance_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Clearance_Type_Bool_Exp>;
};


export type Subscription_RootContainersArgs = {
  distinct_on?: InputMaybe<Array<Containers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Containers_Order_By>>;
  where?: InputMaybe<Containers_Bool_Exp>;
};


export type Subscription_RootContainers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootContainers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Containers_Stream_Cursor_Input>>;
  where?: InputMaybe<Containers_Bool_Exp>;
};


export type Subscription_RootCount_TypeArgs = {
  distinct_on?: InputMaybe<Array<Count_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Count_Type_Order_By>>;
  where?: InputMaybe<Count_Type_Bool_Exp>;
};


export type Subscription_RootCount_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Count_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Count_Type_Bool_Exp>;
};


export type Subscription_RootCustoms_OfficeArgs = {
  distinct_on?: InputMaybe<Array<Customs_Office_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Office_Order_By>>;
  where?: InputMaybe<Customs_Office_Bool_Exp>;
};


export type Subscription_RootCustoms_Office_By_PkArgs = {
  office_number: Scalars['String'];
  valid_from: Scalars['timestamptz'];
};


export type Subscription_RootCustoms_Office_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customs_Office_Stream_Cursor_Input>>;
  where?: InputMaybe<Customs_Office_Bool_Exp>;
};


export type Subscription_RootCustoms_OfficesArgs = {
  distinct_on?: InputMaybe<Array<Customs_Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Offices_Order_By>>;
  where?: InputMaybe<Customs_Offices_Bool_Exp>;
};


export type Subscription_RootCustoms_Offices_By_PkArgs = {
  office_number: Scalars['String'];
};


export type Subscription_RootCustoms_Offices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customs_Offices_Stream_Cursor_Input>>;
  where?: InputMaybe<Customs_Offices_Bool_Exp>;
};


export type Subscription_RootCustoms_Response_DataArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Data_Order_By>>;
  where?: InputMaybe<Customs_Response_Data_Bool_Exp>;
};


export type Subscription_RootCustoms_Response_Data_By_PkArgs = {
  doc_id: Scalars['uuid'];
  document_version: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Subscription_RootCustoms_Response_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customs_Response_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Customs_Response_Data_Bool_Exp>;
};


export type Subscription_RootCustoms_Response_DecodedArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Decoded_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Decoded_Order_By>>;
  where?: InputMaybe<Customs_Response_Decoded_Bool_Exp>;
};


export type Subscription_RootCustoms_Response_Decoded_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customs_Response_Decoded_Stream_Cursor_Input>>;
  where?: InputMaybe<Customs_Response_Decoded_Bool_Exp>;
};


export type Subscription_RootCustoms_Response_Goods_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Goods_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Goods_Items_Order_By>>;
  where?: InputMaybe<Customs_Response_Goods_Items_Bool_Exp>;
};


export type Subscription_RootCustoms_Response_Goods_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Goods_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Goods_Items_Order_By>>;
  where?: InputMaybe<Customs_Response_Goods_Items_Bool_Exp>;
};


export type Subscription_RootCustoms_Response_Goods_Items_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customs_Response_Goods_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Customs_Response_Goods_Items_Bool_Exp>;
};


export type Subscription_RootCustoms_Response_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Customs_Response_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Summary_Order_By>>;
  where?: InputMaybe<Customs_Response_Summary_Bool_Exp>;
};


export type Subscription_RootCustoms_Response_Summary_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customs_Response_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Customs_Response_Summary_Bool_Exp>;
};


export type Subscription_RootDeclarationArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Order_By>>;
  where?: InputMaybe<Declaration_Bool_Exp>;
};


export type Subscription_RootDeclaration_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Subscription_RootDeclaration_DiscussionArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


export type Subscription_RootDeclaration_Discussion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


export type Subscription_RootDeclaration_Discussion_By_PkArgs = {
  discussion_id: Scalars['bigint'];
};


export type Subscription_RootDeclaration_Discussion_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Discussion_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


export type Subscription_RootDeclaration_DiscussionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussions_Order_By>>;
  where?: InputMaybe<Declaration_Discussions_Bool_Exp>;
};


export type Subscription_RootDeclaration_Discussions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Discussions_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Discussions_Bool_Exp>;
};


export type Subscription_RootDeclaration_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Document_Order_By>>;
  where?: InputMaybe<Declaration_Document_Bool_Exp>;
};


export type Subscription_RootDeclaration_Document_By_PkArgs = {
  doc_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Subscription_RootDeclaration_Document_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Document_Bool_Exp>;
};


export type Subscription_RootDeclaration_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Labels_Bool_Exp>;
};


export type Subscription_RootDeclaration_Labels_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDeclaration_Labels_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Labels_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Labels_Bool_Exp>;
};


export type Subscription_RootDeclaration_MessageArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


export type Subscription_RootDeclaration_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


export type Subscription_RootDeclaration_Message_By_PkArgs = {
  creation_user: Scalars['uuid'];
  discussion_id: Scalars['bigint'];
  msg_date: Scalars['timestamptz'];
  read_date?: InputMaybe<Scalars['timestamptz']>;
};


export type Subscription_RootDeclaration_Message_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


export type Subscription_RootDeclaration_RequestArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_AddressArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_Address_AiArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Ai_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Ai_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Ai_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_Address_Ai_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDeclaration_Request_Address_Ai_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Request_Address_Ai_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Request_Address_Ai_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_Address_By_PkArgs = {
  address_type: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Subscription_RootDeclaration_Request_Address_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Request_Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Subscription_RootDeclaration_Request_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_Labels_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  label_id: Scalars['Int'];
};


export type Subscription_RootDeclaration_Request_Labels_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Request_Labels_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


export type Subscription_RootDeclaration_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Requests_Order_By>>;
  where?: InputMaybe<Declaration_Requests_Bool_Exp>;
};


export type Subscription_RootDeclaration_Requests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Requests_Bool_Exp>;
};


export type Subscription_RootDeclaration_SearchArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Search_Order_By>>;
  where?: InputMaybe<Declaration_Search_Bool_Exp>;
};


export type Subscription_RootDeclaration_Search_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Search_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Search_Bool_Exp>;
};


export type Subscription_RootDeclaration_Special_MentionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Special_Mentions_Order_By>>;
  where?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
};


export type Subscription_RootDeclaration_Special_Mentions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDeclaration_Special_Mentions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Special_Mentions_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
};


export type Subscription_RootDeclaration_StatusArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Status_Order_By>>;
  where?: InputMaybe<Declaration_Status_Bool_Exp>;
};


export type Subscription_RootDeclaration_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootDeclaration_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Status_Bool_Exp>;
};


export type Subscription_RootDeclaration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Bool_Exp>;
};


export type Subscription_RootDeclaration_TaskArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


export type Subscription_RootDeclaration_Task_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


export type Subscription_RootDeclaration_Task_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDeclaration_Task_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Task_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


export type Subscription_RootDeclaration_TasksArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Bool_Exp>;
};


export type Subscription_RootDeclaration_Tasks_ObjArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Obj_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Obj_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Obj_Bool_Exp>;
};


export type Subscription_RootDeclaration_Tasks_Obj_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Tasks_Obj_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Tasks_Obj_Bool_Exp>;
};


export type Subscription_RootDeclaration_Tasks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Tasks_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Tasks_Bool_Exp>;
};


export type Subscription_RootDeclaration_TypeArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Type_Order_By>>;
  where?: InputMaybe<Declaration_Type_Bool_Exp>;
};


export type Subscription_RootDeclaration_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootDeclaration_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Type_Bool_Exp>;
};


export type Subscription_RootDiscussion_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Discussion_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discussion_Changes_Order_By>>;
  where?: InputMaybe<Discussion_Changes_Bool_Exp>;
};


export type Subscription_RootDiscussion_Changes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Discussion_Changes_Stream_Cursor_Input>>;
  where?: InputMaybe<Discussion_Changes_Bool_Exp>;
};


export type Subscription_RootDoc_AnnotationArgs = {
  distinct_on?: InputMaybe<Array<Doc_Annotation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Annotation_Order_By>>;
  where?: InputMaybe<Doc_Annotation_Bool_Exp>;
};


export type Subscription_RootDoc_Annotation_By_PkArgs = {
  anno_type_id: Scalars['smallint'];
  doc_id: Scalars['uuid'];
};


export type Subscription_RootDoc_Annotation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Doc_Annotation_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Annotation_Bool_Exp>;
};


export type Subscription_RootDoc_Search_TypeArgs = {
  distinct_on?: InputMaybe<Array<Doc_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Search_Type_Order_By>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Subscription_RootDoc_Search_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Doc_Search_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Subscription_RootDoc_Stats_TypeArgs = {
  distinct_on?: InputMaybe<Array<Doc_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Stats_Type_Order_By>>;
  where?: InputMaybe<Doc_Stats_Type_Bool_Exp>;
};


export type Subscription_RootDoc_Stats_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Doc_Stats_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Stats_Type_Bool_Exp>;
};


export type Subscription_RootDocs_For_ValidationArgs = {
  distinct_on?: InputMaybe<Array<Docs_For_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Docs_For_Validation_Order_By>>;
  where?: InputMaybe<Docs_For_Validation_Bool_Exp>;
};


export type Subscription_RootDocs_For_Validation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Docs_For_Validation_Stream_Cursor_Input>>;
  where?: InputMaybe<Docs_For_Validation_Bool_Exp>;
};


export type Subscription_RootDocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_By_PkArgs = {
  document_type: Scalars['String'];
  id: Scalars['uuid'];
};


export type Subscription_RootDocument_ExtensionArgs = {
  distinct_on?: InputMaybe<Array<Document_Extension_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Extension_Order_By>>;
  where?: InputMaybe<Document_Extension_Bool_Exp>;
};


export type Subscription_RootDocument_Extension_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootDocument_Extension_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Extension_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Extension_Bool_Exp>;
};


export type Subscription_RootDocument_FlagArgs = {
  distinct_on?: InputMaybe<Array<Document_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Flag_Order_By>>;
  where?: InputMaybe<Document_Flag_Bool_Exp>;
};


export type Subscription_RootDocument_Flag_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDocument_Flag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Flag_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Flag_Bool_Exp>;
};


export type Subscription_RootDocument_Is_AllowedArgs = {
  args: Document_Is_Allowed_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_Is_Allowed_AggregateArgs = {
  args: Document_Is_Allowed_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_Label_Org_IdArgs = {
  distinct_on?: InputMaybe<Array<Document_Label_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Label_Org_Id_Order_By>>;
  where?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
};


export type Subscription_RootDocument_Label_Org_Id_By_PkArgs = {
  label_id: Scalars['Int'];
  org_id: Scalars['smallint'];
};


export type Subscription_RootDocument_Label_Org_Id_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Label_Org_Id_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
};


export type Subscription_RootDocument_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Document_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Labels_Order_By>>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};


export type Subscription_RootDocument_Labels_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDocument_Labels_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Labels_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};


export type Subscription_RootDocument_PageArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


export type Subscription_RootDocument_Page_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


export type Subscription_RootDocument_Page_By_PkArgs = {
  document_id: Scalars['uuid'];
  page_id: Scalars['uuid'];
  page_number: Scalars['smallint'];
};


export type Subscription_RootDocument_Page_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Page_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


export type Subscription_RootDocument_StatusArgs = {
  distinct_on?: InputMaybe<Array<Document_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Status_Order_By>>;
  where?: InputMaybe<Document_Status_Bool_Exp>;
};


export type Subscription_RootDocument_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootDocument_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Status_Bool_Exp>;
};


export type Subscription_RootDocument_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_TypeArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocument_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocument_Type_All_Tenant_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
};


export type Subscription_RootDocument_Type_All_Tenant_Settings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Type_All_Tenant_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
};


export type Subscription_RootDocument_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootDocument_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocument_Type_Tenant_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
};


export type Subscription_RootDocument_Type_Tenant_Settings_By_PkArgs = {
  document_type: Scalars['String'];
  tenant: Scalars['uuid'];
};


export type Subscription_RootDocument_Type_Tenant_Settings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Type_Tenant_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
};


export type Subscription_RootDr_Goods_ItemArgs = {
  distinct_on?: InputMaybe<Array<Dr_Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Item_Order_By>>;
  where?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
};


export type Subscription_RootDr_Goods_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dr_Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Item_Order_By>>;
  where?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
};


export type Subscription_RootDr_Goods_Item_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  source: Scalars['smallint'];
  trader_item_id: Scalars['Int'];
};


export type Subscription_RootDr_Goods_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dr_Goods_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Dr_Goods_Item_Bool_Exp>;
};


export type Subscription_RootDr_Goods_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Dr_Goods_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Items_Order_By>>;
  where?: InputMaybe<Dr_Goods_Items_Bool_Exp>;
};


export type Subscription_RootDr_Goods_Items_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dr_Goods_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Dr_Goods_Items_Bool_Exp>;
};


export type Subscription_RootDr_StatsArgs = {
  distinct_on?: InputMaybe<Array<Dr_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Stats_Order_By>>;
  where?: InputMaybe<Dr_Stats_Bool_Exp>;
};


export type Subscription_RootDr_Stats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dr_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Dr_Stats_Bool_Exp>;
};


export type Subscription_RootEdec_CountriesArgs = {
  distinct_on?: InputMaybe<Array<Edec_Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Countries_Order_By>>;
  where?: InputMaybe<Edec_Countries_Bool_Exp>;
};


export type Subscription_RootEdec_Countries_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEdec_Countries_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Edec_Countries_Stream_Cursor_Input>>;
  where?: InputMaybe<Edec_Countries_Bool_Exp>;
};


export type Subscription_RootEdec_Customs_OfficesArgs = {
  distinct_on?: InputMaybe<Array<Edec_Customs_Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Customs_Offices_Order_By>>;
  where?: InputMaybe<Edec_Customs_Offices_Bool_Exp>;
};


export type Subscription_RootEdec_Customs_Offices_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEdec_Customs_Offices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Edec_Customs_Offices_Stream_Cursor_Input>>;
  where?: InputMaybe<Edec_Customs_Offices_Bool_Exp>;
};


export type Subscription_RootEdec_DomainsArgs = {
  distinct_on?: InputMaybe<Array<Edec_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Domains_Order_By>>;
  where?: InputMaybe<Edec_Domains_Bool_Exp>;
};


export type Subscription_RootEdec_Domains_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEdec_Domains_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Edec_Domains_Stream_Cursor_Input>>;
  where?: InputMaybe<Edec_Domains_Bool_Exp>;
};


export type Subscription_RootEdec_Tariff_Commodity_CodeArgs = {
  distinct_on?: InputMaybe<Array<Edec_Tariff_Commodity_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Tariff_Commodity_Code_Order_By>>;
  where?: InputMaybe<Edec_Tariff_Commodity_Code_Bool_Exp>;
};


export type Subscription_RootEdec_Tariff_Commodity_Code_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEdec_Tariff_Commodity_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Edec_Tariff_Commodity_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<Edec_Tariff_Commodity_Code_Bool_Exp>;
};


export type Subscription_RootEdec_Tariff_Statistical_CodeArgs = {
  distinct_on?: InputMaybe<Array<Edec_Tariff_Statistical_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Tariff_Statistical_Code_Order_By>>;
  where?: InputMaybe<Edec_Tariff_Statistical_Code_Bool_Exp>;
};


export type Subscription_RootEdec_Tariff_Statistical_Code_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEdec_Tariff_Statistical_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Edec_Tariff_Statistical_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<Edec_Tariff_Statistical_Code_Bool_Exp>;
};


export type Subscription_RootEmail_Search_TypeArgs = {
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootEmail_Search_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootEmail_Search_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Search_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootExtract_TypeArgs = {
  distinct_on?: InputMaybe<Array<Extract_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Extract_Type_Order_By>>;
  where?: InputMaybe<Extract_Type_Bool_Exp>;
};


export type Subscription_RootExtract_Type_By_PkArgs = {
  extract_type_id: Scalars['smallint'];
};


export type Subscription_RootExtract_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Extract_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Extract_Type_Bool_Exp>;
};


export type Subscription_RootExtraction_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Extraction_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Extraction_Config_Order_By>>;
  where?: InputMaybe<Extraction_Config_Bool_Exp>;
};


export type Subscription_RootExtraction_Config_By_PkArgs = {
  address_id: Scalars['Int'];
};


export type Subscription_RootExtraction_Config_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Extraction_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Extraction_Config_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFile_Stats_TypeArgs = {
  distinct_on?: InputMaybe<Array<File_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Stats_Type_Order_By>>;
  where?: InputMaybe<File_Stats_Type_Bool_Exp>;
};


export type Subscription_RootFile_Stats_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<File_Stats_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Stats_Type_Bool_Exp>;
};


export type Subscription_RootFile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<File_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFile_TypeArgs = {
  distinct_on?: InputMaybe<Array<File_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Type_Order_By>>;
  where?: InputMaybe<File_Type_Bool_Exp>;
};


export type Subscription_RootFile_Type_By_PkArgs = {
  doc_types?: InputMaybe<Scalars['_varchar']>;
  file_type: Scalars['String'];
};


export type Subscription_RootFile_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<File_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Type_Bool_Exp>;
};


export type Subscription_RootGoods_ItemArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Order_By>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


export type Subscription_RootGoods_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Order_By>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


export type Subscription_RootGoods_Item_By_PkArgs = {
  customs_item_number: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Subscription_RootGoods_Item_Special_MentionsArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Special_Mentions_Order_By>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


export type Subscription_RootGoods_Item_Special_Mentions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Special_Mentions_Order_By>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


export type Subscription_RootGoods_Item_Special_Mentions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGoods_Item_Special_Mentions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Goods_Item_Special_Mentions_Stream_Cursor_Input>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


export type Subscription_RootGoods_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Goods_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


export type Subscription_RootGoods_Items_For_DrsArgs = {
  distinct_on?: InputMaybe<Array<Goods_Items_For_Drs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Items_For_Drs_Order_By>>;
  where?: InputMaybe<Goods_Items_For_Drs_Bool_Exp>;
};


export type Subscription_RootGoods_Items_For_Drs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Goods_Items_For_Drs_Stream_Cursor_Input>>;
  where?: InputMaybe<Goods_Items_For_Drs_Bool_Exp>;
};


export type Subscription_RootGroup_MemberArgs = {
  distinct_on?: InputMaybe<Array<Group_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Member_Order_By>>;
  where?: InputMaybe<Group_Member_Bool_Exp>;
};


export type Subscription_RootGroup_Member_By_PkArgs = {
  address_id: Scalars['Int'];
  clearance_types: Scalars['_text'];
  declaration_types: Scalars['_text'];
  group_id: Scalars['smallint'];
};


export type Subscription_RootGroup_Member_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Group_Member_Stream_Cursor_Input>>;
  where?: InputMaybe<Group_Member_Bool_Exp>;
};


export type Subscription_RootGroup_MembersArgs = {
  distinct_on?: InputMaybe<Array<Group_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Members_Order_By>>;
  where?: InputMaybe<Group_Members_Bool_Exp>;
};


export type Subscription_RootGroup_Members_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Group_Members_Stream_Cursor_Input>>;
  where?: InputMaybe<Group_Members_Bool_Exp>;
};


export type Subscription_RootImport_List_TriggerArgs = {
  distinct_on?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_List_Trigger_Order_By>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


export type Subscription_RootImport_List_Trigger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_List_Trigger_Order_By>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


export type Subscription_RootImport_List_Trigger_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootImport_List_Trigger_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Import_List_Trigger_Stream_Cursor_Input>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


export type Subscription_RootIntf_Dr_Payment_InfoArgs = {
  distinct_on?: InputMaybe<Array<Intf_Dr_Payment_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Intf_Dr_Payment_Info_Order_By>>;
  where?: InputMaybe<Intf_Dr_Payment_Info_Bool_Exp>;
};


export type Subscription_RootIntf_Dr_Payment_Info_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Intf_Dr_Payment_Info_Stream_Cursor_Input>>;
  where?: InputMaybe<Intf_Dr_Payment_Info_Bool_Exp>;
};


export type Subscription_RootJson_TypeArgs = {
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootJson_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Json_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootKc_UsersArgs = {
  distinct_on?: InputMaybe<Array<Kc_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kc_Users_Order_By>>;
  where?: InputMaybe<Kc_Users_Bool_Exp>;
};


export type Subscription_RootKc_Users_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Kc_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Kc_Users_Bool_Exp>;
};


export type Subscription_RootMax_Date_TypeArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootMax_Date_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Max_Date_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootModel_RetrainArgs = {
  distinct_on?: InputMaybe<Array<Model_Retrain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Retrain_Order_By>>;
  where?: InputMaybe<Model_Retrain_Bool_Exp>;
};


export type Subscription_RootModel_Retrain_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootModel_Retrain_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Model_Retrain_Stream_Cursor_Input>>;
  where?: InputMaybe<Model_Retrain_Bool_Exp>;
};


export type Subscription_RootOrg_IdArgs = {
  distinct_on?: InputMaybe<Array<Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Id_Order_By>>;
  where?: InputMaybe<Org_Id_Bool_Exp>;
};


export type Subscription_RootOrg_Id_By_PkArgs = {
  org_id: Scalars['smallint'];
};


export type Subscription_RootOrg_Id_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Id_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Id_Bool_Exp>;
};


export type Subscription_RootOrg_IdsArgs = {
  distinct_on?: InputMaybe<Array<Org_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Ids_Order_By>>;
  where?: InputMaybe<Org_Ids_Bool_Exp>;
};


export type Subscription_RootOrg_Ids_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Ids_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Ids_Bool_Exp>;
};


export type Subscription_RootOrg_ParamsArgs = {
  distinct_on?: InputMaybe<Array<Org_Params_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Params_Order_By>>;
  where?: InputMaybe<Org_Params_Bool_Exp>;
};


export type Subscription_RootOrg_Params_By_PkArgs = {
  org_id: Scalars['Int'];
};


export type Subscription_RootOrg_Params_Org_IdArgs = {
  distinct_on?: InputMaybe<Array<Org_Params_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Params_Org_Id_Order_By>>;
  where?: InputMaybe<Org_Params_Org_Id_Bool_Exp>;
};


export type Subscription_RootOrg_Params_Org_Id_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Params_Org_Id_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Params_Org_Id_Bool_Exp>;
};


export type Subscription_RootOrg_Params_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Params_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Params_Bool_Exp>;
};


export type Subscription_RootPackagingsArgs = {
  distinct_on?: InputMaybe<Array<Packagings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packagings_Order_By>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


export type Subscription_RootPackagings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packagings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packagings_Order_By>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


export type Subscription_RootPackagings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPackagings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Packagings_Stream_Cursor_Input>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


export type Subscription_RootPageArgs = {
  distinct_on?: InputMaybe<Array<Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Order_By>>;
  where?: InputMaybe<Page_Bool_Exp>;
};


export type Subscription_RootPage_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPage_ExtractArgs = {
  distinct_on?: InputMaybe<Array<Page_Extract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Extract_Order_By>>;
  where?: InputMaybe<Page_Extract_Bool_Exp>;
};


export type Subscription_RootPage_Extract_By_PkArgs = {
  extract_type_id: Scalars['smallint'];
  page_id: Scalars['uuid'];
};


export type Subscription_RootPage_Extract_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Page_Extract_Stream_Cursor_Input>>;
  where?: InputMaybe<Page_Extract_Bool_Exp>;
};


export type Subscription_RootPage_StatusArgs = {
  distinct_on?: InputMaybe<Array<Page_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Status_Order_By>>;
  where?: InputMaybe<Page_Status_Bool_Exp>;
};


export type Subscription_RootPage_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootPage_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Page_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Page_Status_Bool_Exp>;
};


export type Subscription_RootPage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Page_Stream_Cursor_Input>>;
  where?: InputMaybe<Page_Bool_Exp>;
};


export type Subscription_RootPages_M2m_CacheArgs = {
  distinct_on?: InputMaybe<Array<Pages_M2m_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_M2m_Cache_Order_By>>;
  where?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
};


export type Subscription_RootPages_M2m_Cache_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pages_M2m_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_M2m_Cache_Order_By>>;
  where?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
};


export type Subscription_RootPages_M2m_Cache_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pages_M2m_Cache_Stream_Cursor_Input>>;
  where?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
};


export type Subscription_RootPermitsArgs = {
  distinct_on?: InputMaybe<Array<Permits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permits_Order_By>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


export type Subscription_RootPermits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permits_Order_By>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


export type Subscription_RootPermits_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPermits_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Permits_Stream_Cursor_Input>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


export type Subscription_RootPp_Address_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Address_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Groups_Order_By>>;
  where?: InputMaybe<Address_Groups_Bool_Exp>;
};


export type Subscription_RootPp_AddressesArgs = {
  args: Pp_Addresses_Args;
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootPp_Addresses_By_Payer_AddressArgs = {
  args: Pp_Addresses_By_Payer_Address_Args;
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootPp_Addresses_By_Payer_IdArgs = {
  args: Pp_Addresses_By_Payer_Id_Args;
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootPp_Ai_StatsArgs = {
  args: Pp_Ai_Stats_Args;
  distinct_on?: InputMaybe<Array<Ai_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Type_Bool_Exp>;
};


export type Subscription_RootPp_Ai_Stats_DtArgs = {
  args: Pp_Ai_Stats_Dt_Args;
  distinct_on?: InputMaybe<Array<Ai_Stats_Dt_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Dt_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Dt_Type_Bool_Exp>;
};


export type Subscription_RootPp_Check_Json_ParamArgs = {
  args: Pp_Check_Json_Param_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Customs_Response_SummaryArgs = {
  args: Pp_Customs_Response_Summary_Args;
  distinct_on?: InputMaybe<Array<Customs_Response_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Response_Summary_Order_By>>;
  where?: InputMaybe<Customs_Response_Summary_Bool_Exp>;
};


export type Subscription_RootPp_Declaration_RequestArgs = {
  args: Pp_Declaration_Request_Args;
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


export type Subscription_RootPp_Declaration_TasksArgs = {
  args: Pp_Declaration_Tasks_Args;
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Bool_Exp>;
};


export type Subscription_RootPp_Declaration_Tasks_AggArgs = {
  args: Pp_Declaration_Tasks_Agg_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Declaration_Tasks_ObjArgs = {
  args: Pp_Declaration_Tasks_Obj_Args;
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Obj_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Obj_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Obj_Bool_Exp>;
};


export type Subscription_RootPp_DeclarationsArgs = {
  args: Pp_Declarations_Args;
  distinct_on?: InputMaybe<Array<Declaration_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Search_Order_By>>;
  where?: InputMaybe<Declaration_Search_Bool_Exp>;
};


export type Subscription_RootPp_Delete_Declaration_RequestsArgs = {
  args: Pp_Delete_Declaration_Requests_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Doc_Max_Date_HsArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootPp_Doc_Max_Date_V2Args = {
  args: Pp_Doc_Max_Date_V2_Args;
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootPp_Doc_SearchArgs = {
  args: Pp_Doc_Search_Args;
  distinct_on?: InputMaybe<Array<Doc_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Search_Type_Order_By>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_Doc_Search_HsArgs = {
  args: Pp_Doc_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Doc_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Search_Type_Order_By>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_Doc_StatsArgs = {
  args: Pp_Doc_Stats_Args;
  distinct_on?: InputMaybe<Array<Doc_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Stats_Type_Order_By>>;
  where?: InputMaybe<Doc_Stats_Type_Bool_Exp>;
};


export type Subscription_RootPp_Docs_For_ValidationArgs = {
  args: Pp_Docs_For_Validation_Args;
  distinct_on?: InputMaybe<Array<Docs_For_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Docs_For_Validation_Order_By>>;
  where?: InputMaybe<Docs_For_Validation_Bool_Exp>;
};


export type Subscription_RootPp_DocumentArgs = {
  args: Pp_Document_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootPp_Document_AggregateArgs = {
  args: Pp_Document_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootPp_Document_FlagArgs = {
  args: Pp_Document_Flag_Args;
  distinct_on?: InputMaybe<Array<Document_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Flag_Order_By>>;
  where?: InputMaybe<Document_Flag_Bool_Exp>;
};


export type Subscription_RootPp_Document_LabelsArgs = {
  args: Pp_Document_Labels_Args;
  distinct_on?: InputMaybe<Array<Document_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Labels_Order_By>>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};


export type Subscription_RootPp_Dr_Goods_ItemsArgs = {
  args: Pp_Dr_Goods_Items_Args;
  distinct_on?: InputMaybe<Array<Dr_Goods_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Goods_Items_Order_By>>;
  where?: InputMaybe<Dr_Goods_Items_Bool_Exp>;
};


export type Subscription_RootPp_Dr_Max_DateArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootPp_Dr_StatsArgs = {
  args: Pp_Dr_Stats_Args;
  distinct_on?: InputMaybe<Array<Dr_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Stats_Order_By>>;
  where?: InputMaybe<Dr_Stats_Bool_Exp>;
};


export type Subscription_RootPp_Email_SearchArgs = {
  args: Pp_Email_Search_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_Email_Search_AggregateArgs = {
  args: Pp_Email_Search_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_Email_Search_HsArgs = {
  args: Pp_Email_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_Email_Search_Hs_AggregateArgs = {
  args: Pp_Email_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_File_Max_Date_HsArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootPp_File_Max_Date_V2Args = {
  args: Pp_File_Max_Date_V2_Args;
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootPp_File_SearchArgs = {
  args: Pp_File_Search_Args;
  distinct_on?: InputMaybe<Array<Pp_Types_File_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pp_Types_File_Search_Order_By>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Subscription_RootPp_File_Search_HsArgs = {
  args: Pp_File_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Pp_Types_File_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pp_Types_File_Search_Order_By>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Subscription_RootPp_File_StatsArgs = {
  args: Pp_File_Stats_Args;
  distinct_on?: InputMaybe<Array<File_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Stats_Type_Order_By>>;
  where?: InputMaybe<File_Stats_Type_Bool_Exp>;
};


export type Subscription_RootPp_Get_Wd_Perms_For_DrArgs = {
  args: Pp_Get_Wd_Perms_For_Dr_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Group_MembersArgs = {
  distinct_on?: InputMaybe<Array<Group_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Group_Members_Order_By>>;
  where?: InputMaybe<Group_Members_Bool_Exp>;
};


export type Subscription_RootPp_Hasura_SessionArgs = {
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Kc_UsersArgs = {
  args: Pp_Kc_Users_Args;
  distinct_on?: InputMaybe<Array<Kc_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kc_Users_Order_By>>;
  where?: InputMaybe<Kc_Users_Bool_Exp>;
};


export type Subscription_RootPp_Last_Doc_In_DrArgs = {
  args: Pp_Last_Doc_In_Dr_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootPp_Last_Doc_In_Dr_AggregateArgs = {
  args: Pp_Last_Doc_In_Dr_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootPp_Menu_IndicatorsArgs = {
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Org_Id_DeleteArgs = {
  args: Pp_Org_Id_Delete_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Org_Id_InsertArgs = {
  args: Pp_Org_Id_Insert_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Org_Id_UpdateArgs = {
  args: Pp_Org_Id_Update_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Org_IdsArgs = {
  args: Pp_Org_Ids_Args;
  distinct_on?: InputMaybe<Array<Org_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Ids_Order_By>>;
  where?: InputMaybe<Org_Ids_Bool_Exp>;
};


export type Subscription_RootPp_Page_Extract_Grids_TextArgs = {
  args: Pp_Page_Extract_Grids_Text_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Page_Extract_Text_FragmentArgs = {
  args: Pp_Page_Extract_Text_Fragment_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Page_Extract_Text_Fragment_V2Args = {
  args: Pp_Page_Extract_Text_Fragment_V2_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_TenantsArgs = {
  args: Pp_Tenants_Args;
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootPp_Types_File_SearchArgs = {
  distinct_on?: InputMaybe<Array<Pp_Types_File_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pp_Types_File_Search_Order_By>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Subscription_RootPp_Types_File_Search_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pp_Types_File_Search_Stream_Cursor_Input>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Subscription_RootPp_User_Org_IdArgs = {
  args: Pp_User_Org_Id_Args;
  distinct_on?: InputMaybe<Array<User_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Org_Id_Order_By>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};


export type Subscription_RootPp_User_SearchArgs = {
  args: Pp_User_Search_Args;
  distinct_on?: InputMaybe<Array<User_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Search_Type_Order_By>>;
  where?: InputMaybe<User_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_UsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootPp_View_Document_HistoryArgs = {
  args: Pp_View_Document_History_Args;
  distinct_on?: InputMaybe<Array<View_Document_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_Document_History_Order_By>>;
  where?: InputMaybe<View_Document_History_Bool_Exp>;
};


export type Subscription_RootPp_View_File_HistoryArgs = {
  args: Pp_View_File_History_Args;
  distinct_on?: InputMaybe<Array<View_File_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_File_History_Order_By>>;
  where?: InputMaybe<View_File_History_Bool_Exp>;
};


export type Subscription_RootPrevious_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Previous_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Previous_Documents_Order_By>>;
  where?: InputMaybe<Previous_Documents_Bool_Exp>;
};


export type Subscription_RootPrevious_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPrevious_Documents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Previous_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Previous_Documents_Bool_Exp>;
};


export type Subscription_RootProduced_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produced_Documents_Order_By>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};


export type Subscription_RootProduced_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produced_Documents_Order_By>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};


export type Subscription_RootProduced_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProduced_Documents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Produced_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};


export type Subscription_RootReportArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Subscription_RootReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Subscription_RootReport_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootReport_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Report_Stream_Cursor_Input>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Subscription_RootServiceArgs = {
  distinct_on?: InputMaybe<Array<Service_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Order_By>>;
  where?: InputMaybe<Service_Bool_Exp>;
};


export type Subscription_RootService_By_PkArgs = {
  srv_id: Scalars['Int'];
};


export type Subscription_RootService_RateArgs = {
  distinct_on?: InputMaybe<Array<Service_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Rate_Order_By>>;
  where?: InputMaybe<Service_Rate_Bool_Exp>;
};


export type Subscription_RootService_Rate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Service_Rate_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Rate_Bool_Exp>;
};


export type Subscription_RootService_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Service_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Bool_Exp>;
};


export type Subscription_RootService_TariffArgs = {
  distinct_on?: InputMaybe<Array<Service_Tariff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Tariff_Order_By>>;
  where?: InputMaybe<Service_Tariff_Bool_Exp>;
};


export type Subscription_RootService_Tariff_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Tariff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Tariff_Order_By>>;
  where?: InputMaybe<Service_Tariff_Bool_Exp>;
};


export type Subscription_RootService_Tariff_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Service_Tariff_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Tariff_Bool_Exp>;
};


export type Subscription_RootSettingArgs = {
  distinct_on?: InputMaybe<Array<Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Order_By>>;
  where?: InputMaybe<Setting_Bool_Exp>;
};


export type Subscription_RootSetting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSetting_GroupArgs = {
  distinct_on?: InputMaybe<Array<Setting_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Group_Order_By>>;
  where?: InputMaybe<Setting_Group_Bool_Exp>;
};


export type Subscription_RootSetting_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSetting_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Setting_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Setting_Group_Bool_Exp>;
};


export type Subscription_RootSetting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Setting_Stream_Cursor_Input>>;
  where?: InputMaybe<Setting_Bool_Exp>;
};


export type Subscription_RootSetting_ValueArgs = {
  distinct_on?: InputMaybe<Array<Setting_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Value_Order_By>>;
  where?: InputMaybe<Setting_Value_Bool_Exp>;
};


export type Subscription_RootSetting_Value_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSetting_Value_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Setting_Value_Stream_Cursor_Input>>;
  where?: InputMaybe<Setting_Value_Bool_Exp>;
};


export type Subscription_RootTariff_Number_DescriptionArgs = {
  distinct_on?: InputMaybe<Array<Tariff_Number_Description_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tariff_Number_Description_Order_By>>;
  where?: InputMaybe<Tariff_Number_Description_Bool_Exp>;
};


export type Subscription_RootTariff_Number_Description_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTariff_Number_Description_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tariff_Number_Description_Stream_Cursor_Input>>;
  where?: InputMaybe<Tariff_Number_Description_Bool_Exp>;
};


export type Subscription_RootTask_TypeArgs = {
  distinct_on?: InputMaybe<Array<Task_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Task_Type_Order_By>>;
  where?: InputMaybe<Task_Type_Bool_Exp>;
};


export type Subscription_RootTask_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTask_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Task_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Type_Bool_Exp>;
};


export type Subscription_RootTenantArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenant_Order_By>>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};


export type Subscription_RootTenant_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTenant_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tenant_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};


export type Subscription_RootTenantsArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootTenants_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tenants_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootTransitdoc_Type_DescrArgs = {
  distinct_on?: InputMaybe<Array<Transitdoc_Type_Descr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transitdoc_Type_Descr_Order_By>>;
  where?: InputMaybe<Transitdoc_Type_Descr_Bool_Exp>;
};


export type Subscription_RootTransitdoc_Type_Descr_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Transitdoc_Type_Descr_Stream_Cursor_Input>>;
  where?: InputMaybe<Transitdoc_Type_Descr_Bool_Exp>;
};


export type Subscription_RootUser_Org_IdArgs = {
  distinct_on?: InputMaybe<Array<User_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Org_Id_Order_By>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};


export type Subscription_RootUser_Org_Id_By_PkArgs = {
  org_id: Scalars['smallint'];
  user_pp: Scalars['uuid'];
};


export type Subscription_RootUser_Org_Id_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Org_Id_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};


export type Subscription_RootUser_PpArgs = {
  distinct_on?: InputMaybe<Array<User_Pp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Pp_Order_By>>;
  where?: InputMaybe<User_Pp_Bool_Exp>;
};


export type Subscription_RootUser_Pp_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Pp_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Pp_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Pp_Bool_Exp>;
};


export type Subscription_RootUser_Search_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Search_Type_Order_By>>;
  where?: InputMaybe<User_Search_Type_Bool_Exp>;
};


export type Subscription_RootUser_Search_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Search_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Search_Type_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootView_Document_HistoryArgs = {
  distinct_on?: InputMaybe<Array<View_Document_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_Document_History_Order_By>>;
  where?: InputMaybe<View_Document_History_Bool_Exp>;
};


export type Subscription_RootView_Document_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<View_Document_History_Stream_Cursor_Input>>;
  where?: InputMaybe<View_Document_History_Bool_Exp>;
};


export type Subscription_RootView_File_HistoryArgs = {
  distinct_on?: InputMaybe<Array<View_File_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_File_History_Order_By>>;
  where?: InputMaybe<View_File_History_Bool_Exp>;
};


export type Subscription_RootView_File_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<View_File_History_Stream_Cursor_Input>>;
  where?: InputMaybe<View_File_History_Bool_Exp>;
};


export type Subscription_RootView_HistoryArgs = {
  distinct_on?: InputMaybe<Array<View_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_History_Order_By>>;
  where?: InputMaybe<View_History_Bool_Exp>;
};


export type Subscription_RootView_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<View_History_Stream_Cursor_Input>>;
  where?: InputMaybe<View_History_Bool_Exp>;
};


export type Subscription_RootVw_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Vw_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vw_Documents_Order_By>>;
  where?: InputMaybe<Vw_Documents_Bool_Exp>;
};


export type Subscription_RootVw_Documents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Vw_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Documents_Bool_Exp>;
};


export type Subscription_RootVw_Finished_FilesArgs = {
  distinct_on?: InputMaybe<Array<Vw_Finished_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vw_Finished_Files_Order_By>>;
  where?: InputMaybe<Vw_Finished_Files_Bool_Exp>;
};


export type Subscription_RootVw_Finished_Files_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Vw_Finished_Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Finished_Files_Bool_Exp>;
};

/** Streaming cursor of the table "address_group" */
export type Address_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Group_Stream_Cursor_Value_Input = {
  business_case?: InputMaybe<Scalars['bc_name']>;
  group_id?: InputMaybe<Scalars['smallint']>;
  group_name?: InputMaybe<Scalars['String']>;
  payer_address?: InputMaybe<Scalars['Int']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Streaming cursor of the table "address_groups" */
export type Address_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Groups_Stream_Cursor_Value_Input = {
  business_case?: InputMaybe<Scalars['bc_name']>;
  group_id?: InputMaybe<Scalars['smallint']>;
  group_name?: InputMaybe<Scalars['String']>;
  payer_address?: InputMaybe<Scalars['Int']>;
  payer_name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "address_mapping" */
export type Address_Mapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Mapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Mapping_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  address_override_id?: InputMaybe<Scalars['Int']>;
  is_cross_address?: InputMaybe<Scalars['Boolean']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "address_override" */
export type Address_Override_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Override_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Override_Stream_Cursor_Value_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  reference?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "address" */
export type Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Stream_Cursor_Value_Input = {
  additional_values?: InputMaybe<Scalars['jsonb']>;
  address_type?: InputMaybe<Scalars['Int']>;
  ao_id?: InputMaybe<Scalars['smallint']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  company_name_2?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_account_number?: InputMaybe<Scalars['String']>;
  error_email_address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imported?: InputMaybe<Scalars['Boolean']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_locked?: InputMaybe<Scalars['Boolean']>;
  is_platform_user?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  reference?: InputMaybe<Scalars['String']>;
  search_vector?: InputMaybe<Scalars['tsvector']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
  uid_number?: InputMaybe<Scalars['String']>;
  usage_frequency?: InputMaybe<Scalars['Int']>;
  vat_account_number?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "address_type" */
export type Address_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "addresses" */
export type Addresses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Addresses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Addresses_Stream_Cursor_Value_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  address_types?: InputMaybe<Scalars['_int4']>;
  ao_id?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_account_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  qty?: InputMaybe<Scalars['bigint']>;
  reference?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  vat_account_number?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ai_stats_dt_type" */
export type Ai_Stats_Dt_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ai_Stats_Dt_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ai_Stats_Dt_Type_Stream_Cursor_Value_Input = {
  creation_date?: InputMaybe<Scalars['date']>;
  docs_qty?: InputMaybe<Scalars['bigint']>;
  document_type?: InputMaybe<Scalars['String']>;
  pages_qty?: InputMaybe<Scalars['bigint']>;
  success_ratio?: InputMaybe<Scalars['numeric']>;
  types_match?: InputMaybe<Scalars['numeric']>;
  unknowns?: InputMaybe<Scalars['numeric']>;
  unknowns_pct?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "ai_stats_type" */
export type Ai_Stats_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ai_Stats_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ai_Stats_Type_Stream_Cursor_Value_Input = {
  document_type?: InputMaybe<Scalars['String']>;
  success_ratio?: InputMaybe<Scalars['numeric']>;
  total?: InputMaybe<Scalars['bigint']>;
  types_match?: InputMaybe<Scalars['numeric']>;
  unknowns?: InputMaybe<Scalars['numeric']>;
  unknowns_pct?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "annotation_provider" */
export type Annotation_Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Annotation_Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Annotation_Provider_Stream_Cursor_Value_Input = {
  annotation_provider?: InputMaybe<Scalars['String']>;
  annotation_provider_id?: InputMaybe<Scalars['smallint']>;
};

/** Streaming cursor of the table "annotation_type" */
export type Annotation_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Annotation_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Annotation_Type_Stream_Cursor_Value_Input = {
  anno_schema?: InputMaybe<Scalars['json']>;
  anno_type_id?: InputMaybe<Scalars['smallint']>;
  annotation_provider_id?: InputMaybe<Scalars['smallint']>;
  annotation_schema?: InputMaybe<Scalars['jsonb']>;
  annotation_type?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  ui_schema?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "api_key" */
export type Api_Key_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Api_Key_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Api_Key_Stream_Cursor_Value_Input = {
  api_key?: InputMaybe<Scalars['String']>;
  dsplay_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "arrival_type" */
export type Arrival_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Arrival_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Arrival_Type_Stream_Cursor_Value_Input = {
  arrival_type?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "article" */
export type Article_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['smallint']>;
  code?: InputMaybe<Scalars['String']>;
  coords?: InputMaybe<Scalars['_int4']>;
  country_of_origin?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  doc_id?: InputMaybe<Scalars['uuid']>;
  gross_weight?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['String']>;
  hscode?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['String']>;
  marks?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  net_weight?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  page_id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['String']>;
  purchase_order_number?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  total_price?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  volume?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "bill_detail" */
export type Bill_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bill_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bill_Detail_Stream_Cursor_Value_Input = {
  bill_id?: InputMaybe<Scalars['bigint']>;
  charged_items?: InputMaybe<Scalars['bigint']>;
  const_charge?: InputMaybe<Scalars['numeric']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Scalars['bigint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  remark?: InputMaybe<Scalars['String']>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Scalars['smallint']>;
  srv_id?: InputMaybe<Scalars['Int']>;
  var_charge?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "bill" */
export type Bill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bill_Stream_Cursor_Value_Input = {
  bill_id?: InputMaybe<Scalars['bigint']>;
  /**
   * type of bill, e.g.
   *  - regular - ordianry bill.
   * also might be
   *  - correction
   *  - account_close
   *
   */
  bill_type?: InputMaybe<Scalars['name']>;
  from_ts?: InputMaybe<Scalars['timestamptz']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  payment_terms?: InputMaybe<Scalars['smallint']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
  to_ts?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "clearance_type" */
export type Clearance_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clearance_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clearance_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "containers" */
export type Containers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Containers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Containers_Stream_Cursor_Value_Input = {
  container_number?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "count_type" */
export type Count_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Count_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Count_Type_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "customs_office" */
export type Customs_Office_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customs_Office_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customs_Office_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  office_number?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "customs_offices" */
export type Customs_Offices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customs_Offices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customs_Offices_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  office_number?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "customs_response_data" */
export type Customs_Response_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customs_Response_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customs_Response_Data_Stream_Cursor_Value_Input = {
  correction_code?: InputMaybe<Scalars['smallint']>;
  doc_id?: InputMaybe<Scalars['uuid']>;
  document_version?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "customs_response_decoded" */
export type Customs_Response_Decoded_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customs_Response_Decoded_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customs_Response_Decoded_Stream_Cursor_Value_Input = {
  acceptance_date?: InputMaybe<Scalars['String']>;
  acceptance_time?: InputMaybe<Scalars['String']>;
  access_code?: InputMaybe<Scalars['String']>;
  consignee?: InputMaybe<Scalars['jsonb']>;
  consignor?: InputMaybe<Scalars['jsonb']>;
  customs_account?: InputMaybe<Scalars['jsonb']>;
  customs_clearance_type?: InputMaybe<Scalars['numeric']>;
  customs_office?: InputMaybe<Scalars['jsonb']>;
  declarant?: InputMaybe<Scalars['jsonb']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  dispatch_country?: InputMaybe<Scalars['String']>;
  doc_id?: InputMaybe<Scalars['uuid']>;
  document_type?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_additional_taxes?: InputMaybe<Scalars['jsonb']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  importer?: InputMaybe<Scalars['jsonb']>;
  incoterms?: InputMaybe<Scalars['String']>;
  invoice_currency_type?: InputMaybe<Scalars['String']>;
  number_of_goods_items?: InputMaybe<Scalars['bigint']>;
  packaging_quantity?: InputMaybe<Scalars['numeric']>;
  previous_document?: InputMaybe<Scalars['jsonb']>;
  special_mention?: InputMaybe<Scalars['jsonb']>;
  trader_declaration_number?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
  traderreference?: InputMaybe<Scalars['String']>;
  transport_in_container?: InputMaybe<Scalars['String']>;
  transport_means?: InputMaybe<Scalars['jsonb']>;
  valuation_summary?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
  vat?: InputMaybe<Scalars['jsonb']>;
  vat_account?: InputMaybe<Scalars['jsonb']>;
  vatnumber?: InputMaybe<Scalars['String']>;
  vatvalue?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "customs_response_goods_items" */
export type Customs_Response_Goods_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customs_Response_Goods_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customs_Response_Goods_Items_Stream_Cursor_Value_Input = {
  additional_unit?: InputMaybe<Scalars['jsonb']>;
  commercial_good?: InputMaybe<Scalars['String']>;
  commodity_code?: InputMaybe<Scalars['jsonb']>;
  customs_clearance_type?: InputMaybe<Scalars['String']>;
  customs_itemnumber?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['jsonb']>;
  doc_id?: InputMaybe<Scalars['uuid']>;
  document_type?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_total?: InputMaybe<Scalars['String']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  goods_item?: InputMaybe<Scalars['jsonb']>;
  grossmass?: InputMaybe<Scalars['jsonb']>;
  net_mass?: InputMaybe<Scalars['jsonb']>;
  non_customs_law_obligation?: InputMaybe<Scalars['jsonb']>;
  origin?: InputMaybe<Scalars['jsonb']>;
  origin_country?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['jsonb']>;
  permit_obligation?: InputMaybe<Scalars['jsonb']>;
  preference?: InputMaybe<Scalars['String']>;
  produced_document?: InputMaybe<Scalars['jsonb']>;
  statistic?: InputMaybe<Scalars['jsonb']>;
  statistical_code?: InputMaybe<Scalars['jsonb']>;
  statistical_value?: InputMaybe<Scalars['String']>;
  valuation_details?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
  vat_total?: InputMaybe<Scalars['String']>;
  vatvalue?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "customs_response_summary" */
export type Customs_Response_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customs_Response_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customs_Response_Summary_Stream_Cursor_Value_Input = {
  acceptance_date?: InputMaybe<Scalars['String']>;
  acceptance_dates?: InputMaybe<Scalars['_timestamp']>;
  acceptance_time?: InputMaybe<Scalars['String']>;
  consignee?: InputMaybe<Scalars['jsonb']>;
  consignor?: InputMaybe<Scalars['String']>;
  customs_account?: InputMaybe<Scalars['jsonb']>;
  customs_clearance_type?: InputMaybe<Scalars['numeric']>;
  customs_clearance_type_de?: InputMaybe<Scalars['String']>;
  customs_clearance_type_en?: InputMaybe<Scalars['String']>;
  customs_office?: InputMaybe<Scalars['jsonb']>;
  declarant?: InputMaybe<Scalars['jsonb']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  declaration_type_de?: InputMaybe<Scalars['String']>;
  declaration_type_en?: InputMaybe<Scalars['String']>;
  dispatch_country?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_additional_taxes?: InputMaybe<Scalars['jsonb']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  importer?: InputMaybe<Scalars['jsonb']>;
  incoterms?: InputMaybe<Scalars['String']>;
  invoice_currency_type?: InputMaybe<Scalars['String']>;
  number_of_goods_items?: InputMaybe<Scalars['bigint']>;
  packaging_quantity?: InputMaybe<Scalars['numeric']>;
  previous_document?: InputMaybe<Scalars['jsonb']>;
  special_mention?: InputMaybe<Scalars['jsonb']>;
  src_docs?: InputMaybe<Scalars['_uuid']>;
  src_doctypes?: InputMaybe<Scalars['_text']>;
  trader_declaration_number?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
  traderreference?: InputMaybe<Scalars['String']>;
  transport_means?: InputMaybe<Scalars['jsonb']>;
  valuation_summary?: InputMaybe<Scalars['jsonb']>;
  vat?: InputMaybe<Scalars['jsonb']>;
  vat_account?: InputMaybe<Scalars['jsonb']>;
  vatnumber?: InputMaybe<Scalars['String']>;
  vatvalue?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "declaration_discussion" */
export type Declaration_Discussion_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Discussion_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Discussion_Stream_Cursor_Value_Input = {
  /** Discussion is closed */
  closed?: InputMaybe<Scalars['Boolean']>;
  /** Creation date of discussion. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** User initiated discussion. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Scalars['bigint']>;
  /** Theme of discussion. */
  discussion_theme?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  /** File/Declaration related to discussion. */
  file_id?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "declaration_discussions" */
export type Declaration_Discussions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Discussions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Discussions_Stream_Cursor_Value_Input = {
  closed?: InputMaybe<Scalars['Boolean']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  discussion_id?: InputMaybe<Scalars['bigint']>;
  discussion_theme?: InputMaybe<Scalars['String']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  last_read_date?: InputMaybe<Scalars['timestamptz']>;
  liber_user?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  reference?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_document" */
export type Declaration_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Document_Stream_Cursor_Value_Input = {
  doc_id?: InputMaybe<Scalars['uuid']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "declaration_labels" */
export type Declaration_Labels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Labels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Labels_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "declaration_message" */
export type Declaration_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Message_Stream_Cursor_Value_Input = {
  /** declaration_message creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  discussion_id?: InputMaybe<Scalars['bigint']>;
  message?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  msg_date?: InputMaybe<Scalars['timestamptz']>;
  read_date?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_request_address_ai" */
export type Declaration_Request_Address_Ai_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Request_Address_Ai_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Request_Address_Ai_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['Int']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "declaration_request_address" */
export type Declaration_Request_Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Request_Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Request_Address_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['Int']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['json']>;
  refs?: InputMaybe<Scalars['_text']>;
  search_refs?: InputMaybe<Scalars['_text']>;
};

/** Streaming cursor of the table "declaration_request_labels" */
export type Declaration_Request_Labels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Request_Labels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Request_Labels_Stream_Cursor_Value_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  label_id?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "declaration_request" */
export type Declaration_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Request_Stream_Cursor_Value_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  /** Account number in CH customs */
  account_number?: InputMaybe<Scalars['String']>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  cev_status?: InputMaybe<Scalars['String']>;
  /** WeDeclare must create CH-Exportdeclaration */
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  /** Refer to values in table clearance_type. */
  clearance_type?: InputMaybe<Scalars['String']>;
  /** Date of creation of declaration request. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** User created declaration request. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['smallint']>;
  /** Refer to values in table declaration_status. */
  declaration_status?: InputMaybe<Scalars['String']>;
  /** Refer to values in table declaration_type. */
  declaration_type?: InputMaybe<Scalars['String']>;
  /** Destination Tolldept Code */
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  /** Destination Tolldept Name */
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Scalars['smallint']>;
  edec?: InputMaybe<Scalars['jsonb']>;
  eta?: InputMaybe<Scalars['timestamptz']>;
  /** File related to declaration request. Part of primary key */
  file_id?: InputMaybe<Scalars['uuid']>;
  /** WeDeclare must create the Import customs clearance in the destination Country */
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  /** Service:  Standard  oder Express */
  is_express?: InputMaybe<Scalars['Boolean']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  mrn_number?: InputMaybe<Scalars['String']>;
  /** Who is paying for customs declaration (tenant) */
  payer_id?: InputMaybe<Scalars['uuid']>;
  service_type?: InputMaybe<Scalars['String']>;
  /** Customs office number. Refer to customs_office table.office_number. */
  toll_dep?: InputMaybe<Scalars['String']>;
  /** Truck and Trailer Plate No. */
  tr_no?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  /** Type Transitdocument */
  transitdoc_type?: InputMaybe<Scalars['transitdoc_type']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_requests" */
export type Declaration_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Requests_Stream_Cursor_Value_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  account_number?: InputMaybe<Scalars['String']>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  autoclassified_docs_qty?: InputMaybe<Scalars['bigint']>;
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['smallint']>;
  declaration_status?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  eta?: InputMaybe<Scalars['timestamptz']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  is_express?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  permissions_js?: InputMaybe<Scalars['json']>;
  qty?: InputMaybe<Scalars['bigint']>;
  reference?: InputMaybe<Scalars['String']>;
  row_number?: InputMaybe<Scalars['bigint']>;
  toll_dep?: InputMaybe<Scalars['String']>;
  tr_no?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  transitdoc_type?: InputMaybe<Scalars['transitdoc_type']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_search" */
export type Declaration_Search_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Search_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Search_Stream_Cursor_Value_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  autoclassified_docs_qty?: InputMaybe<Scalars['bigint']>;
  classified_docs_qty?: InputMaybe<Scalars['bigint']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  company_name?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  declaration_status?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  docs_qty?: InputMaybe<Scalars['bigint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  eta?: InputMaybe<Scalars['timestamptz']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  identification?: InputMaybe<Scalars['String']>;
  is_express?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  qty?: InputMaybe<Scalars['bigint']>;
  reference?: InputMaybe<Scalars['String']>;
  user_display_name?: InputMaybe<Scalars['String']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Special_Mentions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Special_Mentions_Stream_Cursor_Value_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  sequence_number?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_status" */
export type Declaration_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Status_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration" */
export type Declaration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Stream_Cursor_Value_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  access_code?: InputMaybe<Scalars['String']>;
  agreed_location_of_goods?: InputMaybe<Scalars['String']>;
  ai_confirmed?: InputMaybe<Scalars['Boolean']>;
  ai_results?: InputMaybe<Scalars['jsonb']>;
  border_eau_number?: InputMaybe<Scalars['numeric']>;
  bunch_number?: InputMaybe<Scalars['Int']>;
  change_information?: InputMaybe<Scalars['date']>;
  clearance_location?: InputMaybe<Scalars['smallint']>;
  company_number_taxpayer?: InputMaybe<Scalars['String']>;
  correction_code?: InputMaybe<Scalars['Int']>;
  correction_reason?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_account_address_type?: InputMaybe<Scalars['Int']>;
  customs_account_name?: InputMaybe<Scalars['String']>;
  customs_account_number?: InputMaybe<Scalars['bigint']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_office_number?: InputMaybe<Scalars['String']>;
  declarant_company_name?: InputMaybe<Scalars['String']>;
  declarant_number?: InputMaybe<Scalars['Int']>;
  declaration_time?: InputMaybe<Scalars['smallint']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  delivery_destination?: InputMaybe<Scalars['bpchar']>;
  dispatch_country?: InputMaybe<Scalars['String']>;
  dispatch_country_confirmation?: InputMaybe<Scalars['Boolean']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_amount?: InputMaybe<Scalars['numeric']>;
  duty_total_amount?: InputMaybe<Scalars['numeric']>;
  evv_confirmed?: InputMaybe<Scalars['Boolean']>;
  evv_received?: InputMaybe<Scalars['Boolean']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  incoterms?: InputMaybe<Scalars['String']>;
  initiator?: InputMaybe<Scalars['smallint']>;
  injunction_type?: InputMaybe<Scalars['smallint']>;
  inspection_code?: InputMaybe<Scalars['Boolean']>;
  invoice_currency_type?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
  material_check?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  place_of_loading?: InputMaybe<Scalars['String']>;
  place_of_unloading?: InputMaybe<Scalars['String']>;
  postal_shipment_type?: InputMaybe<Scalars['String']>;
  procedure_type?: InputMaybe<Scalars['smallint']>;
  provisional_declaration_expiration_date?: InputMaybe<Scalars['date']>;
  reason?: InputMaybe<Scalars['String']>;
  receive_status?: InputMaybe<Scalars['Int']>;
  release?: InputMaybe<Scalars['Boolean']>;
  requestor_trader_identification_number?: InputMaybe<Scalars['String']>;
  security?: InputMaybe<Scalars['Boolean']>;
  selection_correlation_id?: InputMaybe<Scalars['String']>;
  send_date?: InputMaybe<Scalars['timestamptz']>;
  send_status?: InputMaybe<Scalars['Int']>;
  service_type?: InputMaybe<Scalars['String']>;
  show_in_wd?: InputMaybe<Scalars['Boolean']>;
  specific_circumstance_indicator?: InputMaybe<Scalars['bpchar']>;
  status?: InputMaybe<Scalars['Int']>;
  status_date?: InputMaybe<Scalars['date']>;
  status_time?: InputMaybe<Scalars['time']>;
  tara_factor?: InputMaybe<Scalars['numeric']>;
  total_colis?: InputMaybe<Scalars['Int']>;
  total_goods_items?: InputMaybe<Scalars['Int']>;
  total_gross_weight?: InputMaybe<Scalars['numeric']>;
  total_vat_value?: InputMaybe<Scalars['numeric']>;
  trader_declaration_number?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  transfer_to_transit_system?: InputMaybe<Scalars['Boolean']>;
  transport_country?: InputMaybe<Scalars['String']>;
  transport_in_container?: InputMaybe<Scalars['Boolean']>;
  transport_mode?: InputMaybe<Scalars['Int']>;
  transport_number?: InputMaybe<Scalars['String']>;
  transport_type?: InputMaybe<Scalars['String']>;
  unique_consignment_reference_number?: InputMaybe<Scalars['String']>;
  vat_account_address_type?: InputMaybe<Scalars['Int']>;
  vat_account_name?: InputMaybe<Scalars['String']>;
  vat_account_number?: InputMaybe<Scalars['bigint']>;
  vat_number?: InputMaybe<Scalars['String']>;
  vat_suffix?: InputMaybe<Scalars['Boolean']>;
  vat_total_amount?: InputMaybe<Scalars['numeric']>;
  warehouse_coded?: InputMaybe<Scalars['smallint']>;
};

/** Streaming cursor of the table "declaration_task" */
export type Declaration_Task_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Task_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Task_Stream_Cursor_Value_Input = {
  assigned_to?: InputMaybe<Scalars['uuid']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  due_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  object_id?: InputMaybe<Scalars['uuid']>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Scalars['Int']>;
  task_type_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_tasks_obj" */
export type Declaration_Tasks_Obj_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Tasks_Obj_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Tasks_Obj_Stream_Cursor_Value_Input = {
  tasks?: InputMaybe<Scalars['_declaration_tasks_data']>;
  total_finished?: InputMaybe<Scalars['bigint']>;
  total_opened?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "declaration_tasks" */
export type Declaration_Tasks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Tasks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Tasks_Stream_Cursor_Value_Input = {
  assigned_to?: InputMaybe<Scalars['uuid']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  due_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  object_id?: InputMaybe<Scalars['uuid']>;
  qty?: InputMaybe<Scalars['bigint']>;
  rn?: InputMaybe<Scalars['bigint']>;
  task_status_id?: InputMaybe<Scalars['Int']>;
  task_type_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_type" */
export type Declaration_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Type_Stream_Cursor_Value_Input = {
  document_schema?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "discussion_changes" */
export type Discussion_Changes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Discussion_Changes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Discussion_Changes_Stream_Cursor_Value_Input = {
  adit_user?: InputMaybe<Scalars['uuid']>;
  declaration_status?: InputMaybe<Scalars['String']>;
  discussion_closed?: InputMaybe<Scalars['Boolean']>;
  discussion_id?: InputMaybe<Scalars['bigint']>;
  discussion_theme?: InputMaybe<Scalars['String']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  file_name?: InputMaybe<Scalars['String']>;
  last_msg_date?: InputMaybe<Scalars['timestamptz']>;
  last_user?: InputMaybe<Scalars['uuid']>;
  liber_user?: InputMaybe<Scalars['uuid']>;
  reference?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "doc_annotation" */
export type Doc_Annotation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Annotation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Annotation_Stream_Cursor_Value_Input = {
  anno_type_id?: InputMaybe<Scalars['smallint']>;
  /** Document Id related to doc_annotation. */
  doc_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "doc_search_type" */
export type Doc_Search_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Search_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Search_Type_Stream_Cursor_Value_Input = {
  checksum?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  document_extension?: InputMaybe<Scalars['String']>;
  document_flags?: InputMaybe<Scalars['bigint']>;
  document_name?: InputMaybe<Scalars['String']>;
  document_status?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_generated?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  org_id_description?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
  total_rows?: InputMaybe<Scalars['bigint']>;
  user_code?: InputMaybe<Scalars['String']>;
  user_display_name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "doc_stats_type" */
export type Doc_Stats_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Stats_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Stats_Type_Stream_Cursor_Value_Input = {
  docs_qty?: InputMaybe<Scalars['bigint']>;
  document_type?: InputMaybe<Scalars['String']>;
  total_pages?: InputMaybe<Scalars['bigint']>;
  users_qty?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "docs_for_validation" */
export type Docs_For_Validation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Docs_For_Validation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Docs_For_Validation_Stream_Cursor_Value_Input = {
  checksum?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  doc_order?: InputMaybe<Scalars['bigint']>;
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  document_extension?: InputMaybe<Scalars['String']>;
  document_flags?: InputMaybe<Scalars['bigint']>;
  document_name?: InputMaybe<Scalars['String']>;
  document_status?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_customs_relevant?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_generated?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "document_extension" */
export type Document_Extension_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Extension_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Extension_Stream_Cursor_Value_Input = {
  /** document_extension creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** document_extension creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** document_extension last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified document_extension. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  thumbnails_supported?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "document_flag" */
export type Document_Flag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Flag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Flag_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']>;
  display?: InputMaybe<Scalars['Int']>;
  /** id of document_flag. */
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "document_label_org_id" */
export type Document_Label_Org_Id_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Label_Org_Id_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Label_Org_Id_Stream_Cursor_Value_Input = {
  label_id?: InputMaybe<Scalars['Int']>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Scalars['smallint']>;
};

/** Streaming cursor of the table "document_labels" */
export type Document_Labels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Labels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Labels_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  /** id of document_labels. */
  id?: InputMaybe<Scalars['Int']>;
  /** Marks document_labels record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  tenantId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "document_page" */
export type Document_Page_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Page_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Page_Stream_Cursor_Value_Input = {
  /** Document Id related to document_page. */
  document_id?: InputMaybe<Scalars['uuid']>;
  page_id?: InputMaybe<Scalars['uuid']>;
  page_number?: InputMaybe<Scalars['smallint']>;
};

/** Streaming cursor of the table "document_status" */
export type Document_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Status_Stream_Cursor_Value_Input = {
  /** document_status creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** document_status creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** document_status last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified document_status. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "document" */
export type Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Stream_Cursor_Value_Input = {
  /** MD5-checksum of document. */
  checksum?: InputMaybe<Scalars['String']>;
  /** document creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** document creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  document_extension?: InputMaybe<Scalars['String']>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Scalars['bigint']>;
  document_name?: InputMaybe<Scalars['String']>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  document_version?: InputMaybe<Scalars['Int']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Scalars['smallint']>;
  /** Document Id related to document. */
  file?: InputMaybe<Scalars['uuid']>;
  /** id of document. */
  id?: InputMaybe<Scalars['uuid']>;
  is_customs_relevant?: InputMaybe<Scalars['Boolean']>;
  /** Marks document record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_generated?: InputMaybe<Scalars['Boolean']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
  /** document last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified document. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Scalars['smallint']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Type_All_Tenant_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Type_All_Tenant_Settings_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  default_flags?: InputMaybe<Scalars['bigint']>;
  display_name?: InputMaybe<Scalars['String']>;
  document_schema?: InputMaybe<Scalars['jsonb']>;
  document_type?: InputMaybe<Scalars['String']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  tenant?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "document_type" */
export type Document_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Type_Stream_Cursor_Value_Input = {
  /** document_type creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** document_type creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** document_type last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified document_type. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Type_Tenant_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Type_Tenant_Settings_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  default_flags?: InputMaybe<Scalars['bigint']>;
  display_name?: InputMaybe<Scalars['String']>;
  document_schema?: InputMaybe<Scalars['jsonb']>;
  document_type?: InputMaybe<Scalars['String']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  tenant?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "dr_goods_item" */
export type Dr_Goods_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dr_Goods_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dr_Goods_Item_Stream_Cursor_Value_Input = {
  additional_pcs?: InputMaybe<Scalars['numeric']>;
  amount?: InputMaybe<Scalars['jsonb']>;
  certificates?: InputMaybe<Scalars['jsonb']>;
  commodity_code?: InputMaybe<Scalars['String']>;
  customs_net_mass?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  key?: InputMaybe<Scalars['numeric']>;
  net_declaration?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  non_customs_law_obligation?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<Scalars['jsonb']>;
  packaging?: InputMaybe<Scalars['jsonb']>;
  revision?: InputMaybe<Scalars['Boolean']>;
  /** where good_item coming from, 0 - api, 1 - ai-service */
  source?: InputMaybe<Scalars['smallint']>;
  statistic?: InputMaybe<Scalars['jsonb']>;
  statistical_code?: InputMaybe<Scalars['String']>;
  traded_goods?: InputMaybe<Scalars['Boolean']>;
  trader_item_id?: InputMaybe<Scalars['Int']>;
  valuation?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "dr_goods_items" */
export type Dr_Goods_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dr_Goods_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dr_Goods_Items_Stream_Cursor_Value_Input = {
  certificates?: InputMaybe<Scalars['jsonb']>;
  commodity_code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  non_customs_law_obligation?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<Scalars['jsonb']>;
  origin_country?: InputMaybe<Scalars['String']>;
  origin_preference?: InputMaybe<Scalars['Int']>;
  packaging?: InputMaybe<Scalars['_jsonb']>;
  qty?: InputMaybe<Scalars['bigint']>;
  rn?: InputMaybe<Scalars['bigint']>;
  statistic?: InputMaybe<Scalars['jsonb']>;
  statistic_commercial_good?: InputMaybe<Scalars['Int']>;
  statistic_customs_clearance_type?: InputMaybe<Scalars['Int']>;
  statistic_repair?: InputMaybe<Scalars['Int']>;
  statistic_statistical_value?: InputMaybe<Scalars['Int']>;
  trader_item_id?: InputMaybe<Scalars['Int']>;
  valuation?: InputMaybe<Scalars['jsonb']>;
  valuation_vat_code?: InputMaybe<Scalars['Int']>;
  valuation_vat_value?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "dr_stats" */
export type Dr_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dr_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dr_Stats_Stream_Cursor_Value_Input = {
  metric_id?: InputMaybe<Scalars['String']>;
  metric_label?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
  tenant_name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "edec_countries" */
export type Edec_Countries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Edec_Countries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Edec_Countries_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  iso_code?: InputMaybe<Scalars['bpchar']>;
  name_de?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_it?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "edec_customs_offices" */
export type Edec_Customs_Offices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Edec_Customs_Offices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Edec_Customs_Offices_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "edec_domains" */
export type Edec_Domains_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Edec_Domains_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Edec_Domains_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  domain_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  meaning_de?: InputMaybe<Scalars['String']>;
  meaning_en?: InputMaybe<Scalars['String']>;
  meaning_fr?: InputMaybe<Scalars['String']>;
  meaning_it?: InputMaybe<Scalars['String']>;
  valid_for_export?: InputMaybe<Scalars['Boolean']>;
  valid_for_import?: InputMaybe<Scalars['Boolean']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
  value?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "edec_tariff_commodity_code" */
export type Edec_Tariff_Commodity_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Edec_Tariff_Commodity_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Edec_Tariff_Commodity_Code_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  valid_for_export?: InputMaybe<Scalars['Boolean']>;
  valid_for_import?: InputMaybe<Scalars['Boolean']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
  value?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "edec_tariff_statistical_code" */
export type Edec_Tariff_Statistical_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Edec_Tariff_Statistical_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Edec_Tariff_Statistical_Code_Stream_Cursor_Value_Input = {
  commodity_code_id?: InputMaybe<Scalars['Int']>;
  created?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  lower_scale_weight?: InputMaybe<Scalars['numeric']>;
  scale_weight_code?: InputMaybe<Scalars['Int']>;
  storage_type?: InputMaybe<Scalars['String']>;
  upper_scale_weight?: InputMaybe<Scalars['numeric']>;
  valid_for_export?: InputMaybe<Scalars['Boolean']>;
  valid_for_import?: InputMaybe<Scalars['Boolean']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
  value?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "email_search_type" */
export type Email_Search_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Search_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Search_Type_Stream_Cursor_Value_Input = {
  attachments?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  file_status?: InputMaybe<Scalars['String']>;
  file_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  total_rows?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "extract_type" */
export type Extract_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Extract_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Extract_Type_Stream_Cursor_Value_Input = {
  extract_type_id?: InputMaybe<Scalars['smallint']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Scalars['json']>;
};

/** Streaming cursor of the table "extraction_config" */
export type Extraction_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Extraction_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Extraction_Config_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  aliases?: InputMaybe<Scalars['jsonb']>;
  document_templates?: InputMaybe<Scalars['jsonb']>;
  foun_config?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "file_stats_type" */
export type File_Stats_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Stats_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Stats_Type_Stream_Cursor_Value_Input = {
  file_flags?: InputMaybe<Scalars['String']>;
  file_flags_id?: InputMaybe<Scalars['bigint']>;
  qty?: InputMaybe<Scalars['bigint']>;
  users_qty?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "file" */
export type File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Stream_Cursor_Value_Input = {
  ai_doc_classification_confirmed?: InputMaybe<Scalars['Boolean']>;
  /** file creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** file creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  file_flags?: InputMaybe<Scalars['bigint']>;
  file_status?: InputMaybe<Scalars['String']>;
  file_type?: InputMaybe<Scalars['String']>;
  file_url?: InputMaybe<Scalars['String']>;
  /** id of file. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Is usually set automatically by AQW.IdentificationProvider.
   *
   * AQW.IdentificationProvider can be set in tenant settings either DefaultProvider (random uuid) or a company specific provider which calls an external API endpoint.
   *
   */
  identification?: InputMaybe<Scalars['String']>;
  /** Marks file record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  /** file last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified file. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  /** Org_id related to file. */
  org_id?: InputMaybe<Scalars['smallint']>;
  session_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "file_type" */
export type File_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  doc_types?: InputMaybe<Scalars['_varchar']>;
  file_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Goods_Item_Special_Mentions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Goods_Item_Special_Mentions_Stream_Cursor_Value_Input = {
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  sequence_number?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "goods_item" */
export type Goods_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Goods_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Goods_Item_Stream_Cursor_Value_Input = {
  additional_unit?: InputMaybe<Scalars['String']>;
  additional_unit_confirmation?: InputMaybe<Scalars['Boolean']>;
  billing_type?: InputMaybe<Scalars['smallint']>;
  clearance_type?: InputMaybe<Scalars['Int']>;
  commercial_good?: InputMaybe<Scalars['Boolean']>;
  commodity_code?: InputMaybe<Scalars['String']>;
  commodity_code_confirmation?: InputMaybe<Scalars['Boolean']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_favour_code?: InputMaybe<Scalars['Int']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  customs_net_weight?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['smallint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_total?: InputMaybe<Scalars['numeric']>;
  duty_rate?: InputMaybe<Scalars['numeric']>;
  duty_total?: InputMaybe<Scalars['numeric']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  gross_mass_confirmation?: InputMaybe<Scalars['Boolean']>;
  net_duty?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  net_mass_confirmation?: InputMaybe<Scalars['Boolean']>;
  non_customs_law_obligation?: InputMaybe<Scalars['smallint']>;
  origin_country?: InputMaybe<Scalars['String']>;
  origin_preference?: InputMaybe<Scalars['Boolean']>;
  permit_obligation_code?: InputMaybe<Scalars['Int']>;
  preference_confirmation?: InputMaybe<Scalars['Boolean']>;
  process_type?: InputMaybe<Scalars['smallint']>;
  rate_confirmation?: InputMaybe<Scalars['Boolean']>;
  refinement_type?: InputMaybe<Scalars['smallint']>;
  refund_type?: InputMaybe<Scalars['smallint']>;
  repair?: InputMaybe<Scalars['Boolean']>;
  repair_reason?: InputMaybe<Scalars['String']>;
  selection_result?: InputMaybe<Scalars['Int']>;
  statistical_code?: InputMaybe<Scalars['Int']>;
  statistical_value?: InputMaybe<Scalars['Int']>;
  statistical_value_confirmation?: InputMaybe<Scalars['Boolean']>;
  storage_type?: InputMaybe<Scalars['smallint']>;
  tare_supplement?: InputMaybe<Scalars['numeric']>;
  tare_supplement_confirmation?: InputMaybe<Scalars['Boolean']>;
  un_dangerous_goods_code?: InputMaybe<Scalars['String']>;
  vat_code?: InputMaybe<Scalars['smallint']>;
  vat_code_confirmation?: InputMaybe<Scalars['Boolean']>;
  vat_rate?: InputMaybe<Scalars['numeric']>;
  vat_total?: InputMaybe<Scalars['numeric']>;
  vat_value?: InputMaybe<Scalars['numeric']>;
  vat_value_confirmation?: InputMaybe<Scalars['Boolean']>;
  voc_quantity?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "goods_items_for_drs" */
export type Goods_Items_For_Drs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Goods_Items_For_Drs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Goods_Items_For_Drs_Stream_Cursor_Value_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  account_number?: InputMaybe<Scalars['String']>;
  additional_unit?: InputMaybe<Scalars['jsonb']>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  autoclassified_docs_qty?: InputMaybe<Scalars['bigint']>;
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  commercial_good?: InputMaybe<Scalars['String']>;
  commodity_code?: InputMaybe<Scalars['jsonb']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_clearance_type?: InputMaybe<Scalars['String']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['smallint']>;
  customs_itemnumber?: InputMaybe<Scalars['jsonb']>;
  declaration_status?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  doc_id?: InputMaybe<Scalars['uuid']>;
  document_type?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_total?: InputMaybe<Scalars['String']>;
  eta?: InputMaybe<Scalars['timestamptz']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  goods_item?: InputMaybe<Scalars['jsonb']>;
  grossmass?: InputMaybe<Scalars['jsonb']>;
  hs_code?: InputMaybe<Scalars['String']>;
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  is_express?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  net_mass?: InputMaybe<Scalars['jsonb']>;
  non_customs_law_obligation?: InputMaybe<Scalars['jsonb']>;
  nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  origin?: InputMaybe<Scalars['jsonb']>;
  origin_country?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['jsonb']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  permissions_js?: InputMaybe<Scalars['json']>;
  permit_obligation?: InputMaybe<Scalars['jsonb']>;
  preference?: InputMaybe<Scalars['String']>;
  produced_document?: InputMaybe<Scalars['jsonb']>;
  qty?: InputMaybe<Scalars['bigint']>;
  reference?: InputMaybe<Scalars['String']>;
  row_number?: InputMaybe<Scalars['bigint']>;
  statistic?: InputMaybe<Scalars['jsonb']>;
  statistical_code?: InputMaybe<Scalars['jsonb']>;
  statistical_value?: InputMaybe<Scalars['String']>;
  toll_dep?: InputMaybe<Scalars['String']>;
  tr_no?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  transitdoc_type?: InputMaybe<Scalars['transitdoc_type']>;
  valuation_details?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
  vat_total?: InputMaybe<Scalars['String']>;
  vatvalue?: InputMaybe<Scalars['String']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "group_member" */
export type Group_Member_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Group_Member_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Group_Member_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['smallint']>;
  clearance_types?: InputMaybe<Scalars['_text']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  declaration_types?: InputMaybe<Scalars['_text']>;
  group_id?: InputMaybe<Scalars['smallint']>;
  permissions_js?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "group_members" */
export type Group_Members_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Group_Members_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Group_Members_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['String']>;
  business_case?: InputMaybe<Scalars['bc_name']>;
  clearance_types?: InputMaybe<Scalars['_text']>;
  company_name?: InputMaybe<Scalars['String']>;
  declaration_types?: InputMaybe<Scalars['_text']>;
  group_id?: InputMaybe<Scalars['smallint']>;
  group_name?: InputMaybe<Scalars['String']>;
  payer_address?: InputMaybe<Scalars['Int']>;
  payer_company?: InputMaybe<Scalars['String']>;
  payer_tenant?: InputMaybe<Scalars['uuid']>;
  payer_type?: InputMaybe<Scalars['String']>;
  permissions_js?: InputMaybe<Scalars['jsonb']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "import_list_trigger" */
export type Import_List_Trigger_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Import_List_Trigger_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Import_List_Trigger_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  label_id?: InputMaybe<Scalars['Int']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "intf_dr_payment_info" */
export type Intf_Dr_Payment_Info_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Intf_Dr_Payment_Info_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Intf_Dr_Payment_Info_Stream_Cursor_Value_Input = {
  addresses?: InputMaybe<Scalars['_int4']>;
  addresses_qi?: InputMaybe<Scalars['String']>;
  payer?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "json_type" */
export type Json_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Json_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Json_Type_Stream_Cursor_Value_Input = {
  json_value?: InputMaybe<Scalars['json']>;
};

/** Streaming cursor of the table "kc_users" */
export type Kc_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Kc_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Kc_Users_Stream_Cursor_Value_Input = {
  adit_permissions?: InputMaybe<Scalars['bigint']>;
  adit_permissions_desk?: InputMaybe<Scalars['_txtcode']>;
  adit_permissions_hex?: InputMaybe<Scalars['String']>;
  adit_roles?: InputMaybe<Scalars['jsonb']>;
  attrs?: InputMaybe<Scalars['jsonb']>;
  code?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamptz']>;
  default_role?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  federation_link?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  liber_roles?: InputMaybe<Scalars['jsonb']>;
  location?: InputMaybe<Scalars['String']>;
  not_before?: InputMaybe<Scalars['Int']>;
  org_ids?: InputMaybe<Scalars['jsonb']>;
  phone_number?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['bigint']>;
  realm_id?: InputMaybe<Scalars['String']>;
  required_actions?: InputMaybe<Scalars['_varchar']>;
  service_account_client_link?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  user_client_roles?: InputMaybe<Scalars['jsonb']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  username?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "max_date_type" */
export type Max_Date_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Max_Date_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Max_Date_Type_Stream_Cursor_Value_Input = {
  max_change_date?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "model_retrain" */
export type Model_Retrain_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Model_Retrain_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Retrain_Stream_Cursor_Value_Input = {
  end_time?: InputMaybe<Scalars['timestamptz']>;
  error_message?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  request_time?: InputMaybe<Scalars['timestamptz']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "org_id" */
export type Org_Id_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Id_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Id_Stream_Cursor_Value_Input = {
  /** can org_id be used to create new files in adit. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** org_id creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** org_id creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** org_id last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified org_id. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Scalars['smallint']>;
  org_id_description?: InputMaybe<Scalars['String']>;
  /** Tenant of org_id. */
  tenant_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "org_ids" */
export type Org_Ids_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Ids_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Ids_Stream_Cursor_Value_Input = {
  addresses_desc?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  docs_affected?: InputMaybe<Scalars['_uuid']>;
  files_affected?: InputMaybe<Scalars['_uuid']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  org_id_description?: InputMaybe<Scalars['String']>;
  org_ids_desc?: InputMaybe<Scalars['String']>;
  org_params?: InputMaybe<Scalars['json']>;
  qty?: InputMaybe<Scalars['bigint']>;
  users_affected?: InputMaybe<Scalars['_uuid']>;
};

/** Streaming cursor of the table "org_params_org_id" */
export type Org_Params_Org_Id_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Params_Org_Id_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Params_Org_Id_Stream_Cursor_Value_Input = {
  org_id?: InputMaybe<Scalars['Int']>;
  param_org_id?: InputMaybe<Scalars['smallint']>;
};

/** Streaming cursor of the table "org_params" */
export type Org_Params_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Params_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Params_Stream_Cursor_Value_Input = {
  addresses?: InputMaybe<Scalars['query_int']>;
  file_ids?: InputMaybe<Scalars['_uuid']>;
  org_id?: InputMaybe<Scalars['Int']>;
  org_ids?: InputMaybe<Scalars['_int2']>;
  search?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "packagings" */
export type Packagings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Packagings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Packagings_Stream_Cursor_Value_Input = {
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  packaging_reference_number?: InputMaybe<Scalars['String']>;
  packaging_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "page_extract" */
export type Page_Extract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Page_Extract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Page_Extract_Stream_Cursor_Value_Input = {
  extract_type_id?: InputMaybe<Scalars['smallint']>;
  page_id?: InputMaybe<Scalars['uuid']>;
  tables?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "page_status" */
export type Page_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Page_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Page_Status_Stream_Cursor_Value_Input = {
  /** page_status creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** page_status creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** page_status last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified page_status. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "page" */
export type Page_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Page_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Page_Stream_Cursor_Value_Input = {
  ai_ignore_retraining?: InputMaybe<Scalars['Boolean']>;
  /** page creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** page creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** id of page. */
  id?: InputMaybe<Scalars['uuid']>;
  /** page last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified page. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  ocr_text?: InputMaybe<Scalars['String']>;
  page_status?: InputMaybe<Scalars['String']>;
  rotate?: InputMaybe<Scalars['smallint']>;
  thumbnail_big_url?: InputMaybe<Scalars['String']>;
  thumbnail_small_url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "pages_m2m_cache" */
export type Pages_M2m_Cache_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pages_M2m_Cache_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pages_M2m_Cache_Stream_Cursor_Value_Input = {
  document_id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  page?: InputMaybe<Scalars['uuid']>;
  page_number?: InputMaybe<Scalars['bigint']>;
  page_status?: InputMaybe<Scalars['String']>;
  rotate?: InputMaybe<Scalars['Int']>;
  thumbnail_big_url?: InputMaybe<Scalars['String']>;
  thumbnail_small_url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "permits" */
export type Permits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Permits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permits_Stream_Cursor_Value_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  issue_date?: InputMaybe<Scalars['date']>;
  permit_authority?: InputMaybe<Scalars['Int']>;
  permit_item_details?: InputMaybe<Scalars['jsonb']>;
  permit_number?: InputMaybe<Scalars['String']>;
  permit_type?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "pp_types_file_search" */
export type Pp_Types_File_Search_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pp_Types_File_Search_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pp_Types_File_Search_Stream_Cursor_Value_Input = {
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_relevant?: InputMaybe<Scalars['Boolean']>;
  customs_relevant_qty?: InputMaybe<Scalars['bigint']>;
  extraction_completed_qty?: InputMaybe<Scalars['bigint']>;
  extraction_required?: InputMaybe<Scalars['Boolean']>;
  extraction_required_qty?: InputMaybe<Scalars['bigint']>;
  file_flags?: InputMaybe<Scalars['bigint']>;
  file_status?: InputMaybe<Scalars['String']>;
  file_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  identification?: InputMaybe<Scalars['String']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  org_id_description?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  total_rows?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "previous_documents" */
export type Previous_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Previous_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Previous_Documents_Stream_Cursor_Value_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  previous_document_reference?: InputMaybe<Scalars['String']>;
  previous_document_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "produced_documents" */
export type Produced_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Produced_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Produced_Documents_Stream_Cursor_Value_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  produced_document_issue_date?: InputMaybe<Scalars['date']>;
  produced_document_reference_number?: InputMaybe<Scalars['String']>;
  produced_document_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "report" */
export type Report_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Report_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Report_Stream_Cursor_Value_Input = {
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  md5?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "service_rate" */
export type Service_Rate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Rate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Rate_Stream_Cursor_Value_Input = {
  const_included?: InputMaybe<Scalars['Int']>;
  const_rate?: InputMaybe<Scalars['numeric']>;
  srv_id?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
  var_rate?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "service" */
export type Service_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Stream_Cursor_Value_Input = {
  srv_desk?: InputMaybe<Scalars['String']>;
  srv_id?: InputMaybe<Scalars['Int']>;
  srv_type?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "service_tariff" */
export type Service_Tariff_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Tariff_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Tariff_Stream_Cursor_Value_Input = {
  direct_upload_cost?: InputMaybe<Scalars['numeric']>;
  email_upload_cost?: InputMaybe<Scalars['numeric']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  position_cost?: InputMaybe<Scalars['numeric']>;
  positions_included?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "setting_group" */
export type Setting_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Setting_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Setting_Group_Stream_Cursor_Value_Input = {
  /** setting_group creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** setting_group creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  /** id of setting_group. */
  id?: InputMaybe<Scalars['uuid']>;
  /** setting_group last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified setting_group. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "setting" */
export type Setting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Setting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Setting_Stream_Cursor_Value_Input = {
  constrained?: InputMaybe<Scalars['Boolean']>;
  /** setting creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** setting creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  data_type?: InputMaybe<Scalars['String']>;
  default_value?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** id of setting. */
  id?: InputMaybe<Scalars['uuid']>;
  identifier?: InputMaybe<Scalars['String']>;
  /** setting last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified setting. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  max_value?: InputMaybe<Scalars['numeric']>;
  min_value?: InputMaybe<Scalars['numeric']>;
  setting_group_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "setting_value" */
export type Setting_Value_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Setting_Value_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Setting_Value_Stream_Cursor_Value_Input = {
  /** setting_value creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** setting_value creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** id of setting_value. */
  id?: InputMaybe<Scalars['uuid']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
  /** setting_value last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified setting_value. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  reference_id?: InputMaybe<Scalars['String']>;
  reference_type_id?: InputMaybe<Scalars['String']>;
  setting_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "tariff_number_description" */
export type Tariff_Number_Description_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tariff_Number_Description_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tariff_Number_Description_Stream_Cursor_Value_Input = {
  description_de?: InputMaybe<Scalars['String']>;
  hierarchy_path?: InputMaybe<Scalars['ltree']>;
  hierarchy_visual?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  parent_id?: InputMaybe<Scalars['Int']>;
  tariff_number?: InputMaybe<Scalars['String']>;
  tsv?: InputMaybe<Scalars['tsvector']>;
};

/** Streaming cursor of the table "task_type" */
export type Task_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Type_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "tenant" */
export type Tenant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenant_Stream_Cursor_Value_Input = {
  /** Swiss Customs account number */
  account_number?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['Int']>;
  /** tenant creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** tenant creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** id of tenant. */
  id?: InputMaybe<Scalars['uuid']>;
  is_wd_customer?: InputMaybe<Scalars['Boolean']>;
  /** tenant last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified tenant. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  permissions?: InputMaybe<Scalars['bit']>;
  permissions_js?: InputMaybe<Scalars['jsonb']>;
  tenant_name?: InputMaybe<Scalars['String']>;
  tenant_type?: InputMaybe<Scalars['tenant_type']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "tenants" */
export type Tenants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenants_Stream_Cursor_Value_Input = {
  address_groups?: InputMaybe<Scalars['_int2']>;
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  permissions?: InputMaybe<Scalars['String']>;
  permissions_desk?: InputMaybe<Scalars['_txtcode']>;
  qty?: InputMaybe<Scalars['bigint']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
  tenant_name?: InputMaybe<Scalars['String']>;
  tenant_type?: InputMaybe<Scalars['tenant_type']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "transitdoc_type_descr" */
export type Transitdoc_Type_Descr_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transitdoc_Type_Descr_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transitdoc_Type_Descr_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  transitdoc_type?: InputMaybe<Scalars['transitdoc_type']>;
};

/** Streaming cursor of the table "user_org_id" */
export type User_Org_Id_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Org_Id_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Org_Id_Stream_Cursor_Value_Input = {
  /** user_org_id creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** user_org_id creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** user_org_id last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified user_org_id. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Scalars['smallint']>;
  user_pp?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_pp" */
export type User_Pp_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Pp_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Pp_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  /** User creation date */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** user_pp creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_by_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  /** id of user_pp. */
  id?: InputMaybe<Scalars['uuid']>;
  /** user_pp last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified user_pp. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  ldap_entry_dn?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  oauth_id?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['bit']>;
  phone_number?: InputMaybe<Scalars['String']>;
  /** Tenant of user_pp. */
  tenant_id?: InputMaybe<Scalars['uuid']>;
  ui_settings?: InputMaybe<Scalars['jsonb']>;
  ui_settings_templates?: InputMaybe<Scalars['jsonb']>;
  user_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_search_type" */
export type User_Search_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Search_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Search_Type_Stream_Cursor_Value_Input = {
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['json']>;
  total_rows?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  orgs?: InputMaybe<Scalars['_int2']>;
  permissions?: InputMaybe<Scalars['String']>;
  permissions_desk?: InputMaybe<Scalars['_txtcode']>;
  tenant?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "view_document_history" */
export type View_Document_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_Document_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_Document_History_Stream_Cursor_Value_Input = {
  action_title?: InputMaybe<Scalars['String']>;
  action_user?: InputMaybe<Scalars['uuid']>;
  action_value?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  op_date?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "view_file_history" */
export type View_File_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_File_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_File_History_Stream_Cursor_Value_Input = {
  action_title?: InputMaybe<Scalars['String']>;
  action_user?: InputMaybe<Scalars['uuid']>;
  action_value?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  op_date?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "view_history" */
export type View_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_History_Stream_Cursor_Value_Input = {
  action_title?: InputMaybe<Scalars['String']>;
  action_user?: InputMaybe<Scalars['uuid']>;
  action_value?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  op_date?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "vw_documents" */
export type Vw_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Documents_Stream_Cursor_Value_Input = {
  checksum?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  document_extension?: InputMaybe<Scalars['String']>;
  document_flags?: InputMaybe<Scalars['bigint']>;
  document_name?: InputMaybe<Scalars['String']>;
  document_status?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_customs_relevant?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_generated?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "vw_finished_files" */
export type Vw_Finished_Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Finished_Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Finished_Files_Stream_Cursor_Value_Input = {
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  file_flags?: InputMaybe<Scalars['bigint']>;
  file_status?: InputMaybe<Scalars['String']>;
  file_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  identification?: InputMaybe<Scalars['String']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  session_id?: InputMaybe<Scalars['String']>;
};

export type AditGetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AditGetCurrentUserQuery = { user: { firstName: string | null, lastName: string | null, email: string, uiSettings: any, tenantId: any, userId: string, modules: Array<{ name: string }> | null } };

export type AditGetCurrentUserTenantConfigQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type AditGetCurrentUserTenantConfigQuery = { getTenantConfig: any | null };

export type AditUpdateCurrentUserUiSettingsMutationVariables = Exact<{
  id: Scalars['uuid'];
  ui_settings: Scalars['jsonb'];
}>;


export type AditUpdateCurrentUserUiSettingsMutation = { update_user_pp_by_pk: { id: any } | null };

export type AditGetAddressesListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type AditGetAddressesListQuery = { addresses: Array<{ id: number, companyName: string, companyName2: string | null, country: string | null, city: string | null, street: string | null, zipcode: string | null, usageFrequency: number, customsAccountNumber: string | null, traderIdentificationNumber: string | null, vatAccountNumber: string | null, uidNumber: string | null, isLocked: boolean, reference: string | null, isPlatformUser: boolean }> };

export type AdiAddressesListFragmentFragment = { id: number, companyName: string, companyName2: string | null, country: string | null, city: string | null, street: string | null, zipcode: string | null, usageFrequency: number, customsAccountNumber: string | null, traderIdentificationNumber: string | null, vatAccountNumber: string | null, uidNumber: string | null, isLocked: boolean, reference: string | null, isPlatformUser: boolean };

export type AditSearchAddressQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AditSearchAddressQuery = { addresses: Array<{ id: number, company_name: string, street: string | null, street_number: string | null, country: string | null, zipcode: string | null, city: string | null, reference: string | null, customs_account_number: string | null, vat_account_number: string | null }> };

export type AditGetCommodityCodesListQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AditGetCommodityCodesListQuery = { commodityCodes: Array<{ id: number, commodityCode: string | null, descriptionDe: string, hierarchyVisual: string | null }> };

export type AditUpdateDeclarationAiConfirmedMutationVariables = Exact<{
  file_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
  ai_confirmed: Scalars['Boolean'];
}>;


export type AditUpdateDeclarationAiConfirmedMutation = { update_declaration_by_pk: { file_id: any, dr_no: any } | null };

export type Adit_Delete_GooditemsMutationVariables = Exact<{
  file_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
  trader_item_id: Scalars['Int'];
  source: Scalars['smallint'];
}>;


export type Adit_Delete_GooditemsMutation = { delete_dr_goods_item: { affected_rows: number } | null };

export type AditGetDeclarationQueryVariables = Exact<{
  file_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
}>;


export type AditGetDeclarationQuery = { declarations: Array<{ file_id: any, dr_no: any, ai_results: any, ai_confirmed: boolean | null, file: { identification: string | null }, declaration_request: { cev_status: string | null } | null }>, declarationsForm: Array<{ file_id: any, dr_no: any, send_status: number | null, declarant_number: number | null, trader_identification_number: string | null, send_date: any | null, receive_status: number | null, acceptance_date: any | null, customs_declaration_number: string | null, trader_reference: string | null, duty_total_amount: any | null, vat_total_amount: any | null, customs_declaration_version: number | null, material_check: boolean | null, release: boolean | null, gross_mass: any | null, net_mass: any | null, transport_mode: number | null, transport_type: string | null, transport_country: string | null, transport_number: string | null, service_type: string | null, invoice_currency_type: string | null, clearance_location: any | null, place_of_unloading: string | null, declaration_time: any | null, declaration_type: string | null, reason: string | null, lang: string | null, customs_office_number: string | null, dispatch_country: string | null, dispatch_country_confirmation: boolean | null, correction_code: number | null, correction_reason: string | null, transport_in_container: boolean | null, incoterms: string | null, customs_account_address_type: number | null, customs_account_number: any | null, vat_account_address_type: number | null, vat_account_number: any | null, vat_number: string | null, addresses: Array<{ address_type: number, address_id: number | null, refs: any, address: { id: number, company_name: string, street: string | null, street_number: string | null, country: string | null, zipcode: string | null, city: string | null, reference: string | null, customs_account_number: string | null, vat_account_number: string | null } | null }>, previous_documents: Array<{ id: number, previous_document_type: string | null, previous_document_reference: string | null, additional_information: string | null }>, containers: Array<{ id: number, container_number: string | null }>, declaration_special_mentions: Array<{ id: number, sequence_number: number | null, text: string | null }>, goods_items: Array<{ customs_item_number: number, selection_result: number | null, commodity_code: string | null, commodity_code_confirmation: boolean | null, statistical_code: number | null, duty_rate: any | null, rate_confirmation: boolean | null, description: string | null, net_duty: boolean | null, net_mass: any | null, net_mass_confirmation: boolean | null, tare_supplement: any | null, tare_supplement_confirmation: boolean | null, gross_mass: any | null, gross_mass_confirmation: boolean | null, customs_net_weight: any | null, additional_unit: string | null, additional_unit_confirmation: boolean | null, commercial_good: boolean | null, clearance_type: number | null, customs_favour_code: number | null, origin_country: string | null, origin_preference: boolean | null, preference_confirmation: boolean | null, vat_code: any | null, vat_code_confirmation: boolean | null, statistical_value: number | null, statistical_value_confirmation: boolean | null, vat_value: any | null, vat_value_confirmation: boolean | null, repair: boolean | null, packagings: Array<{ id: number, packaging_type: string | null, packaging_quantity: number | null, packaging_reference_number: string | null }>, produced_documents: Array<{ id: number, produced_document_type: string | null, produced_document_reference_number: string | null, produced_document_issue_date: any | null, additional_information: string | null }> }> }> };

export type AditGetDeclarationGoodsItemsQueryVariables = Exact<{
  file_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
}>;


export type AditGetDeclarationGoodsItemsQuery = { goods_items: Array<{ additional_unit: string | null, additional_unit_confirmation: boolean | null, billing_type: any | null, clearance_type: number | null, commercial_good: boolean | null, commodity_code: string | null, commodity_code_confirmation: boolean | null, customs_declaration_version: number | null, customs_favour_code: number | null, customs_item_number: number, customs_net_weight: any | null, description: string | null, direction: any | null, dr_no: any, duty_and_other_taxes_total: any | null, duty_rate: any | null, duty_total: any | null, file_id: any, gross_mass_confirmation: boolean | null, gross_mass: any | null, net_duty: boolean | null, net_mass: any | null, net_mass_confirmation: boolean | null, non_customs_law_obligation: any | null, origin_country: string | null, origin_preference: boolean | null, permit_obligation_code: number | null, preference_confirmation: boolean | null, process_type: any | null, rate_confirmation: boolean | null, refinement_type: any | null, refund_type: any | null, repair: boolean | null, repair_reason: string | null, selection_result: number | null, statistical_code: number | null, statistical_value: number | null, storage_type: any | null, tare_supplement_confirmation: boolean | null, tare_supplement: any | null, un_dangerous_goods_code: string | null, vat_code: any | null, vat_code_confirmation: boolean | null, vat_rate: any | null, vat_total: any | null, vat_value: any | null, vat_value_confirmation: boolean | null, voc_quantity: any | null, packagings: Array<{ packaging_type: string | null, packaging_quantity: number | null, packaging_reference_number: string | null }>, produced_documents: Array<{ produced_document_type: string | null, produced_document_reference_number: string | null, produced_document_issue_date: any | null, additional_information: string | null }> }> };

export type AditGetDeclarationLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type AditGetDeclarationLabelsQuery = { declarationLabels: Array<{ tenant_id: any, id: number, title: any, color: string, tenant: { tenant_name: string } }> };

export type AditGetDeclarationRequestAddressesAiQueryVariables = Exact<{
  file_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
}>;


export type AditGetDeclarationRequestAddressesAiQuery = { declaration_request_addresses_ai: Array<{ address_id: number, address_type: number, address: { id: number, company_name: string, street: string | null, street_number: string | null, country: string | null, zipcode: string | null, city: string | null } | null }> };

export type Adit_Get_Dr_Goods_ItemsQueryVariables = Exact<{
  file_id: Scalars['uuid'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type Adit_Get_Dr_Goods_ItemsQuery = { dr_goods_items: Array<{ packaging: any | null, certificates: any | null, commodity_code: string | null, description: string | null, dr_no: any, file_id: any, gross_mass: any | null, net_mass: any | null, non_customs_law_obligation: number | null, origin: any | null, statistic: any | null, statistical_code: string | null, trader_item_id: number, valuation: any | null }>, dr_goods_item_aggregate: { aggregate: { count: number } | null } };

export type AditUpsertDeclarationMutationVariables = Exact<{
  file_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
  object: Declaration_Insert_Input;
  constraint: Declaration_Constraint;
  update_columns: Array<Declaration_Update_Column> | Declaration_Update_Column;
  goodsItemsToDeleteExp: Array<Goods_Item_Bool_Exp> | Goods_Item_Bool_Exp;
  previousDocumentsToDeleteExp: Array<Previous_Documents_Bool_Exp> | Previous_Documents_Bool_Exp;
  containersToDeleteExp: Array<Containers_Bool_Exp> | Containers_Bool_Exp;
  declarationSpecialMentionsToDeleteExp: Array<Declaration_Special_Mentions_Bool_Exp> | Declaration_Special_Mentions_Bool_Exp;
  packagingsToDeleteExp: Array<Packagings_Bool_Exp> | Packagings_Bool_Exp;
  producedDocumentsToDeleteExp: Array<Produced_Documents_Bool_Exp> | Produced_Documents_Bool_Exp;
}>;


export type AditUpsertDeclarationMutation = { insert_declaration_one: { file_id: any, dr_no: any } | null, delete_previous_documents: { affected_rows: number } | null, delete_containers: { affected_rows: number } | null, delete_declaration_special_mentions: { affected_rows: number } | null, delete_goods_item: { affected_rows: number } | null, delete_packagings: { affected_rows: number } | null, delete_produced_documents: { affected_rows: number } | null };

export type AditInsertDeclarationGoodItemMutationVariables = Exact<{
  dr_goods_item: Dr_Goods_Item_Insert_Input;
}>;


export type AditInsertDeclarationGoodItemMutation = { insert_dr_goods_item_one: { file_id: any } | null };

export type AditUpsertDeclarationRequestAddressesMutationVariables = Exact<{
  declaration_request_addresses: Array<Declaration_Request_Address_Insert_Input> | Declaration_Request_Address_Insert_Input;
}>;


export type AditUpsertDeclarationRequestAddressesMutation = { insert_declaration_request_address: { affected_rows: number } | null };

export type Adit_Mark_Declaration_Discussion_As_ReadMutationVariables = Exact<{
  disc_id?: InputMaybe<Scalars['bigint']>;
  read_date: Scalars['timestamptz'];
}>;


export type Adit_Mark_Declaration_Discussion_As_ReadMutation = { update_declaration_message: { returning: Array<{ discussion_id: any }> } | null };

export type AditGetDeclarationRequestSubscriptionVariables = Exact<{
  identification: Scalars['String'];
  dr_no: Scalars['smallint'];
}>;


export type AditGetDeclarationRequestSubscription = { declaration_requests: Array<{ file_id: any, dr_no: any, acceptance_date: any | null, creation_date: any, payer: { address: { id: number } }, addresses: Array<{ address_type: number, refs: any, address: { id: number, company_name: string, street: string | null, street_number: string | null, country: string | null, zipcode: string | null, city: string | null } | null }>, dr_goods_items: Array<{ file_id: any, dr_no: any, trader_item_id: number, packaging: any | null, commodity_code: string | null, description: string | null, gross_mass: any | null, net_mass: any | null, origin: any | null, statistic: any | null, amount: any | null, traded_goods: boolean | null, customs_net_mass: any | null, key: any | null, additional_pcs: any | null, net_declaration: boolean | null, revision: boolean | null, source: any, statistical_code: string | null }>, file: { identification: string | null } }> };

export type Adit_Get_DocumentQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type Adit_Get_DocumentQuery = { documents: Array<{ id: any, document_extension: string, document_name: string | null, creation_date: any | null, creation_user: any, org_id: any | null, document_status: string, document_flags: any, document_blobs: any, pages_m2m: Array<{ page: { id: any, thumbnail_small_url: string | null, thumbnail_big_url: string | null, page_status: string, rotate: any, meta: any } | null }>, orgId: { org_id_description: string } | null }> };

export type AditGetDocumentsForSubscriptionQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  creationUser?: InputMaybe<Scalars['uuid']>;
  search?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
}>;


export type AditGetDocumentsForSubscriptionQuery = { documents: Array<{ id: any | null, document_extension: string | null, document_name: string | null, creation_date: any | null, creation_user: any | null, org_id: any | null, org_id_description: string | null, document_status: string | null, document_flags: any | null, document_blobs: any | null, total_rows: any | null, user_display_name: string | null, pages_m2m_aggregate: { aggregate: { count: number } | null } }> };

export type GetDocumentUpdatesSubscriptionVariables = Exact<{
  my?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDocumentUpdatesSubscription = { pp_doc_max_date_hs: Array<{ max_change_date: any | null }> };

export type Adit_Get_Document_TypesQueryVariables = Exact<{
  tenantId: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where: Document_Type_Bool_Exp;
}>;


export type Adit_Get_Document_TypesQuery = { document_type: Array<{ name: string, display_name: string | null, translations: any, last_modified_date: any | null, document_type_tenant_settings: Array<{ code: string | null, default_flags: any | null, meta: any | null }> }>, document_type_aggregate: { aggregate: { count: number } | null } };

export type Adit_Get_Document_Type_FlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type Adit_Get_Document_Type_FlagsQuery = { document_flag: Array<{ id: any, name: string, translation: any, color: string | null }> };

export type Adit_Get_Extract_TypesQueryVariables = Exact<{ [key: string]: never; }>;


export type Adit_Get_Extract_TypesQuery = { extract_types: Array<{ extract_type_id: any, translations: any | null }> };

export type UpdateFileMutationVariables = Exact<{
  id: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type UpdateFileMutation = { update_file: { affected_rows: number } | null };

export type Adit_Get_EmailQueryVariables = Exact<{
  id: Scalars['uuid'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type Adit_Get_EmailQuery = { emails: Array<{ id: any | null, name: string | null, meta: any | null, file_status: string | null, creation_user: any | null, creation_date: any | null, file_url: string | null, company: string | null, sender: string | null, total_rows: any | null, documents: Array<{ id: any, document_type: string, document_status: string, document_name: string | null, document_extension: string, document_flags: any, creation_date: any | null, sequence: number | null, meta: any, document_blobs: any, created_by_user: { display_name: string | null }, computedPagesM2M: Array<{ thumbnail_small_url: string | null, thumbnail_big_url: string | null, page_status: string | null, rotate: number | null, meta: any | null, id: any | null }> | null }> }> };

export type GetEmailsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetEmailsQuery = { pp_email_search_hs: Array<{ id: any | null, name: string | null, meta: any | null, file_status: string | null, creation_user: any | null, creation_date: any | null, file_url: string | null, company: string | null, sender: string | null, total_rows: any | null, documents: Array<{ id: any, document_type: string, document_status: string, document_name: string | null, document_extension: string, document_flags: any, creation_date: any | null, sequence: number | null, meta: any, document_blobs: any, created_by_user: { display_name: string | null }, pages_m2m_aggregate: { aggregate: { count: number } | null } }> }> };

export type GetFilesForSubscriptionQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  currUserId?: InputMaybe<Scalars['uuid']>;
  orderBy?: InputMaybe<Scalars['String']>;
  fileFlags?: InputMaybe<Scalars['_int8']>;
  minDate?: InputMaybe<Scalars['timestamptz']>;
  maxDate?: InputMaybe<Scalars['timestamptz']>;
  search?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Scalars['_int2']>;
  myFilesOnly?: InputMaybe<Scalars['Boolean']>;
  fileStatuses?: InputMaybe<Scalars['_text']>;
}>;


export type GetFilesForSubscriptionQuery = { files: Array<{ id: any, identification: string | null, name: string | null, org_id: any, org_id_description: string, meta: any, file_flags: any, file_status: string, creation_user: any, creation_date: any | null, last_modified_date: any | null, file_url: string | null, total_rows: any | null, customs_relevant: boolean | null, extraction_required: boolean | null }> };

export type AditUpdateFileNumberMutationVariables = Exact<{
  file_id: Scalars['ID'];
  file_number: Scalars['String'];
}>;


export type AditUpdateFileNumberMutation = { updateFileNumber: { file_id: string | null } | null };

export type AditGetOrgIdsListQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type AditGetOrgIdsListQuery = { orgIds: Array<{ orgId: number, orgIdDescription: string }> };

export type AditGetUserOrgIdsListQueryVariables = Exact<{ [key: string]: never; }>;


export type AditGetUserOrgIdsListQuery = { userOrgIds: Array<{ orgId: number, orgIdDescription: string }> };

export type OrgIdsListFragmentFragment = { orgId: number, orgIdDescription: string };

export type AditGetRolesListQueryVariables = Exact<{ [key: string]: never; }>;


export type AditGetRolesListQuery = { roles: Array<{ id: number, name: string, isWdRelevant: boolean | null, description: string | null, translations: any }> };

export type AditRolesListFragmentFragment = { id: number, name: string, isWdRelevant: boolean | null, description: string | null, translations: any };

export type Adit_Get_Declaration_Request_EdecQueryVariables = Exact<{
  fileId: Scalars['uuid'];
}>;


export type Adit_Get_Declaration_Request_EdecQuery = { declaration_request: Array<{ edec: any | null }> };

export type Adit_Update_Declaration_Request_EdecMutationVariables = Exact<{
  edec: Scalars['jsonb'];
  fileId: Scalars['uuid'];
  declaration_status: Scalars['String'];
}>;


export type Adit_Update_Declaration_Request_EdecMutation = { update_declaration_request: { affected_rows: number } | null };

export type Delete_Org_IdQueryVariables = Exact<{
  org_id: Scalars['smallint'];
}>;


export type Delete_Org_IdQuery = { pp_org_id_delete: Array<{ json_value: any | null }> };

export type AditExportDeclarationMutationVariables = Exact<{
  fileId: Scalars['String'];
  drNo: Scalars['Float'];
}>;


export type AditExportDeclarationMutation = { exportDeclaration: boolean };

export type Adit_Get_Pp_AddressQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  address_types?: InputMaybe<Scalars['_int4']>;
}>;


export type Adit_Get_Pp_AddressQuery = { pp_addresses: Array<{ company_name: string, address_type: number | null, city: string | null, contact_email: string | null, contact_phone: string | null, contact_website: string | null, country: string | null, id: number, street: string | null, street_number: string | null, zipcode: string | null, reference: string | null, creation_date: any | null, creation_user: any, last_modified_date: any | null, last_modified_user: any | null, qty: any | null }> };

export type Get_Address_TypeQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Address_TypeQuery = { address_type: Array<{ id: number, name: string, translation: any }> };

export type GetAiStatsQueryVariables = Exact<{
  started?: InputMaybe<Scalars['timestamptz']>;
  ended?: InputMaybe<Scalars['timestamptz']>;
  onlyAiDoctypes?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Scalars['_uuid']>;
  orgIds?: InputMaybe<Scalars['_int2']>;
}>;


export type GetAiStatsQuery = { pp_ai_stats: Array<{ document_type: string | null, success_ratio: any | null, total: any | null, types_match: any | null, unknowns: any | null, unknowns_pct: any | null }> };

export type GetAiStatsByDayQueryVariables = Exact<{
  started?: InputMaybe<Scalars['timestamptz']>;
  ended?: InputMaybe<Scalars['timestamptz']>;
  onlyAiDoctypes?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Scalars['_uuid']>;
  orgIds?: InputMaybe<Scalars['_int2']>;
}>;


export type GetAiStatsByDayQuery = { pp_ai_stats_dt: Array<{ creation_date: any | null, docs_qty: any | null, document_type: string | null, pages_qty: any | null, success_ratio: any | null, types_match: any | null, unknowns: any | null, unknowns_pct: any | null }> };

export type Get_Api_KeysQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Api_KeysQuery = { accessTokens: Array<{ id: number, api_key: string, meta: any, display_name: string }> };

export type GetDeclarationWithDocumentsQueryVariables = Exact<{
  declarationId?: InputMaybe<Scalars['_uuid']>;
}>;


export type GetDeclarationWithDocumentsQuery = { declaration_request: Array<{ toll_dep: string | null, eta: any | null, file: { id: any, identification: string | null, documents: Array<{ id: any, meta: any, document_status: string, document_type: string, document_blobs: any, document_flags: any, name: string | null, pages: Array<{ page_number: any, page: { id: any, page_status: string, rotate: any, meta: any, creation_user: any, thumbnailBigUrl: string | null } | null }> }> }, declaration_discussions: Array<{ discussion_id: any, creation_user: any }>, payer: { id: any, tenantName: string }, declaration_request_addresses: Array<{ address_id: number | null, refs: any, address_type: number, address: { id: number, company_name: string, company_name_2: string | null, country: string | null, street: string | null, city: string | null, zipcode: string | null, reference: string | null, street_number: string | null, customs_account_number: string | null, is_locked: boolean | null, uid_number: string | null, usage_frequency: number | null, vat_account_number: string | null, trader_identification_number: string | null, is_platform_user: boolean } | null }>, declaration: { total_gross_weight: any | null, total_colis: number | null, customs_office_number: string | null } | null }> };

export type Adit_Get_Declaration_Tasks_V2QueryVariables = Exact<{
  assigned_to?: InputMaybe<Scalars['uuid']>;
  min_due_date?: InputMaybe<Scalars['timestamptz']>;
  max_due_date?: InputMaybe<Scalars['timestamptz']>;
  task_type_id?: InputMaybe<Scalars['Int']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  task_status_id?: InputMaybe<Scalars['Int']>;
  orderby?: InputMaybe<Scalars['String']>;
}>;


export type Adit_Get_Declaration_Tasks_V2Query = { declaration_task: Array<{ id: number, title: string, assigned_to: any | null, creation_date: any, task_type_id: number, due_date: any | null, meta: any, object_id: any, task_status_id: number, rn: any | null, qty: any | null, assigned_user: { __typename: 'user_pp', id: any, display_name: string | null } | null, task_type: { __typename: 'task_type', display_name: string } | null, document: { __typename: 'document', document_flags: any, documentFile: { __typename: 'file', id: any, identification: string | null } | null, documentType: { __typename: 'document_type', translations: any } } | null, file: { __typename: 'file', id: any, identification: string | null } | null }> };

export type GetDocumentPagesQueryVariables = Exact<{
  documentId: Scalars['uuid'];
}>;


export type GetDocumentPagesQuery = { document: Array<{ pages: Array<{ page_number: any, page: { id: any, rotate: any, meta: any, thumbnailBigUrl: string | null, thumbnailSmallUrl: string | null } | null }> }> };

export type GetDocumentStatsQueryVariables = Exact<{
  started?: InputMaybe<Scalars['timestamptz']>;
  ended?: InputMaybe<Scalars['timestamptz']>;
  userIds?: InputMaybe<Scalars['_uuid']>;
  orgIds?: InputMaybe<Scalars['_int2']>;
  tenant?: InputMaybe<Scalars['uuid']>;
}>;


export type GetDocumentStatsQuery = { pp_doc_stats: Array<{ docs_qty: any | null, document_type: string | null, total_pages: any | null, users_qty: any | null }> };

export type GetDocumentsQueryVariables = Exact<{
  ids?: InputMaybe<Scalars['_uuid']>;
}>;


export type GetDocumentsQuery = { documents: Array<{ id: any, meta: any, document_blobs: any, document_flags: any, name: string | null, pages: Array<{ page_number: any, page: { id: any, page_status: string, rotate: any, meta: any, creation_user: any, thumbnailBigUrl: string | null } | null }> }> };

export type GetFilesPagesQueryVariables = Exact<{
  fileNumber: Scalars['uuid'];
}>;


export type GetFilesPagesQuery = { files: Array<{ documents: Array<{ id: any, document_type: string, document_status: string, document_name: string | null, document_flags: any, last_modified_date: any | null, sequence: number | null, meta: any, document_blobs: any, created_by_user: { display_name: string | null }, documentType: { translations: any }, pages: Array<{ page_number: any, page: { id: any, rotate: any, page_status: string, meta: any, thumbnailBigUrl: string | null, thumbnailSmallUrl: string | null } | null }> }> }> };

export type GetFileStatsQueryVariables = Exact<{
  started?: InputMaybe<Scalars['timestamptz']>;
  ended?: InputMaybe<Scalars['timestamptz']>;
  userIds?: InputMaybe<Scalars['_uuid']>;
  orgIds?: InputMaybe<Scalars['_int2']>;
}>;


export type GetFileStatsQuery = { pp_file_stats: Array<{ file_flags: string | null, file_flags_id: any | null, qty: any | null, users_qty: any | null }> };

export type GetFilesQueryVariables = Exact<{
  fileNumber?: InputMaybe<Scalars['String']>;
}>;


export type GetFilesQuery = { files: Array<{ id: any | null, identification: string | null, name: string | null, type: any | null, declarations: Array<{ file_id: any, dr_no: any }>, documents: Array<{ id: any, document_type: string, document_flags: any, document_blobs: any, document_name: string | null, sequence: number | null, documentType: { translations: any, document_type_tenant_settings: Array<{ meta: any | null }> }, pages: Array<{ page_number: any, page: { id: any, rotate: any, meta: any, thumbnailBigUrl: string | null } | null }> }> }> };

export type GetFilesForSubscriptionForAnnotationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  currUserId?: InputMaybe<Scalars['uuid']>;
  orderBy?: InputMaybe<Scalars['String']>;
  fileFlags?: InputMaybe<Scalars['_int8']>;
  minDate?: InputMaybe<Scalars['timestamptz']>;
  maxDate?: InputMaybe<Scalars['timestamptz']>;
  search?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Scalars['_int2']>;
  myFilesOnly?: InputMaybe<Scalars['Boolean']>;
  fileStatuses?: InputMaybe<Scalars['_text']>;
}>;


export type GetFilesForSubscriptionForAnnotationQuery = { files: Array<{ id: any, identification: string | null, name: string | null, org_id: any, org_id_description: string, meta: any, total_rows: any | null, customs_relevant: boolean | null, extraction_required: boolean | null, type: any, status: string, userId: any, creationDate: any | null, lastUpdate: any | null, fileUrl: string | null }> };

export type GetFileUpdatesSubscriptionForAnnotationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetFileUpdatesSubscriptionForAnnotationSubscription = { pp_file_max_date_hs: Array<{ max_change_date: any | null }> };

export type Get_Full_File_HistoryQueryVariables = Exact<{
  fileId?: InputMaybe<Scalars['uuid']>;
  documentIds?: InputMaybe<Scalars['_uuid']>;
}>;


export type Get_Full_File_HistoryQuery = { file_history: Array<{ action_title: string | null, action_value: string | null, op_date: any, action_user: any | null, entityId: any }>, document_history: Array<{ action_title: string | null, action_value: string | null, op_date: any, action_user: any | null, entityId: any, document: { sequence: number | null, documentType: { translations: any } } | null }> };

export type Adit_Get_Import_List_TriggersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type Adit_Get_Import_List_TriggersQuery = { import_list_trigger: Array<{ id: number, display_name: string, type: string, config: any, creation_date: any, creation_user: any | null, last_modified_date: any | null, last_modified_user: any | null, meta: any, creationUser: { display_name: string | null } | null, lastModifiedUser: { display_name: string | null } | null }>, import_list_trigger_aggregate: { aggregate: { totalCount: number } | null } };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { notifications: any | null };

export type Get_Org_IdsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['smallint']>;
}>;


export type Get_Org_IdsQuery = { org_ids: Array<{ org_id: any | null, display_name: string | null, org_id_description: string | null, qty: any | null, org_params: any | null, addresses_desc: string | null, org_ids_desc: string | null }> };

export type Get_Setting_ValueQueryVariables = Exact<{
  setting_id?: InputMaybe<Scalars['uuid']>;
  reference_type_id?: InputMaybe<Scalars['String']>;
  reference_id?: InputMaybe<Scalars['String']>;
}>;


export type Get_Setting_ValueQuery = { setting_value: Array<{ id: any, display_name: string, value: any | null, setting_id: any, is_template: boolean }> };

export type Get_Tenant_SettingQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type Get_Tenant_SettingQuery = { getTenantConfig: any | null };

export type Get_UsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tenantId?: InputMaybe<Scalars['uuid']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type Get_UsersQuery = { user_pp: Array<{ id: any, display_name: string | null, location: string | null, email: string | null, tenant_id: any }> };

export type Get_Validation_DocumentsQueryVariables = Exact<{
  id: Scalars['uuid'];
  extract_type_id?: InputMaybe<Scalars['smallint']>;
  tenantId: Scalars['uuid'];
}>;


export type Get_Validation_DocumentsQuery = { document: Array<{ id: any, meta: any, document_blobs: any, document_flags: any, document_type: string, name: string | null, annotationType: Array<{ annotation_schema: any | null }>, pages: Array<{ page: { id: any, page_status: string, rotate: any, meta: any, creation_user: any, thumbnailBigUrl: string | null, pageExtracts: Array<{ extract_type_id: any, dataPoints: any | null }> } | null }>, documentType: { translations: any, document_type_tenant_settings: Array<{ documentSchema: any | null }> } }> };

export type Insert_Import_List_TriggerMutationVariables = Exact<{
  object: Import_List_Trigger_Insert_Input;
}>;


export type Insert_Import_List_TriggerMutation = { insert_import_list_trigger_one: { id: number, type: string, config: any, creation_user: any | null, creation_date: any, last_modified_user: any | null, last_modified_date: any | null, meta: any } | null };

export type Insert_Org_IdQueryVariables = Exact<{
  org_id?: InputMaybe<Scalars['smallint']>;
  display_name?: InputMaybe<Scalars['String']>;
  org_params?: InputMaybe<Scalars['json']>;
  org_id_description?: InputMaybe<Scalars['String']>;
}>;


export type Insert_Org_IdQuery = { pp_org_id_insert: Array<{ json_value: any | null }> };

export type Patch_Update_Tenant_SettingMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  settings?: InputMaybe<Scalars['JSON']>;
}>;


export type Patch_Update_Tenant_SettingMutation = { patchTenantConfig: any | null };

export type SendDeclarationMutationVariables = Exact<{
  fileId?: InputMaybe<Scalars['uuid']>;
  declarationStatus?: InputMaybe<Scalars['String']>;
}>;


export type SendDeclarationMutation = { update_declaration_request: { affected_rows: number } | null };

export type Adit_Create_Declaration_MessageMutationVariables = Exact<{
  discussionId: Scalars['Int'];
  message: Scalars['String'];
  user: Scalars['ID'];
  source: Scalars['String'];
}>;


export type Adit_Create_Declaration_MessageMutation = { createDeclarationMessage: { affected_rows: number | null } | null };

export type Adit_Start_DiscussionMutationVariables = Exact<{
  fileId: Scalars['uuid'];
  theme: Scalars['String'];
  user: Scalars['uuid'];
}>;


export type Adit_Start_DiscussionMutation = { insert_declaration_discussion_one: { discussion_id: any, discussion_theme: string | null, file_id: any } | null };

export type AditSubscribeDeclarationChangesSubscriptionVariables = Exact<{
  discussionId: Scalars['bigint'];
}>;


export type AditSubscribeDeclarationChangesSubscription = { declaration_message: Array<{ creation_user: any, message: string, msg_date: any, read_date: any | null, type: string | null, user: { tenant_id: any, display_name: string | null, first_name: string | null, last_name: string | null, email: string | null, tenant: { tenant_name: string } } | null, declaration_discussion: { discussion_theme: string | null } }> };

export type AditSubscribeDiscussionChangesSubscriptionVariables = Exact<{
  user: Scalars['uuid'];
  date: Scalars['timestamptz'];
}>;


export type AditSubscribeDiscussionChangesSubscription = { discussion_changes: Array<{ file_name: string | null, liber_user: any | null, last_msg_date: any | null, file_id: any | null, discussion_theme: string | null, discussion_id: any | null, adit_user: any | null, reference: string | null }> };

export type GetDeclarationUpdatesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetDeclarationUpdatesSubscription = { pp_file_max_date_hs: Array<{ max_change_date: any | null }> };

export type Adit_Update_Declaration_Task_By_PkMutationVariables = Exact<{
  id: Scalars['Int'];
  _set?: InputMaybe<Declaration_Task_Set_Input>;
}>;


export type Adit_Update_Declaration_Task_By_PkMutation = { update_declaration_task_by_pk: { id: number } | null };

export type Update_Import_List_TriggerMutationVariables = Exact<{
  id: Scalars['Int'];
  set: Import_List_Trigger_Set_Input;
  append: Import_List_Trigger_Append_Input;
}>;


export type Update_Import_List_TriggerMutation = { update_import_list_trigger_by_pk: { id: number, type: string, config: any, creation_user: any | null, creation_date: any, last_modified_user: any | null, last_modified_date: any | null, meta: any } | null };

export type Update_Org_IdQueryVariables = Exact<{
  org_id?: InputMaybe<Scalars['smallint']>;
  display_name?: InputMaybe<Scalars['String']>;
  org_params?: InputMaybe<Scalars['json']>;
  org_id_description?: InputMaybe<Scalars['String']>;
}>;


export type Update_Org_IdQuery = { pp_org_id_update: Array<{ json_value: any | null }> };

export type Insert_AddressMutationVariables = Exact<{
  objects: Array<Address_Insert_Input> | Address_Insert_Input;
}>;


export type Insert_AddressMutation = { insert_address: { affected_rows: number } | null };

export type Update_AddressMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  values?: InputMaybe<Address_Set_Input>;
}>;


export type Update_AddressMutation = { update_address: { affected_rows: number } | null };

export type Delete_AddressMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type Delete_AddressMutation = { delete_address: { affected_rows: number } | null };

export type ToggleAiConfirmedMutationVariables = Exact<{
  file_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
  value: Scalars['Boolean'];
}>;


export type ToggleAiConfirmedMutation = { update_declaration: { affected_rows: number } | null };

export type Adit_Delete_DocumentMutationVariables = Exact<{
  id: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type Adit_Delete_DocumentMutation = { update_document: { affected_rows: number } | null };

export type Append_Meta_DocumentMutationVariables = Exact<{
  id: Array<Scalars['uuid']> | Scalars['uuid'];
  meta?: InputMaybe<Scalars['jsonb']>;
}>;


export type Append_Meta_DocumentMutation = { update_document: { affected_rows: number } | null };

export type CreateDocumentMutationVariables = Exact<{
  document: CreateDocumentInput;
}>;


export type CreateDocumentMutation = { createDocument: { success: boolean | null, error: string | null, documentId: string | null } | null };

export type Clear_Document_ChecksumMutationVariables = Exact<{
  checksums: Array<Scalars['String']> | Scalars['String'];
}>;


export type Clear_Document_ChecksumMutation = { update_document: { affected_rows: number } | null };

export type Upsert_Doc_AnnotationMutationVariables = Exact<{
  docId: Scalars['uuid'];
  annoTypeId: Scalars['smallint'];
  value: Scalars['jsonb'];
}>;


export type Upsert_Doc_AnnotationMutation = { insert_doc_annotation: { affected_rows: number } | null };

export type ScheduleDocumentsMutationVariables = Exact<{
  documentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ScheduleDocumentsMutation = { scheduleDocuments: any | null };

export type Create_Document_LabelMutationVariables = Exact<{
  document_label: Array<Document_Labels_Insert_Input> | Document_Labels_Insert_Input;
}>;


export type Create_Document_LabelMutation = { insert_document_labels: { returning: Array<{ id: number }> } | null };

export type Update_Document_LabelMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['jsonb']>;
  color?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
}>;


export type Update_Document_LabelMutation = { update_document_labels: { returning: Array<{ id: number }> } | null };

export type Delete_Document_LabelMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type Delete_Document_LabelMutation = { update_document_labels: { returning: Array<{ id: number }> } | null };

export type Create_Document_Type_Tenant_SettingsMutationVariables = Exact<{
  document_type: Array<Document_Type_Tenant_Settings_Insert_Input> | Document_Type_Tenant_Settings_Insert_Input;
}>;


export type Create_Document_Type_Tenant_SettingsMutation = { insert_document_type_tenant_settings: { returning: Array<{ document_type: string, tenant: any }> } | null };

export type Update_Document_Type_Tenant_SettingsMutationVariables = Exact<{
  documentType: Scalars['String'];
  tenant?: InputMaybe<Scalars['uuid']>;
  translations?: InputMaybe<Scalars['jsonb']>;
  code?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  default_flags?: InputMaybe<Scalars['bigint']>;
}>;


export type Update_Document_Type_Tenant_SettingsMutation = { update_document_type_tenant_settings: { returning: Array<{ document_type: string, tenant: any }> } | null, update_document_type: { name: string } | null };

export type Delete_Document_Type_Tenant_SettingsMutationVariables = Exact<{
  names: Array<Scalars['String']> | Scalars['String'];
  tenant: Scalars['uuid'];
}>;


export type Delete_Document_Type_Tenant_SettingsMutation = { delete_document_type_tenant_settings: { returning: Array<{ document_type: string, tenant: any }> } | null };

export type ValidateFileNumberMutationVariables = Exact<{
  number: Scalars['String'];
}>;


export type ValidateFileNumberMutation = { validateFileNumber: { error_code: string | null, error_description: string | null, data: { orgId: string | null, shipmentNumber: string | null, traffic: string | null, lines: Array<{ grossWeight: string | null, packaging: string | null, quantity: string | null } | null> | null, consignee: { adrID: string | null, city: string | null, consigneeAdrID: string | null, country: string | null, name: string | null, postalCode: string | null, state: string | null, street: string | null } | null, shipper: { adrID: string | null, city: string | null, consigneeAdrID: string | null, country: string | null, name: string | null, postalCode: string | null, state: string | null, street: string | null } | null, orderedBy: { adrID: string | null, city: string | null, consigneeAdrID: string | null, country: string | null, name: string | null, postalCode: string | null, state: string | null, street: string | null } | null } | null } | null };

export type TransmitFileMutationVariables = Exact<{
  data: TransmitFileInput;
}>;


export type TransmitFileMutation = { transmitFile: { success: boolean | null, error: string | null, fileIds: Array<string | null> | null } | null };

export type ScheduleFilesMutationVariables = Exact<{
  fileIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ScheduleFilesMutation = { scheduleFiles: any | null };

export type Adit_Schedule_Data_ExtractionMutationVariables = Exact<{
  fileId: Scalars['ID'];
  drNo: Scalars['Int'];
}>;


export type Adit_Schedule_Data_ExtractionMutation = { scheduleAldiSrvProcessing: any | null };

export type ValidateJourneyNumberMutationVariables = Exact<{
  number: Scalars['String'];
}>;


export type ValidateJourneyNumberMutation = { validateJourneyNumber: { error_code: string | null, error_description: string | null, data: any | null } | null };

export type Upsert_TableMutationVariables = Exact<{
  pageId: Scalars['uuid'];
  extractTypeId: Scalars['smallint'];
  tables: Scalars['jsonb'];
}>;


export type Upsert_TableMutation = { insert_page_extract_one: { page_id: any } | null };

export type UpdateRotationMutationVariables = Exact<{
  objects: Array<Page_Insert_Input> | Page_Insert_Input;
}>;


export type UpdateRotationMutation = { insert_page: { affected_rows: number } | null };

export type Update_Page_ClobMutationVariables = Exact<{
  pageId: Scalars['uuid'];
  dataPointId: Scalars['String'];
  extract_type_id: Scalars['smallint'];
}>;


export type Update_Page_ClobMutation = { update_page_extract: { returning: Array<{ page_id: any }> } | null };

export type Update_Data_PointMutationVariables = Exact<{
  dataPoint: Scalars['jsonb'];
  pageId: Scalars['uuid'];
  dataPointIndex: Scalars['Int'];
  extract_type_id: Scalars['smallint'];
}>;


export type Update_Data_PointMutation = { delete: { page_id: any } | null, append: { page_id: any } | null };

export type Update_Page_Extract_ValueMutationVariables = Exact<{
  value: Page_Extract_Append_Input;
  pageId: Scalars['uuid'];
  extract_type_id: Scalars['smallint'];
}>;


export type Update_Page_Extract_ValueMutation = { update_page_extract_by_pk: { value: any | null } | null };

export type Upsert_Page_Extract_ValueMutationVariables = Exact<{
  pageId: Scalars['uuid'];
  value: Scalars['jsonb'];
  extract_type_id: Scalars['smallint'];
}>;


export type Upsert_Page_Extract_ValueMutation = { insert_page_extract: { affected_rows: number, returning: Array<{ page_id: any }> } | null, update_page_extract_by_pk: { page_id: any } | null };

export type UpdateAiIgnoreRetrainingMutationVariables = Exact<{
  id: Scalars['uuid'];
  value: Scalars['Boolean'];
}>;


export type UpdateAiIgnoreRetrainingMutation = { update_page_by_pk: { id: any, ai_ignore_retraining: boolean | null } | null };

export type Update_Setting_Value_By_IdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  reference_id?: InputMaybe<Scalars['String']>;
  reference_type_id?: InputMaybe<Scalars['String']>;
  setting_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['jsonb']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
}>;


export type Update_Setting_Value_By_IdMutation = { update_setting_value: { returning: Array<{ id: any, value: any | null, display_name: string }> } | null };

export type Update_Setting_ValueMutationVariables = Exact<{
  reference_id?: InputMaybe<Scalars['String']>;
  reference_type_id?: InputMaybe<Scalars['String']>;
  setting_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['jsonb']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
}>;


export type Update_Setting_ValueMutation = { update_setting_value: { returning: Array<{ id: any, value: any | null, display_name: string }> } | null };

export type Create_Setting_ValueMutationVariables = Exact<{
  setting_value: Array<Setting_Value_Insert_Input> | Setting_Value_Insert_Input;
}>;


export type Create_Setting_ValueMutation = { insert_setting_value: { returning: Array<{ id: any, display_name: string, value: any | null }> } | null };

export type Delete_Setting_ValueMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type Delete_Setting_ValueMutation = { delete_setting_value: { returning: Array<{ id: any }> } | null };

export type Schedule_Doc_Annotation_ExportMutationVariables = Exact<{
  documentID: Scalars['ID'];
}>;


export type Schedule_Doc_Annotation_ExportMutation = { scheduleDocAnnotationExport: any | null };

export type Finish_ValidationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Finish_ValidationMutation = { finishDocumentValidation: any | null };

export type Add_Measure_TimeMutationVariables = Exact<{
  id: Scalars['uuid'];
  document_type: Scalars['String'];
  meta: Scalars['jsonb'];
}>;


export type Add_Measure_TimeMutation = { update_document_by_pk: { id: any } | null };

export type GetUsersOrgIdsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['_uuid']>;
}>;


export type GetUsersOrgIdsQuery = { orgIds: Array<{ org_id: any, orgId: { org_id: any, org_id_description: string, active: boolean | null } | null }> };

export type Get_Documents_By_ChecksumQueryVariables = Exact<{
  checksums: Array<Scalars['String']> | Scalars['String'];
}>;


export type Get_Documents_By_ChecksumQuery = { documents: Array<{ id: any, document_name: string | null, checksum: string | null }> };

export type Get_Doc_AnnotationQueryVariables = Exact<{
  docId: Scalars['uuid'];
  annoTypeId: Scalars['smallint'];
}>;


export type Get_Doc_AnnotationQuery = { doc_annotation: Array<{ anno_type_id: any, doc_id: any, value: any | null }> };

export type Get_Annotation_TypeQueryVariables = Exact<{
  annotationProviderId: Scalars['smallint'];
  documentType: Scalars['String'];
}>;


export type Get_Annotation_TypeQuery = { annotation_type: Array<{ anno_type_id: any, anno_schema: any | null, ui_schema: any | null }> };

export type Next_Invalidate_DocumentQueryVariables = Exact<{
  orgs?: InputMaybe<Scalars['_int2']>;
  docId?: InputMaybe<Scalars['uuid']>;
}>;


export type Next_Invalidate_DocumentQuery = { pp_docs_for_validation: Array<{ id: any | null, document_flags: any | null, document_type: string | null, org_id: any | null, doc_order: any | null }> };

export type Get_Document_LabelsQueryVariables = Exact<{
  ids?: InputMaybe<Scalars['_int4']>;
  tenantId: Scalars['uuid'];
}>;


export type Get_Document_LabelsQuery = { document_labels: Array<{ id: number, title: any, description: any, color: string }> };

export type Get_Document_Labels_By_OrgsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  tenantId: Scalars['uuid'];
  orgIds: Array<Scalars['smallint']> | Scalars['smallint'];
}>;


export type Get_Document_Labels_By_OrgsQuery = { document_labels: Array<{ id: number, title: any, description: any, color: string }> };

export type CheckFileStatusQueryVariables = Exact<{
  fileNumber: Scalars['String'];
}>;


export type CheckFileStatusQuery = { file: Array<{ id: any, file_status: string, identification: string | null, file_flags: any }> };

export type Pp_Page_Extract_Text_Fragment_V2QueryVariables = Exact<{
  pageId: Scalars['uuid'];
  x: Scalars['numeric'];
  y: Scalars['numeric'];
  width: Scalars['numeric'];
  height: Scalars['numeric'];
  extract_type_id: Scalars['smallint'];
}>;


export type Pp_Page_Extract_Text_Fragment_V2Query = { pp_page_extract_text_fragment_v2: Array<{ json_value: any | null }> };

export type Pp_Page_Extract_Grids_TextQueryVariables = Exact<{
  pageId: Scalars['uuid'];
  cellCoordinates: Scalars['jsonb'];
  extractTypeId: Scalars['smallint'];
}>;


export type Pp_Page_Extract_Grids_TextQuery = { pp_page_extract_grids_text: Array<{ json_value: any | null }> };

export type GetDeclarationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDeclarationsQuery = { declaration: Array<{ file_id: any, dr_no: any, ai_confirmed: boolean | null, declaration_request: { payer: { tenant_name: string }, declaration_request_addresses: Array<{ address: { company_name: string } | null }>, documents: Array<{ id: any, document_type: string, pages_m2m: Array<{ page: { thumbnail_big_url: string | null } | null }> }> } | null }> };

export type Adit_MarkDocumentAsTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  isTemplate?: InputMaybe<Scalars['Boolean']>;
}>;


export type Adit_MarkDocumentAsTemplateMutation = { markDocumentAsTemplate: any | null };

export type Adit_ScheduleTableCalculationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Adit_ScheduleTableCalculationMutation = { scheduleTableCalculation: any | null };

export type AditGetDeclarationsListQueryVariables = Exact<{
  _like?: InputMaybe<Scalars['String']>;
}>;


export type AditGetDeclarationsListQuery = { declarations: Array<{ file_id: any, dr_no: any, file: { identification: string | null } }> };

export type AditCopyDeclarationAndGoodsItemsMutationVariables = Exact<{
  sourceFileId: Scalars['String'];
  sourceDrNo: Scalars['Int'];
  targetFileId: Scalars['String'];
  targetDrNo: Scalars['Int'];
}>;


export type AditCopyDeclarationAndGoodsItemsMutation = { copyDeclarationAndGoodsItems: boolean };

export type AditGetDeclarationDocumentsTableQueryVariables = Exact<{
  fileId?: InputMaybe<Scalars['UUID']>;
  documentStatus?: InputMaybe<Array<DocumentStatus> | DocumentStatus>;
}>;


export type AditGetDeclarationDocumentsTableQuery = { documents: Array<{ creationUser: string | null, documentExtension: string, documentFlags: number, documentName: string, documentStatus: string, documentType: string, documentTypeTranslations: any | null, id: any, lastModifiedDate: any | null, meta: any | null, sequence: number | null, pages: Array<{ creationDate: any | null, creationUser: any, id: any, lastModifiedDate: any | null, lastModifiedUser: any | null, meta: any, ocrText: string | null, pageNumber: number | null, pageStatus: string, rotate: number, thumbnailBigUrl: string | null, thumbnailSmallUrl: string | null }>, blobs: Array<{ url: string, initial: boolean, extension: string }> | null }> };

export type AditGetDeclarationTableDiscussionsSubscriptionVariables = Exact<{
  fileIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type AditGetDeclarationTableDiscussionsSubscription = { declarationsDiscussions: Array<{ file_id: any, messages: { aggregate: { count: number } | null } }> };

export type AditGetDeclarationsTableQueryVariables = Exact<{
  nonclassifiedDocsExists?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['JSONObject']> | Scalars['JSONObject']>;
  declarationStatus?: InputMaybe<Array<DeclarationStatus> | DeclarationStatus>;
  search?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Array<AddressFilter> | AddressFilter>;
  dateMin?: InputMaybe<Scalars['LocalDateTime']>;
  dateMax?: InputMaybe<Scalars['LocalDateTime']>;
  maxTotalColis?: InputMaybe<Scalars['Int']>;
  maxTotalGrossWeight?: InputMaybe<Scalars['Float']>;
  minTotalColis?: InputMaybe<Scalars['Int']>;
  minTotalGrossWeight?: InputMaybe<Scalars['Float']>;
  orgIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type AditGetDeclarationsTableQuery = { declarations: Array<{ consigneeName: string | null, autoclassifiedDocsQty: number, consigneeRef: string | null, consignorName: string | null, consignorRef: string | null, creationDate: any | null, creationUser: string | null, customsOfficeNumber: string | null, declarationStatus: DeclarationStatus, drNo: number, evvReceived: boolean | null, fileId: string, identification: string | null, importerRef: string | null, messageCount: number, nonclassifiedDocsExists: number, payerName: string | null, payerRef: string | null, totalColis: number | null, totalGrossWeight: number | null, discussionId: number | null, orgId: number | null, addressReferences: string | null }> };

export type AditUpdatePasswordMutationVariables = Exact<{
  updatePasswordInput: UpdatePasswordDto;
}>;


export type AditUpdatePasswordMutation = { updatePassword: boolean };

export type AditGetAiConfirmedDeclarationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AditGetAiConfirmedDeclarationsQuery = { declarations: Array<{ file_id: any, dr_no: any, ai_confirmed: boolean | null, file: { identification: string | null }, declaration_request: { payer: { tenant_name: string }, declaration_request_addresses: Array<{ address: { company_name: string } | null }>, documents: Array<{ id: any, document_type: string, document_extension: string, pages_m2m: Array<{ page_number: any, page: { id: any, thumbnail_big_url: string | null, ai_ignore_retraining: boolean | null, rotate: any } | null }> }> } | null }> };

export type AditGetModelRetrainsQueryVariables = Exact<{ [key: string]: never; }>;


export type AditGetModelRetrainsQuery = { model_retrains: Array<{ id: number, request_time: any | null, status: string | null, start_time: any | null, end_time: any | null, error_message: string | null }> };

export type AditTriggerModelRetrainingMutationVariables = Exact<{
  requestTime: Scalars['timestamptz'];
}>;


export type AditTriggerModelRetrainingMutation = { insert_model_retrain_one: { id: number } | null };

export type AditGetTenantDocumentTypesTableQueryVariables = Exact<{
  tenantId: Scalars['uuid'];
  where: Document_Type_Bool_Exp;
}>;


export type AditGetTenantDocumentTypesTableQuery = { document_type: Array<{ name: string, display_name: string | null, translations: any, document_type_tenant_settings: Array<{ tenant: any, code: string | null, default_flags: any | null, meta: any | null, creation_date: any | null, creation_user: any | null, last_modified_date: any | null, last_modified_user: any | null }> }>, document_flag: Array<{ id: any, name: string, translation: any, color: string | null }> };

export type Adit_Upsert_Document_Type_Tenant_SettingMutationVariables = Exact<{
  document_type_tenant_setting: Document_Type_Tenant_Settings_Insert_Input;
}>;


export type Adit_Upsert_Document_Type_Tenant_SettingMutation = { insert_document_type_tenant_settings: { affected_rows: number } | null };

export type AditCreatTenantUserMutationVariables = Exact<{
  object: AditUserDto;
}>;


export type AditCreatTenantUserMutation = { createAditUser: boolean };

export type AditDeleteTenantUserMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AditDeleteTenantUserMutation = { removeUser: boolean };

export type AditGetTenantUsersTableQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Scalars['UUID']>;
}>;


export type AditGetTenantUsersTableQuery = { users: Array<{ id: string, tenantId: any, firstName: string | null, lastName: string | null, displayName: string | null, email: string, location: string | null, isEnabled: boolean, externalAuthProvider: boolean, creationDate: any | null, lastModifiedDate: any | null, orgIds: Array<{ orgId: number, orgIdDescription: string }>, roles: Array<{ id: number, name: string, isWdRelevant: boolean | null, description: string | null, translations: any }> }> };

export type AditSendResetPasswordLinkMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type AditSendResetPasswordLinkMutation = { sendAditResetPasswordLink: boolean };

export type AditUpdateTenantUserMutationVariables = Exact<{
  object: AditUserDto;
}>;


export type AditUpdateTenantUserMutation = { updateAditUser: boolean };

export type AditCreateTenantMutationVariables = Exact<{
  addressId: Scalars['Int'];
  externalTenantId?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  tenantName: Scalars['String'];
}>;


export type AditCreateTenantMutation = { createTenantACS: boolean };

export type AditUpdateTenantMutationVariables = Exact<{
  tenantId: Scalars['String'];
  addressId: Scalars['Int'];
  externalTenantId?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  tenantName: Scalars['String'];
}>;


export type AditUpdateTenantMutation = { editTenantACS: boolean };

export type AditGetTenantsTableQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type AditGetTenantsTableQuery = { tenants: Array<{ accountNumber: string | null, addressId: number, creationDate: any | null, externalTenantId: string | null, id: any, isWdCustomer: boolean, lastModifiedDate: any | null, permissions: string | null, tenantName: string, tenantType: TenantType, traderIdentificationNumber: string | null, address: { id: number, companyName: string, companyName2: string | null, country: string | null, city: string | null, street: string | null, zipcode: string | null, usageFrequency: number, customsAccountNumber: string | null, traderIdentificationNumber: string | null, vatAccountNumber: string | null, uidNumber: string | null, isLocked: boolean, reference: string | null, isPlatformUser: boolean }, roles: Array<{ id: number, name: string, isWdRelevant: boolean | null, description: string | null, translations: any }> | null }> };

export type Adit_Get_Validation_V2_DocumentQueryVariables = Exact<{
  id: Scalars['uuid'];
  tenantId: Scalars['uuid'];
}>;


export type Adit_Get_Validation_V2_DocumentQuery = { file: { identification: string | null, documents: Array<{ id: any, meta: any, document_extension: string, document_blobs: any, document_flags: any, document_type: string, sequence: number | null, name: string | null, annotationType: Array<{ annotation_schema: any | null }>, pages: Array<{ page: { id: any, page_status: string, rotate: any, meta: any, creation_user: any, thumbnailBigUrl: string | null, pageExtracts: Array<{ page_id: any, extract_type_id: any, tables: any | null, dataPoints: any | null, extract_type: { extract_type_id: any, translations: any | null } }> } | null }>, documentType: { translations: any, document_type_tenant_settings: Array<{ documentSchema: any | null }> } }> } | null };

export type AditGetSasTokenQueryVariables = Exact<{
  container: Scalars['String'];
  contentType?: InputMaybe<Scalars['String']>;
  contentDisposition?: InputMaybe<Scalars['String']>;
}>;


export type AditGetSasTokenQuery = { getSASToken: { container: string | null, sasToken: string | null, expiryDate: string | null } | null };

export const AdiAddressesListFragmentFragmentDoc = gql`
    fragment AdiAddressesListFragment on AddressACS {
  id
  companyName
  companyName2
  country
  city
  street
  zipcode
  usageFrequency
  customsAccountNumber
  traderIdentificationNumber
  vatAccountNumber
  uidNumber
  isLocked
  reference
  isPlatformUser
}
    `;
export const OrgIdsListFragmentFragmentDoc = gql`
    fragment OrgIdsListFragment on OrgIdEntity {
  orgId
  orgIdDescription
}
    `;
export const AditRolesListFragmentFragmentDoc = gql`
    fragment AditRolesListFragment on Role {
  id
  name
  isWdRelevant
  description
  translations
}
    `;
export const AditGetCurrentUserDocument = gql`
    query AditGetCurrentUser {
  user: getCurrentUser {
    userId: id
    firstName
    lastName
    email
    uiSettings
    tenantId
    modules {
      name
    }
  }
}
    `;

/**
 * __useAditGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useAditGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAditGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<AditGetCurrentUserQuery, AditGetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetCurrentUserQuery, AditGetCurrentUserQueryVariables>(AditGetCurrentUserDocument, options);
      }
export function useAditGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetCurrentUserQuery, AditGetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetCurrentUserQuery, AditGetCurrentUserQueryVariables>(AditGetCurrentUserDocument, options);
        }
export type AditGetCurrentUserQueryHookResult = ReturnType<typeof useAditGetCurrentUserQuery>;
export type AditGetCurrentUserLazyQueryHookResult = ReturnType<typeof useAditGetCurrentUserLazyQuery>;
export type AditGetCurrentUserQueryResult = Apollo.QueryResult<AditGetCurrentUserQuery, AditGetCurrentUserQueryVariables>;
export const AditGetCurrentUserTenantConfigDocument = gql`
    query AditGetCurrentUserTenantConfig($tenantId: ID!) {
  getTenantConfig(tenantId: $tenantId)
}
    `;

/**
 * __useAditGetCurrentUserTenantConfigQuery__
 *
 * To run a query within a React component, call `useAditGetCurrentUserTenantConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetCurrentUserTenantConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetCurrentUserTenantConfigQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useAditGetCurrentUserTenantConfigQuery(baseOptions: Apollo.QueryHookOptions<AditGetCurrentUserTenantConfigQuery, AditGetCurrentUserTenantConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetCurrentUserTenantConfigQuery, AditGetCurrentUserTenantConfigQueryVariables>(AditGetCurrentUserTenantConfigDocument, options);
      }
export function useAditGetCurrentUserTenantConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetCurrentUserTenantConfigQuery, AditGetCurrentUserTenantConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetCurrentUserTenantConfigQuery, AditGetCurrentUserTenantConfigQueryVariables>(AditGetCurrentUserTenantConfigDocument, options);
        }
export type AditGetCurrentUserTenantConfigQueryHookResult = ReturnType<typeof useAditGetCurrentUserTenantConfigQuery>;
export type AditGetCurrentUserTenantConfigLazyQueryHookResult = ReturnType<typeof useAditGetCurrentUserTenantConfigLazyQuery>;
export type AditGetCurrentUserTenantConfigQueryResult = Apollo.QueryResult<AditGetCurrentUserTenantConfigQuery, AditGetCurrentUserTenantConfigQueryVariables>;
export const AditUpdateCurrentUserUiSettingsDocument = gql`
    mutation AditUpdateCurrentUserUiSettings($id: uuid!, $ui_settings: jsonb!) {
  update_user_pp_by_pk(pk_columns: {id: $id}, _append: {ui_settings: $ui_settings}) {
    id
  }
}
    `;
export type AditUpdateCurrentUserUiSettingsMutationFn = Apollo.MutationFunction<AditUpdateCurrentUserUiSettingsMutation, AditUpdateCurrentUserUiSettingsMutationVariables>;

/**
 * __useAditUpdateCurrentUserUiSettingsMutation__
 *
 * To run a mutation, you first call `useAditUpdateCurrentUserUiSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpdateCurrentUserUiSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdateCurrentUserUiSettingsMutation, { data, loading, error }] = useAditUpdateCurrentUserUiSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ui_settings: // value for 'ui_settings'
 *   },
 * });
 */
export function useAditUpdateCurrentUserUiSettingsMutation(baseOptions?: Apollo.MutationHookOptions<AditUpdateCurrentUserUiSettingsMutation, AditUpdateCurrentUserUiSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpdateCurrentUserUiSettingsMutation, AditUpdateCurrentUserUiSettingsMutationVariables>(AditUpdateCurrentUserUiSettingsDocument, options);
      }
export type AditUpdateCurrentUserUiSettingsMutationHookResult = ReturnType<typeof useAditUpdateCurrentUserUiSettingsMutation>;
export type AditUpdateCurrentUserUiSettingsMutationResult = Apollo.MutationResult<AditUpdateCurrentUserUiSettingsMutation>;
export type AditUpdateCurrentUserUiSettingsMutationOptions = Apollo.BaseMutationOptions<AditUpdateCurrentUserUiSettingsMutation, AditUpdateCurrentUserUiSettingsMutationVariables>;
export const AditGetAddressesListDocument = gql`
    query AditGetAddressesList($search: String, $limit: Int = 10, $ids: [Int!]) {
  addresses: getAddressesByFrequency(search: $search, limit: $limit, ids: $ids) {
    ...AdiAddressesListFragment
  }
}
    ${AdiAddressesListFragmentFragmentDoc}`;

/**
 * __useAditGetAddressesListQuery__
 *
 * To run a query within a React component, call `useAditGetAddressesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetAddressesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetAddressesListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAditGetAddressesListQuery(baseOptions?: Apollo.QueryHookOptions<AditGetAddressesListQuery, AditGetAddressesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetAddressesListQuery, AditGetAddressesListQueryVariables>(AditGetAddressesListDocument, options);
      }
export function useAditGetAddressesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetAddressesListQuery, AditGetAddressesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetAddressesListQuery, AditGetAddressesListQueryVariables>(AditGetAddressesListDocument, options);
        }
export type AditGetAddressesListQueryHookResult = ReturnType<typeof useAditGetAddressesListQuery>;
export type AditGetAddressesListLazyQueryHookResult = ReturnType<typeof useAditGetAddressesListLazyQuery>;
export type AditGetAddressesListQueryResult = Apollo.QueryResult<AditGetAddressesListQuery, AditGetAddressesListQueryVariables>;
export const AditSearchAddressDocument = gql`
    query AditSearchAddress($search: String) {
  addresses: pp_addresses(args: {_search: $search, _limit: 10}) {
    id
    company_name
    street
    street_number
    country
    zipcode
    city
    reference
    customs_account_number
    vat_account_number
  }
}
    `;

/**
 * __useAditSearchAddressQuery__
 *
 * To run a query within a React component, call `useAditSearchAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditSearchAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditSearchAddressQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAditSearchAddressQuery(baseOptions?: Apollo.QueryHookOptions<AditSearchAddressQuery, AditSearchAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditSearchAddressQuery, AditSearchAddressQueryVariables>(AditSearchAddressDocument, options);
      }
export function useAditSearchAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditSearchAddressQuery, AditSearchAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditSearchAddressQuery, AditSearchAddressQueryVariables>(AditSearchAddressDocument, options);
        }
export type AditSearchAddressQueryHookResult = ReturnType<typeof useAditSearchAddressQuery>;
export type AditSearchAddressLazyQueryHookResult = ReturnType<typeof useAditSearchAddressLazyQuery>;
export type AditSearchAddressQueryResult = Apollo.QueryResult<AditSearchAddressQuery, AditSearchAddressQueryVariables>;
export const AditGetCommodityCodesListDocument = gql`
    query aditGetCommodityCodesList($ids: [String!], $search: String, $limit: Int) {
  commodityCodes: getCommodityCodes(ids: $ids, search: $search, limit: $limit) {
    id
    commodityCode
    descriptionDe
    hierarchyVisual
  }
}
    `;

/**
 * __useAditGetCommodityCodesListQuery__
 *
 * To run a query within a React component, call `useAditGetCommodityCodesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetCommodityCodesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetCommodityCodesListQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAditGetCommodityCodesListQuery(baseOptions?: Apollo.QueryHookOptions<AditGetCommodityCodesListQuery, AditGetCommodityCodesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetCommodityCodesListQuery, AditGetCommodityCodesListQueryVariables>(AditGetCommodityCodesListDocument, options);
      }
export function useAditGetCommodityCodesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetCommodityCodesListQuery, AditGetCommodityCodesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetCommodityCodesListQuery, AditGetCommodityCodesListQueryVariables>(AditGetCommodityCodesListDocument, options);
        }
export type AditGetCommodityCodesListQueryHookResult = ReturnType<typeof useAditGetCommodityCodesListQuery>;
export type AditGetCommodityCodesListLazyQueryHookResult = ReturnType<typeof useAditGetCommodityCodesListLazyQuery>;
export type AditGetCommodityCodesListQueryResult = Apollo.QueryResult<AditGetCommodityCodesListQuery, AditGetCommodityCodesListQueryVariables>;
export const AditUpdateDeclarationAiConfirmedDocument = gql`
    mutation AditUpdateDeclarationAiConfirmed($file_id: uuid!, $dr_no: smallint!, $ai_confirmed: Boolean!) {
  update_declaration_by_pk(pk_columns: {file_id: $file_id, dr_no: $dr_no}, _set: {ai_confirmed: $ai_confirmed}) {
    file_id
    dr_no
  }
}
    `;
export type AditUpdateDeclarationAiConfirmedMutationFn = Apollo.MutationFunction<AditUpdateDeclarationAiConfirmedMutation, AditUpdateDeclarationAiConfirmedMutationVariables>;

/**
 * __useAditUpdateDeclarationAiConfirmedMutation__
 *
 * To run a mutation, you first call `useAditUpdateDeclarationAiConfirmedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpdateDeclarationAiConfirmedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdateDeclarationAiConfirmedMutation, { data, loading, error }] = useAditUpdateDeclarationAiConfirmedMutation({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      dr_no: // value for 'dr_no'
 *      ai_confirmed: // value for 'ai_confirmed'
 *   },
 * });
 */
export function useAditUpdateDeclarationAiConfirmedMutation(baseOptions?: Apollo.MutationHookOptions<AditUpdateDeclarationAiConfirmedMutation, AditUpdateDeclarationAiConfirmedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpdateDeclarationAiConfirmedMutation, AditUpdateDeclarationAiConfirmedMutationVariables>(AditUpdateDeclarationAiConfirmedDocument, options);
      }
export type AditUpdateDeclarationAiConfirmedMutationHookResult = ReturnType<typeof useAditUpdateDeclarationAiConfirmedMutation>;
export type AditUpdateDeclarationAiConfirmedMutationResult = Apollo.MutationResult<AditUpdateDeclarationAiConfirmedMutation>;
export type AditUpdateDeclarationAiConfirmedMutationOptions = Apollo.BaseMutationOptions<AditUpdateDeclarationAiConfirmedMutation, AditUpdateDeclarationAiConfirmedMutationVariables>;
export const Adit_Delete_GooditemsDocument = gql`
    mutation ADIT_DELETE_GOODITEMS($file_id: uuid!, $dr_no: smallint!, $trader_item_id: Int!, $source: smallint!) {
  delete_dr_goods_item(where: {file_id: {_eq: $file_id}, trader_item_id: {_eq: $trader_item_id}, dr_no: {_eq: $dr_no}, source: {_eq: $source}}) {
    affected_rows
  }
}
    `;
export type Adit_Delete_GooditemsMutationFn = Apollo.MutationFunction<Adit_Delete_GooditemsMutation, Adit_Delete_GooditemsMutationVariables>;

/**
 * __useAdit_Delete_GooditemsMutation__
 *
 * To run a mutation, you first call `useAdit_Delete_GooditemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Delete_GooditemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditDeleteGooditemsMutation, { data, loading, error }] = useAdit_Delete_GooditemsMutation({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      dr_no: // value for 'dr_no'
 *      trader_item_id: // value for 'trader_item_id'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAdit_Delete_GooditemsMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Delete_GooditemsMutation, Adit_Delete_GooditemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Delete_GooditemsMutation, Adit_Delete_GooditemsMutationVariables>(Adit_Delete_GooditemsDocument, options);
      }
export type Adit_Delete_GooditemsMutationHookResult = ReturnType<typeof useAdit_Delete_GooditemsMutation>;
export type Adit_Delete_GooditemsMutationResult = Apollo.MutationResult<Adit_Delete_GooditemsMutation>;
export type Adit_Delete_GooditemsMutationOptions = Apollo.BaseMutationOptions<Adit_Delete_GooditemsMutation, Adit_Delete_GooditemsMutationVariables>;
export const AditGetDeclarationDocument = gql`
    query AditGetDeclaration($file_id: uuid!, $dr_no: smallint!) {
  declarations: declaration(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}}) {
    file_id
    dr_no
    file {
      identification
    }
    ai_results
    ai_confirmed
    declaration_request {
      cev_status
    }
  }
  declarationsForm: declaration(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}}) {
    file_id
    dr_no
    send_status
    declarant_number
    trader_identification_number
    send_date
    receive_status
    acceptance_date
    customs_declaration_number
    trader_reference
    duty_total_amount
    vat_total_amount
    customs_declaration_version
    material_check
    release
    gross_mass
    net_mass
    transport_mode
    transport_type
    transport_country
    transport_number
    service_type
    invoice_currency_type
    clearance_location
    place_of_unloading
    declaration_time
    declaration_type
    reason
    lang
    customs_office_number
    dispatch_country
    dispatch_country_confirmation
    correction_code
    correction_reason
    addresses {
      address_type
      address_id
      refs
      address {
        id
        company_name
        street
        street_number
        country
        zipcode
        city
        reference
        customs_account_number
        vat_account_number
      }
    }
    transport_in_container
    incoterms
    customs_account_address_type
    customs_account_number
    vat_account_address_type
    vat_account_number
    vat_number
    previous_documents {
      id
      previous_document_type
      previous_document_reference
      additional_information
    }
    containers {
      id
      container_number
    }
    declaration_special_mentions(order_by: {sequence_number: asc}) {
      id
      sequence_number
      text
    }
    goods_items {
      customs_item_number
      selection_result
      commodity_code
      commodity_code_confirmation
      statistical_code
      duty_rate
      rate_confirmation
      description
      net_duty
      net_mass
      net_mass_confirmation
      tare_supplement
      tare_supplement_confirmation
      gross_mass
      gross_mass_confirmation
      customs_net_weight
      additional_unit
      additional_unit_confirmation
      commercial_good
      clearance_type
      customs_favour_code
      origin_country
      origin_preference
      preference_confirmation
      vat_code
      vat_code_confirmation
      statistical_value
      statistical_value_confirmation
      vat_value
      vat_value_confirmation
      repair
      packagings {
        id
        packaging_type
        packaging_quantity
        packaging_reference_number
      }
      produced_documents {
        id
        produced_document_type
        produced_document_reference_number
        produced_document_issue_date
        additional_information
      }
    }
  }
}
    `;

/**
 * __useAditGetDeclarationQuery__
 *
 * To run a query within a React component, call `useAditGetDeclarationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationQuery({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      dr_no: // value for 'dr_no'
 *   },
 * });
 */
export function useAditGetDeclarationQuery(baseOptions: Apollo.QueryHookOptions<AditGetDeclarationQuery, AditGetDeclarationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetDeclarationQuery, AditGetDeclarationQueryVariables>(AditGetDeclarationDocument, options);
      }
export function useAditGetDeclarationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetDeclarationQuery, AditGetDeclarationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetDeclarationQuery, AditGetDeclarationQueryVariables>(AditGetDeclarationDocument, options);
        }
export type AditGetDeclarationQueryHookResult = ReturnType<typeof useAditGetDeclarationQuery>;
export type AditGetDeclarationLazyQueryHookResult = ReturnType<typeof useAditGetDeclarationLazyQuery>;
export type AditGetDeclarationQueryResult = Apollo.QueryResult<AditGetDeclarationQuery, AditGetDeclarationQueryVariables>;
export const AditGetDeclarationGoodsItemsDocument = gql`
    query AditGetDeclarationGoodsItems($file_id: uuid!, $dr_no: smallint!) {
  goods_items: goods_item(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}}) {
    additional_unit
    additional_unit_confirmation
    billing_type
    clearance_type
    commercial_good
    commodity_code
    commodity_code_confirmation
    customs_declaration_version
    customs_favour_code
    customs_item_number
    customs_net_weight
    description
    direction
    dr_no
    duty_and_other_taxes_total
    duty_rate
    duty_total
    file_id
    gross_mass_confirmation
    gross_mass
    net_duty
    net_mass
    net_mass_confirmation
    non_customs_law_obligation
    origin_country
    origin_preference
    permit_obligation_code
    preference_confirmation
    process_type
    rate_confirmation
    refinement_type
    refund_type
    repair
    repair_reason
    selection_result
    statistical_code
    statistical_value
    storage_type
    tare_supplement_confirmation
    tare_supplement
    un_dangerous_goods_code
    vat_code
    vat_code_confirmation
    vat_rate
    vat_total
    vat_value
    vat_value_confirmation
    voc_quantity
    packagings {
      packaging_type
      packaging_quantity
      packaging_reference_number
    }
    produced_documents {
      produced_document_type
      produced_document_reference_number
      produced_document_issue_date
      additional_information
    }
  }
}
    `;

/**
 * __useAditGetDeclarationGoodsItemsQuery__
 *
 * To run a query within a React component, call `useAditGetDeclarationGoodsItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationGoodsItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationGoodsItemsQuery({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      dr_no: // value for 'dr_no'
 *   },
 * });
 */
export function useAditGetDeclarationGoodsItemsQuery(baseOptions: Apollo.QueryHookOptions<AditGetDeclarationGoodsItemsQuery, AditGetDeclarationGoodsItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetDeclarationGoodsItemsQuery, AditGetDeclarationGoodsItemsQueryVariables>(AditGetDeclarationGoodsItemsDocument, options);
      }
export function useAditGetDeclarationGoodsItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetDeclarationGoodsItemsQuery, AditGetDeclarationGoodsItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetDeclarationGoodsItemsQuery, AditGetDeclarationGoodsItemsQueryVariables>(AditGetDeclarationGoodsItemsDocument, options);
        }
export type AditGetDeclarationGoodsItemsQueryHookResult = ReturnType<typeof useAditGetDeclarationGoodsItemsQuery>;
export type AditGetDeclarationGoodsItemsLazyQueryHookResult = ReturnType<typeof useAditGetDeclarationGoodsItemsLazyQuery>;
export type AditGetDeclarationGoodsItemsQueryResult = Apollo.QueryResult<AditGetDeclarationGoodsItemsQuery, AditGetDeclarationGoodsItemsQueryVariables>;
export const AditGetDeclarationLabelsDocument = gql`
    query AditGetDeclarationLabels {
  declarationLabels: declaration_labels {
    tenant_id
    id
    title
    color
    tenant {
      tenant_name
    }
  }
}
    `;

/**
 * __useAditGetDeclarationLabelsQuery__
 *
 * To run a query within a React component, call `useAditGetDeclarationLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAditGetDeclarationLabelsQuery(baseOptions?: Apollo.QueryHookOptions<AditGetDeclarationLabelsQuery, AditGetDeclarationLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetDeclarationLabelsQuery, AditGetDeclarationLabelsQueryVariables>(AditGetDeclarationLabelsDocument, options);
      }
export function useAditGetDeclarationLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetDeclarationLabelsQuery, AditGetDeclarationLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetDeclarationLabelsQuery, AditGetDeclarationLabelsQueryVariables>(AditGetDeclarationLabelsDocument, options);
        }
export type AditGetDeclarationLabelsQueryHookResult = ReturnType<typeof useAditGetDeclarationLabelsQuery>;
export type AditGetDeclarationLabelsLazyQueryHookResult = ReturnType<typeof useAditGetDeclarationLabelsLazyQuery>;
export type AditGetDeclarationLabelsQueryResult = Apollo.QueryResult<AditGetDeclarationLabelsQuery, AditGetDeclarationLabelsQueryVariables>;
export const AditGetDeclarationRequestAddressesAiDocument = gql`
    query AditGetDeclarationRequestAddressesAi($file_id: uuid!, $dr_no: smallint!) {
  declaration_request_addresses_ai: declaration_request_address_ai(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}}) {
    address_id
    address_type
    address {
      id
      company_name
      street
      street_number
      country
      zipcode
      city
    }
  }
}
    `;

/**
 * __useAditGetDeclarationRequestAddressesAiQuery__
 *
 * To run a query within a React component, call `useAditGetDeclarationRequestAddressesAiQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationRequestAddressesAiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationRequestAddressesAiQuery({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      dr_no: // value for 'dr_no'
 *   },
 * });
 */
export function useAditGetDeclarationRequestAddressesAiQuery(baseOptions: Apollo.QueryHookOptions<AditGetDeclarationRequestAddressesAiQuery, AditGetDeclarationRequestAddressesAiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetDeclarationRequestAddressesAiQuery, AditGetDeclarationRequestAddressesAiQueryVariables>(AditGetDeclarationRequestAddressesAiDocument, options);
      }
export function useAditGetDeclarationRequestAddressesAiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetDeclarationRequestAddressesAiQuery, AditGetDeclarationRequestAddressesAiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetDeclarationRequestAddressesAiQuery, AditGetDeclarationRequestAddressesAiQueryVariables>(AditGetDeclarationRequestAddressesAiDocument, options);
        }
export type AditGetDeclarationRequestAddressesAiQueryHookResult = ReturnType<typeof useAditGetDeclarationRequestAddressesAiQuery>;
export type AditGetDeclarationRequestAddressesAiLazyQueryHookResult = ReturnType<typeof useAditGetDeclarationRequestAddressesAiLazyQuery>;
export type AditGetDeclarationRequestAddressesAiQueryResult = Apollo.QueryResult<AditGetDeclarationRequestAddressesAiQuery, AditGetDeclarationRequestAddressesAiQueryVariables>;
export const Adit_Get_Dr_Goods_ItemsDocument = gql`
    query ADIT_GET_DR_GOODS_ITEMS($file_id: uuid!, $offset: Int!, $limit: Int!) {
  dr_goods_items: dr_goods_item(where: {file_id: {_eq: $file_id}}, offset: $offset, limit: $limit) {
    packaging
    certificates
    commodity_code
    description
    dr_no
    file_id
    gross_mass
    net_mass
    non_customs_law_obligation
    origin
    statistic
    statistical_code
    trader_item_id
    valuation
  }
  dr_goods_item_aggregate(where: {file_id: {_eq: $file_id}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdit_Get_Dr_Goods_ItemsQuery__
 *
 * To run a query within a React component, call `useAdit_Get_Dr_Goods_ItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Dr_Goods_ItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Dr_Goods_ItemsQuery({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdit_Get_Dr_Goods_ItemsQuery(baseOptions: Apollo.QueryHookOptions<Adit_Get_Dr_Goods_ItemsQuery, Adit_Get_Dr_Goods_ItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Dr_Goods_ItemsQuery, Adit_Get_Dr_Goods_ItemsQueryVariables>(Adit_Get_Dr_Goods_ItemsDocument, options);
      }
export function useAdit_Get_Dr_Goods_ItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Dr_Goods_ItemsQuery, Adit_Get_Dr_Goods_ItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Dr_Goods_ItemsQuery, Adit_Get_Dr_Goods_ItemsQueryVariables>(Adit_Get_Dr_Goods_ItemsDocument, options);
        }
export type Adit_Get_Dr_Goods_ItemsQueryHookResult = ReturnType<typeof useAdit_Get_Dr_Goods_ItemsQuery>;
export type Adit_Get_Dr_Goods_ItemsLazyQueryHookResult = ReturnType<typeof useAdit_Get_Dr_Goods_ItemsLazyQuery>;
export type Adit_Get_Dr_Goods_ItemsQueryResult = Apollo.QueryResult<Adit_Get_Dr_Goods_ItemsQuery, Adit_Get_Dr_Goods_ItemsQueryVariables>;
export const AditUpsertDeclarationDocument = gql`
    mutation AditUpsertDeclaration($file_id: uuid!, $dr_no: smallint!, $object: declaration_insert_input!, $constraint: declaration_constraint!, $update_columns: [declaration_update_column!]!, $goodsItemsToDeleteExp: [goods_item_bool_exp!]!, $previousDocumentsToDeleteExp: [previous_documents_bool_exp!]!, $containersToDeleteExp: [containers_bool_exp!]!, $declarationSpecialMentionsToDeleteExp: [declaration_special_mentions_bool_exp!]!, $packagingsToDeleteExp: [packagings_bool_exp!]!, $producedDocumentsToDeleteExp: [produced_documents_bool_exp!]!) {
  insert_declaration_one(object: $object, on_conflict: {constraint: $constraint, update_columns: $update_columns}) {
    file_id
    dr_no
  }
  delete_previous_documents(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}, _or: $previousDocumentsToDeleteExp}) {
    affected_rows
  }
  delete_containers(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}, _or: $containersToDeleteExp}) {
    affected_rows
  }
  delete_declaration_special_mentions(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}, _or: $declarationSpecialMentionsToDeleteExp}) {
    affected_rows
  }
  delete_goods_item(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}, _or: $goodsItemsToDeleteExp}) {
    affected_rows
  }
  delete_packagings(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}, _or: $packagingsToDeleteExp}) {
    affected_rows
  }
  delete_produced_documents(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}, _or: $producedDocumentsToDeleteExp}) {
    affected_rows
  }
}
    `;
export type AditUpsertDeclarationMutationFn = Apollo.MutationFunction<AditUpsertDeclarationMutation, AditUpsertDeclarationMutationVariables>;

/**
 * __useAditUpsertDeclarationMutation__
 *
 * To run a mutation, you first call `useAditUpsertDeclarationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpsertDeclarationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpsertDeclarationMutation, { data, loading, error }] = useAditUpsertDeclarationMutation({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      dr_no: // value for 'dr_no'
 *      object: // value for 'object'
 *      constraint: // value for 'constraint'
 *      update_columns: // value for 'update_columns'
 *      goodsItemsToDeleteExp: // value for 'goodsItemsToDeleteExp'
 *      previousDocumentsToDeleteExp: // value for 'previousDocumentsToDeleteExp'
 *      containersToDeleteExp: // value for 'containersToDeleteExp'
 *      declarationSpecialMentionsToDeleteExp: // value for 'declarationSpecialMentionsToDeleteExp'
 *      packagingsToDeleteExp: // value for 'packagingsToDeleteExp'
 *      producedDocumentsToDeleteExp: // value for 'producedDocumentsToDeleteExp'
 *   },
 * });
 */
export function useAditUpsertDeclarationMutation(baseOptions?: Apollo.MutationHookOptions<AditUpsertDeclarationMutation, AditUpsertDeclarationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpsertDeclarationMutation, AditUpsertDeclarationMutationVariables>(AditUpsertDeclarationDocument, options);
      }
export type AditUpsertDeclarationMutationHookResult = ReturnType<typeof useAditUpsertDeclarationMutation>;
export type AditUpsertDeclarationMutationResult = Apollo.MutationResult<AditUpsertDeclarationMutation>;
export type AditUpsertDeclarationMutationOptions = Apollo.BaseMutationOptions<AditUpsertDeclarationMutation, AditUpsertDeclarationMutationVariables>;
export const AditInsertDeclarationGoodItemDocument = gql`
    mutation AditInsertDeclarationGoodItem($dr_goods_item: dr_goods_item_insert_input!) {
  insert_dr_goods_item_one(object: $dr_goods_item, on_conflict: {constraint: pk_dr_good_item_file_id_dr_no_trader_item_id, update_columns: [packaging, commodity_code, description, gross_mass, net_mass, origin, statistic, amount, traded_goods, customs_net_mass, key, additional_pcs, net_declaration, revision, statistical_code]}) {
    file_id
  }
}
    `;
export type AditInsertDeclarationGoodItemMutationFn = Apollo.MutationFunction<AditInsertDeclarationGoodItemMutation, AditInsertDeclarationGoodItemMutationVariables>;

/**
 * __useAditInsertDeclarationGoodItemMutation__
 *
 * To run a mutation, you first call `useAditInsertDeclarationGoodItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditInsertDeclarationGoodItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditInsertDeclarationGoodItemMutation, { data, loading, error }] = useAditInsertDeclarationGoodItemMutation({
 *   variables: {
 *      dr_goods_item: // value for 'dr_goods_item'
 *   },
 * });
 */
export function useAditInsertDeclarationGoodItemMutation(baseOptions?: Apollo.MutationHookOptions<AditInsertDeclarationGoodItemMutation, AditInsertDeclarationGoodItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditInsertDeclarationGoodItemMutation, AditInsertDeclarationGoodItemMutationVariables>(AditInsertDeclarationGoodItemDocument, options);
      }
export type AditInsertDeclarationGoodItemMutationHookResult = ReturnType<typeof useAditInsertDeclarationGoodItemMutation>;
export type AditInsertDeclarationGoodItemMutationResult = Apollo.MutationResult<AditInsertDeclarationGoodItemMutation>;
export type AditInsertDeclarationGoodItemMutationOptions = Apollo.BaseMutationOptions<AditInsertDeclarationGoodItemMutation, AditInsertDeclarationGoodItemMutationVariables>;
export const AditUpsertDeclarationRequestAddressesDocument = gql`
    mutation AditUpsertDeclarationRequestAddresses($declaration_request_addresses: [declaration_request_address_insert_input!]!) {
  insert_declaration_request_address(objects: $declaration_request_addresses, on_conflict: {constraint: declaration_request_address_pkey, update_columns: [file_id, dr_no, address_id, address_type]}) {
    affected_rows
  }
}
    `;
export type AditUpsertDeclarationRequestAddressesMutationFn = Apollo.MutationFunction<AditUpsertDeclarationRequestAddressesMutation, AditUpsertDeclarationRequestAddressesMutationVariables>;

/**
 * __useAditUpsertDeclarationRequestAddressesMutation__
 *
 * To run a mutation, you first call `useAditUpsertDeclarationRequestAddressesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpsertDeclarationRequestAddressesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpsertDeclarationRequestAddressesMutation, { data, loading, error }] = useAditUpsertDeclarationRequestAddressesMutation({
 *   variables: {
 *      declaration_request_addresses: // value for 'declaration_request_addresses'
 *   },
 * });
 */
export function useAditUpsertDeclarationRequestAddressesMutation(baseOptions?: Apollo.MutationHookOptions<AditUpsertDeclarationRequestAddressesMutation, AditUpsertDeclarationRequestAddressesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpsertDeclarationRequestAddressesMutation, AditUpsertDeclarationRequestAddressesMutationVariables>(AditUpsertDeclarationRequestAddressesDocument, options);
      }
export type AditUpsertDeclarationRequestAddressesMutationHookResult = ReturnType<typeof useAditUpsertDeclarationRequestAddressesMutation>;
export type AditUpsertDeclarationRequestAddressesMutationResult = Apollo.MutationResult<AditUpsertDeclarationRequestAddressesMutation>;
export type AditUpsertDeclarationRequestAddressesMutationOptions = Apollo.BaseMutationOptions<AditUpsertDeclarationRequestAddressesMutation, AditUpsertDeclarationRequestAddressesMutationVariables>;
export const Adit_Mark_Declaration_Discussion_As_ReadDocument = gql`
    mutation ADIT_MARK_DECLARATION_DISCUSSION_AS_READ($disc_id: bigint, $read_date: timestamptz!) {
  update_declaration_message(_set: {read_date: $read_date}, where: {discussion_id: {_eq: $disc_id}, read_date: {_is_null: true}, user: {tenant_id: {_neq: "b4b61b73-4f38-45a0-b460-7e38b2777479"}}}) {
    returning {
      discussion_id
    }
  }
}
    `;
export type Adit_Mark_Declaration_Discussion_As_ReadMutationFn = Apollo.MutationFunction<Adit_Mark_Declaration_Discussion_As_ReadMutation, Adit_Mark_Declaration_Discussion_As_ReadMutationVariables>;

/**
 * __useAdit_Mark_Declaration_Discussion_As_ReadMutation__
 *
 * To run a mutation, you first call `useAdit_Mark_Declaration_Discussion_As_ReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Mark_Declaration_Discussion_As_ReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditMarkDeclarationDiscussionAsReadMutation, { data, loading, error }] = useAdit_Mark_Declaration_Discussion_As_ReadMutation({
 *   variables: {
 *      disc_id: // value for 'disc_id'
 *      read_date: // value for 'read_date'
 *   },
 * });
 */
export function useAdit_Mark_Declaration_Discussion_As_ReadMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Mark_Declaration_Discussion_As_ReadMutation, Adit_Mark_Declaration_Discussion_As_ReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Mark_Declaration_Discussion_As_ReadMutation, Adit_Mark_Declaration_Discussion_As_ReadMutationVariables>(Adit_Mark_Declaration_Discussion_As_ReadDocument, options);
      }
export type Adit_Mark_Declaration_Discussion_As_ReadMutationHookResult = ReturnType<typeof useAdit_Mark_Declaration_Discussion_As_ReadMutation>;
export type Adit_Mark_Declaration_Discussion_As_ReadMutationResult = Apollo.MutationResult<Adit_Mark_Declaration_Discussion_As_ReadMutation>;
export type Adit_Mark_Declaration_Discussion_As_ReadMutationOptions = Apollo.BaseMutationOptions<Adit_Mark_Declaration_Discussion_As_ReadMutation, Adit_Mark_Declaration_Discussion_As_ReadMutationVariables>;
export const AditGetDeclarationRequestDocument = gql`
    subscription AditGetDeclarationRequest($identification: String!, $dr_no: smallint!) {
  declaration_requests: declaration_request(where: {file: {identification: {_eq: $identification}}, dr_no: {_eq: $dr_no}}) {
    file_id
    dr_no
    acceptance_date
    creation_date
    payer {
      address {
        id
      }
    }
    addresses {
      address_type
      address {
        id
        company_name
        street
        street_number
        country
        zipcode
        city
      }
      refs
    }
    dr_goods_items {
      file_id
      dr_no
      trader_item_id
      packaging
      commodity_code
      description
      gross_mass
      net_mass
      origin
      statistic
      amount
      traded_goods
      customs_net_mass
      key
      additional_pcs
      net_declaration
      revision
      source
      statistical_code
    }
    file {
      identification
    }
  }
}
    `;

/**
 * __useAditGetDeclarationRequestSubscription__
 *
 * To run a query within a React component, call `useAditGetDeclarationRequestSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationRequestSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationRequestSubscription({
 *   variables: {
 *      identification: // value for 'identification'
 *      dr_no: // value for 'dr_no'
 *   },
 * });
 */
export function useAditGetDeclarationRequestSubscription(baseOptions: Apollo.SubscriptionHookOptions<AditGetDeclarationRequestSubscription, AditGetDeclarationRequestSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AditGetDeclarationRequestSubscription, AditGetDeclarationRequestSubscriptionVariables>(AditGetDeclarationRequestDocument, options);
      }
export type AditGetDeclarationRequestSubscriptionHookResult = ReturnType<typeof useAditGetDeclarationRequestSubscription>;
export type AditGetDeclarationRequestSubscriptionResult = Apollo.SubscriptionResult<AditGetDeclarationRequestSubscription>;
export const Adit_Get_DocumentDocument = gql`
    query ADIT_GET_DOCUMENT($id: uuid!) {
  documents: document(where: {id: {_eq: $id}}) {
    id
    document_extension
    document_name
    creation_date
    creation_user
    pages_m2m(order_by: {page_number: asc}) {
      page {
        id
        thumbnail_small_url
        thumbnail_big_url
        page_status
        rotate
        meta
      }
    }
    org_id
    orgId {
      org_id_description
    }
    document_status
    document_flags
    document_blobs
  }
}
    `;

/**
 * __useAdit_Get_DocumentQuery__
 *
 * To run a query within a React component, call `useAdit_Get_DocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_DocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_DocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdit_Get_DocumentQuery(baseOptions: Apollo.QueryHookOptions<Adit_Get_DocumentQuery, Adit_Get_DocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_DocumentQuery, Adit_Get_DocumentQueryVariables>(Adit_Get_DocumentDocument, options);
      }
export function useAdit_Get_DocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_DocumentQuery, Adit_Get_DocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_DocumentQuery, Adit_Get_DocumentQueryVariables>(Adit_Get_DocumentDocument, options);
        }
export type Adit_Get_DocumentQueryHookResult = ReturnType<typeof useAdit_Get_DocumentQuery>;
export type Adit_Get_DocumentLazyQueryHookResult = ReturnType<typeof useAdit_Get_DocumentLazyQuery>;
export type Adit_Get_DocumentQueryResult = Apollo.QueryResult<Adit_Get_DocumentQuery, Adit_Get_DocumentQueryVariables>;
export const AditGetDocumentsForSubscriptionDocument = gql`
    query AditGetDocumentsForSubscription($offset: Int, $limit: Int, $creationUser: uuid, $search: String, $orderBy: String) {
  documents: pp_doc_search_hs(args: {_creationuser: $creationUser, _limit: $limit, _offset: $offset, _searchval: $search, _orderby: $orderBy}) {
    id
    document_extension
    document_name
    creation_date
    creation_user
    pages_m2m_aggregate(where: {page: {page_status: {_neq: "classified"}}}) {
      aggregate {
        count
      }
    }
    org_id
    org_id_description
    document_status
    document_flags
    document_blobs
    total_rows
    user_display_name
  }
}
    `;

/**
 * __useAditGetDocumentsForSubscriptionQuery__
 *
 * To run a query within a React component, call `useAditGetDocumentsForSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDocumentsForSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDocumentsForSubscriptionQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      creationUser: // value for 'creationUser'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAditGetDocumentsForSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<AditGetDocumentsForSubscriptionQuery, AditGetDocumentsForSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetDocumentsForSubscriptionQuery, AditGetDocumentsForSubscriptionQueryVariables>(AditGetDocumentsForSubscriptionDocument, options);
      }
export function useAditGetDocumentsForSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetDocumentsForSubscriptionQuery, AditGetDocumentsForSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetDocumentsForSubscriptionQuery, AditGetDocumentsForSubscriptionQueryVariables>(AditGetDocumentsForSubscriptionDocument, options);
        }
export type AditGetDocumentsForSubscriptionQueryHookResult = ReturnType<typeof useAditGetDocumentsForSubscriptionQuery>;
export type AditGetDocumentsForSubscriptionLazyQueryHookResult = ReturnType<typeof useAditGetDocumentsForSubscriptionLazyQuery>;
export type AditGetDocumentsForSubscriptionQueryResult = Apollo.QueryResult<AditGetDocumentsForSubscriptionQuery, AditGetDocumentsForSubscriptionQueryVariables>;
export const GetDocumentUpdatesDocument = gql`
    subscription getDocumentUpdates($my: Boolean) {
  pp_doc_max_date_hs: pp_doc_max_date_v2(args: {_my: $my}) {
    max_change_date
  }
}
    `;

/**
 * __useGetDocumentUpdatesSubscription__
 *
 * To run a query within a React component, call `useGetDocumentUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentUpdatesSubscription({
 *   variables: {
 *      my: // value for 'my'
 *   },
 * });
 */
export function useGetDocumentUpdatesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetDocumentUpdatesSubscription, GetDocumentUpdatesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetDocumentUpdatesSubscription, GetDocumentUpdatesSubscriptionVariables>(GetDocumentUpdatesDocument, options);
      }
export type GetDocumentUpdatesSubscriptionHookResult = ReturnType<typeof useGetDocumentUpdatesSubscription>;
export type GetDocumentUpdatesSubscriptionResult = Apollo.SubscriptionResult<GetDocumentUpdatesSubscription>;
export const Adit_Get_Document_TypesDocument = gql`
    query ADIT_GET_DOCUMENT_TYPES($tenantId: uuid!, $limit: Int, $offset: Int, $where: document_type_bool_exp!) {
  document_type(order_by: {creation_date: asc}, where: $where, limit: $limit, offset: $offset) {
    document_type_tenant_settings(where: {tenant: {_eq: $tenantId}}) {
      code
      default_flags
      meta
    }
    last_modified_date: last_modified_date
    name
    display_name
    translations
  }
  document_type_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdit_Get_Document_TypesQuery__
 *
 * To run a query within a React component, call `useAdit_Get_Document_TypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Document_TypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Document_TypesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdit_Get_Document_TypesQuery(baseOptions: Apollo.QueryHookOptions<Adit_Get_Document_TypesQuery, Adit_Get_Document_TypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Document_TypesQuery, Adit_Get_Document_TypesQueryVariables>(Adit_Get_Document_TypesDocument, options);
      }
export function useAdit_Get_Document_TypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Document_TypesQuery, Adit_Get_Document_TypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Document_TypesQuery, Adit_Get_Document_TypesQueryVariables>(Adit_Get_Document_TypesDocument, options);
        }
export type Adit_Get_Document_TypesQueryHookResult = ReturnType<typeof useAdit_Get_Document_TypesQuery>;
export type Adit_Get_Document_TypesLazyQueryHookResult = ReturnType<typeof useAdit_Get_Document_TypesLazyQuery>;
export type Adit_Get_Document_TypesQueryResult = Apollo.QueryResult<Adit_Get_Document_TypesQuery, Adit_Get_Document_TypesQueryVariables>;
export const Adit_Get_Document_Type_FlagsDocument = gql`
    query ADIT_GET_DOCUMENT_TYPE_FLAGS {
  document_flag(where: {id: {_neq: 0}}, order_by: {id: asc}) {
    id
    name
    translation
    color
  }
}
    `;

/**
 * __useAdit_Get_Document_Type_FlagsQuery__
 *
 * To run a query within a React component, call `useAdit_Get_Document_Type_FlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Document_Type_FlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Document_Type_FlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdit_Get_Document_Type_FlagsQuery(baseOptions?: Apollo.QueryHookOptions<Adit_Get_Document_Type_FlagsQuery, Adit_Get_Document_Type_FlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Document_Type_FlagsQuery, Adit_Get_Document_Type_FlagsQueryVariables>(Adit_Get_Document_Type_FlagsDocument, options);
      }
export function useAdit_Get_Document_Type_FlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Document_Type_FlagsQuery, Adit_Get_Document_Type_FlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Document_Type_FlagsQuery, Adit_Get_Document_Type_FlagsQueryVariables>(Adit_Get_Document_Type_FlagsDocument, options);
        }
export type Adit_Get_Document_Type_FlagsQueryHookResult = ReturnType<typeof useAdit_Get_Document_Type_FlagsQuery>;
export type Adit_Get_Document_Type_FlagsLazyQueryHookResult = ReturnType<typeof useAdit_Get_Document_Type_FlagsLazyQuery>;
export type Adit_Get_Document_Type_FlagsQueryResult = Apollo.QueryResult<Adit_Get_Document_Type_FlagsQuery, Adit_Get_Document_Type_FlagsQueryVariables>;
export const Adit_Get_Extract_TypesDocument = gql`
    query ADIT_GET_EXTRACT_TYPES {
  extract_types: extract_type {
    extract_type_id
    translations
  }
}
    `;

/**
 * __useAdit_Get_Extract_TypesQuery__
 *
 * To run a query within a React component, call `useAdit_Get_Extract_TypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Extract_TypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Extract_TypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdit_Get_Extract_TypesQuery(baseOptions?: Apollo.QueryHookOptions<Adit_Get_Extract_TypesQuery, Adit_Get_Extract_TypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Extract_TypesQuery, Adit_Get_Extract_TypesQueryVariables>(Adit_Get_Extract_TypesDocument, options);
      }
export function useAdit_Get_Extract_TypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Extract_TypesQuery, Adit_Get_Extract_TypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Extract_TypesQuery, Adit_Get_Extract_TypesQueryVariables>(Adit_Get_Extract_TypesDocument, options);
        }
export type Adit_Get_Extract_TypesQueryHookResult = ReturnType<typeof useAdit_Get_Extract_TypesQuery>;
export type Adit_Get_Extract_TypesLazyQueryHookResult = ReturnType<typeof useAdit_Get_Extract_TypesLazyQuery>;
export type Adit_Get_Extract_TypesQueryResult = Apollo.QueryResult<Adit_Get_Extract_TypesQuery, Adit_Get_Extract_TypesQueryVariables>;
export const UpdateFileDocument = gql`
    mutation updateFile($id: [uuid!]!) {
  update_file(where: {id: {_in: $id}}, _set: {is_deleted: true}) {
    affected_rows
  }
}
    `;
export type UpdateFileMutationFn = Apollo.MutationFunction<UpdateFileMutation, UpdateFileMutationVariables>;

/**
 * __useUpdateFileMutation__
 *
 * To run a mutation, you first call `useUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMutation, { data, loading, error }] = useUpdateFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileMutation, UpdateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileMutation, UpdateFileMutationVariables>(UpdateFileDocument, options);
      }
export type UpdateFileMutationHookResult = ReturnType<typeof useUpdateFileMutation>;
export type UpdateFileMutationResult = Apollo.MutationResult<UpdateFileMutation>;
export type UpdateFileMutationOptions = Apollo.BaseMutationOptions<UpdateFileMutation, UpdateFileMutationVariables>;
export const Adit_Get_EmailDocument = gql`
    query ADIT_GET_EMAIL($id: uuid!, $offset: Int, $limit: Int, $orderBy: String, $search: String) {
  emails: pp_email_search_hs(args: {_offset: $offset, _limit: $limit, _search: $search, _orderby: $orderBy}, where: {id: {_eq: $id}}) {
    id
    name
    meta
    file_status
    creation_user
    creation_date
    file_url
    company
    sender
    total_rows
    documents(where: {_or: {is_deleted: {_eq: false}, document_status: {_neq: "classified"}}}) {
      id
      document_type
      document_status
      document_name
      document_extension
      document_flags
      creation_date
      sequence
      meta
      document_blobs
      created_by_user {
        display_name
      }
      computedPagesM2M(where: {page_status: {_neq: "classified"}}) {
        id: page
        thumbnail_small_url
        thumbnail_big_url
        page_status
        rotate
        meta
      }
    }
  }
}
    `;

/**
 * __useAdit_Get_EmailQuery__
 *
 * To run a query within a React component, call `useAdit_Get_EmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_EmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_EmailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdit_Get_EmailQuery(baseOptions: Apollo.QueryHookOptions<Adit_Get_EmailQuery, Adit_Get_EmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_EmailQuery, Adit_Get_EmailQueryVariables>(Adit_Get_EmailDocument, options);
      }
export function useAdit_Get_EmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_EmailQuery, Adit_Get_EmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_EmailQuery, Adit_Get_EmailQueryVariables>(Adit_Get_EmailDocument, options);
        }
export type Adit_Get_EmailQueryHookResult = ReturnType<typeof useAdit_Get_EmailQuery>;
export type Adit_Get_EmailLazyQueryHookResult = ReturnType<typeof useAdit_Get_EmailLazyQuery>;
export type Adit_Get_EmailQueryResult = Apollo.QueryResult<Adit_Get_EmailQuery, Adit_Get_EmailQueryVariables>;
export const GetEmailsDocument = gql`
    query getEmails($offset: Int, $limit: Int, $orderBy: String, $search: String) {
  pp_email_search_hs(args: {_offset: $offset, _limit: $limit, _search: $search, _orderby: $orderBy}, where: {documents: {_and: [{is_deleted: {_eq: false}}, {document_status: {_neq: "classified"}}, {document_status: {_neq: "classified_pending"}}]}}) {
    id
    name
    meta
    file_status
    creation_user
    creation_date
    file_url
    company
    sender
    total_rows
    documents(where: {_or: {is_deleted: {_eq: false}, document_status: {_neq: "classified"}}}) {
      id
      document_type
      document_status
      document_name
      document_extension
      document_flags
      creation_date
      sequence
      meta
      document_blobs
      created_by_user {
        display_name
      }
      pages_m2m_aggregate(where: {page: {page_status: {_neq: "classified"}}}) {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmailsQuery__
 *
 * To run a query within a React component, call `useGetEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEmailsQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailsQuery, GetEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailsQuery, GetEmailsQueryVariables>(GetEmailsDocument, options);
      }
export function useGetEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailsQuery, GetEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailsQuery, GetEmailsQueryVariables>(GetEmailsDocument, options);
        }
export type GetEmailsQueryHookResult = ReturnType<typeof useGetEmailsQuery>;
export type GetEmailsLazyQueryHookResult = ReturnType<typeof useGetEmailsLazyQuery>;
export type GetEmailsQueryResult = Apollo.QueryResult<GetEmailsQuery, GetEmailsQueryVariables>;
export const GetFilesForSubscriptionDocument = gql`
    query getFilesForSubscription($offset: Int, $limit: Int, $currUserId: uuid, $orderBy: String, $fileFlags: _int8, $minDate: timestamptz, $maxDate: timestamptz, $search: String, $orgIds: _int2, $myFilesOnly: Boolean, $fileStatuses: _text) {
  files: pp_file_search(args: {_limit: $limit, _offset: $offset, _orderby: $orderBy, _file_flags: $fileFlags, _max_date: $maxDate, _min_date: $minDate, _searchval: $search, _curr_userid: $currUserId, _org_ids: $orgIds, _my_files_only: $myFilesOnly, _file_statuses: $fileStatuses}) {
    id
    identification
    name
    org_id
    org_id_description
    meta
    file_flags
    file_status
    creation_user
    creation_date
    last_modified_date
    file_url
    total_rows
    customs_relevant
    extraction_required
  }
}
    `;

/**
 * __useGetFilesForSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetFilesForSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesForSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesForSubscriptionQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      currUserId: // value for 'currUserId'
 *      orderBy: // value for 'orderBy'
 *      fileFlags: // value for 'fileFlags'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      search: // value for 'search'
 *      orgIds: // value for 'orgIds'
 *      myFilesOnly: // value for 'myFilesOnly'
 *      fileStatuses: // value for 'fileStatuses'
 *   },
 * });
 */
export function useGetFilesForSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetFilesForSubscriptionQuery, GetFilesForSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesForSubscriptionQuery, GetFilesForSubscriptionQueryVariables>(GetFilesForSubscriptionDocument, options);
      }
export function useGetFilesForSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesForSubscriptionQuery, GetFilesForSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesForSubscriptionQuery, GetFilesForSubscriptionQueryVariables>(GetFilesForSubscriptionDocument, options);
        }
export type GetFilesForSubscriptionQueryHookResult = ReturnType<typeof useGetFilesForSubscriptionQuery>;
export type GetFilesForSubscriptionLazyQueryHookResult = ReturnType<typeof useGetFilesForSubscriptionLazyQuery>;
export type GetFilesForSubscriptionQueryResult = Apollo.QueryResult<GetFilesForSubscriptionQuery, GetFilesForSubscriptionQueryVariables>;
export const AditUpdateFileNumberDocument = gql`
    mutation ADITUpdateFileNumber($file_id: ID!, $file_number: String!) {
  updateFileNumber(file_id: $file_id, file_number: $file_number) {
    file_id
  }
}
    `;
export type AditUpdateFileNumberMutationFn = Apollo.MutationFunction<AditUpdateFileNumberMutation, AditUpdateFileNumberMutationVariables>;

/**
 * __useAditUpdateFileNumberMutation__
 *
 * To run a mutation, you first call `useAditUpdateFileNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpdateFileNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdateFileNumberMutation, { data, loading, error }] = useAditUpdateFileNumberMutation({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      file_number: // value for 'file_number'
 *   },
 * });
 */
export function useAditUpdateFileNumberMutation(baseOptions?: Apollo.MutationHookOptions<AditUpdateFileNumberMutation, AditUpdateFileNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpdateFileNumberMutation, AditUpdateFileNumberMutationVariables>(AditUpdateFileNumberDocument, options);
      }
export type AditUpdateFileNumberMutationHookResult = ReturnType<typeof useAditUpdateFileNumberMutation>;
export type AditUpdateFileNumberMutationResult = Apollo.MutationResult<AditUpdateFileNumberMutation>;
export type AditUpdateFileNumberMutationOptions = Apollo.BaseMutationOptions<AditUpdateFileNumberMutation, AditUpdateFileNumberMutationVariables>;
export const AditGetOrgIdsListDocument = gql`
    query AditGetOrgIdsList($ids: [Int!]) {
  orgIds: getOrgIds(ids: $ids) {
    ...OrgIdsListFragment
  }
}
    ${OrgIdsListFragmentFragmentDoc}`;

/**
 * __useAditGetOrgIdsListQuery__
 *
 * To run a query within a React component, call `useAditGetOrgIdsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetOrgIdsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetOrgIdsListQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAditGetOrgIdsListQuery(baseOptions?: Apollo.QueryHookOptions<AditGetOrgIdsListQuery, AditGetOrgIdsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetOrgIdsListQuery, AditGetOrgIdsListQueryVariables>(AditGetOrgIdsListDocument, options);
      }
export function useAditGetOrgIdsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetOrgIdsListQuery, AditGetOrgIdsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetOrgIdsListQuery, AditGetOrgIdsListQueryVariables>(AditGetOrgIdsListDocument, options);
        }
export type AditGetOrgIdsListQueryHookResult = ReturnType<typeof useAditGetOrgIdsListQuery>;
export type AditGetOrgIdsListLazyQueryHookResult = ReturnType<typeof useAditGetOrgIdsListLazyQuery>;
export type AditGetOrgIdsListQueryResult = Apollo.QueryResult<AditGetOrgIdsListQuery, AditGetOrgIdsListQueryVariables>;
export const AditGetUserOrgIdsListDocument = gql`
    query AditGetUserOrgIdsList {
  userOrgIds: getUserOrgIds {
    ...OrgIdsListFragment
  }
}
    ${OrgIdsListFragmentFragmentDoc}`;

/**
 * __useAditGetUserOrgIdsListQuery__
 *
 * To run a query within a React component, call `useAditGetUserOrgIdsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetUserOrgIdsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetUserOrgIdsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAditGetUserOrgIdsListQuery(baseOptions?: Apollo.QueryHookOptions<AditGetUserOrgIdsListQuery, AditGetUserOrgIdsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetUserOrgIdsListQuery, AditGetUserOrgIdsListQueryVariables>(AditGetUserOrgIdsListDocument, options);
      }
export function useAditGetUserOrgIdsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetUserOrgIdsListQuery, AditGetUserOrgIdsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetUserOrgIdsListQuery, AditGetUserOrgIdsListQueryVariables>(AditGetUserOrgIdsListDocument, options);
        }
export type AditGetUserOrgIdsListQueryHookResult = ReturnType<typeof useAditGetUserOrgIdsListQuery>;
export type AditGetUserOrgIdsListLazyQueryHookResult = ReturnType<typeof useAditGetUserOrgIdsListLazyQuery>;
export type AditGetUserOrgIdsListQueryResult = Apollo.QueryResult<AditGetUserOrgIdsListQuery, AditGetUserOrgIdsListQueryVariables>;
export const AditGetRolesListDocument = gql`
    query AditGetRolesList {
  roles: getAditRoles {
    ...AditRolesListFragment
  }
}
    ${AditRolesListFragmentFragmentDoc}`;

/**
 * __useAditGetRolesListQuery__
 *
 * To run a query within a React component, call `useAditGetRolesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetRolesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetRolesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAditGetRolesListQuery(baseOptions?: Apollo.QueryHookOptions<AditGetRolesListQuery, AditGetRolesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetRolesListQuery, AditGetRolesListQueryVariables>(AditGetRolesListDocument, options);
      }
export function useAditGetRolesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetRolesListQuery, AditGetRolesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetRolesListQuery, AditGetRolesListQueryVariables>(AditGetRolesListDocument, options);
        }
export type AditGetRolesListQueryHookResult = ReturnType<typeof useAditGetRolesListQuery>;
export type AditGetRolesListLazyQueryHookResult = ReturnType<typeof useAditGetRolesListLazyQuery>;
export type AditGetRolesListQueryResult = Apollo.QueryResult<AditGetRolesListQuery, AditGetRolesListQueryVariables>;
export const Adit_Get_Declaration_Request_EdecDocument = gql`
    query ADIT_GET_DECLARATION_REQUEST_EDEC($fileId: uuid!) {
  declaration_request(where: {file_id: {_eq: $fileId}}) {
    edec
  }
}
    `;

/**
 * __useAdit_Get_Declaration_Request_EdecQuery__
 *
 * To run a query within a React component, call `useAdit_Get_Declaration_Request_EdecQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Declaration_Request_EdecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Declaration_Request_EdecQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useAdit_Get_Declaration_Request_EdecQuery(baseOptions: Apollo.QueryHookOptions<Adit_Get_Declaration_Request_EdecQuery, Adit_Get_Declaration_Request_EdecQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Declaration_Request_EdecQuery, Adit_Get_Declaration_Request_EdecQueryVariables>(Adit_Get_Declaration_Request_EdecDocument, options);
      }
export function useAdit_Get_Declaration_Request_EdecLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Declaration_Request_EdecQuery, Adit_Get_Declaration_Request_EdecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Declaration_Request_EdecQuery, Adit_Get_Declaration_Request_EdecQueryVariables>(Adit_Get_Declaration_Request_EdecDocument, options);
        }
export type Adit_Get_Declaration_Request_EdecQueryHookResult = ReturnType<typeof useAdit_Get_Declaration_Request_EdecQuery>;
export type Adit_Get_Declaration_Request_EdecLazyQueryHookResult = ReturnType<typeof useAdit_Get_Declaration_Request_EdecLazyQuery>;
export type Adit_Get_Declaration_Request_EdecQueryResult = Apollo.QueryResult<Adit_Get_Declaration_Request_EdecQuery, Adit_Get_Declaration_Request_EdecQueryVariables>;
export const Adit_Update_Declaration_Request_EdecDocument = gql`
    mutation ADIT_UPDATE_DECLARATION_REQUEST_EDEC($edec: jsonb!, $fileId: uuid!, $declaration_status: String!) {
  update_declaration_request(_set: {edec: $edec, declaration_status: $declaration_status}, where: {file_id: {_eq: $fileId}}) {
    affected_rows
  }
}
    `;
export type Adit_Update_Declaration_Request_EdecMutationFn = Apollo.MutationFunction<Adit_Update_Declaration_Request_EdecMutation, Adit_Update_Declaration_Request_EdecMutationVariables>;

/**
 * __useAdit_Update_Declaration_Request_EdecMutation__
 *
 * To run a mutation, you first call `useAdit_Update_Declaration_Request_EdecMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Update_Declaration_Request_EdecMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdateDeclarationRequestEdecMutation, { data, loading, error }] = useAdit_Update_Declaration_Request_EdecMutation({
 *   variables: {
 *      edec: // value for 'edec'
 *      fileId: // value for 'fileId'
 *      declaration_status: // value for 'declaration_status'
 *   },
 * });
 */
export function useAdit_Update_Declaration_Request_EdecMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Update_Declaration_Request_EdecMutation, Adit_Update_Declaration_Request_EdecMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Update_Declaration_Request_EdecMutation, Adit_Update_Declaration_Request_EdecMutationVariables>(Adit_Update_Declaration_Request_EdecDocument, options);
      }
export type Adit_Update_Declaration_Request_EdecMutationHookResult = ReturnType<typeof useAdit_Update_Declaration_Request_EdecMutation>;
export type Adit_Update_Declaration_Request_EdecMutationResult = Apollo.MutationResult<Adit_Update_Declaration_Request_EdecMutation>;
export type Adit_Update_Declaration_Request_EdecMutationOptions = Apollo.BaseMutationOptions<Adit_Update_Declaration_Request_EdecMutation, Adit_Update_Declaration_Request_EdecMutationVariables>;
export const Delete_Org_IdDocument = gql`
    query DELETE_ORG_ID($org_id: smallint!) {
  pp_org_id_delete(args: {_org_id: $org_id, _force: false}) {
    json_value
  }
}
    `;

/**
 * __useDelete_Org_IdQuery__
 *
 * To run a query within a React component, call `useDelete_Org_IdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDelete_Org_IdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDelete_Org_IdQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useDelete_Org_IdQuery(baseOptions: Apollo.QueryHookOptions<Delete_Org_IdQuery, Delete_Org_IdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Delete_Org_IdQuery, Delete_Org_IdQueryVariables>(Delete_Org_IdDocument, options);
      }
export function useDelete_Org_IdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Delete_Org_IdQuery, Delete_Org_IdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Delete_Org_IdQuery, Delete_Org_IdQueryVariables>(Delete_Org_IdDocument, options);
        }
export type Delete_Org_IdQueryHookResult = ReturnType<typeof useDelete_Org_IdQuery>;
export type Delete_Org_IdLazyQueryHookResult = ReturnType<typeof useDelete_Org_IdLazyQuery>;
export type Delete_Org_IdQueryResult = Apollo.QueryResult<Delete_Org_IdQuery, Delete_Org_IdQueryVariables>;
export const AditExportDeclarationDocument = gql`
    mutation AditExportDeclaration($fileId: String!, $drNo: Float!) {
  exportDeclaration(exportDeclarationInput: {fileId: $fileId, drNo: $drNo})
}
    `;
export type AditExportDeclarationMutationFn = Apollo.MutationFunction<AditExportDeclarationMutation, AditExportDeclarationMutationVariables>;

/**
 * __useAditExportDeclarationMutation__
 *
 * To run a mutation, you first call `useAditExportDeclarationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditExportDeclarationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditExportDeclarationMutation, { data, loading, error }] = useAditExportDeclarationMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      drNo: // value for 'drNo'
 *   },
 * });
 */
export function useAditExportDeclarationMutation(baseOptions?: Apollo.MutationHookOptions<AditExportDeclarationMutation, AditExportDeclarationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditExportDeclarationMutation, AditExportDeclarationMutationVariables>(AditExportDeclarationDocument, options);
      }
export type AditExportDeclarationMutationHookResult = ReturnType<typeof useAditExportDeclarationMutation>;
export type AditExportDeclarationMutationResult = Apollo.MutationResult<AditExportDeclarationMutation>;
export type AditExportDeclarationMutationOptions = Apollo.BaseMutationOptions<AditExportDeclarationMutation, AditExportDeclarationMutationVariables>;
export const Adit_Get_Pp_AddressDocument = gql`
    query ADIT_GET_PP_ADDRESS($search: String, $offset: Int, $limit: Int, $address_types: _int4) {
  pp_addresses(args: {_search: $search, _offset: $offset, _limit: $limit, _address_types: $address_types}) {
    company_name
    address_type
    city
    contact_email
    contact_phone
    contact_website
    country
    id
    street
    street_number
    zipcode
    reference
    creation_date
    creation_user
    last_modified_date
    last_modified_user
    qty
  }
}
    `;

/**
 * __useAdit_Get_Pp_AddressQuery__
 *
 * To run a query within a React component, call `useAdit_Get_Pp_AddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Pp_AddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Pp_AddressQuery({
 *   variables: {
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      address_types: // value for 'address_types'
 *   },
 * });
 */
export function useAdit_Get_Pp_AddressQuery(baseOptions?: Apollo.QueryHookOptions<Adit_Get_Pp_AddressQuery, Adit_Get_Pp_AddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Pp_AddressQuery, Adit_Get_Pp_AddressQueryVariables>(Adit_Get_Pp_AddressDocument, options);
      }
export function useAdit_Get_Pp_AddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Pp_AddressQuery, Adit_Get_Pp_AddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Pp_AddressQuery, Adit_Get_Pp_AddressQueryVariables>(Adit_Get_Pp_AddressDocument, options);
        }
export type Adit_Get_Pp_AddressQueryHookResult = ReturnType<typeof useAdit_Get_Pp_AddressQuery>;
export type Adit_Get_Pp_AddressLazyQueryHookResult = ReturnType<typeof useAdit_Get_Pp_AddressLazyQuery>;
export type Adit_Get_Pp_AddressQueryResult = Apollo.QueryResult<Adit_Get_Pp_AddressQuery, Adit_Get_Pp_AddressQueryVariables>;
export const Get_Address_TypeDocument = gql`
    query GET_ADDRESS_TYPE {
  address_type {
    id
    name
    translation
  }
}
    `;

/**
 * __useGet_Address_TypeQuery__
 *
 * To run a query within a React component, call `useGet_Address_TypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Address_TypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Address_TypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGet_Address_TypeQuery(baseOptions?: Apollo.QueryHookOptions<Get_Address_TypeQuery, Get_Address_TypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Address_TypeQuery, Get_Address_TypeQueryVariables>(Get_Address_TypeDocument, options);
      }
export function useGet_Address_TypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Address_TypeQuery, Get_Address_TypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Address_TypeQuery, Get_Address_TypeQueryVariables>(Get_Address_TypeDocument, options);
        }
export type Get_Address_TypeQueryHookResult = ReturnType<typeof useGet_Address_TypeQuery>;
export type Get_Address_TypeLazyQueryHookResult = ReturnType<typeof useGet_Address_TypeLazyQuery>;
export type Get_Address_TypeQueryResult = Apollo.QueryResult<Get_Address_TypeQuery, Get_Address_TypeQueryVariables>;
export const GetAiStatsDocument = gql`
    query getAiStats($started: timestamptz, $ended: timestamptz, $onlyAiDoctypes: Boolean, $userIds: _uuid, $orgIds: _int2) {
  pp_ai_stats(args: {_started: $started, _ended: $ended, _only_ai_doctypes: $onlyAiDoctypes, _orgids: $orgIds, _crusers: $userIds}, where: {_not: {document_type: {_eq: "TOTAL"}}}) {
    document_type
    success_ratio
    total
    types_match
    unknowns
    unknowns_pct
  }
}
    `;

/**
 * __useGetAiStatsQuery__
 *
 * To run a query within a React component, call `useGetAiStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiStatsQuery({
 *   variables: {
 *      started: // value for 'started'
 *      ended: // value for 'ended'
 *      onlyAiDoctypes: // value for 'onlyAiDoctypes'
 *      userIds: // value for 'userIds'
 *      orgIds: // value for 'orgIds'
 *   },
 * });
 */
export function useGetAiStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAiStatsQuery, GetAiStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiStatsQuery, GetAiStatsQueryVariables>(GetAiStatsDocument, options);
      }
export function useGetAiStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiStatsQuery, GetAiStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiStatsQuery, GetAiStatsQueryVariables>(GetAiStatsDocument, options);
        }
export type GetAiStatsQueryHookResult = ReturnType<typeof useGetAiStatsQuery>;
export type GetAiStatsLazyQueryHookResult = ReturnType<typeof useGetAiStatsLazyQuery>;
export type GetAiStatsQueryResult = Apollo.QueryResult<GetAiStatsQuery, GetAiStatsQueryVariables>;
export const GetAiStatsByDayDocument = gql`
    query getAiStatsByDay($started: timestamptz, $ended: timestamptz, $onlyAiDoctypes: Boolean, $userIds: _uuid, $orgIds: _int2) {
  pp_ai_stats_dt(args: {_started: $started, _ended: $ended, _only_ai_doctypes: $onlyAiDoctypes, _orgids: $orgIds, _crusers: $userIds}) {
    creation_date
    docs_qty
    document_type
    pages_qty
    success_ratio
    types_match
    unknowns
    unknowns_pct
  }
}
    `;

/**
 * __useGetAiStatsByDayQuery__
 *
 * To run a query within a React component, call `useGetAiStatsByDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiStatsByDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiStatsByDayQuery({
 *   variables: {
 *      started: // value for 'started'
 *      ended: // value for 'ended'
 *      onlyAiDoctypes: // value for 'onlyAiDoctypes'
 *      userIds: // value for 'userIds'
 *      orgIds: // value for 'orgIds'
 *   },
 * });
 */
export function useGetAiStatsByDayQuery(baseOptions?: Apollo.QueryHookOptions<GetAiStatsByDayQuery, GetAiStatsByDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiStatsByDayQuery, GetAiStatsByDayQueryVariables>(GetAiStatsByDayDocument, options);
      }
export function useGetAiStatsByDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiStatsByDayQuery, GetAiStatsByDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiStatsByDayQuery, GetAiStatsByDayQueryVariables>(GetAiStatsByDayDocument, options);
        }
export type GetAiStatsByDayQueryHookResult = ReturnType<typeof useGetAiStatsByDayQuery>;
export type GetAiStatsByDayLazyQueryHookResult = ReturnType<typeof useGetAiStatsByDayLazyQuery>;
export type GetAiStatsByDayQueryResult = Apollo.QueryResult<GetAiStatsByDayQuery, GetAiStatsByDayQueryVariables>;
export const Get_Api_KeysDocument = gql`
    query GET_API_KEYS {
  accessTokens: api_key(order_by: {dsplay_name: asc}) {
    id
    api_key
    meta
    display_name: dsplay_name
  }
}
    `;

/**
 * __useGet_Api_KeysQuery__
 *
 * To run a query within a React component, call `useGet_Api_KeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Api_KeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Api_KeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGet_Api_KeysQuery(baseOptions?: Apollo.QueryHookOptions<Get_Api_KeysQuery, Get_Api_KeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Api_KeysQuery, Get_Api_KeysQueryVariables>(Get_Api_KeysDocument, options);
      }
export function useGet_Api_KeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Api_KeysQuery, Get_Api_KeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Api_KeysQuery, Get_Api_KeysQueryVariables>(Get_Api_KeysDocument, options);
        }
export type Get_Api_KeysQueryHookResult = ReturnType<typeof useGet_Api_KeysQuery>;
export type Get_Api_KeysLazyQueryHookResult = ReturnType<typeof useGet_Api_KeysLazyQuery>;
export type Get_Api_KeysQueryResult = Apollo.QueryResult<Get_Api_KeysQuery, Get_Api_KeysQueryVariables>;
export const GetDeclarationWithDocumentsDocument = gql`
    query getDeclarationWithDocuments($declarationId: _uuid) {
  declaration_request: pp_declaration_request(args: {_file_ids: $declarationId}) {
    file {
      id
      identification
      documents(where: {pages_m2m: {page: {page_status: {_neq: "classified"}}}, document_status: {_neq: "classified"}, is_deleted: {_eq: false}}) {
        id
        name: document_name
        meta
        document_status
        document_type
        pages: pages_m2m(order_by: {page_number: asc}, where: {page: {page_status: {_neq: "classified"}}}) {
          page {
            id
            thumbnailBigUrl: thumbnail_big_url
            page_status
            rotate
            meta
            creation_user
          }
          page_number
        }
        document_blobs
        document_flags
      }
    }
    declaration_discussions {
      discussion_id
      creation_user
    }
    payer {
      id
      tenantName: tenant_name
    }
    toll_dep
    eta
    declaration_request_addresses {
      address_id
      refs
      address_type
      address {
        id
        company_name
        company_name_2
        country
        street
        city
        zipcode
        reference
        street_number
        customs_account_number
        is_locked
        uid_number
        usage_frequency
        vat_account_number
        trader_identification_number
        is_platform_user
      }
    }
    declaration {
      total_gross_weight
      total_colis
      customs_office_number
    }
  }
}
    `;

/**
 * __useGetDeclarationWithDocumentsQuery__
 *
 * To run a query within a React component, call `useGetDeclarationWithDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeclarationWithDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeclarationWithDocumentsQuery({
 *   variables: {
 *      declarationId: // value for 'declarationId'
 *   },
 * });
 */
export function useGetDeclarationWithDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetDeclarationWithDocumentsQuery, GetDeclarationWithDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeclarationWithDocumentsQuery, GetDeclarationWithDocumentsQueryVariables>(GetDeclarationWithDocumentsDocument, options);
      }
export function useGetDeclarationWithDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeclarationWithDocumentsQuery, GetDeclarationWithDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeclarationWithDocumentsQuery, GetDeclarationWithDocumentsQueryVariables>(GetDeclarationWithDocumentsDocument, options);
        }
export type GetDeclarationWithDocumentsQueryHookResult = ReturnType<typeof useGetDeclarationWithDocumentsQuery>;
export type GetDeclarationWithDocumentsLazyQueryHookResult = ReturnType<typeof useGetDeclarationWithDocumentsLazyQuery>;
export type GetDeclarationWithDocumentsQueryResult = Apollo.QueryResult<GetDeclarationWithDocumentsQuery, GetDeclarationWithDocumentsQueryVariables>;
export const Adit_Get_Declaration_Tasks_V2Document = gql`
    query ADIT_GET_DECLARATION_TASKS_V2($assigned_to: uuid, $min_due_date: timestamptz, $max_due_date: timestamptz, $task_type_id: Int, $creation_date: timestamptz, $search: String, $limit: Int = 6, $offset: Int = 0, $task_status_id: Int = 0, $orderby: String) {
  declaration_task: pp_declaration_tasks(args: {_assigned_to: $assigned_to, _min_due_date: $min_due_date, _max_due_date: $max_due_date, _task_type_id: $task_type_id, _creation_date: $creation_date, _search: $search, _task_status_id: $task_status_id, _limit: $limit, _offset: $offset, _orderby: $orderby}) {
    id
    title
    assigned_to
    assigned_user {
      id
      display_name
      __typename
    }
    creation_date
    task_type_id
    due_date
    meta
    object_id
    task_status_id
    task_type {
      display_name
      __typename
    }
    document {
      document_flags
      documentFile {
        id
        identification
        __typename
      }
      documentType {
        translations
        __typename
      }
      __typename
    }
    file {
      id
      identification
      __typename
    }
    rn
    qty
  }
}
    `;

/**
 * __useAdit_Get_Declaration_Tasks_V2Query__
 *
 * To run a query within a React component, call `useAdit_Get_Declaration_Tasks_V2Query` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Declaration_Tasks_V2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Declaration_Tasks_V2Query({
 *   variables: {
 *      assigned_to: // value for 'assigned_to'
 *      min_due_date: // value for 'min_due_date'
 *      max_due_date: // value for 'max_due_date'
 *      task_type_id: // value for 'task_type_id'
 *      creation_date: // value for 'creation_date'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      task_status_id: // value for 'task_status_id'
 *      orderby: // value for 'orderby'
 *   },
 * });
 */
export function useAdit_Get_Declaration_Tasks_V2Query(baseOptions?: Apollo.QueryHookOptions<Adit_Get_Declaration_Tasks_V2Query, Adit_Get_Declaration_Tasks_V2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Declaration_Tasks_V2Query, Adit_Get_Declaration_Tasks_V2QueryVariables>(Adit_Get_Declaration_Tasks_V2Document, options);
      }
export function useAdit_Get_Declaration_Tasks_V2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Declaration_Tasks_V2Query, Adit_Get_Declaration_Tasks_V2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Declaration_Tasks_V2Query, Adit_Get_Declaration_Tasks_V2QueryVariables>(Adit_Get_Declaration_Tasks_V2Document, options);
        }
export type Adit_Get_Declaration_Tasks_V2QueryHookResult = ReturnType<typeof useAdit_Get_Declaration_Tasks_V2Query>;
export type Adit_Get_Declaration_Tasks_V2LazyQueryHookResult = ReturnType<typeof useAdit_Get_Declaration_Tasks_V2LazyQuery>;
export type Adit_Get_Declaration_Tasks_V2QueryResult = Apollo.QueryResult<Adit_Get_Declaration_Tasks_V2Query, Adit_Get_Declaration_Tasks_V2QueryVariables>;
export const GetDocumentPagesDocument = gql`
    query getDocumentPages($documentId: uuid!) {
  document(where: {id: {_eq: $documentId}}) {
    pages: pages_m2m(where: {page: {page_status: {_neq: "classified"}}}) {
      page {
        id
        rotate
        thumbnailBigUrl: thumbnail_big_url
        thumbnailSmallUrl: thumbnail_small_url
        meta
      }
      page_number
    }
  }
}
    `;

/**
 * __useGetDocumentPagesQuery__
 *
 * To run a query within a React component, call `useGetDocumentPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentPagesQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentPagesQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentPagesQuery, GetDocumentPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentPagesQuery, GetDocumentPagesQueryVariables>(GetDocumentPagesDocument, options);
      }
export function useGetDocumentPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentPagesQuery, GetDocumentPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentPagesQuery, GetDocumentPagesQueryVariables>(GetDocumentPagesDocument, options);
        }
export type GetDocumentPagesQueryHookResult = ReturnType<typeof useGetDocumentPagesQuery>;
export type GetDocumentPagesLazyQueryHookResult = ReturnType<typeof useGetDocumentPagesLazyQuery>;
export type GetDocumentPagesQueryResult = Apollo.QueryResult<GetDocumentPagesQuery, GetDocumentPagesQueryVariables>;
export const GetDocumentStatsDocument = gql`
    query getDocumentStats($started: timestamptz, $ended: timestamptz, $userIds: _uuid, $orgIds: _int2, $tenant: uuid) {
  pp_doc_stats(args: {_started: $started, _ended: $ended, _orgids: $orgIds, _crusers: $userIds, _tenant: $tenant}) {
    docs_qty
    document_type
    total_pages
    users_qty
  }
}
    `;

/**
 * __useGetDocumentStatsQuery__
 *
 * To run a query within a React component, call `useGetDocumentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentStatsQuery({
 *   variables: {
 *      started: // value for 'started'
 *      ended: // value for 'ended'
 *      userIds: // value for 'userIds'
 *      orgIds: // value for 'orgIds'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useGetDocumentStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentStatsQuery, GetDocumentStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentStatsQuery, GetDocumentStatsQueryVariables>(GetDocumentStatsDocument, options);
      }
export function useGetDocumentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentStatsQuery, GetDocumentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentStatsQuery, GetDocumentStatsQueryVariables>(GetDocumentStatsDocument, options);
        }
export type GetDocumentStatsQueryHookResult = ReturnType<typeof useGetDocumentStatsQuery>;
export type GetDocumentStatsLazyQueryHookResult = ReturnType<typeof useGetDocumentStatsLazyQuery>;
export type GetDocumentStatsQueryResult = Apollo.QueryResult<GetDocumentStatsQuery, GetDocumentStatsQueryVariables>;
export const GetDocumentsDocument = gql`
    query getDocuments($ids: _uuid) {
  documents: pp_document(args: {_ids: $ids}, limit: 1024) {
    id
    name: document_name
    meta
    pages: pages_m2m(order_by: {page_number: asc}) {
      page {
        id
        thumbnailBigUrl: thumbnail_big_url
        page_status
        rotate
        meta
        creation_user
      }
      page_number
    }
    document_blobs
    document_flags
  }
}
    `;

/**
 * __useGetDocumentsQuery__
 *
 * To run a query within a React component, call `useGetDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
      }
export function useGetDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
        }
export type GetDocumentsQueryHookResult = ReturnType<typeof useGetDocumentsQuery>;
export type GetDocumentsLazyQueryHookResult = ReturnType<typeof useGetDocumentsLazyQuery>;
export type GetDocumentsQueryResult = Apollo.QueryResult<GetDocumentsQuery, GetDocumentsQueryVariables>;
export const GetFilesPagesDocument = gql`
    query getFilesPages($fileNumber: uuid!) {
  files: vw_finished_files(where: {id: {_eq: $fileNumber}}) {
    documents(limit: 30, order_by: {creation_date: desc}, where: {_and: {document_type: {_neq: "customs_overview"}, document_status: {_neq: "classified"}, is_deleted: {_eq: false}}}) {
      id
      document_type
      document_status
      document_name
      document_flags
      last_modified_date
      sequence
      meta
      created_by_user {
        display_name
      }
      document_blobs(path: "blobs")
      documentType {
        translations
      }
      pages: pages_m2m(order_by: {page_number: asc}) {
        page {
          id
          rotate
          thumbnailBigUrl: thumbnail_big_url
          thumbnailSmallUrl: thumbnail_small_url
          page_status
          meta
        }
        page_number
      }
    }
  }
}
    `;

/**
 * __useGetFilesPagesQuery__
 *
 * To run a query within a React component, call `useGetFilesPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesPagesQuery({
 *   variables: {
 *      fileNumber: // value for 'fileNumber'
 *   },
 * });
 */
export function useGetFilesPagesQuery(baseOptions: Apollo.QueryHookOptions<GetFilesPagesQuery, GetFilesPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesPagesQuery, GetFilesPagesQueryVariables>(GetFilesPagesDocument, options);
      }
export function useGetFilesPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesPagesQuery, GetFilesPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesPagesQuery, GetFilesPagesQueryVariables>(GetFilesPagesDocument, options);
        }
export type GetFilesPagesQueryHookResult = ReturnType<typeof useGetFilesPagesQuery>;
export type GetFilesPagesLazyQueryHookResult = ReturnType<typeof useGetFilesPagesLazyQuery>;
export type GetFilesPagesQueryResult = Apollo.QueryResult<GetFilesPagesQuery, GetFilesPagesQueryVariables>;
export const GetFileStatsDocument = gql`
    query getFileStats($started: timestamptz, $ended: timestamptz, $userIds: _uuid, $orgIds: _int2) {
  pp_file_stats(args: {_started: $started, _ended: $ended, _orgids: $orgIds, _crusers: $userIds}) {
    file_flags
    file_flags_id
    qty
    users_qty
  }
}
    `;

/**
 * __useGetFileStatsQuery__
 *
 * To run a query within a React component, call `useGetFileStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileStatsQuery({
 *   variables: {
 *      started: // value for 'started'
 *      ended: // value for 'ended'
 *      userIds: // value for 'userIds'
 *      orgIds: // value for 'orgIds'
 *   },
 * });
 */
export function useGetFileStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetFileStatsQuery, GetFileStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileStatsQuery, GetFileStatsQueryVariables>(GetFileStatsDocument, options);
      }
export function useGetFileStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileStatsQuery, GetFileStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileStatsQuery, GetFileStatsQueryVariables>(GetFileStatsDocument, options);
        }
export type GetFileStatsQueryHookResult = ReturnType<typeof useGetFileStatsQuery>;
export type GetFileStatsLazyQueryHookResult = ReturnType<typeof useGetFileStatsLazyQuery>;
export type GetFileStatsQueryResult = Apollo.QueryResult<GetFileStatsQuery, GetFileStatsQueryVariables>;
export const GetFilesDocument = gql`
    query getFiles($fileNumber: String) {
  files: vw_finished_files(order_by: {last_modified_date: desc, id: asc}, where: {_and: {identification: {_eq: $fileNumber}, file_status: {_in: ["transmission_pending", "transmission_generated", "transmission_failed", "archived_pending", "archived_failed", "archived", "ready_for_archive", "pending"]}}}) {
    id
    identification
    name
    type: file_flags
    declarations {
      file_id
      dr_no
    }
    documents(order_by: {creation_date: desc}, where: {document_type: {_neq: "customs_overview"}, is_deleted: {_eq: false}}) {
      id
      document_type
      documentType {
        translations
        document_type_tenant_settings {
          meta
        }
      }
      document_flags
      document_blobs
      document_name
      sequence
      pages: pages_m2m {
        page {
          id
          rotate
          thumbnailBigUrl: thumbnail_big_url
          meta
        }
        page_number
      }
    }
  }
}
    `;

/**
 * __useGetFilesQuery__
 *
 * To run a query within a React component, call `useGetFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesQuery({
 *   variables: {
 *      fileNumber: // value for 'fileNumber'
 *   },
 * });
 */
export function useGetFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetFilesQuery, GetFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
      }
export function useGetFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesQuery, GetFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
        }
export type GetFilesQueryHookResult = ReturnType<typeof useGetFilesQuery>;
export type GetFilesLazyQueryHookResult = ReturnType<typeof useGetFilesLazyQuery>;
export type GetFilesQueryResult = Apollo.QueryResult<GetFilesQuery, GetFilesQueryVariables>;
export const GetFilesForSubscriptionForAnnotationDocument = gql`
    query getFilesForSubscriptionForAnnotation($offset: Int, $limit: Int, $currUserId: uuid, $orderBy: String, $fileFlags: _int8, $minDate: timestamptz, $maxDate: timestamptz, $search: String, $orgIds: _int2, $myFilesOnly: Boolean, $fileStatuses: _text) {
  files: pp_file_search(args: {_limit: $limit, _offset: $offset, _orderby: $orderBy, _file_flags: $fileFlags, _max_date: $maxDate, _min_date: $minDate, _searchval: $search, _curr_userid: $currUserId, _org_ids: $orgIds, _my_files_only: $myFilesOnly, _file_statuses: $fileStatuses}) {
    id
    identification
    name
    org_id
    org_id_description
    meta
    type: file_flags
    status: file_status
    userId: creation_user
    creationDate: creation_date
    lastUpdate: last_modified_date
    fileUrl: file_url
    total_rows
    customs_relevant
    extraction_required
  }
}
    `;

/**
 * __useGetFilesForSubscriptionForAnnotationQuery__
 *
 * To run a query within a React component, call `useGetFilesForSubscriptionForAnnotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesForSubscriptionForAnnotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesForSubscriptionForAnnotationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      currUserId: // value for 'currUserId'
 *      orderBy: // value for 'orderBy'
 *      fileFlags: // value for 'fileFlags'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      search: // value for 'search'
 *      orgIds: // value for 'orgIds'
 *      myFilesOnly: // value for 'myFilesOnly'
 *      fileStatuses: // value for 'fileStatuses'
 *   },
 * });
 */
export function useGetFilesForSubscriptionForAnnotationQuery(baseOptions?: Apollo.QueryHookOptions<GetFilesForSubscriptionForAnnotationQuery, GetFilesForSubscriptionForAnnotationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesForSubscriptionForAnnotationQuery, GetFilesForSubscriptionForAnnotationQueryVariables>(GetFilesForSubscriptionForAnnotationDocument, options);
      }
export function useGetFilesForSubscriptionForAnnotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesForSubscriptionForAnnotationQuery, GetFilesForSubscriptionForAnnotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesForSubscriptionForAnnotationQuery, GetFilesForSubscriptionForAnnotationQueryVariables>(GetFilesForSubscriptionForAnnotationDocument, options);
        }
export type GetFilesForSubscriptionForAnnotationQueryHookResult = ReturnType<typeof useGetFilesForSubscriptionForAnnotationQuery>;
export type GetFilesForSubscriptionForAnnotationLazyQueryHookResult = ReturnType<typeof useGetFilesForSubscriptionForAnnotationLazyQuery>;
export type GetFilesForSubscriptionForAnnotationQueryResult = Apollo.QueryResult<GetFilesForSubscriptionForAnnotationQuery, GetFilesForSubscriptionForAnnotationQueryVariables>;
export const GetFileUpdatesSubscriptionForAnnotationDocument = gql`
    subscription getFileUpdatesSubscriptionForAnnotation {
  pp_file_max_date_hs {
    max_change_date
  }
}
    `;

/**
 * __useGetFileUpdatesSubscriptionForAnnotationSubscription__
 *
 * To run a query within a React component, call `useGetFileUpdatesSubscriptionForAnnotationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetFileUpdatesSubscriptionForAnnotationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileUpdatesSubscriptionForAnnotationSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetFileUpdatesSubscriptionForAnnotationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetFileUpdatesSubscriptionForAnnotationSubscription, GetFileUpdatesSubscriptionForAnnotationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetFileUpdatesSubscriptionForAnnotationSubscription, GetFileUpdatesSubscriptionForAnnotationSubscriptionVariables>(GetFileUpdatesSubscriptionForAnnotationDocument, options);
      }
export type GetFileUpdatesSubscriptionForAnnotationSubscriptionHookResult = ReturnType<typeof useGetFileUpdatesSubscriptionForAnnotationSubscription>;
export type GetFileUpdatesSubscriptionForAnnotationSubscriptionResult = Apollo.SubscriptionResult<GetFileUpdatesSubscriptionForAnnotationSubscription>;
export const Get_Full_File_HistoryDocument = gql`
    query GET_FULL_FILE_HISTORY($fileId: uuid, $documentIds: _uuid) {
  file_history: pp_view_file_history(args: {_file_id: $fileId}, where: {action_title: {_nin: ["other", "file_transmission_generated", "document_added", "transmission_failed"]}}) {
    action_title
    action_value
    entityId: id
    op_date
    action_user
  }
  document_history: pp_view_document_history(args: {_ids: $documentIds}, where: {action_title: {_nin: ["other", "document_flags_changed", "document_thumbnails_generated", "document_thumbnails_generated_frontend", "document_thumbnails_pending", "document_classified"]}}) {
    action_title
    action_value
    entityId: id
    op_date
    action_user
    document {
      sequence
      documentType {
        translations
      }
    }
  }
}
    `;

/**
 * __useGet_Full_File_HistoryQuery__
 *
 * To run a query within a React component, call `useGet_Full_File_HistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Full_File_HistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Full_File_HistoryQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useGet_Full_File_HistoryQuery(baseOptions?: Apollo.QueryHookOptions<Get_Full_File_HistoryQuery, Get_Full_File_HistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Full_File_HistoryQuery, Get_Full_File_HistoryQueryVariables>(Get_Full_File_HistoryDocument, options);
      }
export function useGet_Full_File_HistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Full_File_HistoryQuery, Get_Full_File_HistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Full_File_HistoryQuery, Get_Full_File_HistoryQueryVariables>(Get_Full_File_HistoryDocument, options);
        }
export type Get_Full_File_HistoryQueryHookResult = ReturnType<typeof useGet_Full_File_HistoryQuery>;
export type Get_Full_File_HistoryLazyQueryHookResult = ReturnType<typeof useGet_Full_File_HistoryLazyQuery>;
export type Get_Full_File_HistoryQueryResult = Apollo.QueryResult<Get_Full_File_HistoryQuery, Get_Full_File_HistoryQueryVariables>;
export const Adit_Get_Import_List_TriggersDocument = gql`
    query ADIT_GET_IMPORT_LIST_TRIGGERS($limit: Int, $offset: Int) {
  import_list_trigger: import_list_trigger(limit: $limit, offset: $offset, order_by: {creation_date: desc_nulls_first}) {
    id
    display_name
    type
    config
    creation_date
    creation_user
    last_modified_date
    last_modified_user
    creationUser {
      display_name
    }
    lastModifiedUser {
      display_name
    }
    meta
  }
  import_list_trigger_aggregate {
    aggregate {
      totalCount: count
    }
  }
}
    `;

/**
 * __useAdit_Get_Import_List_TriggersQuery__
 *
 * To run a query within a React component, call `useAdit_Get_Import_List_TriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Import_List_TriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Import_List_TriggersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAdit_Get_Import_List_TriggersQuery(baseOptions?: Apollo.QueryHookOptions<Adit_Get_Import_List_TriggersQuery, Adit_Get_Import_List_TriggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Import_List_TriggersQuery, Adit_Get_Import_List_TriggersQueryVariables>(Adit_Get_Import_List_TriggersDocument, options);
      }
export function useAdit_Get_Import_List_TriggersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Import_List_TriggersQuery, Adit_Get_Import_List_TriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Import_List_TriggersQuery, Adit_Get_Import_List_TriggersQueryVariables>(Adit_Get_Import_List_TriggersDocument, options);
        }
export type Adit_Get_Import_List_TriggersQueryHookResult = ReturnType<typeof useAdit_Get_Import_List_TriggersQuery>;
export type Adit_Get_Import_List_TriggersLazyQueryHookResult = ReturnType<typeof useAdit_Get_Import_List_TriggersLazyQuery>;
export type Adit_Get_Import_List_TriggersQueryResult = Apollo.QueryResult<Adit_Get_Import_List_TriggersQuery, Adit_Get_Import_List_TriggersQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications {
  notifications(count: 10)
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const Get_Org_IdsDocument = gql`
    query GET_ORG_IDS($limit: Int, $offset: Int, $search: String, $id: smallint) {
  org_ids: pp_org_ids(args: {_limit: $limit, _offset: $offset, _search: $search, _id: $id}) {
    org_id
    display_name
    org_id_description
    qty
    org_params
    addresses_desc
    org_ids_desc
  }
}
    `;

/**
 * __useGet_Org_IdsQuery__
 *
 * To run a query within a React component, call `useGet_Org_IdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Org_IdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Org_IdsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGet_Org_IdsQuery(baseOptions?: Apollo.QueryHookOptions<Get_Org_IdsQuery, Get_Org_IdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Org_IdsQuery, Get_Org_IdsQueryVariables>(Get_Org_IdsDocument, options);
      }
export function useGet_Org_IdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Org_IdsQuery, Get_Org_IdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Org_IdsQuery, Get_Org_IdsQueryVariables>(Get_Org_IdsDocument, options);
        }
export type Get_Org_IdsQueryHookResult = ReturnType<typeof useGet_Org_IdsQuery>;
export type Get_Org_IdsLazyQueryHookResult = ReturnType<typeof useGet_Org_IdsLazyQuery>;
export type Get_Org_IdsQueryResult = Apollo.QueryResult<Get_Org_IdsQuery, Get_Org_IdsQueryVariables>;
export const Get_Setting_ValueDocument = gql`
    query GET_SETTING_VALUE($setting_id: uuid, $reference_type_id: String, $reference_id: String) {
  setting_value(where: {setting_id: {_eq: $setting_id}, reference_type_id: {_eq: $reference_type_id}, reference_id: {_eq: $reference_id}}, order_by: {display_name: asc}) {
    id
    display_name
    value
    setting_id
    is_template
  }
}
    `;

/**
 * __useGet_Setting_ValueQuery__
 *
 * To run a query within a React component, call `useGet_Setting_ValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Setting_ValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Setting_ValueQuery({
 *   variables: {
 *      setting_id: // value for 'setting_id'
 *      reference_type_id: // value for 'reference_type_id'
 *      reference_id: // value for 'reference_id'
 *   },
 * });
 */
export function useGet_Setting_ValueQuery(baseOptions?: Apollo.QueryHookOptions<Get_Setting_ValueQuery, Get_Setting_ValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Setting_ValueQuery, Get_Setting_ValueQueryVariables>(Get_Setting_ValueDocument, options);
      }
export function useGet_Setting_ValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Setting_ValueQuery, Get_Setting_ValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Setting_ValueQuery, Get_Setting_ValueQueryVariables>(Get_Setting_ValueDocument, options);
        }
export type Get_Setting_ValueQueryHookResult = ReturnType<typeof useGet_Setting_ValueQuery>;
export type Get_Setting_ValueLazyQueryHookResult = ReturnType<typeof useGet_Setting_ValueLazyQuery>;
export type Get_Setting_ValueQueryResult = Apollo.QueryResult<Get_Setting_ValueQuery, Get_Setting_ValueQueryVariables>;
export const Get_Tenant_SettingDocument = gql`
    query GET_TENANT_SETTING($tenantId: ID!) {
  getTenantConfig(tenantId: $tenantId)
}
    `;

/**
 * __useGet_Tenant_SettingQuery__
 *
 * To run a query within a React component, call `useGet_Tenant_SettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Tenant_SettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Tenant_SettingQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGet_Tenant_SettingQuery(baseOptions: Apollo.QueryHookOptions<Get_Tenant_SettingQuery, Get_Tenant_SettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Tenant_SettingQuery, Get_Tenant_SettingQueryVariables>(Get_Tenant_SettingDocument, options);
      }
export function useGet_Tenant_SettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Tenant_SettingQuery, Get_Tenant_SettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Tenant_SettingQuery, Get_Tenant_SettingQueryVariables>(Get_Tenant_SettingDocument, options);
        }
export type Get_Tenant_SettingQueryHookResult = ReturnType<typeof useGet_Tenant_SettingQuery>;
export type Get_Tenant_SettingLazyQueryHookResult = ReturnType<typeof useGet_Tenant_SettingLazyQuery>;
export type Get_Tenant_SettingQueryResult = Apollo.QueryResult<Get_Tenant_SettingQuery, Get_Tenant_SettingQueryVariables>;
export const Get_UsersDocument = gql`
    query GET_USERS($limit: Int = 10, $offset: Int = 0, $tenantId: uuid = "00000000-0000-0000-0000-000000000000", $search: String = "%") {
  user_pp(limit: $limit, offset: $offset, where: {tenant_id: {_eq: $tenantId}, deleted: {_eq: false}, display_name: {_ilike: $search}}) {
    id
    display_name
    location
    email
    tenant_id
  }
}
    `;

/**
 * __useGet_UsersQuery__
 *
 * To run a query within a React component, call `useGet_UsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_UsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_UsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      tenantId: // value for 'tenantId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGet_UsersQuery(baseOptions?: Apollo.QueryHookOptions<Get_UsersQuery, Get_UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_UsersQuery, Get_UsersQueryVariables>(Get_UsersDocument, options);
      }
export function useGet_UsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_UsersQuery, Get_UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_UsersQuery, Get_UsersQueryVariables>(Get_UsersDocument, options);
        }
export type Get_UsersQueryHookResult = ReturnType<typeof useGet_UsersQuery>;
export type Get_UsersLazyQueryHookResult = ReturnType<typeof useGet_UsersLazyQuery>;
export type Get_UsersQueryResult = Apollo.QueryResult<Get_UsersQuery, Get_UsersQueryVariables>;
export const Get_Validation_DocumentsDocument = gql`
    query GET_VALIDATION_DOCUMENTS($id: uuid!, $extract_type_id: smallint, $tenantId: uuid!) {
  document(where: {id: {_eq: $id}}) {
    id
    name: document_name
    meta
    annotationType(where: {annotation_provider_id: {_eq: 5}}) {
      annotation_schema
    }
    pages: pages_m2m(order_by: {page_number: asc}) {
      page {
        id
        thumbnailBigUrl: thumbnail_big_url
        page_status
        rotate
        meta
        creation_user
        pageExtracts: page_extracts(where: {extract_type_id: {_eq: $extract_type_id}}) {
          extract_type_id
          dataPoints: value
        }
      }
    }
    document_blobs
    document_flags
    document_type
    documentType {
      translations
      document_type_tenant_settings(where: {tenant: {_eq: $tenantId}}) {
        documentSchema: document_schema
      }
    }
  }
}
    `;

/**
 * __useGet_Validation_DocumentsQuery__
 *
 * To run a query within a React component, call `useGet_Validation_DocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Validation_DocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Validation_DocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      extract_type_id: // value for 'extract_type_id'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGet_Validation_DocumentsQuery(baseOptions: Apollo.QueryHookOptions<Get_Validation_DocumentsQuery, Get_Validation_DocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Validation_DocumentsQuery, Get_Validation_DocumentsQueryVariables>(Get_Validation_DocumentsDocument, options);
      }
export function useGet_Validation_DocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Validation_DocumentsQuery, Get_Validation_DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Validation_DocumentsQuery, Get_Validation_DocumentsQueryVariables>(Get_Validation_DocumentsDocument, options);
        }
export type Get_Validation_DocumentsQueryHookResult = ReturnType<typeof useGet_Validation_DocumentsQuery>;
export type Get_Validation_DocumentsLazyQueryHookResult = ReturnType<typeof useGet_Validation_DocumentsLazyQuery>;
export type Get_Validation_DocumentsQueryResult = Apollo.QueryResult<Get_Validation_DocumentsQuery, Get_Validation_DocumentsQueryVariables>;
export const Insert_Import_List_TriggerDocument = gql`
    mutation INSERT_IMPORT_LIST_TRIGGER($object: import_list_trigger_insert_input!) {
  insert_import_list_trigger_one(object: $object) {
    id
    type
    config
    creation_user
    creation_date
    last_modified_user
    last_modified_date
    meta
  }
}
    `;
export type Insert_Import_List_TriggerMutationFn = Apollo.MutationFunction<Insert_Import_List_TriggerMutation, Insert_Import_List_TriggerMutationVariables>;

/**
 * __useInsert_Import_List_TriggerMutation__
 *
 * To run a mutation, you first call `useInsert_Import_List_TriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_Import_List_TriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertImportListTriggerMutation, { data, loading, error }] = useInsert_Import_List_TriggerMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsert_Import_List_TriggerMutation(baseOptions?: Apollo.MutationHookOptions<Insert_Import_List_TriggerMutation, Insert_Import_List_TriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_Import_List_TriggerMutation, Insert_Import_List_TriggerMutationVariables>(Insert_Import_List_TriggerDocument, options);
      }
export type Insert_Import_List_TriggerMutationHookResult = ReturnType<typeof useInsert_Import_List_TriggerMutation>;
export type Insert_Import_List_TriggerMutationResult = Apollo.MutationResult<Insert_Import_List_TriggerMutation>;
export type Insert_Import_List_TriggerMutationOptions = Apollo.BaseMutationOptions<Insert_Import_List_TriggerMutation, Insert_Import_List_TriggerMutationVariables>;
export const Insert_Org_IdDocument = gql`
    query INSERT_ORG_ID($org_id: smallint, $display_name: String, $org_params: json, $org_id_description: String) {
  pp_org_id_insert(args: {_org_id: $org_id, _display_name: $display_name, _org_params: $org_params, _desk: $org_id_description}) {
    json_value
  }
}
    `;

/**
 * __useInsert_Org_IdQuery__
 *
 * To run a query within a React component, call `useInsert_Org_IdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsert_Org_IdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsert_Org_IdQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      display_name: // value for 'display_name'
 *      org_params: // value for 'org_params'
 *      org_id_description: // value for 'org_id_description'
 *   },
 * });
 */
export function useInsert_Org_IdQuery(baseOptions?: Apollo.QueryHookOptions<Insert_Org_IdQuery, Insert_Org_IdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Insert_Org_IdQuery, Insert_Org_IdQueryVariables>(Insert_Org_IdDocument, options);
      }
export function useInsert_Org_IdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Insert_Org_IdQuery, Insert_Org_IdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Insert_Org_IdQuery, Insert_Org_IdQueryVariables>(Insert_Org_IdDocument, options);
        }
export type Insert_Org_IdQueryHookResult = ReturnType<typeof useInsert_Org_IdQuery>;
export type Insert_Org_IdLazyQueryHookResult = ReturnType<typeof useInsert_Org_IdLazyQuery>;
export type Insert_Org_IdQueryResult = Apollo.QueryResult<Insert_Org_IdQuery, Insert_Org_IdQueryVariables>;
export const Patch_Update_Tenant_SettingDocument = gql`
    mutation PATCH_UPDATE_TENANT_SETTING($tenantId: ID!, $settings: JSON) {
  patchTenantConfig(tenantId: $tenantId, value: $settings)
}
    `;
export type Patch_Update_Tenant_SettingMutationFn = Apollo.MutationFunction<Patch_Update_Tenant_SettingMutation, Patch_Update_Tenant_SettingMutationVariables>;

/**
 * __usePatch_Update_Tenant_SettingMutation__
 *
 * To run a mutation, you first call `usePatch_Update_Tenant_SettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatch_Update_Tenant_SettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchUpdateTenantSettingMutation, { data, loading, error }] = usePatch_Update_Tenant_SettingMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function usePatch_Update_Tenant_SettingMutation(baseOptions?: Apollo.MutationHookOptions<Patch_Update_Tenant_SettingMutation, Patch_Update_Tenant_SettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Patch_Update_Tenant_SettingMutation, Patch_Update_Tenant_SettingMutationVariables>(Patch_Update_Tenant_SettingDocument, options);
      }
export type Patch_Update_Tenant_SettingMutationHookResult = ReturnType<typeof usePatch_Update_Tenant_SettingMutation>;
export type Patch_Update_Tenant_SettingMutationResult = Apollo.MutationResult<Patch_Update_Tenant_SettingMutation>;
export type Patch_Update_Tenant_SettingMutationOptions = Apollo.BaseMutationOptions<Patch_Update_Tenant_SettingMutation, Patch_Update_Tenant_SettingMutationVariables>;
export const SendDeclarationDocument = gql`
    mutation sendDeclaration($fileId: uuid, $declarationStatus: String) {
  update_declaration_request(where: {file_id: {_eq: $fileId}}, _set: {declaration_status: $declarationStatus}) {
    affected_rows
  }
}
    `;
export type SendDeclarationMutationFn = Apollo.MutationFunction<SendDeclarationMutation, SendDeclarationMutationVariables>;

/**
 * __useSendDeclarationMutation__
 *
 * To run a mutation, you first call `useSendDeclarationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDeclarationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDeclarationMutation, { data, loading, error }] = useSendDeclarationMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      declarationStatus: // value for 'declarationStatus'
 *   },
 * });
 */
export function useSendDeclarationMutation(baseOptions?: Apollo.MutationHookOptions<SendDeclarationMutation, SendDeclarationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDeclarationMutation, SendDeclarationMutationVariables>(SendDeclarationDocument, options);
      }
export type SendDeclarationMutationHookResult = ReturnType<typeof useSendDeclarationMutation>;
export type SendDeclarationMutationResult = Apollo.MutationResult<SendDeclarationMutation>;
export type SendDeclarationMutationOptions = Apollo.BaseMutationOptions<SendDeclarationMutation, SendDeclarationMutationVariables>;
export const Adit_Create_Declaration_MessageDocument = gql`
    mutation ADIT_CREATE_DECLARATION_MESSAGE($discussionId: Int!, $message: String!, $user: ID!, $source: String!) {
  createDeclarationMessage(discussionId: $discussionId, message: $message, user: $user, source: $source, messageType: "message") {
    affected_rows
  }
}
    `;
export type Adit_Create_Declaration_MessageMutationFn = Apollo.MutationFunction<Adit_Create_Declaration_MessageMutation, Adit_Create_Declaration_MessageMutationVariables>;

/**
 * __useAdit_Create_Declaration_MessageMutation__
 *
 * To run a mutation, you first call `useAdit_Create_Declaration_MessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Create_Declaration_MessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditCreateDeclarationMessageMutation, { data, loading, error }] = useAdit_Create_Declaration_MessageMutation({
 *   variables: {
 *      discussionId: // value for 'discussionId'
 *      message: // value for 'message'
 *      user: // value for 'user'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAdit_Create_Declaration_MessageMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Create_Declaration_MessageMutation, Adit_Create_Declaration_MessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Create_Declaration_MessageMutation, Adit_Create_Declaration_MessageMutationVariables>(Adit_Create_Declaration_MessageDocument, options);
      }
export type Adit_Create_Declaration_MessageMutationHookResult = ReturnType<typeof useAdit_Create_Declaration_MessageMutation>;
export type Adit_Create_Declaration_MessageMutationResult = Apollo.MutationResult<Adit_Create_Declaration_MessageMutation>;
export type Adit_Create_Declaration_MessageMutationOptions = Apollo.BaseMutationOptions<Adit_Create_Declaration_MessageMutation, Adit_Create_Declaration_MessageMutationVariables>;
export const Adit_Start_DiscussionDocument = gql`
    mutation ADIT_START_DISCUSSION($fileId: uuid!, $theme: String!, $user: uuid!) {
  insert_declaration_discussion_one(object: {file_id: $fileId, discussion_theme: $theme, creation_user: $user}) {
    discussion_id
    discussion_theme
    file_id
  }
}
    `;
export type Adit_Start_DiscussionMutationFn = Apollo.MutationFunction<Adit_Start_DiscussionMutation, Adit_Start_DiscussionMutationVariables>;

/**
 * __useAdit_Start_DiscussionMutation__
 *
 * To run a mutation, you first call `useAdit_Start_DiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Start_DiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditStartDiscussionMutation, { data, loading, error }] = useAdit_Start_DiscussionMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      theme: // value for 'theme'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useAdit_Start_DiscussionMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Start_DiscussionMutation, Adit_Start_DiscussionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Start_DiscussionMutation, Adit_Start_DiscussionMutationVariables>(Adit_Start_DiscussionDocument, options);
      }
export type Adit_Start_DiscussionMutationHookResult = ReturnType<typeof useAdit_Start_DiscussionMutation>;
export type Adit_Start_DiscussionMutationResult = Apollo.MutationResult<Adit_Start_DiscussionMutation>;
export type Adit_Start_DiscussionMutationOptions = Apollo.BaseMutationOptions<Adit_Start_DiscussionMutation, Adit_Start_DiscussionMutationVariables>;
export const AditSubscribeDeclarationChangesDocument = gql`
    subscription AditSubscribeDeclarationChanges($discussionId: bigint!) {
  declaration_message(where: {discussion_id: {_eq: $discussionId}}, order_by: {msg_date: asc}) {
    creation_user
    message
    msg_date
    read_date
    type
    user {
      tenant_id
      display_name
      first_name
      last_name
      email
      tenant {
        tenant_name
      }
    }
    declaration_discussion {
      discussion_theme
    }
  }
}
    `;

/**
 * __useAditSubscribeDeclarationChangesSubscription__
 *
 * To run a query within a React component, call `useAditSubscribeDeclarationChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAditSubscribeDeclarationChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditSubscribeDeclarationChangesSubscription({
 *   variables: {
 *      discussionId: // value for 'discussionId'
 *   },
 * });
 */
export function useAditSubscribeDeclarationChangesSubscription(baseOptions: Apollo.SubscriptionHookOptions<AditSubscribeDeclarationChangesSubscription, AditSubscribeDeclarationChangesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AditSubscribeDeclarationChangesSubscription, AditSubscribeDeclarationChangesSubscriptionVariables>(AditSubscribeDeclarationChangesDocument, options);
      }
export type AditSubscribeDeclarationChangesSubscriptionHookResult = ReturnType<typeof useAditSubscribeDeclarationChangesSubscription>;
export type AditSubscribeDeclarationChangesSubscriptionResult = Apollo.SubscriptionResult<AditSubscribeDeclarationChangesSubscription>;
export const AditSubscribeDiscussionChangesDocument = gql`
    subscription aditSubscribeDiscussionChanges($user: uuid!, $date: timestamptz!) {
  discussion_changes(where: {adit_user: {_eq: $user}, last_msg_date: {_gt: $date}, last_user: {_neq: $user}}, distinct_on: file_id) {
    file_name
    liber_user
    last_msg_date
    file_id
    discussion_theme
    discussion_id
    adit_user
    reference
  }
}
    `;

/**
 * __useAditSubscribeDiscussionChangesSubscription__
 *
 * To run a query within a React component, call `useAditSubscribeDiscussionChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAditSubscribeDiscussionChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditSubscribeDiscussionChangesSubscription({
 *   variables: {
 *      user: // value for 'user'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAditSubscribeDiscussionChangesSubscription(baseOptions: Apollo.SubscriptionHookOptions<AditSubscribeDiscussionChangesSubscription, AditSubscribeDiscussionChangesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AditSubscribeDiscussionChangesSubscription, AditSubscribeDiscussionChangesSubscriptionVariables>(AditSubscribeDiscussionChangesDocument, options);
      }
export type AditSubscribeDiscussionChangesSubscriptionHookResult = ReturnType<typeof useAditSubscribeDiscussionChangesSubscription>;
export type AditSubscribeDiscussionChangesSubscriptionResult = Apollo.SubscriptionResult<AditSubscribeDiscussionChangesSubscription>;
export const GetDeclarationUpdatesDocument = gql`
    subscription getDeclarationUpdates {
  pp_file_max_date_hs {
    max_change_date
  }
}
    `;

/**
 * __useGetDeclarationUpdatesSubscription__
 *
 * To run a query within a React component, call `useGetDeclarationUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetDeclarationUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeclarationUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetDeclarationUpdatesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetDeclarationUpdatesSubscription, GetDeclarationUpdatesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetDeclarationUpdatesSubscription, GetDeclarationUpdatesSubscriptionVariables>(GetDeclarationUpdatesDocument, options);
      }
export type GetDeclarationUpdatesSubscriptionHookResult = ReturnType<typeof useGetDeclarationUpdatesSubscription>;
export type GetDeclarationUpdatesSubscriptionResult = Apollo.SubscriptionResult<GetDeclarationUpdatesSubscription>;
export const Adit_Update_Declaration_Task_By_PkDocument = gql`
    mutation ADIT_UPDATE_DECLARATION_TASK_BY_PK($id: Int!, $_set: declaration_task_set_input) {
  update_declaration_task_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;
export type Adit_Update_Declaration_Task_By_PkMutationFn = Apollo.MutationFunction<Adit_Update_Declaration_Task_By_PkMutation, Adit_Update_Declaration_Task_By_PkMutationVariables>;

/**
 * __useAdit_Update_Declaration_Task_By_PkMutation__
 *
 * To run a mutation, you first call `useAdit_Update_Declaration_Task_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Update_Declaration_Task_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdateDeclarationTaskByPkMutation, { data, loading, error }] = useAdit_Update_Declaration_Task_By_PkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdit_Update_Declaration_Task_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Update_Declaration_Task_By_PkMutation, Adit_Update_Declaration_Task_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Update_Declaration_Task_By_PkMutation, Adit_Update_Declaration_Task_By_PkMutationVariables>(Adit_Update_Declaration_Task_By_PkDocument, options);
      }
export type Adit_Update_Declaration_Task_By_PkMutationHookResult = ReturnType<typeof useAdit_Update_Declaration_Task_By_PkMutation>;
export type Adit_Update_Declaration_Task_By_PkMutationResult = Apollo.MutationResult<Adit_Update_Declaration_Task_By_PkMutation>;
export type Adit_Update_Declaration_Task_By_PkMutationOptions = Apollo.BaseMutationOptions<Adit_Update_Declaration_Task_By_PkMutation, Adit_Update_Declaration_Task_By_PkMutationVariables>;
export const Update_Import_List_TriggerDocument = gql`
    mutation UPDATE_IMPORT_LIST_TRIGGER($id: Int!, $set: import_list_trigger_set_input!, $append: import_list_trigger_append_input!) {
  update_import_list_trigger_by_pk(pk_columns: {id: $id}, _set: $set, _append: $append) {
    id
    type
    config
    creation_user
    creation_date
    last_modified_user
    last_modified_date
    meta
  }
}
    `;
export type Update_Import_List_TriggerMutationFn = Apollo.MutationFunction<Update_Import_List_TriggerMutation, Update_Import_List_TriggerMutationVariables>;

/**
 * __useUpdate_Import_List_TriggerMutation__
 *
 * To run a mutation, you first call `useUpdate_Import_List_TriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Import_List_TriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImportListTriggerMutation, { data, loading, error }] = useUpdate_Import_List_TriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *      append: // value for 'append'
 *   },
 * });
 */
export function useUpdate_Import_List_TriggerMutation(baseOptions?: Apollo.MutationHookOptions<Update_Import_List_TriggerMutation, Update_Import_List_TriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Import_List_TriggerMutation, Update_Import_List_TriggerMutationVariables>(Update_Import_List_TriggerDocument, options);
      }
export type Update_Import_List_TriggerMutationHookResult = ReturnType<typeof useUpdate_Import_List_TriggerMutation>;
export type Update_Import_List_TriggerMutationResult = Apollo.MutationResult<Update_Import_List_TriggerMutation>;
export type Update_Import_List_TriggerMutationOptions = Apollo.BaseMutationOptions<Update_Import_List_TriggerMutation, Update_Import_List_TriggerMutationVariables>;
export const Update_Org_IdDocument = gql`
    query UPDATE_ORG_ID($org_id: smallint, $display_name: String, $org_params: json, $org_id_description: String) {
  pp_org_id_update(args: {_org_id: $org_id, _display_name: $display_name, _org_params: $org_params, _desk: $org_id_description}) {
    json_value
  }
}
    `;

/**
 * __useUpdate_Org_IdQuery__
 *
 * To run a query within a React component, call `useUpdate_Org_IdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Org_IdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdate_Org_IdQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      display_name: // value for 'display_name'
 *      org_params: // value for 'org_params'
 *      org_id_description: // value for 'org_id_description'
 *   },
 * });
 */
export function useUpdate_Org_IdQuery(baseOptions?: Apollo.QueryHookOptions<Update_Org_IdQuery, Update_Org_IdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Update_Org_IdQuery, Update_Org_IdQueryVariables>(Update_Org_IdDocument, options);
      }
export function useUpdate_Org_IdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Update_Org_IdQuery, Update_Org_IdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Update_Org_IdQuery, Update_Org_IdQueryVariables>(Update_Org_IdDocument, options);
        }
export type Update_Org_IdQueryHookResult = ReturnType<typeof useUpdate_Org_IdQuery>;
export type Update_Org_IdLazyQueryHookResult = ReturnType<typeof useUpdate_Org_IdLazyQuery>;
export type Update_Org_IdQueryResult = Apollo.QueryResult<Update_Org_IdQuery, Update_Org_IdQueryVariables>;
export const Insert_AddressDocument = gql`
    mutation INSERT_ADDRESS($objects: [address_insert_input!]!) {
  insert_address(objects: $objects) {
    affected_rows
  }
}
    `;
export type Insert_AddressMutationFn = Apollo.MutationFunction<Insert_AddressMutation, Insert_AddressMutationVariables>;

/**
 * __useInsert_AddressMutation__
 *
 * To run a mutation, you first call `useInsert_AddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_AddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAddressMutation, { data, loading, error }] = useInsert_AddressMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsert_AddressMutation(baseOptions?: Apollo.MutationHookOptions<Insert_AddressMutation, Insert_AddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_AddressMutation, Insert_AddressMutationVariables>(Insert_AddressDocument, options);
      }
export type Insert_AddressMutationHookResult = ReturnType<typeof useInsert_AddressMutation>;
export type Insert_AddressMutationResult = Apollo.MutationResult<Insert_AddressMutation>;
export type Insert_AddressMutationOptions = Apollo.BaseMutationOptions<Insert_AddressMutation, Insert_AddressMutationVariables>;
export const Update_AddressDocument = gql`
    mutation UPDATE_ADDRESS($id: Int, $values: address_set_input) {
  update_address(where: {id: {_eq: $id}}, _set: $values) {
    affected_rows
  }
}
    `;
export type Update_AddressMutationFn = Apollo.MutationFunction<Update_AddressMutation, Update_AddressMutationVariables>;

/**
 * __useUpdate_AddressMutation__
 *
 * To run a mutation, you first call `useUpdate_AddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_AddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdate_AddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdate_AddressMutation(baseOptions?: Apollo.MutationHookOptions<Update_AddressMutation, Update_AddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_AddressMutation, Update_AddressMutationVariables>(Update_AddressDocument, options);
      }
export type Update_AddressMutationHookResult = ReturnType<typeof useUpdate_AddressMutation>;
export type Update_AddressMutationResult = Apollo.MutationResult<Update_AddressMutation>;
export type Update_AddressMutationOptions = Apollo.BaseMutationOptions<Update_AddressMutation, Update_AddressMutationVariables>;
export const Delete_AddressDocument = gql`
    mutation DELETE_ADDRESS($id: Int) {
  delete_address(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type Delete_AddressMutationFn = Apollo.MutationFunction<Delete_AddressMutation, Delete_AddressMutationVariables>;

/**
 * __useDelete_AddressMutation__
 *
 * To run a mutation, you first call `useDelete_AddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_AddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddressMutation, { data, loading, error }] = useDelete_AddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_AddressMutation(baseOptions?: Apollo.MutationHookOptions<Delete_AddressMutation, Delete_AddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_AddressMutation, Delete_AddressMutationVariables>(Delete_AddressDocument, options);
      }
export type Delete_AddressMutationHookResult = ReturnType<typeof useDelete_AddressMutation>;
export type Delete_AddressMutationResult = Apollo.MutationResult<Delete_AddressMutation>;
export type Delete_AddressMutationOptions = Apollo.BaseMutationOptions<Delete_AddressMutation, Delete_AddressMutationVariables>;
export const ToggleAiConfirmedDocument = gql`
    mutation ToggleAIConfirmed($file_id: uuid!, $dr_no: smallint!, $value: Boolean!) {
  update_declaration(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}}, _set: {ai_confirmed: $value}) {
    affected_rows
  }
}
    `;
export type ToggleAiConfirmedMutationFn = Apollo.MutationFunction<ToggleAiConfirmedMutation, ToggleAiConfirmedMutationVariables>;

/**
 * __useToggleAiConfirmedMutation__
 *
 * To run a mutation, you first call `useToggleAiConfirmedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAiConfirmedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAiConfirmedMutation, { data, loading, error }] = useToggleAiConfirmedMutation({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      dr_no: // value for 'dr_no'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useToggleAiConfirmedMutation(baseOptions?: Apollo.MutationHookOptions<ToggleAiConfirmedMutation, ToggleAiConfirmedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleAiConfirmedMutation, ToggleAiConfirmedMutationVariables>(ToggleAiConfirmedDocument, options);
      }
export type ToggleAiConfirmedMutationHookResult = ReturnType<typeof useToggleAiConfirmedMutation>;
export type ToggleAiConfirmedMutationResult = Apollo.MutationResult<ToggleAiConfirmedMutation>;
export type ToggleAiConfirmedMutationOptions = Apollo.BaseMutationOptions<ToggleAiConfirmedMutation, ToggleAiConfirmedMutationVariables>;
export const Adit_Delete_DocumentDocument = gql`
    mutation ADIT_DELETE_DOCUMENT($id: [uuid!]!) {
  update_document(where: {id: {_in: $id}}, _set: {is_deleted: true, checksum: null}) {
    affected_rows
  }
}
    `;
export type Adit_Delete_DocumentMutationFn = Apollo.MutationFunction<Adit_Delete_DocumentMutation, Adit_Delete_DocumentMutationVariables>;

/**
 * __useAdit_Delete_DocumentMutation__
 *
 * To run a mutation, you first call `useAdit_Delete_DocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Delete_DocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditDeleteDocumentMutation, { data, loading, error }] = useAdit_Delete_DocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdit_Delete_DocumentMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Delete_DocumentMutation, Adit_Delete_DocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Delete_DocumentMutation, Adit_Delete_DocumentMutationVariables>(Adit_Delete_DocumentDocument, options);
      }
export type Adit_Delete_DocumentMutationHookResult = ReturnType<typeof useAdit_Delete_DocumentMutation>;
export type Adit_Delete_DocumentMutationResult = Apollo.MutationResult<Adit_Delete_DocumentMutation>;
export type Adit_Delete_DocumentMutationOptions = Apollo.BaseMutationOptions<Adit_Delete_DocumentMutation, Adit_Delete_DocumentMutationVariables>;
export const Append_Meta_DocumentDocument = gql`
    mutation APPEND_META_DOCUMENT($id: [uuid!]!, $meta: jsonb) {
  update_document(where: {id: {_in: $id}}, _append: {meta: $meta}) {
    affected_rows
  }
}
    `;
export type Append_Meta_DocumentMutationFn = Apollo.MutationFunction<Append_Meta_DocumentMutation, Append_Meta_DocumentMutationVariables>;

/**
 * __useAppend_Meta_DocumentMutation__
 *
 * To run a mutation, you first call `useAppend_Meta_DocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppend_Meta_DocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendMetaDocumentMutation, { data, loading, error }] = useAppend_Meta_DocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      meta: // value for 'meta'
 *   },
 * });
 */
export function useAppend_Meta_DocumentMutation(baseOptions?: Apollo.MutationHookOptions<Append_Meta_DocumentMutation, Append_Meta_DocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Append_Meta_DocumentMutation, Append_Meta_DocumentMutationVariables>(Append_Meta_DocumentDocument, options);
      }
export type Append_Meta_DocumentMutationHookResult = ReturnType<typeof useAppend_Meta_DocumentMutation>;
export type Append_Meta_DocumentMutationResult = Apollo.MutationResult<Append_Meta_DocumentMutation>;
export type Append_Meta_DocumentMutationOptions = Apollo.BaseMutationOptions<Append_Meta_DocumentMutation, Append_Meta_DocumentMutationVariables>;
export const CreateDocumentDocument = gql`
    mutation createDocument($document: CreateDocumentInput!) {
  createDocument(document: $document) {
    success
    error
    documentId
  }
}
    `;
export type CreateDocumentMutationFn = Apollo.MutationFunction<CreateDocumentMutation, CreateDocumentMutationVariables>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentMutation, CreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(CreateDocumentDocument, options);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const Clear_Document_ChecksumDocument = gql`
    mutation CLEAR_DOCUMENT_CHECKSUM($checksums: [String!]!) {
  update_document(where: {checksum: {_in: $checksums}, document_type: {_eq: "unknown"}}, _set: {checksum: null}) {
    affected_rows
  }
}
    `;
export type Clear_Document_ChecksumMutationFn = Apollo.MutationFunction<Clear_Document_ChecksumMutation, Clear_Document_ChecksumMutationVariables>;

/**
 * __useClear_Document_ChecksumMutation__
 *
 * To run a mutation, you first call `useClear_Document_ChecksumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClear_Document_ChecksumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearDocumentChecksumMutation, { data, loading, error }] = useClear_Document_ChecksumMutation({
 *   variables: {
 *      checksums: // value for 'checksums'
 *   },
 * });
 */
export function useClear_Document_ChecksumMutation(baseOptions?: Apollo.MutationHookOptions<Clear_Document_ChecksumMutation, Clear_Document_ChecksumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Clear_Document_ChecksumMutation, Clear_Document_ChecksumMutationVariables>(Clear_Document_ChecksumDocument, options);
      }
export type Clear_Document_ChecksumMutationHookResult = ReturnType<typeof useClear_Document_ChecksumMutation>;
export type Clear_Document_ChecksumMutationResult = Apollo.MutationResult<Clear_Document_ChecksumMutation>;
export type Clear_Document_ChecksumMutationOptions = Apollo.BaseMutationOptions<Clear_Document_ChecksumMutation, Clear_Document_ChecksumMutationVariables>;
export const Upsert_Doc_AnnotationDocument = gql`
    mutation UPSERT_DOC_ANNOTATION($docId: uuid!, $annoTypeId: smallint!, $value: jsonb!) {
  insert_doc_annotation(objects: {anno_type_id: $annoTypeId, doc_id: $docId, value: $value}, on_conflict: {constraint: pk_doc_annotation_doc_id_anno_type_id, update_columns: [value]}) {
    affected_rows
  }
}
    `;
export type Upsert_Doc_AnnotationMutationFn = Apollo.MutationFunction<Upsert_Doc_AnnotationMutation, Upsert_Doc_AnnotationMutationVariables>;

/**
 * __useUpsert_Doc_AnnotationMutation__
 *
 * To run a mutation, you first call `useUpsert_Doc_AnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsert_Doc_AnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDocAnnotationMutation, { data, loading, error }] = useUpsert_Doc_AnnotationMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *      annoTypeId: // value for 'annoTypeId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpsert_Doc_AnnotationMutation(baseOptions?: Apollo.MutationHookOptions<Upsert_Doc_AnnotationMutation, Upsert_Doc_AnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Upsert_Doc_AnnotationMutation, Upsert_Doc_AnnotationMutationVariables>(Upsert_Doc_AnnotationDocument, options);
      }
export type Upsert_Doc_AnnotationMutationHookResult = ReturnType<typeof useUpsert_Doc_AnnotationMutation>;
export type Upsert_Doc_AnnotationMutationResult = Apollo.MutationResult<Upsert_Doc_AnnotationMutation>;
export type Upsert_Doc_AnnotationMutationOptions = Apollo.BaseMutationOptions<Upsert_Doc_AnnotationMutation, Upsert_Doc_AnnotationMutationVariables>;
export const ScheduleDocumentsDocument = gql`
    mutation scheduleDocuments($documentIds: [ID!]!) {
  scheduleDocuments(documentIds: $documentIds)
}
    `;
export type ScheduleDocumentsMutationFn = Apollo.MutationFunction<ScheduleDocumentsMutation, ScheduleDocumentsMutationVariables>;

/**
 * __useScheduleDocumentsMutation__
 *
 * To run a mutation, you first call `useScheduleDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleDocumentsMutation, { data, loading, error }] = useScheduleDocumentsMutation({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useScheduleDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleDocumentsMutation, ScheduleDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleDocumentsMutation, ScheduleDocumentsMutationVariables>(ScheduleDocumentsDocument, options);
      }
export type ScheduleDocumentsMutationHookResult = ReturnType<typeof useScheduleDocumentsMutation>;
export type ScheduleDocumentsMutationResult = Apollo.MutationResult<ScheduleDocumentsMutation>;
export type ScheduleDocumentsMutationOptions = Apollo.BaseMutationOptions<ScheduleDocumentsMutation, ScheduleDocumentsMutationVariables>;
export const Create_Document_LabelDocument = gql`
    mutation CREATE_DOCUMENT_LABEL($document_label: [document_labels_insert_input!]!) {
  insert_document_labels(objects: $document_label) {
    returning {
      id
    }
  }
}
    `;
export type Create_Document_LabelMutationFn = Apollo.MutationFunction<Create_Document_LabelMutation, Create_Document_LabelMutationVariables>;

/**
 * __useCreate_Document_LabelMutation__
 *
 * To run a mutation, you first call `useCreate_Document_LabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreate_Document_LabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentLabelMutation, { data, loading, error }] = useCreate_Document_LabelMutation({
 *   variables: {
 *      document_label: // value for 'document_label'
 *   },
 * });
 */
export function useCreate_Document_LabelMutation(baseOptions?: Apollo.MutationHookOptions<Create_Document_LabelMutation, Create_Document_LabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Create_Document_LabelMutation, Create_Document_LabelMutationVariables>(Create_Document_LabelDocument, options);
      }
export type Create_Document_LabelMutationHookResult = ReturnType<typeof useCreate_Document_LabelMutation>;
export type Create_Document_LabelMutationResult = Apollo.MutationResult<Create_Document_LabelMutation>;
export type Create_Document_LabelMutationOptions = Apollo.BaseMutationOptions<Create_Document_LabelMutation, Create_Document_LabelMutationVariables>;
export const Update_Document_LabelDocument = gql`
    mutation UPDATE_DOCUMENT_LABEL($id: Int, $title: jsonb, $description: jsonb, $color: String, $is_deleted: Boolean) {
  update_document_labels(where: {id: {_eq: $id}}, _set: {title: $title, description: $description, color: $color}) {
    returning {
      id
    }
  }
}
    `;
export type Update_Document_LabelMutationFn = Apollo.MutationFunction<Update_Document_LabelMutation, Update_Document_LabelMutationVariables>;

/**
 * __useUpdate_Document_LabelMutation__
 *
 * To run a mutation, you first call `useUpdate_Document_LabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Document_LabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentLabelMutation, { data, loading, error }] = useUpdate_Document_LabelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      color: // value for 'color'
 *      is_deleted: // value for 'is_deleted'
 *   },
 * });
 */
export function useUpdate_Document_LabelMutation(baseOptions?: Apollo.MutationHookOptions<Update_Document_LabelMutation, Update_Document_LabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Document_LabelMutation, Update_Document_LabelMutationVariables>(Update_Document_LabelDocument, options);
      }
export type Update_Document_LabelMutationHookResult = ReturnType<typeof useUpdate_Document_LabelMutation>;
export type Update_Document_LabelMutationResult = Apollo.MutationResult<Update_Document_LabelMutation>;
export type Update_Document_LabelMutationOptions = Apollo.BaseMutationOptions<Update_Document_LabelMutation, Update_Document_LabelMutationVariables>;
export const Delete_Document_LabelDocument = gql`
    mutation DELETE_DOCUMENT_LABEL($id: Int) {
  update_document_labels(where: {id: {_eq: $id}}, _set: {is_deleted: true}) {
    returning {
      id
    }
  }
}
    `;
export type Delete_Document_LabelMutationFn = Apollo.MutationFunction<Delete_Document_LabelMutation, Delete_Document_LabelMutationVariables>;

/**
 * __useDelete_Document_LabelMutation__
 *
 * To run a mutation, you first call `useDelete_Document_LabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Document_LabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentLabelMutation, { data, loading, error }] = useDelete_Document_LabelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_Document_LabelMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Document_LabelMutation, Delete_Document_LabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Document_LabelMutation, Delete_Document_LabelMutationVariables>(Delete_Document_LabelDocument, options);
      }
export type Delete_Document_LabelMutationHookResult = ReturnType<typeof useDelete_Document_LabelMutation>;
export type Delete_Document_LabelMutationResult = Apollo.MutationResult<Delete_Document_LabelMutation>;
export type Delete_Document_LabelMutationOptions = Apollo.BaseMutationOptions<Delete_Document_LabelMutation, Delete_Document_LabelMutationVariables>;
export const Create_Document_Type_Tenant_SettingsDocument = gql`
    mutation CREATE_DOCUMENT_TYPE_TENANT_SETTINGS($document_type: [document_type_tenant_settings_insert_input!]!) {
  insert_document_type_tenant_settings(objects: $document_type) {
    returning {
      document_type
      tenant
    }
  }
}
    `;
export type Create_Document_Type_Tenant_SettingsMutationFn = Apollo.MutationFunction<Create_Document_Type_Tenant_SettingsMutation, Create_Document_Type_Tenant_SettingsMutationVariables>;

/**
 * __useCreate_Document_Type_Tenant_SettingsMutation__
 *
 * To run a mutation, you first call `useCreate_Document_Type_Tenant_SettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreate_Document_Type_Tenant_SettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentTypeTenantSettingsMutation, { data, loading, error }] = useCreate_Document_Type_Tenant_SettingsMutation({
 *   variables: {
 *      document_type: // value for 'document_type'
 *   },
 * });
 */
export function useCreate_Document_Type_Tenant_SettingsMutation(baseOptions?: Apollo.MutationHookOptions<Create_Document_Type_Tenant_SettingsMutation, Create_Document_Type_Tenant_SettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Create_Document_Type_Tenant_SettingsMutation, Create_Document_Type_Tenant_SettingsMutationVariables>(Create_Document_Type_Tenant_SettingsDocument, options);
      }
export type Create_Document_Type_Tenant_SettingsMutationHookResult = ReturnType<typeof useCreate_Document_Type_Tenant_SettingsMutation>;
export type Create_Document_Type_Tenant_SettingsMutationResult = Apollo.MutationResult<Create_Document_Type_Tenant_SettingsMutation>;
export type Create_Document_Type_Tenant_SettingsMutationOptions = Apollo.BaseMutationOptions<Create_Document_Type_Tenant_SettingsMutation, Create_Document_Type_Tenant_SettingsMutationVariables>;
export const Update_Document_Type_Tenant_SettingsDocument = gql`
    mutation UPDATE_DOCUMENT_TYPE_TENANT_SETTINGS($documentType: String!, $tenant: uuid, $translations: jsonb, $code: String, $meta: jsonb, $default_flags: bigint) {
  update_document_type_tenant_settings(where: {_and: [{document_type: {_eq: $documentType}}, {tenant: {_eq: $tenant}}]}, _set: {code: $code, meta: $meta, default_flags: $default_flags}) {
    returning {
      document_type
      tenant
    }
  }
  update_document_type: update_document_type_by_pk(pk_columns: {name: $documentType}, _set: {translations: $translations}) {
    name
  }
}
    `;
export type Update_Document_Type_Tenant_SettingsMutationFn = Apollo.MutationFunction<Update_Document_Type_Tenant_SettingsMutation, Update_Document_Type_Tenant_SettingsMutationVariables>;

/**
 * __useUpdate_Document_Type_Tenant_SettingsMutation__
 *
 * To run a mutation, you first call `useUpdate_Document_Type_Tenant_SettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Document_Type_Tenant_SettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentTypeTenantSettingsMutation, { data, loading, error }] = useUpdate_Document_Type_Tenant_SettingsMutation({
 *   variables: {
 *      documentType: // value for 'documentType'
 *      tenant: // value for 'tenant'
 *      translations: // value for 'translations'
 *      code: // value for 'code'
 *      meta: // value for 'meta'
 *      default_flags: // value for 'default_flags'
 *   },
 * });
 */
export function useUpdate_Document_Type_Tenant_SettingsMutation(baseOptions?: Apollo.MutationHookOptions<Update_Document_Type_Tenant_SettingsMutation, Update_Document_Type_Tenant_SettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Document_Type_Tenant_SettingsMutation, Update_Document_Type_Tenant_SettingsMutationVariables>(Update_Document_Type_Tenant_SettingsDocument, options);
      }
export type Update_Document_Type_Tenant_SettingsMutationHookResult = ReturnType<typeof useUpdate_Document_Type_Tenant_SettingsMutation>;
export type Update_Document_Type_Tenant_SettingsMutationResult = Apollo.MutationResult<Update_Document_Type_Tenant_SettingsMutation>;
export type Update_Document_Type_Tenant_SettingsMutationOptions = Apollo.BaseMutationOptions<Update_Document_Type_Tenant_SettingsMutation, Update_Document_Type_Tenant_SettingsMutationVariables>;
export const Delete_Document_Type_Tenant_SettingsDocument = gql`
    mutation DELETE_DOCUMENT_TYPE_TENANT_SETTINGS($names: [String!]!, $tenant: uuid!) {
  delete_document_type_tenant_settings(where: {document_type: {_in: $names}, tenant: {_eq: $tenant}}) {
    returning {
      document_type
      tenant
    }
  }
}
    `;
export type Delete_Document_Type_Tenant_SettingsMutationFn = Apollo.MutationFunction<Delete_Document_Type_Tenant_SettingsMutation, Delete_Document_Type_Tenant_SettingsMutationVariables>;

/**
 * __useDelete_Document_Type_Tenant_SettingsMutation__
 *
 * To run a mutation, you first call `useDelete_Document_Type_Tenant_SettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Document_Type_Tenant_SettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentTypeTenantSettingsMutation, { data, loading, error }] = useDelete_Document_Type_Tenant_SettingsMutation({
 *   variables: {
 *      names: // value for 'names'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useDelete_Document_Type_Tenant_SettingsMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Document_Type_Tenant_SettingsMutation, Delete_Document_Type_Tenant_SettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Document_Type_Tenant_SettingsMutation, Delete_Document_Type_Tenant_SettingsMutationVariables>(Delete_Document_Type_Tenant_SettingsDocument, options);
      }
export type Delete_Document_Type_Tenant_SettingsMutationHookResult = ReturnType<typeof useDelete_Document_Type_Tenant_SettingsMutation>;
export type Delete_Document_Type_Tenant_SettingsMutationResult = Apollo.MutationResult<Delete_Document_Type_Tenant_SettingsMutation>;
export type Delete_Document_Type_Tenant_SettingsMutationOptions = Apollo.BaseMutationOptions<Delete_Document_Type_Tenant_SettingsMutation, Delete_Document_Type_Tenant_SettingsMutationVariables>;
export const ValidateFileNumberDocument = gql`
    mutation ValidateFileNumber($number: String!) {
  validateFileNumber(number: $number) {
    error_code
    error_description
    data {
      orgId
      shipmentNumber
      traffic
      lines {
        grossWeight
        packaging
        quantity
      }
      consignee {
        adrID
        city
        consigneeAdrID
        country
        name
        postalCode
        state
        street
      }
      shipper {
        adrID
        city
        consigneeAdrID
        country
        name
        postalCode
        state
        street
      }
      orderedBy {
        adrID
        city
        consigneeAdrID
        country
        name
        postalCode
        state
        street
      }
    }
  }
}
    `;
export type ValidateFileNumberMutationFn = Apollo.MutationFunction<ValidateFileNumberMutation, ValidateFileNumberMutationVariables>;

/**
 * __useValidateFileNumberMutation__
 *
 * To run a mutation, you first call `useValidateFileNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateFileNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateFileNumberMutation, { data, loading, error }] = useValidateFileNumberMutation({
 *   variables: {
 *      number: // value for 'number'
 *   },
 * });
 */
export function useValidateFileNumberMutation(baseOptions?: Apollo.MutationHookOptions<ValidateFileNumberMutation, ValidateFileNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateFileNumberMutation, ValidateFileNumberMutationVariables>(ValidateFileNumberDocument, options);
      }
export type ValidateFileNumberMutationHookResult = ReturnType<typeof useValidateFileNumberMutation>;
export type ValidateFileNumberMutationResult = Apollo.MutationResult<ValidateFileNumberMutation>;
export type ValidateFileNumberMutationOptions = Apollo.BaseMutationOptions<ValidateFileNumberMutation, ValidateFileNumberMutationVariables>;
export const TransmitFileDocument = gql`
    mutation transmitFile($data: TransmitFileInput!) {
  transmitFile(data: $data) {
    success
    error
    fileIds
  }
}
    `;
export type TransmitFileMutationFn = Apollo.MutationFunction<TransmitFileMutation, TransmitFileMutationVariables>;

/**
 * __useTransmitFileMutation__
 *
 * To run a mutation, you first call `useTransmitFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransmitFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transmitFileMutation, { data, loading, error }] = useTransmitFileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTransmitFileMutation(baseOptions?: Apollo.MutationHookOptions<TransmitFileMutation, TransmitFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransmitFileMutation, TransmitFileMutationVariables>(TransmitFileDocument, options);
      }
export type TransmitFileMutationHookResult = ReturnType<typeof useTransmitFileMutation>;
export type TransmitFileMutationResult = Apollo.MutationResult<TransmitFileMutation>;
export type TransmitFileMutationOptions = Apollo.BaseMutationOptions<TransmitFileMutation, TransmitFileMutationVariables>;
export const ScheduleFilesDocument = gql`
    mutation scheduleFiles($fileIds: [ID!]!) {
  scheduleFiles(fileIds: $fileIds)
}
    `;
export type ScheduleFilesMutationFn = Apollo.MutationFunction<ScheduleFilesMutation, ScheduleFilesMutationVariables>;

/**
 * __useScheduleFilesMutation__
 *
 * To run a mutation, you first call `useScheduleFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleFilesMutation, { data, loading, error }] = useScheduleFilesMutation({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useScheduleFilesMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleFilesMutation, ScheduleFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleFilesMutation, ScheduleFilesMutationVariables>(ScheduleFilesDocument, options);
      }
export type ScheduleFilesMutationHookResult = ReturnType<typeof useScheduleFilesMutation>;
export type ScheduleFilesMutationResult = Apollo.MutationResult<ScheduleFilesMutation>;
export type ScheduleFilesMutationOptions = Apollo.BaseMutationOptions<ScheduleFilesMutation, ScheduleFilesMutationVariables>;
export const Adit_Schedule_Data_ExtractionDocument = gql`
    mutation ADIT_SCHEDULE_DATA_EXTRACTION($fileId: ID!, $drNo: Int!) {
  scheduleAldiSrvProcessing(fileId: $fileId, drNo: $drNo)
}
    `;
export type Adit_Schedule_Data_ExtractionMutationFn = Apollo.MutationFunction<Adit_Schedule_Data_ExtractionMutation, Adit_Schedule_Data_ExtractionMutationVariables>;

/**
 * __useAdit_Schedule_Data_ExtractionMutation__
 *
 * To run a mutation, you first call `useAdit_Schedule_Data_ExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Schedule_Data_ExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditScheduleDataExtractionMutation, { data, loading, error }] = useAdit_Schedule_Data_ExtractionMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      drNo: // value for 'drNo'
 *   },
 * });
 */
export function useAdit_Schedule_Data_ExtractionMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Schedule_Data_ExtractionMutation, Adit_Schedule_Data_ExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Schedule_Data_ExtractionMutation, Adit_Schedule_Data_ExtractionMutationVariables>(Adit_Schedule_Data_ExtractionDocument, options);
      }
export type Adit_Schedule_Data_ExtractionMutationHookResult = ReturnType<typeof useAdit_Schedule_Data_ExtractionMutation>;
export type Adit_Schedule_Data_ExtractionMutationResult = Apollo.MutationResult<Adit_Schedule_Data_ExtractionMutation>;
export type Adit_Schedule_Data_ExtractionMutationOptions = Apollo.BaseMutationOptions<Adit_Schedule_Data_ExtractionMutation, Adit_Schedule_Data_ExtractionMutationVariables>;
export const ValidateJourneyNumberDocument = gql`
    mutation ValidateJourneyNumber($number: String!) {
  validateJourneyNumber(number: $number) {
    error_code
    error_description
    data
  }
}
    `;
export type ValidateJourneyNumberMutationFn = Apollo.MutationFunction<ValidateJourneyNumberMutation, ValidateJourneyNumberMutationVariables>;

/**
 * __useValidateJourneyNumberMutation__
 *
 * To run a mutation, you first call `useValidateJourneyNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateJourneyNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateJourneyNumberMutation, { data, loading, error }] = useValidateJourneyNumberMutation({
 *   variables: {
 *      number: // value for 'number'
 *   },
 * });
 */
export function useValidateJourneyNumberMutation(baseOptions?: Apollo.MutationHookOptions<ValidateJourneyNumberMutation, ValidateJourneyNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateJourneyNumberMutation, ValidateJourneyNumberMutationVariables>(ValidateJourneyNumberDocument, options);
      }
export type ValidateJourneyNumberMutationHookResult = ReturnType<typeof useValidateJourneyNumberMutation>;
export type ValidateJourneyNumberMutationResult = Apollo.MutationResult<ValidateJourneyNumberMutation>;
export type ValidateJourneyNumberMutationOptions = Apollo.BaseMutationOptions<ValidateJourneyNumberMutation, ValidateJourneyNumberMutationVariables>;
export const Upsert_TableDocument = gql`
    mutation UPSERT_TABLE($pageId: uuid!, $extractTypeId: smallint!, $tables: jsonb!) {
  insert_page_extract_one(object: {page_id: $pageId, extract_type_id: $extractTypeId, tables: $tables}, on_conflict: {constraint: page_extract_pk, update_columns: [tables]}) {
    page_id
  }
}
    `;
export type Upsert_TableMutationFn = Apollo.MutationFunction<Upsert_TableMutation, Upsert_TableMutationVariables>;

/**
 * __useUpsert_TableMutation__
 *
 * To run a mutation, you first call `useUpsert_TableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsert_TableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTableMutation, { data, loading, error }] = useUpsert_TableMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      extractTypeId: // value for 'extractTypeId'
 *      tables: // value for 'tables'
 *   },
 * });
 */
export function useUpsert_TableMutation(baseOptions?: Apollo.MutationHookOptions<Upsert_TableMutation, Upsert_TableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Upsert_TableMutation, Upsert_TableMutationVariables>(Upsert_TableDocument, options);
      }
export type Upsert_TableMutationHookResult = ReturnType<typeof useUpsert_TableMutation>;
export type Upsert_TableMutationResult = Apollo.MutationResult<Upsert_TableMutation>;
export type Upsert_TableMutationOptions = Apollo.BaseMutationOptions<Upsert_TableMutation, Upsert_TableMutationVariables>;
export const UpdateRotationDocument = gql`
    mutation updateRotation($objects: [page_insert_input!]!) {
  insert_page(objects: $objects, on_conflict: {constraint: page_pkey, update_columns: rotate}) {
    affected_rows
  }
}
    `;
export type UpdateRotationMutationFn = Apollo.MutationFunction<UpdateRotationMutation, UpdateRotationMutationVariables>;

/**
 * __useUpdateRotationMutation__
 *
 * To run a mutation, you first call `useUpdateRotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRotationMutation, { data, loading, error }] = useUpdateRotationMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpdateRotationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRotationMutation, UpdateRotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRotationMutation, UpdateRotationMutationVariables>(UpdateRotationDocument, options);
      }
export type UpdateRotationMutationHookResult = ReturnType<typeof useUpdateRotationMutation>;
export type UpdateRotationMutationResult = Apollo.MutationResult<UpdateRotationMutation>;
export type UpdateRotationMutationOptions = Apollo.BaseMutationOptions<UpdateRotationMutation, UpdateRotationMutationVariables>;
export const Update_Page_ClobDocument = gql`
    mutation update_page_clob($pageId: uuid!, $dataPointId: String!, $extract_type_id: smallint!) {
  update_page_extract(where: {_and: [{page_id: {_eq: $pageId}}, {extract_type_id: {_eq: $extract_type_id}}]}, _delete_key: {value: $dataPointId}) {
    returning {
      page_id
    }
  }
}
    `;
export type Update_Page_ClobMutationFn = Apollo.MutationFunction<Update_Page_ClobMutation, Update_Page_ClobMutationVariables>;

/**
 * __useUpdate_Page_ClobMutation__
 *
 * To run a mutation, you first call `useUpdate_Page_ClobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Page_ClobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageClobMutation, { data, loading, error }] = useUpdate_Page_ClobMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      dataPointId: // value for 'dataPointId'
 *      extract_type_id: // value for 'extract_type_id'
 *   },
 * });
 */
export function useUpdate_Page_ClobMutation(baseOptions?: Apollo.MutationHookOptions<Update_Page_ClobMutation, Update_Page_ClobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Page_ClobMutation, Update_Page_ClobMutationVariables>(Update_Page_ClobDocument, options);
      }
export type Update_Page_ClobMutationHookResult = ReturnType<typeof useUpdate_Page_ClobMutation>;
export type Update_Page_ClobMutationResult = Apollo.MutationResult<Update_Page_ClobMutation>;
export type Update_Page_ClobMutationOptions = Apollo.BaseMutationOptions<Update_Page_ClobMutation, Update_Page_ClobMutationVariables>;
export const Update_Data_PointDocument = gql`
    mutation update_data_point($dataPoint: jsonb!, $pageId: uuid!, $dataPointIndex: Int!, $extract_type_id: smallint!) {
  delete: update_page_extract_by_pk(pk_columns: {extract_type_id: $extract_type_id, page_id: $pageId}, _delete_elem: {value: $dataPointIndex}) {
    page_id
  }
  append: update_page_extract_by_pk(pk_columns: {extract_type_id: $extract_type_id, page_id: $pageId}, _append: {value: $dataPoint}) {
    page_id
  }
}
    `;
export type Update_Data_PointMutationFn = Apollo.MutationFunction<Update_Data_PointMutation, Update_Data_PointMutationVariables>;

/**
 * __useUpdate_Data_PointMutation__
 *
 * To run a mutation, you first call `useUpdate_Data_PointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Data_PointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataPointMutation, { data, loading, error }] = useUpdate_Data_PointMutation({
 *   variables: {
 *      dataPoint: // value for 'dataPoint'
 *      pageId: // value for 'pageId'
 *      dataPointIndex: // value for 'dataPointIndex'
 *      extract_type_id: // value for 'extract_type_id'
 *   },
 * });
 */
export function useUpdate_Data_PointMutation(baseOptions?: Apollo.MutationHookOptions<Update_Data_PointMutation, Update_Data_PointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Data_PointMutation, Update_Data_PointMutationVariables>(Update_Data_PointDocument, options);
      }
export type Update_Data_PointMutationHookResult = ReturnType<typeof useUpdate_Data_PointMutation>;
export type Update_Data_PointMutationResult = Apollo.MutationResult<Update_Data_PointMutation>;
export type Update_Data_PointMutationOptions = Apollo.BaseMutationOptions<Update_Data_PointMutation, Update_Data_PointMutationVariables>;
export const Update_Page_Extract_ValueDocument = gql`
    mutation UPDATE_PAGE_EXTRACT_VALUE($value: page_extract_append_input!, $pageId: uuid!, $extract_type_id: smallint!) {
  update_page_extract_by_pk(pk_columns: {extract_type_id: $extract_type_id, page_id: $pageId}, _append: $value) {
    value
  }
}
    `;
export type Update_Page_Extract_ValueMutationFn = Apollo.MutationFunction<Update_Page_Extract_ValueMutation, Update_Page_Extract_ValueMutationVariables>;

/**
 * __useUpdate_Page_Extract_ValueMutation__
 *
 * To run a mutation, you first call `useUpdate_Page_Extract_ValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Page_Extract_ValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageExtractValueMutation, { data, loading, error }] = useUpdate_Page_Extract_ValueMutation({
 *   variables: {
 *      value: // value for 'value'
 *      pageId: // value for 'pageId'
 *      extract_type_id: // value for 'extract_type_id'
 *   },
 * });
 */
export function useUpdate_Page_Extract_ValueMutation(baseOptions?: Apollo.MutationHookOptions<Update_Page_Extract_ValueMutation, Update_Page_Extract_ValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Page_Extract_ValueMutation, Update_Page_Extract_ValueMutationVariables>(Update_Page_Extract_ValueDocument, options);
      }
export type Update_Page_Extract_ValueMutationHookResult = ReturnType<typeof useUpdate_Page_Extract_ValueMutation>;
export type Update_Page_Extract_ValueMutationResult = Apollo.MutationResult<Update_Page_Extract_ValueMutation>;
export type Update_Page_Extract_ValueMutationOptions = Apollo.BaseMutationOptions<Update_Page_Extract_ValueMutation, Update_Page_Extract_ValueMutationVariables>;
export const Upsert_Page_Extract_ValueDocument = gql`
    mutation UPSERT_PAGE_EXTRACT_VALUE($pageId: uuid!, $value: jsonb!, $extract_type_id: smallint!) {
  insert_page_extract(objects: {extract_type_id: $extract_type_id, page_id: $pageId, value: {}}, on_conflict: {constraint: page_extract_pk, update_columns: []}) {
    returning {
      page_id
    }
    affected_rows
  }
  update_page_extract_by_pk(pk_columns: {extract_type_id: $extract_type_id, page_id: $pageId}, _append: {value: $value}) {
    page_id
  }
}
    `;
export type Upsert_Page_Extract_ValueMutationFn = Apollo.MutationFunction<Upsert_Page_Extract_ValueMutation, Upsert_Page_Extract_ValueMutationVariables>;

/**
 * __useUpsert_Page_Extract_ValueMutation__
 *
 * To run a mutation, you first call `useUpsert_Page_Extract_ValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsert_Page_Extract_ValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPageExtractValueMutation, { data, loading, error }] = useUpsert_Page_Extract_ValueMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      value: // value for 'value'
 *      extract_type_id: // value for 'extract_type_id'
 *   },
 * });
 */
export function useUpsert_Page_Extract_ValueMutation(baseOptions?: Apollo.MutationHookOptions<Upsert_Page_Extract_ValueMutation, Upsert_Page_Extract_ValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Upsert_Page_Extract_ValueMutation, Upsert_Page_Extract_ValueMutationVariables>(Upsert_Page_Extract_ValueDocument, options);
      }
export type Upsert_Page_Extract_ValueMutationHookResult = ReturnType<typeof useUpsert_Page_Extract_ValueMutation>;
export type Upsert_Page_Extract_ValueMutationResult = Apollo.MutationResult<Upsert_Page_Extract_ValueMutation>;
export type Upsert_Page_Extract_ValueMutationOptions = Apollo.BaseMutationOptions<Upsert_Page_Extract_ValueMutation, Upsert_Page_Extract_ValueMutationVariables>;
export const UpdateAiIgnoreRetrainingDocument = gql`
    mutation UpdateAIIgnoreRetraining($id: uuid!, $value: Boolean!) {
  update_page_by_pk(pk_columns: {id: $id}, _set: {ai_ignore_retraining: $value}) {
    id
    ai_ignore_retraining
  }
}
    `;
export type UpdateAiIgnoreRetrainingMutationFn = Apollo.MutationFunction<UpdateAiIgnoreRetrainingMutation, UpdateAiIgnoreRetrainingMutationVariables>;

/**
 * __useUpdateAiIgnoreRetrainingMutation__
 *
 * To run a mutation, you first call `useUpdateAiIgnoreRetrainingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiIgnoreRetrainingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiIgnoreRetrainingMutation, { data, loading, error }] = useUpdateAiIgnoreRetrainingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateAiIgnoreRetrainingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiIgnoreRetrainingMutation, UpdateAiIgnoreRetrainingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiIgnoreRetrainingMutation, UpdateAiIgnoreRetrainingMutationVariables>(UpdateAiIgnoreRetrainingDocument, options);
      }
export type UpdateAiIgnoreRetrainingMutationHookResult = ReturnType<typeof useUpdateAiIgnoreRetrainingMutation>;
export type UpdateAiIgnoreRetrainingMutationResult = Apollo.MutationResult<UpdateAiIgnoreRetrainingMutation>;
export type UpdateAiIgnoreRetrainingMutationOptions = Apollo.BaseMutationOptions<UpdateAiIgnoreRetrainingMutation, UpdateAiIgnoreRetrainingMutationVariables>;
export const Update_Setting_Value_By_IdDocument = gql`
    mutation UPDATE_SETTING_VALUE_BY_ID($id: uuid, $reference_id: String, $reference_type_id: String, $setting_id: uuid, $value: jsonb, $is_template: Boolean) {
  update_setting_value(where: {id: {_eq: $id}, reference_id: {_eq: $reference_id}, reference_type_id: {_eq: $reference_type_id}, setting_id: {_eq: $setting_id}, is_template: {_eq: $is_template}}, _set: {value: $value}) {
    returning {
      id
      value
      display_name
    }
  }
}
    `;
export type Update_Setting_Value_By_IdMutationFn = Apollo.MutationFunction<Update_Setting_Value_By_IdMutation, Update_Setting_Value_By_IdMutationVariables>;

/**
 * __useUpdate_Setting_Value_By_IdMutation__
 *
 * To run a mutation, you first call `useUpdate_Setting_Value_By_IdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Setting_Value_By_IdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingValueByIdMutation, { data, loading, error }] = useUpdate_Setting_Value_By_IdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reference_id: // value for 'reference_id'
 *      reference_type_id: // value for 'reference_type_id'
 *      setting_id: // value for 'setting_id'
 *      value: // value for 'value'
 *      is_template: // value for 'is_template'
 *   },
 * });
 */
export function useUpdate_Setting_Value_By_IdMutation(baseOptions?: Apollo.MutationHookOptions<Update_Setting_Value_By_IdMutation, Update_Setting_Value_By_IdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Setting_Value_By_IdMutation, Update_Setting_Value_By_IdMutationVariables>(Update_Setting_Value_By_IdDocument, options);
      }
export type Update_Setting_Value_By_IdMutationHookResult = ReturnType<typeof useUpdate_Setting_Value_By_IdMutation>;
export type Update_Setting_Value_By_IdMutationResult = Apollo.MutationResult<Update_Setting_Value_By_IdMutation>;
export type Update_Setting_Value_By_IdMutationOptions = Apollo.BaseMutationOptions<Update_Setting_Value_By_IdMutation, Update_Setting_Value_By_IdMutationVariables>;
export const Update_Setting_ValueDocument = gql`
    mutation UPDATE_SETTING_VALUE($reference_id: String, $reference_type_id: String, $setting_id: uuid, $value: jsonb, $is_template: Boolean) {
  update_setting_value(where: {reference_id: {_eq: $reference_id}, reference_type_id: {_eq: $reference_type_id}, setting_id: {_eq: $setting_id}, is_template: {_eq: $is_template}}, _set: {value: $value}) {
    returning {
      id
      value
      display_name
    }
  }
}
    `;
export type Update_Setting_ValueMutationFn = Apollo.MutationFunction<Update_Setting_ValueMutation, Update_Setting_ValueMutationVariables>;

/**
 * __useUpdate_Setting_ValueMutation__
 *
 * To run a mutation, you first call `useUpdate_Setting_ValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Setting_ValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingValueMutation, { data, loading, error }] = useUpdate_Setting_ValueMutation({
 *   variables: {
 *      reference_id: // value for 'reference_id'
 *      reference_type_id: // value for 'reference_type_id'
 *      setting_id: // value for 'setting_id'
 *      value: // value for 'value'
 *      is_template: // value for 'is_template'
 *   },
 * });
 */
export function useUpdate_Setting_ValueMutation(baseOptions?: Apollo.MutationHookOptions<Update_Setting_ValueMutation, Update_Setting_ValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Setting_ValueMutation, Update_Setting_ValueMutationVariables>(Update_Setting_ValueDocument, options);
      }
export type Update_Setting_ValueMutationHookResult = ReturnType<typeof useUpdate_Setting_ValueMutation>;
export type Update_Setting_ValueMutationResult = Apollo.MutationResult<Update_Setting_ValueMutation>;
export type Update_Setting_ValueMutationOptions = Apollo.BaseMutationOptions<Update_Setting_ValueMutation, Update_Setting_ValueMutationVariables>;
export const Create_Setting_ValueDocument = gql`
    mutation CREATE_SETTING_VALUE($setting_value: [setting_value_insert_input!]!) {
  insert_setting_value(objects: $setting_value) {
    returning {
      id
      display_name
      value
    }
  }
}
    `;
export type Create_Setting_ValueMutationFn = Apollo.MutationFunction<Create_Setting_ValueMutation, Create_Setting_ValueMutationVariables>;

/**
 * __useCreate_Setting_ValueMutation__
 *
 * To run a mutation, you first call `useCreate_Setting_ValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreate_Setting_ValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSettingValueMutation, { data, loading, error }] = useCreate_Setting_ValueMutation({
 *   variables: {
 *      setting_value: // value for 'setting_value'
 *   },
 * });
 */
export function useCreate_Setting_ValueMutation(baseOptions?: Apollo.MutationHookOptions<Create_Setting_ValueMutation, Create_Setting_ValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Create_Setting_ValueMutation, Create_Setting_ValueMutationVariables>(Create_Setting_ValueDocument, options);
      }
export type Create_Setting_ValueMutationHookResult = ReturnType<typeof useCreate_Setting_ValueMutation>;
export type Create_Setting_ValueMutationResult = Apollo.MutationResult<Create_Setting_ValueMutation>;
export type Create_Setting_ValueMutationOptions = Apollo.BaseMutationOptions<Create_Setting_ValueMutation, Create_Setting_ValueMutationVariables>;
export const Delete_Setting_ValueDocument = gql`
    mutation DELETE_SETTING_VALUE($id: uuid!) {
  delete_setting_value(where: {id: {_eq: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type Delete_Setting_ValueMutationFn = Apollo.MutationFunction<Delete_Setting_ValueMutation, Delete_Setting_ValueMutationVariables>;

/**
 * __useDelete_Setting_ValueMutation__
 *
 * To run a mutation, you first call `useDelete_Setting_ValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Setting_ValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSettingValueMutation, { data, loading, error }] = useDelete_Setting_ValueMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_Setting_ValueMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Setting_ValueMutation, Delete_Setting_ValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Setting_ValueMutation, Delete_Setting_ValueMutationVariables>(Delete_Setting_ValueDocument, options);
      }
export type Delete_Setting_ValueMutationHookResult = ReturnType<typeof useDelete_Setting_ValueMutation>;
export type Delete_Setting_ValueMutationResult = Apollo.MutationResult<Delete_Setting_ValueMutation>;
export type Delete_Setting_ValueMutationOptions = Apollo.BaseMutationOptions<Delete_Setting_ValueMutation, Delete_Setting_ValueMutationVariables>;
export const Schedule_Doc_Annotation_ExportDocument = gql`
    mutation SCHEDULE_DOC_ANNOTATION_EXPORT($documentID: ID!) {
  scheduleDocAnnotationExport(id: $documentID)
}
    `;
export type Schedule_Doc_Annotation_ExportMutationFn = Apollo.MutationFunction<Schedule_Doc_Annotation_ExportMutation, Schedule_Doc_Annotation_ExportMutationVariables>;

/**
 * __useSchedule_Doc_Annotation_ExportMutation__
 *
 * To run a mutation, you first call `useSchedule_Doc_Annotation_ExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedule_Doc_Annotation_ExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleDocAnnotationExportMutation, { data, loading, error }] = useSchedule_Doc_Annotation_ExportMutation({
 *   variables: {
 *      documentID: // value for 'documentID'
 *   },
 * });
 */
export function useSchedule_Doc_Annotation_ExportMutation(baseOptions?: Apollo.MutationHookOptions<Schedule_Doc_Annotation_ExportMutation, Schedule_Doc_Annotation_ExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Schedule_Doc_Annotation_ExportMutation, Schedule_Doc_Annotation_ExportMutationVariables>(Schedule_Doc_Annotation_ExportDocument, options);
      }
export type Schedule_Doc_Annotation_ExportMutationHookResult = ReturnType<typeof useSchedule_Doc_Annotation_ExportMutation>;
export type Schedule_Doc_Annotation_ExportMutationResult = Apollo.MutationResult<Schedule_Doc_Annotation_ExportMutation>;
export type Schedule_Doc_Annotation_ExportMutationOptions = Apollo.BaseMutationOptions<Schedule_Doc_Annotation_ExportMutation, Schedule_Doc_Annotation_ExportMutationVariables>;
export const Finish_ValidationDocument = gql`
    mutation FINISH_VALIDATION($id: ID!) {
  finishDocumentValidation(docId: $id)
}
    `;
export type Finish_ValidationMutationFn = Apollo.MutationFunction<Finish_ValidationMutation, Finish_ValidationMutationVariables>;

/**
 * __useFinish_ValidationMutation__
 *
 * To run a mutation, you first call `useFinish_ValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinish_ValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishValidationMutation, { data, loading, error }] = useFinish_ValidationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinish_ValidationMutation(baseOptions?: Apollo.MutationHookOptions<Finish_ValidationMutation, Finish_ValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Finish_ValidationMutation, Finish_ValidationMutationVariables>(Finish_ValidationDocument, options);
      }
export type Finish_ValidationMutationHookResult = ReturnType<typeof useFinish_ValidationMutation>;
export type Finish_ValidationMutationResult = Apollo.MutationResult<Finish_ValidationMutation>;
export type Finish_ValidationMutationOptions = Apollo.BaseMutationOptions<Finish_ValidationMutation, Finish_ValidationMutationVariables>;
export const Add_Measure_TimeDocument = gql`
    mutation ADD_MEASURE_TIME($id: uuid!, $document_type: String!, $meta: jsonb!) {
  update_document_by_pk(pk_columns: {document_type: $document_type, id: $id}, _append: {meta: $meta}) {
    id
  }
}
    `;
export type Add_Measure_TimeMutationFn = Apollo.MutationFunction<Add_Measure_TimeMutation, Add_Measure_TimeMutationVariables>;

/**
 * __useAdd_Measure_TimeMutation__
 *
 * To run a mutation, you first call `useAdd_Measure_TimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdd_Measure_TimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMeasureTimeMutation, { data, loading, error }] = useAdd_Measure_TimeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      document_type: // value for 'document_type'
 *      meta: // value for 'meta'
 *   },
 * });
 */
export function useAdd_Measure_TimeMutation(baseOptions?: Apollo.MutationHookOptions<Add_Measure_TimeMutation, Add_Measure_TimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Add_Measure_TimeMutation, Add_Measure_TimeMutationVariables>(Add_Measure_TimeDocument, options);
      }
export type Add_Measure_TimeMutationHookResult = ReturnType<typeof useAdd_Measure_TimeMutation>;
export type Add_Measure_TimeMutationResult = Apollo.MutationResult<Add_Measure_TimeMutation>;
export type Add_Measure_TimeMutationOptions = Apollo.BaseMutationOptions<Add_Measure_TimeMutation, Add_Measure_TimeMutationVariables>;
export const GetUsersOrgIdsDocument = gql`
    query getUsersOrgIds($userId: _uuid) {
  orgIds: pp_user_org_id(args: {_uids: $userId}) {
    org_id
    orgId {
      org_id
      org_id_description
      active
    }
  }
}
    `;

/**
 * __useGetUsersOrgIdsQuery__
 *
 * To run a query within a React component, call `useGetUsersOrgIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersOrgIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersOrgIdsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUsersOrgIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersOrgIdsQuery, GetUsersOrgIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersOrgIdsQuery, GetUsersOrgIdsQueryVariables>(GetUsersOrgIdsDocument, options);
      }
export function useGetUsersOrgIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersOrgIdsQuery, GetUsersOrgIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersOrgIdsQuery, GetUsersOrgIdsQueryVariables>(GetUsersOrgIdsDocument, options);
        }
export type GetUsersOrgIdsQueryHookResult = ReturnType<typeof useGetUsersOrgIdsQuery>;
export type GetUsersOrgIdsLazyQueryHookResult = ReturnType<typeof useGetUsersOrgIdsLazyQuery>;
export type GetUsersOrgIdsQueryResult = Apollo.QueryResult<GetUsersOrgIdsQuery, GetUsersOrgIdsQueryVariables>;
export const Get_Documents_By_ChecksumDocument = gql`
    query GET_DOCUMENTS_BY_CHECKSUM($checksums: [String!]!) {
  documents: document(where: {_and: [{checksum: {_in: $checksums}}, {document_type: {_eq: "unknown"}}]}) {
    id
    document_name
    checksum
  }
}
    `;

/**
 * __useGet_Documents_By_ChecksumQuery__
 *
 * To run a query within a React component, call `useGet_Documents_By_ChecksumQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Documents_By_ChecksumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Documents_By_ChecksumQuery({
 *   variables: {
 *      checksums: // value for 'checksums'
 *   },
 * });
 */
export function useGet_Documents_By_ChecksumQuery(baseOptions: Apollo.QueryHookOptions<Get_Documents_By_ChecksumQuery, Get_Documents_By_ChecksumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Documents_By_ChecksumQuery, Get_Documents_By_ChecksumQueryVariables>(Get_Documents_By_ChecksumDocument, options);
      }
export function useGet_Documents_By_ChecksumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Documents_By_ChecksumQuery, Get_Documents_By_ChecksumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Documents_By_ChecksumQuery, Get_Documents_By_ChecksumQueryVariables>(Get_Documents_By_ChecksumDocument, options);
        }
export type Get_Documents_By_ChecksumQueryHookResult = ReturnType<typeof useGet_Documents_By_ChecksumQuery>;
export type Get_Documents_By_ChecksumLazyQueryHookResult = ReturnType<typeof useGet_Documents_By_ChecksumLazyQuery>;
export type Get_Documents_By_ChecksumQueryResult = Apollo.QueryResult<Get_Documents_By_ChecksumQuery, Get_Documents_By_ChecksumQueryVariables>;
export const Get_Doc_AnnotationDocument = gql`
    query GET_DOC_ANNOTATION($docId: uuid!, $annoTypeId: smallint!) {
  doc_annotation(where: {doc_id: {_eq: $docId}, anno_type_id: {_eq: $annoTypeId}}) {
    anno_type_id
    doc_id
    value
  }
}
    `;

/**
 * __useGet_Doc_AnnotationQuery__
 *
 * To run a query within a React component, call `useGet_Doc_AnnotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Doc_AnnotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Doc_AnnotationQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *      annoTypeId: // value for 'annoTypeId'
 *   },
 * });
 */
export function useGet_Doc_AnnotationQuery(baseOptions: Apollo.QueryHookOptions<Get_Doc_AnnotationQuery, Get_Doc_AnnotationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Doc_AnnotationQuery, Get_Doc_AnnotationQueryVariables>(Get_Doc_AnnotationDocument, options);
      }
export function useGet_Doc_AnnotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Doc_AnnotationQuery, Get_Doc_AnnotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Doc_AnnotationQuery, Get_Doc_AnnotationQueryVariables>(Get_Doc_AnnotationDocument, options);
        }
export type Get_Doc_AnnotationQueryHookResult = ReturnType<typeof useGet_Doc_AnnotationQuery>;
export type Get_Doc_AnnotationLazyQueryHookResult = ReturnType<typeof useGet_Doc_AnnotationLazyQuery>;
export type Get_Doc_AnnotationQueryResult = Apollo.QueryResult<Get_Doc_AnnotationQuery, Get_Doc_AnnotationQueryVariables>;
export const Get_Annotation_TypeDocument = gql`
    query GET_ANNOTATION_TYPE($annotationProviderId: smallint!, $documentType: String!) {
  annotation_type(where: {annotation_provider_id: {_eq: $annotationProviderId}, document_type: {_eq: $documentType}}) {
    anno_type_id
    anno_schema
    ui_schema
  }
}
    `;

/**
 * __useGet_Annotation_TypeQuery__
 *
 * To run a query within a React component, call `useGet_Annotation_TypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Annotation_TypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Annotation_TypeQuery({
 *   variables: {
 *      annotationProviderId: // value for 'annotationProviderId'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useGet_Annotation_TypeQuery(baseOptions: Apollo.QueryHookOptions<Get_Annotation_TypeQuery, Get_Annotation_TypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Annotation_TypeQuery, Get_Annotation_TypeQueryVariables>(Get_Annotation_TypeDocument, options);
      }
export function useGet_Annotation_TypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Annotation_TypeQuery, Get_Annotation_TypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Annotation_TypeQuery, Get_Annotation_TypeQueryVariables>(Get_Annotation_TypeDocument, options);
        }
export type Get_Annotation_TypeQueryHookResult = ReturnType<typeof useGet_Annotation_TypeQuery>;
export type Get_Annotation_TypeLazyQueryHookResult = ReturnType<typeof useGet_Annotation_TypeLazyQuery>;
export type Get_Annotation_TypeQueryResult = Apollo.QueryResult<Get_Annotation_TypeQuery, Get_Annotation_TypeQueryVariables>;
export const Next_Invalidate_DocumentDocument = gql`
    query NEXT_INVALIDATE_DOCUMENT($orgs: _int2, $docId: uuid) {
  pp_docs_for_validation(args: {_doc_id: $docId, _org_ids: $orgs}) {
    id
    document_flags
    document_type
    org_id
    doc_order
  }
}
    `;

/**
 * __useNext_Invalidate_DocumentQuery__
 *
 * To run a query within a React component, call `useNext_Invalidate_DocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useNext_Invalidate_DocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNext_Invalidate_DocumentQuery({
 *   variables: {
 *      orgs: // value for 'orgs'
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useNext_Invalidate_DocumentQuery(baseOptions?: Apollo.QueryHookOptions<Next_Invalidate_DocumentQuery, Next_Invalidate_DocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Next_Invalidate_DocumentQuery, Next_Invalidate_DocumentQueryVariables>(Next_Invalidate_DocumentDocument, options);
      }
export function useNext_Invalidate_DocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Next_Invalidate_DocumentQuery, Next_Invalidate_DocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Next_Invalidate_DocumentQuery, Next_Invalidate_DocumentQueryVariables>(Next_Invalidate_DocumentDocument, options);
        }
export type Next_Invalidate_DocumentQueryHookResult = ReturnType<typeof useNext_Invalidate_DocumentQuery>;
export type Next_Invalidate_DocumentLazyQueryHookResult = ReturnType<typeof useNext_Invalidate_DocumentLazyQuery>;
export type Next_Invalidate_DocumentQueryResult = Apollo.QueryResult<Next_Invalidate_DocumentQuery, Next_Invalidate_DocumentQueryVariables>;
export const Get_Document_LabelsDocument = gql`
    query GET_DOCUMENT_LABELS($ids: _int4, $tenantId: uuid!) {
  document_labels: pp_document_labels(args: {_ids: $ids}, where: {is_deleted: {_eq: false}, tenantId: {_eq: $tenantId}}, order_by: {id: asc}) {
    id
    title
    description
    color
  }
}
    `;

/**
 * __useGet_Document_LabelsQuery__
 *
 * To run a query within a React component, call `useGet_Document_LabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Document_LabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Document_LabelsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGet_Document_LabelsQuery(baseOptions: Apollo.QueryHookOptions<Get_Document_LabelsQuery, Get_Document_LabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Document_LabelsQuery, Get_Document_LabelsQueryVariables>(Get_Document_LabelsDocument, options);
      }
export function useGet_Document_LabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Document_LabelsQuery, Get_Document_LabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Document_LabelsQuery, Get_Document_LabelsQueryVariables>(Get_Document_LabelsDocument, options);
        }
export type Get_Document_LabelsQueryHookResult = ReturnType<typeof useGet_Document_LabelsQuery>;
export type Get_Document_LabelsLazyQueryHookResult = ReturnType<typeof useGet_Document_LabelsLazyQuery>;
export type Get_Document_LabelsQueryResult = Apollo.QueryResult<Get_Document_LabelsQuery, Get_Document_LabelsQueryVariables>;
export const Get_Document_Labels_By_OrgsDocument = gql`
    query GET_DOCUMENT_LABELS_BY_ORGS($ids: [Int!], $tenantId: uuid!, $orgIds: [smallint!]!) {
  document_labels(where: {id: {_in: $ids}, is_deleted: {_eq: false}, tenantId: {_eq: $tenantId}, document_label_org_ids: {org_id: {_in: $orgIds}}}, order_by: {id: asc}) {
    id
    title
    description
    color
  }
}
    `;

/**
 * __useGet_Document_Labels_By_OrgsQuery__
 *
 * To run a query within a React component, call `useGet_Document_Labels_By_OrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Document_Labels_By_OrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Document_Labels_By_OrgsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      tenantId: // value for 'tenantId'
 *      orgIds: // value for 'orgIds'
 *   },
 * });
 */
export function useGet_Document_Labels_By_OrgsQuery(baseOptions: Apollo.QueryHookOptions<Get_Document_Labels_By_OrgsQuery, Get_Document_Labels_By_OrgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Document_Labels_By_OrgsQuery, Get_Document_Labels_By_OrgsQueryVariables>(Get_Document_Labels_By_OrgsDocument, options);
      }
export function useGet_Document_Labels_By_OrgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Document_Labels_By_OrgsQuery, Get_Document_Labels_By_OrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Document_Labels_By_OrgsQuery, Get_Document_Labels_By_OrgsQueryVariables>(Get_Document_Labels_By_OrgsDocument, options);
        }
export type Get_Document_Labels_By_OrgsQueryHookResult = ReturnType<typeof useGet_Document_Labels_By_OrgsQuery>;
export type Get_Document_Labels_By_OrgsLazyQueryHookResult = ReturnType<typeof useGet_Document_Labels_By_OrgsLazyQuery>;
export type Get_Document_Labels_By_OrgsQueryResult = Apollo.QueryResult<Get_Document_Labels_By_OrgsQuery, Get_Document_Labels_By_OrgsQueryVariables>;
export const CheckFileStatusDocument = gql`
    query checkFileStatus($fileNumber: String!) {
  file(where: {identification: {_eq: $fileNumber}}) {
    id
    file_status
    identification
    file_flags
  }
}
    `;

/**
 * __useCheckFileStatusQuery__
 *
 * To run a query within a React component, call `useCheckFileStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckFileStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckFileStatusQuery({
 *   variables: {
 *      fileNumber: // value for 'fileNumber'
 *   },
 * });
 */
export function useCheckFileStatusQuery(baseOptions: Apollo.QueryHookOptions<CheckFileStatusQuery, CheckFileStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckFileStatusQuery, CheckFileStatusQueryVariables>(CheckFileStatusDocument, options);
      }
export function useCheckFileStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckFileStatusQuery, CheckFileStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckFileStatusQuery, CheckFileStatusQueryVariables>(CheckFileStatusDocument, options);
        }
export type CheckFileStatusQueryHookResult = ReturnType<typeof useCheckFileStatusQuery>;
export type CheckFileStatusLazyQueryHookResult = ReturnType<typeof useCheckFileStatusLazyQuery>;
export type CheckFileStatusQueryResult = Apollo.QueryResult<CheckFileStatusQuery, CheckFileStatusQueryVariables>;
export const Pp_Page_Extract_Text_Fragment_V2Document = gql`
    query pp_page_extract_text_fragment_v2($pageId: uuid!, $x: numeric!, $y: numeric!, $width: numeric!, $height: numeric!, $extract_type_id: smallint!) {
  pp_page_extract_text_fragment_v2(args: {_pageid: $pageId, _x: $x, _y: $y, _width: $width, _height: $height, _extract_type_id: $extract_type_id}) {
    json_value
  }
}
    `;

/**
 * __usePp_Page_Extract_Text_Fragment_V2Query__
 *
 * To run a query within a React component, call `usePp_Page_Extract_Text_Fragment_V2Query` and pass it any options that fit your needs.
 * When your component renders, `usePp_Page_Extract_Text_Fragment_V2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePp_Page_Extract_Text_Fragment_V2Query({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      x: // value for 'x'
 *      y: // value for 'y'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *      extract_type_id: // value for 'extract_type_id'
 *   },
 * });
 */
export function usePp_Page_Extract_Text_Fragment_V2Query(baseOptions: Apollo.QueryHookOptions<Pp_Page_Extract_Text_Fragment_V2Query, Pp_Page_Extract_Text_Fragment_V2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pp_Page_Extract_Text_Fragment_V2Query, Pp_Page_Extract_Text_Fragment_V2QueryVariables>(Pp_Page_Extract_Text_Fragment_V2Document, options);
      }
export function usePp_Page_Extract_Text_Fragment_V2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pp_Page_Extract_Text_Fragment_V2Query, Pp_Page_Extract_Text_Fragment_V2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pp_Page_Extract_Text_Fragment_V2Query, Pp_Page_Extract_Text_Fragment_V2QueryVariables>(Pp_Page_Extract_Text_Fragment_V2Document, options);
        }
export type Pp_Page_Extract_Text_Fragment_V2QueryHookResult = ReturnType<typeof usePp_Page_Extract_Text_Fragment_V2Query>;
export type Pp_Page_Extract_Text_Fragment_V2LazyQueryHookResult = ReturnType<typeof usePp_Page_Extract_Text_Fragment_V2LazyQuery>;
export type Pp_Page_Extract_Text_Fragment_V2QueryResult = Apollo.QueryResult<Pp_Page_Extract_Text_Fragment_V2Query, Pp_Page_Extract_Text_Fragment_V2QueryVariables>;
export const Pp_Page_Extract_Grids_TextDocument = gql`
    query pp_page_extract_grids_text($pageId: uuid!, $cellCoordinates: jsonb!, $extractTypeId: smallint!) {
  pp_page_extract_grids_text(args: {_page_id: $pageId, _coordinates: $cellCoordinates, _extract_type_id: $extractTypeId}) {
    json_value
  }
}
    `;

/**
 * __usePp_Page_Extract_Grids_TextQuery__
 *
 * To run a query within a React component, call `usePp_Page_Extract_Grids_TextQuery` and pass it any options that fit your needs.
 * When your component renders, `usePp_Page_Extract_Grids_TextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePp_Page_Extract_Grids_TextQuery({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      cellCoordinates: // value for 'cellCoordinates'
 *      extractTypeId: // value for 'extractTypeId'
 *   },
 * });
 */
export function usePp_Page_Extract_Grids_TextQuery(baseOptions: Apollo.QueryHookOptions<Pp_Page_Extract_Grids_TextQuery, Pp_Page_Extract_Grids_TextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pp_Page_Extract_Grids_TextQuery, Pp_Page_Extract_Grids_TextQueryVariables>(Pp_Page_Extract_Grids_TextDocument, options);
      }
export function usePp_Page_Extract_Grids_TextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pp_Page_Extract_Grids_TextQuery, Pp_Page_Extract_Grids_TextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pp_Page_Extract_Grids_TextQuery, Pp_Page_Extract_Grids_TextQueryVariables>(Pp_Page_Extract_Grids_TextDocument, options);
        }
export type Pp_Page_Extract_Grids_TextQueryHookResult = ReturnType<typeof usePp_Page_Extract_Grids_TextQuery>;
export type Pp_Page_Extract_Grids_TextLazyQueryHookResult = ReturnType<typeof usePp_Page_Extract_Grids_TextLazyQuery>;
export type Pp_Page_Extract_Grids_TextQueryResult = Apollo.QueryResult<Pp_Page_Extract_Grids_TextQuery, Pp_Page_Extract_Grids_TextQueryVariables>;
export const GetDeclarationsDocument = gql`
    query GetDeclarations {
  declaration(where: {ai_confirmed: {_eq: true}}) {
    file_id
    dr_no
    ai_confirmed
    declaration_request {
      payer {
        tenant_name
      }
      declaration_request_addresses(where: {address_type: {_eq: 3}}) {
        address {
          company_name
        }
      }
      documents(where: {document_type: {_neq: "unknown"}}) {
        id
        document_type
        pages_m2m {
          page {
            thumbnail_big_url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDeclarationsQuery__
 *
 * To run a query within a React component, call `useGetDeclarationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeclarationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeclarationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDeclarationsQuery(baseOptions?: Apollo.QueryHookOptions<GetDeclarationsQuery, GetDeclarationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeclarationsQuery, GetDeclarationsQueryVariables>(GetDeclarationsDocument, options);
      }
export function useGetDeclarationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeclarationsQuery, GetDeclarationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeclarationsQuery, GetDeclarationsQueryVariables>(GetDeclarationsDocument, options);
        }
export type GetDeclarationsQueryHookResult = ReturnType<typeof useGetDeclarationsQuery>;
export type GetDeclarationsLazyQueryHookResult = ReturnType<typeof useGetDeclarationsLazyQuery>;
export type GetDeclarationsQueryResult = Apollo.QueryResult<GetDeclarationsQuery, GetDeclarationsQueryVariables>;
export const Adit_MarkDocumentAsTemplateDocument = gql`
    mutation ADIT_markDocumentAsTemplate($id: ID!, $isTemplate: Boolean) {
  markDocumentAsTemplate(docId: $id, isTemplate: $isTemplate)
}
    `;
export type Adit_MarkDocumentAsTemplateMutationFn = Apollo.MutationFunction<Adit_MarkDocumentAsTemplateMutation, Adit_MarkDocumentAsTemplateMutationVariables>;

/**
 * __useAdit_MarkDocumentAsTemplateMutation__
 *
 * To run a mutation, you first call `useAdit_MarkDocumentAsTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_MarkDocumentAsTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditMarkDocumentAsTemplateMutation, { data, loading, error }] = useAdit_MarkDocumentAsTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isTemplate: // value for 'isTemplate'
 *   },
 * });
 */
export function useAdit_MarkDocumentAsTemplateMutation(baseOptions?: Apollo.MutationHookOptions<Adit_MarkDocumentAsTemplateMutation, Adit_MarkDocumentAsTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_MarkDocumentAsTemplateMutation, Adit_MarkDocumentAsTemplateMutationVariables>(Adit_MarkDocumentAsTemplateDocument, options);
      }
export type Adit_MarkDocumentAsTemplateMutationHookResult = ReturnType<typeof useAdit_MarkDocumentAsTemplateMutation>;
export type Adit_MarkDocumentAsTemplateMutationResult = Apollo.MutationResult<Adit_MarkDocumentAsTemplateMutation>;
export type Adit_MarkDocumentAsTemplateMutationOptions = Apollo.BaseMutationOptions<Adit_MarkDocumentAsTemplateMutation, Adit_MarkDocumentAsTemplateMutationVariables>;
export const Adit_ScheduleTableCalculationDocument = gql`
    mutation ADIT_scheduleTableCalculation($id: ID!) {
  scheduleTableCalculation(docId: $id)
}
    `;
export type Adit_ScheduleTableCalculationMutationFn = Apollo.MutationFunction<Adit_ScheduleTableCalculationMutation, Adit_ScheduleTableCalculationMutationVariables>;

/**
 * __useAdit_ScheduleTableCalculationMutation__
 *
 * To run a mutation, you first call `useAdit_ScheduleTableCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_ScheduleTableCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditScheduleTableCalculationMutation, { data, loading, error }] = useAdit_ScheduleTableCalculationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdit_ScheduleTableCalculationMutation(baseOptions?: Apollo.MutationHookOptions<Adit_ScheduleTableCalculationMutation, Adit_ScheduleTableCalculationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_ScheduleTableCalculationMutation, Adit_ScheduleTableCalculationMutationVariables>(Adit_ScheduleTableCalculationDocument, options);
      }
export type Adit_ScheduleTableCalculationMutationHookResult = ReturnType<typeof useAdit_ScheduleTableCalculationMutation>;
export type Adit_ScheduleTableCalculationMutationResult = Apollo.MutationResult<Adit_ScheduleTableCalculationMutation>;
export type Adit_ScheduleTableCalculationMutationOptions = Apollo.BaseMutationOptions<Adit_ScheduleTableCalculationMutation, Adit_ScheduleTableCalculationMutationVariables>;
export const AditGetDeclarationsListDocument = gql`
    query AditGetDeclarationsList($_like: String) {
  declarations: declaration_request(where: {file: {identification: {_is_null: false, _ilike: $_like}}}) {
    file_id
    dr_no
    file {
      identification
    }
  }
}
    `;

/**
 * __useAditGetDeclarationsListQuery__
 *
 * To run a query within a React component, call `useAditGetDeclarationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationsListQuery({
 *   variables: {
 *      _like: // value for '_like'
 *   },
 * });
 */
export function useAditGetDeclarationsListQuery(baseOptions?: Apollo.QueryHookOptions<AditGetDeclarationsListQuery, AditGetDeclarationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetDeclarationsListQuery, AditGetDeclarationsListQueryVariables>(AditGetDeclarationsListDocument, options);
      }
export function useAditGetDeclarationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetDeclarationsListQuery, AditGetDeclarationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetDeclarationsListQuery, AditGetDeclarationsListQueryVariables>(AditGetDeclarationsListDocument, options);
        }
export type AditGetDeclarationsListQueryHookResult = ReturnType<typeof useAditGetDeclarationsListQuery>;
export type AditGetDeclarationsListLazyQueryHookResult = ReturnType<typeof useAditGetDeclarationsListLazyQuery>;
export type AditGetDeclarationsListQueryResult = Apollo.QueryResult<AditGetDeclarationsListQuery, AditGetDeclarationsListQueryVariables>;
export const AditCopyDeclarationAndGoodsItemsDocument = gql`
    mutation AditCopyDeclarationAndGoodsItems($sourceFileId: String!, $sourceDrNo: Int!, $targetFileId: String!, $targetDrNo: Int!) {
  copyDeclarationAndGoodsItems(copyDeclarationInput: {sourceFileId: $sourceFileId, sourceDrNo: $sourceDrNo, targetFileId: $targetFileId, targetDrNo: $targetDrNo})
}
    `;
export type AditCopyDeclarationAndGoodsItemsMutationFn = Apollo.MutationFunction<AditCopyDeclarationAndGoodsItemsMutation, AditCopyDeclarationAndGoodsItemsMutationVariables>;

/**
 * __useAditCopyDeclarationAndGoodsItemsMutation__
 *
 * To run a mutation, you first call `useAditCopyDeclarationAndGoodsItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditCopyDeclarationAndGoodsItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditCopyDeclarationAndGoodsItemsMutation, { data, loading, error }] = useAditCopyDeclarationAndGoodsItemsMutation({
 *   variables: {
 *      sourceFileId: // value for 'sourceFileId'
 *      sourceDrNo: // value for 'sourceDrNo'
 *      targetFileId: // value for 'targetFileId'
 *      targetDrNo: // value for 'targetDrNo'
 *   },
 * });
 */
export function useAditCopyDeclarationAndGoodsItemsMutation(baseOptions?: Apollo.MutationHookOptions<AditCopyDeclarationAndGoodsItemsMutation, AditCopyDeclarationAndGoodsItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditCopyDeclarationAndGoodsItemsMutation, AditCopyDeclarationAndGoodsItemsMutationVariables>(AditCopyDeclarationAndGoodsItemsDocument, options);
      }
export type AditCopyDeclarationAndGoodsItemsMutationHookResult = ReturnType<typeof useAditCopyDeclarationAndGoodsItemsMutation>;
export type AditCopyDeclarationAndGoodsItemsMutationResult = Apollo.MutationResult<AditCopyDeclarationAndGoodsItemsMutation>;
export type AditCopyDeclarationAndGoodsItemsMutationOptions = Apollo.BaseMutationOptions<AditCopyDeclarationAndGoodsItemsMutation, AditCopyDeclarationAndGoodsItemsMutationVariables>;
export const AditGetDeclarationDocumentsTableDocument = gql`
    query AditGetDeclarationDocumentsTable($fileId: UUID, $documentStatus: [DocumentStatus!]) {
  documents: getFileDocuments(fileId: $fileId, documentStatus: $documentStatus) {
    pages {
      creationDate
      creationUser
      id
      lastModifiedDate
      lastModifiedUser
      meta
      ocrText
      pageNumber
      pageStatus
      rotate
      thumbnailBigUrl
      thumbnailSmallUrl
    }
    blobs {
      url
      initial
      extension
    }
    creationUser
    documentExtension
    documentFlags
    documentName
    documentStatus
    documentType
    documentTypeTranslations
    id
    lastModifiedDate
    meta
    sequence
  }
}
    `;

/**
 * __useAditGetDeclarationDocumentsTableQuery__
 *
 * To run a query within a React component, call `useAditGetDeclarationDocumentsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationDocumentsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationDocumentsTableQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      documentStatus: // value for 'documentStatus'
 *   },
 * });
 */
export function useAditGetDeclarationDocumentsTableQuery(baseOptions?: Apollo.QueryHookOptions<AditGetDeclarationDocumentsTableQuery, AditGetDeclarationDocumentsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetDeclarationDocumentsTableQuery, AditGetDeclarationDocumentsTableQueryVariables>(AditGetDeclarationDocumentsTableDocument, options);
      }
export function useAditGetDeclarationDocumentsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetDeclarationDocumentsTableQuery, AditGetDeclarationDocumentsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetDeclarationDocumentsTableQuery, AditGetDeclarationDocumentsTableQueryVariables>(AditGetDeclarationDocumentsTableDocument, options);
        }
export type AditGetDeclarationDocumentsTableQueryHookResult = ReturnType<typeof useAditGetDeclarationDocumentsTableQuery>;
export type AditGetDeclarationDocumentsTableLazyQueryHookResult = ReturnType<typeof useAditGetDeclarationDocumentsTableLazyQuery>;
export type AditGetDeclarationDocumentsTableQueryResult = Apollo.QueryResult<AditGetDeclarationDocumentsTableQuery, AditGetDeclarationDocumentsTableQueryVariables>;
export const AditGetDeclarationTableDiscussionsDocument = gql`
    subscription AditGetDeclarationTableDiscussions($fileIds: [uuid!]!) {
  declarationsDiscussions: declaration_discussion(where: {file_id: {_in: $fileIds}}) {
    file_id
    messages: declaration_messages_aggregate(where: {read_date: {_is_null: true}, user: {tenant_id: {_neq: "b4b61b73-4f38-45a0-b460-7e38b2777479"}}}) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useAditGetDeclarationTableDiscussionsSubscription__
 *
 * To run a query within a React component, call `useAditGetDeclarationTableDiscussionsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationTableDiscussionsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationTableDiscussionsSubscription({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useAditGetDeclarationTableDiscussionsSubscription(baseOptions: Apollo.SubscriptionHookOptions<AditGetDeclarationTableDiscussionsSubscription, AditGetDeclarationTableDiscussionsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AditGetDeclarationTableDiscussionsSubscription, AditGetDeclarationTableDiscussionsSubscriptionVariables>(AditGetDeclarationTableDiscussionsDocument, options);
      }
export type AditGetDeclarationTableDiscussionsSubscriptionHookResult = ReturnType<typeof useAditGetDeclarationTableDiscussionsSubscription>;
export type AditGetDeclarationTableDiscussionsSubscriptionResult = Apollo.SubscriptionResult<AditGetDeclarationTableDiscussionsSubscription>;
export const AditGetDeclarationsTableDocument = gql`
    query AditGetDeclarationsTable($nonclassifiedDocsExists: Boolean, $limit: Int, $offset: Int, $orderBy: [JSONObject!], $declarationStatus: [DeclarationStatus!], $search: String, $addresses: [AddressFilter!], $dateMin: LocalDateTime, $dateMax: LocalDateTime, $maxTotalColis: Int, $maxTotalGrossWeight: Float, $minTotalColis: Int, $minTotalGrossWeight: Float, $orgIds: [Int!]) {
  declarations: getDeclarationRequestsAdit(nonclassifiedDocsExists: $nonclassifiedDocsExists, limit: $limit, offset: $offset, orderBy: $orderBy, declarationStatus: $declarationStatus, search: $search, addresses: $addresses, dateMin: $dateMin, dateMax: $dateMax, maxTotalColis: $maxTotalColis, maxTotalGrossWeight: $maxTotalGrossWeight, minTotalColis: $minTotalColis, minTotalGrossWeight: $minTotalGrossWeight, orgIds: $orgIds) {
    consigneeName
    autoclassifiedDocsQty
    consigneeRef
    consignorName
    consignorRef
    creationDate
    creationUser
    customsOfficeNumber
    declarationStatus
    drNo
    evvReceived
    fileId
    identification
    importerRef
    messageCount
    nonclassifiedDocsExists
    payerName
    payerRef
    totalColis
    totalGrossWeight
    discussionId
    orgId
    addressReferences
  }
}
    `;

/**
 * __useAditGetDeclarationsTableQuery__
 *
 * To run a query within a React component, call `useAditGetDeclarationsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationsTableQuery({
 *   variables: {
 *      nonclassifiedDocsExists: // value for 'nonclassifiedDocsExists'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      declarationStatus: // value for 'declarationStatus'
 *      search: // value for 'search'
 *      addresses: // value for 'addresses'
 *      dateMin: // value for 'dateMin'
 *      dateMax: // value for 'dateMax'
 *      maxTotalColis: // value for 'maxTotalColis'
 *      maxTotalGrossWeight: // value for 'maxTotalGrossWeight'
 *      minTotalColis: // value for 'minTotalColis'
 *      minTotalGrossWeight: // value for 'minTotalGrossWeight'
 *      orgIds: // value for 'orgIds'
 *   },
 * });
 */
export function useAditGetDeclarationsTableQuery(baseOptions?: Apollo.QueryHookOptions<AditGetDeclarationsTableQuery, AditGetDeclarationsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetDeclarationsTableQuery, AditGetDeclarationsTableQueryVariables>(AditGetDeclarationsTableDocument, options);
      }
export function useAditGetDeclarationsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetDeclarationsTableQuery, AditGetDeclarationsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetDeclarationsTableQuery, AditGetDeclarationsTableQueryVariables>(AditGetDeclarationsTableDocument, options);
        }
export type AditGetDeclarationsTableQueryHookResult = ReturnType<typeof useAditGetDeclarationsTableQuery>;
export type AditGetDeclarationsTableLazyQueryHookResult = ReturnType<typeof useAditGetDeclarationsTableLazyQuery>;
export type AditGetDeclarationsTableQueryResult = Apollo.QueryResult<AditGetDeclarationsTableQuery, AditGetDeclarationsTableQueryVariables>;
export const AditUpdatePasswordDocument = gql`
    mutation AditUpdatePassword($updatePasswordInput: UpdatePasswordDto!) {
  updatePassword(updatePasswordInput: $updatePasswordInput)
}
    `;
export type AditUpdatePasswordMutationFn = Apollo.MutationFunction<AditUpdatePasswordMutation, AditUpdatePasswordMutationVariables>;

/**
 * __useAditUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useAditUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdatePasswordMutation, { data, loading, error }] = useAditUpdatePasswordMutation({
 *   variables: {
 *      updatePasswordInput: // value for 'updatePasswordInput'
 *   },
 * });
 */
export function useAditUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<AditUpdatePasswordMutation, AditUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpdatePasswordMutation, AditUpdatePasswordMutationVariables>(AditUpdatePasswordDocument, options);
      }
export type AditUpdatePasswordMutationHookResult = ReturnType<typeof useAditUpdatePasswordMutation>;
export type AditUpdatePasswordMutationResult = Apollo.MutationResult<AditUpdatePasswordMutation>;
export type AditUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<AditUpdatePasswordMutation, AditUpdatePasswordMutationVariables>;
export const AditGetAiConfirmedDeclarationsDocument = gql`
    query AditGetAiConfirmedDeclarations {
  declarations: declaration(where: {ai_confirmed: {_eq: true}}) {
    file_id
    dr_no
    ai_confirmed
    file {
      identification
    }
    declaration_request {
      payer {
        tenant_name
      }
      declaration_request_addresses(where: {address_type: {_eq: 3}}) {
        address {
          company_name
        }
      }
      documents(where: {document_type: {_neq: "unknown"}}) {
        id
        document_type
        document_extension
        pages_m2m {
          page_number
          page {
            id
            thumbnail_big_url
            ai_ignore_retraining
            rotate
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAditGetAiConfirmedDeclarationsQuery__
 *
 * To run a query within a React component, call `useAditGetAiConfirmedDeclarationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetAiConfirmedDeclarationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetAiConfirmedDeclarationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAditGetAiConfirmedDeclarationsQuery(baseOptions?: Apollo.QueryHookOptions<AditGetAiConfirmedDeclarationsQuery, AditGetAiConfirmedDeclarationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetAiConfirmedDeclarationsQuery, AditGetAiConfirmedDeclarationsQueryVariables>(AditGetAiConfirmedDeclarationsDocument, options);
      }
export function useAditGetAiConfirmedDeclarationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetAiConfirmedDeclarationsQuery, AditGetAiConfirmedDeclarationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetAiConfirmedDeclarationsQuery, AditGetAiConfirmedDeclarationsQueryVariables>(AditGetAiConfirmedDeclarationsDocument, options);
        }
export type AditGetAiConfirmedDeclarationsQueryHookResult = ReturnType<typeof useAditGetAiConfirmedDeclarationsQuery>;
export type AditGetAiConfirmedDeclarationsLazyQueryHookResult = ReturnType<typeof useAditGetAiConfirmedDeclarationsLazyQuery>;
export type AditGetAiConfirmedDeclarationsQueryResult = Apollo.QueryResult<AditGetAiConfirmedDeclarationsQuery, AditGetAiConfirmedDeclarationsQueryVariables>;
export const AditGetModelRetrainsDocument = gql`
    query AditGetModelRetrains {
  model_retrains: model_retrain {
    id
    request_time
    status
    start_time
    end_time
    error_message
  }
}
    `;

/**
 * __useAditGetModelRetrainsQuery__
 *
 * To run a query within a React component, call `useAditGetModelRetrainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetModelRetrainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetModelRetrainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAditGetModelRetrainsQuery(baseOptions?: Apollo.QueryHookOptions<AditGetModelRetrainsQuery, AditGetModelRetrainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetModelRetrainsQuery, AditGetModelRetrainsQueryVariables>(AditGetModelRetrainsDocument, options);
      }
export function useAditGetModelRetrainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetModelRetrainsQuery, AditGetModelRetrainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetModelRetrainsQuery, AditGetModelRetrainsQueryVariables>(AditGetModelRetrainsDocument, options);
        }
export type AditGetModelRetrainsQueryHookResult = ReturnType<typeof useAditGetModelRetrainsQuery>;
export type AditGetModelRetrainsLazyQueryHookResult = ReturnType<typeof useAditGetModelRetrainsLazyQuery>;
export type AditGetModelRetrainsQueryResult = Apollo.QueryResult<AditGetModelRetrainsQuery, AditGetModelRetrainsQueryVariables>;
export const AditTriggerModelRetrainingDocument = gql`
    mutation AditTriggerModelRetraining($requestTime: timestamptz!) {
  insert_model_retrain_one(object: {request_time: $requestTime, status: "pending"}) {
    id
  }
}
    `;
export type AditTriggerModelRetrainingMutationFn = Apollo.MutationFunction<AditTriggerModelRetrainingMutation, AditTriggerModelRetrainingMutationVariables>;

/**
 * __useAditTriggerModelRetrainingMutation__
 *
 * To run a mutation, you first call `useAditTriggerModelRetrainingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditTriggerModelRetrainingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditTriggerModelRetrainingMutation, { data, loading, error }] = useAditTriggerModelRetrainingMutation({
 *   variables: {
 *      requestTime: // value for 'requestTime'
 *   },
 * });
 */
export function useAditTriggerModelRetrainingMutation(baseOptions?: Apollo.MutationHookOptions<AditTriggerModelRetrainingMutation, AditTriggerModelRetrainingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditTriggerModelRetrainingMutation, AditTriggerModelRetrainingMutationVariables>(AditTriggerModelRetrainingDocument, options);
      }
export type AditTriggerModelRetrainingMutationHookResult = ReturnType<typeof useAditTriggerModelRetrainingMutation>;
export type AditTriggerModelRetrainingMutationResult = Apollo.MutationResult<AditTriggerModelRetrainingMutation>;
export type AditTriggerModelRetrainingMutationOptions = Apollo.BaseMutationOptions<AditTriggerModelRetrainingMutation, AditTriggerModelRetrainingMutationVariables>;
export const AditGetTenantDocumentTypesTableDocument = gql`
    query AditGetTenantDocumentTypesTable($tenantId: uuid!, $where: document_type_bool_exp!) {
  document_type(order_by: {creation_date: asc}, where: $where) {
    document_type_tenant_settings(where: {tenant: {_eq: $tenantId}}) {
      tenant
      code
      default_flags
      meta
      creation_date
      creation_user
      last_modified_date
      last_modified_user
    }
    name
    display_name
    translations
  }
  document_flag {
    id
    name
    translation
    color
  }
}
    `;

/**
 * __useAditGetTenantDocumentTypesTableQuery__
 *
 * To run a query within a React component, call `useAditGetTenantDocumentTypesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetTenantDocumentTypesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetTenantDocumentTypesTableQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAditGetTenantDocumentTypesTableQuery(baseOptions: Apollo.QueryHookOptions<AditGetTenantDocumentTypesTableQuery, AditGetTenantDocumentTypesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetTenantDocumentTypesTableQuery, AditGetTenantDocumentTypesTableQueryVariables>(AditGetTenantDocumentTypesTableDocument, options);
      }
export function useAditGetTenantDocumentTypesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetTenantDocumentTypesTableQuery, AditGetTenantDocumentTypesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetTenantDocumentTypesTableQuery, AditGetTenantDocumentTypesTableQueryVariables>(AditGetTenantDocumentTypesTableDocument, options);
        }
export type AditGetTenantDocumentTypesTableQueryHookResult = ReturnType<typeof useAditGetTenantDocumentTypesTableQuery>;
export type AditGetTenantDocumentTypesTableLazyQueryHookResult = ReturnType<typeof useAditGetTenantDocumentTypesTableLazyQuery>;
export type AditGetTenantDocumentTypesTableQueryResult = Apollo.QueryResult<AditGetTenantDocumentTypesTableQuery, AditGetTenantDocumentTypesTableQueryVariables>;
export const Adit_Upsert_Document_Type_Tenant_SettingDocument = gql`
    mutation ADIT_UPSERT_DOCUMENT_TYPE_TENANT_SETTING($document_type_tenant_setting: document_type_tenant_settings_insert_input!) {
  insert_document_type_tenant_settings(on_conflict: {constraint: document_type_tenant_settings_pkey, update_columns: [code, meta, default_flags]}, objects: [$document_type_tenant_setting]) {
    affected_rows
  }
}
    `;
export type Adit_Upsert_Document_Type_Tenant_SettingMutationFn = Apollo.MutationFunction<Adit_Upsert_Document_Type_Tenant_SettingMutation, Adit_Upsert_Document_Type_Tenant_SettingMutationVariables>;

/**
 * __useAdit_Upsert_Document_Type_Tenant_SettingMutation__
 *
 * To run a mutation, you first call `useAdit_Upsert_Document_Type_Tenant_SettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Upsert_Document_Type_Tenant_SettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpsertDocumentTypeTenantSettingMutation, { data, loading, error }] = useAdit_Upsert_Document_Type_Tenant_SettingMutation({
 *   variables: {
 *      document_type_tenant_setting: // value for 'document_type_tenant_setting'
 *   },
 * });
 */
export function useAdit_Upsert_Document_Type_Tenant_SettingMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Upsert_Document_Type_Tenant_SettingMutation, Adit_Upsert_Document_Type_Tenant_SettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Upsert_Document_Type_Tenant_SettingMutation, Adit_Upsert_Document_Type_Tenant_SettingMutationVariables>(Adit_Upsert_Document_Type_Tenant_SettingDocument, options);
      }
export type Adit_Upsert_Document_Type_Tenant_SettingMutationHookResult = ReturnType<typeof useAdit_Upsert_Document_Type_Tenant_SettingMutation>;
export type Adit_Upsert_Document_Type_Tenant_SettingMutationResult = Apollo.MutationResult<Adit_Upsert_Document_Type_Tenant_SettingMutation>;
export type Adit_Upsert_Document_Type_Tenant_SettingMutationOptions = Apollo.BaseMutationOptions<Adit_Upsert_Document_Type_Tenant_SettingMutation, Adit_Upsert_Document_Type_Tenant_SettingMutationVariables>;
export const AditCreatTenantUserDocument = gql`
    mutation aditCreatTenantUser($object: AditUserDto!) {
  createAditUser(createUserInput: $object)
}
    `;
export type AditCreatTenantUserMutationFn = Apollo.MutationFunction<AditCreatTenantUserMutation, AditCreatTenantUserMutationVariables>;

/**
 * __useAditCreatTenantUserMutation__
 *
 * To run a mutation, you first call `useAditCreatTenantUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditCreatTenantUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditCreatTenantUserMutation, { data, loading, error }] = useAditCreatTenantUserMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAditCreatTenantUserMutation(baseOptions?: Apollo.MutationHookOptions<AditCreatTenantUserMutation, AditCreatTenantUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditCreatTenantUserMutation, AditCreatTenantUserMutationVariables>(AditCreatTenantUserDocument, options);
      }
export type AditCreatTenantUserMutationHookResult = ReturnType<typeof useAditCreatTenantUserMutation>;
export type AditCreatTenantUserMutationResult = Apollo.MutationResult<AditCreatTenantUserMutation>;
export type AditCreatTenantUserMutationOptions = Apollo.BaseMutationOptions<AditCreatTenantUserMutation, AditCreatTenantUserMutationVariables>;
export const AditDeleteTenantUserDocument = gql`
    mutation AditDeleteTenantUser($id: UUID!) {
  removeUser(id: $id)
}
    `;
export type AditDeleteTenantUserMutationFn = Apollo.MutationFunction<AditDeleteTenantUserMutation, AditDeleteTenantUserMutationVariables>;

/**
 * __useAditDeleteTenantUserMutation__
 *
 * To run a mutation, you first call `useAditDeleteTenantUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditDeleteTenantUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditDeleteTenantUserMutation, { data, loading, error }] = useAditDeleteTenantUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAditDeleteTenantUserMutation(baseOptions?: Apollo.MutationHookOptions<AditDeleteTenantUserMutation, AditDeleteTenantUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditDeleteTenantUserMutation, AditDeleteTenantUserMutationVariables>(AditDeleteTenantUserDocument, options);
      }
export type AditDeleteTenantUserMutationHookResult = ReturnType<typeof useAditDeleteTenantUserMutation>;
export type AditDeleteTenantUserMutationResult = Apollo.MutationResult<AditDeleteTenantUserMutation>;
export type AditDeleteTenantUserMutationOptions = Apollo.BaseMutationOptions<AditDeleteTenantUserMutation, AditDeleteTenantUserMutationVariables>;
export const AditGetTenantUsersTableDocument = gql`
    query aditGetTenantUsersTable($limit: Int, $offset: Int, $search: String, $tenant: UUID) {
  users: getUsers(args: {limit: $limit, offset: $offset, search: $search, tenant: $tenant}) {
    id
    tenantId
    firstName
    lastName
    displayName
    email
    location
    isEnabled
    externalAuthProvider
    creationDate
    lastModifiedDate
    orgIds: orgIdEntities {
      ...OrgIdsListFragment
    }
    roles {
      ...AditRolesListFragment
    }
  }
}
    ${OrgIdsListFragmentFragmentDoc}
${AditRolesListFragmentFragmentDoc}`;

/**
 * __useAditGetTenantUsersTableQuery__
 *
 * To run a query within a React component, call `useAditGetTenantUsersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetTenantUsersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetTenantUsersTableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useAditGetTenantUsersTableQuery(baseOptions?: Apollo.QueryHookOptions<AditGetTenantUsersTableQuery, AditGetTenantUsersTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetTenantUsersTableQuery, AditGetTenantUsersTableQueryVariables>(AditGetTenantUsersTableDocument, options);
      }
export function useAditGetTenantUsersTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetTenantUsersTableQuery, AditGetTenantUsersTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetTenantUsersTableQuery, AditGetTenantUsersTableQueryVariables>(AditGetTenantUsersTableDocument, options);
        }
export type AditGetTenantUsersTableQueryHookResult = ReturnType<typeof useAditGetTenantUsersTableQuery>;
export type AditGetTenantUsersTableLazyQueryHookResult = ReturnType<typeof useAditGetTenantUsersTableLazyQuery>;
export type AditGetTenantUsersTableQueryResult = Apollo.QueryResult<AditGetTenantUsersTableQuery, AditGetTenantUsersTableQueryVariables>;
export const AditSendResetPasswordLinkDocument = gql`
    mutation AditSendResetPasswordLink($email: String!) {
  sendAditResetPasswordLink(email: $email)
}
    `;
export type AditSendResetPasswordLinkMutationFn = Apollo.MutationFunction<AditSendResetPasswordLinkMutation, AditSendResetPasswordLinkMutationVariables>;

/**
 * __useAditSendResetPasswordLinkMutation__
 *
 * To run a mutation, you first call `useAditSendResetPasswordLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditSendResetPasswordLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditSendResetPasswordLinkMutation, { data, loading, error }] = useAditSendResetPasswordLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAditSendResetPasswordLinkMutation(baseOptions?: Apollo.MutationHookOptions<AditSendResetPasswordLinkMutation, AditSendResetPasswordLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditSendResetPasswordLinkMutation, AditSendResetPasswordLinkMutationVariables>(AditSendResetPasswordLinkDocument, options);
      }
export type AditSendResetPasswordLinkMutationHookResult = ReturnType<typeof useAditSendResetPasswordLinkMutation>;
export type AditSendResetPasswordLinkMutationResult = Apollo.MutationResult<AditSendResetPasswordLinkMutation>;
export type AditSendResetPasswordLinkMutationOptions = Apollo.BaseMutationOptions<AditSendResetPasswordLinkMutation, AditSendResetPasswordLinkMutationVariables>;
export const AditUpdateTenantUserDocument = gql`
    mutation aditUpdateTenantUser($object: AditUserDto!) {
  updateAditUser(updateUserInput: $object)
}
    `;
export type AditUpdateTenantUserMutationFn = Apollo.MutationFunction<AditUpdateTenantUserMutation, AditUpdateTenantUserMutationVariables>;

/**
 * __useAditUpdateTenantUserMutation__
 *
 * To run a mutation, you first call `useAditUpdateTenantUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpdateTenantUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdateTenantUserMutation, { data, loading, error }] = useAditUpdateTenantUserMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAditUpdateTenantUserMutation(baseOptions?: Apollo.MutationHookOptions<AditUpdateTenantUserMutation, AditUpdateTenantUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpdateTenantUserMutation, AditUpdateTenantUserMutationVariables>(AditUpdateTenantUserDocument, options);
      }
export type AditUpdateTenantUserMutationHookResult = ReturnType<typeof useAditUpdateTenantUserMutation>;
export type AditUpdateTenantUserMutationResult = Apollo.MutationResult<AditUpdateTenantUserMutation>;
export type AditUpdateTenantUserMutationOptions = Apollo.BaseMutationOptions<AditUpdateTenantUserMutation, AditUpdateTenantUserMutationVariables>;
export const AditCreateTenantDocument = gql`
    mutation AditCreateTenant($addressId: Int!, $externalTenantId: String, $roles: [Int!], $tenantName: String!) {
  createTenantACS(addressId: $addressId, externalTenantId: $externalTenantId, roles: $roles, tenantName: $tenantName)
}
    `;
export type AditCreateTenantMutationFn = Apollo.MutationFunction<AditCreateTenantMutation, AditCreateTenantMutationVariables>;

/**
 * __useAditCreateTenantMutation__
 *
 * To run a mutation, you first call `useAditCreateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditCreateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditCreateTenantMutation, { data, loading, error }] = useAditCreateTenantMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *      externalTenantId: // value for 'externalTenantId'
 *      roles: // value for 'roles'
 *      tenantName: // value for 'tenantName'
 *   },
 * });
 */
export function useAditCreateTenantMutation(baseOptions?: Apollo.MutationHookOptions<AditCreateTenantMutation, AditCreateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditCreateTenantMutation, AditCreateTenantMutationVariables>(AditCreateTenantDocument, options);
      }
export type AditCreateTenantMutationHookResult = ReturnType<typeof useAditCreateTenantMutation>;
export type AditCreateTenantMutationResult = Apollo.MutationResult<AditCreateTenantMutation>;
export type AditCreateTenantMutationOptions = Apollo.BaseMutationOptions<AditCreateTenantMutation, AditCreateTenantMutationVariables>;
export const AditUpdateTenantDocument = gql`
    mutation AditUpdateTenant($tenantId: String!, $addressId: Int!, $externalTenantId: String, $roles: [Int!], $tenantName: String!) {
  editTenantACS(tenantId: $tenantId, addressId: $addressId, externalTenantId: $externalTenantId, roles: $roles, tenantName: $tenantName)
}
    `;
export type AditUpdateTenantMutationFn = Apollo.MutationFunction<AditUpdateTenantMutation, AditUpdateTenantMutationVariables>;

/**
 * __useAditUpdateTenantMutation__
 *
 * To run a mutation, you first call `useAditUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdateTenantMutation, { data, loading, error }] = useAditUpdateTenantMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      addressId: // value for 'addressId'
 *      externalTenantId: // value for 'externalTenantId'
 *      roles: // value for 'roles'
 *      tenantName: // value for 'tenantName'
 *   },
 * });
 */
export function useAditUpdateTenantMutation(baseOptions?: Apollo.MutationHookOptions<AditUpdateTenantMutation, AditUpdateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpdateTenantMutation, AditUpdateTenantMutationVariables>(AditUpdateTenantDocument, options);
      }
export type AditUpdateTenantMutationHookResult = ReturnType<typeof useAditUpdateTenantMutation>;
export type AditUpdateTenantMutationResult = Apollo.MutationResult<AditUpdateTenantMutation>;
export type AditUpdateTenantMutationOptions = Apollo.BaseMutationOptions<AditUpdateTenantMutation, AditUpdateTenantMutationVariables>;
export const AditGetTenantsTableDocument = gql`
    query AditGetTenantsTable($id: String) {
  tenants: getTenants(id: $id) {
    accountNumber
    addressId
    creationDate
    externalTenantId
    id
    isWdCustomer
    lastModifiedDate
    permissions
    tenantName
    tenantType
    traderIdentificationNumber
    address {
      ...AdiAddressesListFragment
    }
    roles {
      ...AditRolesListFragment
    }
  }
}
    ${AdiAddressesListFragmentFragmentDoc}
${AditRolesListFragmentFragmentDoc}`;

/**
 * __useAditGetTenantsTableQuery__
 *
 * To run a query within a React component, call `useAditGetTenantsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetTenantsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetTenantsTableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAditGetTenantsTableQuery(baseOptions?: Apollo.QueryHookOptions<AditGetTenantsTableQuery, AditGetTenantsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetTenantsTableQuery, AditGetTenantsTableQueryVariables>(AditGetTenantsTableDocument, options);
      }
export function useAditGetTenantsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetTenantsTableQuery, AditGetTenantsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetTenantsTableQuery, AditGetTenantsTableQueryVariables>(AditGetTenantsTableDocument, options);
        }
export type AditGetTenantsTableQueryHookResult = ReturnType<typeof useAditGetTenantsTableQuery>;
export type AditGetTenantsTableLazyQueryHookResult = ReturnType<typeof useAditGetTenantsTableLazyQuery>;
export type AditGetTenantsTableQueryResult = Apollo.QueryResult<AditGetTenantsTableQuery, AditGetTenantsTableQueryVariables>;
export const Adit_Get_Validation_V2_DocumentDocument = gql`
    query ADIT_GET_VALIDATION_V2_DOCUMENT($id: uuid!, $tenantId: uuid!) {
  file: file_by_pk(id: $id) {
    identification
    documents {
      id
      name: document_name
      meta
      document_extension
      annotationType(where: {annotation_provider_id: {_eq: 5}}) {
        annotation_schema
      }
      pages: pages_m2m(order_by: {page_number: asc}) {
        page {
          id
          thumbnailBigUrl: thumbnail_big_url
          page_status
          rotate
          meta
          creation_user
          pageExtracts: page_extracts {
            page_id
            extract_type_id
            extract_type {
              extract_type_id
              translations
            }
            dataPoints: value
            tables
          }
        }
      }
      document_blobs
      document_flags
      document_type
      sequence
      documentType {
        translations
        document_type_tenant_settings(where: {tenant: {_eq: $tenantId}}) {
          documentSchema: document_schema
        }
      }
    }
  }
}
    `;

/**
 * __useAdit_Get_Validation_V2_DocumentQuery__
 *
 * To run a query within a React component, call `useAdit_Get_Validation_V2_DocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Validation_V2_DocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Validation_V2_DocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useAdit_Get_Validation_V2_DocumentQuery(baseOptions: Apollo.QueryHookOptions<Adit_Get_Validation_V2_DocumentQuery, Adit_Get_Validation_V2_DocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Validation_V2_DocumentQuery, Adit_Get_Validation_V2_DocumentQueryVariables>(Adit_Get_Validation_V2_DocumentDocument, options);
      }
export function useAdit_Get_Validation_V2_DocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Validation_V2_DocumentQuery, Adit_Get_Validation_V2_DocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Validation_V2_DocumentQuery, Adit_Get_Validation_V2_DocumentQueryVariables>(Adit_Get_Validation_V2_DocumentDocument, options);
        }
export type Adit_Get_Validation_V2_DocumentQueryHookResult = ReturnType<typeof useAdit_Get_Validation_V2_DocumentQuery>;
export type Adit_Get_Validation_V2_DocumentLazyQueryHookResult = ReturnType<typeof useAdit_Get_Validation_V2_DocumentLazyQuery>;
export type Adit_Get_Validation_V2_DocumentQueryResult = Apollo.QueryResult<Adit_Get_Validation_V2_DocumentQuery, Adit_Get_Validation_V2_DocumentQueryVariables>;
export const AditGetSasTokenDocument = gql`
    query AditGetSASToken($container: String!, $contentType: String, $contentDisposition: String) {
  getSASToken(container: $container, contentType: $contentType, contentDisposition: $contentDisposition) {
    container
    sasToken
    expiryDate
  }
}
    `;

/**
 * __useAditGetSasTokenQuery__
 *
 * To run a query within a React component, call `useAditGetSasTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetSasTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetSasTokenQuery({
 *   variables: {
 *      container: // value for 'container'
 *      contentType: // value for 'contentType'
 *      contentDisposition: // value for 'contentDisposition'
 *   },
 * });
 */
export function useAditGetSasTokenQuery(baseOptions: Apollo.QueryHookOptions<AditGetSasTokenQuery, AditGetSasTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetSasTokenQuery, AditGetSasTokenQueryVariables>(AditGetSasTokenDocument, options);
      }
export function useAditGetSasTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetSasTokenQuery, AditGetSasTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetSasTokenQuery, AditGetSasTokenQueryVariables>(AditGetSasTokenDocument, options);
        }
export type AditGetSasTokenQueryHookResult = ReturnType<typeof useAditGetSasTokenQuery>;
export type AditGetSasTokenLazyQueryHookResult = ReturnType<typeof useAditGetSasTokenLazyQuery>;
export type AditGetSasTokenQueryResult = Apollo.QueryResult<AditGetSasTokenQuery, AditGetSasTokenQueryVariables>;